
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireeaf2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireeaf2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8gte5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexiconDefNotFoundError = module.exports.InvalidLexiconError = module.exports.ValidationError = module.exports.lexiconDoc = module.exports.lexUserType = module.exports.lexRecord = module.exports.lexXrpcSubscription = module.exports.lexXrpcProcedure = module.exports.lexXrpcQuery = module.exports.lexXrpcError = module.exports.lexXrpcSubscriptionMessage = module.exports.lexXrpcBody = module.exports.lexXrpcParameters = module.exports.lexObject = module.exports.lexToken = module.exports.lexPrimitiveArray = module.exports.lexArray = module.exports.lexBlob = module.exports.lexRefVariant = module.exports.lexRefUnion = module.exports.lexRef = module.exports.lexIpldType = module.exports.lexCidLink = module.exports.lexBytes = module.exports.lexPrimitive = module.exports.lexUnknown = module.exports.lexString = module.exports.lexStringFormat = module.exports.lexInteger = module.exports.lexBoolean = void 0;
module.exports.isValidLexiconDoc = $60467d129bce6776$var$isValidLexiconDoc;
module.exports.isObj = $60467d129bce6776$var$isObj;
module.exports.isDiscriminatedObject = $60467d129bce6776$var$isDiscriminatedObject;
module.exports.parseLexiconDoc = $60467d129bce6776$var$parseLexiconDoc;

var $2zDt6 = parcelRequire("2zDt6");

var $9IHRK = parcelRequire("9IHRK");

var $78Ykk = parcelRequire("78Ykk");
// primitives
// =
module.exports.lexBoolean = $2zDt6.z.object({
    type: $2zDt6.z.literal('boolean'),
    description: $2zDt6.z.string().optional(),
    default: $2zDt6.z.boolean().optional(),
    const: $2zDt6.z.boolean().optional()
}).strict();
module.exports.lexInteger = $2zDt6.z.object({
    type: $2zDt6.z.literal('integer'),
    description: $2zDt6.z.string().optional(),
    default: $2zDt6.z.number().int().optional(),
    minimum: $2zDt6.z.number().int().optional(),
    maximum: $2zDt6.z.number().int().optional(),
    enum: $2zDt6.z.number().int().array().optional(),
    const: $2zDt6.z.number().int().optional()
}).strict();
module.exports.lexStringFormat = $2zDt6.z.enum([
    'datetime',
    'uri',
    'at-uri',
    'did',
    'handle',
    'at-identifier',
    'nsid',
    'cid',
    'language',
    'tid',
    'record-key'
]);
module.exports.lexString = $2zDt6.z.object({
    type: $2zDt6.z.literal('string'),
    format: module.exports.lexStringFormat.optional(),
    description: $2zDt6.z.string().optional(),
    default: $2zDt6.z.string().optional(),
    minLength: $2zDt6.z.number().int().optional(),
    maxLength: $2zDt6.z.number().int().optional(),
    minGraphemes: $2zDt6.z.number().int().optional(),
    maxGraphemes: $2zDt6.z.number().int().optional(),
    enum: $2zDt6.z.string().array().optional(),
    const: $2zDt6.z.string().optional(),
    knownValues: $2zDt6.z.string().array().optional()
}).strict();
module.exports.lexUnknown = $2zDt6.z.object({
    type: $2zDt6.z.literal('unknown'),
    description: $2zDt6.z.string().optional()
}).strict();
module.exports.lexPrimitive = $2zDt6.z.discriminatedUnion('type', [
    module.exports.lexBoolean,
    module.exports.lexInteger,
    module.exports.lexString,
    module.exports.lexUnknown
]);
// ipld types
// =
module.exports.lexBytes = $2zDt6.z.object({
    type: $2zDt6.z.literal('bytes'),
    description: $2zDt6.z.string().optional(),
    maxLength: $2zDt6.z.number().optional(),
    minLength: $2zDt6.z.number().optional()
}).strict();
module.exports.lexCidLink = $2zDt6.z.object({
    type: $2zDt6.z.literal('cid-link'),
    description: $2zDt6.z.string().optional()
}).strict();
module.exports.lexIpldType = $2zDt6.z.discriminatedUnion('type', [
    module.exports.lexBytes,
    module.exports.lexCidLink
]);
// references
// =
module.exports.lexRef = $2zDt6.z.object({
    type: $2zDt6.z.literal('ref'),
    description: $2zDt6.z.string().optional(),
    ref: $2zDt6.z.string()
}).strict();
module.exports.lexRefUnion = $2zDt6.z.object({
    type: $2zDt6.z.literal('union'),
    description: $2zDt6.z.string().optional(),
    refs: $2zDt6.z.string().array(),
    closed: $2zDt6.z.boolean().optional()
}).strict();
module.exports.lexRefVariant = $2zDt6.z.discriminatedUnion('type', [
    module.exports.lexRef,
    module.exports.lexRefUnion
]);
// blobs
// =
module.exports.lexBlob = $2zDt6.z.object({
    type: $2zDt6.z.literal('blob'),
    description: $2zDt6.z.string().optional(),
    accept: $2zDt6.z.string().array().optional(),
    maxSize: $2zDt6.z.number().optional()
}).strict();
// complex types
// =
module.exports.lexArray = $2zDt6.z.object({
    type: $2zDt6.z.literal('array'),
    description: $2zDt6.z.string().optional(),
    items: $2zDt6.z.discriminatedUnion('type', [
        // lexPrimitive
        module.exports.lexBoolean,
        module.exports.lexInteger,
        module.exports.lexString,
        module.exports.lexUnknown,
        // lexIpldType
        module.exports.lexBytes,
        module.exports.lexCidLink,
        // lexRefVariant
        module.exports.lexRef,
        module.exports.lexRefUnion,
        // other
        module.exports.lexBlob
    ]),
    minLength: $2zDt6.z.number().int().optional(),
    maxLength: $2zDt6.z.number().int().optional()
}).strict();
module.exports.lexPrimitiveArray = module.exports.lexArray.merge($2zDt6.z.object({
    items: module.exports.lexPrimitive
}).strict());
module.exports.lexToken = $2zDt6.z.object({
    type: $2zDt6.z.literal('token'),
    description: $2zDt6.z.string().optional()
}).strict();
module.exports.lexObject = $2zDt6.z.object({
    type: $2zDt6.z.literal('object'),
    description: $2zDt6.z.string().optional(),
    required: $2zDt6.z.string().array().optional(),
    nullable: $2zDt6.z.string().array().optional(),
    properties: $2zDt6.z.record($2zDt6.z.discriminatedUnion('type', [
        module.exports.lexArray,
        // lexPrimitive
        module.exports.lexBoolean,
        module.exports.lexInteger,
        module.exports.lexString,
        module.exports.lexUnknown,
        // lexIpldType
        module.exports.lexBytes,
        module.exports.lexCidLink,
        // lexRefVariant
        module.exports.lexRef,
        module.exports.lexRefUnion,
        // other
        module.exports.lexBlob
    ]))
}).strict().superRefine($78Ykk.requiredPropertiesRefinement);
// xrpc
// =
module.exports.lexXrpcParameters = $2zDt6.z.object({
    type: $2zDt6.z.literal('params'),
    description: $2zDt6.z.string().optional(),
    required: $2zDt6.z.string().array().optional(),
    properties: $2zDt6.z.record($2zDt6.z.discriminatedUnion('type', [
        module.exports.lexPrimitiveArray,
        // lexPrimitive
        module.exports.lexBoolean,
        module.exports.lexInteger,
        module.exports.lexString,
        module.exports.lexUnknown
    ]))
}).strict().superRefine($78Ykk.requiredPropertiesRefinement);
module.exports.lexXrpcBody = $2zDt6.z.object({
    description: $2zDt6.z.string().optional(),
    encoding: $2zDt6.z.string(),
    // @NOTE using discriminatedUnion with a refined schema requires zod >= 4
    schema: $2zDt6.z.union([
        module.exports.lexRefVariant,
        module.exports.lexObject
    ]).optional()
}).strict();
module.exports.lexXrpcSubscriptionMessage = $2zDt6.z.object({
    description: $2zDt6.z.string().optional(),
    // @NOTE using discriminatedUnion with a refined schema requires zod >= 4
    schema: $2zDt6.z.union([
        module.exports.lexRefVariant,
        module.exports.lexObject
    ]).optional()
}).strict();
module.exports.lexXrpcError = $2zDt6.z.object({
    name: $2zDt6.z.string(),
    description: $2zDt6.z.string().optional()
}).strict();
module.exports.lexXrpcQuery = $2zDt6.z.object({
    type: $2zDt6.z.literal('query'),
    description: $2zDt6.z.string().optional(),
    parameters: module.exports.lexXrpcParameters.optional(),
    output: module.exports.lexXrpcBody.optional(),
    errors: module.exports.lexXrpcError.array().optional()
}).strict();
module.exports.lexXrpcProcedure = $2zDt6.z.object({
    type: $2zDt6.z.literal('procedure'),
    description: $2zDt6.z.string().optional(),
    parameters: module.exports.lexXrpcParameters.optional(),
    input: module.exports.lexXrpcBody.optional(),
    output: module.exports.lexXrpcBody.optional(),
    errors: module.exports.lexXrpcError.array().optional()
}).strict();
module.exports.lexXrpcSubscription = $2zDt6.z.object({
    type: $2zDt6.z.literal('subscription'),
    description: $2zDt6.z.string().optional(),
    parameters: module.exports.lexXrpcParameters.optional(),
    message: module.exports.lexXrpcSubscriptionMessage.optional(),
    errors: module.exports.lexXrpcError.array().optional()
}).strict();
// database
// =
module.exports.lexRecord = $2zDt6.z.object({
    type: $2zDt6.z.literal('record'),
    description: $2zDt6.z.string().optional(),
    key: $2zDt6.z.string().optional(),
    record: module.exports.lexObject
}).strict();
// core
// =
// We need to use `z.custom` here because
// lexXrpcProperty and lexObject are refined
// `z.union` would work, but it's too slow
// see #915 for details
module.exports.lexUserType = $2zDt6.z.custom((val)=>{
    if (!val || typeof val !== 'object') return;
    if (val['type'] === undefined) return;
    switch(val['type']){
        case 'record':
            return module.exports.lexRecord.parse(val);
        case 'query':
            return module.exports.lexXrpcQuery.parse(val);
        case 'procedure':
            return module.exports.lexXrpcProcedure.parse(val);
        case 'subscription':
            return module.exports.lexXrpcSubscription.parse(val);
        case 'blob':
            return module.exports.lexBlob.parse(val);
        case 'array':
            return module.exports.lexArray.parse(val);
        case 'token':
            return module.exports.lexToken.parse(val);
        case 'object':
            return module.exports.lexObject.parse(val);
        case 'boolean':
            return module.exports.lexBoolean.parse(val);
        case 'integer':
            return module.exports.lexInteger.parse(val);
        case 'string':
            return module.exports.lexString.parse(val);
        case 'bytes':
            return module.exports.lexBytes.parse(val);
        case 'cid-link':
            return module.exports.lexCidLink.parse(val);
        case 'unknown':
            return module.exports.lexUnknown.parse(val);
    }
}, (val)=>{
    if (!val || typeof val !== 'object') return {
        message: 'Must be an object',
        fatal: true
    };
    if (val['type'] === undefined) return {
        message: 'Must have a type',
        fatal: true
    };
    if (typeof val['type'] !== 'string') return {
        message: 'Type property must be a string',
        fatal: true
    };
    return {
        message: `Invalid type: ${val['type']} must be one of: record, query, procedure, subscription, blob, array, token, object, boolean, integer, string, bytes, cid-link, unknown`,
        fatal: true
    };
});
module.exports.lexiconDoc = $2zDt6.z.object({
    lexicon: $2zDt6.z.literal(1),
    id: $2zDt6.z.string().refine((v)=>$9IHRK.NSID.isValid(v), {
        message: 'Must be a valid NSID'
    }),
    revision: $2zDt6.z.number().optional(),
    description: $2zDt6.z.string().optional(),
    defs: $2zDt6.z.record(module.exports.lexUserType)
}).strict().superRefine((doc, ctx)=>{
    for(const defId in doc.defs){
        const def = doc.defs[defId];
        if (defId !== 'main' && (def.type === 'record' || def.type === 'procedure' || def.type === 'query' || def.type === 'subscription')) ctx.addIssue({
            code: $2zDt6.z.ZodIssueCode.custom,
            message: `Records, procedures, queries, and subscriptions must be the main definition.`
        });
    }
});
// helpers
// =
function $60467d129bce6776$var$isValidLexiconDoc(v) {
    return module.exports.lexiconDoc.safeParse(v).success;
}
function $60467d129bce6776$var$isObj(v) {
    return v != null && typeof v === 'object';
}
function $60467d129bce6776$var$isDiscriminatedObject(v) {
    return $60467d129bce6776$var$isObj(v) && '$type' in v && typeof v.$type === 'string';
}
function $60467d129bce6776$var$parseLexiconDoc(v) {
    module.exports.lexiconDoc.parse(v);
    return v;
}
class $60467d129bce6776$var$ValidationError extends Error {
}
module.exports.ValidationError = $60467d129bce6776$var$ValidationError;
class $60467d129bce6776$var$InvalidLexiconError extends Error {
}
module.exports.InvalidLexiconError = $60467d129bce6776$var$InvalidLexiconError;
class $60467d129bce6776$var$LexiconDefNotFoundError extends Error {
}
module.exports.LexiconDefNotFoundError = $60467d129bce6776$var$LexiconDefNotFoundError;

});
parcelRegister("2zDt6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "util", () => $9ee9c7b494d01fc9$export$7debb50ef11d5e0b);
$parcel$export(module.exports, "objectUtil", () => $9ee9c7b494d01fc9$export$4aa2142c225fd5c7);
$parcel$export(module.exports, "ZodParsedType", () => $9ee9c7b494d01fc9$export$5716da67bfaa244d);
$parcel$export(module.exports, "getParsedType", () => $9ee9c7b494d01fc9$export$3e9057828ebd5c7a);
$parcel$export(module.exports, "ZodIssueCode", () => $9ee9c7b494d01fc9$export$5ba560653e4a1035);
$parcel$export(module.exports, "quotelessJson", () => $9ee9c7b494d01fc9$export$913eddeaf297cfea);
$parcel$export(module.exports, "ZodError", () => $9ee9c7b494d01fc9$export$f98dac4b251ab333);
$parcel$export(module.exports, "defaultErrorMap", () => $9ee9c7b494d01fc9$export$341b0b6e0a6f5099);
$parcel$export(module.exports, "setErrorMap", () => $9ee9c7b494d01fc9$export$1097a8289cfd22d7);
$parcel$export(module.exports, "getErrorMap", () => $9ee9c7b494d01fc9$export$32f27c719778d4c4);
$parcel$export(module.exports, "makeIssue", () => $9ee9c7b494d01fc9$export$244a85fde9c419ed);
$parcel$export(module.exports, "EMPTY_PATH", () => $9ee9c7b494d01fc9$export$1526d2e05f74572);
$parcel$export(module.exports, "addIssueToContext", () => $9ee9c7b494d01fc9$export$db7caee60e5d514d);
$parcel$export(module.exports, "ParseStatus", () => $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f);
$parcel$export(module.exports, "INVALID", () => $9ee9c7b494d01fc9$export$9a105a556e65c2c0);
$parcel$export(module.exports, "DIRTY", () => $9ee9c7b494d01fc9$export$325a211da9693fcf);
$parcel$export(module.exports, "OK", () => $9ee9c7b494d01fc9$export$c6813a8d51f77eaf);
$parcel$export(module.exports, "isAborted", () => $9ee9c7b494d01fc9$export$afa861e3c5730743);
$parcel$export(module.exports, "isDirty", () => $9ee9c7b494d01fc9$export$910b6cdd390341b3);
$parcel$export(module.exports, "isValid", () => $9ee9c7b494d01fc9$export$1ea939691cdc45b8);
$parcel$export(module.exports, "isAsync", () => $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e);
$parcel$export(module.exports, "Schema", () => $9ee9c7b494d01fc9$export$19342e026b58ebb7);
$parcel$export(module.exports, "ZodEffects", () => $9ee9c7b494d01fc9$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodFirstPartyTypeKind", () => $9ee9c7b494d01fc9$export$558106ce543bd011);
$parcel$export(module.exports, "ZodOptional", () => $9ee9c7b494d01fc9$export$aa56fec1e9d629b8);
$parcel$export(module.exports, "ZodNullable", () => $9ee9c7b494d01fc9$export$aaac0b8b429cef5);
$parcel$export(module.exports, "ZodArray", () => $9ee9c7b494d01fc9$export$7acfc3e64785411);
$parcel$export(module.exports, "ZodPromise", () => $9ee9c7b494d01fc9$export$3f196b0127d6e50a);
$parcel$export(module.exports, "ZodUnion", () => $9ee9c7b494d01fc9$export$a8b236cb5070a311);
$parcel$export(module.exports, "ZodIntersection", () => $9ee9c7b494d01fc9$export$c02deaf0bb5203d4);
$parcel$export(module.exports, "ZodDefault", () => $9ee9c7b494d01fc9$export$bb19b37874861e7e);
$parcel$export(module.exports, "ZodBranded", () => $9ee9c7b494d01fc9$export$66b0c798a395271f);
$parcel$export(module.exports, "ZodCatch", () => $9ee9c7b494d01fc9$export$75a44ec6249ac76b);
$parcel$export(module.exports, "ZodPipeline", () => $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da);
$parcel$export(module.exports, "ZodReadonly", () => $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a);
$parcel$export(module.exports, "datetimeRegex", () => $9ee9c7b494d01fc9$export$a4b563879add27a);
$parcel$export(module.exports, "ZodString", () => $9ee9c7b494d01fc9$export$1230eb29b8d3b502);
$parcel$export(module.exports, "ZodNumber", () => $9ee9c7b494d01fc9$export$5b070a55c0c43e09);
$parcel$export(module.exports, "ZodBigInt", () => $9ee9c7b494d01fc9$export$67d741fd70ff98f4);
$parcel$export(module.exports, "ZodBoolean", () => $9ee9c7b494d01fc9$export$723d146f80596191);
$parcel$export(module.exports, "ZodDate", () => $9ee9c7b494d01fc9$export$e974be33bdc55521);
$parcel$export(module.exports, "ZodSymbol", () => $9ee9c7b494d01fc9$export$bcc3b40f6b638044);
$parcel$export(module.exports, "ZodUndefined", () => $9ee9c7b494d01fc9$export$4e780e961c30340d);
$parcel$export(module.exports, "ZodNull", () => $9ee9c7b494d01fc9$export$a96281f914484f2d);
$parcel$export(module.exports, "ZodAny", () => $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb);
$parcel$export(module.exports, "ZodUnknown", () => $9ee9c7b494d01fc9$export$ef3b1bb1630977ae);
$parcel$export(module.exports, "ZodNever", () => $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5);
$parcel$export(module.exports, "ZodVoid", () => $9ee9c7b494d01fc9$export$7d39f5df85f21031);
$parcel$export(module.exports, "ZodObject", () => $9ee9c7b494d01fc9$export$736315c5b55efbad);
$parcel$export(module.exports, "ZodTuple", () => $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3);
$parcel$export(module.exports, "ZodLazy", () => $9ee9c7b494d01fc9$export$378d0cfce37406e6);
$parcel$export(module.exports, "ZodLiteral", () => $9ee9c7b494d01fc9$export$7e44096782a165d3);
$parcel$export(module.exports, "ZodEnum", () => $9ee9c7b494d01fc9$export$d325d1f0e1c20179);
$parcel$export(module.exports, "ZodNativeEnum", () => $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56);
$parcel$export(module.exports, "ZodDiscriminatedUnion", () => $9ee9c7b494d01fc9$export$5ef2424805ac76a3);
$parcel$export(module.exports, "ZodRecord", () => $9ee9c7b494d01fc9$export$a2acc09968cb4b7f);
$parcel$export(module.exports, "ZodMap", () => $9ee9c7b494d01fc9$export$163b6a2b712d9542);
$parcel$export(module.exports, "ZodSet", () => $9ee9c7b494d01fc9$export$977057706f816712);
$parcel$export(module.exports, "ZodFunction", () => $9ee9c7b494d01fc9$export$d4602ba55673f53c);
$parcel$export(module.exports, "ZodNaN", () => $9ee9c7b494d01fc9$export$26ccfa0145e8511f);
$parcel$export(module.exports, "BRAND", () => $9ee9c7b494d01fc9$export$cf2deea74cde46b4);
$parcel$export(module.exports, "custom", () => $9ee9c7b494d01fc9$export$4c00f665f0d4b443);
$parcel$export(module.exports, "late", () => $9ee9c7b494d01fc9$export$1ee8ee30835eab8b);
$parcel$export(module.exports, "instanceof", () => $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5);
$parcel$export(module.exports, "string", () => $9ee9c7b494d01fc9$export$22b082955e083ec3);
$parcel$export(module.exports, "number", () => $9ee9c7b494d01fc9$export$98e628dec113755e);
$parcel$export(module.exports, "nan", () => $9ee9c7b494d01fc9$export$9e06de0973666692);
$parcel$export(module.exports, "bigint", () => $9ee9c7b494d01fc9$export$a0f65b52274bcc00);
$parcel$export(module.exports, "boolean", () => $9ee9c7b494d01fc9$export$4a21f16c33752377);
$parcel$export(module.exports, "date", () => $9ee9c7b494d01fc9$export$324d90190a8b822a);
$parcel$export(module.exports, "symbol", () => $9ee9c7b494d01fc9$export$8f701197936bc2a6);
$parcel$export(module.exports, "undefined", () => $9ee9c7b494d01fc9$export$1db45310990710a5);
$parcel$export(module.exports, "null", () => $9ee9c7b494d01fc9$export$7b1b591b262c240);
$parcel$export(module.exports, "any", () => $9ee9c7b494d01fc9$export$4154a199d7d90455);
$parcel$export(module.exports, "unknown", () => $9ee9c7b494d01fc9$export$19282c40b967aec6);
$parcel$export(module.exports, "never", () => $9ee9c7b494d01fc9$export$b3e22bcfd64c1022);
$parcel$export(module.exports, "void", () => $9ee9c7b494d01fc9$export$490e536ee7389aeb);
$parcel$export(module.exports, "array", () => $9ee9c7b494d01fc9$export$2f23118c22fb2630);
$parcel$export(module.exports, "object", () => $9ee9c7b494d01fc9$export$be5493f9613cbbe);
$parcel$export(module.exports, "strictObject", () => $9ee9c7b494d01fc9$export$8fb0df5f40d0b477);
$parcel$export(module.exports, "union", () => $9ee9c7b494d01fc9$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "discriminatedUnion", () => $9ee9c7b494d01fc9$export$4b888e40c4ee26dd);
$parcel$export(module.exports, "intersection", () => $9ee9c7b494d01fc9$export$bc86dfbf7795668c);
$parcel$export(module.exports, "tuple", () => $9ee9c7b494d01fc9$export$65e3907585753458);
$parcel$export(module.exports, "record", () => $9ee9c7b494d01fc9$export$e5185e241753e543);
$parcel$export(module.exports, "map", () => $9ee9c7b494d01fc9$export$871de8747c9eaa88);
$parcel$export(module.exports, "set", () => $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "function", () => $9ee9c7b494d01fc9$export$44e51c8aac7c2deb);
$parcel$export(module.exports, "lazy", () => $9ee9c7b494d01fc9$export$488013bae63b21da);
$parcel$export(module.exports, "literal", () => $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0);
$parcel$export(module.exports, "enum", () => $9ee9c7b494d01fc9$export$78a99c8d44d72635);
$parcel$export(module.exports, "nativeEnum", () => $9ee9c7b494d01fc9$export$6fe7eca19ebe5199);
$parcel$export(module.exports, "promise", () => $9ee9c7b494d01fc9$export$c957ef27a0ebfd4);
$parcel$export(module.exports, "effect", () => $9ee9c7b494d01fc9$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "optional", () => $9ee9c7b494d01fc9$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "nullable", () => $9ee9c7b494d01fc9$export$133fc36489ac9add);
$parcel$export(module.exports, "preprocess", () => $9ee9c7b494d01fc9$export$fc37fe19dfda43ee);
$parcel$export(module.exports, "pipeline", () => $9ee9c7b494d01fc9$export$43f28b24e1eb8181);
$parcel$export(module.exports, "ostring", () => $9ee9c7b494d01fc9$export$3b3d07727c5b702c);
$parcel$export(module.exports, "onumber", () => $9ee9c7b494d01fc9$export$eb150471a61fced6);
$parcel$export(module.exports, "oboolean", () => $9ee9c7b494d01fc9$export$269251733cdcbbf1);
$parcel$export(module.exports, "coerce", () => $9ee9c7b494d01fc9$export$8c14e57e778d3873);
$parcel$export(module.exports, "NEVER", () => $9ee9c7b494d01fc9$export$96c94437c95d7862);
$parcel$export(module.exports, "default", () => $9ee9c7b494d01fc9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ZodSchema", () => $9ee9c7b494d01fc9$export$19342e026b58ebb7);
$parcel$export(module.exports, "ZodTransformer", () => $9ee9c7b494d01fc9$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodType", () => $9ee9c7b494d01fc9$export$19342e026b58ebb7);
$parcel$export(module.exports, "transformer", () => $9ee9c7b494d01fc9$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "z", () => $9ee9c7b494d01fc9$export$2e2bcd8739ae039);
var $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($9ee9c7b494d01fc9$export$7debb50ef11d5e0b || ($9ee9c7b494d01fc9$export$7debb50ef11d5e0b = {}));
var $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 || ($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 = {}));
const $9ee9c7b494d01fc9$export$5716da67bfaa244d = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $9ee9c7b494d01fc9$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined;
        case "string":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan : $9ee9c7b494d01fc9$export$5716da67bfaa244d.number;
        case "boolean":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean;
        case "function":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.function;
        case "bigint":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.array;
            if (data === null) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.date;
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.object;
        default:
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.unknown;
    }
};
const $9ee9c7b494d01fc9$export$5ba560653e4a1035 = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $9ee9c7b494d01fc9$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $9ee9c7b494d01fc9$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $9ee9c7b494d01fc9$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$9ee9c7b494d01fc9$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues);
    return error;
};
const $9ee9c7b494d01fc9$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $9ee9c7b494d01fc9$var$overrideErrorMap = $9ee9c7b494d01fc9$export$341b0b6e0a6f5099;
function $9ee9c7b494d01fc9$export$1097a8289cfd22d7(map) {
    $9ee9c7b494d01fc9$var$overrideErrorMap = map;
}
function $9ee9c7b494d01fc9$export$32f27c719778d4c4() {
    return $9ee9c7b494d01fc9$var$overrideErrorMap;
}
const $9ee9c7b494d01fc9$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $9ee9c7b494d01fc9$export$1526d2e05f74572 = [];
function $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $9ee9c7b494d01fc9$export$32f27c719778d4c4();
    const issue = $9ee9c7b494d01fc9$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $9ee9c7b494d01fc9$export$341b0b6e0a6f5099 ? undefined : $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $9ee9c7b494d01fc9$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $9ee9c7b494d01fc9$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $9ee9c7b494d01fc9$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $9ee9c7b494d01fc9$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $9ee9c7b494d01fc9$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $9ee9c7b494d01fc9$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $9ee9c7b494d01fc9$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $9ee9c7b494d01fc9$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $9ee9c7b494d01fc9$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($9ee9c7b494d01fc9$var$errorUtil || ($9ee9c7b494d01fc9$var$errorUtil = {}));
var $9ee9c7b494d01fc9$var$_ZodEnum_cache, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache;
class $9ee9c7b494d01fc9$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $9ee9c7b494d01fc9$var$handleResult = (ctx, result)=>{
    if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $9ee9c7b494d01fc9$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        var _a, _b;
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return $9ee9c7b494d01fc9$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if ((_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>$9ee9c7b494d01fc9$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $9ee9c7b494d01fc9$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $9ee9c7b494d01fc9$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $9ee9c7b494d01fc9$export$66b0c798a395271f({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $9ee9c7b494d01fc9$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $9ee9c7b494d01fc9$var$cuid2Regex = /^[0-9a-z]+$/;
const $9ee9c7b494d01fc9$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $9ee9c7b494d01fc9$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $9ee9c7b494d01fc9$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $9ee9c7b494d01fc9$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $9ee9c7b494d01fc9$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $9ee9c7b494d01fc9$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $9ee9c7b494d01fc9$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $9ee9c7b494d01fc9$var$emojiRegex;
// faster, simpler, safer
const $9ee9c7b494d01fc9$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $9ee9c7b494d01fc9$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $9ee9c7b494d01fc9$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $9ee9c7b494d01fc9$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $9ee9c7b494d01fc9$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $9ee9c7b494d01fc9$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $9ee9c7b494d01fc9$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $9ee9c7b494d01fc9$var$dateRegex = new RegExp(`^${$9ee9c7b494d01fc9$var$dateRegexSource}$`);
function $9ee9c7b494d01fc9$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $9ee9c7b494d01fc9$var$timeRegex(args) {
    return new RegExp(`^${$9ee9c7b494d01fc9$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $9ee9c7b494d01fc9$export$a4b563879add27a(args) {
    let regex = `${$9ee9c7b494d01fc9$var$dateRegexSource}T${$9ee9c7b494d01fc9$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $9ee9c7b494d01fc9$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $9ee9c7b494d01fc9$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $9ee9c7b494d01fc9$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $9ee9c7b494d01fc9$var$isValidJWT(jwt, alg) {
    if (!$9ee9c7b494d01fc9$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if (!decoded.typ || !decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch (_a) {
        return false;
    }
}
function $9ee9c7b494d01fc9$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $9ee9c7b494d01fc9$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $9ee9c7b494d01fc9$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $9ee9c7b494d01fc9$export$1230eb29b8d3b502 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$9ee9c7b494d01fc9$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$9ee9c7b494d01fc9$var$emojiRegex) $9ee9c7b494d01fc9$var$emojiRegex = new RegExp($9ee9c7b494d01fc9$var$_emojiRegex, "u");
                if (!$9ee9c7b494d01fc9$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$9ee9c7b494d01fc9$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$9ee9c7b494d01fc9$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$9ee9c7b494d01fc9$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$9ee9c7b494d01fc9$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$9ee9c7b494d01fc9$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $9ee9c7b494d01fc9$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $9ee9c7b494d01fc9$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $9ee9c7b494d01fc9$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$9ee9c7b494d01fc9$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$9ee9c7b494d01fc9$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$9ee9c7b494d01fc9$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "jwt",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$9ee9c7b494d01fc9$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cidr",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$9ee9c7b494d01fc9$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$9ee9c7b494d01fc9$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "base64url",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, $9ee9c7b494d01fc9$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $9ee9c7b494d01fc9$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $9ee9c7b494d01fc9$export$5b070a55c0c43e09 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($9ee9c7b494d01fc9$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$67d741fd70ff98f4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch (_a) {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
            expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint,
            received: ctx.parsedType
        });
        return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$723d146f80596191 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$723d146f80596191.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$723d146f80596191({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e974be33bdc55521 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$9ee9c7b494d01fc9$export$e974be33bdc55521.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDate,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bcc3b40f6b638044 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$bcc3b40f6b638044.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$bcc3b40f6b638044({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSymbol,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$4e780e961c30340d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$4e780e961c30340d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$4e780e961c30340d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUndefined,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a96281f914484f2d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$a96281f914484f2d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$a96281f914484f2d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNull,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodAny,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$ef3b1bb1630977ae extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$ef3b1bb1630977ae({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnknown,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
            expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
    }
}
$9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNever,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7d39f5df85f21031 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$7d39f5df85f21031.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$7d39f5df85f21031({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodVoid,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7acfc3e64785411 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big : $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$7acfc3e64785411.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodArray,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$deepPartialify(schema) {
    if (schema instanceof $9ee9c7b494d01fc9$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(fieldSchema));
        }
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $9ee9c7b494d01fc9$export$7acfc3e64785411) return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        ...schema._def,
        type: $9ee9c7b494d01fc9$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8) return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$aaac0b8b429cef5) return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3) return $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$9ee9c7b494d01fc9$var$deepPartialify(item)));
    else return schema;
}
class $9ee9c7b494d01fc9$export$736315c5b55efbad extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $9ee9c7b494d01fc9$var$errorUtil.errToObj;
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $9ee9c7b494d01fc9$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $9ee9c7b494d01fc9$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $9ee9c7b494d01fc9$var$createZodEnum($9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$9ee9c7b494d01fc9$export$736315c5b55efbad.create = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a8b236cb5070a311 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(result.ctx.common.issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$9ee9c7b494d01fc9$export$a8b236cb5070a311.create = (types, params)=>{
    return new $9ee9c7b494d01fc9$export$a8b236cb5070a311({
        options: types,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnion,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $9ee9c7b494d01fc9$var$getDiscriminator = (type)=>{
    if (type instanceof $9ee9c7b494d01fc9$export$378d0cfce37406e6) return $9ee9c7b494d01fc9$var$getDiscriminator(type.schema);
    else if (type instanceof $9ee9c7b494d01fc9$export$a60af00cc0ce2582) return $9ee9c7b494d01fc9$var$getDiscriminator(type.innerType());
    else if (type instanceof $9ee9c7b494d01fc9$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $9ee9c7b494d01fc9$export$bb19b37874861e7e) return $9ee9c7b494d01fc9$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $9ee9c7b494d01fc9$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8) return [
        undefined,
        ...$9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$aaac0b8b429cef5) return [
        null,
        ...$9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$66b0c798a395271f) return $9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap());
    else if (type instanceof $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a) return $9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap());
    else if (type instanceof $9ee9c7b494d01fc9$export$75a44ec6249ac76b) return $9ee9c7b494d01fc9$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $9ee9c7b494d01fc9$export$5ef2424805ac76a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $9ee9c7b494d01fc9$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $9ee9c7b494d01fc9$export$5ef2424805ac76a3({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
function $9ee9c7b494d01fc9$var$mergeValues(a, b) {
    const aType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(a);
    const bType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
        const bKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $9ee9c7b494d01fc9$export$c02deaf0bb5203d4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($9ee9c7b494d01fc9$export$afa861e3c5730743(parsedLeft) || $9ee9c7b494d01fc9$export$afa861e3c5730743(parsedRight)) return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            const merged = $9ee9c7b494d01fc9$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            }
            if ($9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedLeft) || $9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $9ee9c7b494d01fc9$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodIntersection,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a2acc09968cb4b7f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $9ee9c7b494d01fc9$export$19342e026b58ebb7) return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(third)
        });
        return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(second)
        });
    }
}
class $9ee9c7b494d01fc9$export$163b6a2b712d9542 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.map) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$9ee9c7b494d01fc9$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodMap,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$977057706f816712 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.set) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$977057706f816712.create = (valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSet,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$d4602ba55673f53c extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.function) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $9ee9c7b494d01fc9$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            args: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(items).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            args: args ? args : $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create([]).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create()),
            returns: returns || $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create(),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodFunction,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
class $9ee9c7b494d01fc9$export$378d0cfce37406e6 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$9ee9c7b494d01fc9$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $9ee9c7b494d01fc9$export$378d0cfce37406e6({
        getter: getter,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLazy,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7e44096782a165d3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$9ee9c7b494d01fc9$export$7e44096782a165d3.create = (value, params)=>{
    return new $9ee9c7b494d01fc9$export$7e44096782a165d3({
        value: value,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLiteral,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$createZodEnum(values, params) {
    return new $9ee9c7b494d01fc9$export$d325d1f0e1c20179({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
}
class $9ee9c7b494d01fc9$export$d325d1f0e1c20179 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $9ee9c7b494d01fc9$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodEnum_cache, "f")) $9ee9c7b494d01fc9$var$__classPrivateFieldSet(this, $9ee9c7b494d01fc9$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$9ee9c7b494d01fc9$var$_ZodEnum_cache = new WeakMap();
$9ee9c7b494d01fc9$export$d325d1f0e1c20179.create = $9ee9c7b494d01fc9$var$createZodEnum;
class $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string && ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache, "f")) $9ee9c7b494d01fc9$var$__classPrivateFieldSet(this, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache, new Set($9ee9c7b494d01fc9$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$9ee9c7b494d01fc9$var$_ZodNativeEnum_cache = new WeakMap();
$9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNativeEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$3f196b0127d6e50a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$9ee9c7b494d01fc9$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$3f196b0127d6e50a({
        type: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPromise,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a60af00cc0ce2582 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aa56fec1e9d629b8 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodOptional,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aaac0b8b429cef5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNullable,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bb19b37874861e7e extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$bb19b37874861e7e.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$75a44ec6249ac76b extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$26ccfa0145e8511f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$9ee9c7b494d01fc9$export$26ccfa0145e8511f.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$26ccfa0145e8511f({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNaN,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
const $9ee9c7b494d01fc9$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $9ee9c7b494d01fc9$export$66b0c798a395271f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $9ee9c7b494d01fc9$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodReadonly,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $9ee9c7b494d01fc9$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $9ee9c7b494d01fc9$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            var _a, _b;
            if (!r) {
                const params = $9ee9c7b494d01fc9$var$cleanParams(_params, data);
                const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $9ee9c7b494d01fc9$var$cleanParams(_params, data);
            const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create();
}
const $9ee9c7b494d01fc9$export$1ee8ee30835eab8b = {
    object: $9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate
};
var $9ee9c7b494d01fc9$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($9ee9c7b494d01fc9$export$558106ce543bd011 || ($9ee9c7b494d01fc9$export$558106ce543bd011 = {}));
const $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$9ee9c7b494d01fc9$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $9ee9c7b494d01fc9$export$22b082955e083ec3 = $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create;
const $9ee9c7b494d01fc9$export$98e628dec113755e = $9ee9c7b494d01fc9$export$5b070a55c0c43e09.create;
const $9ee9c7b494d01fc9$export$9e06de0973666692 = $9ee9c7b494d01fc9$export$26ccfa0145e8511f.create;
const $9ee9c7b494d01fc9$export$a0f65b52274bcc00 = $9ee9c7b494d01fc9$export$67d741fd70ff98f4.create;
const $9ee9c7b494d01fc9$export$4a21f16c33752377 = $9ee9c7b494d01fc9$export$723d146f80596191.create;
const $9ee9c7b494d01fc9$export$324d90190a8b822a = $9ee9c7b494d01fc9$export$e974be33bdc55521.create;
const $9ee9c7b494d01fc9$export$8f701197936bc2a6 = $9ee9c7b494d01fc9$export$bcc3b40f6b638044.create;
const $9ee9c7b494d01fc9$export$1db45310990710a5 = $9ee9c7b494d01fc9$export$4e780e961c30340d.create;
const $9ee9c7b494d01fc9$export$7b1b591b262c240 = $9ee9c7b494d01fc9$export$a96281f914484f2d.create;
const $9ee9c7b494d01fc9$export$4154a199d7d90455 = $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create;
const $9ee9c7b494d01fc9$export$19282c40b967aec6 = $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create;
const $9ee9c7b494d01fc9$export$b3e22bcfd64c1022 = $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create;
const $9ee9c7b494d01fc9$export$490e536ee7389aeb = $9ee9c7b494d01fc9$export$7d39f5df85f21031.create;
const $9ee9c7b494d01fc9$export$2f23118c22fb2630 = $9ee9c7b494d01fc9$export$7acfc3e64785411.create;
const $9ee9c7b494d01fc9$export$be5493f9613cbbe = $9ee9c7b494d01fc9$export$736315c5b55efbad.create;
const $9ee9c7b494d01fc9$export$8fb0df5f40d0b477 = $9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate;
const $9ee9c7b494d01fc9$export$971dd5b0dfd021b6 = $9ee9c7b494d01fc9$export$a8b236cb5070a311.create;
const $9ee9c7b494d01fc9$export$4b888e40c4ee26dd = $9ee9c7b494d01fc9$export$5ef2424805ac76a3.create;
const $9ee9c7b494d01fc9$export$bc86dfbf7795668c = $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create;
const $9ee9c7b494d01fc9$export$65e3907585753458 = $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create;
const $9ee9c7b494d01fc9$export$e5185e241753e543 = $9ee9c7b494d01fc9$export$a2acc09968cb4b7f.create;
const $9ee9c7b494d01fc9$export$871de8747c9eaa88 = $9ee9c7b494d01fc9$export$163b6a2b712d9542.create;
const $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be = $9ee9c7b494d01fc9$export$977057706f816712.create;
const $9ee9c7b494d01fc9$export$44e51c8aac7c2deb = $9ee9c7b494d01fc9$export$d4602ba55673f53c.create;
const $9ee9c7b494d01fc9$export$488013bae63b21da = $9ee9c7b494d01fc9$export$378d0cfce37406e6.create;
const $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0 = $9ee9c7b494d01fc9$export$7e44096782a165d3.create;
const $9ee9c7b494d01fc9$export$78a99c8d44d72635 = $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create;
const $9ee9c7b494d01fc9$export$6fe7eca19ebe5199 = $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create;
const $9ee9c7b494d01fc9$export$c957ef27a0ebfd4 = $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create;
const $9ee9c7b494d01fc9$export$dc573d8a6576cdb3 = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.create;
const $9ee9c7b494d01fc9$export$516e28dec6a4b6d4 = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create;
const $9ee9c7b494d01fc9$export$133fc36489ac9add = $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create;
const $9ee9c7b494d01fc9$export$fc37fe19dfda43ee = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess;
const $9ee9c7b494d01fc9$export$43f28b24e1eb8181 = $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create;
const $9ee9c7b494d01fc9$export$3b3d07727c5b702c = ()=>$9ee9c7b494d01fc9$export$22b082955e083ec3().optional();
const $9ee9c7b494d01fc9$export$eb150471a61fced6 = ()=>$9ee9c7b494d01fc9$export$98e628dec113755e().optional();
const $9ee9c7b494d01fc9$export$269251733cdcbbf1 = ()=>$9ee9c7b494d01fc9$export$4a21f16c33752377().optional();
const $9ee9c7b494d01fc9$export$8c14e57e778d3873 = {
    string: (arg)=>$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$9ee9c7b494d01fc9$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$9ee9c7b494d01fc9$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $9ee9c7b494d01fc9$export$96c94437c95d7862 = $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
var $9ee9c7b494d01fc9$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $9ee9c7b494d01fc9$export$341b0b6e0a6f5099,
    setErrorMap: $9ee9c7b494d01fc9$export$1097a8289cfd22d7,
    getErrorMap: $9ee9c7b494d01fc9$export$32f27c719778d4c4,
    makeIssue: $9ee9c7b494d01fc9$export$244a85fde9c419ed,
    EMPTY_PATH: $9ee9c7b494d01fc9$export$1526d2e05f74572,
    addIssueToContext: $9ee9c7b494d01fc9$export$db7caee60e5d514d,
    ParseStatus: $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f,
    INVALID: $9ee9c7b494d01fc9$export$9a105a556e65c2c0,
    DIRTY: $9ee9c7b494d01fc9$export$325a211da9693fcf,
    OK: $9ee9c7b494d01fc9$export$c6813a8d51f77eaf,
    isAborted: $9ee9c7b494d01fc9$export$afa861e3c5730743,
    isDirty: $9ee9c7b494d01fc9$export$910b6cdd390341b3,
    isValid: $9ee9c7b494d01fc9$export$1ea939691cdc45b8,
    isAsync: $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e,
    get util () {
        return $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $9ee9c7b494d01fc9$export$5716da67bfaa244d,
    getParsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a,
    ZodType: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    datetimeRegex: $9ee9c7b494d01fc9$export$a4b563879add27a,
    ZodString: $9ee9c7b494d01fc9$export$1230eb29b8d3b502,
    ZodNumber: $9ee9c7b494d01fc9$export$5b070a55c0c43e09,
    ZodBigInt: $9ee9c7b494d01fc9$export$67d741fd70ff98f4,
    ZodBoolean: $9ee9c7b494d01fc9$export$723d146f80596191,
    ZodDate: $9ee9c7b494d01fc9$export$e974be33bdc55521,
    ZodSymbol: $9ee9c7b494d01fc9$export$bcc3b40f6b638044,
    ZodUndefined: $9ee9c7b494d01fc9$export$4e780e961c30340d,
    ZodNull: $9ee9c7b494d01fc9$export$a96281f914484f2d,
    ZodAny: $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb,
    ZodUnknown: $9ee9c7b494d01fc9$export$ef3b1bb1630977ae,
    ZodNever: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5,
    ZodVoid: $9ee9c7b494d01fc9$export$7d39f5df85f21031,
    ZodArray: $9ee9c7b494d01fc9$export$7acfc3e64785411,
    ZodObject: $9ee9c7b494d01fc9$export$736315c5b55efbad,
    ZodUnion: $9ee9c7b494d01fc9$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $9ee9c7b494d01fc9$export$5ef2424805ac76a3,
    ZodIntersection: $9ee9c7b494d01fc9$export$c02deaf0bb5203d4,
    ZodTuple: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3,
    ZodRecord: $9ee9c7b494d01fc9$export$a2acc09968cb4b7f,
    ZodMap: $9ee9c7b494d01fc9$export$163b6a2b712d9542,
    ZodSet: $9ee9c7b494d01fc9$export$977057706f816712,
    ZodFunction: $9ee9c7b494d01fc9$export$d4602ba55673f53c,
    ZodLazy: $9ee9c7b494d01fc9$export$378d0cfce37406e6,
    ZodLiteral: $9ee9c7b494d01fc9$export$7e44096782a165d3,
    ZodEnum: $9ee9c7b494d01fc9$export$d325d1f0e1c20179,
    ZodNativeEnum: $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56,
    ZodPromise: $9ee9c7b494d01fc9$export$3f196b0127d6e50a,
    ZodEffects: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodTransformer: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodOptional: $9ee9c7b494d01fc9$export$aa56fec1e9d629b8,
    ZodNullable: $9ee9c7b494d01fc9$export$aaac0b8b429cef5,
    ZodDefault: $9ee9c7b494d01fc9$export$bb19b37874861e7e,
    ZodCatch: $9ee9c7b494d01fc9$export$75a44ec6249ac76b,
    ZodNaN: $9ee9c7b494d01fc9$export$26ccfa0145e8511f,
    BRAND: $9ee9c7b494d01fc9$export$cf2deea74cde46b4,
    ZodBranded: $9ee9c7b494d01fc9$export$66b0c798a395271f,
    ZodPipeline: $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da,
    ZodReadonly: $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a,
    custom: $9ee9c7b494d01fc9$export$4c00f665f0d4b443,
    Schema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    ZodSchema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    late: $9ee9c7b494d01fc9$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $9ee9c7b494d01fc9$export$558106ce543bd011;
    },
    coerce: $9ee9c7b494d01fc9$export$8c14e57e778d3873,
    any: $9ee9c7b494d01fc9$export$4154a199d7d90455,
    array: $9ee9c7b494d01fc9$export$2f23118c22fb2630,
    bigint: $9ee9c7b494d01fc9$export$a0f65b52274bcc00,
    boolean: $9ee9c7b494d01fc9$export$4a21f16c33752377,
    date: $9ee9c7b494d01fc9$export$324d90190a8b822a,
    discriminatedUnion: $9ee9c7b494d01fc9$export$4b888e40c4ee26dd,
    effect: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    'enum': $9ee9c7b494d01fc9$export$78a99c8d44d72635,
    'function': $9ee9c7b494d01fc9$export$44e51c8aac7c2deb,
    'instanceof': $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5,
    intersection: $9ee9c7b494d01fc9$export$bc86dfbf7795668c,
    lazy: $9ee9c7b494d01fc9$export$488013bae63b21da,
    literal: $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0,
    map: $9ee9c7b494d01fc9$export$871de8747c9eaa88,
    nan: $9ee9c7b494d01fc9$export$9e06de0973666692,
    nativeEnum: $9ee9c7b494d01fc9$export$6fe7eca19ebe5199,
    never: $9ee9c7b494d01fc9$export$b3e22bcfd64c1022,
    'null': $9ee9c7b494d01fc9$export$7b1b591b262c240,
    nullable: $9ee9c7b494d01fc9$export$133fc36489ac9add,
    number: $9ee9c7b494d01fc9$export$98e628dec113755e,
    object: $9ee9c7b494d01fc9$export$be5493f9613cbbe,
    oboolean: $9ee9c7b494d01fc9$export$269251733cdcbbf1,
    onumber: $9ee9c7b494d01fc9$export$eb150471a61fced6,
    optional: $9ee9c7b494d01fc9$export$516e28dec6a4b6d4,
    ostring: $9ee9c7b494d01fc9$export$3b3d07727c5b702c,
    pipeline: $9ee9c7b494d01fc9$export$43f28b24e1eb8181,
    preprocess: $9ee9c7b494d01fc9$export$fc37fe19dfda43ee,
    promise: $9ee9c7b494d01fc9$export$c957ef27a0ebfd4,
    record: $9ee9c7b494d01fc9$export$e5185e241753e543,
    set: $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be,
    strictObject: $9ee9c7b494d01fc9$export$8fb0df5f40d0b477,
    string: $9ee9c7b494d01fc9$export$22b082955e083ec3,
    symbol: $9ee9c7b494d01fc9$export$8f701197936bc2a6,
    transformer: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    tuple: $9ee9c7b494d01fc9$export$65e3907585753458,
    'undefined': $9ee9c7b494d01fc9$export$1db45310990710a5,
    union: $9ee9c7b494d01fc9$export$971dd5b0dfd021b6,
    unknown: $9ee9c7b494d01fc9$export$19282c40b967aec6,
    'void': $9ee9c7b494d01fc9$export$490e536ee7389aeb,
    NEVER: $9ee9c7b494d01fc9$export$96c94437c95d7862,
    ZodIssueCode: $9ee9c7b494d01fc9$export$5ba560653e4a1035,
    quotelessJson: $9ee9c7b494d01fc9$export$913eddeaf297cfea,
    ZodError: $9ee9c7b494d01fc9$export$f98dac4b251ab333
});

});

parcelRegister("9IHRK", function(module, exports) {
"use strict";
var $713a3ffa637bbeba$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $713a3ffa637bbeba$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $713a3ffa637bbeba$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$713a3ffa637bbeba$var$__exportStar((parcelRequire("jJSNL")), module.exports);

$713a3ffa637bbeba$var$__exportStar((parcelRequire("4wmh6")), module.exports);

$713a3ffa637bbeba$var$__exportStar((parcelRequire("hqlQK")), module.exports);

$713a3ffa637bbeba$var$__exportStar((parcelRequire("dRonm")), module.exports);

$713a3ffa637bbeba$var$__exportStar((parcelRequire("49BLc")), module.exports);

$713a3ffa637bbeba$var$__exportStar((parcelRequire("hiHEa")), module.exports);

$713a3ffa637bbeba$var$__exportStar((parcelRequire("d76y6")), module.exports);

});
parcelRegister("jJSNL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DisallowedDomainError = module.exports.UnsupportedDomainError = module.exports.ReservedHandleError = module.exports.InvalidHandleError = module.exports.isValidTld = module.exports.isValidHandle = module.exports.normalizeAndEnsureValidHandle = module.exports.normalizeHandle = module.exports.ensureValidHandleRegex = module.exports.ensureValidHandle = module.exports.DISALLOWED_TLDS = module.exports.INVALID_HANDLE = void 0;
module.exports.INVALID_HANDLE = 'handle.invalid';
// Currently these are registration-time restrictions, not protocol-level
// restrictions. We have a couple accounts in the wild that we need to clean up
// before hard-disallow.
// See also: https://en.wikipedia.org/wiki/Top-level_domain#Reserved_domains
module.exports.DISALLOWED_TLDS = [
    '.local',
    '.arpa',
    '.invalid',
    '.localhost',
    '.internal',
    '.example',
    '.alt',
    // policy could concievably change on ".onion" some day
    '.onion'
];
// Handle constraints, in English:
//  - must be a possible domain name
//    - RFC-1035 is commonly referenced, but has been updated. eg, RFC-3696,
//      section 2. and RFC-3986, section 3. can now have leading numbers (eg,
//      4chan.org)
//    - "labels" (sub-names) are made of ASCII letters, digits, hyphens
//    - can not start or end with a hyphen
//    - TLD (last component) should not start with a digit
//    - can't end with a hyphen (can end with digit)
//    - each segment must be between 1 and 63 characters (not including any periods)
//    - overall length can't be more than 253 characters
//    - separated by (ASCII) periods; does not start or end with period
//    - case insensitive
//    - domains (handles) are equal if they are the same lower-case
//    - punycode allowed for internationalization
//  - no whitespace, null bytes, joining chars, etc
//  - does not validate whether domain or TLD exists, or is a reserved or
//    special TLD (eg, .onion or .local)
//  - does not validate punycode
const $e5ecbac2828765fe$var$ensureValidHandle = (handle)=>{
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9.-]*$/.test(handle)) throw new $e5ecbac2828765fe$var$InvalidHandleError('Disallowed characters in handle (ASCII letters, digits, dashes, periods only)');
    if (handle.length > 253) throw new $e5ecbac2828765fe$var$InvalidHandleError('Handle is too long (253 chars max)');
    const labels = handle.split('.');
    if (labels.length < 2) throw new $e5ecbac2828765fe$var$InvalidHandleError('Handle domain needs at least two parts');
    for(let i = 0; i < labels.length; i++){
        const l = labels[i];
        if (l.length < 1) throw new $e5ecbac2828765fe$var$InvalidHandleError('Handle parts can not be empty');
        if (l.length > 63) throw new $e5ecbac2828765fe$var$InvalidHandleError('Handle part too long (max 63 chars)');
        if (l.endsWith('-') || l.startsWith('-')) throw new $e5ecbac2828765fe$var$InvalidHandleError('Handle parts can not start or end with hyphens');
        if (i + 1 === labels.length && !/^[a-zA-Z]/.test(l)) throw new $e5ecbac2828765fe$var$InvalidHandleError('Handle final component (TLD) must start with ASCII letter');
    }
};
module.exports.ensureValidHandle = $e5ecbac2828765fe$var$ensureValidHandle;
// simple regex translation of above constraints
const $e5ecbac2828765fe$var$ensureValidHandleRegex = (handle)=>{
    if (!/^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/.test(handle)) throw new $e5ecbac2828765fe$var$InvalidHandleError("Handle didn't validate via regex");
    if (handle.length > 253) throw new $e5ecbac2828765fe$var$InvalidHandleError('Handle is too long (253 chars max)');
};
module.exports.ensureValidHandleRegex = $e5ecbac2828765fe$var$ensureValidHandleRegex;
const $e5ecbac2828765fe$var$normalizeHandle = (handle)=>{
    return handle.toLowerCase();
};
module.exports.normalizeHandle = $e5ecbac2828765fe$var$normalizeHandle;
const $e5ecbac2828765fe$var$normalizeAndEnsureValidHandle = (handle)=>{
    const normalized = (0, module.exports.normalizeHandle)(handle);
    (0, module.exports.ensureValidHandle)(normalized);
    return normalized;
};
module.exports.normalizeAndEnsureValidHandle = $e5ecbac2828765fe$var$normalizeAndEnsureValidHandle;
const $e5ecbac2828765fe$var$isValidHandle = (handle)=>{
    try {
        (0, module.exports.ensureValidHandle)(handle);
    } catch (err) {
        if (err instanceof $e5ecbac2828765fe$var$InvalidHandleError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidHandle = $e5ecbac2828765fe$var$isValidHandle;
const $e5ecbac2828765fe$var$isValidTld = (handle)=>{
    return !module.exports.DISALLOWED_TLDS.some((domain)=>handle.endsWith(domain));
};
module.exports.isValidTld = $e5ecbac2828765fe$var$isValidTld;
class $e5ecbac2828765fe$var$InvalidHandleError extends Error {
}
module.exports.InvalidHandleError = $e5ecbac2828765fe$var$InvalidHandleError;
/** @deprecated Never used */ class $e5ecbac2828765fe$var$ReservedHandleError extends Error {
}
module.exports.ReservedHandleError = $e5ecbac2828765fe$var$ReservedHandleError;
/** @deprecated Never used */ class $e5ecbac2828765fe$var$UnsupportedDomainError extends Error {
}
module.exports.UnsupportedDomainError = $e5ecbac2828765fe$var$UnsupportedDomainError;
/** @deprecated Never used */ class $e5ecbac2828765fe$var$DisallowedDomainError extends Error {
}
module.exports.DisallowedDomainError = $e5ecbac2828765fe$var$DisallowedDomainError;

});

parcelRegister("4wmh6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidDidError = module.exports.ensureValidDidRegex = module.exports.ensureValidDid = void 0;
// Human-readable constraints:
//   - valid W3C DID (https://www.w3.org/TR/did-core/#did-syntax)
//      - entire URI is ASCII: [a-zA-Z0-9._:%-]
//      - always starts "did:" (lower-case)
//      - method name is one or more lower-case letters, followed by ":"
//      - remaining identifier can have any of the above chars, but can not end in ":"
//      - it seems that a bunch of ":" can be included, and don't need spaces between
//      - "%" is used only for "percent encoding" and must be followed by two hex characters (and thus can't end in "%")
//      - query ("?") and fragment ("#") stuff is defined for "DID URIs", but not as part of identifier itself
//      - "The current specification does not take a position on the maximum length of a DID"
//   - in current atproto, only allowing did:plc and did:web. But not *forcing* this at lexicon layer
//   - hard length limit of 8KBytes
//   - not going to validate "percent encoding" here
const $34ab6de46441f408$var$ensureValidDid = (did)=>{
    if (!did.startsWith('did:')) throw new $34ab6de46441f408$var$InvalidDidError('DID requires "did:" prefix');
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9._:%-]*$/.test(did)) throw new $34ab6de46441f408$var$InvalidDidError('Disallowed characters in DID (ASCII letters, digits, and a couple other characters only)');
    const { length: length, 1: method } = did.split(':');
    if (length < 3) throw new $34ab6de46441f408$var$InvalidDidError('DID requires prefix, method, and method-specific content');
    if (!/^[a-z]+$/.test(method)) throw new $34ab6de46441f408$var$InvalidDidError('DID method must be lower-case letters');
    if (did.endsWith(':') || did.endsWith('%')) throw new $34ab6de46441f408$var$InvalidDidError('DID can not end with ":" or "%"');
    if (did.length > 2048) throw new $34ab6de46441f408$var$InvalidDidError('DID is too long (2048 chars max)');
};
module.exports.ensureValidDid = $34ab6de46441f408$var$ensureValidDid;
const $34ab6de46441f408$var$ensureValidDidRegex = (did)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints
    if (!/^did:[a-z]+:[a-zA-Z0-9._:%-]*[a-zA-Z0-9._-]$/.test(did)) throw new $34ab6de46441f408$var$InvalidDidError("DID didn't validate via regex");
    if (did.length > 2048) throw new $34ab6de46441f408$var$InvalidDidError('DID is too long (2048 chars max)');
};
module.exports.ensureValidDidRegex = $34ab6de46441f408$var$ensureValidDidRegex;
class $34ab6de46441f408$var$InvalidDidError extends Error {
}
module.exports.InvalidDidError = $34ab6de46441f408$var$InvalidDidError;

});

parcelRegister("hqlQK", function(module, exports) {
"use strict";
/*
Grammar:

alpha     = "a" / "b" / "c" / "d" / "e" / "f" / "g" / "h" / "i" / "j" / "k" / "l" / "m" / "n" / "o" / "p" / "q" / "r" / "s" / "t" / "u" / "v" / "w" / "x" / "y" / "z" / "A" / "B" / "C" / "D" / "E" / "F" / "G" / "H" / "I" / "J" / "K" / "L" / "M" / "N" / "O" / "P" / "Q" / "R" / "S" / "T" / "U" / "V" / "W" / "X" / "Y" / "Z"
number    = "1" / "2" / "3" / "4" / "5" / "6" / "7" / "8" / "9" / "0"
delim     = "."
segment   = alpha *( alpha / number / "-" )
authority = segment *( delim segment )
name      = alpha *( alpha )
nsid      = authority delim name

*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidNsidError = module.exports.ensureValidNsidRegex = module.exports.ensureValidNsid = module.exports.NSID = void 0;
class $caf5d043d37d6636$var$NSID {
    static parse(nsid) {
        return new $caf5d043d37d6636$var$NSID(nsid);
    }
    static create(authority, name) {
        const segments = [
            ...authority.split('.').reverse(),
            name
        ].join('.');
        return new $caf5d043d37d6636$var$NSID(segments);
    }
    static isValid(nsid) {
        try {
            $caf5d043d37d6636$var$NSID.parse(nsid);
            return true;
        } catch (e) {
            return false;
        }
    }
    constructor(nsid){
        Object.defineProperty(this, "segments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        (0, module.exports.ensureValidNsid)(nsid);
        this.segments = nsid.split('.');
    }
    get authority() {
        return this.segments.slice(0, this.segments.length - 1).reverse().join('.');
    }
    get name() {
        return this.segments.at(this.segments.length - 1);
    }
    toString() {
        return this.segments.join('.');
    }
}
module.exports.NSID = $caf5d043d37d6636$var$NSID;
// Human readable constraints on NSID:
// - a valid domain in reversed notation
// - followed by an additional period-separated name, which is camel-case letters
const $caf5d043d37d6636$var$ensureValidNsid = (nsid)=>{
    const toCheck = nsid;
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9.-]*$/.test(toCheck)) throw new $caf5d043d37d6636$var$InvalidNsidError('Disallowed characters in NSID (ASCII letters, digits, dashes, periods only)');
    if (toCheck.length > 317) throw new $caf5d043d37d6636$var$InvalidNsidError('NSID is too long (317 chars max)');
    const labels = toCheck.split('.');
    if (labels.length < 3) throw new $caf5d043d37d6636$var$InvalidNsidError('NSID needs at least three parts');
    for(let i = 0; i < labels.length; i++){
        const l = labels[i];
        if (l.length < 1) throw new $caf5d043d37d6636$var$InvalidNsidError('NSID parts can not be empty');
        if (l.length > 63) throw new $caf5d043d37d6636$var$InvalidNsidError('NSID part too long (max 63 chars)');
        if (l.endsWith('-') || l.startsWith('-')) throw new $caf5d043d37d6636$var$InvalidNsidError('NSID parts can not start or end with hyphen');
        if (/^[0-9]/.test(l) && i === 0) throw new $caf5d043d37d6636$var$InvalidNsidError('NSID first part may not start with a digit');
        if (!/^[a-zA-Z][a-zA-Z0-9]*$/.test(l) && i + 1 === labels.length) throw new $caf5d043d37d6636$var$InvalidNsidError('NSID name part must be only letters and digits (and no leading digit)');
    }
};
module.exports.ensureValidNsid = $caf5d043d37d6636$var$ensureValidNsid;
const $caf5d043d37d6636$var$ensureValidNsidRegex = (nsid)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints
    if (!/^[a-zA-Z]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(\.[a-zA-Z]([a-zA-Z0-9]{0,62})?)$/.test(nsid)) throw new $caf5d043d37d6636$var$InvalidNsidError("NSID didn't validate via regex");
    if (nsid.length > 317) throw new $caf5d043d37d6636$var$InvalidNsidError('NSID is too long (317 chars max)');
};
module.exports.ensureValidNsidRegex = $caf5d043d37d6636$var$ensureValidNsidRegex;
class $caf5d043d37d6636$var$InvalidNsidError extends Error {
}
module.exports.InvalidNsidError = $caf5d043d37d6636$var$InvalidNsidError;

});

parcelRegister("dRonm", function(module, exports) {
"use strict";
var $a173222477362e19$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a173222477362e19$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a173222477362e19$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtUri = module.exports.ATP_URI_REGEX = void 0;

$a173222477362e19$var$__exportStar((parcelRequire("3eyKX")), module.exports);
module.exports.ATP_URI_REGEX = // proto-    --did--------------   --name----------------   --path----   --query--   --hash--
/^(at:\/\/)?((?:did:[a-z0-9:%-]+)|(?:[a-z0-9][a-z0-9.:-]*))(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
//                       --path-----   --query--  --hash--
const $a173222477362e19$var$RELATIVE_REGEX = /^(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
class $a173222477362e19$var$AtUri {
    constructor(uri, base){
        Object.defineProperty(this, "hash", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "host", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pathname", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "searchParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        let parsed;
        if (base) {
            parsed = $a173222477362e19$var$parse(base);
            if (!parsed) throw new Error(`Invalid at uri: ${base}`);
            const relativep = $a173222477362e19$var$parseRelative(uri);
            if (!relativep) throw new Error(`Invalid path: ${uri}`);
            Object.assign(parsed, relativep);
        } else {
            parsed = $a173222477362e19$var$parse(uri);
            if (!parsed) throw new Error(`Invalid at uri: ${uri}`);
        }
        this.hash = parsed.hash;
        this.host = parsed.host;
        this.pathname = parsed.pathname;
        this.searchParams = parsed.searchParams;
    }
    static make(handleOrDid, collection, rkey) {
        let str = handleOrDid;
        if (collection) str += '/' + collection;
        if (rkey) str += '/' + rkey;
        return new $a173222477362e19$var$AtUri(str);
    }
    get protocol() {
        return 'at:';
    }
    get origin() {
        return `at://${this.host}`;
    }
    get hostname() {
        return this.host;
    }
    set hostname(v) {
        this.host = v;
    }
    get search() {
        return this.searchParams.toString();
    }
    set search(v) {
        this.searchParams = new URLSearchParams(v);
    }
    get collection() {
        return this.pathname.split('/').filter(Boolean)[0] || '';
    }
    set collection(v) {
        const parts = this.pathname.split('/').filter(Boolean);
        parts[0] = v;
        this.pathname = parts.join('/');
    }
    get rkey() {
        return this.pathname.split('/').filter(Boolean)[1] || '';
    }
    set rkey(v) {
        const parts = this.pathname.split('/').filter(Boolean);
        if (!parts[0]) parts[0] = 'undefined';
        parts[1] = v;
        this.pathname = parts.join('/');
    }
    get href() {
        return this.toString();
    }
    toString() {
        let path = this.pathname || '/';
        if (!path.startsWith('/')) path = `/${path}`;
        let qs = this.searchParams.toString();
        if (qs && !qs.startsWith('?')) qs = `?${qs}`;
        let hash = this.hash;
        if (hash && !hash.startsWith('#')) hash = `#${hash}`;
        return `at://${this.host}${path}${qs}${hash}`;
    }
}
module.exports.AtUri = $a173222477362e19$var$AtUri;
function $a173222477362e19$var$parse(str) {
    const match = module.exports.ATP_URI_REGEX.exec(str);
    if (match) return {
        hash: match[5] || '',
        host: match[2] || '',
        pathname: match[3] || '',
        searchParams: new URLSearchParams(match[4] || '')
    };
    return undefined;
}
function $a173222477362e19$var$parseRelative(str) {
    const match = $a173222477362e19$var$RELATIVE_REGEX.exec(str);
    if (match) return {
        hash: match[3] || '',
        pathname: match[1] || '',
        searchParams: new URLSearchParams(match[2] || '')
    };
    return undefined;
}

});
parcelRegister("3eyKX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ensureValidAtUriRegex = module.exports.ensureValidAtUri = void 0;

var $4wmh6 = parcelRequire("4wmh6");

var $jJSNL = parcelRequire("jJSNL");

var $hqlQK = parcelRequire("hqlQK");
// Human-readable constraints on ATURI:
//   - following regular URLs, a 8KByte hard total length limit
//   - follows ATURI docs on website
//      - all ASCII characters, no whitespace. non-ASCII could be URL-encoded
//      - starts "at://"
//      - "authority" is a valid DID or a valid handle
//      - optionally, follow "authority" with "/" and valid NSID as start of path
//      - optionally, if NSID given, follow that with "/" and rkey
//      - rkey path component can include URL-encoded ("percent encoded"), or:
//          ALPHA / DIGIT / "-" / "." / "_" / "~" / ":" / "@" / "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
//          [a-zA-Z0-9._~:@!$&'\(\)*+,;=-]
//      - rkey must have at least one char
//      - regardless of path component, a fragment can follow  as "#" and then a JSON pointer (RFC-6901)
const $25ada3cb521e1952$var$ensureValidAtUri = (uri)=>{
    // JSON pointer is pretty different from rest of URI, so split that out first
    const uriParts = uri.split('#');
    if (uriParts.length > 2) throw new Error('ATURI can have at most one "#", separating fragment out');
    const fragmentPart = uriParts[1] || null;
    uri = uriParts[0];
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9._~:@!$&')(*+,;=%/-]*$/.test(uri)) throw new Error('Disallowed characters in ATURI (ASCII)');
    const parts = uri.split('/');
    if (parts.length >= 3 && (parts[0] !== 'at:' || parts[1].length !== 0)) throw new Error('ATURI must start with "at://"');
    if (parts.length < 3) throw new Error('ATURI requires at least method and authority sections');
    try {
        if (parts[2].startsWith('did:')) (0, $4wmh6.ensureValidDid)(parts[2]);
        else (0, $jJSNL.ensureValidHandle)(parts[2]);
    } catch  {
        throw new Error('ATURI authority must be a valid handle or DID');
    }
    if (parts.length >= 4) {
        if (parts[3].length === 0) throw new Error('ATURI can not have a slash after authority without a path segment');
        try {
            (0, $hqlQK.ensureValidNsid)(parts[3]);
        } catch  {
            throw new Error('ATURI requires first path segment (if supplied) to be valid NSID');
        }
    }
    if (parts.length >= 5) {
        if (parts[4].length === 0) throw new Error('ATURI can not have a slash after collection, unless record key is provided');
    // would validate rkey here, but there are basically no constraints!
    }
    if (parts.length >= 6) throw new Error('ATURI path can have at most two parts, and no trailing slash');
    if (uriParts.length >= 2 && fragmentPart == null) throw new Error('ATURI fragment must be non-empty and start with slash');
    if (fragmentPart != null) {
        if (fragmentPart.length === 0 || fragmentPart[0] !== '/') throw new Error('ATURI fragment must be non-empty and start with slash');
        // NOTE: enforcing *some* checks here for sanity. Eg, at least no whitespace
        if (!/^\/[a-zA-Z0-9._~:@!$&')(*+,;=%[\]/-]*$/.test(fragmentPart)) throw new Error('Disallowed characters in ATURI fragment (ASCII)');
    }
    if (uri.length > 8192) throw new Error('ATURI is far too long');
};
module.exports.ensureValidAtUri = $25ada3cb521e1952$var$ensureValidAtUri;
const $25ada3cb521e1952$var$ensureValidAtUriRegex = (uri)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints. whew!
    const aturiRegex = /^at:\/\/(?<authority>[a-zA-Z0-9._:%-]+)(\/(?<collection>[a-zA-Z0-9-.]+)(\/(?<rkey>[a-zA-Z0-9._~:@!$&%')(*+,;=-]+))?)?(#(?<fragment>\/[a-zA-Z0-9._~:@!$&%')(*+,;=\-[\]/\\]*))?$/;
    const rm = uri.match(aturiRegex);
    if (!rm || !rm.groups) throw new Error("ATURI didn't validate via regex");
    const groups = rm.groups;
    try {
        (0, $jJSNL.ensureValidHandleRegex)(groups.authority);
    } catch  {
        try {
            (0, $4wmh6.ensureValidDidRegex)(groups.authority);
        } catch  {
            throw new Error('ATURI authority must be a valid handle or DID');
        }
    }
    if (groups.collection) try {
        (0, $hqlQK.ensureValidNsidRegex)(groups.collection);
    } catch  {
        throw new Error('ATURI collection path segment must be a valid NSID');
    }
    if (uri.length > 8192) throw new Error('ATURI is far too long');
};
module.exports.ensureValidAtUriRegex = $25ada3cb521e1952$var$ensureValidAtUriRegex;

});


parcelRegister("49BLc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidTidError = module.exports.isValidTid = module.exports.ensureValidTid = void 0;
const $30654b15f480ec69$var$TID_LENGTH = 13;
const $30654b15f480ec69$var$TID_REGEX = /^[234567abcdefghij][234567abcdefghijklmnopqrstuvwxyz]{12}$/;
const $30654b15f480ec69$var$ensureValidTid = (tid)=>{
    if (tid.length !== $30654b15f480ec69$var$TID_LENGTH) throw new $30654b15f480ec69$var$InvalidTidError(`TID must be ${$30654b15f480ec69$var$TID_LENGTH} characters`);
    // simple regex to enforce most constraints via just regex and length.
    if (!$30654b15f480ec69$var$TID_REGEX.test(tid)) throw new $30654b15f480ec69$var$InvalidTidError('TID syntax not valid (regex)');
};
module.exports.ensureValidTid = $30654b15f480ec69$var$ensureValidTid;
const $30654b15f480ec69$var$isValidTid = (tid)=>{
    return tid.length === $30654b15f480ec69$var$TID_LENGTH && $30654b15f480ec69$var$TID_REGEX.test(tid);
};
module.exports.isValidTid = $30654b15f480ec69$var$isValidTid;
class $30654b15f480ec69$var$InvalidTidError extends Error {
}
module.exports.InvalidTidError = $30654b15f480ec69$var$InvalidTidError;

});

parcelRegister("hiHEa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidRecordKeyError = module.exports.isValidRecordKey = module.exports.ensureValidRecordKey = void 0;
const $c985f97081204c0e$var$ensureValidRecordKey = (rkey)=>{
    if (rkey.length > 512 || rkey.length < 1) throw new $c985f97081204c0e$var$InvalidRecordKeyError('record key must be 1 to 512 characters');
    // simple regex to enforce most constraints via just regex and length.
    if (!/^[a-zA-Z0-9_~.:-]{1,512}$/.test(rkey)) throw new $c985f97081204c0e$var$InvalidRecordKeyError('record key syntax not valid (regex)');
    if (rkey === '.' || rkey === '..') throw new $c985f97081204c0e$var$InvalidRecordKeyError('record key can not be "." or ".."');
};
module.exports.ensureValidRecordKey = $c985f97081204c0e$var$ensureValidRecordKey;
const $c985f97081204c0e$var$isValidRecordKey = (rkey)=>{
    try {
        (0, module.exports.ensureValidRecordKey)(rkey);
    } catch (err) {
        if (err instanceof $c985f97081204c0e$var$InvalidRecordKeyError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidRecordKey = $c985f97081204c0e$var$isValidRecordKey;
class $c985f97081204c0e$var$InvalidRecordKeyError extends Error {
}
module.exports.InvalidRecordKeyError = $c985f97081204c0e$var$InvalidRecordKeyError;

});

parcelRegister("d76y6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidDatetimeError = module.exports.normalizeDatetimeAlways = module.exports.normalizeDatetime = module.exports.isValidDatetime = module.exports.ensureValidDatetime = void 0;
/* Validates datetime string against atproto Lexicon 'datetime' format.
 * Syntax is described at: https://atproto.com/specs/lexicon#datetime
 */ const $98c1024ca2334a5c$var$ensureValidDatetime = (dtStr)=>{
    const date = new Date(dtStr);
    // must parse as ISO 8601; this also verifies semantics like month is not 13 or 00
    if (isNaN(date.getTime())) throw new $98c1024ca2334a5c$var$InvalidDatetimeError('datetime did not parse as ISO 8601');
    if (date.toISOString().startsWith('-')) throw new $98c1024ca2334a5c$var$InvalidDatetimeError('datetime normalized to a negative time');
    // regex and other checks for RFC-3339
    if (!/^[0-9]{4}-[01][0-9]-[0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9](.[0-9]{1,20})?(Z|([+-][0-2][0-9]:[0-5][0-9]))$/.test(dtStr)) throw new $98c1024ca2334a5c$var$InvalidDatetimeError("datetime didn't validate via regex");
    if (dtStr.length > 64) throw new $98c1024ca2334a5c$var$InvalidDatetimeError('datetime is too long (64 chars max)');
    if (dtStr.endsWith('-00:00')) throw new $98c1024ca2334a5c$var$InvalidDatetimeError('datetime can not use "-00:00" for UTC timezone');
    if (dtStr.startsWith('000')) throw new $98c1024ca2334a5c$var$InvalidDatetimeError('datetime so close to year zero not allowed');
};
module.exports.ensureValidDatetime = $98c1024ca2334a5c$var$ensureValidDatetime;
/* Same logic as ensureValidDatetime(), but returns a boolean instead of throwing an exception.
 */ const $98c1024ca2334a5c$var$isValidDatetime = (dtStr)=>{
    try {
        (0, module.exports.ensureValidDatetime)(dtStr);
    } catch (err) {
        if (err instanceof $98c1024ca2334a5c$var$InvalidDatetimeError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidDatetime = $98c1024ca2334a5c$var$isValidDatetime;
/* Takes a flexible datetime string and normalizes representation.
 *
 * This function will work with any valid atproto datetime (eg, anything which isValidDatetime() is true for). It *additionally* is more flexible about accepting datetimes that don't comply to RFC 3339, or are missing timezone information, and normalizing them to a valid datetime.
 *
 * One use-case is a consistent, sortable string. Another is to work with older invalid createdAt datetimes.
 *
 * Successful output will be a valid atproto datetime with millisecond precision (3 sub-second digits) and UTC timezone with trailing 'Z' syntax. Throws `InvalidDatetimeError` if the input string could not be parsed as a datetime, even with permissive parsing.
 *
 * Expected output format: YYYY-MM-DDTHH:mm:ss.sssZ
 */ const $98c1024ca2334a5c$var$normalizeDatetime = (dtStr)=>{
    if ((0, module.exports.isValidDatetime)(dtStr)) {
        const outStr = new Date(dtStr).toISOString();
        if ((0, module.exports.isValidDatetime)(outStr)) return outStr;
    }
    // check if this permissive datetime is missing a timezone
    if (!/.*(([+-]\d\d:?\d\d)|[a-zA-Z])$/.test(dtStr)) {
        const date = new Date(dtStr + 'Z');
        if (!isNaN(date.getTime())) {
            const tzStr = date.toISOString();
            if ((0, module.exports.isValidDatetime)(tzStr)) return tzStr;
        }
    }
    // finally try parsing as simple datetime
    const date = new Date(dtStr);
    if (isNaN(date.getTime())) throw new $98c1024ca2334a5c$var$InvalidDatetimeError('datetime did not parse as any timestamp format');
    const isoStr = date.toISOString();
    if ((0, module.exports.isValidDatetime)(isoStr)) return isoStr;
    else throw new $98c1024ca2334a5c$var$InvalidDatetimeError('datetime normalized to invalid timestamp string');
};
module.exports.normalizeDatetime = $98c1024ca2334a5c$var$normalizeDatetime;
/* Variant of normalizeDatetime() which always returns a valid datetime strings.
 *
 * If a InvalidDatetimeError is encountered, returns the UNIX epoch time as a UTC datetime (1970-01-01T00:00:00.000Z).
 */ const $98c1024ca2334a5c$var$normalizeDatetimeAlways = (dtStr)=>{
    try {
        return (0, module.exports.normalizeDatetime)(dtStr);
    } catch (err) {
        if (err instanceof $98c1024ca2334a5c$var$InvalidDatetimeError) return new Date(0).toISOString();
        throw err;
    }
};
module.exports.normalizeDatetimeAlways = $98c1024ca2334a5c$var$normalizeDatetimeAlways;
/* Indicates a datetime string did not pass full atproto Lexicon datetime string format checks.
 */ class $98c1024ca2334a5c$var$InvalidDatetimeError extends Error {
}
module.exports.InvalidDatetimeError = $98c1024ca2334a5c$var$InvalidDatetimeError;

});


parcelRegister("78Ykk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toLexUri = $5338136e99e40211$var$toLexUri;
module.exports.requiredPropertiesRefinement = $5338136e99e40211$var$requiredPropertiesRefinement;

var $2zDt6 = parcelRequire("2zDt6");
function $5338136e99e40211$var$toLexUri(str, baseUri) {
    if (str.split('#').length > 2) throw new Error('Uri can only have one hash segment');
    if (str.startsWith('lex:')) return str;
    if (str.startsWith('#')) {
        if (!baseUri) throw new Error(`Unable to resolve uri without anchor: ${str}`);
        return `${baseUri}${str}`;
    }
    return `lex:${str}`;
}
function $5338136e99e40211$var$requiredPropertiesRefinement(object, ctx) {
    // Required fields check
    if (object.required === undefined) return;
    if (!Array.isArray(object.required)) {
        ctx.addIssue({
            code: $2zDt6.z.ZodIssueCode.invalid_type,
            received: typeof object.required,
            expected: 'array'
        });
        return;
    }
    if (object.properties === undefined) {
        if (object.required.length > 0) ctx.addIssue({
            code: $2zDt6.z.ZodIssueCode.custom,
            message: `Required fields defined but no properties defined`
        });
        return;
    }
    for (const field of object.required)if (object.properties[field] === undefined) ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: `Required field "${field}" not defined`
    });
}

});


parcelRegister("fqvnA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexicons = void 0;

var $8gte5 = parcelRequire("8gte5");

var $78Ykk = parcelRequire("78Ykk");

var $ieUkn = parcelRequire("ieUkn");

var $7Y8kb = parcelRequire("7Y8kb");
/**
 * A collection of compiled lexicons.
 */ class $b3b1a004a95ef16f$var$Lexicons {
    constructor(docs){
        Object.defineProperty(this, "docs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "defs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        if (docs) for (const doc of docs)this.add(doc);
    }
    /**
     * @example clone a lexicon:
     * ```ts
     * const clone = new Lexicons(originalLexicon)
     * ```
     *
     * @example get docs array:
     * ```ts
     * const docs = Array.from(lexicons)
     * ```
     */ [Symbol.iterator]() {
        return this.docs.values();
    }
    /**
     * Add a lexicon doc.
     */ add(doc) {
        const uri = (0, $78Ykk.toLexUri)(doc.id);
        if (this.docs.has(uri)) throw new Error(`${uri} has already been registered`);
        // WARNING
        // mutates the object
        // -prf
        $b3b1a004a95ef16f$var$resolveRefUris(doc, uri);
        this.docs.set(uri, doc);
        for (const [defUri, def] of $b3b1a004a95ef16f$var$iterDefs(doc))this.defs.set(defUri, def);
    }
    /**
     * Remove a lexicon doc.
     */ remove(uri) {
        uri = (0, $78Ykk.toLexUri)(uri);
        const doc = this.docs.get(uri);
        if (!doc) throw new Error(`Unable to remove "${uri}": does not exist`);
        for (const [defUri, _def] of $b3b1a004a95ef16f$var$iterDefs(doc))this.defs.delete(defUri);
        this.docs.delete(uri);
    }
    /**
     * Get a lexicon doc.
     */ get(uri) {
        uri = (0, $78Ykk.toLexUri)(uri);
        return this.docs.get(uri);
    }
    /**
     * Get a definition.
     */ getDef(uri) {
        uri = (0, $78Ykk.toLexUri)(uri);
        return this.defs.get(uri);
    }
    getDefOrThrow(uri, types) {
        const def = this.getDef(uri);
        if (!def) throw new $8gte5.LexiconDefNotFoundError(`Lexicon not found: ${uri}`);
        if (types && !types.includes(def.type)) throw new $8gte5.InvalidLexiconError(`Not a ${types.join(' or ')} lexicon: ${uri}`);
        return def;
    }
    /**
     * Validate a record or object.
     */ validate(lexUri, value) {
        if (!(0, $8gte5.isObj)(value)) throw new $8gte5.ValidationError(`Value must be an object`);
        const lexUriNormalized = (0, $78Ykk.toLexUri)(lexUri);
        const def = this.getDefOrThrow(lexUriNormalized, [
            'record',
            'object'
        ]);
        if (def.type === 'record') return (0, $7Y8kb.object)(this, 'Record', def.record, value);
        else if (def.type === 'object') return (0, $7Y8kb.object)(this, 'Object', def, value);
        else // shouldn't happen
        throw new $8gte5.InvalidLexiconError('Definition must be a record or object');
    }
    /**
     * Validate a record and throw on any error.
     */ assertValidRecord(lexUri, value) {
        if (!(0, $8gte5.isObj)(value)) throw new $8gte5.ValidationError(`Record must be an object`);
        if (!('$type' in value)) throw new $8gte5.ValidationError(`Record/$type must be a string`);
        const { $type: $type } = value;
        if (typeof $type !== 'string') throw new $8gte5.ValidationError(`Record/$type must be a string`);
        const lexUriNormalized = (0, $78Ykk.toLexUri)(lexUri);
        if ((0, $78Ykk.toLexUri)($type) !== lexUriNormalized) throw new $8gte5.ValidationError(`Invalid $type: must be ${lexUriNormalized}, got ${$type}`);
        const def = this.getDefOrThrow(lexUriNormalized, [
            'record'
        ]);
        return (0, $ieUkn.assertValidRecord)(this, def, value);
    }
    /**
     * Validate xrpc query params and throw on any error.
     */ assertValidXrpcParams(lexUri, value) {
        lexUri = (0, $78Ykk.toLexUri)(lexUri);
        const def = this.getDefOrThrow(lexUri, [
            'query',
            'procedure',
            'subscription'
        ]);
        return (0, $ieUkn.assertValidXrpcParams)(this, def, value);
    }
    /**
     * Validate xrpc input body and throw on any error.
     */ assertValidXrpcInput(lexUri, value) {
        lexUri = (0, $78Ykk.toLexUri)(lexUri);
        const def = this.getDefOrThrow(lexUri, [
            'procedure'
        ]);
        return (0, $ieUkn.assertValidXrpcInput)(this, def, value);
    }
    /**
     * Validate xrpc output body and throw on any error.
     */ assertValidXrpcOutput(lexUri, value) {
        lexUri = (0, $78Ykk.toLexUri)(lexUri);
        const def = this.getDefOrThrow(lexUri, [
            'query',
            'procedure'
        ]);
        return (0, $ieUkn.assertValidXrpcOutput)(this, def, value);
    }
    /**
     * Validate xrpc subscription message and throw on any error.
     */ assertValidXrpcMessage(lexUri, value) {
        lexUri = (0, $78Ykk.toLexUri)(lexUri);
        const def = this.getDefOrThrow(lexUri, [
            'subscription'
        ]);
        return (0, $ieUkn.assertValidXrpcMessage)(this, def, value);
    }
    /**
     * Resolve a lex uri given a ref
     */ resolveLexUri(lexUri, ref) {
        lexUri = (0, $78Ykk.toLexUri)(lexUri);
        return (0, $78Ykk.toLexUri)(ref, lexUri);
    }
}
module.exports.Lexicons = $b3b1a004a95ef16f$var$Lexicons;
function* $b3b1a004a95ef16f$var$iterDefs(doc) {
    for(const defId in doc.defs){
        yield [
            `lex:${doc.id}#${defId}`,
            doc.defs[defId]
        ];
        if (defId === 'main') yield [
            `lex:${doc.id}`,
            doc.defs[defId]
        ];
    }
}
// WARNING
// this method mutates objects
// -prf
function $b3b1a004a95ef16f$var$resolveRefUris(obj, baseUri) {
    for(const k in obj){
        if (obj.type === 'ref') obj.ref = (0, $78Ykk.toLexUri)(obj.ref, baseUri);
        else if (obj.type === 'union') obj.refs = obj.refs.map((ref)=>(0, $78Ykk.toLexUri)(ref, baseUri));
        else if (Array.isArray(obj[k])) obj[k] = obj[k].map((item)=>{
            if (typeof item === 'string') return item.startsWith('#') ? (0, $78Ykk.toLexUri)(item, baseUri) : item;
            else if (item && typeof item === 'object') return $b3b1a004a95ef16f$var$resolveRefUris(item, baseUri);
            return item;
        });
        else if (obj[k] && typeof obj[k] === 'object') obj[k] = $b3b1a004a95ef16f$var$resolveRefUris(obj[k], baseUri);
    }
    return obj;
}

});
parcelRegister("ieUkn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertValidRecord = $d4753a4a8a117c34$var$assertValidRecord;
module.exports.assertValidXrpcParams = $d4753a4a8a117c34$var$assertValidXrpcParams;
module.exports.assertValidXrpcInput = $d4753a4a8a117c34$var$assertValidXrpcInput;
module.exports.assertValidXrpcOutput = $d4753a4a8a117c34$var$assertValidXrpcOutput;
module.exports.assertValidXrpcMessage = $d4753a4a8a117c34$var$assertValidXrpcMessage;

var $7Y8kb = parcelRequire("7Y8kb");

var $6jNDP = parcelRequire("6jNDP");
function $d4753a4a8a117c34$var$assertValidRecord(lexicons, def, value) {
    const res = (0, $7Y8kb.object)(lexicons, 'Record', def.record, value);
    if (!res.success) throw res.error;
    return res.value;
}
function $d4753a4a8a117c34$var$assertValidXrpcParams(lexicons, def, value) {
    if (def.parameters) {
        const res = (0, $6jNDP.params)(lexicons, 'Params', def.parameters, value);
        if (!res.success) throw res.error;
        return res.value;
    }
}
function $d4753a4a8a117c34$var$assertValidXrpcInput(lexicons, def, value) {
    if (def.input?.schema) // loop: all input schema definitions
    return $d4753a4a8a117c34$var$assertValidOneOf(lexicons, 'Input', def.input.schema, value, true);
}
function $d4753a4a8a117c34$var$assertValidXrpcOutput(lexicons, def, value) {
    if (def.output?.schema) // loop: all output schema definitions
    return $d4753a4a8a117c34$var$assertValidOneOf(lexicons, 'Output', def.output.schema, value, true);
}
function $d4753a4a8a117c34$var$assertValidXrpcMessage(lexicons, def, value) {
    if (def.message?.schema) // loop: all output schema definitions
    return $d4753a4a8a117c34$var$assertValidOneOf(lexicons, 'Message', def.message.schema, value, true);
}
function $d4753a4a8a117c34$var$assertValidOneOf(lexicons, path, def, value, mustBeObj = false) {
    const res = (0, $7Y8kb.validateOneOf)(lexicons, path, def, value, mustBeObj);
    if (!res.success) throw res.error;
    return res.value;
}

});
parcelRegister("7Y8kb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validate = $5cd498153bb473c7$var$validate;
module.exports.array = $5cd498153bb473c7$var$array;
module.exports.object = $5cd498153bb473c7$var$object;
module.exports.validateOneOf = $5cd498153bb473c7$var$validateOneOf;

var $8gte5 = parcelRequire("8gte5");

var $78Ykk = parcelRequire("78Ykk");

var $1b6Cy = parcelRequire("1b6Cy");

var $9FyPS = parcelRequire("9FyPS");
function $5cd498153bb473c7$var$validate(lexicons, path, def, value) {
    switch(def.type){
        case 'object':
            return $5cd498153bb473c7$var$object(lexicons, path, def, value);
        case 'array':
            return $5cd498153bb473c7$var$array(lexicons, path, def, value);
        case 'blob':
            return (0, $1b6Cy.blob)(lexicons, path, def, value);
        default:
            return (0, $9FyPS.validate)(lexicons, path, def, value);
    }
}
function $5cd498153bb473c7$var$array(lexicons, path, def, value) {
    // type
    if (!Array.isArray(value)) return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be an array`)
    };
    // maxLength
    if (typeof def.maxLength === 'number') {
        if (value.length > def.maxLength) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must not have more than ${def.maxLength} elements`)
        };
    }
    // minLength
    if (typeof def.minLength === 'number') {
        if (value.length < def.minLength) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must not have fewer than ${def.minLength} elements`)
        };
    }
    // items
    const itemsDef = def.items;
    for(let i = 0; i < value.length; i++){
        const itemValue = value[i];
        const itemPath = `${path}/${i}`;
        const res = $5cd498153bb473c7$var$validateOneOf(lexicons, itemPath, itemsDef, itemValue);
        if (!res.success) return res;
    }
    return {
        success: true,
        value: value
    };
}
function $5cd498153bb473c7$var$object(lexicons, path, def, value) {
    // type
    if (!(0, $8gte5.isObj)(value)) return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be an object`)
    };
    // properties
    let resultValue = value;
    if ('properties' in def && def.properties != null) for(const key in def.properties){
        const keyValue = value[key];
        if (keyValue === null && def.nullable?.includes(key)) continue;
        const propDef = def.properties[key];
        if (keyValue === undefined && !def.required?.includes(key)) {
            // Fast path for non-required undefined props.
            if (propDef.type === 'integer' || propDef.type === 'boolean' || propDef.type === 'string') {
                if (propDef.default === undefined) continue;
            } else continue;
        }
        const propPath = `${path}/${key}`;
        const validated = $5cd498153bb473c7$var$validateOneOf(lexicons, propPath, propDef, keyValue);
        const propValue = validated.success ? validated.value : keyValue;
        // Return error for bad validation, giving required rule precedence
        if (propValue === undefined) {
            if (def.required?.includes(key)) return {
                success: false,
                error: new $8gte5.ValidationError(`${path} must have the property "${key}"`)
            };
        } else {
            if (!validated.success) return validated;
        }
        // Adjust value based on e.g. applied defaults, cloning shallowly if there was a changed value
        if (propValue !== keyValue) {
            if (resultValue === value) // Lazy shallow clone
            resultValue = {
                ...value
            };
            resultValue[key] = propValue;
        }
    }
    return {
        success: true,
        value: resultValue
    };
}
function $5cd498153bb473c7$var$validateOneOf(lexicons, path, def, value, mustBeObj = false) {
    let concreteDef;
    if (def.type === 'union') {
        if (!(0, $8gte5.isDiscriminatedObject)(value)) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be an object which includes the "$type" property`)
        };
        if (!$5cd498153bb473c7$var$refsContainType(def.refs, value.$type)) {
            if (def.closed) return {
                success: false,
                error: new $8gte5.ValidationError(`${path} $type must be one of ${def.refs.join(', ')}`)
            };
            return {
                success: true,
                value: value
            };
        } else concreteDef = lexicons.getDefOrThrow(value.$type);
    } else if (def.type === 'ref') concreteDef = lexicons.getDefOrThrow(def.ref);
    else concreteDef = def;
    return mustBeObj ? $5cd498153bb473c7$var$object(lexicons, path, concreteDef, value) : $5cd498153bb473c7$var$validate(lexicons, path, concreteDef, value);
}
// to avoid bugs like #0189 this needs to handle both
// explicit and implicit #main
const $5cd498153bb473c7$var$refsContainType = (refs, type)=>{
    const lexUri = (0, $78Ykk.toLexUri)(type);
    if (refs.includes(lexUri)) return true;
    if (lexUri.endsWith('#main')) return refs.includes(lexUri.slice(0, -5));
    else return !lexUri.includes('#') && refs.includes(`${lexUri}#main`);
};

});
parcelRegister("1b6Cy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.blob = $0dbbf444d2c67262$var$blob;

var $9mWeA = parcelRequire("9mWeA");

var $8gte5 = parcelRequire("8gte5");
function $0dbbf444d2c67262$var$blob(lexicons, path, def, value) {
    // check
    if (!value || !(value instanceof $9mWeA.BlobRef)) return {
        success: false,
        error: new $8gte5.ValidationError(`${path} should be a blob ref`)
    };
    return {
        success: true,
        value: value
    };
}

});
parcelRegister("9mWeA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlobRef = module.exports.jsonBlobRef = module.exports.untypedJsonBlobRef = module.exports.typedJsonBlobRef = void 0;

var $a3h4N = parcelRequire("a3h4N");

var $2zDt6 = parcelRequire("2zDt6");

var $bc6Ix = parcelRequire("bc6Ix");
module.exports.typedJsonBlobRef = $2zDt6.z.object({
    $type: $2zDt6.z.literal('blob'),
    ref: $bc6Ix.schema.cid,
    mimeType: $2zDt6.z.string(),
    size: $2zDt6.z.number()
}).strict();
module.exports.untypedJsonBlobRef = $2zDt6.z.object({
    cid: $2zDt6.z.string(),
    mimeType: $2zDt6.z.string()
}).strict();
module.exports.jsonBlobRef = $2zDt6.z.union([
    module.exports.typedJsonBlobRef,
    module.exports.untypedJsonBlobRef
]);
class $6d235738dc228eb7$var$BlobRef {
    constructor(ref, mimeType, size, original){
        Object.defineProperty(this, "ref", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ref
        });
        Object.defineProperty(this, "mimeType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: mimeType
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: size
        });
        Object.defineProperty(this, "original", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.original = original ?? {
            $type: 'blob',
            ref: ref,
            mimeType: mimeType,
            size: size
        };
    }
    static asBlobRef(obj) {
        if ($bc6Ix.check.is(obj, module.exports.jsonBlobRef)) return $6d235738dc228eb7$var$BlobRef.fromJsonRef(obj);
        return null;
    }
    static fromJsonRef(json) {
        if ($bc6Ix.check.is(json, module.exports.typedJsonBlobRef)) return new $6d235738dc228eb7$var$BlobRef(json.ref, json.mimeType, json.size);
        else return new $6d235738dc228eb7$var$BlobRef($a3h4N.CID.parse(json.cid), json.mimeType, -1, json);
    }
    ipld() {
        return {
            $type: 'blob',
            ref: this.ref,
            mimeType: this.mimeType,
            size: this.size
        };
    }
    toJSON() {
        return (0, $bc6Ix.ipldToJson)(this.ipld());
    }
}
module.exports.BlobRef = $6d235738dc228eb7$var$BlobRef;

});
parcelRegister("a3h4N", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $4mKzA = parcelRequire("4mKzA");

var $kRxmT = parcelRequire("kRxmT");

var $g48Q7 = parcelRequire("g48Q7");

var $9mHUH = parcelRequire("9mHUH");

var $6DEzE = parcelRequire("6DEzE");
class $75176e30f12252bd$var$CID {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $75176e30f12252bd$var$hidden,
            byteLength: $75176e30f12252bd$var$hidden,
            code: $75176e30f12252bd$var$readonly,
            version: $75176e30f12252bd$var$readonly,
            multihash: $75176e30f12252bd$var$readonly,
            bytes: $75176e30f12252bd$var$readonly,
            _baseCache: $75176e30f12252bd$var$hidden,
            asCID: $75176e30f12252bd$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error('Cannot convert a non dag-pb CID to CIDv0');
                    if (multihash.code !== $75176e30f12252bd$var$SHA_256_CODE) throw new Error('Cannot convert non sha2-256 multihash CID to CIDv0');
                    return $75176e30f12252bd$var$CID.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest$1 } = this.multihash;
                    const multihash = $kRxmT.create(code, digest$1);
                    return $75176e30f12252bd$var$CID.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $kRxmT.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $75176e30f12252bd$var$toStringV0(bytes, _baseCache, base || $g48Q7.base58btc.encoder);
            default:
                return $75176e30f12252bd$var$toStringV1(bytes, _baseCache, base || $9mHUH.base32.encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return 'CID';
    }
    [Symbol.for('nodejs.util.inspect.custom')]() {
        return 'CID(' + this.toString() + ')';
    }
    static isCID(value) {
        $75176e30f12252bd$var$deprecate(/^0\.0/, $75176e30f12252bd$var$IS_CID_DEPRECATION);
        return !!(value && (value[$75176e30f12252bd$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error('Deprecated, use .toString()');
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error('Deprecated .buffer property, use .bytes to get Uint8Array instead');
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $75176e30f12252bd$var$CID) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $75176e30f12252bd$var$CID(version, code, multihash, bytes || $75176e30f12252bd$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$75176e30f12252bd$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest$1 = $kRxmT.decode(multihash);
            return $75176e30f12252bd$var$CID.create(version, code, digest$1);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== 'number') throw new Error('String codecs are no longer supported');
        switch(version){
            case 0:
                if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$75176e30f12252bd$var$DAG_PB_CODE}) block encoding`);
                else return new $75176e30f12252bd$var$CID(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $75176e30f12252bd$var$encodeCID(version, code, digest.bytes);
                    return new $75176e30f12252bd$var$CID(version, code, digest, bytes);
                }
            default:
                throw new Error('Invalid version');
        }
    }
    static createV0(digest) {
        return $75176e30f12252bd$var$CID.create(0, $75176e30f12252bd$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $75176e30f12252bd$var$CID.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $75176e30f12252bd$var$CID.decodeFirst(bytes);
        if (remainder.length) throw new Error('Incorrect length');
        return cid;
    }
    static decodeFirst(bytes$1) {
        const specs = $75176e30f12252bd$var$CID.inspectBytes(bytes$1);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = $6DEzE.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error('Incorrect length');
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest$1 = new $kRxmT.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $75176e30f12252bd$var$CID.createV0(digest$1) : $75176e30f12252bd$var$CID.createV1(specs.codec, digest$1);
        return [
            cid,
            bytes$1.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $4mKzA.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $75176e30f12252bd$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $75176e30f12252bd$var$parseCIDtoBytes(source, base);
        const cid = $75176e30f12252bd$var$CID.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $75176e30f12252bd$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case 'Q':
            {
                const decoder = base || $g48Q7.base58btc;
                return [
                    $g48Q7.base58btc.prefix,
                    decoder.decode(`${$g48Q7.base58btc.prefix}${source}`)
                ];
            }
        case $g48Q7.base58btc.prefix:
            {
                const decoder = base || $g48Q7.base58btc;
                return [
                    $g48Q7.base58btc.prefix,
                    decoder.decode(source)
                ];
            }
        case $9mHUH.base32.prefix:
            {
                const decoder = base || $9mHUH.base32;
                return [
                    $9mHUH.base32.prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error('To parse non base32 or base58btc encoded CID multibase decoder must be provided');
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $75176e30f12252bd$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== $g48Q7.base58btc.prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$DAG_PB_CODE = 112;
const $75176e30f12252bd$var$SHA_256_CODE = 18;
const $75176e30f12252bd$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $4mKzA.encodingLength(version);
    const hashOffset = codeOffset + $4mKzA.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $4mKzA.encodeTo(version, bytes, 0);
    $4mKzA.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $75176e30f12252bd$var$cidSymbol = Symbol.for('@ipld/js-cid/CID');
const $75176e30f12252bd$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $75176e30f12252bd$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $75176e30f12252bd$var$version = '0.0.0-dev';
const $75176e30f12252bd$var$deprecate = (range, message)=>{
    if (range.test($75176e30f12252bd$var$version)) console.warn(message);
    else throw new Error(message);
};
const $75176e30f12252bd$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;
module.exports.CID = $75176e30f12252bd$var$CID;

});
parcelRegister("4mKzA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $lsRo7 = parcelRequire("lsRo7");
const $32dd57f0aae68c66$var$decode = (data, offset = 0)=>{
    const code = $lsRo7.decode(data, offset);
    return [
        code,
        $lsRo7.decode.bytes
    ];
};
const $32dd57f0aae68c66$var$encodeTo = (int, target, offset = 0)=>{
    $lsRo7.encode(int, target, offset);
    return target;
};
const $32dd57f0aae68c66$var$encodingLength = (int)=>{
    return $lsRo7.encodingLength(int);
};
module.exports.decode = $32dd57f0aae68c66$var$decode;
module.exports.encodeTo = $32dd57f0aae68c66$var$encodeTo;
module.exports.encodingLength = $32dd57f0aae68c66$var$encodingLength;

});
parcelRegister("lsRo7", function(module, exports) {
'use strict';
var $fa05a038af787ba8$var$encode_1 = $fa05a038af787ba8$var$encode;
var $fa05a038af787ba8$var$MSB = 128, $fa05a038af787ba8$var$REST = 127, $fa05a038af787ba8$var$MSBALL = ~$fa05a038af787ba8$var$REST, $fa05a038af787ba8$var$INT = Math.pow(2, 31);
function $fa05a038af787ba8$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $fa05a038af787ba8$var$INT){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num /= 128;
    }
    while(num & $fa05a038af787ba8$var$MSBALL){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $fa05a038af787ba8$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $fa05a038af787ba8$var$decode = $fa05a038af787ba8$var$read;
var $fa05a038af787ba8$var$MSB$1 = 128, $fa05a038af787ba8$var$REST$1 = 127;
function $fa05a038af787ba8$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $fa05a038af787ba8$var$read.bytes = 0;
            throw new RangeError('Could not decode varint');
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $fa05a038af787ba8$var$REST$1) << shift : (b & $fa05a038af787ba8$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $fa05a038af787ba8$var$MSB$1);
    $fa05a038af787ba8$var$read.bytes = counter - offset;
    return res;
}
var $fa05a038af787ba8$var$N1 = Math.pow(2, 7);
var $fa05a038af787ba8$var$N2 = Math.pow(2, 14);
var $fa05a038af787ba8$var$N3 = Math.pow(2, 21);
var $fa05a038af787ba8$var$N4 = Math.pow(2, 28);
var $fa05a038af787ba8$var$N5 = Math.pow(2, 35);
var $fa05a038af787ba8$var$N6 = Math.pow(2, 42);
var $fa05a038af787ba8$var$N7 = Math.pow(2, 49);
var $fa05a038af787ba8$var$N8 = Math.pow(2, 56);
var $fa05a038af787ba8$var$N9 = Math.pow(2, 63);
var $fa05a038af787ba8$var$length = function(value) {
    return value < $fa05a038af787ba8$var$N1 ? 1 : value < $fa05a038af787ba8$var$N2 ? 2 : value < $fa05a038af787ba8$var$N3 ? 3 : value < $fa05a038af787ba8$var$N4 ? 4 : value < $fa05a038af787ba8$var$N5 ? 5 : value < $fa05a038af787ba8$var$N6 ? 6 : value < $fa05a038af787ba8$var$N7 ? 7 : value < $fa05a038af787ba8$var$N8 ? 8 : value < $fa05a038af787ba8$var$N9 ? 9 : 10;
};
var $fa05a038af787ba8$var$varint = {
    encode: $fa05a038af787ba8$var$encode_1,
    decode: $fa05a038af787ba8$var$decode,
    encodingLength: $fa05a038af787ba8$var$length
};
var $fa05a038af787ba8$var$_brrp_varint = $fa05a038af787ba8$var$varint;
var $fa05a038af787ba8$var$varint$1 = $fa05a038af787ba8$var$_brrp_varint;
module.exports = $fa05a038af787ba8$var$varint$1;

});


parcelRegister("kRxmT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $6DEzE = parcelRequire("6DEzE");

var $4mKzA = parcelRequire("4mKzA");
const $f302a42295b946b3$var$create = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $4mKzA.encodingLength(code);
    const digestOffset = sizeOffset + $4mKzA.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $4mKzA.encodeTo(code, bytes, 0);
    $4mKzA.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes);
};
const $f302a42295b946b3$var$decode = (multihash)=>{
    const bytes$1 = $6DEzE.coerce(multihash);
    const [code, sizeOffset] = $4mKzA.decode(bytes$1);
    const [size, digestOffset] = $4mKzA.decode(bytes$1.subarray(sizeOffset));
    const digest = bytes$1.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error('Incorrect length');
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes$1);
};
const $f302a42295b946b3$var$equals = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && $6DEzE.equals(a.bytes, b.bytes);
};
class $f302a42295b946b3$var$Digest {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}
module.exports.Digest = $f302a42295b946b3$var$Digest;
module.exports.create = $f302a42295b946b3$var$create;
module.exports.decode = $f302a42295b946b3$var$decode;
module.exports.equals = $f302a42295b946b3$var$equals;

});
parcelRegister("6DEzE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
const $4d55dbc11a5f1aec$var$empty = new Uint8Array(0);
const $4d55dbc11a5f1aec$var$toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, '0'), '');
const $4d55dbc11a5f1aec$var$fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $4d55dbc11a5f1aec$var$empty;
};
const $4d55dbc11a5f1aec$var$equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $4d55dbc11a5f1aec$var$coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === 'Uint8Array') return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error('Unknown type, must be binary type');
};
const $4d55dbc11a5f1aec$var$isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $4d55dbc11a5f1aec$var$fromString = (str)=>new TextEncoder().encode(str);
const $4d55dbc11a5f1aec$var$toString = (b)=>new TextDecoder().decode(b);
module.exports.coerce = $4d55dbc11a5f1aec$var$coerce;
module.exports.empty = $4d55dbc11a5f1aec$var$empty;
module.exports.equals = $4d55dbc11a5f1aec$var$equals;
module.exports.fromHex = $4d55dbc11a5f1aec$var$fromHex;
module.exports.fromString = $4d55dbc11a5f1aec$var$fromString;
module.exports.isBinary = $4d55dbc11a5f1aec$var$isBinary;
module.exports.toHex = $4d55dbc11a5f1aec$var$toHex;
module.exports.toString = $4d55dbc11a5f1aec$var$toString;

});


parcelRegister("g48Q7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $bb23e06a31e86f7c$var$base58btc = $j5XlC.baseX({
    name: 'base58btc',
    prefix: 'z',
    alphabet: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
});
const $bb23e06a31e86f7c$var$base58flickr = $j5XlC.baseX({
    name: 'base58flickr',
    prefix: 'Z',
    alphabet: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'
});
module.exports.base58btc = $bb23e06a31e86f7c$var$base58btc;
module.exports.base58flickr = $bb23e06a31e86f7c$var$base58flickr;

});
parcelRegister("j5XlC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $hjHF0 = parcelRequire("hjHF0");

var $6DEzE = parcelRequire("6DEzE");
class $de6c852f920490b4$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error('Unknown type, must be binary type');
    }
}
class $de6c852f920490b4$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error('Invalid prefix character');
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === 'string') {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error('Can only multibase decode strings');
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
}
class $de6c852f920490b4$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $de6c852f920490b4$var$or = (left, right)=>new $de6c852f920490b4$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $de6c852f920490b4$var$Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $de6c852f920490b4$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $de6c852f920490b4$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $de6c852f920490b4$var$from = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $de6c852f920490b4$var$Codec(name, prefix, encode, decode);
const $de6c852f920490b4$var$baseX = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = $hjHF0(alphabet, name);
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>$6DEzE.coerce(decode(text))
    });
};
const $de6c852f920490b4$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === '=')--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError('Unexpected end of data');
    return out;
};
const $de6c852f920490b4$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === '=';
    const mask = (1 << bitsPerChar) - 1;
    let out = '';
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += '=';
    return out;
};
const $de6c852f920490b4$var$rfc4648 = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode (input) {
            return $de6c852f920490b4$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $de6c852f920490b4$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};
module.exports.Codec = $de6c852f920490b4$var$Codec;
module.exports.baseX = $de6c852f920490b4$var$baseX;
module.exports.from = $de6c852f920490b4$var$from;
module.exports.or = $de6c852f920490b4$var$or;
module.exports.rfc4648 = $de6c852f920490b4$var$rfc4648;

});
parcelRegister("hjHF0", function(module, exports) {
'use strict';
function $0340df4a7a7e39d8$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === ' ') return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        if (source[psz] === ' ') return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $0340df4a7a7e39d8$var$src = $0340df4a7a7e39d8$var$base;
var $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX = $0340df4a7a7e39d8$var$src;
module.exports = $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX;

});



parcelRegister("9mHUH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $6d183b7418ac11d8$var$base32 = $j5XlC.rfc4648({
    prefix: 'b',
    name: 'base32',
    alphabet: 'abcdefghijklmnopqrstuvwxyz234567',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32upper = $j5XlC.rfc4648({
    prefix: 'B',
    name: 'base32upper',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32pad = $j5XlC.rfc4648({
    prefix: 'c',
    name: 'base32pad',
    alphabet: 'abcdefghijklmnopqrstuvwxyz234567=',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32padupper = $j5XlC.rfc4648({
    prefix: 'C',
    name: 'base32padupper',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hex = $j5XlC.rfc4648({
    prefix: 'v',
    name: 'base32hex',
    alphabet: '0123456789abcdefghijklmnopqrstuv',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexupper = $j5XlC.rfc4648({
    prefix: 'V',
    name: 'base32hexupper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpad = $j5XlC.rfc4648({
    prefix: 't',
    name: 'base32hexpad',
    alphabet: '0123456789abcdefghijklmnopqrstuv=',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpadupper = $j5XlC.rfc4648({
    prefix: 'T',
    name: 'base32hexpadupper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV=',
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32z = $j5XlC.rfc4648({
    prefix: 'h',
    name: 'base32z',
    alphabet: 'ybndrfg8ejkmcpqxot1uwisza345h769',
    bitsPerChar: 5
});
module.exports.base32 = $6d183b7418ac11d8$var$base32;
module.exports.base32hex = $6d183b7418ac11d8$var$base32hex;
module.exports.base32hexpad = $6d183b7418ac11d8$var$base32hexpad;
module.exports.base32hexpadupper = $6d183b7418ac11d8$var$base32hexpadupper;
module.exports.base32hexupper = $6d183b7418ac11d8$var$base32hexupper;
module.exports.base32pad = $6d183b7418ac11d8$var$base32pad;
module.exports.base32padupper = $6d183b7418ac11d8$var$base32padupper;
module.exports.base32upper = $6d183b7418ac11d8$var$base32upper;
module.exports.base32z = $6d183b7418ac11d8$var$base32z;

});


parcelRegister("bc6Ix", function(module, exports) {
"use strict";
var $8266069c76fd0e56$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8266069c76fd0e56$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8266069c76fd0e56$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8266069c76fd0e56$var$__createBinding(result, mod, k);
    }
    $8266069c76fd0e56$var$__setModuleDefault(result, mod);
    return result;
};
var $8266069c76fd0e56$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8266069c76fd0e56$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.util = module.exports.check = void 0;

module.exports.check = $8266069c76fd0e56$var$__importStar((parcelRequire("8iDO3")));

module.exports.util = $8266069c76fd0e56$var$__importStar((parcelRequire("0a4W9")));

$8266069c76fd0e56$var$__exportStar((parcelRequire("3X8VQ")), module.exports);

$8266069c76fd0e56$var$__exportStar((parcelRequire("e4FU3")), module.exports);

$8266069c76fd0e56$var$__exportStar((parcelRequire("0a4W9")), module.exports);

$8266069c76fd0e56$var$__exportStar((parcelRequire("bO8lx")), module.exports);

$8266069c76fd0e56$var$__exportStar((parcelRequire("fBziq")), module.exports);

$8266069c76fd0e56$var$__exportStar((parcelRequire("csbhN")), module.exports);

$8266069c76fd0e56$var$__exportStar((parcelRequire("gXQAS")), module.exports);

$8266069c76fd0e56$var$__exportStar((parcelRequire("e27cm")), module.exports);

$8266069c76fd0e56$var$__exportStar((parcelRequire("JHLP0")), module.exports);

$8266069c76fd0e56$var$__exportStar((parcelRequire("47FX6")), module.exports);

});
parcelRegister("8iDO3", function(module, exports) {
"use strict";
// Explicitly not using "zod" types here to avoid mismatching types due to
// version differences.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isObject = module.exports.assure = module.exports.create = module.exports.is = void 0;
const $60aee1e47f9870da$var$is = (obj, def)=>{
    return def.safeParse(obj).success;
};
module.exports.is = $60aee1e47f9870da$var$is;
const $60aee1e47f9870da$var$create = (def)=>(v)=>def.safeParse(v).success;
module.exports.create = $60aee1e47f9870da$var$create;
const $60aee1e47f9870da$var$assure = (def, obj)=>{
    return def.parse(obj);
};
module.exports.assure = $60aee1e47f9870da$var$assure;
const $60aee1e47f9870da$var$isObject = (obj)=>{
    return typeof obj === 'object' && obj !== null;
};
module.exports.isObject = $60aee1e47f9870da$var$isObject;

});

parcelRegister("0a4W9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseIntWithFallback = module.exports.dedupeStrs = module.exports.range = module.exports.chunkArray = module.exports.errHasMsg = module.exports.isErrnoException = module.exports.asyncFilter = module.exports.s32decode = module.exports.s32encode = module.exports.streamToBuffer = module.exports.flattenUint8Arrays = module.exports.bailableWait = module.exports.wait = module.exports.jitter = module.exports.noUndefinedVals = void 0;
module.exports.omit = $0007d19b88099438$var$omit;
const $0007d19b88099438$var$noUndefinedVals = (obj)=>{
    Object.keys(obj).forEach((k)=>{
        if (obj[k] === undefined) delete obj[k];
    });
    return obj;
};
module.exports.noUndefinedVals = $0007d19b88099438$var$noUndefinedVals;
function $0007d19b88099438$var$omit(src, rejectedKeys) {
    // Hot path
    if (!src) return src;
    const dst = {};
    const srcKeys = Object.keys(src);
    for(let i = 0; i < srcKeys.length; i++){
        const key = srcKeys[i];
        if (!rejectedKeys.includes(key)) dst[key] = src[key];
    }
    return dst;
}
const $0007d19b88099438$var$jitter = (maxMs)=>{
    return Math.round((Math.random() - 0.5) * maxMs * 2);
};
module.exports.jitter = $0007d19b88099438$var$jitter;
const $0007d19b88099438$var$wait = (ms)=>{
    return new Promise((res)=>setTimeout(res, ms));
};
module.exports.wait = $0007d19b88099438$var$wait;
const $0007d19b88099438$var$bailableWait = (ms)=>{
    let bail;
    const waitPromise = new Promise((res)=>{
        const timeout = setTimeout(res, ms);
        bail = ()=>{
            clearTimeout(timeout);
            res();
        };
    });
    return {
        bail: bail,
        wait: ()=>waitPromise
    };
};
module.exports.bailableWait = $0007d19b88099438$var$bailableWait;
const $0007d19b88099438$var$flattenUint8Arrays = (arrs)=>{
    const length = arrs.reduce((acc, cur)=>{
        return acc + cur.length;
    }, 0);
    const flattened = new Uint8Array(length);
    let offset = 0;
    arrs.forEach((arr)=>{
        flattened.set(arr, offset);
        offset += arr.length;
    });
    return flattened;
};
module.exports.flattenUint8Arrays = $0007d19b88099438$var$flattenUint8Arrays;
const $0007d19b88099438$var$streamToBuffer = async (stream)=>{
    const arrays = [];
    for await (const chunk of stream)arrays.push(chunk);
    return (0, module.exports.flattenUint8Arrays)(arrays);
};
module.exports.streamToBuffer = $0007d19b88099438$var$streamToBuffer;
const $0007d19b88099438$var$S32_CHAR = '234567abcdefghijklmnopqrstuvwxyz';
const $0007d19b88099438$var$s32encode = (i)=>{
    let s = '';
    while(i){
        const c = i % 32;
        i = Math.floor(i / 32);
        s = $0007d19b88099438$var$S32_CHAR.charAt(c) + s;
    }
    return s;
};
module.exports.s32encode = $0007d19b88099438$var$s32encode;
const $0007d19b88099438$var$s32decode = (s)=>{
    let i = 0;
    for (const c of s)i = i * 32 + $0007d19b88099438$var$S32_CHAR.indexOf(c);
    return i;
};
module.exports.s32decode = $0007d19b88099438$var$s32decode;
const $0007d19b88099438$var$asyncFilter = async (arr, fn)=>{
    const results = await Promise.all(arr.map((t)=>fn(t)));
    return arr.filter((_, i)=>results[i]);
};
module.exports.asyncFilter = $0007d19b88099438$var$asyncFilter;
const $0007d19b88099438$var$isErrnoException = (err)=>{
    return !!err && err['code'];
};
module.exports.isErrnoException = $0007d19b88099438$var$isErrnoException;
const $0007d19b88099438$var$errHasMsg = (err, msg)=>{
    return !!err && typeof err === 'object' && err['message'] === msg;
};
module.exports.errHasMsg = $0007d19b88099438$var$errHasMsg;
const $0007d19b88099438$var$chunkArray = (arr, chunkSize)=>{
    return arr.reduce((acc, cur, i)=>{
        const chunkI = Math.floor(i / chunkSize);
        if (!acc[chunkI]) acc[chunkI] = [];
        acc[chunkI].push(cur);
        return acc;
    }, []);
};
module.exports.chunkArray = $0007d19b88099438$var$chunkArray;
const $0007d19b88099438$var$range = (num)=>{
    const nums = [];
    for(let i = 0; i < num; i++)nums.push(i);
    return nums;
};
module.exports.range = $0007d19b88099438$var$range;
const $0007d19b88099438$var$dedupeStrs = (strs)=>{
    return [
        ...new Set(strs)
    ];
};
module.exports.dedupeStrs = $0007d19b88099438$var$dedupeStrs;
const $0007d19b88099438$var$parseIntWithFallback = (value, fallback)=>{
    const parsed = parseInt(value || '', 10);
    return isNaN(parsed) ? fallback : parsed;
};
module.exports.parseIntWithFallback = $0007d19b88099438$var$parseIntWithFallback;

});

parcelRegister("3X8VQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapDefined = void 0;
module.exports.keyBy = $2e0dcf79b829af61$var$keyBy;
function $2e0dcf79b829af61$var$keyBy(arr, key) {
    return arr.reduce((acc, cur)=>{
        acc.set(cur[key], cur);
        return acc;
    }, new Map());
}
const $2e0dcf79b829af61$var$mapDefined = (arr, fn)=>{
    const output = [];
    for (const item of arr){
        const val = fn(item);
        if (val !== undefined) output.push(val);
    }
    return output;
};
module.exports.mapDefined = $2e0dcf79b829af61$var$mapDefined;

});

parcelRegister("e4FU3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AsyncBufferFullError = module.exports.AsyncBuffer = module.exports.allComplete = module.exports.createDeferrables = module.exports.createDeferrable = module.exports.readFromGenerator = void 0;
module.exports.allFulfilled = $a3f1f17d2f781a3a$var$allFulfilled;
module.exports.handleAllSettledErrors = $a3f1f17d2f781a3a$var$handleAllSettledErrors;
module.exports.isRejectedResult = $a3f1f17d2f781a3a$var$isRejectedResult;
module.exports.isFulfilledResult = $a3f1f17d2f781a3a$var$isFulfilledResult;

var $0a4W9 = parcelRequire("0a4W9");
// reads values from a generator into a list
// breaks when isDone signals `true` AND `waitFor` completes OR when a max length is reached
// NOTE: does not signal generator to close. it *will* continue to produce values
const $a3f1f17d2f781a3a$var$readFromGenerator = async (gen, isDone, waitFor = Promise.resolve(), maxLength = Number.MAX_SAFE_INTEGER)=>{
    const evts = [];
    let bail;
    let hasBroke = false;
    const awaitDone = async ()=>{
        if (await isDone(evts.at(-1))) return true;
        const bailable = (0, $0a4W9.bailableWait)(20);
        await bailable.wait();
        bail = bailable.bail;
        if (hasBroke) return false;
        return await awaitDone();
    };
    const breakOn = new Promise((resolve)=>{
        waitFor.then(()=>{
            awaitDone().then(()=>resolve());
        });
    });
    try {
        while(evts.length < maxLength){
            const maybeEvt = await Promise.race([
                gen.next(),
                breakOn
            ]);
            if (!maybeEvt) break;
            const evt = maybeEvt;
            if (evt.done) break;
            evts.push(evt.value);
        }
    } finally{
        hasBroke = true;
        bail && bail();
    }
    return evts;
};
module.exports.readFromGenerator = $a3f1f17d2f781a3a$var$readFromGenerator;
const $a3f1f17d2f781a3a$var$createDeferrable = ()=>{
    let resolve;
    const promise = new Promise((res)=>{
        resolve = ()=>res();
    });
    return {
        resolve: resolve,
        complete: promise
    };
};
module.exports.createDeferrable = $a3f1f17d2f781a3a$var$createDeferrable;
const $a3f1f17d2f781a3a$var$createDeferrables = (count)=>{
    const list = [];
    for(let i = 0; i < count; i++)list.push((0, module.exports.createDeferrable)());
    return list;
};
module.exports.createDeferrables = $a3f1f17d2f781a3a$var$createDeferrables;
const $a3f1f17d2f781a3a$var$allComplete = async (deferrables)=>{
    await Promise.all(deferrables.map((d)=>d.complete));
};
module.exports.allComplete = $a3f1f17d2f781a3a$var$allComplete;
class $a3f1f17d2f781a3a$var$AsyncBuffer {
    constructor(maxSize){
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: maxSize
        });
        Object.defineProperty(this, "buffer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "promise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resolve", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "closed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "toThrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Initializing to satisfy types/build, immediately reset by resetPromise()
        this.promise = Promise.resolve();
        this.resolve = ()=>null;
        this.resetPromise();
    }
    get curr() {
        return this.buffer;
    }
    get size() {
        return this.buffer.length;
    }
    get isClosed() {
        return this.closed;
    }
    resetPromise() {
        this.promise = new Promise((r)=>this.resolve = r);
    }
    push(item) {
        this.buffer.push(item);
        this.resolve();
    }
    pushMany(items) {
        items.forEach((i)=>this.buffer.push(i));
        this.resolve();
    }
    async *events() {
        while(true){
            if (this.closed && this.buffer.length === 0) {
                if (this.toThrow) throw this.toThrow;
                else return;
            }
            await this.promise;
            if (this.toThrow) throw this.toThrow;
            if (this.maxSize && this.size > this.maxSize) throw new $a3f1f17d2f781a3a$var$AsyncBufferFullError(this.maxSize);
            const [first, ...rest] = this.buffer;
            if (first) {
                this.buffer = rest;
                yield first;
            } else this.resetPromise();
        }
    }
    throw(err) {
        this.toThrow = err;
        this.closed = true;
        this.resolve();
    }
    close() {
        this.closed = true;
        this.resolve();
    }
}
module.exports.AsyncBuffer = $a3f1f17d2f781a3a$var$AsyncBuffer;
class $a3f1f17d2f781a3a$var$AsyncBufferFullError extends Error {
    constructor(maxSize){
        super(`ReachedMaxBufferSize: ${maxSize}`);
    }
}
module.exports.AsyncBufferFullError = $a3f1f17d2f781a3a$var$AsyncBufferFullError;
function $a3f1f17d2f781a3a$var$allFulfilled(promises) {
    return Promise.allSettled(promises).then($a3f1f17d2f781a3a$var$handleAllSettledErrors);
}
function $a3f1f17d2f781a3a$var$handleAllSettledErrors(results) {
    const errors = results.filter($a3f1f17d2f781a3a$var$isRejectedResult).map($a3f1f17d2f781a3a$var$extractReason);
    if (errors.length === 0) // No need to filter here, it is safe to assume that all promises are fulfilled
    return results.map($a3f1f17d2f781a3a$var$extractValue);
    if (errors.length === 1) throw errors[0];
    throw new AggregateError(errors, `Multiple errors: ${errors.map($a3f1f17d2f781a3a$var$stringifyReason).join('\n')}`);
}
function $a3f1f17d2f781a3a$var$isRejectedResult(result) {
    return result.status === 'rejected';
}
function $a3f1f17d2f781a3a$var$extractReason(result) {
    return result.reason;
}
function $a3f1f17d2f781a3a$var$isFulfilledResult(result) {
    return result.status === 'fulfilled';
}
function $a3f1f17d2f781a3a$var$extractValue(result) {
    return result.value;
}
function $a3f1f17d2f781a3a$var$stringifyReason(reason) {
    if (reason instanceof Error) return reason.message;
    return String(reason);
}

});

parcelRegister("bO8lx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TID = void 0;

var $0a4W9 = parcelRequire("0a4W9");
const $898ad6a8404a87b9$var$TID_LEN = 13;
let $898ad6a8404a87b9$var$lastTimestamp = 0;
let $898ad6a8404a87b9$var$timestampCount = 0;
let $898ad6a8404a87b9$var$clockid = null;
function $898ad6a8404a87b9$var$dedash(str) {
    return str.replaceAll('-', '');
}
class $898ad6a8404a87b9$var$TID {
    constructor(str){
        Object.defineProperty(this, "str", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const noDashes = $898ad6a8404a87b9$var$dedash(str);
        if (noDashes.length !== $898ad6a8404a87b9$var$TID_LEN) throw new Error(`Poorly formatted TID: ${noDashes.length} length`);
        this.str = noDashes;
    }
    static next(prev) {
        // javascript does not have microsecond precision
        // instead, we append a counter to the timestamp to indicate if multiple timestamps were created within the same millisecond
        // take max of current time & last timestamp to prevent tids moving backwards if system clock drifts backwards
        const time = Math.max(Date.now(), $898ad6a8404a87b9$var$lastTimestamp);
        if (time === $898ad6a8404a87b9$var$lastTimestamp) $898ad6a8404a87b9$var$timestampCount++;
        $898ad6a8404a87b9$var$lastTimestamp = time;
        const timestamp = time * 1000 + $898ad6a8404a87b9$var$timestampCount;
        // the bottom 32 clock ids can be randomized & are not guaranteed to be collision resistant
        // we use the same clockid for all tids coming from this machine
        if ($898ad6a8404a87b9$var$clockid === null) $898ad6a8404a87b9$var$clockid = Math.floor(Math.random() * 32);
        const tid = $898ad6a8404a87b9$var$TID.fromTime(timestamp, $898ad6a8404a87b9$var$clockid);
        if (!prev || tid.newerThan(prev)) return tid;
        return $898ad6a8404a87b9$var$TID.fromTime(prev.timestamp() + 1, $898ad6a8404a87b9$var$clockid);
    }
    static nextStr(prev) {
        return $898ad6a8404a87b9$var$TID.next(prev ? new $898ad6a8404a87b9$var$TID(prev) : undefined).toString();
    }
    static fromTime(timestamp, clockid) {
        // base32 encode with encoding variant sort (s32)
        const str = `${(0, $0a4W9.s32encode)(timestamp)}${(0, $0a4W9.s32encode)(clockid).padStart(2, '2')}`;
        return new $898ad6a8404a87b9$var$TID(str);
    }
    static fromStr(str) {
        return new $898ad6a8404a87b9$var$TID(str);
    }
    static oldestFirst(a, b) {
        return a.compareTo(b);
    }
    static newestFirst(a, b) {
        return b.compareTo(a);
    }
    static is(str) {
        return $898ad6a8404a87b9$var$dedash(str).length === $898ad6a8404a87b9$var$TID_LEN;
    }
    timestamp() {
        return (0, $0a4W9.s32decode)(this.str.slice(0, 11));
    }
    clockid() {
        return (0, $0a4W9.s32decode)(this.str.slice(11, 13));
    }
    formatted() {
        const str = this.toString();
        return `${str.slice(0, 4)}-${str.slice(4, 7)}-${str.slice(7, 11)}-${str.slice(11, 13)}`;
    }
    toString() {
        return this.str;
    }
    // newer > older
    compareTo(other) {
        if (this.str > other.str) return 1;
        if (this.str < other.str) return -1;
        return 0;
    }
    equals(other) {
        return this.str === other.str;
    }
    newerThan(other) {
        return this.compareTo(other) > 0;
    }
    olderThan(other) {
        return this.compareTo(other) < 0;
    }
}
module.exports.TID = $898ad6a8404a87b9$var$TID;

});

parcelRegister("fBziq", function(module, exports) {
"use strict";
var $b5c5b0c779b44391$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b5c5b0c779b44391$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b5c5b0c779b44391$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b5c5b0c779b44391$var$__createBinding(result, mod, k);
    }
    $b5c5b0c779b44391$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ipldEquals = module.exports.ipldToJson = module.exports.jsonToIpld = void 0;

var $a3h4N = parcelRequire("a3h4N");

const $b5c5b0c779b44391$var$ui8 = $b5c5b0c779b44391$var$__importStar((parcelRequire("a2jTq")));
// @NOTE avoiding use of check.is() here only because it makes
// these implementations slow, and they often live in hot paths.
const $b5c5b0c779b44391$var$jsonToIpld = (val)=>{
    // walk arrays
    if (Array.isArray(val)) return val.map((item)=>(0, module.exports.jsonToIpld)(item));
    // objects
    if (val && typeof val === 'object') {
        // check for dag json values
        if (typeof val['$link'] === 'string' && Object.keys(val).length === 1) return $a3h4N.CID.parse(val['$link']);
        if (typeof val['$bytes'] === 'string' && Object.keys(val).length === 1) return $b5c5b0c779b44391$var$ui8.fromString(val['$bytes'], 'base64');
        // walk plain objects
        const toReturn = {};
        for (const key of Object.keys(val))toReturn[key] = (0, module.exports.jsonToIpld)(val[key]);
        return toReturn;
    }
    // pass through
    return val;
};
module.exports.jsonToIpld = $b5c5b0c779b44391$var$jsonToIpld;
const $b5c5b0c779b44391$var$ipldToJson = (val)=>{
    // walk arrays
    if (Array.isArray(val)) return val.map((item)=>(0, module.exports.ipldToJson)(item));
    // objects
    if (val && typeof val === 'object') {
        // convert bytes
        if (val instanceof Uint8Array) return {
            $bytes: $b5c5b0c779b44391$var$ui8.toString(val, 'base64')
        };
        // convert cids
        if ($a3h4N.CID.asCID(val)) return {
            $link: val.toString()
        };
        // walk plain objects
        const toReturn = {};
        for (const key of Object.keys(val))toReturn[key] = (0, module.exports.ipldToJson)(val[key]);
        return toReturn;
    }
    // pass through
    return val;
};
module.exports.ipldToJson = $b5c5b0c779b44391$var$ipldToJson;
const $b5c5b0c779b44391$var$ipldEquals = (a, b)=>{
    // walk arrays
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!(0, module.exports.ipldEquals)(a[i], b[i])) return false;
        }
        return true;
    }
    // objects
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        // check bytes
        if (a instanceof Uint8Array && b instanceof Uint8Array) return $b5c5b0c779b44391$var$ui8.equals(a, b);
        // check cids
        if ($a3h4N.CID.asCID(a) && $a3h4N.CID.asCID(b)) return $a3h4N.CID.asCID(a)?.equals($a3h4N.CID.asCID(b));
        // walk plain objects
        if (Object.keys(a).length !== Object.keys(b).length) return false;
        for (const key of Object.keys(a)){
            if (!(0, module.exports.ipldEquals)(a[key], b[key])) return false;
        }
        return true;
    }
    return a === b;
};
module.exports.ipldEquals = $b5c5b0c779b44391$var$ipldEquals;

});
parcelRegister("a2jTq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $4ZVv6 = parcelRequire("4ZVv6");

var $67QIB = parcelRequire("67QIB");

var $5DFrB = parcelRequire("5DFrB");

var $e9TA6 = parcelRequire("e9TA6");

var $gj7w6 = parcelRequire("gj7w6");

var $8pBj0 = parcelRequire("8pBj0");
module.exports.compare = $4ZVv6.compare;
module.exports.concat = $67QIB.concat;
module.exports.equals = $5DFrB.equals;
module.exports.fromString = $e9TA6.fromString;
module.exports.toString = $gj7w6.toString;
module.exports.xor = $8pBj0.xor;

});
parcelRegister("4ZVv6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $3a397656998e9fe7$var$compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
module.exports.compare = $3a397656998e9fe7$var$compare;

});

parcelRegister("67QIB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $475c4a512fd4a246$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = new Uint8Array(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}
module.exports.concat = $475c4a512fd4a246$var$concat;

});

parcelRegister("5DFrB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $41b0be3b2401ec7e$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.equals = $41b0be3b2401ec7e$var$equals;

});

parcelRegister("e9TA6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $7BbeY = parcelRequire("7BbeY");
function $a4ed053a1131469e$var$fromString(string, encoding = 'utf8') {
    const base = $7BbeY[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    return base.decoder.decode(`${base.prefix}${string}`);
}
module.exports.fromString = $a4ed053a1131469e$var$fromString;

});
parcelRegister("7BbeY", function(module, exports) {
'use strict';

var $fDRtp = parcelRequire("fDRtp");
function $5884b53a084a924d$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $5884b53a084a924d$var$string = $5884b53a084a924d$var$createCodec('utf8', 'u', (buf)=>{
    const decoder = new TextDecoder('utf8');
    return 'u' + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $5884b53a084a924d$var$ascii = $5884b53a084a924d$var$createCodec('ascii', 'a', (buf)=>{
    let string = 'a';
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $5884b53a084a924d$var$BASES = {
    utf8: $5884b53a084a924d$var$string,
    'utf-8': $5884b53a084a924d$var$string,
    hex: $fDRtp.bases.base16,
    latin1: $5884b53a084a924d$var$ascii,
    ascii: $5884b53a084a924d$var$ascii,
    binary: $5884b53a084a924d$var$ascii,
    ...$fDRtp.bases
};
module.exports = $5884b53a084a924d$var$BASES;

});
parcelRegister("fDRtp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $lwvkp = parcelRequire("lwvkp");

var $5RC5t = parcelRequire("5RC5t");

var $9T9EZ = parcelRequire("9T9EZ");

var $aGHoO = parcelRequire("aGHoO");

var $6IsCN = parcelRequire("6IsCN");

var $9mHUH = parcelRequire("9mHUH");

var $388Mf = parcelRequire("388Mf");

var $g48Q7 = parcelRequire("g48Q7");

var $j3YM6 = parcelRequire("j3YM6");

var $hkEkj = parcelRequire("hkEkj");

var $lFa2r = parcelRequire("lFa2r");

var $8iBGc = parcelRequire("8iBGc");

var $04T17 = parcelRequire("04T17");

var $847dK = parcelRequire("847dK");
parcelRequire("hHwg3");

var $a3h4N = parcelRequire("a3h4N");

var $g30mz = parcelRequire("g30mz");

var $kRxmT = parcelRequire("kRxmT");

var $4mKzA = parcelRequire("4mKzA");

var $6DEzE = parcelRequire("6DEzE");
const $b633fa38a7f8a649$var$bases = {
    ...$lwvkp,
    ...$5RC5t,
    ...$9T9EZ,
    ...$aGHoO,
    ...$6IsCN,
    ...$9mHUH,
    ...$388Mf,
    ...$g48Q7,
    ...$j3YM6,
    ...$hkEkj
};
const $b633fa38a7f8a649$var$hashes = {
    ...$lFa2r,
    ...$8iBGc
};
const $b633fa38a7f8a649$var$codecs = {
    raw: $04T17,
    json: $847dK
};
module.exports.CID = $a3h4N.CID;
module.exports.hasher = $g30mz;
module.exports.digest = $kRxmT;
module.exports.varint = $4mKzA;
module.exports.bytes = $6DEzE;
module.exports.bases = $b633fa38a7f8a649$var$bases;
module.exports.codecs = $b633fa38a7f8a649$var$codecs;
module.exports.hashes = $b633fa38a7f8a649$var$hashes;

});
parcelRegister("lwvkp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");

var $6DEzE = parcelRequire("6DEzE");
const $fab4e33fc8c0336e$var$identity = $j5XlC.from({
    prefix: '\0',
    name: 'identity',
    encode: (buf)=>$6DEzE.toString(buf),
    decode: (str)=>$6DEzE.fromString(str)
});
module.exports.identity = $fab4e33fc8c0336e$var$identity;

});

parcelRegister("5RC5t", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $444f725972ab843c$var$base2 = $j5XlC.rfc4648({
    prefix: '0',
    name: 'base2',
    alphabet: '01',
    bitsPerChar: 1
});
module.exports.base2 = $444f725972ab843c$var$base2;

});

parcelRegister("9T9EZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $7330be652d1faeae$var$base8 = $j5XlC.rfc4648({
    prefix: '7',
    name: 'base8',
    alphabet: '01234567',
    bitsPerChar: 3
});
module.exports.base8 = $7330be652d1faeae$var$base8;

});

parcelRegister("aGHoO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $7c7f7dd3c1547a66$var$base10 = $j5XlC.baseX({
    prefix: '9',
    name: 'base10',
    alphabet: '0123456789'
});
module.exports.base10 = $7c7f7dd3c1547a66$var$base10;

});

parcelRegister("6IsCN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $4e3d0e6f3707af45$var$base16 = $j5XlC.rfc4648({
    prefix: 'f',
    name: 'base16',
    alphabet: '0123456789abcdef',
    bitsPerChar: 4
});
const $4e3d0e6f3707af45$var$base16upper = $j5XlC.rfc4648({
    prefix: 'F',
    name: 'base16upper',
    alphabet: '0123456789ABCDEF',
    bitsPerChar: 4
});
module.exports.base16 = $4e3d0e6f3707af45$var$base16;
module.exports.base16upper = $4e3d0e6f3707af45$var$base16upper;

});

parcelRegister("388Mf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $2478ed668ff199ad$var$base36 = $j5XlC.baseX({
    prefix: 'k',
    name: 'base36',
    alphabet: '0123456789abcdefghijklmnopqrstuvwxyz'
});
const $2478ed668ff199ad$var$base36upper = $j5XlC.baseX({
    prefix: 'K',
    name: 'base36upper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
});
module.exports.base36 = $2478ed668ff199ad$var$base36;
module.exports.base36upper = $2478ed668ff199ad$var$base36upper;

});

parcelRegister("j3YM6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $de0d70bb34ca5e4e$var$base64 = $j5XlC.rfc4648({
    prefix: 'm',
    name: 'base64',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64pad = $j5XlC.rfc4648({
    prefix: 'M',
    name: 'base64pad',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64url = $j5XlC.rfc4648({
    prefix: 'u',
    name: 'base64url',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64urlpad = $j5XlC.rfc4648({
    prefix: 'U',
    name: 'base64urlpad',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=',
    bitsPerChar: 6
});
module.exports.base64 = $de0d70bb34ca5e4e$var$base64;
module.exports.base64pad = $de0d70bb34ca5e4e$var$base64pad;
module.exports.base64url = $de0d70bb34ca5e4e$var$base64url;
module.exports.base64urlpad = $de0d70bb34ca5e4e$var$base64urlpad;

});

parcelRegister("hkEkj", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $c9e395f0a3e1277d$var$alphabet = Array.from('\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42');
const $c9e395f0a3e1277d$var$alphabetBytesToChars = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $c9e395f0a3e1277d$var$alphabetCharsToBytes = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $c9e395f0a3e1277d$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $c9e395f0a3e1277d$var$alphabetBytesToChars[c];
        return p;
    }, '');
}
function $c9e395f0a3e1277d$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $c9e395f0a3e1277d$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $c9e395f0a3e1277d$var$base256emoji = $j5XlC.from({
    prefix: '\uD83D\uDE80',
    name: 'base256emoji',
    encode: $c9e395f0a3e1277d$var$encode,
    decode: $c9e395f0a3e1277d$var$decode
});
module.exports.base256emoji = $c9e395f0a3e1277d$var$base256emoji;

});

parcelRegister("lFa2r", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $g30mz = parcelRequire("g30mz");
const $fc5536b924e664f3$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $fc5536b924e664f3$var$sha256 = $g30mz.from({
    name: 'sha2-256',
    code: 18,
    encode: $fc5536b924e664f3$var$sha('SHA-256')
});
const $fc5536b924e664f3$var$sha512 = $g30mz.from({
    name: 'sha2-512',
    code: 19,
    encode: $fc5536b924e664f3$var$sha('SHA-512')
});
module.exports.sha256 = $fc5536b924e664f3$var$sha256;
module.exports.sha512 = $fc5536b924e664f3$var$sha512;

});
parcelRegister("g30mz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $kRxmT = parcelRequire("kRxmT");
const $baed353b52eedd46$var$from = ({ name: name, code: code, encode: encode })=>new $baed353b52eedd46$var$Hasher(name, code, encode);
class $baed353b52eedd46$var$Hasher {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $kRxmT.create(this.code, result) : result.then((digest$1)=>$kRxmT.create(this.code, digest$1));
        } else throw Error('Unknown type, must be binary type');
    }
}
module.exports.Hasher = $baed353b52eedd46$var$Hasher;
module.exports.from = $baed353b52eedd46$var$from;

});


parcelRegister("8iBGc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $6DEzE = parcelRequire("6DEzE");

var $kRxmT = parcelRequire("kRxmT");
const $60ad3b9242aa2ade$var$code = 0;
const $60ad3b9242aa2ade$var$name = 'identity';
const $60ad3b9242aa2ade$var$encode = $6DEzE.coerce;
const $60ad3b9242aa2ade$var$digest = (input)=>$kRxmT.create($60ad3b9242aa2ade$var$code, $60ad3b9242aa2ade$var$encode(input));
const $60ad3b9242aa2ade$var$identity = {
    code: $60ad3b9242aa2ade$var$code,
    name: $60ad3b9242aa2ade$var$name,
    encode: $60ad3b9242aa2ade$var$encode,
    digest: $60ad3b9242aa2ade$var$digest
};
module.exports.identity = $60ad3b9242aa2ade$var$identity;

});

parcelRegister("04T17", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $6DEzE = parcelRequire("6DEzE");
const $00eb0d0ec1c470ae$var$name = 'raw';
const $00eb0d0ec1c470ae$var$code = 85;
const $00eb0d0ec1c470ae$var$encode = (node)=>$6DEzE.coerce(node);
const $00eb0d0ec1c470ae$var$decode = (data)=>$6DEzE.coerce(data);
module.exports.code = $00eb0d0ec1c470ae$var$code;
module.exports.decode = $00eb0d0ec1c470ae$var$decode;
module.exports.encode = $00eb0d0ec1c470ae$var$encode;
module.exports.name = $00eb0d0ec1c470ae$var$name;

});

parcelRegister("847dK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
const $5df44c55fa70023d$var$textEncoder = new TextEncoder();
const $5df44c55fa70023d$var$textDecoder = new TextDecoder();
const $5df44c55fa70023d$var$name = 'json';
const $5df44c55fa70023d$var$code = 512;
const $5df44c55fa70023d$var$encode = (node)=>$5df44c55fa70023d$var$textEncoder.encode(JSON.stringify(node));
const $5df44c55fa70023d$var$decode = (data)=>JSON.parse($5df44c55fa70023d$var$textDecoder.decode(data));
module.exports.code = $5df44c55fa70023d$var$code;
module.exports.decode = $5df44c55fa70023d$var$decode;
module.exports.encode = $5df44c55fa70023d$var$encode;
module.exports.name = $5df44c55fa70023d$var$name;

});

parcelRegister("hHwg3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $a3h4N = parcelRequire("a3h4N");

var $4mKzA = parcelRequire("4mKzA");

var $6DEzE = parcelRequire("6DEzE");

var $g30mz = parcelRequire("g30mz");

var $kRxmT = parcelRequire("kRxmT");
module.exports.CID = $a3h4N.CID;
module.exports.varint = $4mKzA;
module.exports.bytes = $6DEzE;
module.exports.hasher = $g30mz;
module.exports.digest = $kRxmT;

});




parcelRegister("gj7w6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $7BbeY = parcelRequire("7BbeY");
function $bdf44057d833ab1f$var$toString(array, encoding = 'utf8') {
    const base = $7BbeY[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    return base.encoder.encode(array).substring(1);
}
module.exports.toString = $bdf44057d833ab1f$var$toString;

});

parcelRegister("8pBj0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $61fd98a3451cab50$var$xor(a, b) {
    if (a.length !== b.length) throw new Error('Inputs should have the same length');
    const result = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return result;
}
module.exports.xor = $61fd98a3451cab50$var$xor;

});



parcelRegister("csbhN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.retry = $9110dabea01b7e77$var$retry;
module.exports.createRetryable = $9110dabea01b7e77$var$createRetryable;
module.exports.backoffMs = $9110dabea01b7e77$var$backoffMs;

var $0a4W9 = parcelRequire("0a4W9");
async function $9110dabea01b7e77$var$retry(fn, opts = {}) {
    const { maxRetries: maxRetries = 3, retryable: retryable = ()=>true, getWaitMs: getWaitMs = $9110dabea01b7e77$var$backoffMs } = opts;
    let retries = 0;
    let doneError;
    while(!doneError)try {
        return await fn();
    } catch (err) {
        const waitMs = getWaitMs(retries);
        const willRetry = retries < maxRetries && waitMs !== null && retryable(err);
        if (willRetry) {
            retries += 1;
            if (waitMs !== 0) await (0, $0a4W9.wait)(waitMs);
        } else doneError = err;
    }
    throw doneError;
}
function $9110dabea01b7e77$var$createRetryable(retryable) {
    return async (fn, opts)=>$9110dabea01b7e77$var$retry(fn, {
            ...opts,
            retryable: retryable
        });
}
// Waits exponential backoff with max and jitter: ~100, ~200, ~400, ~800, ~1000, ~1000, ...
function $9110dabea01b7e77$var$backoffMs(n, multiplier = 100, max = 1000) {
    const exponentialMs = Math.pow(2, n) * multiplier;
    const ms = Math.min(exponentialMs, max);
    return $9110dabea01b7e77$var$jitter(ms);
}
// Adds randomness +/-15% of value
function $9110dabea01b7e77$var$jitter(value) {
    const delta = value * 0.15;
    return value + $9110dabea01b7e77$var$randomRange(-delta, delta);
}
function $9110dabea01b7e77$var$randomRange(from, to) {
    const rand = Math.random() * (to - from);
    return rand + from;
}

});

parcelRegister("gXQAS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.def = module.exports.schema = void 0;

var $a3h4N = parcelRequire("a3h4N");

var $2zDt6 = parcelRequire("2zDt6");
const $c59af414d0efefcb$var$cidSchema = $2zDt6.z.any().refine((obj)=>$a3h4N.CID.asCID(obj) !== null, {
    message: 'Not a CID'
}).transform((obj)=>$a3h4N.CID.asCID(obj));
const $c59af414d0efefcb$var$carHeader = $2zDt6.z.object({
    version: $2zDt6.z.literal(1),
    roots: $2zDt6.z.array($c59af414d0efefcb$var$cidSchema)
});
module.exports.schema = {
    cid: $c59af414d0efefcb$var$cidSchema,
    carHeader: $c59af414d0efefcb$var$carHeader,
    bytes: $2zDt6.z.instanceof(Uint8Array),
    string: $2zDt6.z.string(),
    array: $2zDt6.z.array($2zDt6.z.unknown()),
    map: $2zDt6.z.record($2zDt6.z.string(), $2zDt6.z.unknown()),
    unknown: $2zDt6.z.unknown()
};
module.exports.def = {
    cid: {
        name: 'cid',
        schema: module.exports.schema.cid
    },
    carHeader: {
        name: 'CAR header',
        schema: module.exports.schema.carHeader
    },
    bytes: {
        name: 'bytes',
        schema: module.exports.schema.bytes
    },
    string: {
        name: 'string',
        schema: module.exports.schema.string
    },
    map: {
        name: 'map',
        schema: module.exports.schema.map
    },
    unknown: {
        name: 'unknown',
        schema: module.exports.schema.unknown
    }
};

});

parcelRegister("e27cm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addHoursToDate = module.exports.lessThanAgoMs = module.exports.DAY = module.exports.HOUR = module.exports.MINUTE = module.exports.SECOND = void 0;
module.exports.SECOND = 1000;
module.exports.MINUTE = module.exports.SECOND * 60;
module.exports.HOUR = module.exports.MINUTE * 60;
module.exports.DAY = module.exports.HOUR * 24;
const $a376d60d16d7a7c9$var$lessThanAgoMs = (time, range)=>{
    return Date.now() < time.getTime() + range;
};
module.exports.lessThanAgoMs = $a376d60d16d7a7c9$var$lessThanAgoMs;
const $a376d60d16d7a7c9$var$addHoursToDate = (hours, startingDate)=>{
    // When date is passed, clone before calling `setHours()` so that we are not mutating the original date
    const currentDate = startingDate ? new Date(startingDate) : new Date();
    currentDate.setHours(currentDate.getHours() + hours);
    return currentDate;
};
module.exports.addHoursToDate = $a376d60d16d7a7c9$var$addHoursToDate;

});

parcelRegister("JHLP0", function(module, exports) {
"use strict";
var $089627f4f87a461b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $089627f4f87a461b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $089627f4f87a461b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $089627f4f87a461b$var$__createBinding(result, mod, k);
    }
    $089627f4f87a461b$var$__setModuleDefault(result, mod);
    return result;
};
var $089627f4f87a461b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateLanguage = module.exports.parseLanguage = module.exports.b64UrlToUtf8 = module.exports.utf8ToB64Url = module.exports.graphemeLen = module.exports.utf8Len = void 0;

const $089627f4f87a461b$var$graphemer_1 = $089627f4f87a461b$var$__importDefault((parcelRequire("2SUxW")));

const $089627f4f87a461b$var$ui8 = $089627f4f87a461b$var$__importStar((parcelRequire("a2jTq")));
// counts the number of bytes in a utf8 string
const $089627f4f87a461b$var$utf8Len = (str)=>{
    return new TextEncoder().encode(str).byteLength;
};
module.exports.utf8Len = $089627f4f87a461b$var$utf8Len;
// counts the number of graphemes (user-displayed characters) in a string
const $089627f4f87a461b$var$graphemeLen = (str)=>{
    const splitter = new $089627f4f87a461b$var$graphemer_1.default();
    return splitter.countGraphemes(str);
};
module.exports.graphemeLen = $089627f4f87a461b$var$graphemeLen;
const $089627f4f87a461b$var$utf8ToB64Url = (utf8)=>{
    return $089627f4f87a461b$var$ui8.toString($089627f4f87a461b$var$ui8.fromString(utf8, 'utf8'), 'base64url');
};
module.exports.utf8ToB64Url = $089627f4f87a461b$var$utf8ToB64Url;
const $089627f4f87a461b$var$b64UrlToUtf8 = (b64)=>{
    return $089627f4f87a461b$var$ui8.toString($089627f4f87a461b$var$ui8.fromString(b64, 'base64url'), 'utf8');
};
module.exports.b64UrlToUtf8 = $089627f4f87a461b$var$b64UrlToUtf8;
const $089627f4f87a461b$var$parseLanguage = (langTag)=>{
    const parsed = langTag.match($089627f4f87a461b$var$bcp47Regexp);
    if (!parsed?.groups) return null;
    const parts = parsed.groups;
    return {
        grandfathered: parts.grandfathered,
        language: parts.language,
        extlang: parts.extlang,
        script: parts.script,
        region: parts.region,
        variant: parts.variant,
        extension: parts.extension,
        privateUse: parts.privateUseA || parts.privateUseB
    };
};
module.exports.parseLanguage = $089627f4f87a461b$var$parseLanguage;
const $089627f4f87a461b$var$validateLanguage = (langTag)=>{
    return $089627f4f87a461b$var$bcp47Regexp.test(langTag);
};
module.exports.validateLanguage = $089627f4f87a461b$var$validateLanguage;
// Validates well-formed BCP 47 syntax: https://www.rfc-editor.org/rfc/rfc5646.html#section-2.1
const $089627f4f87a461b$var$bcp47Regexp = /^((?<grandfathered>(en-GB-oed|i-ami|i-bnn|i-default|i-enochian|i-hak|i-klingon|i-lux|i-mingo|i-navajo|i-pwn|i-tao|i-tay|i-tsu|sgn-BE-FR|sgn-BE-NL|sgn-CH-DE)|(art-lojban|cel-gaulish|no-bok|no-nyn|zh-guoyu|zh-hakka|zh-min|zh-min-nan|zh-xiang))|((?<language>([A-Za-z]{2,3}(-(?<extlang>[A-Za-z]{3}(-[A-Za-z]{3}){0,2}))?)|[A-Za-z]{4}|[A-Za-z]{5,8})(-(?<script>[A-Za-z]{4}))?(-(?<region>[A-Za-z]{2}|[0-9]{3}))?(-(?<variant>[A-Za-z0-9]{5,8}|[0-9][A-Za-z0-9]{3}))*(-(?<extension>[0-9A-WY-Za-wy-z](-[A-Za-z0-9]{2,8})+))*(-(?<privateUseA>x(-[A-Za-z0-9]{1,8})+))?)|(?<privateUseB>x(-[A-Za-z0-9]{1,8})+))$/;

});
parcelRegister("2SUxW", function(module, exports) {
"use strict";
var $219c7ce1c214aa28$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $219c7ce1c214aa28$var$Graphemer_1 = $219c7ce1c214aa28$var$__importDefault((parcelRequire("7tiTz")));
module.exports.default = $219c7ce1c214aa28$var$Graphemer_1.default;

});
parcelRegister("7tiTz", function(module, exports) {
"use strict";
var $5709e612125632f3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXl8C = parcelRequire("lXl8C");

const $5709e612125632f3$var$GraphemerHelper_1 = $5709e612125632f3$var$__importDefault((parcelRequire("e5Vtd")));

const $5709e612125632f3$var$GraphemerIterator_1 = $5709e612125632f3$var$__importDefault((parcelRequire("KZpkG")));
class $5709e612125632f3$var$Graphemer {
    /**
     * Returns the next grapheme break in the string after the given index
     * @param string {string}
     * @param index {number}
     * @returns {number}
     */ static nextBreak(string, index) {
        if (index === undefined) index = 0;
        if (index < 0) return 0;
        if (index >= string.length - 1) return string.length;
        const prevCP = $5709e612125632f3$var$GraphemerHelper_1.default.codePointAt(string, index);
        const prev = $5709e612125632f3$var$Graphemer.getGraphemeBreakProperty(prevCP);
        const prevEmoji = $5709e612125632f3$var$Graphemer.getEmojiProperty(prevCP);
        const mid = [];
        const midEmoji = [];
        for(let i = index + 1; i < string.length; i++){
            // check for already processed low surrogates
            if ($5709e612125632f3$var$GraphemerHelper_1.default.isSurrogate(string, i - 1)) continue;
            const nextCP = $5709e612125632f3$var$GraphemerHelper_1.default.codePointAt(string, i);
            const next = $5709e612125632f3$var$Graphemer.getGraphemeBreakProperty(nextCP);
            const nextEmoji = $5709e612125632f3$var$Graphemer.getEmojiProperty(nextCP);
            if ($5709e612125632f3$var$GraphemerHelper_1.default.shouldBreak(prev, mid, next, prevEmoji, midEmoji, nextEmoji)) return i;
            mid.push(next);
            midEmoji.push(nextEmoji);
        }
        return string.length;
    }
    /**
     * Breaks the given string into an array of grapheme clusters
     * @param str {string}
     * @returns {string[]}
     */ splitGraphemes(str) {
        const res = [];
        let index = 0;
        let brk;
        while((brk = $5709e612125632f3$var$Graphemer.nextBreak(str, index)) < str.length){
            res.push(str.slice(index, brk));
            index = brk;
        }
        if (index < str.length) res.push(str.slice(index));
        return res;
    }
    /**
     * Returns an iterator of grapheme clusters in the given string
     * @param str {string}
     * @returns {GraphemerIterator}
     */ iterateGraphemes(str) {
        return new $5709e612125632f3$var$GraphemerIterator_1.default(str, $5709e612125632f3$var$Graphemer.nextBreak);
    }
    /**
     * Returns the number of grapheme clusters in the given string
     * @param str {string}
     * @returns {number}
     */ countGraphemes(str) {
        let count = 0;
        let index = 0;
        let brk;
        while((brk = $5709e612125632f3$var$Graphemer.nextBreak(str, index)) < str.length){
            index = brk;
            count++;
        }
        if (index < str.length) count++;
        return count;
    }
    /**
     * Given a Unicode code point, determines this symbol's grapheme break property
     * @param code {number} Unicode code point
     * @returns {number}
     */ static getGraphemeBreakProperty(code) {
        // Grapheme break property taken from:
        // https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakProperty.txt
        // and generated by
        // node ./scripts/generate-grapheme-break.js
        if (code < 0xbf09) {
            if (code < 0xac54) {
                if (code < 0x102d) {
                    if (code < 0xb02) {
                        if (code < 0x93b) {
                            if (code < 0x6df) {
                                if (code < 0x5bf) {
                                    if (code < 0x7f) {
                                        if (code < 0xb) {
                                            if (code < 0xa) {
                                                // Cc  [10] <control-0000>..<control-0009>
                                                if (0x0 <= code && code <= 0x9) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                            } else {
                                                // Cc       <control-000A>
                                                if (0xa === code) return $lXl8C.CLUSTER_BREAK.LF;
                                            }
                                        } else {
                                            if (code < 0xd) {
                                                // Cc   [2] <control-000B>..<control-000C>
                                                if (0xb <= code && code <= 0xc) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                            } else if (code < 0xe) {
                                                // Cc       <control-000D>
                                                if (0xd === code) return $lXl8C.CLUSTER_BREAK.CR;
                                            } else {
                                                // Cc  [18] <control-000E>..<control-001F>
                                                if (0xe <= code && code <= 0x1f) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                            }
                                        }
                                    } else if (code < 0x300) {
                                        if (code < 0xad) {
                                            // Cc  [33] <control-007F>..<control-009F>
                                            if (0x7f <= code && code <= 0x9f) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                        } else {
                                            // Cf       SOFT HYPHEN
                                            if (0xad === code) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                        }
                                    } else {
                                        if (code < 0x483) {
                                            // Mn [112] COMBINING GRAVE ACCENT..COMBINING LATIN SMALL LETTER X
                                            if (0x300 <= code && code <= 0x36f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x591) {
                                            // Mn   [5] COMBINING CYRILLIC TITLO..COMBINING CYRILLIC POKRYTIE
                                            // Me   [2] COMBINING CYRILLIC HUNDRED THOUSANDS SIGN..COMBINING CYRILLIC MILLIONS SIGN
                                            if (0x483 <= code && code <= 0x489) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn  [45] HEBREW ACCENT ETNAHTA..HEBREW POINT METEG
                                            if (0x591 <= code && code <= 0x5bd) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else {
                                    if (code < 0x610) {
                                        if (code < 0x5c4) {
                                            if (code < 0x5c1) {
                                                // Mn       HEBREW POINT RAFE
                                                if (0x5bf === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mn   [2] HEBREW POINT SHIN DOT..HEBREW POINT SIN DOT
                                                if (0x5c1 <= code && code <= 0x5c2) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else {
                                            if (code < 0x5c7) {
                                                // Mn   [2] HEBREW MARK UPPER DOT..HEBREW MARK LOWER DOT
                                                if (0x5c4 <= code && code <= 0x5c5) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else if (code < 0x600) {
                                                // Mn       HEBREW POINT QAMATS QATAN
                                                if (0x5c7 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Cf   [6] ARABIC NUMBER SIGN..ARABIC NUMBER MARK ABOVE
                                                if (0x600 <= code && code <= 0x605) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                            }
                                        }
                                    } else if (code < 0x670) {
                                        if (code < 0x61c) {
                                            // Mn  [11] ARABIC SIGN SALLALLAHOU ALAYHE WASSALLAM..ARABIC SMALL KASRA
                                            if (0x610 <= code && code <= 0x61a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x64b) {
                                            // Cf       ARABIC LETTER MARK
                                            if (0x61c === code) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                        } else {
                                            // Mn  [21] ARABIC FATHATAN..ARABIC WAVY HAMZA BELOW
                                            if (0x64b <= code && code <= 0x65f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x6d6) {
                                            // Mn       ARABIC LETTER SUPERSCRIPT ALEF
                                            if (0x670 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x6dd) {
                                            // Mn   [7] ARABIC SMALL HIGH LIGATURE SAD WITH LAM WITH ALEF MAKSURA..ARABIC SMALL HIGH SEEN
                                            if (0x6d6 <= code && code <= 0x6dc) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Cf       ARABIC END OF AYAH
                                            if (0x6dd === code) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                        }
                                    }
                                }
                            } else {
                                if (code < 0x81b) {
                                    if (code < 0x730) {
                                        if (code < 0x6ea) {
                                            if (code < 0x6e7) {
                                                // Mn   [6] ARABIC SMALL HIGH ROUNDED ZERO..ARABIC SMALL HIGH MADDA
                                                if (0x6df <= code && code <= 0x6e4) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mn   [2] ARABIC SMALL HIGH YEH..ARABIC SMALL HIGH NOON
                                                if (0x6e7 <= code && code <= 0x6e8) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else if (code < 0x70f) {
                                            // Mn   [4] ARABIC EMPTY CENTRE LOW STOP..ARABIC SMALL LOW MEEM
                                            if (0x6ea <= code && code <= 0x6ed) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Cf       SYRIAC ABBREVIATION MARK
                                            if (0x70f === code) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                            // Mn       SYRIAC LETTER SUPERSCRIPT ALAPH
                                            if (0x711 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else if (code < 0x7eb) {
                                        if (code < 0x7a6) {
                                            // Mn  [27] SYRIAC PTHAHA ABOVE..SYRIAC BARREKH
                                            if (0x730 <= code && code <= 0x74a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn  [11] THAANA ABAFILI..THAANA SUKUN
                                            if (0x7a6 <= code && code <= 0x7b0) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x7fd) {
                                            // Mn   [9] NKO COMBINING SHORT HIGH TONE..NKO COMBINING DOUBLE DOT ABOVE
                                            if (0x7eb <= code && code <= 0x7f3) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x816) {
                                            // Mn       NKO DANTAYALAN
                                            if (0x7fd === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [4] SAMARITAN MARK IN..SAMARITAN MARK DAGESH
                                            if (0x816 <= code && code <= 0x819) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0x898) {
                                    if (code < 0x829) {
                                        if (code < 0x825) {
                                            // Mn   [9] SAMARITAN MARK EPENTHETIC YUT..SAMARITAN VOWEL SIGN A
                                            if (0x81b <= code && code <= 0x823) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [3] SAMARITAN VOWEL SIGN SHORT A..SAMARITAN VOWEL SIGN U
                                            if (0x825 <= code && code <= 0x827) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x859) {
                                            // Mn   [5] SAMARITAN VOWEL SIGN LONG I..SAMARITAN MARK NEQUDAA
                                            if (0x829 <= code && code <= 0x82d) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x890) {
                                            // Mn   [3] MANDAIC AFFRICATION MARK..MANDAIC GEMINATION MARK
                                            if (0x859 <= code && code <= 0x85b) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Cf   [2] ARABIC POUND MARK ABOVE..ARABIC PIASTRE MARK ABOVE
                                            if (0x890 <= code && code <= 0x891) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                        }
                                    }
                                } else {
                                    if (code < 0x8e3) {
                                        if (code < 0x8ca) {
                                            // Mn   [8] ARABIC SMALL HIGH WORD AL-JUZ..ARABIC HALF MADDA OVER MADDA
                                            if (0x898 <= code && code <= 0x89f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x8e2) {
                                            // Mn  [24] ARABIC SMALL HIGH FARSI YEH..ARABIC SMALL HIGH SIGN SAFHA
                                            if (0x8ca <= code && code <= 0x8e1) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Cf       ARABIC DISPUTED END OF AYAH
                                            if (0x8e2 === code) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                        }
                                    } else if (code < 0x903) {
                                        // Mn  [32] ARABIC TURNED DAMMA BELOW..DEVANAGARI SIGN ANUSVARA
                                        if (0x8e3 <= code && code <= 0x902) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc       DEVANAGARI SIGN VISARGA
                                        if (0x903 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        // Mn       DEVANAGARI VOWEL SIGN OE
                                        if (0x93a === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            }
                        } else {
                            if (code < 0xa01) {
                                if (code < 0x982) {
                                    if (code < 0x94d) {
                                        if (code < 0x93e) {
                                            // Mc       DEVANAGARI VOWEL SIGN OOE
                                            if (0x93b === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                            // Mn       DEVANAGARI SIGN NUKTA
                                            if (0x93c === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            if (code < 0x941) {
                                                // Mc   [3] DEVANAGARI VOWEL SIGN AA..DEVANAGARI VOWEL SIGN II
                                                if (0x93e <= code && code <= 0x940) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (code < 0x949) {
                                                // Mn   [8] DEVANAGARI VOWEL SIGN U..DEVANAGARI VOWEL SIGN AI
                                                if (0x941 <= code && code <= 0x948) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mc   [4] DEVANAGARI VOWEL SIGN CANDRA O..DEVANAGARI VOWEL SIGN AU
                                                if (0x949 <= code && code <= 0x94c) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                            }
                                        }
                                    } else if (code < 0x951) {
                                        if (code < 0x94e) {
                                            // Mn       DEVANAGARI SIGN VIRAMA
                                            if (0x94d === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [2] DEVANAGARI VOWEL SIGN PRISHTHAMATRA E..DEVANAGARI VOWEL SIGN AW
                                            if (0x94e <= code && code <= 0x94f) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else {
                                        if (code < 0x962) {
                                            // Mn   [7] DEVANAGARI STRESS SIGN UDATTA..DEVANAGARI VOWEL SIGN UUE
                                            if (0x951 <= code && code <= 0x957) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x981) {
                                            // Mn   [2] DEVANAGARI VOWEL SIGN VOCALIC L..DEVANAGARI VOWEL SIGN VOCALIC LL
                                            if (0x962 <= code && code <= 0x963) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn       BENGALI SIGN CANDRABINDU
                                            if (0x981 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else {
                                    if (code < 0x9c7) {
                                        if (code < 0x9be) {
                                            if (code < 0x9bc) {
                                                // Mc   [2] BENGALI SIGN ANUSVARA..BENGALI SIGN VISARGA
                                                if (0x982 <= code && code <= 0x983) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                            } else {
                                                // Mn       BENGALI SIGN NUKTA
                                                if (0x9bc === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else {
                                            if (code < 0x9bf) {
                                                // Mc       BENGALI VOWEL SIGN AA
                                                if (0x9be === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else if (code < 0x9c1) {
                                                // Mc   [2] BENGALI VOWEL SIGN I..BENGALI VOWEL SIGN II
                                                if (0x9bf <= code && code <= 0x9c0) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                            } else {
                                                // Mn   [4] BENGALI VOWEL SIGN U..BENGALI VOWEL SIGN VOCALIC RR
                                                if (0x9c1 <= code && code <= 0x9c4) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            }
                                        }
                                    } else if (code < 0x9d7) {
                                        if (code < 0x9cb) {
                                            // Mc   [2] BENGALI VOWEL SIGN E..BENGALI VOWEL SIGN AI
                                            if (0x9c7 <= code && code <= 0x9c8) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0x9cd) {
                                            // Mc   [2] BENGALI VOWEL SIGN O..BENGALI VOWEL SIGN AU
                                            if (0x9cb <= code && code <= 0x9cc) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn       BENGALI SIGN VIRAMA
                                            if (0x9cd === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x9e2) {
                                            // Mc       BENGALI AU LENGTH MARK
                                            if (0x9d7 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x9fe) {
                                            // Mn   [2] BENGALI VOWEL SIGN VOCALIC L..BENGALI VOWEL SIGN VOCALIC LL
                                            if (0x9e2 <= code && code <= 0x9e3) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn       BENGALI SANDHI MARK
                                            if (0x9fe === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                }
                            } else if (code < 0xa83) {
                                if (code < 0xa47) {
                                    if (code < 0xa3c) {
                                        if (code < 0xa03) {
                                            // Mn   [2] GURMUKHI SIGN ADAK BINDI..GURMUKHI SIGN BINDI
                                            if (0xa01 <= code && code <= 0xa02) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       GURMUKHI SIGN VISARGA
                                            if (0xa03 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else {
                                        if (code < 0xa3e) {
                                            // Mn       GURMUKHI SIGN NUKTA
                                            if (0xa3c === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0xa41) {
                                            // Mc   [3] GURMUKHI VOWEL SIGN AA..GURMUKHI VOWEL SIGN II
                                            if (0xa3e <= code && code <= 0xa40) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [2] GURMUKHI VOWEL SIGN U..GURMUKHI VOWEL SIGN UU
                                            if (0xa41 <= code && code <= 0xa42) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0xa70) {
                                    if (code < 0xa4b) {
                                        // Mn   [2] GURMUKHI VOWEL SIGN EE..GURMUKHI VOWEL SIGN AI
                                        if (0xa47 <= code && code <= 0xa48) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xa51) {
                                        // Mn   [3] GURMUKHI VOWEL SIGN OO..GURMUKHI SIGN VIRAMA
                                        if (0xa4b <= code && code <= 0xa4d) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       GURMUKHI SIGN UDAAT
                                        if (0xa51 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xa75) {
                                        // Mn   [2] GURMUKHI TIPPI..GURMUKHI ADDAK
                                        if (0xa70 <= code && code <= 0xa71) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xa81) {
                                        // Mn       GURMUKHI SIGN YAKASH
                                        if (0xa75 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] GUJARATI SIGN CANDRABINDU..GUJARATI SIGN ANUSVARA
                                        if (0xa81 <= code && code <= 0xa82) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0xac9) {
                                    if (code < 0xabe) {
                                        // Mc       GUJARATI SIGN VISARGA
                                        if (0xa83 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        // Mn       GUJARATI SIGN NUKTA
                                        if (0xabc === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (code < 0xac1) {
                                            // Mc   [3] GUJARATI VOWEL SIGN AA..GUJARATI VOWEL SIGN II
                                            if (0xabe <= code && code <= 0xac0) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0xac7) {
                                            // Mn   [5] GUJARATI VOWEL SIGN U..GUJARATI VOWEL SIGN CANDRA E
                                            if (0xac1 <= code && code <= 0xac5) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [2] GUJARATI VOWEL SIGN E..GUJARATI VOWEL SIGN AI
                                            if (0xac7 <= code && code <= 0xac8) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0xae2) {
                                    if (code < 0xacb) {
                                        // Mc       GUJARATI VOWEL SIGN CANDRA O
                                        if (0xac9 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xacd) {
                                        // Mc   [2] GUJARATI VOWEL SIGN O..GUJARATI VOWEL SIGN AU
                                        if (0xacb <= code && code <= 0xacc) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       GUJARATI SIGN VIRAMA
                                        if (0xacd === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xafa) {
                                        // Mn   [2] GUJARATI VOWEL SIGN VOCALIC L..GUJARATI VOWEL SIGN VOCALIC LL
                                        if (0xae2 <= code && code <= 0xae3) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xb01) {
                                        // Mn   [6] GUJARATI SIGN SUKUN..GUJARATI SIGN TWO-CIRCLE NUKTA ABOVE
                                        if (0xafa <= code && code <= 0xaff) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       ORIYA SIGN CANDRABINDU
                                        if (0xb01 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            }
                        }
                    } else if (code < 0xcf3) {
                        if (code < 0xc04) {
                            if (code < 0xb82) {
                                if (code < 0xb47) {
                                    if (code < 0xb3e) {
                                        if (code < 0xb3c) {
                                            // Mc   [2] ORIYA SIGN ANUSVARA..ORIYA SIGN VISARGA
                                            if (0xb02 <= code && code <= 0xb03) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn       ORIYA SIGN NUKTA
                                            if (0xb3c === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0xb40) {
                                            // Mc       ORIYA VOWEL SIGN AA
                                            // Mn       ORIYA VOWEL SIGN I
                                            if (0xb3e <= code && code <= 0xb3f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0xb41) {
                                            // Mc       ORIYA VOWEL SIGN II
                                            if (0xb40 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [4] ORIYA VOWEL SIGN U..ORIYA VOWEL SIGN VOCALIC RR
                                            if (0xb41 <= code && code <= 0xb44) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0xb4d) {
                                    if (code < 0xb4b) {
                                        // Mc   [2] ORIYA VOWEL SIGN E..ORIYA VOWEL SIGN AI
                                        if (0xb47 <= code && code <= 0xb48) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mc   [2] ORIYA VOWEL SIGN O..ORIYA VOWEL SIGN AU
                                        if (0xb4b <= code && code <= 0xb4c) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0xb55) {
                                        // Mn       ORIYA SIGN VIRAMA
                                        if (0xb4d === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xb62) {
                                        // Mn   [2] ORIYA SIGN OVERLINE..ORIYA AI LENGTH MARK
                                        // Mc       ORIYA AU LENGTH MARK
                                        if (0xb55 <= code && code <= 0xb57) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] ORIYA VOWEL SIGN VOCALIC L..ORIYA VOWEL SIGN VOCALIC LL
                                        if (0xb62 <= code && code <= 0xb63) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0xbc6) {
                                    if (code < 0xbbf) {
                                        // Mn       TAMIL SIGN ANUSVARA
                                        if (0xb82 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        // Mc       TAMIL VOWEL SIGN AA
                                        if (0xbbe === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (code < 0xbc0) {
                                            // Mc       TAMIL VOWEL SIGN I
                                            if (0xbbf === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0xbc1) {
                                            // Mn       TAMIL VOWEL SIGN II
                                            if (0xbc0 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [2] TAMIL VOWEL SIGN U..TAMIL VOWEL SIGN UU
                                            if (0xbc1 <= code && code <= 0xbc2) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                } else if (code < 0xbd7) {
                                    if (code < 0xbca) {
                                        // Mc   [3] TAMIL VOWEL SIGN E..TAMIL VOWEL SIGN AI
                                        if (0xbc6 <= code && code <= 0xbc8) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xbcd) {
                                        // Mc   [3] TAMIL VOWEL SIGN O..TAMIL VOWEL SIGN AU
                                        if (0xbca <= code && code <= 0xbcc) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       TAMIL SIGN VIRAMA
                                        if (0xbcd === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xc00) {
                                        // Mc       TAMIL AU LENGTH MARK
                                        if (0xbd7 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xc01) {
                                        // Mn       TELUGU SIGN COMBINING CANDRABINDU ABOVE
                                        if (0xc00 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [3] TELUGU SIGN CANDRABINDU..TELUGU SIGN VISARGA
                                        if (0xc01 <= code && code <= 0xc03) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            }
                        } else if (code < 0xcbe) {
                            if (code < 0xc4a) {
                                if (code < 0xc3e) {
                                    // Mn       TELUGU SIGN COMBINING ANUSVARA ABOVE
                                    if (0xc04 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    // Mn       TELUGU SIGN NUKTA
                                    if (0xc3c === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (code < 0xc41) {
                                        // Mn   [3] TELUGU VOWEL SIGN AA..TELUGU VOWEL SIGN II
                                        if (0xc3e <= code && code <= 0xc40) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xc46) {
                                        // Mc   [4] TELUGU VOWEL SIGN U..TELUGU VOWEL SIGN VOCALIC RR
                                        if (0xc41 <= code && code <= 0xc44) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [3] TELUGU VOWEL SIGN E..TELUGU VOWEL SIGN AI
                                        if (0xc46 <= code && code <= 0xc48) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0xc81) {
                                if (code < 0xc55) {
                                    // Mn   [4] TELUGU VOWEL SIGN O..TELUGU SIGN VIRAMA
                                    if (0xc4a <= code && code <= 0xc4d) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xc62) {
                                    // Mn   [2] TELUGU LENGTH MARK..TELUGU AI LENGTH MARK
                                    if (0xc55 <= code && code <= 0xc56) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [2] TELUGU VOWEL SIGN VOCALIC L..TELUGU VOWEL SIGN VOCALIC LL
                                    if (0xc62 <= code && code <= 0xc63) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0xc82) {
                                    // Mn       KANNADA SIGN CANDRABINDU
                                    if (0xc81 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xcbc) {
                                    // Mc   [2] KANNADA SIGN ANUSVARA..KANNADA SIGN VISARGA
                                    if (0xc82 <= code && code <= 0xc83) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       KANNADA SIGN NUKTA
                                    if (0xcbc === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0xcc6) {
                                if (code < 0xcc0) {
                                    // Mc       KANNADA VOWEL SIGN AA
                                    if (0xcbe === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       KANNADA VOWEL SIGN I
                                    if (0xcbf === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (code < 0xcc2) {
                                        // Mc   [2] KANNADA VOWEL SIGN II..KANNADA VOWEL SIGN U
                                        if (0xcc0 <= code && code <= 0xcc1) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xcc3) {
                                        // Mc       KANNADA VOWEL SIGN UU
                                        if (0xcc2 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] KANNADA VOWEL SIGN VOCALIC R..KANNADA VOWEL SIGN VOCALIC RR
                                        if (0xcc3 <= code && code <= 0xcc4) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else if (code < 0xccc) {
                                if (code < 0xcc7) {
                                    // Mn       KANNADA VOWEL SIGN E
                                    if (0xcc6 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xcca) {
                                    // Mc   [2] KANNADA VOWEL SIGN EE..KANNADA VOWEL SIGN AI
                                    if (0xcc7 <= code && code <= 0xcc8) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mc   [2] KANNADA VOWEL SIGN O..KANNADA VOWEL SIGN OO
                                    if (0xcca <= code && code <= 0xccb) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0xcd5) {
                                    // Mn   [2] KANNADA VOWEL SIGN AU..KANNADA SIGN VIRAMA
                                    if (0xccc <= code && code <= 0xccd) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xce2) {
                                    // Mc   [2] KANNADA LENGTH MARK..KANNADA AI LENGTH MARK
                                    if (0xcd5 <= code && code <= 0xcd6) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [2] KANNADA VOWEL SIGN VOCALIC L..KANNADA VOWEL SIGN VOCALIC LL
                                    if (0xce2 <= code && code <= 0xce3) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    } else {
                        if (code < 0xddf) {
                            if (code < 0xd4e) {
                                if (code < 0xd3f) {
                                    if (code < 0xd02) {
                                        if (code < 0xd00) {
                                            // Mc       KANNADA SIGN COMBINING ANUSVARA ABOVE RIGHT
                                            if (0xcf3 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [2] MALAYALAM SIGN COMBINING ANUSVARA ABOVE..MALAYALAM SIGN CANDRABINDU
                                            if (0xd00 <= code && code <= 0xd01) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0xd3b) {
                                            // Mc   [2] MALAYALAM SIGN ANUSVARA..MALAYALAM SIGN VISARGA
                                            if (0xd02 <= code && code <= 0xd03) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0xd3e) {
                                            // Mn   [2] MALAYALAM SIGN VERTICAL BAR VIRAMA..MALAYALAM SIGN CIRCULAR VIRAMA
                                            if (0xd3b <= code && code <= 0xd3c) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       MALAYALAM VOWEL SIGN AA
                                            if (0xd3e === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0xd46) {
                                    if (code < 0xd41) {
                                        // Mc   [2] MALAYALAM VOWEL SIGN I..MALAYALAM VOWEL SIGN II
                                        if (0xd3f <= code && code <= 0xd40) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [4] MALAYALAM VOWEL SIGN U..MALAYALAM VOWEL SIGN VOCALIC RR
                                        if (0xd41 <= code && code <= 0xd44) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xd4a) {
                                        // Mc   [3] MALAYALAM VOWEL SIGN E..MALAYALAM VOWEL SIGN AI
                                        if (0xd46 <= code && code <= 0xd48) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xd4d) {
                                        // Mc   [3] MALAYALAM VOWEL SIGN O..MALAYALAM VOWEL SIGN AU
                                        if (0xd4a <= code && code <= 0xd4c) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       MALAYALAM SIGN VIRAMA
                                        if (0xd4d === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0xdca) {
                                    if (code < 0xd62) {
                                        // Lo       MALAYALAM LETTER DOT REPH
                                        if (0xd4e === code) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                        // Mc       MALAYALAM AU LENGTH MARK
                                        if (0xd57 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (code < 0xd81) {
                                            // Mn   [2] MALAYALAM VOWEL SIGN VOCALIC L..MALAYALAM VOWEL SIGN VOCALIC LL
                                            if (0xd62 <= code && code <= 0xd63) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0xd82) {
                                            // Mn       SINHALA SIGN CANDRABINDU
                                            if (0xd81 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [2] SINHALA SIGN ANUSVARAYA..SINHALA SIGN VISARGAYA
                                            if (0xd82 <= code && code <= 0xd83) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                } else if (code < 0xdd2) {
                                    if (code < 0xdcf) {
                                        // Mn       SINHALA SIGN AL-LAKUNA
                                        if (0xdca === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xdd0) {
                                        // Mc       SINHALA VOWEL SIGN AELA-PILLA
                                        if (0xdcf === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] SINHALA VOWEL SIGN KETTI AEDA-PILLA..SINHALA VOWEL SIGN DIGA AEDA-PILLA
                                        if (0xdd0 <= code && code <= 0xdd1) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0xdd6) {
                                        // Mn   [3] SINHALA VOWEL SIGN KETTI IS-PILLA..SINHALA VOWEL SIGN KETTI PAA-PILLA
                                        if (0xdd2 <= code && code <= 0xdd4) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xdd8) {
                                        // Mn       SINHALA VOWEL SIGN DIGA PAA-PILLA
                                        if (0xdd6 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [7] SINHALA VOWEL SIGN GAETTA-PILLA..SINHALA VOWEL SIGN KOMBUVA HAA GAYANUKITTA
                                        if (0xdd8 <= code && code <= 0xdde) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            }
                        } else if (code < 0xf35) {
                            if (code < 0xe47) {
                                if (code < 0xe31) {
                                    if (code < 0xdf2) {
                                        // Mc       SINHALA VOWEL SIGN GAYANUKITTA
                                        if (0xddf === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] SINHALA VOWEL SIGN DIGA GAETTA-PILLA..SINHALA VOWEL SIGN DIGA GAYANUKITTA
                                        if (0xdf2 <= code && code <= 0xdf3) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0xe33) {
                                        // Mn       THAI CHARACTER MAI HAN-AKAT
                                        if (0xe31 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xe34) {
                                        // Lo       THAI CHARACTER SARA AM
                                        if (0xe33 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [7] THAI CHARACTER SARA I..THAI CHARACTER PHINTHU
                                        if (0xe34 <= code && code <= 0xe3a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0xeb4) {
                                if (code < 0xeb1) {
                                    // Mn   [8] THAI CHARACTER MAITAIKHU..THAI CHARACTER YAMAKKAN
                                    if (0xe47 <= code && code <= 0xe4e) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       LAO VOWEL SIGN MAI KAN
                                    if (0xeb1 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    // Lo       LAO VOWEL SIGN AM
                                    if (0xeb3 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0xec8) {
                                    // Mn   [9] LAO VOWEL SIGN I..LAO SEMIVOWEL SIGN LO
                                    if (0xeb4 <= code && code <= 0xebc) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xf18) {
                                    // Mn   [7] LAO TONE MAI EK..LAO YAMAKKAN
                                    if (0xec8 <= code && code <= 0xece) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [2] TIBETAN ASTROLOGICAL SIGN -KHYUD PA..TIBETAN ASTROLOGICAL SIGN SDONG TSHUGS
                                    if (0xf18 <= code && code <= 0xf19) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0xf7f) {
                                if (code < 0xf39) {
                                    // Mn       TIBETAN MARK NGAS BZUNG NYI ZLA
                                    if (0xf35 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    // Mn       TIBETAN MARK NGAS BZUNG SGOR RTAGS
                                    if (0xf37 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (code < 0xf3e) {
                                        // Mn       TIBETAN MARK TSA -PHRU
                                        if (0xf39 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xf71) {
                                        // Mc   [2] TIBETAN SIGN YAR TSHES..TIBETAN SIGN MAR TSHES
                                        if (0xf3e <= code && code <= 0xf3f) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn  [14] TIBETAN VOWEL SIGN AA..TIBETAN SIGN RJES SU NGA RO
                                        if (0xf71 <= code && code <= 0xf7e) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0xf8d) {
                                if (code < 0xf80) {
                                    // Mc       TIBETAN SIGN RNAM BCAD
                                    if (0xf7f === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0xf86) {
                                    // Mn   [5] TIBETAN VOWEL SIGN REVERSED I..TIBETAN MARK HALANTA
                                    if (0xf80 <= code && code <= 0xf84) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [2] TIBETAN SIGN LCI RTAGS..TIBETAN SIGN YANG RTAGS
                                    if (0xf86 <= code && code <= 0xf87) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0xf99) {
                                    // Mn  [11] TIBETAN SUBJOINED SIGN LCE TSA CAN..TIBETAN SUBJOINED LETTER JA
                                    if (0xf8d <= code && code <= 0xf97) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xfc6) {
                                    // Mn  [36] TIBETAN SUBJOINED LETTER NYA..TIBETAN SUBJOINED LETTER FIXED-FORM RA
                                    if (0xf99 <= code && code <= 0xfbc) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       TIBETAN SYMBOL PADMA GDAN
                                    if (0xfc6 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    }
                } else {
                    if (code < 0x1c24) {
                        if (code < 0x1930) {
                            if (code < 0x1732) {
                                if (code < 0x1082) {
                                    if (code < 0x103d) {
                                        if (code < 0x1032) {
                                            if (code < 0x1031) {
                                                // Mn   [4] MYANMAR VOWEL SIGN I..MYANMAR VOWEL SIGN UU
                                                if (0x102d <= code && code <= 0x1030) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mc       MYANMAR VOWEL SIGN E
                                                if (0x1031 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                            }
                                        } else {
                                            if (code < 0x1039) {
                                                // Mn   [6] MYANMAR VOWEL SIGN AI..MYANMAR SIGN DOT BELOW
                                                if (0x1032 <= code && code <= 0x1037) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else if (code < 0x103b) {
                                                // Mn   [2] MYANMAR SIGN VIRAMA..MYANMAR SIGN ASAT
                                                if (0x1039 <= code && code <= 0x103a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mc   [2] MYANMAR CONSONANT SIGN MEDIAL YA..MYANMAR CONSONANT SIGN MEDIAL RA
                                                if (0x103b <= code && code <= 0x103c) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                            }
                                        }
                                    } else if (code < 0x1058) {
                                        if (code < 0x1056) {
                                            // Mn   [2] MYANMAR CONSONANT SIGN MEDIAL WA..MYANMAR CONSONANT SIGN MEDIAL HA
                                            if (0x103d <= code && code <= 0x103e) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [2] MYANMAR VOWEL SIGN VOCALIC R..MYANMAR VOWEL SIGN VOCALIC RR
                                            if (0x1056 <= code && code <= 0x1057) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else {
                                        if (code < 0x105e) {
                                            // Mn   [2] MYANMAR VOWEL SIGN VOCALIC L..MYANMAR VOWEL SIGN VOCALIC LL
                                            if (0x1058 <= code && code <= 0x1059) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x1071) {
                                            // Mn   [3] MYANMAR CONSONANT SIGN MON MEDIAL NA..MYANMAR CONSONANT SIGN MON MEDIAL LA
                                            if (0x105e <= code && code <= 0x1060) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [4] MYANMAR VOWEL SIGN GEBA KAREN I..MYANMAR VOWEL SIGN KAYAH EE
                                            if (0x1071 <= code && code <= 0x1074) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else {
                                    if (code < 0x1100) {
                                        if (code < 0x1085) {
                                            // Mn       MYANMAR CONSONANT SIGN SHAN MEDIAL WA
                                            if (0x1082 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            // Mc       MYANMAR VOWEL SIGN SHAN E
                                            if (0x1084 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0x108d) {
                                            // Mn   [2] MYANMAR VOWEL SIGN SHAN E ABOVE..MYANMAR VOWEL SIGN SHAN FINAL Y
                                            if (0x1085 <= code && code <= 0x1086) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn       MYANMAR SIGN SHAN COUNCIL EMPHATIC TONE
                                            if (0x108d === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            // Mn       MYANMAR VOWEL SIGN AITON AI
                                            if (0x109d === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else if (code < 0x135d) {
                                        if (code < 0x1160) {
                                            // Lo  [96] HANGUL CHOSEONG KIYEOK..HANGUL CHOSEONG FILLER
                                            if (0x1100 <= code && code <= 0x115f) return $lXl8C.CLUSTER_BREAK.L;
                                        } else if (code < 0x11a8) {
                                            // Lo  [72] HANGUL JUNGSEONG FILLER..HANGUL JUNGSEONG O-YAE
                                            if (0x1160 <= code && code <= 0x11a7) return $lXl8C.CLUSTER_BREAK.V;
                                        } else {
                                            // Lo  [88] HANGUL JONGSEONG KIYEOK..HANGUL JONGSEONG SSANGNIEUN
                                            if (0x11a8 <= code && code <= 0x11ff) return $lXl8C.CLUSTER_BREAK.T;
                                        }
                                    } else {
                                        if (code < 0x1712) {
                                            // Mn   [3] ETHIOPIC COMBINING GEMINATION AND VOWEL LENGTH MARK..ETHIOPIC COMBINING GEMINATION MARK
                                            if (0x135d <= code && code <= 0x135f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x1715) {
                                            // Mn   [3] TAGALOG VOWEL SIGN I..TAGALOG SIGN VIRAMA
                                            if (0x1712 <= code && code <= 0x1714) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       TAGALOG SIGN PAMUDPOD
                                            if (0x1715 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                }
                            } else if (code < 0x17c9) {
                                if (code < 0x17b6) {
                                    if (code < 0x1752) {
                                        if (code < 0x1734) {
                                            // Mn   [2] HANUNOO VOWEL SIGN I..HANUNOO VOWEL SIGN U
                                            if (0x1732 <= code && code <= 0x1733) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       HANUNOO SIGN PAMUDPOD
                                            if (0x1734 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else {
                                        if (code < 0x1772) {
                                            // Mn   [2] BUHID VOWEL SIGN I..BUHID VOWEL SIGN U
                                            if (0x1752 <= code && code <= 0x1753) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x17b4) {
                                            // Mn   [2] TAGBANWA VOWEL SIGN I..TAGBANWA VOWEL SIGN U
                                            if (0x1772 <= code && code <= 0x1773) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [2] KHMER VOWEL INHERENT AQ..KHMER VOWEL INHERENT AA
                                            if (0x17b4 <= code && code <= 0x17b5) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0x17be) {
                                    if (code < 0x17b7) {
                                        // Mc       KHMER VOWEL SIGN AA
                                        if (0x17b6 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [7] KHMER VOWEL SIGN I..KHMER VOWEL SIGN UA
                                        if (0x17b7 <= code && code <= 0x17bd) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x17c6) {
                                        // Mc   [8] KHMER VOWEL SIGN OE..KHMER VOWEL SIGN AU
                                        if (0x17be <= code && code <= 0x17c5) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x17c7) {
                                        // Mn       KHMER SIGN NIKAHIT
                                        if (0x17c6 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] KHMER SIGN REAHMUK..KHMER SIGN YUUKALEAPINTU
                                        if (0x17c7 <= code && code <= 0x17c8) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else {
                                if (code < 0x1885) {
                                    if (code < 0x180b) {
                                        if (code < 0x17dd) {
                                            // Mn  [11] KHMER SIGN MUUSIKATOAN..KHMER SIGN BATHAMASAT
                                            if (0x17c9 <= code && code <= 0x17d3) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn       KHMER SIGN ATTHACAN
                                            if (0x17dd === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else if (code < 0x180e) {
                                        // Mn   [3] MONGOLIAN FREE VARIATION SELECTOR ONE..MONGOLIAN FREE VARIATION SELECTOR THREE
                                        if (0x180b <= code && code <= 0x180d) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Cf       MONGOLIAN VOWEL SEPARATOR
                                        if (0x180e === code) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                        // Mn       MONGOLIAN FREE VARIATION SELECTOR FOUR
                                        if (0x180f === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0x1923) {
                                    if (code < 0x18a9) {
                                        // Mn   [2] MONGOLIAN LETTER ALI GALI BALUDA..MONGOLIAN LETTER ALI GALI THREE BALUDA
                                        if (0x1885 <= code && code <= 0x1886) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x1920) {
                                        // Mn       MONGOLIAN LETTER ALI GALI DAGALGA
                                        if (0x18a9 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [3] LIMBU VOWEL SIGN A..LIMBU VOWEL SIGN U
                                        if (0x1920 <= code && code <= 0x1922) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x1927) {
                                        // Mc   [4] LIMBU VOWEL SIGN EE..LIMBU VOWEL SIGN AU
                                        if (0x1923 <= code && code <= 0x1926) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x1929) {
                                        // Mn   [2] LIMBU VOWEL SIGN E..LIMBU VOWEL SIGN O
                                        if (0x1927 <= code && code <= 0x1928) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [3] LIMBU SUBJOINED LETTER YA..LIMBU SUBJOINED LETTER WA
                                        if (0x1929 <= code && code <= 0x192b) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            }
                        } else {
                            if (code < 0x1b3b) {
                                if (code < 0x1a58) {
                                    if (code < 0x1a19) {
                                        if (code < 0x1933) {
                                            if (code < 0x1932) {
                                                // Mc   [2] LIMBU SMALL LETTER KA..LIMBU SMALL LETTER NGA
                                                if (0x1930 <= code && code <= 0x1931) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                            } else {
                                                // Mn       LIMBU SMALL LETTER ANUSVARA
                                                if (0x1932 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else {
                                            if (code < 0x1939) {
                                                // Mc   [6] LIMBU SMALL LETTER TA..LIMBU SMALL LETTER LA
                                                if (0x1933 <= code && code <= 0x1938) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (code < 0x1a17) {
                                                // Mn   [3] LIMBU SIGN MUKPHRENG..LIMBU SIGN SA-I
                                                if (0x1939 <= code && code <= 0x193b) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mn   [2] BUGINESE VOWEL SIGN I..BUGINESE VOWEL SIGN U
                                                if (0x1a17 <= code && code <= 0x1a18) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            }
                                        }
                                    } else {
                                        if (code < 0x1a55) {
                                            if (code < 0x1a1b) {
                                                // Mc   [2] BUGINESE VOWEL SIGN E..BUGINESE VOWEL SIGN O
                                                if (0x1a19 <= code && code <= 0x1a1a) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                            } else {
                                                // Mn       BUGINESE VOWEL SIGN AE
                                                if (0x1a1b === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else if (code < 0x1a56) {
                                            // Mc       TAI THAM CONSONANT SIGN MEDIAL RA
                                            if (0x1a55 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn       TAI THAM CONSONANT SIGN MEDIAL LA
                                            if (0x1a56 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            // Mc       TAI THAM CONSONANT SIGN LA TANG LAI
                                            if (0x1a57 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                } else {
                                    if (code < 0x1a73) {
                                        if (code < 0x1a62) {
                                            if (code < 0x1a60) {
                                                // Mn   [7] TAI THAM SIGN MAI KANG LAI..TAI THAM CONSONANT SIGN SA
                                                if (0x1a58 <= code && code <= 0x1a5e) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mn       TAI THAM SIGN SAKOT
                                                if (0x1a60 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else {
                                            if (code < 0x1a65) {
                                                // Mn       TAI THAM VOWEL SIGN MAI SAT
                                                if (0x1a62 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else if (code < 0x1a6d) {
                                                // Mn   [8] TAI THAM VOWEL SIGN I..TAI THAM VOWEL SIGN OA BELOW
                                                if (0x1a65 <= code && code <= 0x1a6c) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mc   [6] TAI THAM VOWEL SIGN OY..TAI THAM VOWEL SIGN THAM AI
                                                if (0x1a6d <= code && code <= 0x1a72) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                            }
                                        }
                                    } else if (code < 0x1b00) {
                                        if (code < 0x1a7f) {
                                            // Mn  [10] TAI THAM VOWEL SIGN OA ABOVE..TAI THAM SIGN KHUEN-LUE KARAN
                                            if (0x1a73 <= code && code <= 0x1a7c) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x1ab0) {
                                            // Mn       TAI THAM COMBINING CRYPTOGRAMMIC DOT
                                            if (0x1a7f === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn  [14] COMBINING DOUBLED CIRCUMFLEX ACCENT..COMBINING PARENTHESES BELOW
                                            // Me       COMBINING PARENTHESES OVERLAY
                                            // Mn  [16] COMBINING LATIN SMALL LETTER W BELOW..COMBINING LATIN SMALL LETTER INSULAR T
                                            if (0x1ab0 <= code && code <= 0x1ace) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x1b04) {
                                            // Mn   [4] BALINESE SIGN ULU RICEM..BALINESE SIGN SURANG
                                            if (0x1b00 <= code && code <= 0x1b03) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x1b34) {
                                            // Mc       BALINESE SIGN BISAH
                                            if (0x1b04 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn       BALINESE SIGN REREKAN
                                            // Mc       BALINESE VOWEL SIGN TEDUNG
                                            // Mn   [5] BALINESE VOWEL SIGN ULU..BALINESE VOWEL SIGN RA REPA
                                            if (0x1b34 <= code && code <= 0x1b3a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                }
                            } else if (code < 0x1ba8) {
                                if (code < 0x1b6b) {
                                    if (code < 0x1b3d) {
                                        // Mc       BALINESE VOWEL SIGN RA REPA TEDUNG
                                        if (0x1b3b === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        // Mn       BALINESE VOWEL SIGN LA LENGA
                                        if (0x1b3c === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (code < 0x1b42) {
                                            // Mc   [5] BALINESE VOWEL SIGN LA LENGA TEDUNG..BALINESE VOWEL SIGN TALING REPA TEDUNG
                                            if (0x1b3d <= code && code <= 0x1b41) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0x1b43) {
                                            // Mn       BALINESE VOWEL SIGN PEPET
                                            if (0x1b42 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [2] BALINESE VOWEL SIGN PEPET TEDUNG..BALINESE ADEG ADEG
                                            if (0x1b43 <= code && code <= 0x1b44) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                } else if (code < 0x1ba1) {
                                    if (code < 0x1b80) {
                                        // Mn   [9] BALINESE MUSICAL SYMBOL COMBINING TEGEH..BALINESE MUSICAL SYMBOL COMBINING GONG
                                        if (0x1b6b <= code && code <= 0x1b73) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x1b82) {
                                        // Mn   [2] SUNDANESE SIGN PANYECEK..SUNDANESE SIGN PANGLAYAR
                                        if (0x1b80 <= code && code <= 0x1b81) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc       SUNDANESE SIGN PANGWISAD
                                        if (0x1b82 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0x1ba2) {
                                        // Mc       SUNDANESE CONSONANT SIGN PAMINGKAL
                                        if (0x1ba1 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x1ba6) {
                                        // Mn   [4] SUNDANESE CONSONANT SIGN PANYAKRA..SUNDANESE VOWEL SIGN PANYUKU
                                        if (0x1ba2 <= code && code <= 0x1ba5) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] SUNDANESE VOWEL SIGN PANAELAENG..SUNDANESE VOWEL SIGN PANOLONG
                                        if (0x1ba6 <= code && code <= 0x1ba7) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else {
                                if (code < 0x1be8) {
                                    if (code < 0x1bab) {
                                        if (code < 0x1baa) {
                                            // Mn   [2] SUNDANESE VOWEL SIGN PAMEPET..SUNDANESE VOWEL SIGN PANEULEUNG
                                            if (0x1ba8 <= code && code <= 0x1ba9) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       SUNDANESE SIGN PAMAAEH
                                            if (0x1baa === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else if (code < 0x1be6) {
                                        // Mn   [3] SUNDANESE SIGN VIRAMA..SUNDANESE CONSONANT SIGN PASANGAN WA
                                        if (0x1bab <= code && code <= 0x1bad) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       BATAK SIGN TOMPI
                                        if (0x1be6 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        // Mc       BATAK VOWEL SIGN E
                                        if (0x1be7 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else if (code < 0x1bee) {
                                    if (code < 0x1bea) {
                                        // Mn   [2] BATAK VOWEL SIGN PAKPAK E..BATAK VOWEL SIGN EE
                                        if (0x1be8 <= code && code <= 0x1be9) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x1bed) {
                                        // Mc   [3] BATAK VOWEL SIGN I..BATAK VOWEL SIGN O
                                        if (0x1bea <= code && code <= 0x1bec) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       BATAK VOWEL SIGN KARO O
                                        if (0x1bed === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x1bef) {
                                        // Mc       BATAK VOWEL SIGN U
                                        if (0x1bee === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x1bf2) {
                                        // Mn   [3] BATAK VOWEL SIGN U FOR SIMALUNGUN SA..BATAK CONSONANT SIGN H
                                        if (0x1bef <= code && code <= 0x1bf1) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] BATAK PANGOLAT..BATAK PANONGONAN
                                        if (0x1bf2 <= code && code <= 0x1bf3) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            }
                        }
                    } else if (code < 0xa952) {
                        if (code < 0x2d7f) {
                            if (code < 0x1cf7) {
                                if (code < 0x1cd4) {
                                    if (code < 0x1c34) {
                                        if (code < 0x1c2c) {
                                            // Mc   [8] LEPCHA SUBJOINED LETTER YA..LEPCHA VOWEL SIGN UU
                                            if (0x1c24 <= code && code <= 0x1c2b) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [8] LEPCHA VOWEL SIGN E..LEPCHA CONSONANT SIGN T
                                            if (0x1c2c <= code && code <= 0x1c33) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x1c36) {
                                            // Mc   [2] LEPCHA CONSONANT SIGN NYIN-DO..LEPCHA CONSONANT SIGN KANG
                                            if (0x1c34 <= code && code <= 0x1c35) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0x1cd0) {
                                            // Mn   [2] LEPCHA SIGN RAN..LEPCHA SIGN NUKTA
                                            if (0x1c36 <= code && code <= 0x1c37) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [3] VEDIC TONE KARSHANA..VEDIC TONE PRENKHA
                                            if (0x1cd0 <= code && code <= 0x1cd2) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else {
                                    if (code < 0x1ce2) {
                                        if (code < 0x1ce1) {
                                            // Mn  [13] VEDIC SIGN YAJURVEDIC MIDLINE SVARITA..VEDIC TONE RIGVEDIC KASHMIRI INDEPENDENT SVARITA
                                            if (0x1cd4 <= code && code <= 0x1ce0) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       VEDIC TONE ATHARVAVEDIC INDEPENDENT SVARITA
                                            if (0x1ce1 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else if (code < 0x1ced) {
                                        // Mn   [7] VEDIC SIGN VISARGA SVARITA..VEDIC SIGN VISARGA ANUDATTA WITH TAIL
                                        if (0x1ce2 <= code && code <= 0x1ce8) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       VEDIC SIGN TIRYAK
                                        if (0x1ced === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        // Mn       VEDIC TONE CANDRA ABOVE
                                        if (0x1cf4 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0x200d) {
                                    if (code < 0x1dc0) {
                                        if (code < 0x1cf8) {
                                            // Mc       VEDIC SIGN ATIKRAMA
                                            if (0x1cf7 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [2] VEDIC TONE RING ABOVE..VEDIC TONE DOUBLE RING ABOVE
                                            if (0x1cf8 <= code && code <= 0x1cf9) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else if (code < 0x200b) {
                                        // Mn  [64] COMBINING DOTTED GRAVE ACCENT..COMBINING RIGHT ARROWHEAD AND DOWN ARROWHEAD BELOW
                                        if (0x1dc0 <= code && code <= 0x1dff) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Cf       ZERO WIDTH SPACE
                                        if (0x200b === code) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                        // Cf       ZERO WIDTH NON-JOINER
                                        if (0x200c === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0x2060) {
                                    if (code < 0x200e) {
                                        // Cf       ZERO WIDTH JOINER
                                        if (0x200d === code) return $lXl8C.CLUSTER_BREAK.ZWJ;
                                    } else if (code < 0x2028) {
                                        // Cf   [2] LEFT-TO-RIGHT MARK..RIGHT-TO-LEFT MARK
                                        if (0x200e <= code && code <= 0x200f) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                    } else {
                                        // Zl       LINE SEPARATOR
                                        // Zp       PARAGRAPH SEPARATOR
                                        // Cf   [5] LEFT-TO-RIGHT EMBEDDING..RIGHT-TO-LEFT OVERRIDE
                                        if (0x2028 <= code && code <= 0x202e) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                    }
                                } else {
                                    if (code < 0x20d0) {
                                        // Cf   [5] WORD JOINER..INVISIBLE PLUS
                                        // Cn       <reserved-2065>
                                        // Cf  [10] LEFT-TO-RIGHT ISOLATE..NOMINAL DIGIT SHAPES
                                        if (0x2060 <= code && code <= 0x206f) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                    } else if (code < 0x2cef) {
                                        // Mn  [13] COMBINING LEFT HARPOON ABOVE..COMBINING FOUR DOTS ABOVE
                                        // Me   [4] COMBINING ENCLOSING CIRCLE..COMBINING ENCLOSING CIRCLE BACKSLASH
                                        // Mn       COMBINING LEFT RIGHT ARROW ABOVE
                                        // Me   [3] COMBINING ENCLOSING SCREEN..COMBINING ENCLOSING UPWARD POINTING TRIANGLE
                                        // Mn  [12] COMBINING REVERSE SOLIDUS OVERLAY..COMBINING ASTERISK ABOVE
                                        if (0x20d0 <= code && code <= 0x20f0) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [3] COPTIC COMBINING NI ABOVE..COPTIC COMBINING SPIRITUS LENIS
                                        if (0x2cef <= code && code <= 0x2cf1) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            }
                        } else if (code < 0xa823) {
                            if (code < 0xa674) {
                                if (code < 0x302a) {
                                    if (code < 0x2de0) {
                                        // Mn       TIFINAGH CONSONANT JOINER
                                        if (0x2d7f === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn  [32] COMBINING CYRILLIC LETTER BE..COMBINING CYRILLIC LETTER IOTIFIED BIG YUS
                                        if (0x2de0 <= code && code <= 0x2dff) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x3099) {
                                        // Mn   [4] IDEOGRAPHIC LEVEL TONE MARK..IDEOGRAPHIC ENTERING TONE MARK
                                        // Mc   [2] HANGUL SINGLE DOT TONE MARK..HANGUL DOUBLE DOT TONE MARK
                                        if (0x302a <= code && code <= 0x302f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xa66f) {
                                        // Mn   [2] COMBINING KATAKANA-HIRAGANA VOICED SOUND MARK..COMBINING KATAKANA-HIRAGANA SEMI-VOICED SOUND MARK
                                        if (0x3099 <= code && code <= 0x309a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       COMBINING CYRILLIC VZMET
                                        // Me   [3] COMBINING CYRILLIC TEN MILLIONS SIGN..COMBINING CYRILLIC THOUSAND MILLIONS SIGN
                                        if (0xa66f <= code && code <= 0xa672) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0xa802) {
                                    if (code < 0xa69e) {
                                        // Mn  [10] COMBINING CYRILLIC LETTER UKRAINIAN IE..COMBINING CYRILLIC PAYEROK
                                        if (0xa674 <= code && code <= 0xa67d) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xa6f0) {
                                        // Mn   [2] COMBINING CYRILLIC LETTER EF..COMBINING CYRILLIC LETTER IOTIFIED E
                                        if (0xa69e <= code && code <= 0xa69f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] BAMUM COMBINING MARK KOQNDON..BAMUM COMBINING MARK TUKWENTIS
                                        if (0xa6f0 <= code && code <= 0xa6f1) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0xa806) {
                                    // Mn       SYLOTI NAGRI SIGN DVISVARA
                                    if (0xa802 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       SYLOTI NAGRI SIGN HASANTA
                                    if (0xa806 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    // Mn       SYLOTI NAGRI SIGN ANUSVARA
                                    if (0xa80b === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0xa8b4) {
                                if (code < 0xa827) {
                                    if (code < 0xa825) {
                                        // Mc   [2] SYLOTI NAGRI VOWEL SIGN A..SYLOTI NAGRI VOWEL SIGN I
                                        if (0xa823 <= code && code <= 0xa824) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] SYLOTI NAGRI VOWEL SIGN U..SYLOTI NAGRI VOWEL SIGN E
                                        if (0xa825 <= code && code <= 0xa826) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xa82c) {
                                        // Mc       SYLOTI NAGRI VOWEL SIGN OO
                                        if (0xa827 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xa880) {
                                        // Mn       SYLOTI NAGRI SIGN ALTERNATE HASANTA
                                        if (0xa82c === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] SAURASHTRA SIGN ANUSVARA..SAURASHTRA SIGN VISARGA
                                        if (0xa880 <= code && code <= 0xa881) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else if (code < 0xa8ff) {
                                if (code < 0xa8c4) {
                                    // Mc  [16] SAURASHTRA CONSONANT SIGN HAARU..SAURASHTRA VOWEL SIGN AU
                                    if (0xa8b4 <= code && code <= 0xa8c3) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0xa8e0) {
                                    // Mn   [2] SAURASHTRA SIGN VIRAMA..SAURASHTRA SIGN CANDRABINDU
                                    if (0xa8c4 <= code && code <= 0xa8c5) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn  [18] COMBINING DEVANAGARI DIGIT ZERO..COMBINING DEVANAGARI SIGN AVAGRAHA
                                    if (0xa8e0 <= code && code <= 0xa8f1) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0xa926) {
                                    // Mn       DEVANAGARI VOWEL SIGN AY
                                    if (0xa8ff === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xa947) {
                                    // Mn   [8] KAYAH LI VOWEL UE..KAYAH LI TONE CALYA PLOPHU
                                    if (0xa926 <= code && code <= 0xa92d) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn  [11] REJANG VOWEL SIGN I..REJANG CONSONANT SIGN R
                                    if (0xa947 <= code && code <= 0xa951) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    } else {
                        if (code < 0xaab2) {
                            if (code < 0xa9e5) {
                                if (code < 0xa9b4) {
                                    if (code < 0xa980) {
                                        if (code < 0xa960) {
                                            // Mc   [2] REJANG CONSONANT SIGN H..REJANG VIRAMA
                                            if (0xa952 <= code && code <= 0xa953) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Lo  [29] HANGUL CHOSEONG TIKEUT-MIEUM..HANGUL CHOSEONG SSANGYEORINHIEUH
                                            if (0xa960 <= code && code <= 0xa97c) return $lXl8C.CLUSTER_BREAK.L;
                                        }
                                    } else if (code < 0xa983) {
                                        // Mn   [3] JAVANESE SIGN PANYANGGA..JAVANESE SIGN LAYAR
                                        if (0xa980 <= code && code <= 0xa982) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc       JAVANESE SIGN WIGNYAN
                                        if (0xa983 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        // Mn       JAVANESE SIGN CECAK TELU
                                        if (0xa9b3 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0xa9ba) {
                                    if (code < 0xa9b6) {
                                        // Mc   [2] JAVANESE VOWEL SIGN TARUNG..JAVANESE VOWEL SIGN TOLONG
                                        if (0xa9b4 <= code && code <= 0xa9b5) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [4] JAVANESE VOWEL SIGN WULU..JAVANESE VOWEL SIGN SUKU MENDUT
                                        if (0xa9b6 <= code && code <= 0xa9b9) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xa9bc) {
                                        // Mc   [2] JAVANESE VOWEL SIGN TALING..JAVANESE VOWEL SIGN DIRGA MURE
                                        if (0xa9ba <= code && code <= 0xa9bb) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xa9be) {
                                        // Mn   [2] JAVANESE VOWEL SIGN PEPET..JAVANESE CONSONANT SIGN KERET
                                        if (0xa9bc <= code && code <= 0xa9bd) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [3] JAVANESE CONSONANT SIGN PENGKAL..JAVANESE PANGKON
                                        if (0xa9be <= code && code <= 0xa9c0) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else if (code < 0xaa35) {
                                if (code < 0xaa2f) {
                                    if (code < 0xaa29) {
                                        // Mn       MYANMAR SIGN SHAN SAW
                                        if (0xa9e5 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [6] CHAM VOWEL SIGN AA..CHAM VOWEL SIGN OE
                                        if (0xaa29 <= code && code <= 0xaa2e) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xaa31) {
                                        // Mc   [2] CHAM VOWEL SIGN O..CHAM VOWEL SIGN AI
                                        if (0xaa2f <= code && code <= 0xaa30) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xaa33) {
                                        // Mn   [2] CHAM VOWEL SIGN AU..CHAM VOWEL SIGN UE
                                        if (0xaa31 <= code && code <= 0xaa32) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] CHAM CONSONANT SIGN YA..CHAM CONSONANT SIGN RA
                                        if (0xaa33 <= code && code <= 0xaa34) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else {
                                if (code < 0xaa4d) {
                                    if (code < 0xaa43) {
                                        // Mn   [2] CHAM CONSONANT SIGN LA..CHAM CONSONANT SIGN WA
                                        if (0xaa35 <= code && code <= 0xaa36) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       CHAM CONSONANT SIGN FINAL NG
                                        if (0xaa43 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        // Mn       CHAM CONSONANT SIGN FINAL M
                                        if (0xaa4c === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0xaa7c) {
                                    // Mc       CHAM CONSONANT SIGN FINAL H
                                    if (0xaa4d === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       MYANMAR SIGN TAI LAING TONE-2
                                    if (0xaa7c === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    // Mn       TAI VIET MAI KANG
                                    if (0xaab0 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0xabe6) {
                            if (code < 0xaaec) {
                                if (code < 0xaabe) {
                                    if (code < 0xaab7) {
                                        // Mn   [3] TAI VIET VOWEL I..TAI VIET VOWEL U
                                        if (0xaab2 <= code && code <= 0xaab4) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] TAI VIET MAI KHIT..TAI VIET VOWEL IA
                                        if (0xaab7 <= code && code <= 0xaab8) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0xaac1) {
                                    // Mn   [2] TAI VIET VOWEL AM..TAI VIET TONE MAI EK
                                    if (0xaabe <= code && code <= 0xaabf) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       TAI VIET TONE MAI THO
                                    if (0xaac1 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    // Mc       MEETEI MAYEK VOWEL SIGN II
                                    if (0xaaeb === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else if (code < 0xaaf6) {
                                if (code < 0xaaee) {
                                    // Mn   [2] MEETEI MAYEK VOWEL SIGN UU..MEETEI MAYEK VOWEL SIGN AAI
                                    if (0xaaec <= code && code <= 0xaaed) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xaaf5) {
                                    // Mc   [2] MEETEI MAYEK VOWEL SIGN AU..MEETEI MAYEK VOWEL SIGN AAU
                                    if (0xaaee <= code && code <= 0xaaef) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mc       MEETEI MAYEK VOWEL SIGN VISARGA
                                    if (0xaaf5 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0xabe3) {
                                    // Mn       MEETEI MAYEK VIRAMA
                                    if (0xaaf6 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xabe5) {
                                    // Mc   [2] MEETEI MAYEK VOWEL SIGN ONAP..MEETEI MAYEK VOWEL SIGN INAP
                                    if (0xabe3 <= code && code <= 0xabe4) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       MEETEI MAYEK VOWEL SIGN ANAP
                                    if (0xabe5 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0xac00) {
                                if (code < 0xabe9) {
                                    if (code < 0xabe8) {
                                        // Mc   [2] MEETEI MAYEK VOWEL SIGN YENAP..MEETEI MAYEK VOWEL SIGN SOUNAP
                                        if (0xabe6 <= code && code <= 0xabe7) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       MEETEI MAYEK VOWEL SIGN UNAP
                                        if (0xabe8 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0xabec) {
                                    // Mc   [2] MEETEI MAYEK VOWEL SIGN CHEINAP..MEETEI MAYEK VOWEL SIGN NUNG
                                    if (0xabe9 <= code && code <= 0xabea) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mc       MEETEI MAYEK LUM IYEK
                                    if (0xabec === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       MEETEI MAYEK APUN IYEK
                                    if (0xabed === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else if (code < 0xac1d) {
                                if (code < 0xac01) {
                                    // Lo       HANGUL SYLLABLE GA
                                    if (0xac00 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xac1c) {
                                    // Lo  [27] HANGUL SYLLABLE GAG..HANGUL SYLLABLE GAH
                                    if (0xac01 <= code && code <= 0xac1b) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE GAE
                                    if (0xac1c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xac38) {
                                    // Lo  [27] HANGUL SYLLABLE GAEG..HANGUL SYLLABLE GAEH
                                    if (0xac1d <= code && code <= 0xac37) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xac39) {
                                    // Lo       HANGUL SYLLABLE GYA
                                    if (0xac38 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE GYAG..HANGUL SYLLABLE GYAH
                                    if (0xac39 <= code && code <= 0xac53) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    }
                }
            } else if (code < 0xb5a1) {
                if (code < 0xb0ed) {
                    if (code < 0xaea0) {
                        if (code < 0xad6d) {
                            if (code < 0xace0) {
                                if (code < 0xac8d) {
                                    if (code < 0xac70) {
                                        if (code < 0xac55) {
                                            // Lo       HANGUL SYLLABLE GYAE
                                            if (0xac54 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE GYAEG..HANGUL SYLLABLE GYAEH
                                            if (0xac55 <= code && code <= 0xac6f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xac71) {
                                            // Lo       HANGUL SYLLABLE GEO
                                            if (0xac70 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xac8c) {
                                            // Lo  [27] HANGUL SYLLABLE GEOG..HANGUL SYLLABLE GEOH
                                            if (0xac71 <= code && code <= 0xac8b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE GE
                                            if (0xac8c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xaca9) {
                                    if (code < 0xaca8) {
                                        // Lo  [27] HANGUL SYLLABLE GEG..HANGUL SYLLABLE GEH
                                        if (0xac8d <= code && code <= 0xaca7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GYEO
                                        if (0xaca8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xacc4) {
                                        // Lo  [27] HANGUL SYLLABLE GYEOG..HANGUL SYLLABLE GYEOH
                                        if (0xaca9 <= code && code <= 0xacc3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xacc5) {
                                        // Lo       HANGUL SYLLABLE GYE
                                        if (0xacc4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GYEG..HANGUL SYLLABLE GYEH
                                        if (0xacc5 <= code && code <= 0xacdf) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xad19) {
                                    if (code < 0xacfc) {
                                        if (code < 0xace1) {
                                            // Lo       HANGUL SYLLABLE GO
                                            if (0xace0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE GOG..HANGUL SYLLABLE GOH
                                            if (0xace1 <= code && code <= 0xacfb) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xacfd) {
                                            // Lo       HANGUL SYLLABLE GWA
                                            if (0xacfc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xad18) {
                                            // Lo  [27] HANGUL SYLLABLE GWAG..HANGUL SYLLABLE GWAH
                                            if (0xacfd <= code && code <= 0xad17) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE GWAE
                                            if (0xad18 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xad50) {
                                    if (code < 0xad34) {
                                        // Lo  [27] HANGUL SYLLABLE GWAEG..HANGUL SYLLABLE GWAEH
                                        if (0xad19 <= code && code <= 0xad33) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xad35) {
                                        // Lo       HANGUL SYLLABLE GOE
                                        if (0xad34 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GOEG..HANGUL SYLLABLE GOEH
                                        if (0xad35 <= code && code <= 0xad4f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xad51) {
                                        // Lo       HANGUL SYLLABLE GYO
                                        if (0xad50 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xad6c) {
                                        // Lo  [27] HANGUL SYLLABLE GYOG..HANGUL SYLLABLE GYOH
                                        if (0xad51 <= code && code <= 0xad6b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GU
                                        if (0xad6c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xadf9) {
                            if (code < 0xadc0) {
                                if (code < 0xad89) {
                                    if (code < 0xad88) {
                                        // Lo  [27] HANGUL SYLLABLE GUG..HANGUL SYLLABLE GUH
                                        if (0xad6d <= code && code <= 0xad87) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GWEO
                                        if (0xad88 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xada4) {
                                        // Lo  [27] HANGUL SYLLABLE GWEOG..HANGUL SYLLABLE GWEOH
                                        if (0xad89 <= code && code <= 0xada3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xada5) {
                                        // Lo       HANGUL SYLLABLE GWE
                                        if (0xada4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GWEG..HANGUL SYLLABLE GWEH
                                        if (0xada5 <= code && code <= 0xadbf) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xaddc) {
                                if (code < 0xadc1) {
                                    // Lo       HANGUL SYLLABLE GWI
                                    if (0xadc0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE GWIG..HANGUL SYLLABLE GWIH
                                    if (0xadc1 <= code && code <= 0xaddb) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xaddd) {
                                    // Lo       HANGUL SYLLABLE GYU
                                    if (0xaddc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xadf8) {
                                    // Lo  [27] HANGUL SYLLABLE GYUG..HANGUL SYLLABLE GYUH
                                    if (0xaddd <= code && code <= 0xadf7) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE GEU
                                    if (0xadf8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xae4c) {
                                if (code < 0xae15) {
                                    if (code < 0xae14) {
                                        // Lo  [27] HANGUL SYLLABLE GEUG..HANGUL SYLLABLE GEUH
                                        if (0xadf9 <= code && code <= 0xae13) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GYI
                                        if (0xae14 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xae30) {
                                        // Lo  [27] HANGUL SYLLABLE GYIG..HANGUL SYLLABLE GYIH
                                        if (0xae15 <= code && code <= 0xae2f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xae31) {
                                        // Lo       HANGUL SYLLABLE GI
                                        if (0xae30 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GIG..HANGUL SYLLABLE GIH
                                        if (0xae31 <= code && code <= 0xae4b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xae69) {
                                if (code < 0xae4d) {
                                    // Lo       HANGUL SYLLABLE GGA
                                    if (0xae4c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xae68) {
                                    // Lo  [27] HANGUL SYLLABLE GGAG..HANGUL SYLLABLE GGAH
                                    if (0xae4d <= code && code <= 0xae67) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE GGAE
                                    if (0xae68 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xae84) {
                                    // Lo  [27] HANGUL SYLLABLE GGAEG..HANGUL SYLLABLE GGAEH
                                    if (0xae69 <= code && code <= 0xae83) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xae85) {
                                    // Lo       HANGUL SYLLABLE GGYA
                                    if (0xae84 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE GGYAG..HANGUL SYLLABLE GGYAH
                                    if (0xae85 <= code && code <= 0xae9f) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else {
                        if (code < 0xafb9) {
                            if (code < 0xaf2c) {
                                if (code < 0xaed9) {
                                    if (code < 0xaebc) {
                                        if (code < 0xaea1) {
                                            // Lo       HANGUL SYLLABLE GGYAE
                                            if (0xaea0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE GGYAEG..HANGUL SYLLABLE GGYAEH
                                            if (0xaea1 <= code && code <= 0xaebb) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xaebd) {
                                            // Lo       HANGUL SYLLABLE GGEO
                                            if (0xaebc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xaed8) {
                                            // Lo  [27] HANGUL SYLLABLE GGEOG..HANGUL SYLLABLE GGEOH
                                            if (0xaebd <= code && code <= 0xaed7) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE GGE
                                            if (0xaed8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xaef5) {
                                    if (code < 0xaef4) {
                                        // Lo  [27] HANGUL SYLLABLE GGEG..HANGUL SYLLABLE GGEH
                                        if (0xaed9 <= code && code <= 0xaef3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GGYEO
                                        if (0xaef4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xaf10) {
                                        // Lo  [27] HANGUL SYLLABLE GGYEOG..HANGUL SYLLABLE GGYEOH
                                        if (0xaef5 <= code && code <= 0xaf0f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xaf11) {
                                        // Lo       HANGUL SYLLABLE GGYE
                                        if (0xaf10 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GGYEG..HANGUL SYLLABLE GGYEH
                                        if (0xaf11 <= code && code <= 0xaf2b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xaf65) {
                                    if (code < 0xaf48) {
                                        if (code < 0xaf2d) {
                                            // Lo       HANGUL SYLLABLE GGO
                                            if (0xaf2c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE GGOG..HANGUL SYLLABLE GGOH
                                            if (0xaf2d <= code && code <= 0xaf47) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xaf49) {
                                            // Lo       HANGUL SYLLABLE GGWA
                                            if (0xaf48 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xaf64) {
                                            // Lo  [27] HANGUL SYLLABLE GGWAG..HANGUL SYLLABLE GGWAH
                                            if (0xaf49 <= code && code <= 0xaf63) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE GGWAE
                                            if (0xaf64 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xaf9c) {
                                    if (code < 0xaf80) {
                                        // Lo  [27] HANGUL SYLLABLE GGWAEG..HANGUL SYLLABLE GGWAEH
                                        if (0xaf65 <= code && code <= 0xaf7f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xaf81) {
                                        // Lo       HANGUL SYLLABLE GGOE
                                        if (0xaf80 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GGOEG..HANGUL SYLLABLE GGOEH
                                        if (0xaf81 <= code && code <= 0xaf9b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xaf9d) {
                                        // Lo       HANGUL SYLLABLE GGYO
                                        if (0xaf9c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xafb8) {
                                        // Lo  [27] HANGUL SYLLABLE GGYOG..HANGUL SYLLABLE GGYOH
                                        if (0xaf9d <= code && code <= 0xafb7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GGU
                                        if (0xafb8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xb060) {
                            if (code < 0xb00c) {
                                if (code < 0xafd5) {
                                    if (code < 0xafd4) {
                                        // Lo  [27] HANGUL SYLLABLE GGUG..HANGUL SYLLABLE GGUH
                                        if (0xafb9 <= code && code <= 0xafd3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GGWEO
                                        if (0xafd4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xaff0) {
                                        // Lo  [27] HANGUL SYLLABLE GGWEOG..HANGUL SYLLABLE GGWEOH
                                        if (0xafd5 <= code && code <= 0xafef) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xaff1) {
                                        // Lo       HANGUL SYLLABLE GGWE
                                        if (0xaff0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GGWEG..HANGUL SYLLABLE GGWEH
                                        if (0xaff1 <= code && code <= 0xb00b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xb029) {
                                if (code < 0xb00d) {
                                    // Lo       HANGUL SYLLABLE GGWI
                                    if (0xb00c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xb028) {
                                    // Lo  [27] HANGUL SYLLABLE GGWIG..HANGUL SYLLABLE GGWIH
                                    if (0xb00d <= code && code <= 0xb027) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE GGYU
                                    if (0xb028 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb044) {
                                    // Lo  [27] HANGUL SYLLABLE GGYUG..HANGUL SYLLABLE GGYUH
                                    if (0xb029 <= code && code <= 0xb043) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb045) {
                                    // Lo       HANGUL SYLLABLE GGEU
                                    if (0xb044 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE GGEUG..HANGUL SYLLABLE GGEUH
                                    if (0xb045 <= code && code <= 0xb05f) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xb099) {
                                if (code < 0xb07c) {
                                    if (code < 0xb061) {
                                        // Lo       HANGUL SYLLABLE GGYI
                                        if (0xb060 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GGYIG..HANGUL SYLLABLE GGYIH
                                        if (0xb061 <= code && code <= 0xb07b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb07d) {
                                        // Lo       HANGUL SYLLABLE GGI
                                        if (0xb07c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb098) {
                                        // Lo  [27] HANGUL SYLLABLE GGIG..HANGUL SYLLABLE GGIH
                                        if (0xb07d <= code && code <= 0xb097) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE NA
                                        if (0xb098 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xb0d0) {
                                if (code < 0xb0b4) {
                                    // Lo  [27] HANGUL SYLLABLE NAG..HANGUL SYLLABLE NAH
                                    if (0xb099 <= code && code <= 0xb0b3) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb0b5) {
                                    // Lo       HANGUL SYLLABLE NAE
                                    if (0xb0b4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE NAEG..HANGUL SYLLABLE NAEH
                                    if (0xb0b5 <= code && code <= 0xb0cf) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb0d1) {
                                    // Lo       HANGUL SYLLABLE NYA
                                    if (0xb0d0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xb0ec) {
                                    // Lo  [27] HANGUL SYLLABLE NYAG..HANGUL SYLLABLE NYAH
                                    if (0xb0d1 <= code && code <= 0xb0eb) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE NYAE
                                    if (0xb0ec === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    }
                } else if (code < 0xb354) {
                    if (code < 0xb220) {
                        if (code < 0xb179) {
                            if (code < 0xb140) {
                                if (code < 0xb109) {
                                    if (code < 0xb108) {
                                        // Lo  [27] HANGUL SYLLABLE NYAEG..HANGUL SYLLABLE NYAEH
                                        if (0xb0ed <= code && code <= 0xb107) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE NEO
                                        if (0xb108 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb124) {
                                        // Lo  [27] HANGUL SYLLABLE NEOG..HANGUL SYLLABLE NEOH
                                        if (0xb109 <= code && code <= 0xb123) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb125) {
                                        // Lo       HANGUL SYLLABLE NE
                                        if (0xb124 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE NEG..HANGUL SYLLABLE NEH
                                        if (0xb125 <= code && code <= 0xb13f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xb15c) {
                                if (code < 0xb141) {
                                    // Lo       HANGUL SYLLABLE NYEO
                                    if (0xb140 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE NYEOG..HANGUL SYLLABLE NYEOH
                                    if (0xb141 <= code && code <= 0xb15b) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb15d) {
                                    // Lo       HANGUL SYLLABLE NYE
                                    if (0xb15c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xb178) {
                                    // Lo  [27] HANGUL SYLLABLE NYEG..HANGUL SYLLABLE NYEH
                                    if (0xb15d <= code && code <= 0xb177) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE NO
                                    if (0xb178 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xb1cc) {
                                if (code < 0xb195) {
                                    if (code < 0xb194) {
                                        // Lo  [27] HANGUL SYLLABLE NOG..HANGUL SYLLABLE NOH
                                        if (0xb179 <= code && code <= 0xb193) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE NWA
                                        if (0xb194 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb1b0) {
                                        // Lo  [27] HANGUL SYLLABLE NWAG..HANGUL SYLLABLE NWAH
                                        if (0xb195 <= code && code <= 0xb1af) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb1b1) {
                                        // Lo       HANGUL SYLLABLE NWAE
                                        if (0xb1b0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE NWAEG..HANGUL SYLLABLE NWAEH
                                        if (0xb1b1 <= code && code <= 0xb1cb) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xb1e9) {
                                if (code < 0xb1cd) {
                                    // Lo       HANGUL SYLLABLE NOE
                                    if (0xb1cc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xb1e8) {
                                    // Lo  [27] HANGUL SYLLABLE NOEG..HANGUL SYLLABLE NOEH
                                    if (0xb1cd <= code && code <= 0xb1e7) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE NYO
                                    if (0xb1e8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb204) {
                                    // Lo  [27] HANGUL SYLLABLE NYOG..HANGUL SYLLABLE NYOH
                                    if (0xb1e9 <= code && code <= 0xb203) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb205) {
                                    // Lo       HANGUL SYLLABLE NU
                                    if (0xb204 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE NUG..HANGUL SYLLABLE NUH
                                    if (0xb205 <= code && code <= 0xb21f) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else if (code < 0xb2ad) {
                        if (code < 0xb259) {
                            if (code < 0xb23c) {
                                if (code < 0xb221) {
                                    // Lo       HANGUL SYLLABLE NWEO
                                    if (0xb220 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE NWEOG..HANGUL SYLLABLE NWEOH
                                    if (0xb221 <= code && code <= 0xb23b) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb23d) {
                                    // Lo       HANGUL SYLLABLE NWE
                                    if (0xb23c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xb258) {
                                    // Lo  [27] HANGUL SYLLABLE NWEG..HANGUL SYLLABLE NWEH
                                    if (0xb23d <= code && code <= 0xb257) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE NWI
                                    if (0xb258 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else if (code < 0xb290) {
                            if (code < 0xb274) {
                                // Lo  [27] HANGUL SYLLABLE NWIG..HANGUL SYLLABLE NWIH
                                if (0xb259 <= code && code <= 0xb273) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else if (code < 0xb275) {
                                // Lo       HANGUL SYLLABLE NYU
                                if (0xb274 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE NYUG..HANGUL SYLLABLE NYUH
                                if (0xb275 <= code && code <= 0xb28f) return $lXl8C.CLUSTER_BREAK.LVT;
                            }
                        } else {
                            if (code < 0xb291) {
                                // Lo       HANGUL SYLLABLE NEU
                                if (0xb290 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else if (code < 0xb2ac) {
                                // Lo  [27] HANGUL SYLLABLE NEUG..HANGUL SYLLABLE NEUH
                                if (0xb291 <= code && code <= 0xb2ab) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE NYI
                                if (0xb2ac === code) return $lXl8C.CLUSTER_BREAK.LV;
                            }
                        }
                    } else {
                        if (code < 0xb300) {
                            if (code < 0xb2c9) {
                                if (code < 0xb2c8) {
                                    // Lo  [27] HANGUL SYLLABLE NYIG..HANGUL SYLLABLE NYIH
                                    if (0xb2ad <= code && code <= 0xb2c7) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE NI
                                    if (0xb2c8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb2e4) {
                                    // Lo  [27] HANGUL SYLLABLE NIG..HANGUL SYLLABLE NIH
                                    if (0xb2c9 <= code && code <= 0xb2e3) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb2e5) {
                                    // Lo       HANGUL SYLLABLE DA
                                    if (0xb2e4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DAG..HANGUL SYLLABLE DAH
                                    if (0xb2e5 <= code && code <= 0xb2ff) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else if (code < 0xb31d) {
                            if (code < 0xb301) {
                                // Lo       HANGUL SYLLABLE DAE
                                if (0xb300 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else if (code < 0xb31c) {
                                // Lo  [27] HANGUL SYLLABLE DAEG..HANGUL SYLLABLE DAEH
                                if (0xb301 <= code && code <= 0xb31b) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE DYA
                                if (0xb31c === code) return $lXl8C.CLUSTER_BREAK.LV;
                            }
                        } else {
                            if (code < 0xb338) {
                                // Lo  [27] HANGUL SYLLABLE DYAG..HANGUL SYLLABLE DYAH
                                if (0xb31d <= code && code <= 0xb337) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else if (code < 0xb339) {
                                // Lo       HANGUL SYLLABLE DYAE
                                if (0xb338 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE DYAEG..HANGUL SYLLABLE DYAEH
                                if (0xb339 <= code && code <= 0xb353) return $lXl8C.CLUSTER_BREAK.LVT;
                            }
                        }
                    }
                } else {
                    if (code < 0xb46d) {
                        if (code < 0xb3e0) {
                            if (code < 0xb38d) {
                                if (code < 0xb370) {
                                    if (code < 0xb355) {
                                        // Lo       HANGUL SYLLABLE DEO
                                        if (0xb354 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE DEOG..HANGUL SYLLABLE DEOH
                                        if (0xb355 <= code && code <= 0xb36f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb371) {
                                        // Lo       HANGUL SYLLABLE DE
                                        if (0xb370 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb38c) {
                                        // Lo  [27] HANGUL SYLLABLE DEG..HANGUL SYLLABLE DEH
                                        if (0xb371 <= code && code <= 0xb38b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE DYEO
                                        if (0xb38c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xb3a9) {
                                if (code < 0xb3a8) {
                                    // Lo  [27] HANGUL SYLLABLE DYEOG..HANGUL SYLLABLE DYEOH
                                    if (0xb38d <= code && code <= 0xb3a7) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE DYE
                                    if (0xb3a8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb3c4) {
                                    // Lo  [27] HANGUL SYLLABLE DYEG..HANGUL SYLLABLE DYEH
                                    if (0xb3a9 <= code && code <= 0xb3c3) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb3c5) {
                                    // Lo       HANGUL SYLLABLE DO
                                    if (0xb3c4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DOG..HANGUL SYLLABLE DOH
                                    if (0xb3c5 <= code && code <= 0xb3df) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xb419) {
                                if (code < 0xb3fc) {
                                    if (code < 0xb3e1) {
                                        // Lo       HANGUL SYLLABLE DWA
                                        if (0xb3e0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE DWAG..HANGUL SYLLABLE DWAH
                                        if (0xb3e1 <= code && code <= 0xb3fb) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb3fd) {
                                        // Lo       HANGUL SYLLABLE DWAE
                                        if (0xb3fc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb418) {
                                        // Lo  [27] HANGUL SYLLABLE DWAEG..HANGUL SYLLABLE DWAEH
                                        if (0xb3fd <= code && code <= 0xb417) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE DOE
                                        if (0xb418 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xb450) {
                                if (code < 0xb434) {
                                    // Lo  [27] HANGUL SYLLABLE DOEG..HANGUL SYLLABLE DOEH
                                    if (0xb419 <= code && code <= 0xb433) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb435) {
                                    // Lo       HANGUL SYLLABLE DYO
                                    if (0xb434 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DYOG..HANGUL SYLLABLE DYOH
                                    if (0xb435 <= code && code <= 0xb44f) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb451) {
                                    // Lo       HANGUL SYLLABLE DU
                                    if (0xb450 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xb46c) {
                                    // Lo  [27] HANGUL SYLLABLE DUG..HANGUL SYLLABLE DUH
                                    if (0xb451 <= code && code <= 0xb46b) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE DWEO
                                    if (0xb46c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    } else if (code < 0xb514) {
                        if (code < 0xb4c0) {
                            if (code < 0xb489) {
                                if (code < 0xb488) {
                                    // Lo  [27] HANGUL SYLLABLE DWEOG..HANGUL SYLLABLE DWEOH
                                    if (0xb46d <= code && code <= 0xb487) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE DWE
                                    if (0xb488 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb4a4) {
                                    // Lo  [27] HANGUL SYLLABLE DWEG..HANGUL SYLLABLE DWEH
                                    if (0xb489 <= code && code <= 0xb4a3) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb4a5) {
                                    // Lo       HANGUL SYLLABLE DWI
                                    if (0xb4a4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DWIG..HANGUL SYLLABLE DWIH
                                    if (0xb4a5 <= code && code <= 0xb4bf) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else if (code < 0xb4dd) {
                            if (code < 0xb4c1) {
                                // Lo       HANGUL SYLLABLE DYU
                                if (0xb4c0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else if (code < 0xb4dc) {
                                // Lo  [27] HANGUL SYLLABLE DYUG..HANGUL SYLLABLE DYUH
                                if (0xb4c1 <= code && code <= 0xb4db) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE DEU
                                if (0xb4dc === code) return $lXl8C.CLUSTER_BREAK.LV;
                            }
                        } else {
                            if (code < 0xb4f8) {
                                // Lo  [27] HANGUL SYLLABLE DEUG..HANGUL SYLLABLE DEUH
                                if (0xb4dd <= code && code <= 0xb4f7) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else if (code < 0xb4f9) {
                                // Lo       HANGUL SYLLABLE DYI
                                if (0xb4f8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE DYIG..HANGUL SYLLABLE DYIH
                                if (0xb4f9 <= code && code <= 0xb513) return $lXl8C.CLUSTER_BREAK.LVT;
                            }
                        }
                    } else {
                        if (code < 0xb54d) {
                            if (code < 0xb530) {
                                if (code < 0xb515) {
                                    // Lo       HANGUL SYLLABLE DI
                                    if (0xb514 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DIG..HANGUL SYLLABLE DIH
                                    if (0xb515 <= code && code <= 0xb52f) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb531) {
                                    // Lo       HANGUL SYLLABLE DDA
                                    if (0xb530 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xb54c) {
                                    // Lo  [27] HANGUL SYLLABLE DDAG..HANGUL SYLLABLE DDAH
                                    if (0xb531 <= code && code <= 0xb54b) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE DDAE
                                    if (0xb54c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else if (code < 0xb584) {
                            if (code < 0xb568) {
                                // Lo  [27] HANGUL SYLLABLE DDAEG..HANGUL SYLLABLE DDAEH
                                if (0xb54d <= code && code <= 0xb567) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else if (code < 0xb569) {
                                // Lo       HANGUL SYLLABLE DDYA
                                if (0xb568 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE DDYAG..HANGUL SYLLABLE DDYAH
                                if (0xb569 <= code && code <= 0xb583) return $lXl8C.CLUSTER_BREAK.LVT;
                            }
                        } else {
                            if (code < 0xb585) {
                                // Lo       HANGUL SYLLABLE DDYAE
                                if (0xb584 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else if (code < 0xb5a0) {
                                // Lo  [27] HANGUL SYLLABLE DDYAEG..HANGUL SYLLABLE DDYAEH
                                if (0xb585 <= code && code <= 0xb59f) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE DDEO
                                if (0xb5a0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            }
                        }
                    }
                }
            } else {
                if (code < 0xba55) {
                    if (code < 0xb808) {
                        if (code < 0xb6d4) {
                            if (code < 0xb62d) {
                                if (code < 0xb5f4) {
                                    if (code < 0xb5bd) {
                                        if (code < 0xb5bc) {
                                            // Lo  [27] HANGUL SYLLABLE DDEOG..HANGUL SYLLABLE DDEOH
                                            if (0xb5a1 <= code && code <= 0xb5bb) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE DDE
                                            if (0xb5bc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xb5d8) {
                                            // Lo  [27] HANGUL SYLLABLE DDEG..HANGUL SYLLABLE DDEH
                                            if (0xb5bd <= code && code <= 0xb5d7) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xb5d9) {
                                            // Lo       HANGUL SYLLABLE DDYEO
                                            if (0xb5d8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE DDYEOG..HANGUL SYLLABLE DDYEOH
                                            if (0xb5d9 <= code && code <= 0xb5f3) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xb610) {
                                    if (code < 0xb5f5) {
                                        // Lo       HANGUL SYLLABLE DDYE
                                        if (0xb5f4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE DDYEG..HANGUL SYLLABLE DDYEH
                                        if (0xb5f5 <= code && code <= 0xb60f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb611) {
                                        // Lo       HANGUL SYLLABLE DDO
                                        if (0xb610 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb62c) {
                                        // Lo  [27] HANGUL SYLLABLE DDOG..HANGUL SYLLABLE DDOH
                                        if (0xb611 <= code && code <= 0xb62b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE DDWA
                                        if (0xb62c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else {
                                if (code < 0xb680) {
                                    if (code < 0xb649) {
                                        if (code < 0xb648) {
                                            // Lo  [27] HANGUL SYLLABLE DDWAG..HANGUL SYLLABLE DDWAH
                                            if (0xb62d <= code && code <= 0xb647) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE DDWAE
                                            if (0xb648 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xb664) {
                                            // Lo  [27] HANGUL SYLLABLE DDWAEG..HANGUL SYLLABLE DDWAEH
                                            if (0xb649 <= code && code <= 0xb663) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xb665) {
                                            // Lo       HANGUL SYLLABLE DDOE
                                            if (0xb664 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE DDOEG..HANGUL SYLLABLE DDOEH
                                            if (0xb665 <= code && code <= 0xb67f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xb69d) {
                                    if (code < 0xb681) {
                                        // Lo       HANGUL SYLLABLE DDYO
                                        if (0xb680 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb69c) {
                                        // Lo  [27] HANGUL SYLLABLE DDYOG..HANGUL SYLLABLE DDYOH
                                        if (0xb681 <= code && code <= 0xb69b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE DDU
                                        if (0xb69c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb6b8) {
                                        // Lo  [27] HANGUL SYLLABLE DDUG..HANGUL SYLLABLE DDUH
                                        if (0xb69d <= code && code <= 0xb6b7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb6b9) {
                                        // Lo       HANGUL SYLLABLE DDWEO
                                        if (0xb6b8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE DDWEOG..HANGUL SYLLABLE DDWEOH
                                        if (0xb6b9 <= code && code <= 0xb6d3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            }
                        } else if (code < 0xb761) {
                            if (code < 0xb70d) {
                                if (code < 0xb6f0) {
                                    if (code < 0xb6d5) {
                                        // Lo       HANGUL SYLLABLE DDWE
                                        if (0xb6d4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE DDWEG..HANGUL SYLLABLE DDWEH
                                        if (0xb6d5 <= code && code <= 0xb6ef) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb6f1) {
                                        // Lo       HANGUL SYLLABLE DDWI
                                        if (0xb6f0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb70c) {
                                        // Lo  [27] HANGUL SYLLABLE DDWIG..HANGUL SYLLABLE DDWIH
                                        if (0xb6f1 <= code && code <= 0xb70b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE DDYU
                                        if (0xb70c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xb744) {
                                if (code < 0xb728) {
                                    // Lo  [27] HANGUL SYLLABLE DDYUG..HANGUL SYLLABLE DDYUH
                                    if (0xb70d <= code && code <= 0xb727) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb729) {
                                    // Lo       HANGUL SYLLABLE DDEU
                                    if (0xb728 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DDEUG..HANGUL SYLLABLE DDEUH
                                    if (0xb729 <= code && code <= 0xb743) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb745) {
                                    // Lo       HANGUL SYLLABLE DDYI
                                    if (0xb744 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xb760) {
                                    // Lo  [27] HANGUL SYLLABLE DDYIG..HANGUL SYLLABLE DDYIH
                                    if (0xb745 <= code && code <= 0xb75f) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE DDI
                                    if (0xb760 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xb7b4) {
                                if (code < 0xb77d) {
                                    if (code < 0xb77c) {
                                        // Lo  [27] HANGUL SYLLABLE DDIG..HANGUL SYLLABLE DDIH
                                        if (0xb761 <= code && code <= 0xb77b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE RA
                                        if (0xb77c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb798) {
                                        // Lo  [27] HANGUL SYLLABLE RAG..HANGUL SYLLABLE RAH
                                        if (0xb77d <= code && code <= 0xb797) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb799) {
                                        // Lo       HANGUL SYLLABLE RAE
                                        if (0xb798 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE RAEG..HANGUL SYLLABLE RAEH
                                        if (0xb799 <= code && code <= 0xb7b3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xb7d1) {
                                if (code < 0xb7b5) {
                                    // Lo       HANGUL SYLLABLE RYA
                                    if (0xb7b4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xb7d0) {
                                    // Lo  [27] HANGUL SYLLABLE RYAG..HANGUL SYLLABLE RYAH
                                    if (0xb7b5 <= code && code <= 0xb7cf) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE RYAE
                                    if (0xb7d0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb7ec) {
                                    // Lo  [27] HANGUL SYLLABLE RYAEG..HANGUL SYLLABLE RYAEH
                                    if (0xb7d1 <= code && code <= 0xb7eb) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb7ed) {
                                    // Lo       HANGUL SYLLABLE REO
                                    if (0xb7ec === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE REOG..HANGUL SYLLABLE REOH
                                    if (0xb7ed <= code && code <= 0xb807) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else {
                        if (code < 0xb921) {
                            if (code < 0xb894) {
                                if (code < 0xb841) {
                                    if (code < 0xb824) {
                                        if (code < 0xb809) {
                                            // Lo       HANGUL SYLLABLE RE
                                            if (0xb808 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE REG..HANGUL SYLLABLE REH
                                            if (0xb809 <= code && code <= 0xb823) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xb825) {
                                            // Lo       HANGUL SYLLABLE RYEO
                                            if (0xb824 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xb840) {
                                            // Lo  [27] HANGUL SYLLABLE RYEOG..HANGUL SYLLABLE RYEOH
                                            if (0xb825 <= code && code <= 0xb83f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE RYE
                                            if (0xb840 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xb85d) {
                                    if (code < 0xb85c) {
                                        // Lo  [27] HANGUL SYLLABLE RYEG..HANGUL SYLLABLE RYEH
                                        if (0xb841 <= code && code <= 0xb85b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE RO
                                        if (0xb85c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb878) {
                                        // Lo  [27] HANGUL SYLLABLE ROG..HANGUL SYLLABLE ROH
                                        if (0xb85d <= code && code <= 0xb877) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb879) {
                                        // Lo       HANGUL SYLLABLE RWA
                                        if (0xb878 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE RWAG..HANGUL SYLLABLE RWAH
                                        if (0xb879 <= code && code <= 0xb893) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xb8cd) {
                                    if (code < 0xb8b0) {
                                        if (code < 0xb895) {
                                            // Lo       HANGUL SYLLABLE RWAE
                                            if (0xb894 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE RWAEG..HANGUL SYLLABLE RWAEH
                                            if (0xb895 <= code && code <= 0xb8af) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xb8b1) {
                                            // Lo       HANGUL SYLLABLE ROE
                                            if (0xb8b0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xb8cc) {
                                            // Lo  [27] HANGUL SYLLABLE ROEG..HANGUL SYLLABLE ROEH
                                            if (0xb8b1 <= code && code <= 0xb8cb) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE RYO
                                            if (0xb8cc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xb904) {
                                    if (code < 0xb8e8) {
                                        // Lo  [27] HANGUL SYLLABLE RYOG..HANGUL SYLLABLE RYOH
                                        if (0xb8cd <= code && code <= 0xb8e7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb8e9) {
                                        // Lo       HANGUL SYLLABLE RU
                                        if (0xb8e8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE RUG..HANGUL SYLLABLE RUH
                                        if (0xb8e9 <= code && code <= 0xb903) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb905) {
                                        // Lo       HANGUL SYLLABLE RWEO
                                        if (0xb904 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb920) {
                                        // Lo  [27] HANGUL SYLLABLE RWEOG..HANGUL SYLLABLE RWEOH
                                        if (0xb905 <= code && code <= 0xb91f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE RWE
                                        if (0xb920 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xb9c8) {
                            if (code < 0xb974) {
                                if (code < 0xb93d) {
                                    if (code < 0xb93c) {
                                        // Lo  [27] HANGUL SYLLABLE RWEG..HANGUL SYLLABLE RWEH
                                        if (0xb921 <= code && code <= 0xb93b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE RWI
                                        if (0xb93c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb958) {
                                        // Lo  [27] HANGUL SYLLABLE RWIG..HANGUL SYLLABLE RWIH
                                        if (0xb93d <= code && code <= 0xb957) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb959) {
                                        // Lo       HANGUL SYLLABLE RYU
                                        if (0xb958 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE RYUG..HANGUL SYLLABLE RYUH
                                        if (0xb959 <= code && code <= 0xb973) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xb991) {
                                if (code < 0xb975) {
                                    // Lo       HANGUL SYLLABLE REU
                                    if (0xb974 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xb990) {
                                    // Lo  [27] HANGUL SYLLABLE REUG..HANGUL SYLLABLE REUH
                                    if (0xb975 <= code && code <= 0xb98f) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE RYI
                                    if (0xb990 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb9ac) {
                                    // Lo  [27] HANGUL SYLLABLE RYIG..HANGUL SYLLABLE RYIH
                                    if (0xb991 <= code && code <= 0xb9ab) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb9ad) {
                                    // Lo       HANGUL SYLLABLE RI
                                    if (0xb9ac === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE RIG..HANGUL SYLLABLE RIH
                                    if (0xb9ad <= code && code <= 0xb9c7) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xba01) {
                                if (code < 0xb9e4) {
                                    if (code < 0xb9c9) {
                                        // Lo       HANGUL SYLLABLE MA
                                        if (0xb9c8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE MAG..HANGUL SYLLABLE MAH
                                        if (0xb9c9 <= code && code <= 0xb9e3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb9e5) {
                                        // Lo       HANGUL SYLLABLE MAE
                                        if (0xb9e4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xba00) {
                                        // Lo  [27] HANGUL SYLLABLE MAEG..HANGUL SYLLABLE MAEH
                                        if (0xb9e5 <= code && code <= 0xb9ff) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE MYA
                                        if (0xba00 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xba38) {
                                if (code < 0xba1c) {
                                    // Lo  [27] HANGUL SYLLABLE MYAG..HANGUL SYLLABLE MYAH
                                    if (0xba01 <= code && code <= 0xba1b) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xba1d) {
                                    // Lo       HANGUL SYLLABLE MYAE
                                    if (0xba1c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE MYAEG..HANGUL SYLLABLE MYAEH
                                    if (0xba1d <= code && code <= 0xba37) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xba39) {
                                    // Lo       HANGUL SYLLABLE MEO
                                    if (0xba38 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xba54) {
                                    // Lo  [27] HANGUL SYLLABLE MEOG..HANGUL SYLLABLE MEOH
                                    if (0xba39 <= code && code <= 0xba53) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE ME
                                    if (0xba54 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    }
                } else if (code < 0xbcbc) {
                    if (code < 0xbb88) {
                        if (code < 0xbae1) {
                            if (code < 0xbaa8) {
                                if (code < 0xba71) {
                                    if (code < 0xba70) {
                                        // Lo  [27] HANGUL SYLLABLE MEG..HANGUL SYLLABLE MEH
                                        if (0xba55 <= code && code <= 0xba6f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE MYEO
                                        if (0xba70 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xba8c) {
                                        // Lo  [27] HANGUL SYLLABLE MYEOG..HANGUL SYLLABLE MYEOH
                                        if (0xba71 <= code && code <= 0xba8b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xba8d) {
                                        // Lo       HANGUL SYLLABLE MYE
                                        if (0xba8c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE MYEG..HANGUL SYLLABLE MYEH
                                        if (0xba8d <= code && code <= 0xbaa7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xbac4) {
                                if (code < 0xbaa9) {
                                    // Lo       HANGUL SYLLABLE MO
                                    if (0xbaa8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE MOG..HANGUL SYLLABLE MOH
                                    if (0xbaa9 <= code && code <= 0xbac3) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xbac5) {
                                    // Lo       HANGUL SYLLABLE MWA
                                    if (0xbac4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xbae0) {
                                    // Lo  [27] HANGUL SYLLABLE MWAG..HANGUL SYLLABLE MWAH
                                    if (0xbac5 <= code && code <= 0xbadf) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE MWAE
                                    if (0xbae0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xbb34) {
                                if (code < 0xbafd) {
                                    if (code < 0xbafc) {
                                        // Lo  [27] HANGUL SYLLABLE MWAEG..HANGUL SYLLABLE MWAEH
                                        if (0xbae1 <= code && code <= 0xbafb) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE MOE
                                        if (0xbafc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xbb18) {
                                        // Lo  [27] HANGUL SYLLABLE MOEG..HANGUL SYLLABLE MOEH
                                        if (0xbafd <= code && code <= 0xbb17) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xbb19) {
                                        // Lo       HANGUL SYLLABLE MYO
                                        if (0xbb18 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE MYOG..HANGUL SYLLABLE MYOH
                                        if (0xbb19 <= code && code <= 0xbb33) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xbb51) {
                                if (code < 0xbb35) {
                                    // Lo       HANGUL SYLLABLE MU
                                    if (0xbb34 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xbb50) {
                                    // Lo  [27] HANGUL SYLLABLE MUG..HANGUL SYLLABLE MUH
                                    if (0xbb35 <= code && code <= 0xbb4f) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE MWEO
                                    if (0xbb50 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xbb6c) {
                                    // Lo  [27] HANGUL SYLLABLE MWEOG..HANGUL SYLLABLE MWEOH
                                    if (0xbb51 <= code && code <= 0xbb6b) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xbb6d) {
                                    // Lo       HANGUL SYLLABLE MWE
                                    if (0xbb6c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE MWEG..HANGUL SYLLABLE MWEH
                                    if (0xbb6d <= code && code <= 0xbb87) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else if (code < 0xbc15) {
                        if (code < 0xbbc1) {
                            if (code < 0xbba4) {
                                if (code < 0xbb89) {
                                    // Lo       HANGUL SYLLABLE MWI
                                    if (0xbb88 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE MWIG..HANGUL SYLLABLE MWIH
                                    if (0xbb89 <= code && code <= 0xbba3) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xbba5) {
                                    // Lo       HANGUL SYLLABLE MYU
                                    if (0xbba4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xbbc0) {
                                    // Lo  [27] HANGUL SYLLABLE MYUG..HANGUL SYLLABLE MYUH
                                    if (0xbba5 <= code && code <= 0xbbbf) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE MEU
                                    if (0xbbc0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else if (code < 0xbbf8) {
                            if (code < 0xbbdc) {
                                // Lo  [27] HANGUL SYLLABLE MEUG..HANGUL SYLLABLE MEUH
                                if (0xbbc1 <= code && code <= 0xbbdb) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else if (code < 0xbbdd) {
                                // Lo       HANGUL SYLLABLE MYI
                                if (0xbbdc === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE MYIG..HANGUL SYLLABLE MYIH
                                if (0xbbdd <= code && code <= 0xbbf7) return $lXl8C.CLUSTER_BREAK.LVT;
                            }
                        } else {
                            if (code < 0xbbf9) {
                                // Lo       HANGUL SYLLABLE MI
                                if (0xbbf8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else if (code < 0xbc14) {
                                // Lo  [27] HANGUL SYLLABLE MIG..HANGUL SYLLABLE MIH
                                if (0xbbf9 <= code && code <= 0xbc13) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE BA
                                if (0xbc14 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            }
                        }
                    } else {
                        if (code < 0xbc68) {
                            if (code < 0xbc31) {
                                if (code < 0xbc30) {
                                    // Lo  [27] HANGUL SYLLABLE BAG..HANGUL SYLLABLE BAH
                                    if (0xbc15 <= code && code <= 0xbc2f) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE BAE
                                    if (0xbc30 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xbc4c) {
                                    // Lo  [27] HANGUL SYLLABLE BAEG..HANGUL SYLLABLE BAEH
                                    if (0xbc31 <= code && code <= 0xbc4b) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xbc4d) {
                                    // Lo       HANGUL SYLLABLE BYA
                                    if (0xbc4c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE BYAG..HANGUL SYLLABLE BYAH
                                    if (0xbc4d <= code && code <= 0xbc67) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else if (code < 0xbc85) {
                            if (code < 0xbc69) {
                                // Lo       HANGUL SYLLABLE BYAE
                                if (0xbc68 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else if (code < 0xbc84) {
                                // Lo  [27] HANGUL SYLLABLE BYAEG..HANGUL SYLLABLE BYAEH
                                if (0xbc69 <= code && code <= 0xbc83) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE BEO
                                if (0xbc84 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            }
                        } else {
                            if (code < 0xbca0) {
                                // Lo  [27] HANGUL SYLLABLE BEOG..HANGUL SYLLABLE BEOH
                                if (0xbc85 <= code && code <= 0xbc9f) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else if (code < 0xbca1) {
                                // Lo       HANGUL SYLLABLE BE
                                if (0xbca0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE BEG..HANGUL SYLLABLE BEH
                                if (0xbca1 <= code && code <= 0xbcbb) return $lXl8C.CLUSTER_BREAK.LVT;
                            }
                        }
                    }
                } else {
                    if (code < 0xbdd5) {
                        if (code < 0xbd48) {
                            if (code < 0xbcf5) {
                                if (code < 0xbcd8) {
                                    if (code < 0xbcbd) {
                                        // Lo       HANGUL SYLLABLE BYEO
                                        if (0xbcbc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE BYEOG..HANGUL SYLLABLE BYEOH
                                        if (0xbcbd <= code && code <= 0xbcd7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xbcd9) {
                                        // Lo       HANGUL SYLLABLE BYE
                                        if (0xbcd8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xbcf4) {
                                        // Lo  [27] HANGUL SYLLABLE BYEG..HANGUL SYLLABLE BYEH
                                        if (0xbcd9 <= code && code <= 0xbcf3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE BO
                                        if (0xbcf4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xbd11) {
                                if (code < 0xbd10) {
                                    // Lo  [27] HANGUL SYLLABLE BOG..HANGUL SYLLABLE BOH
                                    if (0xbcf5 <= code && code <= 0xbd0f) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE BWA
                                    if (0xbd10 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xbd2c) {
                                    // Lo  [27] HANGUL SYLLABLE BWAG..HANGUL SYLLABLE BWAH
                                    if (0xbd11 <= code && code <= 0xbd2b) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xbd2d) {
                                    // Lo       HANGUL SYLLABLE BWAE
                                    if (0xbd2c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE BWAEG..HANGUL SYLLABLE BWAEH
                                    if (0xbd2d <= code && code <= 0xbd47) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xbd81) {
                                if (code < 0xbd64) {
                                    if (code < 0xbd49) {
                                        // Lo       HANGUL SYLLABLE BOE
                                        if (0xbd48 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE BOEG..HANGUL SYLLABLE BOEH
                                        if (0xbd49 <= code && code <= 0xbd63) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xbd65) {
                                        // Lo       HANGUL SYLLABLE BYO
                                        if (0xbd64 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xbd80) {
                                        // Lo  [27] HANGUL SYLLABLE BYOG..HANGUL SYLLABLE BYOH
                                        if (0xbd65 <= code && code <= 0xbd7f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE BU
                                        if (0xbd80 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xbdb8) {
                                if (code < 0xbd9c) {
                                    // Lo  [27] HANGUL SYLLABLE BUG..HANGUL SYLLABLE BUH
                                    if (0xbd81 <= code && code <= 0xbd9b) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xbd9d) {
                                    // Lo       HANGUL SYLLABLE BWEO
                                    if (0xbd9c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE BWEOG..HANGUL SYLLABLE BWEOH
                                    if (0xbd9d <= code && code <= 0xbdb7) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xbdb9) {
                                    // Lo       HANGUL SYLLABLE BWE
                                    if (0xbdb8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xbdd4) {
                                    // Lo  [27] HANGUL SYLLABLE BWEG..HANGUL SYLLABLE BWEH
                                    if (0xbdb9 <= code && code <= 0xbdd3) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE BWI
                                    if (0xbdd4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    } else if (code < 0xbe7c) {
                        if (code < 0xbe28) {
                            if (code < 0xbdf1) {
                                if (code < 0xbdf0) {
                                    // Lo  [27] HANGUL SYLLABLE BWIG..HANGUL SYLLABLE BWIH
                                    if (0xbdd5 <= code && code <= 0xbdef) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE BYU
                                    if (0xbdf0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xbe0c) {
                                    // Lo  [27] HANGUL SYLLABLE BYUG..HANGUL SYLLABLE BYUH
                                    if (0xbdf1 <= code && code <= 0xbe0b) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xbe0d) {
                                    // Lo       HANGUL SYLLABLE BEU
                                    if (0xbe0c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE BEUG..HANGUL SYLLABLE BEUH
                                    if (0xbe0d <= code && code <= 0xbe27) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else if (code < 0xbe45) {
                            if (code < 0xbe29) {
                                // Lo       HANGUL SYLLABLE BYI
                                if (0xbe28 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else if (code < 0xbe44) {
                                // Lo  [27] HANGUL SYLLABLE BYIG..HANGUL SYLLABLE BYIH
                                if (0xbe29 <= code && code <= 0xbe43) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE BI
                                if (0xbe44 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            }
                        } else {
                            if (code < 0xbe60) {
                                // Lo  [27] HANGUL SYLLABLE BIG..HANGUL SYLLABLE BIH
                                if (0xbe45 <= code && code <= 0xbe5f) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else if (code < 0xbe61) {
                                // Lo       HANGUL SYLLABLE BBA
                                if (0xbe60 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE BBAG..HANGUL SYLLABLE BBAH
                                if (0xbe61 <= code && code <= 0xbe7b) return $lXl8C.CLUSTER_BREAK.LVT;
                            }
                        }
                    } else {
                        if (code < 0xbeb5) {
                            if (code < 0xbe98) {
                                if (code < 0xbe7d) {
                                    // Lo       HANGUL SYLLABLE BBAE
                                    if (0xbe7c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE BBAEG..HANGUL SYLLABLE BBAEH
                                    if (0xbe7d <= code && code <= 0xbe97) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xbe99) {
                                    // Lo       HANGUL SYLLABLE BBYA
                                    if (0xbe98 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xbeb4) {
                                    // Lo  [27] HANGUL SYLLABLE BBYAG..HANGUL SYLLABLE BBYAH
                                    if (0xbe99 <= code && code <= 0xbeb3) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE BBYAE
                                    if (0xbeb4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else if (code < 0xbeec) {
                            if (code < 0xbed0) {
                                // Lo  [27] HANGUL SYLLABLE BBYAEG..HANGUL SYLLABLE BBYAEH
                                if (0xbeb5 <= code && code <= 0xbecf) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else if (code < 0xbed1) {
                                // Lo       HANGUL SYLLABLE BBEO
                                if (0xbed0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE BBEOG..HANGUL SYLLABLE BBEOH
                                if (0xbed1 <= code && code <= 0xbeeb) return $lXl8C.CLUSTER_BREAK.LVT;
                            }
                        } else {
                            if (code < 0xbeed) {
                                // Lo       HANGUL SYLLABLE BBE
                                if (0xbeec === code) return $lXl8C.CLUSTER_BREAK.LV;
                            } else if (code < 0xbf08) {
                                // Lo  [27] HANGUL SYLLABLE BBEG..HANGUL SYLLABLE BBEH
                                if (0xbeed <= code && code <= 0xbf07) return $lXl8C.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE BBYEO
                                if (0xbf08 === code) return $lXl8C.CLUSTER_BREAK.LV;
                            }
                        }
                    }
                }
            }
        } else {
            if (code < 0xd1d8) {
                if (code < 0xc870) {
                    if (code < 0xc3bc) {
                        if (code < 0xc155) {
                            if (code < 0xc03c) {
                                if (code < 0xbf95) {
                                    if (code < 0xbf5c) {
                                        if (code < 0xbf25) {
                                            if (code < 0xbf24) {
                                                // Lo  [27] HANGUL SYLLABLE BBYEOG..HANGUL SYLLABLE BBYEOH
                                                if (0xbf09 <= code && code <= 0xbf23) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE BBYE
                                                if (0xbf24 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xbf40) {
                                                // Lo  [27] HANGUL SYLLABLE BBYEG..HANGUL SYLLABLE BBYEH
                                                if (0xbf25 <= code && code <= 0xbf3f) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xbf41) {
                                                // Lo       HANGUL SYLLABLE BBO
                                                if (0xbf40 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE BBOG..HANGUL SYLLABLE BBOH
                                                if (0xbf41 <= code && code <= 0xbf5b) return $lXl8C.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xbf78) {
                                        if (code < 0xbf5d) {
                                            // Lo       HANGUL SYLLABLE BBWA
                                            if (0xbf5c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE BBWAG..HANGUL SYLLABLE BBWAH
                                            if (0xbf5d <= code && code <= 0xbf77) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xbf79) {
                                            // Lo       HANGUL SYLLABLE BBWAE
                                            if (0xbf78 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xbf94) {
                                            // Lo  [27] HANGUL SYLLABLE BBWAEG..HANGUL SYLLABLE BBWAEH
                                            if (0xbf79 <= code && code <= 0xbf93) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE BBOE
                                            if (0xbf94 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else {
                                    if (code < 0xbfe8) {
                                        if (code < 0xbfb1) {
                                            if (code < 0xbfb0) {
                                                // Lo  [27] HANGUL SYLLABLE BBOEG..HANGUL SYLLABLE BBOEH
                                                if (0xbf95 <= code && code <= 0xbfaf) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE BBYO
                                                if (0xbfb0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xbfcc) {
                                                // Lo  [27] HANGUL SYLLABLE BBYOG..HANGUL SYLLABLE BBYOH
                                                if (0xbfb1 <= code && code <= 0xbfcb) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xbfcd) {
                                                // Lo       HANGUL SYLLABLE BBU
                                                if (0xbfcc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE BBUG..HANGUL SYLLABLE BBUH
                                                if (0xbfcd <= code && code <= 0xbfe7) return $lXl8C.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xc005) {
                                        if (code < 0xbfe9) {
                                            // Lo       HANGUL SYLLABLE BBWEO
                                            if (0xbfe8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc004) {
                                            // Lo  [27] HANGUL SYLLABLE BBWEOG..HANGUL SYLLABLE BBWEOH
                                            if (0xbfe9 <= code && code <= 0xc003) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE BBWE
                                            if (0xc004 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc020) {
                                            // Lo  [27] HANGUL SYLLABLE BBWEG..HANGUL SYLLABLE BBWEH
                                            if (0xc005 <= code && code <= 0xc01f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc021) {
                                            // Lo       HANGUL SYLLABLE BBWI
                                            if (0xc020 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE BBWIG..HANGUL SYLLABLE BBWIH
                                            if (0xc021 <= code && code <= 0xc03b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                }
                            } else if (code < 0xc0c8) {
                                if (code < 0xc075) {
                                    if (code < 0xc058) {
                                        if (code < 0xc03d) {
                                            // Lo       HANGUL SYLLABLE BBYU
                                            if (0xc03c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE BBYUG..HANGUL SYLLABLE BBYUH
                                            if (0xc03d <= code && code <= 0xc057) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc059) {
                                            // Lo       HANGUL SYLLABLE BBEU
                                            if (0xc058 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc074) {
                                            // Lo  [27] HANGUL SYLLABLE BBEUG..HANGUL SYLLABLE BBEUH
                                            if (0xc059 <= code && code <= 0xc073) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE BBYI
                                            if (0xc074 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xc091) {
                                    if (code < 0xc090) {
                                        // Lo  [27] HANGUL SYLLABLE BBYIG..HANGUL SYLLABLE BBYIH
                                        if (0xc075 <= code && code <= 0xc08f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE BBI
                                        if (0xc090 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc0ac) {
                                        // Lo  [27] HANGUL SYLLABLE BBIG..HANGUL SYLLABLE BBIH
                                        if (0xc091 <= code && code <= 0xc0ab) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc0ad) {
                                        // Lo       HANGUL SYLLABLE SA
                                        if (0xc0ac === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SAG..HANGUL SYLLABLE SAH
                                        if (0xc0ad <= code && code <= 0xc0c7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xc101) {
                                    if (code < 0xc0e4) {
                                        if (code < 0xc0c9) {
                                            // Lo       HANGUL SYLLABLE SAE
                                            if (0xc0c8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SAEG..HANGUL SYLLABLE SAEH
                                            if (0xc0c9 <= code && code <= 0xc0e3) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc0e5) {
                                            // Lo       HANGUL SYLLABLE SYA
                                            if (0xc0e4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc100) {
                                            // Lo  [27] HANGUL SYLLABLE SYAG..HANGUL SYLLABLE SYAH
                                            if (0xc0e5 <= code && code <= 0xc0ff) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SYAE
                                            if (0xc100 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xc138) {
                                    if (code < 0xc11c) {
                                        // Lo  [27] HANGUL SYLLABLE SYAEG..HANGUL SYLLABLE SYAEH
                                        if (0xc101 <= code && code <= 0xc11b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc11d) {
                                        // Lo       HANGUL SYLLABLE SEO
                                        if (0xc11c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SEOG..HANGUL SYLLABLE SEOH
                                        if (0xc11d <= code && code <= 0xc137) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc139) {
                                        // Lo       HANGUL SYLLABLE SE
                                        if (0xc138 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc154) {
                                        // Lo  [27] HANGUL SYLLABLE SEG..HANGUL SYLLABLE SEH
                                        if (0xc139 <= code && code <= 0xc153) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SYEO
                                        if (0xc154 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else {
                            if (code < 0xc288) {
                                if (code < 0xc1e1) {
                                    if (code < 0xc1a8) {
                                        if (code < 0xc171) {
                                            if (code < 0xc170) {
                                                // Lo  [27] HANGUL SYLLABLE SYEOG..HANGUL SYLLABLE SYEOH
                                                if (0xc155 <= code && code <= 0xc16f) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE SYE
                                                if (0xc170 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xc18c) {
                                                // Lo  [27] HANGUL SYLLABLE SYEG..HANGUL SYLLABLE SYEH
                                                if (0xc171 <= code && code <= 0xc18b) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xc18d) {
                                                // Lo       HANGUL SYLLABLE SO
                                                if (0xc18c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE SOG..HANGUL SYLLABLE SOH
                                                if (0xc18d <= code && code <= 0xc1a7) return $lXl8C.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xc1c4) {
                                        if (code < 0xc1a9) {
                                            // Lo       HANGUL SYLLABLE SWA
                                            if (0xc1a8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SWAG..HANGUL SYLLABLE SWAH
                                            if (0xc1a9 <= code && code <= 0xc1c3) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc1c5) {
                                            // Lo       HANGUL SYLLABLE SWAE
                                            if (0xc1c4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc1e0) {
                                            // Lo  [27] HANGUL SYLLABLE SWAEG..HANGUL SYLLABLE SWAEH
                                            if (0xc1c5 <= code && code <= 0xc1df) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SOE
                                            if (0xc1e0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else {
                                    if (code < 0xc234) {
                                        if (code < 0xc1fd) {
                                            if (code < 0xc1fc) {
                                                // Lo  [27] HANGUL SYLLABLE SOEG..HANGUL SYLLABLE SOEH
                                                if (0xc1e1 <= code && code <= 0xc1fb) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE SYO
                                                if (0xc1fc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xc218) {
                                                // Lo  [27] HANGUL SYLLABLE SYOG..HANGUL SYLLABLE SYOH
                                                if (0xc1fd <= code && code <= 0xc217) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xc219) {
                                                // Lo       HANGUL SYLLABLE SU
                                                if (0xc218 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE SUG..HANGUL SYLLABLE SUH
                                                if (0xc219 <= code && code <= 0xc233) return $lXl8C.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xc251) {
                                        if (code < 0xc235) {
                                            // Lo       HANGUL SYLLABLE SWEO
                                            if (0xc234 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc250) {
                                            // Lo  [27] HANGUL SYLLABLE SWEOG..HANGUL SYLLABLE SWEOH
                                            if (0xc235 <= code && code <= 0xc24f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SWE
                                            if (0xc250 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc26c) {
                                            // Lo  [27] HANGUL SYLLABLE SWEG..HANGUL SYLLABLE SWEH
                                            if (0xc251 <= code && code <= 0xc26b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc26d) {
                                            // Lo       HANGUL SYLLABLE SWI
                                            if (0xc26c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SWIG..HANGUL SYLLABLE SWIH
                                            if (0xc26d <= code && code <= 0xc287) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                }
                            } else if (code < 0xc315) {
                                if (code < 0xc2c1) {
                                    if (code < 0xc2a4) {
                                        if (code < 0xc289) {
                                            // Lo       HANGUL SYLLABLE SYU
                                            if (0xc288 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SYUG..HANGUL SYLLABLE SYUH
                                            if (0xc289 <= code && code <= 0xc2a3) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc2a5) {
                                            // Lo       HANGUL SYLLABLE SEU
                                            if (0xc2a4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc2c0) {
                                            // Lo  [27] HANGUL SYLLABLE SEUG..HANGUL SYLLABLE SEUH
                                            if (0xc2a5 <= code && code <= 0xc2bf) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SYI
                                            if (0xc2c0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xc2f8) {
                                    if (code < 0xc2dc) {
                                        // Lo  [27] HANGUL SYLLABLE SYIG..HANGUL SYLLABLE SYIH
                                        if (0xc2c1 <= code && code <= 0xc2db) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc2dd) {
                                        // Lo       HANGUL SYLLABLE SI
                                        if (0xc2dc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SIG..HANGUL SYLLABLE SIH
                                        if (0xc2dd <= code && code <= 0xc2f7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc2f9) {
                                        // Lo       HANGUL SYLLABLE SSA
                                        if (0xc2f8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc314) {
                                        // Lo  [27] HANGUL SYLLABLE SSAG..HANGUL SYLLABLE SSAH
                                        if (0xc2f9 <= code && code <= 0xc313) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SSAE
                                        if (0xc314 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else {
                                if (code < 0xc368) {
                                    if (code < 0xc331) {
                                        if (code < 0xc330) {
                                            // Lo  [27] HANGUL SYLLABLE SSAEG..HANGUL SYLLABLE SSAEH
                                            if (0xc315 <= code && code <= 0xc32f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SSYA
                                            if (0xc330 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc34c) {
                                            // Lo  [27] HANGUL SYLLABLE SSYAG..HANGUL SYLLABLE SSYAH
                                            if (0xc331 <= code && code <= 0xc34b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc34d) {
                                            // Lo       HANGUL SYLLABLE SSYAE
                                            if (0xc34c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SSYAEG..HANGUL SYLLABLE SSYAEH
                                            if (0xc34d <= code && code <= 0xc367) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xc385) {
                                    if (code < 0xc369) {
                                        // Lo       HANGUL SYLLABLE SSEO
                                        if (0xc368 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc384) {
                                        // Lo  [27] HANGUL SYLLABLE SSEOG..HANGUL SYLLABLE SSEOH
                                        if (0xc369 <= code && code <= 0xc383) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SSE
                                        if (0xc384 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc3a0) {
                                        // Lo  [27] HANGUL SYLLABLE SSEG..HANGUL SYLLABLE SSEH
                                        if (0xc385 <= code && code <= 0xc39f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc3a1) {
                                        // Lo       HANGUL SYLLABLE SSYEO
                                        if (0xc3a0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SSYEOG..HANGUL SYLLABLE SSYEOH
                                        if (0xc3a1 <= code && code <= 0xc3bb) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            }
                        }
                    } else if (code < 0xc609) {
                        if (code < 0xc4d5) {
                            if (code < 0xc448) {
                                if (code < 0xc3f5) {
                                    if (code < 0xc3d8) {
                                        if (code < 0xc3bd) {
                                            // Lo       HANGUL SYLLABLE SSYE
                                            if (0xc3bc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SSYEG..HANGUL SYLLABLE SSYEH
                                            if (0xc3bd <= code && code <= 0xc3d7) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc3d9) {
                                            // Lo       HANGUL SYLLABLE SSO
                                            if (0xc3d8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc3f4) {
                                            // Lo  [27] HANGUL SYLLABLE SSOG..HANGUL SYLLABLE SSOH
                                            if (0xc3d9 <= code && code <= 0xc3f3) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SSWA
                                            if (0xc3f4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xc411) {
                                    if (code < 0xc410) {
                                        // Lo  [27] HANGUL SYLLABLE SSWAG..HANGUL SYLLABLE SSWAH
                                        if (0xc3f5 <= code && code <= 0xc40f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SSWAE
                                        if (0xc410 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc42c) {
                                        // Lo  [27] HANGUL SYLLABLE SSWAEG..HANGUL SYLLABLE SSWAEH
                                        if (0xc411 <= code && code <= 0xc42b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc42d) {
                                        // Lo       HANGUL SYLLABLE SSOE
                                        if (0xc42c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SSOEG..HANGUL SYLLABLE SSOEH
                                        if (0xc42d <= code && code <= 0xc447) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xc481) {
                                    if (code < 0xc464) {
                                        if (code < 0xc449) {
                                            // Lo       HANGUL SYLLABLE SSYO
                                            if (0xc448 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SSYOG..HANGUL SYLLABLE SSYOH
                                            if (0xc449 <= code && code <= 0xc463) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc465) {
                                            // Lo       HANGUL SYLLABLE SSU
                                            if (0xc464 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc480) {
                                            // Lo  [27] HANGUL SYLLABLE SSUG..HANGUL SYLLABLE SSUH
                                            if (0xc465 <= code && code <= 0xc47f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SSWEO
                                            if (0xc480 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xc4b8) {
                                    if (code < 0xc49c) {
                                        // Lo  [27] HANGUL SYLLABLE SSWEOG..HANGUL SYLLABLE SSWEOH
                                        if (0xc481 <= code && code <= 0xc49b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc49d) {
                                        // Lo       HANGUL SYLLABLE SSWE
                                        if (0xc49c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SSWEG..HANGUL SYLLABLE SSWEH
                                        if (0xc49d <= code && code <= 0xc4b7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc4b9) {
                                        // Lo       HANGUL SYLLABLE SSWI
                                        if (0xc4b8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc4d4) {
                                        // Lo  [27] HANGUL SYLLABLE SSWIG..HANGUL SYLLABLE SSWIH
                                        if (0xc4b9 <= code && code <= 0xc4d3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SSYU
                                        if (0xc4d4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xc57c) {
                            if (code < 0xc528) {
                                if (code < 0xc4f1) {
                                    if (code < 0xc4f0) {
                                        // Lo  [27] HANGUL SYLLABLE SSYUG..HANGUL SYLLABLE SSYUH
                                        if (0xc4d5 <= code && code <= 0xc4ef) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SSEU
                                        if (0xc4f0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc50c) {
                                        // Lo  [27] HANGUL SYLLABLE SSEUG..HANGUL SYLLABLE SSEUH
                                        if (0xc4f1 <= code && code <= 0xc50b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc50d) {
                                        // Lo       HANGUL SYLLABLE SSYI
                                        if (0xc50c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SSYIG..HANGUL SYLLABLE SSYIH
                                        if (0xc50d <= code && code <= 0xc527) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xc545) {
                                if (code < 0xc529) {
                                    // Lo       HANGUL SYLLABLE SSI
                                    if (0xc528 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xc544) {
                                    // Lo  [27] HANGUL SYLLABLE SSIG..HANGUL SYLLABLE SSIH
                                    if (0xc529 <= code && code <= 0xc543) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE A
                                    if (0xc544 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xc560) {
                                    // Lo  [27] HANGUL SYLLABLE AG..HANGUL SYLLABLE AH
                                    if (0xc545 <= code && code <= 0xc55f) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xc561) {
                                    // Lo       HANGUL SYLLABLE AE
                                    if (0xc560 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE AEG..HANGUL SYLLABLE AEH
                                    if (0xc561 <= code && code <= 0xc57b) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xc5b5) {
                                if (code < 0xc598) {
                                    if (code < 0xc57d) {
                                        // Lo       HANGUL SYLLABLE YA
                                        if (0xc57c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE YAG..HANGUL SYLLABLE YAH
                                        if (0xc57d <= code && code <= 0xc597) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc599) {
                                        // Lo       HANGUL SYLLABLE YAE
                                        if (0xc598 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc5b4) {
                                        // Lo  [27] HANGUL SYLLABLE YAEG..HANGUL SYLLABLE YAEH
                                        if (0xc599 <= code && code <= 0xc5b3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE EO
                                        if (0xc5b4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xc5ec) {
                                if (code < 0xc5d0) {
                                    // Lo  [27] HANGUL SYLLABLE EOG..HANGUL SYLLABLE EOH
                                    if (0xc5b5 <= code && code <= 0xc5cf) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xc5d1) {
                                    // Lo       HANGUL SYLLABLE E
                                    if (0xc5d0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE EG..HANGUL SYLLABLE EH
                                    if (0xc5d1 <= code && code <= 0xc5eb) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xc5ed) {
                                    // Lo       HANGUL SYLLABLE YEO
                                    if (0xc5ec === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xc608) {
                                    // Lo  [27] HANGUL SYLLABLE YEOG..HANGUL SYLLABLE YEOH
                                    if (0xc5ed <= code && code <= 0xc607) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE YE
                                    if (0xc608 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    } else {
                        if (code < 0xc73c) {
                            if (code < 0xc695) {
                                if (code < 0xc65c) {
                                    if (code < 0xc625) {
                                        if (code < 0xc624) {
                                            // Lo  [27] HANGUL SYLLABLE YEG..HANGUL SYLLABLE YEH
                                            if (0xc609 <= code && code <= 0xc623) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE O
                                            if (0xc624 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc640) {
                                            // Lo  [27] HANGUL SYLLABLE OG..HANGUL SYLLABLE OH
                                            if (0xc625 <= code && code <= 0xc63f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc641) {
                                            // Lo       HANGUL SYLLABLE WA
                                            if (0xc640 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE WAG..HANGUL SYLLABLE WAH
                                            if (0xc641 <= code && code <= 0xc65b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xc678) {
                                    if (code < 0xc65d) {
                                        // Lo       HANGUL SYLLABLE WAE
                                        if (0xc65c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE WAEG..HANGUL SYLLABLE WAEH
                                        if (0xc65d <= code && code <= 0xc677) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc679) {
                                        // Lo       HANGUL SYLLABLE OE
                                        if (0xc678 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc694) {
                                        // Lo  [27] HANGUL SYLLABLE OEG..HANGUL SYLLABLE OEH
                                        if (0xc679 <= code && code <= 0xc693) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE YO
                                        if (0xc694 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else {
                                if (code < 0xc6e8) {
                                    if (code < 0xc6b1) {
                                        if (code < 0xc6b0) {
                                            // Lo  [27] HANGUL SYLLABLE YOG..HANGUL SYLLABLE YOH
                                            if (0xc695 <= code && code <= 0xc6af) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE U
                                            if (0xc6b0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc6cc) {
                                            // Lo  [27] HANGUL SYLLABLE UG..HANGUL SYLLABLE UH
                                            if (0xc6b1 <= code && code <= 0xc6cb) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc6cd) {
                                            // Lo       HANGUL SYLLABLE WEO
                                            if (0xc6cc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE WEOG..HANGUL SYLLABLE WEOH
                                            if (0xc6cd <= code && code <= 0xc6e7) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xc705) {
                                    if (code < 0xc6e9) {
                                        // Lo       HANGUL SYLLABLE WE
                                        if (0xc6e8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc704) {
                                        // Lo  [27] HANGUL SYLLABLE WEG..HANGUL SYLLABLE WEH
                                        if (0xc6e9 <= code && code <= 0xc703) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE WI
                                        if (0xc704 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc720) {
                                        // Lo  [27] HANGUL SYLLABLE WIG..HANGUL SYLLABLE WIH
                                        if (0xc705 <= code && code <= 0xc71f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc721) {
                                        // Lo       HANGUL SYLLABLE YU
                                        if (0xc720 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE YUG..HANGUL SYLLABLE YUH
                                        if (0xc721 <= code && code <= 0xc73b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            }
                        } else if (code < 0xc7c9) {
                            if (code < 0xc775) {
                                if (code < 0xc758) {
                                    if (code < 0xc73d) {
                                        // Lo       HANGUL SYLLABLE EU
                                        if (0xc73c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE EUG..HANGUL SYLLABLE EUH
                                        if (0xc73d <= code && code <= 0xc757) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc759) {
                                        // Lo       HANGUL SYLLABLE YI
                                        if (0xc758 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc774) {
                                        // Lo  [27] HANGUL SYLLABLE YIG..HANGUL SYLLABLE YIH
                                        if (0xc759 <= code && code <= 0xc773) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE I
                                        if (0xc774 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xc7ac) {
                                if (code < 0xc790) {
                                    // Lo  [27] HANGUL SYLLABLE IG..HANGUL SYLLABLE IH
                                    if (0xc775 <= code && code <= 0xc78f) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xc791) {
                                    // Lo       HANGUL SYLLABLE JA
                                    if (0xc790 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE JAG..HANGUL SYLLABLE JAH
                                    if (0xc791 <= code && code <= 0xc7ab) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xc7ad) {
                                    // Lo       HANGUL SYLLABLE JAE
                                    if (0xc7ac === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xc7c8) {
                                    // Lo  [27] HANGUL SYLLABLE JAEG..HANGUL SYLLABLE JAEH
                                    if (0xc7ad <= code && code <= 0xc7c7) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE JYA
                                    if (0xc7c8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xc81c) {
                                if (code < 0xc7e5) {
                                    if (code < 0xc7e4) {
                                        // Lo  [27] HANGUL SYLLABLE JYAG..HANGUL SYLLABLE JYAH
                                        if (0xc7c9 <= code && code <= 0xc7e3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE JYAE
                                        if (0xc7e4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc800) {
                                        // Lo  [27] HANGUL SYLLABLE JYAEG..HANGUL SYLLABLE JYAEH
                                        if (0xc7e5 <= code && code <= 0xc7ff) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc801) {
                                        // Lo       HANGUL SYLLABLE JEO
                                        if (0xc800 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE JEOG..HANGUL SYLLABLE JEOH
                                        if (0xc801 <= code && code <= 0xc81b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xc839) {
                                if (code < 0xc81d) {
                                    // Lo       HANGUL SYLLABLE JE
                                    if (0xc81c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xc838) {
                                    // Lo  [27] HANGUL SYLLABLE JEG..HANGUL SYLLABLE JEH
                                    if (0xc81d <= code && code <= 0xc837) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE JYEO
                                    if (0xc838 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xc854) {
                                    // Lo  [27] HANGUL SYLLABLE JYEOG..HANGUL SYLLABLE JYEOH
                                    if (0xc839 <= code && code <= 0xc853) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xc855) {
                                    // Lo       HANGUL SYLLABLE JYE
                                    if (0xc854 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE JYEG..HANGUL SYLLABLE JYEH
                                    if (0xc855 <= code && code <= 0xc86f) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    }
                } else {
                    if (code < 0xcd24) {
                        if (code < 0xcabd) {
                            if (code < 0xc989) {
                                if (code < 0xc8fc) {
                                    if (code < 0xc8a9) {
                                        if (code < 0xc88c) {
                                            if (code < 0xc871) {
                                                // Lo       HANGUL SYLLABLE JO
                                                if (0xc870 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE JOG..HANGUL SYLLABLE JOH
                                                if (0xc871 <= code && code <= 0xc88b) return $lXl8C.CLUSTER_BREAK.LVT;
                                            }
                                        } else {
                                            if (code < 0xc88d) {
                                                // Lo       HANGUL SYLLABLE JWA
                                                if (0xc88c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            } else if (code < 0xc8a8) {
                                                // Lo  [27] HANGUL SYLLABLE JWAG..HANGUL SYLLABLE JWAH
                                                if (0xc88d <= code && code <= 0xc8a7) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE JWAE
                                                if (0xc8a8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            }
                                        }
                                    } else if (code < 0xc8c5) {
                                        if (code < 0xc8c4) {
                                            // Lo  [27] HANGUL SYLLABLE JWAEG..HANGUL SYLLABLE JWAEH
                                            if (0xc8a9 <= code && code <= 0xc8c3) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JOE
                                            if (0xc8c4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc8e0) {
                                            // Lo  [27] HANGUL SYLLABLE JOEG..HANGUL SYLLABLE JOEH
                                            if (0xc8c5 <= code && code <= 0xc8df) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc8e1) {
                                            // Lo       HANGUL SYLLABLE JYO
                                            if (0xc8e0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JYOG..HANGUL SYLLABLE JYOH
                                            if (0xc8e1 <= code && code <= 0xc8fb) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else {
                                    if (code < 0xc935) {
                                        if (code < 0xc918) {
                                            if (code < 0xc8fd) {
                                                // Lo       HANGUL SYLLABLE JU
                                                if (0xc8fc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE JUG..HANGUL SYLLABLE JUH
                                                if (0xc8fd <= code && code <= 0xc917) return $lXl8C.CLUSTER_BREAK.LVT;
                                            }
                                        } else {
                                            if (code < 0xc919) {
                                                // Lo       HANGUL SYLLABLE JWEO
                                                if (0xc918 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            } else if (code < 0xc934) {
                                                // Lo  [27] HANGUL SYLLABLE JWEOG..HANGUL SYLLABLE JWEOH
                                                if (0xc919 <= code && code <= 0xc933) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE JWE
                                                if (0xc934 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            }
                                        }
                                    } else if (code < 0xc96c) {
                                        if (code < 0xc950) {
                                            // Lo  [27] HANGUL SYLLABLE JWEG..HANGUL SYLLABLE JWEH
                                            if (0xc935 <= code && code <= 0xc94f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc951) {
                                            // Lo       HANGUL SYLLABLE JWI
                                            if (0xc950 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JWIG..HANGUL SYLLABLE JWIH
                                            if (0xc951 <= code && code <= 0xc96b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc96d) {
                                            // Lo       HANGUL SYLLABLE JYU
                                            if (0xc96c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc988) {
                                            // Lo  [27] HANGUL SYLLABLE JYUG..HANGUL SYLLABLE JYUH
                                            if (0xc96d <= code && code <= 0xc987) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JEU
                                            if (0xc988 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                }
                            } else if (code < 0xca30) {
                                if (code < 0xc9dc) {
                                    if (code < 0xc9a5) {
                                        if (code < 0xc9a4) {
                                            // Lo  [27] HANGUL SYLLABLE JEUG..HANGUL SYLLABLE JEUH
                                            if (0xc989 <= code && code <= 0xc9a3) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JYI
                                            if (0xc9a4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc9c0) {
                                            // Lo  [27] HANGUL SYLLABLE JYIG..HANGUL SYLLABLE JYIH
                                            if (0xc9a5 <= code && code <= 0xc9bf) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc9c1) {
                                            // Lo       HANGUL SYLLABLE JI
                                            if (0xc9c0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JIG..HANGUL SYLLABLE JIH
                                            if (0xc9c1 <= code && code <= 0xc9db) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xc9f9) {
                                    if (code < 0xc9dd) {
                                        // Lo       HANGUL SYLLABLE JJA
                                        if (0xc9dc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc9f8) {
                                        // Lo  [27] HANGUL SYLLABLE JJAG..HANGUL SYLLABLE JJAH
                                        if (0xc9dd <= code && code <= 0xc9f7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE JJAE
                                        if (0xc9f8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xca14) {
                                        // Lo  [27] HANGUL SYLLABLE JJAEG..HANGUL SYLLABLE JJAEH
                                        if (0xc9f9 <= code && code <= 0xca13) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xca15) {
                                        // Lo       HANGUL SYLLABLE JJYA
                                        if (0xca14 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE JJYAG..HANGUL SYLLABLE JJYAH
                                        if (0xca15 <= code && code <= 0xca2f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xca69) {
                                    if (code < 0xca4c) {
                                        if (code < 0xca31) {
                                            // Lo       HANGUL SYLLABLE JJYAE
                                            if (0xca30 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JJYAEG..HANGUL SYLLABLE JJYAEH
                                            if (0xca31 <= code && code <= 0xca4b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xca4d) {
                                            // Lo       HANGUL SYLLABLE JJEO
                                            if (0xca4c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xca68) {
                                            // Lo  [27] HANGUL SYLLABLE JJEOG..HANGUL SYLLABLE JJEOH
                                            if (0xca4d <= code && code <= 0xca67) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JJE
                                            if (0xca68 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xcaa0) {
                                    if (code < 0xca84) {
                                        // Lo  [27] HANGUL SYLLABLE JJEG..HANGUL SYLLABLE JJEH
                                        if (0xca69 <= code && code <= 0xca83) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xca85) {
                                        // Lo       HANGUL SYLLABLE JJYEO
                                        if (0xca84 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE JJYEOG..HANGUL SYLLABLE JJYEOH
                                        if (0xca85 <= code && code <= 0xca9f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xcaa1) {
                                        // Lo       HANGUL SYLLABLE JJYE
                                        if (0xcaa0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xcabc) {
                                        // Lo  [27] HANGUL SYLLABLE JJYEG..HANGUL SYLLABLE JJYEH
                                        if (0xcaa1 <= code && code <= 0xcabb) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE JJO
                                        if (0xcabc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else {
                            if (code < 0xcbf0) {
                                if (code < 0xcb49) {
                                    if (code < 0xcb10) {
                                        if (code < 0xcad9) {
                                            if (code < 0xcad8) {
                                                // Lo  [27] HANGUL SYLLABLE JJOG..HANGUL SYLLABLE JJOH
                                                if (0xcabd <= code && code <= 0xcad7) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE JJWA
                                                if (0xcad8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xcaf4) {
                                                // Lo  [27] HANGUL SYLLABLE JJWAG..HANGUL SYLLABLE JJWAH
                                                if (0xcad9 <= code && code <= 0xcaf3) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xcaf5) {
                                                // Lo       HANGUL SYLLABLE JJWAE
                                                if (0xcaf4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE JJWAEG..HANGUL SYLLABLE JJWAEH
                                                if (0xcaf5 <= code && code <= 0xcb0f) return $lXl8C.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xcb2c) {
                                        if (code < 0xcb11) {
                                            // Lo       HANGUL SYLLABLE JJOE
                                            if (0xcb10 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JJOEG..HANGUL SYLLABLE JJOEH
                                            if (0xcb11 <= code && code <= 0xcb2b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xcb2d) {
                                            // Lo       HANGUL SYLLABLE JJYO
                                            if (0xcb2c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xcb48) {
                                            // Lo  [27] HANGUL SYLLABLE JJYOG..HANGUL SYLLABLE JJYOH
                                            if (0xcb2d <= code && code <= 0xcb47) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JJU
                                            if (0xcb48 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else {
                                    if (code < 0xcb9c) {
                                        if (code < 0xcb65) {
                                            if (code < 0xcb64) {
                                                // Lo  [27] HANGUL SYLLABLE JJUG..HANGUL SYLLABLE JJUH
                                                if (0xcb49 <= code && code <= 0xcb63) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE JJWEO
                                                if (0xcb64 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xcb80) {
                                                // Lo  [27] HANGUL SYLLABLE JJWEOG..HANGUL SYLLABLE JJWEOH
                                                if (0xcb65 <= code && code <= 0xcb7f) return $lXl8C.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xcb81) {
                                                // Lo       HANGUL SYLLABLE JJWE
                                                if (0xcb80 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE JJWEG..HANGUL SYLLABLE JJWEH
                                                if (0xcb81 <= code && code <= 0xcb9b) return $lXl8C.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xcbb9) {
                                        if (code < 0xcb9d) {
                                            // Lo       HANGUL SYLLABLE JJWI
                                            if (0xcb9c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xcbb8) {
                                            // Lo  [27] HANGUL SYLLABLE JJWIG..HANGUL SYLLABLE JJWIH
                                            if (0xcb9d <= code && code <= 0xcbb7) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JJYU
                                            if (0xcbb8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xcbd4) {
                                            // Lo  [27] HANGUL SYLLABLE JJYUG..HANGUL SYLLABLE JJYUH
                                            if (0xcbb9 <= code && code <= 0xcbd3) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xcbd5) {
                                            // Lo       HANGUL SYLLABLE JJEU
                                            if (0xcbd4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JJEUG..HANGUL SYLLABLE JJEUH
                                            if (0xcbd5 <= code && code <= 0xcbef) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                }
                            } else if (code < 0xcc7d) {
                                if (code < 0xcc29) {
                                    if (code < 0xcc0c) {
                                        if (code < 0xcbf1) {
                                            // Lo       HANGUL SYLLABLE JJYI
                                            if (0xcbf0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JJYIG..HANGUL SYLLABLE JJYIH
                                            if (0xcbf1 <= code && code <= 0xcc0b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xcc0d) {
                                            // Lo       HANGUL SYLLABLE JJI
                                            if (0xcc0c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xcc28) {
                                            // Lo  [27] HANGUL SYLLABLE JJIG..HANGUL SYLLABLE JJIH
                                            if (0xcc0d <= code && code <= 0xcc27) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE CA
                                            if (0xcc28 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xcc60) {
                                    if (code < 0xcc44) {
                                        // Lo  [27] HANGUL SYLLABLE CAG..HANGUL SYLLABLE CAH
                                        if (0xcc29 <= code && code <= 0xcc43) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xcc45) {
                                        // Lo       HANGUL SYLLABLE CAE
                                        if (0xcc44 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE CAEG..HANGUL SYLLABLE CAEH
                                        if (0xcc45 <= code && code <= 0xcc5f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xcc61) {
                                        // Lo       HANGUL SYLLABLE CYA
                                        if (0xcc60 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xcc7c) {
                                        // Lo  [27] HANGUL SYLLABLE CYAG..HANGUL SYLLABLE CYAH
                                        if (0xcc61 <= code && code <= 0xcc7b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE CYAE
                                        if (0xcc7c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else {
                                if (code < 0xccd0) {
                                    if (code < 0xcc99) {
                                        if (code < 0xcc98) {
                                            // Lo  [27] HANGUL SYLLABLE CYAEG..HANGUL SYLLABLE CYAEH
                                            if (0xcc7d <= code && code <= 0xcc97) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE CEO
                                            if (0xcc98 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xccb4) {
                                            // Lo  [27] HANGUL SYLLABLE CEOG..HANGUL SYLLABLE CEOH
                                            if (0xcc99 <= code && code <= 0xccb3) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xccb5) {
                                            // Lo       HANGUL SYLLABLE CE
                                            if (0xccb4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE CEG..HANGUL SYLLABLE CEH
                                            if (0xccb5 <= code && code <= 0xcccf) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xcced) {
                                    if (code < 0xccd1) {
                                        // Lo       HANGUL SYLLABLE CYEO
                                        if (0xccd0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xccec) {
                                        // Lo  [27] HANGUL SYLLABLE CYEOG..HANGUL SYLLABLE CYEOH
                                        if (0xccd1 <= code && code <= 0xcceb) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE CYE
                                        if (0xccec === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xcd08) {
                                        // Lo  [27] HANGUL SYLLABLE CYEG..HANGUL SYLLABLE CYEH
                                        if (0xcced <= code && code <= 0xcd07) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xcd09) {
                                        // Lo       HANGUL SYLLABLE CO
                                        if (0xcd08 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE COG..HANGUL SYLLABLE COH
                                        if (0xcd09 <= code && code <= 0xcd23) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            }
                        }
                    } else if (code < 0xcf71) {
                        if (code < 0xce3d) {
                            if (code < 0xcdb0) {
                                if (code < 0xcd5d) {
                                    if (code < 0xcd40) {
                                        if (code < 0xcd25) {
                                            // Lo       HANGUL SYLLABLE CWA
                                            if (0xcd24 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE CWAG..HANGUL SYLLABLE CWAH
                                            if (0xcd25 <= code && code <= 0xcd3f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xcd41) {
                                            // Lo       HANGUL SYLLABLE CWAE
                                            if (0xcd40 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xcd5c) {
                                            // Lo  [27] HANGUL SYLLABLE CWAEG..HANGUL SYLLABLE CWAEH
                                            if (0xcd41 <= code && code <= 0xcd5b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE COE
                                            if (0xcd5c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xcd79) {
                                    if (code < 0xcd78) {
                                        // Lo  [27] HANGUL SYLLABLE COEG..HANGUL SYLLABLE COEH
                                        if (0xcd5d <= code && code <= 0xcd77) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE CYO
                                        if (0xcd78 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xcd94) {
                                        // Lo  [27] HANGUL SYLLABLE CYOG..HANGUL SYLLABLE CYOH
                                        if (0xcd79 <= code && code <= 0xcd93) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xcd95) {
                                        // Lo       HANGUL SYLLABLE CU
                                        if (0xcd94 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE CUG..HANGUL SYLLABLE CUH
                                        if (0xcd95 <= code && code <= 0xcdaf) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xcde9) {
                                    if (code < 0xcdcc) {
                                        if (code < 0xcdb1) {
                                            // Lo       HANGUL SYLLABLE CWEO
                                            if (0xcdb0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE CWEOG..HANGUL SYLLABLE CWEOH
                                            if (0xcdb1 <= code && code <= 0xcdcb) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xcdcd) {
                                            // Lo       HANGUL SYLLABLE CWE
                                            if (0xcdcc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xcde8) {
                                            // Lo  [27] HANGUL SYLLABLE CWEG..HANGUL SYLLABLE CWEH
                                            if (0xcdcd <= code && code <= 0xcde7) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE CWI
                                            if (0xcde8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xce20) {
                                    if (code < 0xce04) {
                                        // Lo  [27] HANGUL SYLLABLE CWIG..HANGUL SYLLABLE CWIH
                                        if (0xcde9 <= code && code <= 0xce03) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xce05) {
                                        // Lo       HANGUL SYLLABLE CYU
                                        if (0xce04 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE CYUG..HANGUL SYLLABLE CYUH
                                        if (0xce05 <= code && code <= 0xce1f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xce21) {
                                        // Lo       HANGUL SYLLABLE CEU
                                        if (0xce20 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xce3c) {
                                        // Lo  [27] HANGUL SYLLABLE CEUG..HANGUL SYLLABLE CEUH
                                        if (0xce21 <= code && code <= 0xce3b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE CYI
                                        if (0xce3c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xcee4) {
                            if (code < 0xce90) {
                                if (code < 0xce59) {
                                    if (code < 0xce58) {
                                        // Lo  [27] HANGUL SYLLABLE CYIG..HANGUL SYLLABLE CYIH
                                        if (0xce3d <= code && code <= 0xce57) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE CI
                                        if (0xce58 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xce74) {
                                        // Lo  [27] HANGUL SYLLABLE CIG..HANGUL SYLLABLE CIH
                                        if (0xce59 <= code && code <= 0xce73) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xce75) {
                                        // Lo       HANGUL SYLLABLE KA
                                        if (0xce74 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE KAG..HANGUL SYLLABLE KAH
                                        if (0xce75 <= code && code <= 0xce8f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xcead) {
                                if (code < 0xce91) {
                                    // Lo       HANGUL SYLLABLE KAE
                                    if (0xce90 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xceac) {
                                    // Lo  [27] HANGUL SYLLABLE KAEG..HANGUL SYLLABLE KAEH
                                    if (0xce91 <= code && code <= 0xceab) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE KYA
                                    if (0xceac === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xcec8) {
                                    // Lo  [27] HANGUL SYLLABLE KYAG..HANGUL SYLLABLE KYAH
                                    if (0xcead <= code && code <= 0xcec7) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xcec9) {
                                    // Lo       HANGUL SYLLABLE KYAE
                                    if (0xcec8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE KYAEG..HANGUL SYLLABLE KYAEH
                                    if (0xcec9 <= code && code <= 0xcee3) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xcf1d) {
                                if (code < 0xcf00) {
                                    if (code < 0xcee5) {
                                        // Lo       HANGUL SYLLABLE KEO
                                        if (0xcee4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE KEOG..HANGUL SYLLABLE KEOH
                                        if (0xcee5 <= code && code <= 0xceff) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xcf01) {
                                        // Lo       HANGUL SYLLABLE KE
                                        if (0xcf00 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xcf1c) {
                                        // Lo  [27] HANGUL SYLLABLE KEG..HANGUL SYLLABLE KEH
                                        if (0xcf01 <= code && code <= 0xcf1b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE KYEO
                                        if (0xcf1c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xcf54) {
                                if (code < 0xcf38) {
                                    // Lo  [27] HANGUL SYLLABLE KYEOG..HANGUL SYLLABLE KYEOH
                                    if (0xcf1d <= code && code <= 0xcf37) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xcf39) {
                                    // Lo       HANGUL SYLLABLE KYE
                                    if (0xcf38 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE KYEG..HANGUL SYLLABLE KYEH
                                    if (0xcf39 <= code && code <= 0xcf53) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xcf55) {
                                    // Lo       HANGUL SYLLABLE KO
                                    if (0xcf54 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xcf70) {
                                    // Lo  [27] HANGUL SYLLABLE KOG..HANGUL SYLLABLE KOH
                                    if (0xcf55 <= code && code <= 0xcf6f) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE KWA
                                    if (0xcf70 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    } else {
                        if (code < 0xd0a4) {
                            if (code < 0xcffd) {
                                if (code < 0xcfc4) {
                                    if (code < 0xcf8d) {
                                        if (code < 0xcf8c) {
                                            // Lo  [27] HANGUL SYLLABLE KWAG..HANGUL SYLLABLE KWAH
                                            if (0xcf71 <= code && code <= 0xcf8b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE KWAE
                                            if (0xcf8c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xcfa8) {
                                            // Lo  [27] HANGUL SYLLABLE KWAEG..HANGUL SYLLABLE KWAEH
                                            if (0xcf8d <= code && code <= 0xcfa7) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xcfa9) {
                                            // Lo       HANGUL SYLLABLE KOE
                                            if (0xcfa8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE KOEG..HANGUL SYLLABLE KOEH
                                            if (0xcfa9 <= code && code <= 0xcfc3) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xcfe0) {
                                    if (code < 0xcfc5) {
                                        // Lo       HANGUL SYLLABLE KYO
                                        if (0xcfc4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE KYOG..HANGUL SYLLABLE KYOH
                                        if (0xcfc5 <= code && code <= 0xcfdf) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xcfe1) {
                                        // Lo       HANGUL SYLLABLE KU
                                        if (0xcfe0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xcffc) {
                                        // Lo  [27] HANGUL SYLLABLE KUG..HANGUL SYLLABLE KUH
                                        if (0xcfe1 <= code && code <= 0xcffb) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE KWEO
                                        if (0xcffc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else {
                                if (code < 0xd050) {
                                    if (code < 0xd019) {
                                        if (code < 0xd018) {
                                            // Lo  [27] HANGUL SYLLABLE KWEOG..HANGUL SYLLABLE KWEOH
                                            if (0xcffd <= code && code <= 0xd017) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE KWE
                                            if (0xd018 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xd034) {
                                            // Lo  [27] HANGUL SYLLABLE KWEG..HANGUL SYLLABLE KWEH
                                            if (0xd019 <= code && code <= 0xd033) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xd035) {
                                            // Lo       HANGUL SYLLABLE KWI
                                            if (0xd034 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE KWIG..HANGUL SYLLABLE KWIH
                                            if (0xd035 <= code && code <= 0xd04f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xd06d) {
                                    if (code < 0xd051) {
                                        // Lo       HANGUL SYLLABLE KYU
                                        if (0xd050 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xd06c) {
                                        // Lo  [27] HANGUL SYLLABLE KYUG..HANGUL SYLLABLE KYUH
                                        if (0xd051 <= code && code <= 0xd06b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE KEU
                                        if (0xd06c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd088) {
                                        // Lo  [27] HANGUL SYLLABLE KEUG..HANGUL SYLLABLE KEUH
                                        if (0xd06d <= code && code <= 0xd087) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd089) {
                                        // Lo       HANGUL SYLLABLE KYI
                                        if (0xd088 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE KYIG..HANGUL SYLLABLE KYIH
                                        if (0xd089 <= code && code <= 0xd0a3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            }
                        } else if (code < 0xd131) {
                            if (code < 0xd0dd) {
                                if (code < 0xd0c0) {
                                    if (code < 0xd0a5) {
                                        // Lo       HANGUL SYLLABLE KI
                                        if (0xd0a4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE KIG..HANGUL SYLLABLE KIH
                                        if (0xd0a5 <= code && code <= 0xd0bf) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xd0c1) {
                                        // Lo       HANGUL SYLLABLE TA
                                        if (0xd0c0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xd0dc) {
                                        // Lo  [27] HANGUL SYLLABLE TAG..HANGUL SYLLABLE TAH
                                        if (0xd0c1 <= code && code <= 0xd0db) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE TAE
                                        if (0xd0dc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xd114) {
                                if (code < 0xd0f8) {
                                    // Lo  [27] HANGUL SYLLABLE TAEG..HANGUL SYLLABLE TAEH
                                    if (0xd0dd <= code && code <= 0xd0f7) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd0f9) {
                                    // Lo       HANGUL SYLLABLE TYA
                                    if (0xd0f8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE TYAG..HANGUL SYLLABLE TYAH
                                    if (0xd0f9 <= code && code <= 0xd113) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xd115) {
                                    // Lo       HANGUL SYLLABLE TYAE
                                    if (0xd114 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xd130) {
                                    // Lo  [27] HANGUL SYLLABLE TYAEG..HANGUL SYLLABLE TYAEH
                                    if (0xd115 <= code && code <= 0xd12f) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE TEO
                                    if (0xd130 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xd184) {
                                if (code < 0xd14d) {
                                    if (code < 0xd14c) {
                                        // Lo  [27] HANGUL SYLLABLE TEOG..HANGUL SYLLABLE TEOH
                                        if (0xd131 <= code && code <= 0xd14b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE TE
                                        if (0xd14c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd168) {
                                        // Lo  [27] HANGUL SYLLABLE TEG..HANGUL SYLLABLE TEH
                                        if (0xd14d <= code && code <= 0xd167) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd169) {
                                        // Lo       HANGUL SYLLABLE TYEO
                                        if (0xd168 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE TYEOG..HANGUL SYLLABLE TYEOH
                                        if (0xd169 <= code && code <= 0xd183) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd1a1) {
                                if (code < 0xd185) {
                                    // Lo       HANGUL SYLLABLE TYE
                                    if (0xd184 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xd1a0) {
                                    // Lo  [27] HANGUL SYLLABLE TYEG..HANGUL SYLLABLE TYEH
                                    if (0xd185 <= code && code <= 0xd19f) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE TO
                                    if (0xd1a0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xd1bc) {
                                    // Lo  [27] HANGUL SYLLABLE TOG..HANGUL SYLLABLE TOH
                                    if (0xd1a1 <= code && code <= 0xd1bb) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd1bd) {
                                    // Lo       HANGUL SYLLABLE TWA
                                    if (0xd1bc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE TWAG..HANGUL SYLLABLE TWAH
                                    if (0xd1bd <= code && code <= 0xd1d7) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    }
                }
            } else if (code < 0x1133b) {
                if (code < 0xd671) {
                    if (code < 0xd424) {
                        if (code < 0xd2f1) {
                            if (code < 0xd264) {
                                if (code < 0xd211) {
                                    if (code < 0xd1f4) {
                                        if (code < 0xd1d9) {
                                            // Lo       HANGUL SYLLABLE TWAE
                                            if (0xd1d8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE TWAEG..HANGUL SYLLABLE TWAEH
                                            if (0xd1d9 <= code && code <= 0xd1f3) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xd1f5) {
                                            // Lo       HANGUL SYLLABLE TOE
                                            if (0xd1f4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xd210) {
                                            // Lo  [27] HANGUL SYLLABLE TOEG..HANGUL SYLLABLE TOEH
                                            if (0xd1f5 <= code && code <= 0xd20f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE TYO
                                            if (0xd210 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xd22d) {
                                    if (code < 0xd22c) {
                                        // Lo  [27] HANGUL SYLLABLE TYOG..HANGUL SYLLABLE TYOH
                                        if (0xd211 <= code && code <= 0xd22b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE TU
                                        if (0xd22c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd248) {
                                        // Lo  [27] HANGUL SYLLABLE TUG..HANGUL SYLLABLE TUH
                                        if (0xd22d <= code && code <= 0xd247) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd249) {
                                        // Lo       HANGUL SYLLABLE TWEO
                                        if (0xd248 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE TWEOG..HANGUL SYLLABLE TWEOH
                                        if (0xd249 <= code && code <= 0xd263) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xd29d) {
                                    if (code < 0xd280) {
                                        if (code < 0xd265) {
                                            // Lo       HANGUL SYLLABLE TWE
                                            if (0xd264 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE TWEG..HANGUL SYLLABLE TWEH
                                            if (0xd265 <= code && code <= 0xd27f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xd281) {
                                            // Lo       HANGUL SYLLABLE TWI
                                            if (0xd280 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xd29c) {
                                            // Lo  [27] HANGUL SYLLABLE TWIG..HANGUL SYLLABLE TWIH
                                            if (0xd281 <= code && code <= 0xd29b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE TYU
                                            if (0xd29c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xd2d4) {
                                    if (code < 0xd2b8) {
                                        // Lo  [27] HANGUL SYLLABLE TYUG..HANGUL SYLLABLE TYUH
                                        if (0xd29d <= code && code <= 0xd2b7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd2b9) {
                                        // Lo       HANGUL SYLLABLE TEU
                                        if (0xd2b8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE TEUG..HANGUL SYLLABLE TEUH
                                        if (0xd2b9 <= code && code <= 0xd2d3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xd2d5) {
                                        // Lo       HANGUL SYLLABLE TYI
                                        if (0xd2d4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xd2f0) {
                                        // Lo  [27] HANGUL SYLLABLE TYIG..HANGUL SYLLABLE TYIH
                                        if (0xd2d5 <= code && code <= 0xd2ef) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE TI
                                        if (0xd2f0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xd37d) {
                            if (code < 0xd344) {
                                if (code < 0xd30d) {
                                    if (code < 0xd30c) {
                                        // Lo  [27] HANGUL SYLLABLE TIG..HANGUL SYLLABLE TIH
                                        if (0xd2f1 <= code && code <= 0xd30b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE PA
                                        if (0xd30c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd328) {
                                        // Lo  [27] HANGUL SYLLABLE PAG..HANGUL SYLLABLE PAH
                                        if (0xd30d <= code && code <= 0xd327) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd329) {
                                        // Lo       HANGUL SYLLABLE PAE
                                        if (0xd328 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE PAEG..HANGUL SYLLABLE PAEH
                                        if (0xd329 <= code && code <= 0xd343) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd360) {
                                if (code < 0xd345) {
                                    // Lo       HANGUL SYLLABLE PYA
                                    if (0xd344 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE PYAG..HANGUL SYLLABLE PYAH
                                    if (0xd345 <= code && code <= 0xd35f) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xd361) {
                                    // Lo       HANGUL SYLLABLE PYAE
                                    if (0xd360 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xd37c) {
                                    // Lo  [27] HANGUL SYLLABLE PYAEG..HANGUL SYLLABLE PYAEH
                                    if (0xd361 <= code && code <= 0xd37b) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE PEO
                                    if (0xd37c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xd3d0) {
                                if (code < 0xd399) {
                                    if (code < 0xd398) {
                                        // Lo  [27] HANGUL SYLLABLE PEOG..HANGUL SYLLABLE PEOH
                                        if (0xd37d <= code && code <= 0xd397) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE PE
                                        if (0xd398 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd3b4) {
                                        // Lo  [27] HANGUL SYLLABLE PEG..HANGUL SYLLABLE PEH
                                        if (0xd399 <= code && code <= 0xd3b3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd3b5) {
                                        // Lo       HANGUL SYLLABLE PYEO
                                        if (0xd3b4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE PYEOG..HANGUL SYLLABLE PYEOH
                                        if (0xd3b5 <= code && code <= 0xd3cf) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd3ed) {
                                if (code < 0xd3d1) {
                                    // Lo       HANGUL SYLLABLE PYE
                                    if (0xd3d0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xd3ec) {
                                    // Lo  [27] HANGUL SYLLABLE PYEG..HANGUL SYLLABLE PYEH
                                    if (0xd3d1 <= code && code <= 0xd3eb) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE PO
                                    if (0xd3ec === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xd408) {
                                    // Lo  [27] HANGUL SYLLABLE POG..HANGUL SYLLABLE POH
                                    if (0xd3ed <= code && code <= 0xd407) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd409) {
                                    // Lo       HANGUL SYLLABLE PWA
                                    if (0xd408 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE PWAG..HANGUL SYLLABLE PWAH
                                    if (0xd409 <= code && code <= 0xd423) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else {
                        if (code < 0xd53d) {
                            if (code < 0xd4b0) {
                                if (code < 0xd45d) {
                                    if (code < 0xd440) {
                                        if (code < 0xd425) {
                                            // Lo       HANGUL SYLLABLE PWAE
                                            if (0xd424 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE PWAEG..HANGUL SYLLABLE PWAEH
                                            if (0xd425 <= code && code <= 0xd43f) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xd441) {
                                            // Lo       HANGUL SYLLABLE POE
                                            if (0xd440 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xd45c) {
                                            // Lo  [27] HANGUL SYLLABLE POEG..HANGUL SYLLABLE POEH
                                            if (0xd441 <= code && code <= 0xd45b) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE PYO
                                            if (0xd45c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xd479) {
                                    if (code < 0xd478) {
                                        // Lo  [27] HANGUL SYLLABLE PYOG..HANGUL SYLLABLE PYOH
                                        if (0xd45d <= code && code <= 0xd477) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE PU
                                        if (0xd478 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd494) {
                                        // Lo  [27] HANGUL SYLLABLE PUG..HANGUL SYLLABLE PUH
                                        if (0xd479 <= code && code <= 0xd493) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd495) {
                                        // Lo       HANGUL SYLLABLE PWEO
                                        if (0xd494 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE PWEOG..HANGUL SYLLABLE PWEOH
                                        if (0xd495 <= code && code <= 0xd4af) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xd4e9) {
                                    if (code < 0xd4cc) {
                                        if (code < 0xd4b1) {
                                            // Lo       HANGUL SYLLABLE PWE
                                            if (0xd4b0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE PWEG..HANGUL SYLLABLE PWEH
                                            if (0xd4b1 <= code && code <= 0xd4cb) return $lXl8C.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xd4cd) {
                                            // Lo       HANGUL SYLLABLE PWI
                                            if (0xd4cc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        } else if (code < 0xd4e8) {
                                            // Lo  [27] HANGUL SYLLABLE PWIG..HANGUL SYLLABLE PWIH
                                            if (0xd4cd <= code && code <= 0xd4e7) return $lXl8C.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE PYU
                                            if (0xd4e8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xd520) {
                                    if (code < 0xd504) {
                                        // Lo  [27] HANGUL SYLLABLE PYUG..HANGUL SYLLABLE PYUH
                                        if (0xd4e9 <= code && code <= 0xd503) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd505) {
                                        // Lo       HANGUL SYLLABLE PEU
                                        if (0xd504 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE PEUG..HANGUL SYLLABLE PEUH
                                        if (0xd505 <= code && code <= 0xd51f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xd521) {
                                        // Lo       HANGUL SYLLABLE PYI
                                        if (0xd520 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xd53c) {
                                        // Lo  [27] HANGUL SYLLABLE PYIG..HANGUL SYLLABLE PYIH
                                        if (0xd521 <= code && code <= 0xd53b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE PI
                                        if (0xd53c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xd5e4) {
                            if (code < 0xd590) {
                                if (code < 0xd559) {
                                    if (code < 0xd558) {
                                        // Lo  [27] HANGUL SYLLABLE PIG..HANGUL SYLLABLE PIH
                                        if (0xd53d <= code && code <= 0xd557) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE HA
                                        if (0xd558 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd574) {
                                        // Lo  [27] HANGUL SYLLABLE HAG..HANGUL SYLLABLE HAH
                                        if (0xd559 <= code && code <= 0xd573) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd575) {
                                        // Lo       HANGUL SYLLABLE HAE
                                        if (0xd574 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE HAEG..HANGUL SYLLABLE HAEH
                                        if (0xd575 <= code && code <= 0xd58f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd5ad) {
                                if (code < 0xd591) {
                                    // Lo       HANGUL SYLLABLE HYA
                                    if (0xd590 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xd5ac) {
                                    // Lo  [27] HANGUL SYLLABLE HYAG..HANGUL SYLLABLE HYAH
                                    if (0xd591 <= code && code <= 0xd5ab) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE HYAE
                                    if (0xd5ac === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xd5c8) {
                                    // Lo  [27] HANGUL SYLLABLE HYAEG..HANGUL SYLLABLE HYAEH
                                    if (0xd5ad <= code && code <= 0xd5c7) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd5c9) {
                                    // Lo       HANGUL SYLLABLE HEO
                                    if (0xd5c8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE HEOG..HANGUL SYLLABLE HEOH
                                    if (0xd5c9 <= code && code <= 0xd5e3) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xd61d) {
                                if (code < 0xd600) {
                                    if (code < 0xd5e5) {
                                        // Lo       HANGUL SYLLABLE HE
                                        if (0xd5e4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE HEG..HANGUL SYLLABLE HEH
                                        if (0xd5e5 <= code && code <= 0xd5ff) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xd601) {
                                        // Lo       HANGUL SYLLABLE HYEO
                                        if (0xd600 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else if (code < 0xd61c) {
                                        // Lo  [27] HANGUL SYLLABLE HYEOG..HANGUL SYLLABLE HYEOH
                                        if (0xd601 <= code && code <= 0xd61b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE HYE
                                        if (0xd61c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xd654) {
                                if (code < 0xd638) {
                                    // Lo  [27] HANGUL SYLLABLE HYEG..HANGUL SYLLABLE HYEH
                                    if (0xd61d <= code && code <= 0xd637) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd639) {
                                    // Lo       HANGUL SYLLABLE HO
                                    if (0xd638 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE HOG..HANGUL SYLLABLE HOH
                                    if (0xd639 <= code && code <= 0xd653) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xd655) {
                                    // Lo       HANGUL SYLLABLE HWA
                                    if (0xd654 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xd670) {
                                    // Lo  [27] HANGUL SYLLABLE HWAG..HANGUL SYLLABLE HWAH
                                    if (0xd655 <= code && code <= 0xd66f) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE HWAE
                                    if (0xd670 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    }
                } else if (code < 0x11000) {
                    if (code < 0xd7b0) {
                        if (code < 0xd6fd) {
                            if (code < 0xd6c4) {
                                if (code < 0xd68d) {
                                    if (code < 0xd68c) {
                                        // Lo  [27] HANGUL SYLLABLE HWAEG..HANGUL SYLLABLE HWAEH
                                        if (0xd671 <= code && code <= 0xd68b) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE HOE
                                        if (0xd68c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd6a8) {
                                        // Lo  [27] HANGUL SYLLABLE HOEG..HANGUL SYLLABLE HOEH
                                        if (0xd68d <= code && code <= 0xd6a7) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd6a9) {
                                        // Lo       HANGUL SYLLABLE HYO
                                        if (0xd6a8 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE HYOG..HANGUL SYLLABLE HYOH
                                        if (0xd6a9 <= code && code <= 0xd6c3) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd6e0) {
                                if (code < 0xd6c5) {
                                    // Lo       HANGUL SYLLABLE HU
                                    if (0xd6c4 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE HUG..HANGUL SYLLABLE HUH
                                    if (0xd6c5 <= code && code <= 0xd6df) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xd6e1) {
                                    // Lo       HANGUL SYLLABLE HWEO
                                    if (0xd6e0 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xd6fc) {
                                    // Lo  [27] HANGUL SYLLABLE HWEOG..HANGUL SYLLABLE HWEOH
                                    if (0xd6e1 <= code && code <= 0xd6fb) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE HWE
                                    if (0xd6fc === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xd750) {
                                if (code < 0xd719) {
                                    if (code < 0xd718) {
                                        // Lo  [27] HANGUL SYLLABLE HWEG..HANGUL SYLLABLE HWEH
                                        if (0xd6fd <= code && code <= 0xd717) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE HWI
                                        if (0xd718 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd734) {
                                        // Lo  [27] HANGUL SYLLABLE HWIG..HANGUL SYLLABLE HWIH
                                        if (0xd719 <= code && code <= 0xd733) return $lXl8C.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd735) {
                                        // Lo       HANGUL SYLLABLE HYU
                                        if (0xd734 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE HYUG..HANGUL SYLLABLE HYUH
                                        if (0xd735 <= code && code <= 0xd74f) return $lXl8C.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd76d) {
                                if (code < 0xd751) {
                                    // Lo       HANGUL SYLLABLE HEU
                                    if (0xd750 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else if (code < 0xd76c) {
                                    // Lo  [27] HANGUL SYLLABLE HEUG..HANGUL SYLLABLE HEUH
                                    if (0xd751 <= code && code <= 0xd76b) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE HYI
                                    if (0xd76c === code) return $lXl8C.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xd788) {
                                    // Lo  [27] HANGUL SYLLABLE HYIG..HANGUL SYLLABLE HYIH
                                    if (0xd76d <= code && code <= 0xd787) return $lXl8C.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd789) {
                                    // Lo       HANGUL SYLLABLE HI
                                    if (0xd788 === code) return $lXl8C.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE HIG..HANGUL SYLLABLE HIH
                                    if (0xd789 <= code && code <= 0xd7a3) return $lXl8C.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else if (code < 0x10a01) {
                        if (code < 0xfeff) {
                            if (code < 0xfb1e) {
                                if (code < 0xd7cb) {
                                    // Lo  [23] HANGUL JUNGSEONG O-YEO..HANGUL JUNGSEONG ARAEA-E
                                    if (0xd7b0 <= code && code <= 0xd7c6) return $lXl8C.CLUSTER_BREAK.V;
                                } else {
                                    // Lo  [49] HANGUL JONGSEONG NIEUN-RIEUL..HANGUL JONGSEONG PHIEUPH-THIEUTH
                                    if (0xd7cb <= code && code <= 0xd7fb) return $lXl8C.CLUSTER_BREAK.T;
                                }
                            } else {
                                if (code < 0xfe00) {
                                    // Mn       HEBREW POINT JUDEO-SPANISH VARIKA
                                    if (0xfb1e === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xfe20) {
                                    // Mn  [16] VARIATION SELECTOR-1..VARIATION SELECTOR-16
                                    if (0xfe00 <= code && code <= 0xfe0f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn  [16] COMBINING LIGATURE LEFT HALF..COMBINING CYRILLIC TITLO RIGHT HALF
                                    if (0xfe20 <= code && code <= 0xfe2f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0x101fd) {
                            if (code < 0xff9e) {
                                // Cf       ZERO WIDTH NO-BREAK SPACE
                                if (0xfeff === code) return $lXl8C.CLUSTER_BREAK.CONTROL;
                            } else if (code < 0xfff0) {
                                // Lm   [2] HALFWIDTH KATAKANA VOICED SOUND MARK..HALFWIDTH KATAKANA SEMI-VOICED SOUND MARK
                                if (0xff9e <= code && code <= 0xff9f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Cn   [9] <reserved-FFF0>..<reserved-FFF8>
                                // Cf   [3] INTERLINEAR ANNOTATION ANCHOR..INTERLINEAR ANNOTATION TERMINATOR
                                if (0xfff0 <= code && code <= 0xfffb) return $lXl8C.CLUSTER_BREAK.CONTROL;
                            }
                        } else {
                            if (code < 0x102e0) {
                                // Mn       PHAISTOS DISC SIGN COMBINING OBLIQUE STROKE
                                if (0x101fd === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x10376) {
                                // Mn       COPTIC EPACT THOUSANDS MARK
                                if (0x102e0 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn   [5] COMBINING OLD PERMIC LETTER AN..COMBINING OLD PERMIC LETTER SII
                                if (0x10376 <= code && code <= 0x1037a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        }
                    } else {
                        if (code < 0x10ae5) {
                            if (code < 0x10a0c) {
                                if (code < 0x10a05) {
                                    // Mn   [3] KHAROSHTHI VOWEL SIGN I..KHAROSHTHI VOWEL SIGN VOCALIC R
                                    if (0x10a01 <= code && code <= 0x10a03) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [2] KHAROSHTHI VOWEL SIGN E..KHAROSHTHI VOWEL SIGN O
                                    if (0x10a05 <= code && code <= 0x10a06) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x10a38) {
                                    // Mn   [4] KHAROSHTHI VOWEL LENGTH MARK..KHAROSHTHI SIGN VISARGA
                                    if (0x10a0c <= code && code <= 0x10a0f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x10a3f) {
                                    // Mn   [3] KHAROSHTHI SIGN BAR ABOVE..KHAROSHTHI SIGN DOT BELOW
                                    if (0x10a38 <= code && code <= 0x10a3a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       KHAROSHTHI VIRAMA
                                    if (0x10a3f === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0x10efd) {
                            if (code < 0x10d24) {
                                // Mn   [2] MANICHAEAN ABBREVIATION MARK ABOVE..MANICHAEAN ABBREVIATION MARK BELOW
                                if (0x10ae5 <= code && code <= 0x10ae6) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x10eab) {
                                // Mn   [4] HANIFI ROHINGYA SIGN HARBAHAY..HANIFI ROHINGYA SIGN TASSI
                                if (0x10d24 <= code && code <= 0x10d27) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn   [2] YEZIDI COMBINING HAMZA MARK..YEZIDI COMBINING MADDA MARK
                                if (0x10eab <= code && code <= 0x10eac) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        } else {
                            if (code < 0x10f46) {
                                // Mn   [3] ARABIC SMALL LOW WORD SAKTA..ARABIC SMALL LOW WORD MADDA
                                if (0x10efd <= code && code <= 0x10eff) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x10f82) {
                                // Mn  [11] SOGDIAN COMBINING DOT BELOW..SOGDIAN COMBINING STROKE BELOW
                                if (0x10f46 <= code && code <= 0x10f50) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn   [4] OLD UYGHUR COMBINING DOT ABOVE..OLD UYGHUR COMBINING TWO DOTS BELOW
                                if (0x10f82 <= code && code <= 0x10f85) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        }
                    }
                } else {
                    if (code < 0x11180) {
                        if (code < 0x110b7) {
                            if (code < 0x11073) {
                                if (code < 0x11002) {
                                    // Mc       BRAHMI SIGN CANDRABINDU
                                    if (0x11000 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       BRAHMI SIGN ANUSVARA
                                    if (0x11001 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (code < 0x11038) {
                                        // Mc       BRAHMI SIGN VISARGA
                                        if (0x11002 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x11070) {
                                        // Mn  [15] BRAHMI VOWEL SIGN AA..BRAHMI VIRAMA
                                        if (0x11038 <= code && code <= 0x11046) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       BRAHMI SIGN OLD TAMIL VIRAMA
                                        if (0x11070 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x11082) {
                                if (code < 0x1107f) {
                                    // Mn   [2] BRAHMI VOWEL SIGN OLD TAMIL SHORT E..BRAHMI VOWEL SIGN OLD TAMIL SHORT O
                                    if (0x11073 <= code && code <= 0x11074) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [3] BRAHMI NUMBER JOINER..KAITHI SIGN ANUSVARA
                                    if (0x1107f <= code && code <= 0x11081) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x110b0) {
                                    // Mc       KAITHI SIGN VISARGA
                                    if (0x11082 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0x110b3) {
                                    // Mc   [3] KAITHI VOWEL SIGN AA..KAITHI VOWEL SIGN II
                                    if (0x110b0 <= code && code <= 0x110b2) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn   [4] KAITHI VOWEL SIGN U..KAITHI VOWEL SIGN AI
                                    if (0x110b3 <= code && code <= 0x110b6) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0x11100) {
                                if (code < 0x110bd) {
                                    if (code < 0x110b9) {
                                        // Mc   [2] KAITHI VOWEL SIGN O..KAITHI VOWEL SIGN AU
                                        if (0x110b7 <= code && code <= 0x110b8) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] KAITHI SIGN VIRAMA..KAITHI SIGN NUKTA
                                        if (0x110b9 <= code && code <= 0x110ba) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0x110c2) {
                                    // Cf       KAITHI NUMBER SIGN
                                    if (0x110bd === code) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                } else {
                                    // Mn       KAITHI VOWEL SIGN VOCALIC R
                                    if (0x110c2 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    // Cf       KAITHI NUMBER SIGN ABOVE
                                    if (0x110cd === code) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                }
                            } else if (code < 0x1112d) {
                                if (code < 0x11127) {
                                    // Mn   [3] CHAKMA SIGN CANDRABINDU..CHAKMA SIGN VISARGA
                                    if (0x11100 <= code && code <= 0x11102) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1112c) {
                                    // Mn   [5] CHAKMA VOWEL SIGN A..CHAKMA VOWEL SIGN UU
                                    if (0x11127 <= code && code <= 0x1112b) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc       CHAKMA VOWEL SIGN E
                                    if (0x1112c === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0x11145) {
                                    // Mn   [8] CHAKMA VOWEL SIGN AI..CHAKMA MAAYYAA
                                    if (0x1112d <= code && code <= 0x11134) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x11173) {
                                    // Mc   [2] CHAKMA VOWEL SIGN AA..CHAKMA VOWEL SIGN EI
                                    if (0x11145 <= code && code <= 0x11146) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       MAHAJANI SIGN NUKTA
                                    if (0x11173 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    } else if (code < 0x11232) {
                        if (code < 0x111c2) {
                            if (code < 0x111b3) {
                                if (code < 0x11182) {
                                    // Mn   [2] SHARADA SIGN CANDRABINDU..SHARADA SIGN ANUSVARA
                                    if (0x11180 <= code && code <= 0x11181) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc       SHARADA SIGN VISARGA
                                    if (0x11182 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0x111b6) {
                                    // Mc   [3] SHARADA VOWEL SIGN AA..SHARADA VOWEL SIGN II
                                    if (0x111b3 <= code && code <= 0x111b5) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0x111bf) {
                                    // Mn   [9] SHARADA VOWEL SIGN U..SHARADA VOWEL SIGN O
                                    if (0x111b6 <= code && code <= 0x111be) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [2] SHARADA VOWEL SIGN AU..SHARADA SIGN VIRAMA
                                    if (0x111bf <= code && code <= 0x111c0) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            }
                        } else if (code < 0x111cf) {
                            if (code < 0x111c9) {
                                // Lo   [2] SHARADA SIGN JIHVAMULIYA..SHARADA SIGN UPADHMANIYA
                                if (0x111c2 <= code && code <= 0x111c3) return $lXl8C.CLUSTER_BREAK.PREPEND;
                            } else if (code < 0x111ce) {
                                // Mn   [4] SHARADA SANDHI MARK..SHARADA EXTRA SHORT VOWEL MARK
                                if (0x111c9 <= code && code <= 0x111cc) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mc       SHARADA VOWEL SIGN PRISHTHAMATRA E
                                if (0x111ce === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                            }
                        } else {
                            if (code < 0x1122c) {
                                // Mn       SHARADA SIGN INVERTED CANDRABINDU
                                if (0x111cf === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x1122f) {
                                // Mc   [3] KHOJKI VOWEL SIGN AA..KHOJKI VOWEL SIGN II
                                if (0x1122c <= code && code <= 0x1122e) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                            } else {
                                // Mn   [3] KHOJKI VOWEL SIGN U..KHOJKI VOWEL SIGN AI
                                if (0x1122f <= code && code <= 0x11231) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        }
                    } else {
                        if (code < 0x11241) {
                            if (code < 0x11235) {
                                if (code < 0x11234) {
                                    // Mc   [2] KHOJKI VOWEL SIGN O..KHOJKI VOWEL SIGN AU
                                    if (0x11232 <= code && code <= 0x11233) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       KHOJKI SIGN ANUSVARA
                                    if (0x11234 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x11236) {
                                    // Mc       KHOJKI SIGN VIRAMA
                                    if (0x11235 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0x1123e) {
                                    // Mn   [2] KHOJKI SIGN NUKTA..KHOJKI SIGN SHADDA
                                    if (0x11236 <= code && code <= 0x11237) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       KHOJKI SIGN SUKUN
                                    if (0x1123e === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0x112e3) {
                            if (code < 0x112df) {
                                // Mn       KHOJKI VOWEL SIGN VOCALIC R
                                if (0x11241 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x112e0) {
                                // Mn       KHUDAWADI SIGN ANUSVARA
                                if (0x112df === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mc   [3] KHUDAWADI VOWEL SIGN AA..KHUDAWADI VOWEL SIGN II
                                if (0x112e0 <= code && code <= 0x112e2) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                            }
                        } else {
                            if (code < 0x11300) {
                                // Mn   [8] KHUDAWADI VOWEL SIGN U..KHUDAWADI SIGN VIRAMA
                                if (0x112e3 <= code && code <= 0x112ea) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x11302) {
                                // Mn   [2] GRANTHA SIGN COMBINING ANUSVARA ABOVE..GRANTHA SIGN CANDRABINDU
                                if (0x11300 <= code && code <= 0x11301) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mc   [2] GRANTHA SIGN ANUSVARA..GRANTHA SIGN VISARGA
                                if (0x11302 <= code && code <= 0x11303) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                            }
                        }
                    }
                }
            } else {
                if (code < 0x11a97) {
                    if (code < 0x116ab) {
                        if (code < 0x114b9) {
                            if (code < 0x11370) {
                                if (code < 0x11347) {
                                    if (code < 0x1133f) {
                                        if (code < 0x1133e) {
                                            // Mn   [2] COMBINING BINDU BELOW..GRANTHA SIGN NUKTA
                                            if (0x1133b <= code && code <= 0x1133c) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       GRANTHA VOWEL SIGN AA
                                            if (0x1133e === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x11340) {
                                            // Mc       GRANTHA VOWEL SIGN I
                                            if (0x1133f === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0x11341) {
                                            // Mn       GRANTHA VOWEL SIGN II
                                            if (0x11340 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [4] GRANTHA VOWEL SIGN U..GRANTHA VOWEL SIGN VOCALIC RR
                                            if (0x11341 <= code && code <= 0x11344) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                } else if (code < 0x11357) {
                                    if (code < 0x1134b) {
                                        // Mc   [2] GRANTHA VOWEL SIGN EE..GRANTHA VOWEL SIGN AI
                                        if (0x11347 <= code && code <= 0x11348) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mc   [3] GRANTHA VOWEL SIGN OO..GRANTHA SIGN VIRAMA
                                        if (0x1134b <= code && code <= 0x1134d) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0x11362) {
                                        // Mc       GRANTHA AU LENGTH MARK
                                        if (0x11357 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x11366) {
                                        // Mc   [2] GRANTHA VOWEL SIGN VOCALIC L..GRANTHA VOWEL SIGN VOCALIC LL
                                        if (0x11362 <= code && code <= 0x11363) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [7] COMBINING GRANTHA DIGIT ZERO..COMBINING GRANTHA DIGIT SIX
                                        if (0x11366 <= code && code <= 0x1136c) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0x11445) {
                                    if (code < 0x11438) {
                                        if (code < 0x11435) {
                                            // Mn   [5] COMBINING GRANTHA LETTER A..COMBINING GRANTHA LETTER PA
                                            if (0x11370 <= code && code <= 0x11374) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [3] NEWA VOWEL SIGN AA..NEWA VOWEL SIGN II
                                            if (0x11435 <= code && code <= 0x11437) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else {
                                        if (code < 0x11440) {
                                            // Mn   [8] NEWA VOWEL SIGN U..NEWA VOWEL SIGN AI
                                            if (0x11438 <= code && code <= 0x1143f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x11442) {
                                            // Mc   [2] NEWA VOWEL SIGN O..NEWA VOWEL SIGN AU
                                            if (0x11440 <= code && code <= 0x11441) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [3] NEWA SIGN VIRAMA..NEWA SIGN ANUSVARA
                                            if (0x11442 <= code && code <= 0x11444) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0x114b0) {
                                    if (code < 0x11446) {
                                        // Mc       NEWA SIGN VISARGA
                                        if (0x11445 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       NEWA SIGN NUKTA
                                        if (0x11446 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        // Mn       NEWA SANDHI MARK
                                        if (0x1145e === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x114b1) {
                                        // Mc       TIRHUTA VOWEL SIGN AA
                                        if (0x114b0 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x114b3) {
                                        // Mc   [2] TIRHUTA VOWEL SIGN I..TIRHUTA VOWEL SIGN II
                                        if (0x114b1 <= code && code <= 0x114b2) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [6] TIRHUTA VOWEL SIGN U..TIRHUTA VOWEL SIGN VOCALIC LL
                                        if (0x114b3 <= code && code <= 0x114b8) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            }
                        } else if (code < 0x115b8) {
                            if (code < 0x114bf) {
                                if (code < 0x114bb) {
                                    // Mc       TIRHUTA VOWEL SIGN E
                                    if (0x114b9 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       TIRHUTA VOWEL SIGN SHORT E
                                    if (0x114ba === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x114bd) {
                                    // Mc   [2] TIRHUTA VOWEL SIGN AI..TIRHUTA VOWEL SIGN O
                                    if (0x114bb <= code && code <= 0x114bc) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mc       TIRHUTA VOWEL SIGN SHORT O
                                    if (0x114bd === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    // Mc       TIRHUTA VOWEL SIGN AU
                                    if (0x114be === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else if (code < 0x115af) {
                                if (code < 0x114c1) {
                                    // Mn   [2] TIRHUTA SIGN CANDRABINDU..TIRHUTA SIGN ANUSVARA
                                    if (0x114bf <= code && code <= 0x114c0) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x114c2) {
                                    // Mc       TIRHUTA SIGN VISARGA
                                    if (0x114c1 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn   [2] TIRHUTA SIGN VIRAMA..TIRHUTA SIGN NUKTA
                                    if (0x114c2 <= code && code <= 0x114c3) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x115b0) {
                                    // Mc       SIDDHAM VOWEL SIGN AA
                                    if (0x115af === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x115b2) {
                                    // Mc   [2] SIDDHAM VOWEL SIGN I..SIDDHAM VOWEL SIGN II
                                    if (0x115b0 <= code && code <= 0x115b1) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn   [4] SIDDHAM VOWEL SIGN U..SIDDHAM VOWEL SIGN VOCALIC RR
                                    if (0x115b2 <= code && code <= 0x115b5) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0x11630) {
                                if (code < 0x115be) {
                                    if (code < 0x115bc) {
                                        // Mc   [4] SIDDHAM VOWEL SIGN E..SIDDHAM VOWEL SIGN AU
                                        if (0x115b8 <= code && code <= 0x115bb) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] SIDDHAM SIGN CANDRABINDU..SIDDHAM SIGN ANUSVARA
                                        if (0x115bc <= code && code <= 0x115bd) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x115bf) {
                                        // Mc       SIDDHAM SIGN VISARGA
                                        if (0x115be === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x115dc) {
                                        // Mn   [2] SIDDHAM SIGN VIRAMA..SIDDHAM SIGN NUKTA
                                        if (0x115bf <= code && code <= 0x115c0) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] SIDDHAM VOWEL SIGN ALTERNATE U..SIDDHAM VOWEL SIGN ALTERNATE UU
                                        if (0x115dc <= code && code <= 0x115dd) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x1163d) {
                                if (code < 0x11633) {
                                    // Mc   [3] MODI VOWEL SIGN AA..MODI VOWEL SIGN II
                                    if (0x11630 <= code && code <= 0x11632) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0x1163b) {
                                    // Mn   [8] MODI VOWEL SIGN U..MODI VOWEL SIGN AI
                                    if (0x11633 <= code && code <= 0x1163a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [2] MODI VOWEL SIGN O..MODI VOWEL SIGN AU
                                    if (0x1163b <= code && code <= 0x1163c) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0x1163e) {
                                    // Mn       MODI SIGN ANUSVARA
                                    if (0x1163d === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1163f) {
                                    // Mc       MODI SIGN VISARGA
                                    if (0x1163e === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn   [2] MODI SIGN VIRAMA..MODI SIGN ARDHACANDRA
                                    if (0x1163f <= code && code <= 0x11640) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    } else {
                        if (code < 0x1193f) {
                            if (code < 0x11727) {
                                if (code < 0x116b6) {
                                    if (code < 0x116ad) {
                                        // Mn       TAKRI SIGN ANUSVARA
                                        if (0x116ab === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        // Mc       TAKRI SIGN VISARGA
                                        if (0x116ac === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        if (code < 0x116ae) {
                                            // Mn       TAKRI VOWEL SIGN AA
                                            if (0x116ad === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x116b0) {
                                            // Mc   [2] TAKRI VOWEL SIGN I..TAKRI VOWEL SIGN II
                                            if (0x116ae <= code && code <= 0x116af) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [6] TAKRI VOWEL SIGN U..TAKRI VOWEL SIGN AU
                                            if (0x116b0 <= code && code <= 0x116b5) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0x1171d) {
                                    // Mc       TAKRI SIGN VIRAMA
                                    if (0x116b6 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       TAKRI SIGN NUKTA
                                    if (0x116b7 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (code < 0x11722) {
                                        // Mn   [3] AHOM CONSONANT SIGN MEDIAL LA..AHOM CONSONANT SIGN MEDIAL LIGATING RA
                                        if (0x1171d <= code && code <= 0x1171f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x11726) {
                                        // Mn   [4] AHOM VOWEL SIGN I..AHOM VOWEL SIGN UU
                                        if (0x11722 <= code && code <= 0x11725) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc       AHOM VOWEL SIGN E
                                        if (0x11726 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else if (code < 0x11930) {
                                if (code < 0x1182f) {
                                    if (code < 0x1182c) {
                                        // Mn   [5] AHOM VOWEL SIGN AW..AHOM SIGN KILLER
                                        if (0x11727 <= code && code <= 0x1172b) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [3] DOGRA VOWEL SIGN AA..DOGRA VOWEL SIGN II
                                        if (0x1182c <= code && code <= 0x1182e) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0x11838) {
                                        // Mn   [9] DOGRA VOWEL SIGN U..DOGRA SIGN ANUSVARA
                                        if (0x1182f <= code && code <= 0x11837) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x11839) {
                                        // Mc       DOGRA SIGN VISARGA
                                        if (0x11838 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] DOGRA SIGN VIRAMA..DOGRA SIGN NUKTA
                                        if (0x11839 <= code && code <= 0x1183a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0x1193b) {
                                    if (code < 0x11931) {
                                        // Mc       DIVES AKURU VOWEL SIGN AA
                                        if (0x11930 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x11937) {
                                        // Mc   [5] DIVES AKURU VOWEL SIGN I..DIVES AKURU VOWEL SIGN E
                                        if (0x11931 <= code && code <= 0x11935) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mc   [2] DIVES AKURU VOWEL SIGN AI..DIVES AKURU VOWEL SIGN O
                                        if (0x11937 <= code && code <= 0x11938) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else if (code < 0x1193d) {
                                    // Mn   [2] DIVES AKURU SIGN ANUSVARA..DIVES AKURU SIGN CANDRABINDU
                                    if (0x1193b <= code && code <= 0x1193c) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc       DIVES AKURU SIGN HALANTA
                                    if (0x1193d === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       DIVES AKURU VIRAMA
                                    if (0x1193e === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0x11a01) {
                            if (code < 0x119d1) {
                                if (code < 0x11941) {
                                    // Lo       DIVES AKURU PREFIXED NASAL SIGN
                                    if (0x1193f === code) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                    // Mc       DIVES AKURU MEDIAL YA
                                    if (0x11940 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0x11942) {
                                    // Lo       DIVES AKURU INITIAL RA
                                    if (0x11941 === code) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                } else {
                                    // Mc       DIVES AKURU MEDIAL RA
                                    if (0x11942 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       DIVES AKURU SIGN NUKTA
                                    if (0x11943 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x119dc) {
                                    if (code < 0x119d4) {
                                        // Mc   [3] NANDINAGARI VOWEL SIGN AA..NANDINAGARI VOWEL SIGN II
                                        if (0x119d1 <= code && code <= 0x119d3) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x119da) {
                                        // Mn   [4] NANDINAGARI VOWEL SIGN U..NANDINAGARI VOWEL SIGN VOCALIC RR
                                        if (0x119d4 <= code && code <= 0x119d7) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] NANDINAGARI VOWEL SIGN E..NANDINAGARI VOWEL SIGN AI
                                        if (0x119da <= code && code <= 0x119db) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0x119e0) {
                                    // Mc   [4] NANDINAGARI VOWEL SIGN O..NANDINAGARI SIGN VISARGA
                                    if (0x119dc <= code && code <= 0x119df) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       NANDINAGARI SIGN VIRAMA
                                    if (0x119e0 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    // Mc       NANDINAGARI VOWEL SIGN PRISHTHAMATRA E
                                    if (0x119e4 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            }
                        } else {
                            if (code < 0x11a47) {
                                if (code < 0x11a39) {
                                    if (code < 0x11a33) {
                                        // Mn  [10] ZANABAZAR SQUARE VOWEL SIGN I..ZANABAZAR SQUARE VOWEL LENGTH MARK
                                        if (0x11a01 <= code && code <= 0x11a0a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [6] ZANABAZAR SQUARE FINAL CONSONANT MARK..ZANABAZAR SQUARE SIGN ANUSVARA
                                        if (0x11a33 <= code && code <= 0x11a38) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x11a3a) {
                                        // Mc       ZANABAZAR SQUARE SIGN VISARGA
                                        if (0x11a39 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x11a3b) {
                                        // Lo       ZANABAZAR SQUARE CLUSTER-INITIAL LETTER RA
                                        if (0x11a3a === code) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                    } else {
                                        // Mn   [4] ZANABAZAR SQUARE CLUSTER-FINAL LETTER YA..ZANABAZAR SQUARE CLUSTER-FINAL LETTER VA
                                        if (0x11a3b <= code && code <= 0x11a3e) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x11a59) {
                                if (code < 0x11a51) {
                                    // Mn       ZANABAZAR SQUARE SUBJOINER
                                    if (0x11a47 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x11a57) {
                                    // Mn   [6] SOYOMBO VOWEL SIGN I..SOYOMBO VOWEL SIGN OE
                                    if (0x11a51 <= code && code <= 0x11a56) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [2] SOYOMBO VOWEL SIGN AI..SOYOMBO VOWEL SIGN AU
                                    if (0x11a57 <= code && code <= 0x11a58) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0x11a84) {
                                    // Mn   [3] SOYOMBO VOWEL SIGN VOCALIC R..SOYOMBO VOWEL LENGTH MARK
                                    if (0x11a59 <= code && code <= 0x11a5b) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x11a8a) {
                                    // Lo   [6] SOYOMBO SIGN JIHVAMULIYA..SOYOMBO CLUSTER-INITIAL LETTER SA
                                    if (0x11a84 <= code && code <= 0x11a89) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                } else {
                                    // Mn  [13] SOYOMBO FINAL CONSONANT SIGN G..SOYOMBO SIGN ANUSVARA
                                    if (0x11a8a <= code && code <= 0x11a96) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    }
                } else if (code < 0x16f51) {
                    if (code < 0x11d90) {
                        if (code < 0x11cb1) {
                            if (code < 0x11c3e) {
                                if (code < 0x11c2f) {
                                    if (code < 0x11a98) {
                                        // Mc       SOYOMBO SIGN VISARGA
                                        if (0x11a97 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] SOYOMBO GEMINATION MARK..SOYOMBO SUBJOINER
                                        if (0x11a98 <= code && code <= 0x11a99) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x11c30) {
                                        // Mc       BHAIKSUKI VOWEL SIGN AA
                                        if (0x11c2f === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x11c38) {
                                        // Mn   [7] BHAIKSUKI VOWEL SIGN I..BHAIKSUKI VOWEL SIGN VOCALIC L
                                        if (0x11c30 <= code && code <= 0x11c36) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [6] BHAIKSUKI VOWEL SIGN E..BHAIKSUKI SIGN ANUSVARA
                                        if (0x11c38 <= code && code <= 0x11c3d) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x11c92) {
                                // Mc       BHAIKSUKI SIGN VISARGA
                                if (0x11c3e === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                // Mn       BHAIKSUKI SIGN VIRAMA
                                if (0x11c3f === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                if (code < 0x11ca9) {
                                    // Mn  [22] MARCHEN SUBJOINED LETTER KA..MARCHEN SUBJOINED LETTER ZA
                                    if (0x11c92 <= code && code <= 0x11ca7) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x11caa) {
                                    // Mc       MARCHEN SUBJOINED LETTER YA
                                    if (0x11ca9 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn   [7] MARCHEN SUBJOINED LETTER RA..MARCHEN VOWEL SIGN AA
                                    if (0x11caa <= code && code <= 0x11cb0) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0x11d3a) {
                                if (code < 0x11cb4) {
                                    if (code < 0x11cb2) {
                                        // Mc       MARCHEN VOWEL SIGN I
                                        if (0x11cb1 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] MARCHEN VOWEL SIGN U..MARCHEN VOWEL SIGN E
                                        if (0x11cb2 <= code && code <= 0x11cb3) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x11cb5) {
                                        // Mc       MARCHEN VOWEL SIGN O
                                        if (0x11cb4 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x11d31) {
                                        // Mn   [2] MARCHEN SIGN ANUSVARA..MARCHEN SIGN CANDRABINDU
                                        if (0x11cb5 <= code && code <= 0x11cb6) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [6] MASARAM GONDI VOWEL SIGN AA..MASARAM GONDI VOWEL SIGN VOCALIC R
                                        if (0x11d31 <= code && code <= 0x11d36) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x11d46) {
                                if (code < 0x11d3c) {
                                    // Mn       MASARAM GONDI VOWEL SIGN E
                                    if (0x11d3a === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x11d3f) {
                                    // Mn   [2] MASARAM GONDI VOWEL SIGN AI..MASARAM GONDI VOWEL SIGN O
                                    if (0x11d3c <= code && code <= 0x11d3d) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [7] MASARAM GONDI VOWEL SIGN AU..MASARAM GONDI VIRAMA
                                    if (0x11d3f <= code && code <= 0x11d45) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x11d47) {
                                    // Lo       MASARAM GONDI REPHA
                                    if (0x11d46 === code) return $lXl8C.CLUSTER_BREAK.PREPEND;
                                } else if (code < 0x11d8a) {
                                    // Mn       MASARAM GONDI RA-KARA
                                    if (0x11d47 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [5] GUNJALA GONDI VOWEL SIGN AA..GUNJALA GONDI VOWEL SIGN UU
                                    if (0x11d8a <= code && code <= 0x11d8e) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            }
                        }
                    } else if (code < 0x11f36) {
                        if (code < 0x11ef3) {
                            if (code < 0x11d95) {
                                if (code < 0x11d93) {
                                    // Mn   [2] GUNJALA GONDI VOWEL SIGN EE..GUNJALA GONDI VOWEL SIGN AI
                                    if (0x11d90 <= code && code <= 0x11d91) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [2] GUNJALA GONDI VOWEL SIGN OO..GUNJALA GONDI VOWEL SIGN AU
                                    if (0x11d93 <= code && code <= 0x11d94) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else if (code < 0x11d96) {
                                // Mn       GUNJALA GONDI SIGN ANUSVARA
                                if (0x11d95 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mc       GUNJALA GONDI SIGN VISARGA
                                if (0x11d96 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                // Mn       GUNJALA GONDI VIRAMA
                                if (0x11d97 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (code < 0x11f02) {
                            if (code < 0x11ef5) {
                                // Mn   [2] MAKASAR VOWEL SIGN I..MAKASAR VOWEL SIGN U
                                if (0x11ef3 <= code && code <= 0x11ef4) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x11f00) {
                                // Mc   [2] MAKASAR VOWEL SIGN E..MAKASAR VOWEL SIGN O
                                if (0x11ef5 <= code && code <= 0x11ef6) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                            } else {
                                // Mn   [2] KAWI SIGN CANDRABINDU..KAWI SIGN ANUSVARA
                                if (0x11f00 <= code && code <= 0x11f01) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        } else {
                            if (code < 0x11f03) {
                                // Lo       KAWI SIGN REPHA
                                if (0x11f02 === code) return $lXl8C.CLUSTER_BREAK.PREPEND;
                            } else if (code < 0x11f34) {
                                // Mc       KAWI SIGN VISARGA
                                if (0x11f03 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                            } else {
                                // Mc   [2] KAWI VOWEL SIGN AA..KAWI VOWEL SIGN ALTERNATE AA
                                if (0x11f34 <= code && code <= 0x11f35) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                            }
                        }
                    } else {
                        if (code < 0x13430) {
                            if (code < 0x11f40) {
                                if (code < 0x11f3e) {
                                    // Mn   [5] KAWI VOWEL SIGN I..KAWI VOWEL SIGN VOCALIC R
                                    if (0x11f36 <= code && code <= 0x11f3a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [2] KAWI VOWEL SIGN E..KAWI VOWEL SIGN AI
                                    if (0x11f3e <= code && code <= 0x11f3f) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else if (code < 0x11f41) {
                                // Mn       KAWI VOWEL SIGN EU
                                if (0x11f40 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mc       KAWI SIGN KILLER
                                if (0x11f41 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                // Mn       KAWI CONJOINER
                                if (0x11f42 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (code < 0x16af0) {
                            if (code < 0x13440) {
                                // Cf  [16] EGYPTIAN HIEROGLYPH VERTICAL JOINER..EGYPTIAN HIEROGLYPH END WALLED ENCLOSURE
                                if (0x13430 <= code && code <= 0x1343f) return $lXl8C.CLUSTER_BREAK.CONTROL;
                            } else if (code < 0x13447) {
                                // Mn       EGYPTIAN HIEROGLYPH MIRROR HORIZONTALLY
                                if (0x13440 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn  [15] EGYPTIAN HIEROGLYPH MODIFIER DAMAGED AT TOP START..EGYPTIAN HIEROGLYPH MODIFIER DAMAGED
                                if (0x13447 <= code && code <= 0x13455) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        } else {
                            if (code < 0x16b30) {
                                // Mn   [5] BASSA VAH COMBINING HIGH TONE..BASSA VAH COMBINING HIGH-LOW TONE
                                if (0x16af0 <= code && code <= 0x16af4) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x16f4f) {
                                // Mn   [7] PAHAWH HMONG MARK CIM TUB..PAHAWH HMONG MARK CIM TAUM
                                if (0x16b30 <= code && code <= 0x16b36) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn       MIAO SIGN CONSONANT MODIFIER BAR
                                if (0x16f4f === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        }
                    }
                } else {
                    if (code < 0x1da84) {
                        if (code < 0x1d167) {
                            if (code < 0x1bca0) {
                                if (code < 0x16fe4) {
                                    if (code < 0x16f8f) {
                                        // Mc  [55] MIAO SIGN ASPIRATION..MIAO VOWEL SIGN UI
                                        if (0x16f51 <= code && code <= 0x16f87) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [4] MIAO TONE RIGHT..MIAO TONE BELOW
                                        if (0x16f8f <= code && code <= 0x16f92) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x16ff0) {
                                        // Mn       KHITAN SMALL SCRIPT FILLER
                                        if (0x16fe4 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x1bc9d) {
                                        // Mc   [2] VIETNAMESE ALTERNATE READING MARK CA..VIETNAMESE ALTERNATE READING MARK NHAY
                                        if (0x16ff0 <= code && code <= 0x16ff1) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] DUPLOYAN THICK LETTER SELECTOR..DUPLOYAN DOUBLE MARK
                                        if (0x1bc9d <= code && code <= 0x1bc9e) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0x1cf30) {
                                    if (code < 0x1cf00) {
                                        // Cf   [4] SHORTHAND FORMAT LETTER OVERLAP..SHORTHAND FORMAT UP STEP
                                        if (0x1bca0 <= code && code <= 0x1bca3) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                    } else {
                                        // Mn  [46] ZNAMENNY COMBINING MARK GORAZDO NIZKO S KRYZHEM ON LEFT..ZNAMENNY COMBINING MARK KRYZH ON LEFT
                                        if (0x1cf00 <= code && code <= 0x1cf2d) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0x1d165) {
                                    // Mn  [23] ZNAMENNY COMBINING TONAL RANGE MARK MRACHNO..ZNAMENNY PRIZNAK MODIFIER ROG
                                    if (0x1cf30 <= code && code <= 0x1cf46) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc       MUSICAL SYMBOL COMBINING STEM
                                    if (0x1d165 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    // Mc       MUSICAL SYMBOL COMBINING SPRECHGESANG STEM
                                    if (0x1d166 === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                }
                            }
                        } else {
                            if (code < 0x1d185) {
                                if (code < 0x1d16e) {
                                    if (code < 0x1d16d) {
                                        // Mn   [3] MUSICAL SYMBOL COMBINING TREMOLO-1..MUSICAL SYMBOL COMBINING TREMOLO-3
                                        if (0x1d167 <= code && code <= 0x1d169) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc       MUSICAL SYMBOL COMBINING AUGMENTATION DOT
                                        if (0x1d16d === code) return $lXl8C.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0x1d173) {
                                        // Mc   [5] MUSICAL SYMBOL COMBINING FLAG-1..MUSICAL SYMBOL COMBINING FLAG-5
                                        if (0x1d16e <= code && code <= 0x1d172) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x1d17b) {
                                        // Cf   [8] MUSICAL SYMBOL BEGIN BEAM..MUSICAL SYMBOL END PHRASE
                                        if (0x1d173 <= code && code <= 0x1d17a) return $lXl8C.CLUSTER_BREAK.CONTROL;
                                    } else {
                                        // Mn   [8] MUSICAL SYMBOL COMBINING ACCENT..MUSICAL SYMBOL COMBINING LOURE
                                        if (0x1d17b <= code && code <= 0x1d182) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x1da00) {
                                if (code < 0x1d1aa) {
                                    // Mn   [7] MUSICAL SYMBOL COMBINING DOIT..MUSICAL SYMBOL COMBINING TRIPLE TONGUE
                                    if (0x1d185 <= code && code <= 0x1d18b) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1d242) {
                                    // Mn   [4] MUSICAL SYMBOL COMBINING DOWN BOW..MUSICAL SYMBOL COMBINING SNAP PIZZICATO
                                    if (0x1d1aa <= code && code <= 0x1d1ad) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [3] COMBINING GREEK MUSICAL TRISEME..COMBINING GREEK MUSICAL PENTASEME
                                    if (0x1d242 <= code && code <= 0x1d244) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x1da3b) {
                                    // Mn  [55] SIGNWRITING HEAD RIM..SIGNWRITING AIR SUCKING IN
                                    if (0x1da00 <= code && code <= 0x1da36) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1da75) {
                                    // Mn  [50] SIGNWRITING MOUTH CLOSED NEUTRAL..SIGNWRITING EXCITEMENT
                                    if (0x1da3b <= code && code <= 0x1da6c) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       SIGNWRITING UPPER BODY TILTING FROM HIP JOINTS
                                    if (0x1da75 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    } else if (code < 0x1e2ec) {
                        if (code < 0x1e01b) {
                            if (code < 0x1daa1) {
                                if (code < 0x1da9b) {
                                    // Mn       SIGNWRITING LOCATION HEAD NECK
                                    if (0x1da84 === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [5] SIGNWRITING FILL MODIFIER-2..SIGNWRITING FILL MODIFIER-6
                                    if (0x1da9b <= code && code <= 0x1da9f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x1e000) {
                                    // Mn  [15] SIGNWRITING ROTATION MODIFIER-2..SIGNWRITING ROTATION MODIFIER-16
                                    if (0x1daa1 <= code && code <= 0x1daaf) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1e008) {
                                    // Mn   [7] COMBINING GLAGOLITIC LETTER AZU..COMBINING GLAGOLITIC LETTER ZHIVETE
                                    if (0x1e000 <= code && code <= 0x1e006) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn  [17] COMBINING GLAGOLITIC LETTER ZEMLJA..COMBINING GLAGOLITIC LETTER HERU
                                    if (0x1e008 <= code && code <= 0x1e018) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0x1e08f) {
                            if (code < 0x1e023) {
                                // Mn   [7] COMBINING GLAGOLITIC LETTER SHTA..COMBINING GLAGOLITIC LETTER YATI
                                if (0x1e01b <= code && code <= 0x1e021) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x1e026) {
                                // Mn   [2] COMBINING GLAGOLITIC LETTER YU..COMBINING GLAGOLITIC LETTER SMALL YUS
                                if (0x1e023 <= code && code <= 0x1e024) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn   [5] COMBINING GLAGOLITIC LETTER YO..COMBINING GLAGOLITIC LETTER FITA
                                if (0x1e026 <= code && code <= 0x1e02a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        } else {
                            if (code < 0x1e130) {
                                // Mn       COMBINING CYRILLIC SMALL LETTER BYELORUSSIAN-UKRAINIAN I
                                if (0x1e08f === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x1e2ae) {
                                // Mn   [7] NYIAKENG PUACHUE HMONG TONE-B..NYIAKENG PUACHUE HMONG TONE-D
                                if (0x1e130 <= code && code <= 0x1e136) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn       TOTO SIGN RISING TONE
                                if (0x1e2ae === code) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        }
                    } else {
                        if (code < 0x1f3fb) {
                            if (code < 0x1e8d0) {
                                if (code < 0x1e4ec) {
                                    // Mn   [4] WANCHO TONE TUP..WANCHO TONE KOINI
                                    if (0x1e2ec <= code && code <= 0x1e2ef) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [4] NAG MUNDARI SIGN MUHOR..NAG MUNDARI SIGN SUTUH
                                    if (0x1e4ec <= code && code <= 0x1e4ef) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x1e944) {
                                    // Mn   [7] MENDE KIKAKUI COMBINING NUMBER TEENS..MENDE KIKAKUI COMBINING NUMBER MILLIONS
                                    if (0x1e8d0 <= code && code <= 0x1e8d6) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1f1e6) {
                                    // Mn   [7] ADLAM ALIF LENGTHENER..ADLAM NUKTA
                                    if (0x1e944 <= code && code <= 0x1e94a) return $lXl8C.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // So  [26] REGIONAL INDICATOR SYMBOL LETTER A..REGIONAL INDICATOR SYMBOL LETTER Z
                                    if (0x1f1e6 <= code && code <= 0x1f1ff) return $lXl8C.CLUSTER_BREAK.REGIONAL_INDICATOR;
                                }
                            }
                        } else if (code < 0xe0080) {
                            if (code < 0xe0000) {
                                // Sk   [5] EMOJI MODIFIER FITZPATRICK TYPE-1-2..EMOJI MODIFIER FITZPATRICK TYPE-6
                                if (0x1f3fb <= code && code <= 0x1f3ff) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0xe0020) {
                                // Cn       <reserved-E0000>
                                // Cf       LANGUAGE TAG
                                // Cn  [30] <reserved-E0002>..<reserved-E001F>
                                if (0xe0000 <= code && code <= 0xe001f) return $lXl8C.CLUSTER_BREAK.CONTROL;
                            } else {
                                // Cf  [96] TAG SPACE..CANCEL TAG
                                if (0xe0020 <= code && code <= 0xe007f) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            }
                        } else {
                            if (code < 0xe0100) {
                                // Cn [128] <reserved-E0080>..<reserved-E00FF>
                                if (0xe0080 <= code && code <= 0xe00ff) return $lXl8C.CLUSTER_BREAK.CONTROL;
                            } else if (code < 0xe01f0) {
                                // Mn [240] VARIATION SELECTOR-17..VARIATION SELECTOR-256
                                if (0xe0100 <= code && code <= 0xe01ef) return $lXl8C.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Cn [3600] <reserved-E01F0>..<reserved-E0FFF>
                                if (0xe01f0 <= code && code <= 0xe0fff) return $lXl8C.CLUSTER_BREAK.CONTROL;
                            }
                        }
                    }
                }
            }
        }
        // unlisted code points are treated as a break property of "Other"
        return $lXl8C.CLUSTER_BREAK.OTHER;
    }
    /**
     * Given a Unicode code point, returns if symbol is an extended pictographic or some other break
     * @param code {number} Unicode code point
     * @returns {number}
     */ static getEmojiProperty(code) {
        // emoji property taken from:
        // https://www.unicode.org/Public/UCD/latest/ucd/emoji/emoji-data.txt
        // and generated by
        // node ./scripts/generate-emoji-extended-pictographic.js
        if (code < 0x27b0) {
            if (code < 0x2600) {
                if (code < 0x2328) {
                    if (code < 0x2122) {
                        if (code < 0x203c) {
                            // E0.6   [1] (©️)       copyright
                            if (0xa9 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            // E0.6   [1] (®️)       registered
                            if (0xae === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [1] (‼️)       double exclamation mark
                            if (0x203c === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            // E0.6   [1] (⁉️)       exclamation question mark
                            if (0x2049 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    } else if (code < 0x2194) {
                        // E0.6   [1] (™️)       trade mark
                        if (0x2122 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        // E0.6   [1] (ℹ️)       information
                        if (0x2139 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else {
                        if (code < 0x21a9) {
                            // E0.6   [6] (↔️..↙️)    left-right arrow..down-left arrow
                            if (0x2194 <= code && code <= 0x2199) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x231a) {
                            // E0.6   [2] (↩️..↪️)    right arrow curving left..left arrow curving right
                            if (0x21a9 <= code && code <= 0x21aa) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [2] (⌚..⌛)    watch..hourglass done
                            if (0x231a <= code && code <= 0x231b) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                } else {
                    if (code < 0x24c2) {
                        if (code < 0x23cf) {
                            // E1.0   [1] (⌨️)       keyboard
                            if (0x2328 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            // E0.0   [1] (⎈)       HELM SYMBOL
                            if (0x2388 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            if (code < 0x23e9) {
                                // E1.0   [1] (⏏️)       eject button
                                if (0x23cf === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            } else if (code < 0x23f8) {
                                // E0.6   [4] (⏩..⏬)    fast-forward button..fast down button
                                // E0.7   [2] (⏭️..⏮️)    next track button..last track button
                                // E1.0   [1] (⏯️)       play or pause button
                                // E0.6   [1] (⏰)       alarm clock
                                // E1.0   [2] (⏱️..⏲️)    stopwatch..timer clock
                                // E0.6   [1] (⏳)       hourglass not done
                                if (0x23e9 <= code && code <= 0x23f3) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            } else {
                                // E0.7   [3] (⏸️..⏺️)    pause button..record button
                                if (0x23f8 <= code && code <= 0x23fa) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            }
                        }
                    } else if (code < 0x25b6) {
                        if (code < 0x25aa) {
                            // E0.6   [1] (Ⓜ️)       circled M
                            if (0x24c2 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [2] (▪️..▫️)    black small square..white small square
                            if (0x25aa <= code && code <= 0x25ab) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x25c0) {
                            // E0.6   [1] (▶️)       play button
                            if (0x25b6 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x25fb) {
                            // E0.6   [1] (◀️)       reverse button
                            if (0x25c0 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [4] (◻️..◾)    white medium square..black medium-small square
                            if (0x25fb <= code && code <= 0x25fe) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                }
            } else if (code < 0x2733) {
                if (code < 0x2714) {
                    if (code < 0x2614) {
                        if (code < 0x2607) {
                            // E0.6   [2] (☀️..☁️)    sun..cloud
                            // E0.7   [2] (☂️..☃️)    umbrella..snowman
                            // E1.0   [1] (☄️)       comet
                            // E0.0   [1] (★)       BLACK STAR
                            if (0x2600 <= code && code <= 0x2605) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.0   [7] (☇..☍)    LIGHTNING..OPPOSITION
                            // E0.6   [1] (☎️)       telephone
                            // E0.0   [2] (☏..☐)    WHITE TELEPHONE..BALLOT BOX
                            // E0.6   [1] (☑️)       check box with check
                            // E0.0   [1] (☒)       BALLOT BOX WITH X
                            if (0x2607 <= code && code <= 0x2612) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x2690) {
                            // E0.6   [2] (☔..☕)    umbrella with rain drops..hot beverage
                            // E0.0   [2] (☖..☗)    WHITE SHOGI PIECE..BLACK SHOGI PIECE
                            // E1.0   [1] (☘️)       shamrock
                            // E0.0   [4] (☙..☜)    REVERSED ROTATED FLORAL HEART BULLET..WHITE LEFT POINTING INDEX
                            // E0.6   [1] (☝️)       index pointing up
                            // E0.0   [2] (☞..☟)    WHITE RIGHT POINTING INDEX..WHITE DOWN POINTING INDEX
                            // E1.0   [1] (☠️)       skull and crossbones
                            // E0.0   [1] (☡)       CAUTION SIGN
                            // E1.0   [2] (☢️..☣️)    radioactive..biohazard
                            // E0.0   [2] (☤..☥)    CADUCEUS..ANKH
                            // E1.0   [1] (☦️)       orthodox cross
                            // E0.0   [3] (☧..☩)    CHI RHO..CROSS OF JERUSALEM
                            // E0.7   [1] (☪️)       star and crescent
                            // E0.0   [3] (☫..☭)    FARSI SYMBOL..HAMMER AND SICKLE
                            // E1.0   [1] (☮️)       peace symbol
                            // E0.7   [1] (☯️)       yin yang
                            // E0.0   [8] (☰..☷)    TRIGRAM FOR HEAVEN..TRIGRAM FOR EARTH
                            // E0.7   [2] (☸️..☹️)    wheel of dharma..frowning face
                            // E0.6   [1] (☺️)       smiling face
                            // E0.0   [5] (☻..☿)    BLACK SMILING FACE..MERCURY
                            // E4.0   [1] (♀️)       female sign
                            // E0.0   [1] (♁)       EARTH
                            // E4.0   [1] (♂️)       male sign
                            // E0.0   [5] (♃..♇)    JUPITER..PLUTO
                            // E0.6  [12] (♈..♓)    Aries..Pisces
                            // E0.0  [11] (♔..♞)    WHITE CHESS KING..BLACK CHESS KNIGHT
                            // E11.0  [1] (♟️)       chess pawn
                            // E0.6   [1] (♠️)       spade suit
                            // E0.0   [2] (♡..♢)    WHITE HEART SUIT..WHITE DIAMOND SUIT
                            // E0.6   [1] (♣️)       club suit
                            // E0.0   [1] (♤)       WHITE SPADE SUIT
                            // E0.6   [2] (♥️..♦️)    heart suit..diamond suit
                            // E0.0   [1] (♧)       WHITE CLUB SUIT
                            // E0.6   [1] (♨️)       hot springs
                            // E0.0  [18] (♩..♺)    QUARTER NOTE..RECYCLING SYMBOL FOR GENERIC MATERIALS
                            // E0.6   [1] (♻️)       recycling symbol
                            // E0.0   [2] (♼..♽)    RECYCLED PAPER SYMBOL..PARTIALLY-RECYCLED PAPER SYMBOL
                            // E11.0  [1] (♾️)       infinity
                            // E0.6   [1] (♿)       wheelchair symbol
                            // E0.0   [6] (⚀..⚅)    DIE FACE-1..DIE FACE-6
                            if (0x2614 <= code && code <= 0x2685) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x2708) {
                            // E0.0   [2] (⚐..⚑)    WHITE FLAG..BLACK FLAG
                            // E1.0   [1] (⚒️)       hammer and pick
                            // E0.6   [1] (⚓)       anchor
                            // E1.0   [1] (⚔️)       crossed swords
                            // E4.0   [1] (⚕️)       medical symbol
                            // E1.0   [2] (⚖️..⚗️)    balance scale..alembic
                            // E0.0   [1] (⚘)       FLOWER
                            // E1.0   [1] (⚙️)       gear
                            // E0.0   [1] (⚚)       STAFF OF HERMES
                            // E1.0   [2] (⚛️..⚜️)    atom symbol..fleur-de-lis
                            // E0.0   [3] (⚝..⚟)    OUTLINED WHITE STAR..THREE LINES CONVERGING LEFT
                            // E0.6   [2] (⚠️..⚡)    warning..high voltage
                            // E0.0   [5] (⚢..⚦)    DOUBLED FEMALE SIGN..MALE WITH STROKE SIGN
                            // E13.0  [1] (⚧️)       transgender symbol
                            // E0.0   [2] (⚨..⚩)    VERTICAL MALE WITH STROKE SIGN..HORIZONTAL MALE WITH STROKE SIGN
                            // E0.6   [2] (⚪..⚫)    white circle..black circle
                            // E0.0   [4] (⚬..⚯)    MEDIUM SMALL WHITE CIRCLE..UNMARRIED PARTNERSHIP SYMBOL
                            // E1.0   [2] (⚰️..⚱️)    coffin..funeral urn
                            // E0.0  [11] (⚲..⚼)    NEUTER..SESQUIQUADRATE
                            // E0.6   [2] (⚽..⚾)    soccer ball..baseball
                            // E0.0   [5] (⚿..⛃)    SQUARED KEY..BLACK DRAUGHTS KING
                            // E0.6   [2] (⛄..⛅)    snowman without snow..sun behind cloud
                            // E0.0   [2] (⛆..⛇)    RAIN..BLACK SNOWMAN
                            // E0.7   [1] (⛈️)       cloud with lightning and rain
                            // E0.0   [5] (⛉..⛍)    TURNED WHITE SHOGI PIECE..DISABLED CAR
                            // E0.6   [1] (⛎)       Ophiuchus
                            // E0.7   [1] (⛏️)       pick
                            // E0.0   [1] (⛐)       CAR SLIDING
                            // E0.7   [1] (⛑️)       rescue worker’s helmet
                            // E0.0   [1] (⛒)       CIRCLED CROSSING LANES
                            // E0.7   [1] (⛓️)       chains
                            // E0.6   [1] (⛔)       no entry
                            // E0.0  [20] (⛕..⛨)    ALTERNATE ONE-WAY LEFT WAY TRAFFIC..BLACK CROSS ON SHIELD
                            // E0.7   [1] (⛩️)       shinto shrine
                            // E0.6   [1] (⛪)       church
                            // E0.0   [5] (⛫..⛯)    CASTLE..MAP SYMBOL FOR LIGHTHOUSE
                            // E0.7   [2] (⛰️..⛱️)    mountain..umbrella on ground
                            // E0.6   [2] (⛲..⛳)    fountain..flag in hole
                            // E0.7   [1] (⛴️)       ferry
                            // E0.6   [1] (⛵)       sailboat
                            // E0.0   [1] (⛶)       SQUARE FOUR CORNERS
                            // E0.7   [3] (⛷️..⛹️)    skier..person bouncing ball
                            // E0.6   [1] (⛺)       tent
                            // E0.0   [2] (⛻..⛼)    JAPANESE BANK SYMBOL..HEADSTONE GRAVEYARD SYMBOL
                            // E0.6   [1] (⛽)       fuel pump
                            // E0.0   [4] (⛾..✁)    CUP ON BLACK SQUARE..UPPER BLADE SCISSORS
                            // E0.6   [1] (✂️)       scissors
                            // E0.0   [2] (✃..✄)    LOWER BLADE SCISSORS..WHITE SCISSORS
                            // E0.6   [1] (✅)       check mark button
                            if (0x2690 <= code && code <= 0x2705) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [5] (✈️..✌️)    airplane..victory hand
                            // E0.7   [1] (✍️)       writing hand
                            // E0.0   [1] (✎)       LOWER RIGHT PENCIL
                            // E0.6   [1] (✏️)       pencil
                            // E0.0   [2] (✐..✑)    UPPER RIGHT PENCIL..WHITE NIB
                            // E0.6   [1] (✒️)       black nib
                            if (0x2708 <= code && code <= 0x2712) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                } else {
                    if (code < 0x271d) {
                        // E0.6   [1] (✔️)       check mark
                        if (0x2714 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        // E0.6   [1] (✖️)       multiply
                        if (0x2716 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else if (code < 0x2721) {
                        // E0.7   [1] (✝️)       latin cross
                        if (0x271d === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.7   [1] (✡️)       star of David
                        if (0x2721 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        // E0.6   [1] (✨)       sparkles
                        if (0x2728 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    }
                }
            } else {
                if (code < 0x2753) {
                    if (code < 0x2747) {
                        if (code < 0x2744) {
                            // E0.6   [2] (✳️..✴️)    eight-spoked asterisk..eight-pointed star
                            if (0x2733 <= code && code <= 0x2734) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [1] (❄️)       snowflake
                            if (0x2744 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    } else if (code < 0x274c) {
                        // E0.6   [1] (❇️)       sparkle
                        if (0x2747 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.6   [1] (❌)       cross mark
                        if (0x274c === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        // E0.6   [1] (❎)       cross mark button
                        if (0x274e === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    }
                } else if (code < 0x2763) {
                    if (code < 0x2757) {
                        // E0.6   [3] (❓..❕)    red question mark..white exclamation mark
                        if (0x2753 <= code && code <= 0x2755) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.6   [1] (❗)       red exclamation mark
                        if (0x2757 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    }
                } else {
                    if (code < 0x2795) {
                        // E1.0   [1] (❣️)       heart exclamation
                        // E0.6   [1] (❤️)       red heart
                        // E0.0   [3] (❥..❧)    ROTATED HEAVY BLACK HEART BULLET..ROTATED FLORAL HEART BULLET
                        if (0x2763 <= code && code <= 0x2767) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else if (code < 0x27a1) {
                        // E0.6   [3] (➕..➗)    plus..divide
                        if (0x2795 <= code && code <= 0x2797) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.6   [1] (➡️)       right arrow
                        if (0x27a1 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    }
                }
            }
        } else {
            if (code < 0x1f201) {
                if (code < 0x3297) {
                    if (code < 0x2b1b) {
                        if (code < 0x2934) {
                            // E0.6   [1] (➰)       curly loop
                            if (0x27b0 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            // E1.0   [1] (➿)       double curly loop
                            if (0x27bf === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x2b05) {
                            // E0.6   [2] (⤴️..⤵️)    right arrow curving up..right arrow curving down
                            if (0x2934 <= code && code <= 0x2935) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [3] (⬅️..⬇️)    left arrow..down arrow
                            if (0x2b05 <= code && code <= 0x2b07) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x2b55) {
                            if (code < 0x2b50) {
                                // E0.6   [2] (⬛..⬜)    black large square..white large square
                                if (0x2b1b <= code && code <= 0x2b1c) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            } else {
                                // E0.6   [1] (⭐)       star
                                if (0x2b50 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            }
                        } else if (code < 0x3030) {
                            // E0.6   [1] (⭕)       hollow red circle
                            if (0x2b55 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [1] (〰️)       wavy dash
                            if (0x3030 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            // E0.6   [1] (〽️)       part alternation mark
                            if (0x303d === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                } else {
                    if (code < 0x1f16c) {
                        if (code < 0x1f000) {
                            // E0.6   [1] (㊗️)       Japanese “congratulations” button
                            if (0x3297 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            // E0.6   [1] (㊙️)       Japanese “secret” button
                            if (0x3299 === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            if (code < 0x1f10d) {
                                // E0.0   [4] (🀀..🀃)    MAHJONG TILE EAST WIND..MAHJONG TILE NORTH WIND
                                // E0.6   [1] (🀄)       mahjong red dragon
                                // E0.0 [202] (🀅..🃎)    MAHJONG TILE GREEN DRAGON..PLAYING CARD KING OF DIAMONDS
                                // E0.6   [1] (🃏)       joker
                                // E0.0  [48] (🃐..🃿)    <reserved-1F0D0>..<reserved-1F0FF>
                                if (0x1f000 <= code && code <= 0x1f0ff) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            } else if (code < 0x1f12f) {
                                // E0.0   [3] (🄍..🄏)    CIRCLED ZERO WITH SLASH..CIRCLED DOLLAR SIGN WITH OVERLAID BACKSLASH
                                if (0x1f10d <= code && code <= 0x1f10f) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            } else {
                                // E0.0   [1] (🄯)       COPYLEFT SYMBOL
                                if (0x1f12f === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                            }
                        }
                    } else if (code < 0x1f18e) {
                        if (code < 0x1f17e) {
                            // E0.0   [4] (🅬..🅯)    RAISED MR SIGN..CIRCLED HUMAN FIGURE
                            // E0.6   [2] (🅰️..🅱️)    A button (blood type)..B button (blood type)
                            if (0x1f16c <= code && code <= 0x1f171) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [2] (🅾️..🅿️)    O button (blood type)..P button
                            if (0x1f17e <= code && code <= 0x1f17f) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x1f191) {
                            // E0.6   [1] (🆎)       AB button (blood type)
                            if (0x1f18e === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x1f1ad) {
                            // E0.6  [10] (🆑..🆚)    CL button..VS button
                            if (0x1f191 <= code && code <= 0x1f19a) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.0  [57] (🆭..🇥)    MASK WORK SYMBOL..<reserved-1F1E5>
                            if (0x1f1ad <= code && code <= 0x1f1e5) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                }
            } else if (code < 0x1f7d5) {
                if (code < 0x1f249) {
                    if (code < 0x1f22f) {
                        if (code < 0x1f21a) {
                            // E0.6   [2] (🈁..🈂️)    Japanese “here” button..Japanese “service charge” button
                            // E0.0  [13] (🈃..🈏)    <reserved-1F203>..<reserved-1F20F>
                            if (0x1f201 <= code && code <= 0x1f20f) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [1] (🈚)       Japanese “free of charge” button
                            if (0x1f21a === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x1f232) {
                            // E0.6   [1] (🈯)       Japanese “reserved” button
                            if (0x1f22f === code) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x1f23c) {
                            // E0.6   [9] (🈲..🈺)    Japanese “prohibited” button..Japanese “open for business” button
                            if (0x1f232 <= code && code <= 0x1f23a) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.0   [4] (🈼..🈿)    <reserved-1F23C>..<reserved-1F23F>
                            if (0x1f23c <= code && code <= 0x1f23f) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                } else if (code < 0x1f546) {
                    if (code < 0x1f400) {
                        // E0.0   [7] (🉉..🉏)    <reserved-1F249>..<reserved-1F24F>
                        // E0.6   [2] (🉐..🉑)    Japanese “bargain” button..Japanese “acceptable” button
                        // E0.0 [174] (🉒..🋿)    <reserved-1F252>..<reserved-1F2FF>
                        // E0.6  [13] (🌀..🌌)    cyclone..milky way
                        // E0.7   [2] (🌍..🌎)    globe showing Europe-Africa..globe showing Americas
                        // E0.6   [1] (🌏)       globe showing Asia-Australia
                        // E1.0   [1] (🌐)       globe with meridians
                        // E0.6   [1] (🌑)       new moon
                        // E1.0   [1] (🌒)       waxing crescent moon
                        // E0.6   [3] (🌓..🌕)    first quarter moon..full moon
                        // E1.0   [3] (🌖..🌘)    waning gibbous moon..waning crescent moon
                        // E0.6   [1] (🌙)       crescent moon
                        // E1.0   [1] (🌚)       new moon face
                        // E0.6   [1] (🌛)       first quarter moon face
                        // E0.7   [1] (🌜)       last quarter moon face
                        // E1.0   [2] (🌝..🌞)    full moon face..sun with face
                        // E0.6   [2] (🌟..🌠)    glowing star..shooting star
                        // E0.7   [1] (🌡️)       thermometer
                        // E0.0   [2] (🌢..🌣)    BLACK DROPLET..WHITE SUN
                        // E0.7   [9] (🌤️..🌬️)    sun behind small cloud..wind face
                        // E1.0   [3] (🌭..🌯)    hot dog..burrito
                        // E0.6   [2] (🌰..🌱)    chestnut..seedling
                        // E1.0   [2] (🌲..🌳)    evergreen tree..deciduous tree
                        // E0.6   [2] (🌴..🌵)    palm tree..cactus
                        // E0.7   [1] (🌶️)       hot pepper
                        // E0.6  [20] (🌷..🍊)    tulip..tangerine
                        // E1.0   [1] (🍋)       lemon
                        // E0.6   [4] (🍌..🍏)    banana..green apple
                        // E1.0   [1] (🍐)       pear
                        // E0.6  [43] (🍑..🍻)    peach..clinking beer mugs
                        // E1.0   [1] (🍼)       baby bottle
                        // E0.7   [1] (🍽️)       fork and knife with plate
                        // E1.0   [2] (🍾..🍿)    bottle with popping cork..popcorn
                        // E0.6  [20] (🎀..🎓)    ribbon..graduation cap
                        // E0.0   [2] (🎔..🎕)    HEART WITH TIP ON THE LEFT..BOUQUET OF FLOWERS
                        // E0.7   [2] (🎖️..🎗️)    military medal..reminder ribbon
                        // E0.0   [1] (🎘)       MUSICAL KEYBOARD WITH JACKS
                        // E0.7   [3] (🎙️..🎛️)    studio microphone..control knobs
                        // E0.0   [2] (🎜..🎝)    BEAMED ASCENDING MUSICAL NOTES..BEAMED DESCENDING MUSICAL NOTES
                        // E0.7   [2] (🎞️..🎟️)    film frames..admission tickets
                        // E0.6  [37] (🎠..🏄)    carousel horse..person surfing
                        // E1.0   [1] (🏅)       sports medal
                        // E0.6   [1] (🏆)       trophy
                        // E1.0   [1] (🏇)       horse racing
                        // E0.6   [1] (🏈)       american football
                        // E1.0   [1] (🏉)       rugby football
                        // E0.6   [1] (🏊)       person swimming
                        // E0.7   [4] (🏋️..🏎️)    person lifting weights..racing car
                        // E1.0   [5] (🏏..🏓)    cricket game..ping pong
                        // E0.7  [12] (🏔️..🏟️)    snow-capped mountain..stadium
                        // E0.6   [4] (🏠..🏣)    house..Japanese post office
                        // E1.0   [1] (🏤)       post office
                        // E0.6  [12] (🏥..🏰)    hospital..castle
                        // E0.0   [2] (🏱..🏲)    WHITE PENNANT..BLACK PENNANT
                        // E0.7   [1] (🏳️)       white flag
                        // E1.0   [1] (🏴)       black flag
                        // E0.7   [1] (🏵️)       rosette
                        // E0.0   [1] (🏶)       BLACK ROSETTE
                        // E0.7   [1] (🏷️)       label
                        // E1.0   [3] (🏸..🏺)    badminton..amphora
                        if (0x1f249 <= code && code <= 0x1f3fa) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E1.0   [8] (🐀..🐇)    rat..rabbit
                        // E0.7   [1] (🐈)       cat
                        // E1.0   [3] (🐉..🐋)    dragon..whale
                        // E0.6   [3] (🐌..🐎)    snail..horse
                        // E1.0   [2] (🐏..🐐)    ram..goat
                        // E0.6   [2] (🐑..🐒)    ewe..monkey
                        // E1.0   [1] (🐓)       rooster
                        // E0.6   [1] (🐔)       chicken
                        // E0.7   [1] (🐕)       dog
                        // E1.0   [1] (🐖)       pig
                        // E0.6  [19] (🐗..🐩)    boar..poodle
                        // E1.0   [1] (🐪)       camel
                        // E0.6  [20] (🐫..🐾)    two-hump camel..paw prints
                        // E0.7   [1] (🐿️)       chipmunk
                        // E0.6   [1] (👀)       eyes
                        // E0.7   [1] (👁️)       eye
                        // E0.6  [35] (👂..👤)    ear..bust in silhouette
                        // E1.0   [1] (👥)       busts in silhouette
                        // E0.6   [6] (👦..👫)    boy..woman and man holding hands
                        // E1.0   [2] (👬..👭)    men holding hands..women holding hands
                        // E0.6  [63] (👮..💬)    police officer..speech balloon
                        // E1.0   [1] (💭)       thought balloon
                        // E0.6   [8] (💮..💵)    white flower..dollar banknote
                        // E1.0   [2] (💶..💷)    euro banknote..pound banknote
                        // E0.6  [52] (💸..📫)    money with wings..closed mailbox with raised flag
                        // E0.7   [2] (📬..📭)    open mailbox with raised flag..open mailbox with lowered flag
                        // E0.6   [1] (📮)       postbox
                        // E1.0   [1] (📯)       postal horn
                        // E0.6   [5] (📰..📴)    newspaper..mobile phone off
                        // E1.0   [1] (📵)       no mobile phones
                        // E0.6   [2] (📶..📷)    antenna bars..camera
                        // E1.0   [1] (📸)       camera with flash
                        // E0.6   [4] (📹..📼)    video camera..videocassette
                        // E0.7   [1] (📽️)       film projector
                        // E0.0   [1] (📾)       PORTABLE STEREO
                        // E1.0   [4] (📿..🔂)    prayer beads..repeat single button
                        // E0.6   [1] (🔃)       clockwise vertical arrows
                        // E1.0   [4] (🔄..🔇)    counterclockwise arrows button..muted speaker
                        // E0.7   [1] (🔈)       speaker low volume
                        // E1.0   [1] (🔉)       speaker medium volume
                        // E0.6  [11] (🔊..🔔)    speaker high volume..bell
                        // E1.0   [1] (🔕)       bell with slash
                        // E0.6  [22] (🔖..🔫)    bookmark..water pistol
                        // E1.0   [2] (🔬..🔭)    microscope..telescope
                        // E0.6  [16] (🔮..🔽)    crystal ball..downwards button
                        if (0x1f400 <= code && code <= 0x1f53d) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    }
                } else {
                    if (code < 0x1f680) {
                        // E0.0   [3] (🕆..🕈)    WHITE LATIN CROSS..CELTIC CROSS
                        // E0.7   [2] (🕉️..🕊️)    om..dove
                        // E1.0   [4] (🕋..🕎)    kaaba..menorah
                        // E0.0   [1] (🕏)       BOWL OF HYGIEIA
                        // E0.6  [12] (🕐..🕛)    one o’clock..twelve o’clock
                        // E0.7  [12] (🕜..🕧)    one-thirty..twelve-thirty
                        // E0.0   [7] (🕨..🕮)    RIGHT SPEAKER..BOOK
                        // E0.7   [2] (🕯️..🕰️)    candle..mantelpiece clock
                        // E0.0   [2] (🕱..🕲)    BLACK SKULL AND CROSSBONES..NO PIRACY
                        // E0.7   [7] (🕳️..🕹️)    hole..joystick
                        // E3.0   [1] (🕺)       man dancing
                        // E0.0  [12] (🕻..🖆)    LEFT HAND TELEPHONE RECEIVER..PEN OVER STAMPED ENVELOPE
                        // E0.7   [1] (🖇️)       linked paperclips
                        // E0.0   [2] (🖈..🖉)    BLACK PUSHPIN..LOWER LEFT PENCIL
                        // E0.7   [4] (🖊️..🖍️)    pen..crayon
                        // E0.0   [2] (🖎..🖏)    LEFT WRITING HAND..TURNED OK HAND SIGN
                        // E0.7   [1] (🖐️)       hand with fingers splayed
                        // E0.0   [4] (🖑..🖔)    REVERSED RAISED HAND WITH FINGERS SPLAYED..REVERSED VICTORY HAND
                        // E1.0   [2] (🖕..🖖)    middle finger..vulcan salute
                        // E0.0  [13] (🖗..🖣)    WHITE DOWN POINTING LEFT HAND INDEX..BLACK DOWN POINTING BACKHAND INDEX
                        // E3.0   [1] (🖤)       black heart
                        // E0.7   [1] (🖥️)       desktop computer
                        // E0.0   [2] (🖦..🖧)    KEYBOARD AND MOUSE..THREE NETWORKED COMPUTERS
                        // E0.7   [1] (🖨️)       printer
                        // E0.0   [8] (🖩..🖰)    POCKET CALCULATOR..TWO BUTTON MOUSE
                        // E0.7   [2] (🖱️..🖲️)    computer mouse..trackball
                        // E0.0   [9] (🖳..🖻)    OLD PERSONAL COMPUTER..DOCUMENT WITH PICTURE
                        // E0.7   [1] (🖼️)       framed picture
                        // E0.0   [5] (🖽..🗁)    FRAME WITH TILES..OPEN FOLDER
                        // E0.7   [3] (🗂️..🗄️)    card index dividers..file cabinet
                        // E0.0  [12] (🗅..🗐)    EMPTY NOTE..PAGES
                        // E0.7   [3] (🗑️..🗓️)    wastebasket..spiral calendar
                        // E0.0   [8] (🗔..🗛)    DESKTOP WINDOW..DECREASE FONT SIZE SYMBOL
                        // E0.7   [3] (🗜️..🗞️)    clamp..rolled-up newspaper
                        // E0.0   [2] (🗟..🗠)    PAGE WITH CIRCLED TEXT..STOCK CHART
                        // E0.7   [1] (🗡️)       dagger
                        // E0.0   [1] (🗢)       LIPS
                        // E0.7   [1] (🗣️)       speaking head
                        // E0.0   [4] (🗤..🗧)    THREE RAYS ABOVE..THREE RAYS RIGHT
                        // E2.0   [1] (🗨️)       left speech bubble
                        // E0.0   [6] (🗩..🗮)    RIGHT SPEECH BUBBLE..LEFT ANGER BUBBLE
                        // E0.7   [1] (🗯️)       right anger bubble
                        // E0.0   [3] (🗰..🗲)    MOOD BUBBLE..LIGHTNING MOOD
                        // E0.7   [1] (🗳️)       ballot box with ballot
                        // E0.0   [6] (🗴..🗹)    BALLOT SCRIPT X..BALLOT BOX WITH BOLD CHECK
                        // E0.7   [1] (🗺️)       world map
                        // E0.6   [5] (🗻..🗿)    mount fuji..moai
                        // E1.0   [1] (😀)       grinning face
                        // E0.6   [6] (😁..😆)    beaming face with smiling eyes..grinning squinting face
                        // E1.0   [2] (😇..😈)    smiling face with halo..smiling face with horns
                        // E0.6   [5] (😉..😍)    winking face..smiling face with heart-eyes
                        // E1.0   [1] (😎)       smiling face with sunglasses
                        // E0.6   [1] (😏)       smirking face
                        // E0.7   [1] (😐)       neutral face
                        // E1.0   [1] (😑)       expressionless face
                        // E0.6   [3] (😒..😔)    unamused face..pensive face
                        // E1.0   [1] (😕)       confused face
                        // E0.6   [1] (😖)       confounded face
                        // E1.0   [1] (😗)       kissing face
                        // E0.6   [1] (😘)       face blowing a kiss
                        // E1.0   [1] (😙)       kissing face with smiling eyes
                        // E0.6   [1] (😚)       kissing face with closed eyes
                        // E1.0   [1] (😛)       face with tongue
                        // E0.6   [3] (😜..😞)    winking face with tongue..disappointed face
                        // E1.0   [1] (😟)       worried face
                        // E0.6   [6] (😠..😥)    angry face..sad but relieved face
                        // E1.0   [2] (😦..😧)    frowning face with open mouth..anguished face
                        // E0.6   [4] (😨..😫)    fearful face..tired face
                        // E1.0   [1] (😬)       grimacing face
                        // E0.6   [1] (😭)       loudly crying face
                        // E1.0   [2] (😮..😯)    face with open mouth..hushed face
                        // E0.6   [4] (😰..😳)    anxious face with sweat..flushed face
                        // E1.0   [1] (😴)       sleeping face
                        // E0.6   [1] (😵)       face with crossed-out eyes
                        // E1.0   [1] (😶)       face without mouth
                        // E0.6  [10] (😷..🙀)    face with medical mask..weary cat
                        // E1.0   [4] (🙁..🙄)    slightly frowning face..face with rolling eyes
                        // E0.6  [11] (🙅..🙏)    person gesturing NO..folded hands
                        if (0x1f546 <= code && code <= 0x1f64f) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else if (code < 0x1f774) {
                        // E0.6   [1] (🚀)       rocket
                        // E1.0   [2] (🚁..🚂)    helicopter..locomotive
                        // E0.6   [3] (🚃..🚅)    railway car..bullet train
                        // E1.0   [1] (🚆)       train
                        // E0.6   [1] (🚇)       metro
                        // E1.0   [1] (🚈)       light rail
                        // E0.6   [1] (🚉)       station
                        // E1.0   [2] (🚊..🚋)    tram..tram car
                        // E0.6   [1] (🚌)       bus
                        // E0.7   [1] (🚍)       oncoming bus
                        // E1.0   [1] (🚎)       trolleybus
                        // E0.6   [1] (🚏)       bus stop
                        // E1.0   [1] (🚐)       minibus
                        // E0.6   [3] (🚑..🚓)    ambulance..police car
                        // E0.7   [1] (🚔)       oncoming police car
                        // E0.6   [1] (🚕)       taxi
                        // E1.0   [1] (🚖)       oncoming taxi
                        // E0.6   [1] (🚗)       automobile
                        // E0.7   [1] (🚘)       oncoming automobile
                        // E0.6   [2] (🚙..🚚)    sport utility vehicle..delivery truck
                        // E1.0   [7] (🚛..🚡)    articulated lorry..aerial tramway
                        // E0.6   [1] (🚢)       ship
                        // E1.0   [1] (🚣)       person rowing boat
                        // E0.6   [2] (🚤..🚥)    speedboat..horizontal traffic light
                        // E1.0   [1] (🚦)       vertical traffic light
                        // E0.6   [7] (🚧..🚭)    construction..no smoking
                        // E1.0   [4] (🚮..🚱)    litter in bin sign..non-potable water
                        // E0.6   [1] (🚲)       bicycle
                        // E1.0   [3] (🚳..🚵)    no bicycles..person mountain biking
                        // E0.6   [1] (🚶)       person walking
                        // E1.0   [2] (🚷..🚸)    no pedestrians..children crossing
                        // E0.6   [6] (🚹..🚾)    men’s room..water closet
                        // E1.0   [1] (🚿)       shower
                        // E0.6   [1] (🛀)       person taking bath
                        // E1.0   [5] (🛁..🛅)    bathtub..left luggage
                        // E0.0   [5] (🛆..🛊)    TRIANGLE WITH ROUNDED CORNERS..GIRLS SYMBOL
                        // E0.7   [1] (🛋️)       couch and lamp
                        // E1.0   [1] (🛌)       person in bed
                        // E0.7   [3] (🛍️..🛏️)    shopping bags..bed
                        // E1.0   [1] (🛐)       place of worship
                        // E3.0   [2] (🛑..🛒)    stop sign..shopping cart
                        // E0.0   [2] (🛓..🛔)    STUPA..PAGODA
                        // E12.0  [1] (🛕)       hindu temple
                        // E13.0  [2] (🛖..🛗)    hut..elevator
                        // E0.0   [4] (🛘..🛛)    <reserved-1F6D8>..<reserved-1F6DB>
                        // E15.0  [1] (🛜)       wireless
                        // E14.0  [3] (🛝..🛟)    playground slide..ring buoy
                        // E0.7   [6] (🛠️..🛥️)    hammer and wrench..motor boat
                        // E0.0   [3] (🛦..🛨)    UP-POINTING MILITARY AIRPLANE..UP-POINTING SMALL AIRPLANE
                        // E0.7   [1] (🛩️)       small airplane
                        // E0.0   [1] (🛪)       NORTHEAST-POINTING AIRPLANE
                        // E1.0   [2] (🛫..🛬)    airplane departure..airplane arrival
                        // E0.0   [3] (🛭..🛯)    <reserved-1F6ED>..<reserved-1F6EF>
                        // E0.7   [1] (🛰️)       satellite
                        // E0.0   [2] (🛱..🛲)    ONCOMING FIRE ENGINE..DIESEL LOCOMOTIVE
                        // E0.7   [1] (🛳️)       passenger ship
                        // E3.0   [3] (🛴..🛶)    kick scooter..canoe
                        // E5.0   [2] (🛷..🛸)    sled..flying saucer
                        // E11.0  [1] (🛹)       skateboard
                        // E12.0  [1] (🛺)       auto rickshaw
                        // E13.0  [2] (🛻..🛼)    pickup truck..roller skate
                        // E0.0   [3] (🛽..🛿)    <reserved-1F6FD>..<reserved-1F6FF>
                        if (0x1f680 <= code && code <= 0x1f6ff) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.0  [12] (🝴..🝿)    LOT OF FORTUNE..ORCUS
                        if (0x1f774 <= code && code <= 0x1f77f) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    }
                }
            } else {
                if (code < 0x1f8ae) {
                    if (code < 0x1f848) {
                        if (code < 0x1f80c) {
                            // E0.0  [11] (🟕..🟟)    CIRCLED TRIANGLE..<reserved-1F7DF>
                            // E12.0 [12] (🟠..🟫)    orange circle..brown square
                            // E0.0   [4] (🟬..🟯)    <reserved-1F7EC>..<reserved-1F7EF>
                            // E14.0  [1] (🟰)       heavy equals sign
                            // E0.0  [15] (🟱..🟿)    <reserved-1F7F1>..<reserved-1F7FF>
                            if (0x1f7d5 <= code && code <= 0x1f7ff) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.0   [4] (🠌..🠏)    <reserved-1F80C>..<reserved-1F80F>
                            if (0x1f80c <= code && code <= 0x1f80f) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x1f85a) {
                            // E0.0   [8] (🡈..🡏)    <reserved-1F848>..<reserved-1F84F>
                            if (0x1f848 <= code && code <= 0x1f84f) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x1f888) {
                            // E0.0   [6] (🡚..🡟)    <reserved-1F85A>..<reserved-1F85F>
                            if (0x1f85a <= code && code <= 0x1f85f) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.0   [8] (🢈..🢏)    <reserved-1F888>..<reserved-1F88F>
                            if (0x1f888 <= code && code <= 0x1f88f) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                } else if (code < 0x1f93c) {
                    if (code < 0x1f90c) {
                        // E0.0  [82] (🢮..🣿)    <reserved-1F8AE>..<reserved-1F8FF>
                        if (0x1f8ae <= code && code <= 0x1f8ff) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E13.0  [1] (🤌)       pinched fingers
                        // E12.0  [3] (🤍..🤏)    white heart..pinching hand
                        // E1.0   [9] (🤐..🤘)    zipper-mouth face..sign of the horns
                        // E3.0   [6] (🤙..🤞)    call me hand..crossed fingers
                        // E5.0   [1] (🤟)       love-you gesture
                        // E3.0   [8] (🤠..🤧)    cowboy hat face..sneezing face
                        // E5.0   [8] (🤨..🤯)    face with raised eyebrow..exploding head
                        // E3.0   [1] (🤰)       pregnant woman
                        // E5.0   [2] (🤱..🤲)    breast-feeding..palms up together
                        // E3.0   [8] (🤳..🤺)    selfie..person fencing
                        if (0x1f90c <= code && code <= 0x1f93a) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    }
                } else {
                    if (code < 0x1f947) {
                        // E3.0   [3] (🤼..🤾)    people wrestling..person playing handball
                        // E12.0  [1] (🤿)       diving mask
                        // E3.0   [6] (🥀..🥅)    wilted flower..goal net
                        if (0x1f93c <= code && code <= 0x1f945) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else if (code < 0x1fc00) {
                        // E3.0   [5] (🥇..🥋)    1st place medal..martial arts uniform
                        // E5.0   [1] (🥌)       curling stone
                        // E11.0  [3] (🥍..🥏)    lacrosse..flying disc
                        // E3.0  [15] (🥐..🥞)    croissant..pancakes
                        // E5.0  [13] (🥟..🥫)    dumpling..canned food
                        // E11.0  [5] (🥬..🥰)    leafy green..smiling face with hearts
                        // E12.0  [1] (🥱)       yawning face
                        // E13.0  [1] (🥲)       smiling face with tear
                        // E11.0  [4] (🥳..🥶)    partying face..cold face
                        // E13.0  [2] (🥷..🥸)    ninja..disguised face
                        // E14.0  [1] (🥹)       face holding back tears
                        // E11.0  [1] (🥺)       pleading face
                        // E12.0  [1] (🥻)       sari
                        // E11.0  [4] (🥼..🥿)    lab coat..flat shoe
                        // E1.0   [5] (🦀..🦄)    crab..unicorn
                        // E3.0  [13] (🦅..🦑)    eagle..squid
                        // E5.0   [6] (🦒..🦗)    giraffe..cricket
                        // E11.0 [11] (🦘..🦢)    kangaroo..swan
                        // E13.0  [2] (🦣..🦤)    mammoth..dodo
                        // E12.0  [6] (🦥..🦪)    sloth..oyster
                        // E13.0  [3] (🦫..🦭)    beaver..seal
                        // E12.0  [2] (🦮..🦯)    guide dog..white cane
                        // E11.0 [10] (🦰..🦹)    red hair..supervillain
                        // E12.0  [6] (🦺..🦿)    safety vest..mechanical leg
                        // E1.0   [1] (🧀)       cheese wedge
                        // E11.0  [2] (🧁..🧂)    cupcake..salt
                        // E12.0  [8] (🧃..🧊)    beverage box..ice
                        // E13.0  [1] (🧋)       bubble tea
                        // E14.0  [1] (🧌)       troll
                        // E12.0  [3] (🧍..🧏)    person standing..deaf person
                        // E5.0  [23] (🧐..🧦)    face with monocle..socks
                        // E11.0 [25] (🧧..🧿)    red envelope..nazar amulet
                        // E0.0 [112] (🨀..🩯)    NEUTRAL CHESS KING..<reserved-1FA6F>
                        // E12.0  [4] (🩰..🩳)    ballet shoes..shorts
                        // E13.0  [1] (🩴)       thong sandal
                        // E15.0  [3] (🩵..🩷)    light blue heart..pink heart
                        // E12.0  [3] (🩸..🩺)    drop of blood..stethoscope
                        // E14.0  [2] (🩻..🩼)    x-ray..crutch
                        // E0.0   [3] (🩽..🩿)    <reserved-1FA7D>..<reserved-1FA7F>
                        // E12.0  [3] (🪀..🪂)    yo-yo..parachute
                        // E13.0  [4] (🪃..🪆)    boomerang..nesting dolls
                        // E15.0  [2] (🪇..🪈)    maracas..flute
                        // E0.0   [7] (🪉..🪏)    <reserved-1FA89>..<reserved-1FA8F>
                        // E12.0  [6] (🪐..🪕)    ringed planet..banjo
                        // E13.0 [19] (🪖..🪨)    military helmet..rock
                        // E14.0  [4] (🪩..🪬)    mirror ball..hamsa
                        // E15.0  [3] (🪭..🪯)    folding hand fan..khanda
                        // E13.0  [7] (🪰..🪶)    fly..feather
                        // E14.0  [4] (🪷..🪺)    lotus..nest with eggs
                        // E15.0  [3] (🪻..🪽)    hyacinth..wing
                        // E0.0   [1] (🪾)       <reserved-1FABE>
                        // E15.0  [1] (🪿)       goose
                        // E13.0  [3] (🫀..🫂)    anatomical heart..people hugging
                        // E14.0  [3] (🫃..🫅)    pregnant man..person with crown
                        // E0.0   [8] (🫆..🫍)    <reserved-1FAC6>..<reserved-1FACD>
                        // E15.0  [2] (🫎..🫏)    moose..donkey
                        // E13.0  [7] (🫐..🫖)    blueberries..teapot
                        // E14.0  [3] (🫗..🫙)    pouring liquid..jar
                        // E15.0  [2] (🫚..🫛)    ginger root..pea pod
                        // E0.0   [4] (🫜..🫟)    <reserved-1FADC>..<reserved-1FADF>
                        // E14.0  [8] (🫠..🫧)    melting face..bubbles
                        // E15.0  [1] (🫨)       shaking face
                        // E0.0   [7] (🫩..🫯)    <reserved-1FAE9>..<reserved-1FAEF>
                        // E14.0  [7] (🫰..🫶)    hand with index finger and thumb crossed..heart hands
                        // E15.0  [2] (🫷..🫸)    leftwards pushing hand..rightwards pushing hand
                        // E0.0   [7] (🫹..🫿)    <reserved-1FAF9>..<reserved-1FAFF>
                        if (0x1f947 <= code && code <= 0x1faff) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.0[1022] (🰀..🿽)    <reserved-1FC00>..<reserved-1FFFD>
                        if (0x1fc00 <= code && code <= 0x1fffd) return $lXl8C.EXTENDED_PICTOGRAPHIC;
                    }
                }
            }
        }
        // unlisted code points are treated as a break property of "Other"
        return $lXl8C.CLUSTER_BREAK.OTHER;
    }
}
module.exports.default = $5709e612125632f3$var$Graphemer;

});
parcelRegister("lXl8C", function(module, exports) {
"use strict";
/**
 * The Grapheme_Cluster_Break property value
 * @see https://www.unicode.org/reports/tr29/#Default_Grapheme_Cluster_Table
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EXTENDED_PICTOGRAPHIC = module.exports.CLUSTER_BREAK = void 0;
var $ffbf813d3b48cd58$var$CLUSTER_BREAK;
(function(CLUSTER_BREAK) {
    CLUSTER_BREAK[CLUSTER_BREAK["CR"] = 0] = "CR";
    CLUSTER_BREAK[CLUSTER_BREAK["LF"] = 1] = "LF";
    CLUSTER_BREAK[CLUSTER_BREAK["CONTROL"] = 2] = "CONTROL";
    CLUSTER_BREAK[CLUSTER_BREAK["EXTEND"] = 3] = "EXTEND";
    CLUSTER_BREAK[CLUSTER_BREAK["REGIONAL_INDICATOR"] = 4] = "REGIONAL_INDICATOR";
    CLUSTER_BREAK[CLUSTER_BREAK["SPACINGMARK"] = 5] = "SPACINGMARK";
    CLUSTER_BREAK[CLUSTER_BREAK["L"] = 6] = "L";
    CLUSTER_BREAK[CLUSTER_BREAK["V"] = 7] = "V";
    CLUSTER_BREAK[CLUSTER_BREAK["T"] = 8] = "T";
    CLUSTER_BREAK[CLUSTER_BREAK["LV"] = 9] = "LV";
    CLUSTER_BREAK[CLUSTER_BREAK["LVT"] = 10] = "LVT";
    CLUSTER_BREAK[CLUSTER_BREAK["OTHER"] = 11] = "OTHER";
    CLUSTER_BREAK[CLUSTER_BREAK["PREPEND"] = 12] = "PREPEND";
    CLUSTER_BREAK[CLUSTER_BREAK["E_BASE"] = 13] = "E_BASE";
    CLUSTER_BREAK[CLUSTER_BREAK["E_MODIFIER"] = 14] = "E_MODIFIER";
    CLUSTER_BREAK[CLUSTER_BREAK["ZWJ"] = 15] = "ZWJ";
    CLUSTER_BREAK[CLUSTER_BREAK["GLUE_AFTER_ZWJ"] = 16] = "GLUE_AFTER_ZWJ";
    CLUSTER_BREAK[CLUSTER_BREAK["E_BASE_GAZ"] = 17] = "E_BASE_GAZ";
})($ffbf813d3b48cd58$var$CLUSTER_BREAK = module.exports.CLUSTER_BREAK || (module.exports.CLUSTER_BREAK = {}));
/**
 * The Emoji character property is an extension of UCD but shares the same namespace and structure
 * @see http://www.unicode.org/reports/tr51/tr51-14.html#Emoji_Properties_and_Data_Files
 *
 * Here we model Extended_Pictograhpic only to implement UAX #29 GB11
 * \p{Extended_Pictographic} Extend* ZWJ	×	\p{Extended_Pictographic}
 *
 * The Emoji character property should not be mixed with Grapheme_Cluster_Break since they are not exclusive
 */ module.exports.EXTENDED_PICTOGRAPHIC = 101;

});

parcelRegister("e5Vtd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXl8C = parcelRequire("lXl8C");
// BreakTypes
// @type {BreakType}
const $a42e1cb82d3589a0$var$NotBreak = 0;
const $a42e1cb82d3589a0$var$BreakStart = 1;
const $a42e1cb82d3589a0$var$Break = 2;
const $a42e1cb82d3589a0$var$BreakLastRegional = 3;
const $a42e1cb82d3589a0$var$BreakPenultimateRegional = 4;
class $a42e1cb82d3589a0$var$GraphemerHelper {
    /**
     * Check if the the character at the position {pos} of the string is surrogate
     * @param str {string}
     * @param pos {number}
     * @returns {boolean}
     */ static isSurrogate(str, pos) {
        return 0xd800 <= str.charCodeAt(pos) && str.charCodeAt(pos) <= 0xdbff && 0xdc00 <= str.charCodeAt(pos + 1) && str.charCodeAt(pos + 1) <= 0xdfff;
    }
    /**
     * The String.prototype.codePointAt polyfill
     * Private function, gets a Unicode code point from a JavaScript UTF-16 string
     * handling surrogate pairs appropriately
     * @param str {string}
     * @param idx {number}
     * @returns {number}
     */ static codePointAt(str, idx) {
        if (idx === undefined) idx = 0;
        const code = str.charCodeAt(idx);
        // if a high surrogate
        if (0xd800 <= code && code <= 0xdbff && idx < str.length - 1) {
            const hi = code;
            const low = str.charCodeAt(idx + 1);
            if (0xdc00 <= low && low <= 0xdfff) return (hi - 0xd800) * 0x400 + (low - 0xdc00) + 0x10000;
            return hi;
        }
        // if a low surrogate
        if (0xdc00 <= code && code <= 0xdfff && idx >= 1) {
            const hi = str.charCodeAt(idx - 1);
            const low = code;
            if (0xd800 <= hi && hi <= 0xdbff) return (hi - 0xd800) * 0x400 + (low - 0xdc00) + 0x10000;
            return low;
        }
        // just return the char if an unmatched surrogate half or a
        // single-char codepoint
        return code;
    }
    //
    /**
     * Private function, returns whether a break is allowed between the two given grapheme breaking classes
     * Implemented the UAX #29 3.1.1 Grapheme Cluster Boundary Rules on extended grapheme clusters
     * @param start {number}
     * @param mid {Array<number>}
     * @param end {number}
     * @param startEmoji {number}
     * @param midEmoji {Array<number>}
     * @param endEmoji {number}
     * @returns {number}
     */ static shouldBreak(start, mid, end, startEmoji, midEmoji, endEmoji) {
        const all = [
            start
        ].concat(mid).concat([
            end
        ]);
        const allEmoji = [
            startEmoji
        ].concat(midEmoji).concat([
            endEmoji
        ]);
        const previous = all[all.length - 2];
        const next = end;
        const nextEmoji = endEmoji;
        // Lookahead terminator for:
        // GB12. ^ (RI RI)* RI ? RI
        // GB13. [^RI] (RI RI)* RI ? RI
        const rIIndex = all.lastIndexOf($lXl8C.CLUSTER_BREAK.REGIONAL_INDICATOR);
        if (rIIndex > 0 && all.slice(1, rIIndex).every(function(c) {
            return c === $lXl8C.CLUSTER_BREAK.REGIONAL_INDICATOR;
        }) && [
            $lXl8C.CLUSTER_BREAK.PREPEND,
            $lXl8C.CLUSTER_BREAK.REGIONAL_INDICATOR
        ].indexOf(previous) === -1) {
            if (all.filter(function(c) {
                return c === $lXl8C.CLUSTER_BREAK.REGIONAL_INDICATOR;
            }).length % 2 === 1) return $a42e1cb82d3589a0$var$BreakLastRegional;
            else return $a42e1cb82d3589a0$var$BreakPenultimateRegional;
        }
        // GB3. CR × LF
        if (previous === $lXl8C.CLUSTER_BREAK.CR && next === $lXl8C.CLUSTER_BREAK.LF) return $a42e1cb82d3589a0$var$NotBreak;
        else if (previous === $lXl8C.CLUSTER_BREAK.CONTROL || previous === $lXl8C.CLUSTER_BREAK.CR || previous === $lXl8C.CLUSTER_BREAK.LF) return $a42e1cb82d3589a0$var$BreakStart;
        else if (next === $lXl8C.CLUSTER_BREAK.CONTROL || next === $lXl8C.CLUSTER_BREAK.CR || next === $lXl8C.CLUSTER_BREAK.LF) return $a42e1cb82d3589a0$var$BreakStart;
        else if (previous === $lXl8C.CLUSTER_BREAK.L && (next === $lXl8C.CLUSTER_BREAK.L || next === $lXl8C.CLUSTER_BREAK.V || next === $lXl8C.CLUSTER_BREAK.LV || next === $lXl8C.CLUSTER_BREAK.LVT)) return $a42e1cb82d3589a0$var$NotBreak;
        else if ((previous === $lXl8C.CLUSTER_BREAK.LV || previous === $lXl8C.CLUSTER_BREAK.V) && (next === $lXl8C.CLUSTER_BREAK.V || next === $lXl8C.CLUSTER_BREAK.T)) return $a42e1cb82d3589a0$var$NotBreak;
        else if ((previous === $lXl8C.CLUSTER_BREAK.LVT || previous === $lXl8C.CLUSTER_BREAK.T) && next === $lXl8C.CLUSTER_BREAK.T) return $a42e1cb82d3589a0$var$NotBreak;
        else if (next === $lXl8C.CLUSTER_BREAK.EXTEND || next === $lXl8C.CLUSTER_BREAK.ZWJ) return $a42e1cb82d3589a0$var$NotBreak;
        else if (next === $lXl8C.CLUSTER_BREAK.SPACINGMARK) return $a42e1cb82d3589a0$var$NotBreak;
        else if (previous === $lXl8C.CLUSTER_BREAK.PREPEND) return $a42e1cb82d3589a0$var$NotBreak;
        // GB11. \p{Extended_Pictographic} Extend* ZWJ × \p{Extended_Pictographic}
        const previousNonExtendIndex = allEmoji.slice(0, -1).lastIndexOf($lXl8C.EXTENDED_PICTOGRAPHIC);
        if (previousNonExtendIndex !== -1 && allEmoji[previousNonExtendIndex] === $lXl8C.EXTENDED_PICTOGRAPHIC && all.slice(previousNonExtendIndex + 1, -2).every(function(c) {
            return c === $lXl8C.CLUSTER_BREAK.EXTEND;
        }) && previous === $lXl8C.CLUSTER_BREAK.ZWJ && nextEmoji === $lXl8C.EXTENDED_PICTOGRAPHIC) return $a42e1cb82d3589a0$var$NotBreak;
        // GB12. ^ (RI RI)* RI × RI
        // GB13. [^RI] (RI RI)* RI × RI
        if (mid.indexOf($lXl8C.CLUSTER_BREAK.REGIONAL_INDICATOR) !== -1) return $a42e1cb82d3589a0$var$Break;
        if (previous === $lXl8C.CLUSTER_BREAK.REGIONAL_INDICATOR && next === $lXl8C.CLUSTER_BREAK.REGIONAL_INDICATOR) return $a42e1cb82d3589a0$var$NotBreak;
        // GB999. Any ? Any
        return $a42e1cb82d3589a0$var$BreakStart;
    }
}
module.exports.default = $a42e1cb82d3589a0$var$GraphemerHelper;

});

parcelRegister("KZpkG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * GraphemerIterator
 *
 * Takes a string and a "BreakHandler" method during initialisation
 * and creates an iterable object that returns individual graphemes.
 *
 * @param str {string}
 * @return GraphemerIterator
 */ class $08d3ee42b980513d$var$GraphemerIterator {
    constructor(str, nextBreak){
        this._index = 0;
        this._str = str;
        this._nextBreak = nextBreak;
    }
    [Symbol.iterator]() {
        return this;
    }
    next() {
        let brk;
        if ((brk = this._nextBreak(this._str, this._index)) < this._str.length) {
            const value = this._str.slice(this._index, brk);
            this._index = brk;
            return {
                value: value,
                done: false
            };
        }
        if (this._index < this._str.length) {
            const value = this._str.slice(this._index);
            this._index = this._str.length;
            return {
                value: value,
                done: false
            };
        }
        return {
            value: undefined,
            done: true
        };
    }
}
module.exports.default = $08d3ee42b980513d$var$GraphemerIterator;

});




parcelRegister("47FX6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.didDocument = module.exports.getServiceEndpoint = module.exports.getNotifEndpoint = module.exports.getFeedGenEndpoint = module.exports.getPdsEndpoint = module.exports.getSigningDidKey = module.exports.getVerificationMaterial = module.exports.getSigningKey = module.exports.getHandle = module.exports.getDid = module.exports.isValidDidDoc = void 0;

var $2zDt6 = parcelRequire("2zDt6");
// Parsing atproto data
// --------
const $30085bb3e412fd9c$var$isValidDidDoc = (doc)=>{
    return module.exports.didDocument.safeParse(doc).success;
};
module.exports.isValidDidDoc = $30085bb3e412fd9c$var$isValidDidDoc;
const $30085bb3e412fd9c$var$getDid = (doc)=>{
    const id = doc.id;
    if (typeof id !== 'string') throw new Error('No `id` on document');
    return id;
};
module.exports.getDid = $30085bb3e412fd9c$var$getDid;
const $30085bb3e412fd9c$var$getHandle = (doc)=>{
    const aka = doc.alsoKnownAs;
    if (aka) for(let i = 0; i < aka.length; i++){
        const alias = aka[i];
        if (alias.startsWith('at://')) // strip off "at://" prefix
        return alias.slice(5);
    }
    return undefined;
};
module.exports.getHandle = $30085bb3e412fd9c$var$getHandle;
// @NOTE we parse to type/publicKeyMultibase to avoid the dependency on @atproto/crypto
const $30085bb3e412fd9c$var$getSigningKey = (doc)=>{
    return (0, module.exports.getVerificationMaterial)(doc, 'atproto');
};
module.exports.getSigningKey = $30085bb3e412fd9c$var$getSigningKey;
const $30085bb3e412fd9c$var$getVerificationMaterial = (doc, keyId)=>{
    // /!\ Hot path
    const key = $30085bb3e412fd9c$var$findItemById(doc, 'verificationMethod', `#${keyId}`);
    if (!key) return undefined;
    if (!key.publicKeyMultibase) return undefined;
    return {
        type: key.type,
        publicKeyMultibase: key.publicKeyMultibase
    };
};
module.exports.getVerificationMaterial = $30085bb3e412fd9c$var$getVerificationMaterial;
const $30085bb3e412fd9c$var$getSigningDidKey = (doc)=>{
    const parsed = (0, module.exports.getSigningKey)(doc);
    if (!parsed) return;
    return `did:key:${parsed.publicKeyMultibase}`;
};
module.exports.getSigningDidKey = $30085bb3e412fd9c$var$getSigningDidKey;
const $30085bb3e412fd9c$var$getPdsEndpoint = (doc)=>{
    return (0, module.exports.getServiceEndpoint)(doc, {
        id: '#atproto_pds',
        type: 'AtprotoPersonalDataServer'
    });
};
module.exports.getPdsEndpoint = $30085bb3e412fd9c$var$getPdsEndpoint;
const $30085bb3e412fd9c$var$getFeedGenEndpoint = (doc)=>{
    return (0, module.exports.getServiceEndpoint)(doc, {
        id: '#bsky_fg',
        type: 'BskyFeedGenerator'
    });
};
module.exports.getFeedGenEndpoint = $30085bb3e412fd9c$var$getFeedGenEndpoint;
const $30085bb3e412fd9c$var$getNotifEndpoint = (doc)=>{
    return (0, module.exports.getServiceEndpoint)(doc, {
        id: '#bsky_notif',
        type: 'BskyNotificationService'
    });
};
module.exports.getNotifEndpoint = $30085bb3e412fd9c$var$getNotifEndpoint;
const $30085bb3e412fd9c$var$getServiceEndpoint = (doc, opts)=>{
    // /!\ Hot path
    const service = $30085bb3e412fd9c$var$findItemById(doc, 'service', opts.id);
    if (!service) return undefined;
    if (opts.type && service.type !== opts.type) return undefined;
    if (typeof service.serviceEndpoint !== 'string') return undefined;
    return $30085bb3e412fd9c$var$validateUrl(service.serviceEndpoint);
};
module.exports.getServiceEndpoint = $30085bb3e412fd9c$var$getServiceEndpoint;
function $30085bb3e412fd9c$var$findItemById(doc, type, id) {
    // /!\ Hot path
    const items = doc[type];
    if (items) for(let i = 0; i < items.length; i++){
        const item = items[i];
        const itemId = item.id;
        if (itemId[0] === '#' ? itemId === id : itemId.length === doc.id.length + id.length && itemId[doc.id.length] === '#' && itemId.endsWith(id) && itemId.startsWith(doc.id) // <== We could probably skip this check
        ) return item;
    }
    return undefined;
}
// Check protocol and hostname to prevent potential SSRF
const $30085bb3e412fd9c$var$validateUrl = (urlStr)=>{
    if (!urlStr.startsWith('http://') && !urlStr.startsWith('https://')) return undefined;
    if (!$30085bb3e412fd9c$var$canParseUrl(urlStr)) return undefined;
    return urlStr;
};
const $30085bb3e412fd9c$var$canParseUrl = URL.canParse ?? // URL.canParse is not available in Node.js < 18.17.0
((urlStr)=>{
    try {
        new URL(urlStr);
        return true;
    } catch  {
        return false;
    }
});
// Types
// --------
const $30085bb3e412fd9c$var$verificationMethod = $2zDt6.z.object({
    id: $2zDt6.z.string(),
    type: $2zDt6.z.string(),
    controller: $2zDt6.z.string(),
    publicKeyMultibase: $2zDt6.z.string().optional()
});
const $30085bb3e412fd9c$var$service = $2zDt6.z.object({
    id: $2zDt6.z.string(),
    type: $2zDt6.z.string(),
    serviceEndpoint: $2zDt6.z.union([
        $2zDt6.z.string(),
        $2zDt6.z.record($2zDt6.z.unknown())
    ])
});
module.exports.didDocument = $2zDt6.z.object({
    id: $2zDt6.z.string(),
    alsoKnownAs: $2zDt6.z.array($2zDt6.z.string()).optional(),
    verificationMethod: $2zDt6.z.array($30085bb3e412fd9c$var$verificationMethod).optional(),
    service: $2zDt6.z.array($30085bb3e412fd9c$var$service).optional()
});

});




parcelRegister("9FyPS", function(module, exports) {
"use strict";
var $70a2f70f562176c1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $70a2f70f562176c1$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $70a2f70f562176c1$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $70a2f70f562176c1$var$__createBinding(result, mod, k);
    }
    $70a2f70f562176c1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validate = $70a2f70f562176c1$var$validate;

var $a3h4N = parcelRequire("a3h4N");

var $bc6Ix = parcelRequire("bc6Ix");

var $8gte5 = parcelRequire("8gte5");

const $70a2f70f562176c1$var$formats = $70a2f70f562176c1$var$__importStar((parcelRequire("eqnGm")));
function $70a2f70f562176c1$var$validate(lexicons, path, def, value) {
    switch(def.type){
        case 'boolean':
            return $70a2f70f562176c1$var$boolean(lexicons, path, def, value);
        case 'integer':
            return $70a2f70f562176c1$var$integer(lexicons, path, def, value);
        case 'string':
            return $70a2f70f562176c1$var$string(lexicons, path, def, value);
        case 'bytes':
            return $70a2f70f562176c1$var$bytes(lexicons, path, def, value);
        case 'cid-link':
            return $70a2f70f562176c1$var$cidLink(lexicons, path, def, value);
        case 'unknown':
            return $70a2f70f562176c1$var$unknown(lexicons, path, def, value);
        default:
            return {
                success: false,
                error: new $8gte5.ValidationError(`Unexpected lexicon type: ${def.type}`)
            };
    }
}
function $70a2f70f562176c1$var$boolean(lexicons, path, def, value) {
    def;
    // type
    const type = typeof value;
    if (type === 'undefined') {
        if (typeof def.default === 'boolean') return {
            success: true,
            value: def.default
        };
        return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be a boolean`)
        };
    } else if (type !== 'boolean') return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be a boolean`)
    };
    // const
    if (typeof def.const === 'boolean') {
        if (value !== def.const) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be ${def.const}`)
        };
    }
    return {
        success: true,
        value: value
    };
}
function $70a2f70f562176c1$var$integer(lexicons, path, def, value) {
    def;
    // type
    const type = typeof value;
    if (type === 'undefined') {
        if (typeof def.default === 'number') return {
            success: true,
            value: def.default
        };
        return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be an integer`)
        };
    } else if (!Number.isInteger(value)) return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be an integer`)
    };
    // const
    if (typeof def.const === 'number') {
        if (value !== def.const) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be ${def.const}`)
        };
    }
    // enum
    if (Array.isArray(def.enum)) {
        if (!def.enum.includes(value)) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be one of (${def.enum.join('|')})`)
        };
    }
    // maximum
    if (typeof def.maximum === 'number') {
        if (value > def.maximum) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} can not be greater than ${def.maximum}`)
        };
    }
    // minimum
    if (typeof def.minimum === 'number') {
        if (value < def.minimum) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} can not be less than ${def.minimum}`)
        };
    }
    return {
        success: true,
        value: value
    };
}
function $70a2f70f562176c1$var$string(lexicons, path, def, value) {
    def;
    // type
    if (typeof value === 'undefined') {
        if (typeof def.default === 'string') return {
            success: true,
            value: def.default
        };
        return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be a string`)
        };
    } else if (typeof value !== 'string') return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be a string`)
    };
    // const
    if (typeof def.const === 'string') {
        if (value !== def.const) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be ${def.const}`)
        };
    }
    // enum
    if (Array.isArray(def.enum)) {
        if (!def.enum.includes(value)) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be one of (${def.enum.join('|')})`)
        };
    }
    // maxLength and minLength
    if (typeof def.minLength === 'number' || typeof def.maxLength === 'number') {
        // If the JavaScript string length * 3 is below the maximum limit,
        // its UTF8 length (which <= .length * 3) will also be below.
        if (typeof def.minLength === 'number' && value.length * 3 < def.minLength) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must not be shorter than ${def.minLength} characters`)
        };
        // If the JavaScript string length * 3 is within the maximum limit,
        // its UTF8 length (which <= .length * 3) will also be within.
        // When there's no minimal length, this lets us skip the UTF8 length check.
        let canSkipUtf8LenChecks = false;
        if (typeof def.minLength === 'undefined' && typeof def.maxLength === 'number' && value.length * 3 <= def.maxLength) canSkipUtf8LenChecks = true;
        if (!canSkipUtf8LenChecks) {
            const len = (0, $bc6Ix.utf8Len)(value);
            if (typeof def.maxLength === 'number') {
                if (len > def.maxLength) return {
                    success: false,
                    error: new $8gte5.ValidationError(`${path} must not be longer than ${def.maxLength} characters`)
                };
            }
            if (typeof def.minLength === 'number') {
                if (len < def.minLength) return {
                    success: false,
                    error: new $8gte5.ValidationError(`${path} must not be shorter than ${def.minLength} characters`)
                };
            }
        }
    }
    // maxGraphemes and minGraphemes
    if (typeof def.maxGraphemes === 'number' || typeof def.minGraphemes === 'number') {
        let needsMaxGraphemesCheck = false;
        let needsMinGraphemesCheck = false;
        if (typeof def.maxGraphemes === 'number') {
            if (value.length <= def.maxGraphemes) // If the JavaScript string length (UTF-16) is within the maximum limit,
            // its grapheme length (which <= .length) will also be within.
            needsMaxGraphemesCheck = false;
            else needsMaxGraphemesCheck = true;
        }
        if (typeof def.minGraphemes === 'number') {
            if (value.length < def.minGraphemes) // If the JavaScript string length (UTF-16) is below the minimal limit,
            // its grapheme length (which <= .length) will also be below.
            // Fail early.
            return {
                success: false,
                error: new $8gte5.ValidationError(`${path} must not be shorter than ${def.minGraphemes} graphemes`)
            };
            else needsMinGraphemesCheck = true;
        }
        if (needsMaxGraphemesCheck || needsMinGraphemesCheck) {
            const len = (0, $bc6Ix.graphemeLen)(value);
            if (typeof def.maxGraphemes === 'number') {
                if (len > def.maxGraphemes) return {
                    success: false,
                    error: new $8gte5.ValidationError(`${path} must not be longer than ${def.maxGraphemes} graphemes`)
                };
            }
            if (typeof def.minGraphemes === 'number') {
                if (len < def.minGraphemes) return {
                    success: false,
                    error: new $8gte5.ValidationError(`${path} must not be shorter than ${def.minGraphemes} graphemes`)
                };
            }
        }
    }
    if (typeof def.format === 'string') switch(def.format){
        case 'datetime':
            return $70a2f70f562176c1$var$formats.datetime(path, value);
        case 'uri':
            return $70a2f70f562176c1$var$formats.uri(path, value);
        case 'at-uri':
            return $70a2f70f562176c1$var$formats.atUri(path, value);
        case 'did':
            return $70a2f70f562176c1$var$formats.did(path, value);
        case 'handle':
            return $70a2f70f562176c1$var$formats.handle(path, value);
        case 'at-identifier':
            return $70a2f70f562176c1$var$formats.atIdentifier(path, value);
        case 'nsid':
            return $70a2f70f562176c1$var$formats.nsid(path, value);
        case 'cid':
            return $70a2f70f562176c1$var$formats.cid(path, value);
        case 'language':
            return $70a2f70f562176c1$var$formats.language(path, value);
        case 'tid':
            return $70a2f70f562176c1$var$formats.tid(path, value);
        case 'record-key':
            return $70a2f70f562176c1$var$formats.recordKey(path, value);
    }
    return {
        success: true,
        value: value
    };
}
function $70a2f70f562176c1$var$bytes(lexicons, path, def, value) {
    def;
    if (!value || !(value instanceof Uint8Array)) return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be a byte array`)
    };
    // maxLength
    if (typeof def.maxLength === 'number') {
        if (value.byteLength > def.maxLength) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must not be larger than ${def.maxLength} bytes`)
        };
    }
    // minLength
    if (typeof def.minLength === 'number') {
        if (value.byteLength < def.minLength) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must not be smaller than ${def.minLength} bytes`)
        };
    }
    return {
        success: true,
        value: value
    };
}
function $70a2f70f562176c1$var$cidLink(lexicons, path, def, value) {
    if ($a3h4N.CID.asCID(value) === null) return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be a CID`)
    };
    return {
        success: true,
        value: value
    };
}
function $70a2f70f562176c1$var$unknown(lexicons, path, def, value) {
    // type
    if (!value || typeof value !== 'object') return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be an object`)
    };
    return {
        success: true,
        value: value
    };
}

});
parcelRegister("eqnGm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.datetime = $a805dd36997f75fe$var$datetime;
module.exports.uri = $a805dd36997f75fe$var$uri;
module.exports.atUri = $a805dd36997f75fe$var$atUri;
module.exports.did = $a805dd36997f75fe$var$did;
module.exports.handle = $a805dd36997f75fe$var$handle;
module.exports.atIdentifier = $a805dd36997f75fe$var$atIdentifier;
module.exports.nsid = $a805dd36997f75fe$var$nsid;
module.exports.cid = $a805dd36997f75fe$var$cid;
module.exports.language = $a805dd36997f75fe$var$language;
module.exports.tid = $a805dd36997f75fe$var$tid;
module.exports.recordKey = $a805dd36997f75fe$var$recordKey;

var $c1xzH = parcelRequire("c1xzH");

var $a3h4N = parcelRequire("a3h4N");

var $bc6Ix = parcelRequire("bc6Ix");

var $9IHRK = parcelRequire("9IHRK");

var $8gte5 = parcelRequire("8gte5");
function $a805dd36997f75fe$var$datetime(path, value) {
    try {
        if (!(0, $c1xzH.isValidISODateString)(value)) throw new Error();
    } catch  {
        return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be an valid atproto datetime (both RFC-3339 and ISO-8601)`)
        };
    }
    return {
        success: true,
        value: value
    };
}
function $a805dd36997f75fe$var$uri(path, value) {
    const isUri = value.match(/^\w+:(?:\/\/)?[^\s/][^\s]*$/) !== null;
    if (!isUri) return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be a uri`)
    };
    return {
        success: true,
        value: value
    };
}
function $a805dd36997f75fe$var$atUri(path, value) {
    try {
        (0, $9IHRK.ensureValidAtUri)(value);
    } catch  {
        return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be a valid at-uri`)
        };
    }
    return {
        success: true,
        value: value
    };
}
function $a805dd36997f75fe$var$did(path, value) {
    try {
        (0, $9IHRK.ensureValidDid)(value);
    } catch  {
        return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be a valid did`)
        };
    }
    return {
        success: true,
        value: value
    };
}
function $a805dd36997f75fe$var$handle(path, value) {
    try {
        (0, $9IHRK.ensureValidHandle)(value);
    } catch  {
        return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be a valid handle`)
        };
    }
    return {
        success: true,
        value: value
    };
}
function $a805dd36997f75fe$var$atIdentifier(path, value) {
    // We can discriminate based on the "did:" prefix
    if (value.startsWith('did:')) {
        const didResult = $a805dd36997f75fe$var$did(path, value);
        if (didResult.success) return didResult;
    } else {
        const handleResult = $a805dd36997f75fe$var$handle(path, value);
        if (handleResult.success) return handleResult;
    }
    return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be a valid did or a handle`)
    };
}
function $a805dd36997f75fe$var$nsid(path, value) {
    try {
        (0, $9IHRK.ensureValidNsid)(value);
    } catch  {
        return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be a valid nsid`)
        };
    }
    return {
        success: true,
        value: value
    };
}
function $a805dd36997f75fe$var$cid(path, value) {
    try {
        $a3h4N.CID.parse(value);
    } catch  {
        return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be a cid string`)
        };
    }
    return {
        success: true,
        value: value
    };
}
// The language format validates well-formed BCP 47 language tags: https://www.rfc-editor.org/info/bcp47
function $a805dd36997f75fe$var$language(path, value) {
    if ((0, $bc6Ix.validateLanguage)(value)) return {
        success: true,
        value: value
    };
    return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be a well-formed BCP 47 language tag`)
    };
}
function $a805dd36997f75fe$var$tid(path, value) {
    if ((0, $9IHRK.isValidTid)(value)) return {
        success: true,
        value: value
    };
    return {
        success: false,
        error: new $8gte5.ValidationError(`${path} must be a valid TID`)
    };
}
function $a805dd36997f75fe$var$recordKey(path, value) {
    try {
        (0, $9IHRK.ensureValidRecordKey)(value);
    } catch  {
        return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must be a valid Record Key`)
        };
    }
    return {
        success: true,
        value: value
    };
}

});
parcelRegister("c1xzH", function(module, exports) {
(()=>{
    "use strict";
    var e = {
        d: (t, r)=>{
            for(var n in r)e.o(r, n) && !e.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: r[n]
            });
        },
        o: (e, t)=>Object.prototype.hasOwnProperty.call(e, t),
        r: (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }
    }, t = {};
    function r(e, t) {
        return void 0 === t && (t = "-"), new RegExp("^(?!0{4}" + t + "0{2}" + t + "0{2})((?=[0-9]{4}" + t + "(((0[^2])|1[0-2])|02(?=" + t + "(([0-1][0-9])|2[0-8])))" + t + "[0-9]{2})|(?=((([13579][26])|([2468][048])|(0[48]))0{2})|([0-9]{2}((((0|[2468])[48])|[2468][048])|([13579][26])))" + t + "02" + t + "29))([0-9]{4})" + t + "(?!((0[469])|11)" + t + "31)((0[1,3-9]|1[0-2])|(02(?!" + t + "3)))" + t + "(0[1-9]|[1-2][0-9]|3[0-1])$").test(e);
    }
    function n(e) {
        var t = /\D/.exec(e);
        return t ? t[0] : "";
    }
    function i(e, t, r) {
        void 0 === t && (t = ":"), void 0 === r && (r = !1);
        var i = new RegExp("^([0-1]|2(?=([0-3])|4" + t + "00))[0-9]" + t + "[0-5][0-9](" + t + "([0-5]|6(?=0))[0-9])?(.[0-9]{1,9})?$");
        if (!r || !/[Z+\-]/.test(e)) return i.test(e);
        if (/Z$/.test(e)) return i.test(e.replace("Z", ""));
        var o = e.includes("+"), a = e.split(/[+-]/), u = a[0], d = a[1];
        return i.test(u) && function(e, t, r) {
            return void 0 === r && (r = ":"), new RegExp(t ? "^(0(?!(2" + r + "4)|0" + r + "3)|1(?=([0-1]|2(?=" + r + "[04])|[34](?=" + r + "0))))([03469](?=" + r + "[03])|[17](?=" + r + "0)|2(?=" + r + "[04])|5(?=" + r + "[034])|8(?=" + r + "[04]))" + r + "([03](?=0)|4(?=5))[05]$" : "^(0(?=[^0])|1(?=[0-2]))([39](?=" + r + "[03])|[0-24-8](?=" + r + "00))" + r + "[03]0$").test(e);
        }(d, o, n(d));
    }
    function o(e) {
        var t = e.split("T"), o = t[0], a = t[1], u = r(o, n(o));
        if (!a) return !1;
        var d, s = (d = a.match(/([^Z+\-\d])(?=\d+\1)/), Array.isArray(d) ? d[0] : "");
        return u && i(a, s, !0);
    }
    function a(e, t) {
        return void 0 === t && (t = "-"), new RegExp("^[0-9]{4}" + t + "(0(?=[^0])|1(?=[0-2]))[0-9]$").test(e);
    }
    e.r(t), e.d(t, {
        isValidDate: ()=>r,
        isValidISODateString: ()=>o,
        isValidTime: ()=>i,
        isValidYearMonth: ()=>a
    });
    var u = module.exports;
    for(var d in t)u[d] = t[d];
    t.__esModule && Object.defineProperty(u, "__esModule", {
        value: !0
    });
})();

});




parcelRegister("6jNDP", function(module, exports) {
"use strict";
var $499b062c2dc2f01b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $499b062c2dc2f01b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $499b062c2dc2f01b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $499b062c2dc2f01b$var$__createBinding(result, mod, k);
    }
    $499b062c2dc2f01b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.params = $499b062c2dc2f01b$var$params;

var $8gte5 = parcelRequire("8gte5");

var $7Y8kb = parcelRequire("7Y8kb");

const $499b062c2dc2f01b$var$PrimitiveValidators = $499b062c2dc2f01b$var$__importStar((parcelRequire("9FyPS")));
function $499b062c2dc2f01b$var$params(lexicons, path, def, val) {
    // type
    const value = val && typeof val === 'object' ? val : {};
    const requiredProps = new Set(def.required ?? []);
    // properties
    let resultValue = value;
    if (typeof def.properties === 'object') for(const key in def.properties){
        const propDef = def.properties[key];
        const validated = propDef.type === 'array' ? (0, $7Y8kb.array)(lexicons, key, propDef, value[key]) : $499b062c2dc2f01b$var$PrimitiveValidators.validate(lexicons, key, propDef, value[key]);
        const propValue = validated.success ? validated.value : value[key];
        const propIsUndefined = typeof propValue === 'undefined';
        // Return error for bad validation, giving required rule precedence
        if (propIsUndefined && requiredProps.has(key)) return {
            success: false,
            error: new $8gte5.ValidationError(`${path} must have the property "${key}"`)
        };
        else if (!propIsUndefined && !validated.success) return validated;
        // Adjust value based on e.g. applied defaults, cloning shallowly if there was a changed value
        if (propValue !== value[key]) {
            if (resultValue === value) // Lazy shallow clone
            resultValue = {
                ...value
            };
            resultValue[key] = propValue;
        }
    }
    return {
        success: true,
        value: resultValue
    };
}

});



parcelRegister("cjXJG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonStringToLex = module.exports.jsonToLex = module.exports.stringifyLex = module.exports.lexToJson = module.exports.ipldToLex = module.exports.lexToIpld = void 0;

var $a3h4N = parcelRequire("a3h4N");

var $bc6Ix = parcelRequire("bc6Ix");

var $9mWeA = parcelRequire("9mWeA");
// @NOTE avoiding use of check.is() here only because it makes
// these implementations slow, and they often live in hot paths.
const $8f8598b1f753b1cf$var$lexToIpld = (val)=>{
    // walk arrays
    if (Array.isArray(val)) return val.map((item)=>(0, module.exports.lexToIpld)(item));
    // objects
    if (val && typeof val === 'object') {
        // convert blobs, leaving the original encoding so that we don't change CIDs on re-encode
        if (val instanceof $9mWeA.BlobRef) return val.original;
        // retain cids & bytes
        if ($a3h4N.CID.asCID(val) || val instanceof Uint8Array) return val;
        // walk plain objects
        const toReturn = {};
        for (const key of Object.keys(val))toReturn[key] = (0, module.exports.lexToIpld)(val[key]);
        return toReturn;
    }
    // pass through
    return val;
};
module.exports.lexToIpld = $8f8598b1f753b1cf$var$lexToIpld;
const $8f8598b1f753b1cf$var$ipldToLex = (val)=>{
    // map arrays
    if (Array.isArray(val)) return val.map((item)=>(0, module.exports.ipldToLex)(item));
    // objects
    if (val && typeof val === 'object') {
        // convert blobs, using hints to avoid expensive is() check
        if ((val['$type'] === 'blob' || typeof val['cid'] === 'string' && typeof val['mimeType'] === 'string') && $bc6Ix.check.is(val, $9mWeA.jsonBlobRef)) return $9mWeA.BlobRef.fromJsonRef(val);
        // retain cids, bytes
        if ($a3h4N.CID.asCID(val) || val instanceof Uint8Array) return val;
        // map plain objects
        const toReturn = {};
        for (const key of Object.keys(val))toReturn[key] = (0, module.exports.ipldToLex)(val[key]);
        return toReturn;
    }
    // pass through
    return val;
};
module.exports.ipldToLex = $8f8598b1f753b1cf$var$ipldToLex;
const $8f8598b1f753b1cf$var$lexToJson = (val)=>{
    return (0, $bc6Ix.ipldToJson)((0, module.exports.lexToIpld)(val));
};
module.exports.lexToJson = $8f8598b1f753b1cf$var$lexToJson;
const $8f8598b1f753b1cf$var$stringifyLex = (val)=>{
    return JSON.stringify((0, module.exports.lexToJson)(val));
};
module.exports.stringifyLex = $8f8598b1f753b1cf$var$stringifyLex;
const $8f8598b1f753b1cf$var$jsonToLex = (val)=>{
    return (0, module.exports.ipldToLex)((0, $bc6Ix.jsonToIpld)(val));
};
module.exports.jsonToLex = $8f8598b1f753b1cf$var$jsonToLex;
const $8f8598b1f753b1cf$var$jsonStringToLex = (val)=>{
    return (0, module.exports.jsonToLex)(JSON.parse(val));
};
module.exports.jsonStringToLex = $8f8598b1f753b1cf$var$jsonStringToLex;

});

parcelRegister("1MpES", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DisallowedDomainError = module.exports.UnsupportedDomainError = module.exports.ReservedHandleError = module.exports.InvalidHandleError = module.exports.isValidTld = module.exports.isValidHandle = module.exports.normalizeAndEnsureValidHandle = module.exports.normalizeHandle = module.exports.ensureValidHandleRegex = module.exports.ensureValidHandle = module.exports.DISALLOWED_TLDS = module.exports.INVALID_HANDLE = void 0;
module.exports.INVALID_HANDLE = 'handle.invalid';
// Currently these are registration-time restrictions, not protocol-level
// restrictions. We have a couple accounts in the wild that we need to clean up
// before hard-disallow.
// See also: https://en.wikipedia.org/wiki/Top-level_domain#Reserved_domains
module.exports.DISALLOWED_TLDS = [
    '.local',
    '.arpa',
    '.invalid',
    '.localhost',
    '.internal',
    '.example',
    '.alt',
    // policy could concievably change on ".onion" some day
    '.onion'
];
// Handle constraints, in English:
//  - must be a possible domain name
//    - RFC-1035 is commonly referenced, but has been updated. eg, RFC-3696,
//      section 2. and RFC-3986, section 3. can now have leading numbers (eg,
//      4chan.org)
//    - "labels" (sub-names) are made of ASCII letters, digits, hyphens
//    - can not start or end with a hyphen
//    - TLD (last component) should not start with a digit
//    - can't end with a hyphen (can end with digit)
//    - each segment must be between 1 and 63 characters (not including any periods)
//    - overall length can't be more than 253 characters
//    - separated by (ASCII) periods; does not start or end with period
//    - case insensitive
//    - domains (handles) are equal if they are the same lower-case
//    - punycode allowed for internationalization
//  - no whitespace, null bytes, joining chars, etc
//  - does not validate whether domain or TLD exists, or is a reserved or
//    special TLD (eg, .onion or .local)
//  - does not validate punycode
const $14be2d5be930bc8e$var$ensureValidHandle = (handle)=>{
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9.-]*$/.test(handle)) throw new $14be2d5be930bc8e$var$InvalidHandleError('Disallowed characters in handle (ASCII letters, digits, dashes, periods only)');
    if (handle.length > 253) throw new $14be2d5be930bc8e$var$InvalidHandleError('Handle is too long (253 chars max)');
    const labels = handle.split('.');
    if (labels.length < 2) throw new $14be2d5be930bc8e$var$InvalidHandleError('Handle domain needs at least two parts');
    for(let i = 0; i < labels.length; i++){
        const l = labels[i];
        if (l.length < 1) throw new $14be2d5be930bc8e$var$InvalidHandleError('Handle parts can not be empty');
        if (l.length > 63) throw new $14be2d5be930bc8e$var$InvalidHandleError('Handle part too long (max 63 chars)');
        if (l.endsWith('-') || l.startsWith('-')) throw new $14be2d5be930bc8e$var$InvalidHandleError('Handle parts can not start or end with hyphens');
        if (i + 1 === labels.length && !/^[a-zA-Z]/.test(l)) throw new $14be2d5be930bc8e$var$InvalidHandleError('Handle final component (TLD) must start with ASCII letter');
    }
};
module.exports.ensureValidHandle = $14be2d5be930bc8e$var$ensureValidHandle;
// simple regex translation of above constraints
const $14be2d5be930bc8e$var$ensureValidHandleRegex = (handle)=>{
    if (!/^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/.test(handle)) throw new $14be2d5be930bc8e$var$InvalidHandleError("Handle didn't validate via regex");
    if (handle.length > 253) throw new $14be2d5be930bc8e$var$InvalidHandleError('Handle is too long (253 chars max)');
};
module.exports.ensureValidHandleRegex = $14be2d5be930bc8e$var$ensureValidHandleRegex;
const $14be2d5be930bc8e$var$normalizeHandle = (handle)=>{
    return handle.toLowerCase();
};
module.exports.normalizeHandle = $14be2d5be930bc8e$var$normalizeHandle;
const $14be2d5be930bc8e$var$normalizeAndEnsureValidHandle = (handle)=>{
    const normalized = (0, module.exports.normalizeHandle)(handle);
    (0, module.exports.ensureValidHandle)(normalized);
    return normalized;
};
module.exports.normalizeAndEnsureValidHandle = $14be2d5be930bc8e$var$normalizeAndEnsureValidHandle;
const $14be2d5be930bc8e$var$isValidHandle = (handle)=>{
    try {
        (0, module.exports.ensureValidHandle)(handle);
    } catch (err) {
        if (err instanceof $14be2d5be930bc8e$var$InvalidHandleError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidHandle = $14be2d5be930bc8e$var$isValidHandle;
const $14be2d5be930bc8e$var$isValidTld = (handle)=>{
    return !module.exports.DISALLOWED_TLDS.some((domain)=>handle.endsWith(domain));
};
module.exports.isValidTld = $14be2d5be930bc8e$var$isValidTld;
class $14be2d5be930bc8e$var$InvalidHandleError extends Error {
}
module.exports.InvalidHandleError = $14be2d5be930bc8e$var$InvalidHandleError;
/** @deprecated Never used */ class $14be2d5be930bc8e$var$ReservedHandleError extends Error {
}
module.exports.ReservedHandleError = $14be2d5be930bc8e$var$ReservedHandleError;
/** @deprecated Never used */ class $14be2d5be930bc8e$var$UnsupportedDomainError extends Error {
}
module.exports.UnsupportedDomainError = $14be2d5be930bc8e$var$UnsupportedDomainError;
/** @deprecated Never used */ class $14be2d5be930bc8e$var$DisallowedDomainError extends Error {
}
module.exports.DisallowedDomainError = $14be2d5be930bc8e$var$DisallowedDomainError;

});

parcelRegister("3gKOw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidDidError = module.exports.ensureValidDidRegex = module.exports.ensureValidDid = void 0;
// Human-readable constraints:
//   - valid W3C DID (https://www.w3.org/TR/did-core/#did-syntax)
//      - entire URI is ASCII: [a-zA-Z0-9._:%-]
//      - always starts "did:" (lower-case)
//      - method name is one or more lower-case letters, followed by ":"
//      - remaining identifier can have any of the above chars, but can not end in ":"
//      - it seems that a bunch of ":" can be included, and don't need spaces between
//      - "%" is used only for "percent encoding" and must be followed by two hex characters (and thus can't end in "%")
//      - query ("?") and fragment ("#") stuff is defined for "DID URIs", but not as part of identifier itself
//      - "The current specification does not take a position on the maximum length of a DID"
//   - in current atproto, only allowing did:plc and did:web. But not *forcing* this at lexicon layer
//   - hard length limit of 8KBytes
//   - not going to validate "percent encoding" here
const $26172df72b56388e$var$ensureValidDid = (did)=>{
    if (!did.startsWith('did:')) throw new $26172df72b56388e$var$InvalidDidError('DID requires "did:" prefix');
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9._:%-]*$/.test(did)) throw new $26172df72b56388e$var$InvalidDidError('Disallowed characters in DID (ASCII letters, digits, and a couple other characters only)');
    const { length: length, 1: method } = did.split(':');
    if (length < 3) throw new $26172df72b56388e$var$InvalidDidError('DID requires prefix, method, and method-specific content');
    if (!/^[a-z]+$/.test(method)) throw new $26172df72b56388e$var$InvalidDidError('DID method must be lower-case letters');
    if (did.endsWith(':') || did.endsWith('%')) throw new $26172df72b56388e$var$InvalidDidError('DID can not end with ":" or "%"');
    if (did.length > 2048) throw new $26172df72b56388e$var$InvalidDidError('DID is too long (2048 chars max)');
};
module.exports.ensureValidDid = $26172df72b56388e$var$ensureValidDid;
const $26172df72b56388e$var$ensureValidDidRegex = (did)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints
    if (!/^did:[a-z]+:[a-zA-Z0-9._:%-]*[a-zA-Z0-9._-]$/.test(did)) throw new $26172df72b56388e$var$InvalidDidError("DID didn't validate via regex");
    if (did.length > 2048) throw new $26172df72b56388e$var$InvalidDidError('DID is too long (2048 chars max)');
};
module.exports.ensureValidDidRegex = $26172df72b56388e$var$ensureValidDidRegex;
class $26172df72b56388e$var$InvalidDidError extends Error {
}
module.exports.InvalidDidError = $26172df72b56388e$var$InvalidDidError;

});

parcelRegister("hDhgK", function(module, exports) {
"use strict";
/*
Grammar:

alpha     = "a" / "b" / "c" / "d" / "e" / "f" / "g" / "h" / "i" / "j" / "k" / "l" / "m" / "n" / "o" / "p" / "q" / "r" / "s" / "t" / "u" / "v" / "w" / "x" / "y" / "z" / "A" / "B" / "C" / "D" / "E" / "F" / "G" / "H" / "I" / "J" / "K" / "L" / "M" / "N" / "O" / "P" / "Q" / "R" / "S" / "T" / "U" / "V" / "W" / "X" / "Y" / "Z"
number    = "1" / "2" / "3" / "4" / "5" / "6" / "7" / "8" / "9" / "0"
delim     = "."
segment   = alpha *( alpha / number / "-" )
authority = segment *( delim segment )
name      = alpha *( alpha )
nsid      = authority delim name

*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidNsidError = module.exports.ensureValidNsidRegex = module.exports.ensureValidNsid = module.exports.NSID = void 0;
class $cd63797be799f977$var$NSID {
    static parse(nsid) {
        return new $cd63797be799f977$var$NSID(nsid);
    }
    static create(authority, name) {
        const segments = [
            ...authority.split('.').reverse(),
            name
        ].join('.');
        return new $cd63797be799f977$var$NSID(segments);
    }
    static isValid(nsid) {
        try {
            $cd63797be799f977$var$NSID.parse(nsid);
            return true;
        } catch (e) {
            return false;
        }
    }
    constructor(nsid){
        Object.defineProperty(this, "segments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        (0, module.exports.ensureValidNsid)(nsid);
        this.segments = nsid.split('.');
    }
    get authority() {
        return this.segments.slice(0, this.segments.length - 1).reverse().join('.');
    }
    get name() {
        return this.segments.at(this.segments.length - 1);
    }
    toString() {
        return this.segments.join('.');
    }
}
module.exports.NSID = $cd63797be799f977$var$NSID;
// Human readable constraints on NSID:
// - a valid domain in reversed notation
// - followed by an additional period-separated name, which is camel-case letters
const $cd63797be799f977$var$ensureValidNsid = (nsid)=>{
    const toCheck = nsid;
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9.-]*$/.test(toCheck)) throw new $cd63797be799f977$var$InvalidNsidError('Disallowed characters in NSID (ASCII letters, digits, dashes, periods only)');
    if (toCheck.length > 317) throw new $cd63797be799f977$var$InvalidNsidError('NSID is too long (317 chars max)');
    const labels = toCheck.split('.');
    if (labels.length < 3) throw new $cd63797be799f977$var$InvalidNsidError('NSID needs at least three parts');
    for(let i = 0; i < labels.length; i++){
        const l = labels[i];
        if (l.length < 1) throw new $cd63797be799f977$var$InvalidNsidError('NSID parts can not be empty');
        if (l.length > 63) throw new $cd63797be799f977$var$InvalidNsidError('NSID part too long (max 63 chars)');
        if (l.endsWith('-') || l.startsWith('-')) throw new $cd63797be799f977$var$InvalidNsidError('NSID parts can not start or end with hyphen');
        if (/^[0-9]/.test(l) && i === 0) throw new $cd63797be799f977$var$InvalidNsidError('NSID first part may not start with a digit');
        if (!/^[a-zA-Z]+$/.test(l) && i + 1 === labels.length) throw new $cd63797be799f977$var$InvalidNsidError('NSID name part must be only letters');
    }
};
module.exports.ensureValidNsid = $cd63797be799f977$var$ensureValidNsid;
const $cd63797be799f977$var$ensureValidNsidRegex = (nsid)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints
    if (!/^[a-zA-Z]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(\.[a-zA-Z]([a-zA-Z]{0,61}[a-zA-Z])?)$/.test(nsid)) throw new $cd63797be799f977$var$InvalidNsidError("NSID didn't validate via regex");
    if (nsid.length > 317) throw new $cd63797be799f977$var$InvalidNsidError('NSID is too long (317 chars max)');
};
module.exports.ensureValidNsidRegex = $cd63797be799f977$var$ensureValidNsidRegex;
class $cd63797be799f977$var$InvalidNsidError extends Error {
}
module.exports.InvalidNsidError = $cd63797be799f977$var$InvalidNsidError;

});

parcelRegister("lyyoE", function(module, exports) {
"use strict";
var $fb17746a31b5b5a3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fb17746a31b5b5a3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fb17746a31b5b5a3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtUri = module.exports.ATP_URI_REGEX = void 0;

$fb17746a31b5b5a3$var$__exportStar((parcelRequire("k7vdJ")), module.exports);
module.exports.ATP_URI_REGEX = // proto-    --did--------------   --name----------------   --path----   --query--   --hash--
/^(at:\/\/)?((?:did:[a-z0-9:%-]+)|(?:[a-z0-9][a-z0-9.:-]*))(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
//                       --path-----   --query--  --hash--
const $fb17746a31b5b5a3$var$RELATIVE_REGEX = /^(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
class $fb17746a31b5b5a3$var$AtUri {
    constructor(uri, base){
        Object.defineProperty(this, "hash", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "host", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pathname", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "searchParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        let parsed;
        if (base) {
            parsed = $fb17746a31b5b5a3$var$parse(base);
            if (!parsed) throw new Error(`Invalid at uri: ${base}`);
            const relativep = $fb17746a31b5b5a3$var$parseRelative(uri);
            if (!relativep) throw new Error(`Invalid path: ${uri}`);
            Object.assign(parsed, relativep);
        } else {
            parsed = $fb17746a31b5b5a3$var$parse(uri);
            if (!parsed) throw new Error(`Invalid at uri: ${uri}`);
        }
        this.hash = parsed.hash;
        this.host = parsed.host;
        this.pathname = parsed.pathname;
        this.searchParams = parsed.searchParams;
    }
    static make(handleOrDid, collection, rkey) {
        let str = handleOrDid;
        if (collection) str += '/' + collection;
        if (rkey) str += '/' + rkey;
        return new $fb17746a31b5b5a3$var$AtUri(str);
    }
    get protocol() {
        return 'at:';
    }
    get origin() {
        return `at://${this.host}`;
    }
    get hostname() {
        return this.host;
    }
    set hostname(v) {
        this.host = v;
    }
    get search() {
        return this.searchParams.toString();
    }
    set search(v) {
        this.searchParams = new URLSearchParams(v);
    }
    get collection() {
        return this.pathname.split('/').filter(Boolean)[0] || '';
    }
    set collection(v) {
        const parts = this.pathname.split('/').filter(Boolean);
        parts[0] = v;
        this.pathname = parts.join('/');
    }
    get rkey() {
        return this.pathname.split('/').filter(Boolean)[1] || '';
    }
    set rkey(v) {
        const parts = this.pathname.split('/').filter(Boolean);
        if (!parts[0]) parts[0] = 'undefined';
        parts[1] = v;
        this.pathname = parts.join('/');
    }
    get href() {
        return this.toString();
    }
    toString() {
        let path = this.pathname || '/';
        if (!path.startsWith('/')) path = `/${path}`;
        let qs = this.searchParams.toString();
        if (qs && !qs.startsWith('?')) qs = `?${qs}`;
        let hash = this.hash;
        if (hash && !hash.startsWith('#')) hash = `#${hash}`;
        return `at://${this.host}${path}${qs}${hash}`;
    }
}
module.exports.AtUri = $fb17746a31b5b5a3$var$AtUri;
function $fb17746a31b5b5a3$var$parse(str) {
    const match = module.exports.ATP_URI_REGEX.exec(str);
    if (match) return {
        hash: match[5] || '',
        host: match[2] || '',
        pathname: match[3] || '',
        searchParams: new URLSearchParams(match[4] || '')
    };
    return undefined;
}
function $fb17746a31b5b5a3$var$parseRelative(str) {
    const match = $fb17746a31b5b5a3$var$RELATIVE_REGEX.exec(str);
    if (match) return {
        hash: match[3] || '',
        pathname: match[1] || '',
        searchParams: new URLSearchParams(match[2] || '')
    };
    return undefined;
}

});
parcelRegister("k7vdJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ensureValidAtUriRegex = module.exports.ensureValidAtUri = void 0;

var $3gKOw = parcelRequire("3gKOw");

var $1MpES = parcelRequire("1MpES");

var $hDhgK = parcelRequire("hDhgK");
// Human-readable constraints on ATURI:
//   - following regular URLs, a 8KByte hard total length limit
//   - follows ATURI docs on website
//      - all ASCII characters, no whitespace. non-ASCII could be URL-encoded
//      - starts "at://"
//      - "authority" is a valid DID or a valid handle
//      - optionally, follow "authority" with "/" and valid NSID as start of path
//      - optionally, if NSID given, follow that with "/" and rkey
//      - rkey path component can include URL-encoded ("percent encoded"), or:
//          ALPHA / DIGIT / "-" / "." / "_" / "~" / ":" / "@" / "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
//          [a-zA-Z0-9._~:@!$&'\(\)*+,;=-]
//      - rkey must have at least one char
//      - regardless of path component, a fragment can follow  as "#" and then a JSON pointer (RFC-6901)
const $ea5cadd46dce823d$var$ensureValidAtUri = (uri)=>{
    // JSON pointer is pretty different from rest of URI, so split that out first
    const uriParts = uri.split('#');
    if (uriParts.length > 2) throw new Error('ATURI can have at most one "#", separating fragment out');
    const fragmentPart = uriParts[1] || null;
    uri = uriParts[0];
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9._~:@!$&')(*+,;=%/-]*$/.test(uri)) throw new Error('Disallowed characters in ATURI (ASCII)');
    const parts = uri.split('/');
    if (parts.length >= 3 && (parts[0] !== 'at:' || parts[1].length !== 0)) throw new Error('ATURI must start with "at://"');
    if (parts.length < 3) throw new Error('ATURI requires at least method and authority sections');
    try {
        if (parts[2].startsWith('did:')) (0, $3gKOw.ensureValidDid)(parts[2]);
        else (0, $1MpES.ensureValidHandle)(parts[2]);
    } catch  {
        throw new Error('ATURI authority must be a valid handle or DID');
    }
    if (parts.length >= 4) {
        if (parts[3].length === 0) throw new Error('ATURI can not have a slash after authority without a path segment');
        try {
            (0, $hDhgK.ensureValidNsid)(parts[3]);
        } catch  {
            throw new Error('ATURI requires first path segment (if supplied) to be valid NSID');
        }
    }
    if (parts.length >= 5) {
        if (parts[4].length === 0) throw new Error('ATURI can not have a slash after collection, unless record key is provided');
    // would validate rkey here, but there are basically no constraints!
    }
    if (parts.length >= 6) throw new Error('ATURI path can have at most two parts, and no trailing slash');
    if (uriParts.length >= 2 && fragmentPart == null) throw new Error('ATURI fragment must be non-empty and start with slash');
    if (fragmentPart != null) {
        if (fragmentPart.length === 0 || fragmentPart[0] !== '/') throw new Error('ATURI fragment must be non-empty and start with slash');
        // NOTE: enforcing *some* checks here for sanity. Eg, at least no whitespace
        if (!/^\/[a-zA-Z0-9._~:@!$&')(*+,;=%[\]/-]*$/.test(fragmentPart)) throw new Error('Disallowed characters in ATURI fragment (ASCII)');
    }
    if (uri.length > 8192) throw new Error('ATURI is far too long');
};
module.exports.ensureValidAtUri = $ea5cadd46dce823d$var$ensureValidAtUri;
const $ea5cadd46dce823d$var$ensureValidAtUriRegex = (uri)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints. whew!
    const aturiRegex = /^at:\/\/(?<authority>[a-zA-Z0-9._:%-]+)(\/(?<collection>[a-zA-Z0-9-.]+)(\/(?<rkey>[a-zA-Z0-9._~:@!$&%')(*+,;=-]+))?)?(#(?<fragment>\/[a-zA-Z0-9._~:@!$&%')(*+,;=\-[\]/\\]*))?$/;
    const rm = uri.match(aturiRegex);
    if (!rm || !rm.groups) throw new Error("ATURI didn't validate via regex");
    const groups = rm.groups;
    try {
        (0, $1MpES.ensureValidHandleRegex)(groups.authority);
    } catch  {
        try {
            (0, $3gKOw.ensureValidDidRegex)(groups.authority);
        } catch  {
            throw new Error('ATURI authority must be a valid handle or DID');
        }
    }
    if (groups.collection) try {
        (0, $hDhgK.ensureValidNsidRegex)(groups.collection);
    } catch  {
        throw new Error('ATURI collection path segment must be a valid NSID');
    }
    if (uri.length > 8192) throw new Error('ATURI is far too long');
};
module.exports.ensureValidAtUriRegex = $ea5cadd46dce823d$var$ensureValidAtUriRegex;

});


parcelRegister("s45NF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidTidError = module.exports.isValidTid = module.exports.ensureValidTid = void 0;
const $0545ca55ce53b8ae$var$TID_LENGTH = 13;
const $0545ca55ce53b8ae$var$TID_REGEX = /^[234567abcdefghij][234567abcdefghijklmnopqrstuvwxyz]{12}$/;
const $0545ca55ce53b8ae$var$ensureValidTid = (tid)=>{
    if (tid.length !== $0545ca55ce53b8ae$var$TID_LENGTH) throw new $0545ca55ce53b8ae$var$InvalidTidError(`TID must be ${$0545ca55ce53b8ae$var$TID_LENGTH} characters`);
    // simple regex to enforce most constraints via just regex and length.
    if (!$0545ca55ce53b8ae$var$TID_REGEX.test(tid)) throw new $0545ca55ce53b8ae$var$InvalidTidError('TID syntax not valid (regex)');
};
module.exports.ensureValidTid = $0545ca55ce53b8ae$var$ensureValidTid;
const $0545ca55ce53b8ae$var$isValidTid = (tid)=>{
    return tid.length === $0545ca55ce53b8ae$var$TID_LENGTH && $0545ca55ce53b8ae$var$TID_REGEX.test(tid);
};
module.exports.isValidTid = $0545ca55ce53b8ae$var$isValidTid;
class $0545ca55ce53b8ae$var$InvalidTidError extends Error {
}
module.exports.InvalidTidError = $0545ca55ce53b8ae$var$InvalidTidError;

});

parcelRegister("4mRLS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidRecordKeyError = module.exports.isValidRecordKey = module.exports.ensureValidRecordKey = void 0;
const $32e2ed51e04bd9d2$var$ensureValidRecordKey = (rkey)=>{
    if (rkey.length > 512 || rkey.length < 1) throw new $32e2ed51e04bd9d2$var$InvalidRecordKeyError('record key must be 1 to 512 characters');
    // simple regex to enforce most constraints via just regex and length.
    if (!/^[a-zA-Z0-9_~.:-]{1,512}$/.test(rkey)) throw new $32e2ed51e04bd9d2$var$InvalidRecordKeyError('record key syntax not valid (regex)');
    if (rkey === '.' || rkey === '..') throw new $32e2ed51e04bd9d2$var$InvalidRecordKeyError('record key can not be "." or ".."');
};
module.exports.ensureValidRecordKey = $32e2ed51e04bd9d2$var$ensureValidRecordKey;
const $32e2ed51e04bd9d2$var$isValidRecordKey = (rkey)=>{
    try {
        (0, module.exports.ensureValidRecordKey)(rkey);
    } catch (err) {
        if (err instanceof $32e2ed51e04bd9d2$var$InvalidRecordKeyError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidRecordKey = $32e2ed51e04bd9d2$var$isValidRecordKey;
class $32e2ed51e04bd9d2$var$InvalidRecordKeyError extends Error {
}
module.exports.InvalidRecordKeyError = $32e2ed51e04bd9d2$var$InvalidRecordKeyError;

});

parcelRegister("ckHH9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidDatetimeError = module.exports.normalizeDatetimeAlways = module.exports.normalizeDatetime = module.exports.isValidDatetime = module.exports.ensureValidDatetime = void 0;
/* Validates datetime string against atproto Lexicon 'datetime' format.
 * Syntax is described at: https://atproto.com/specs/lexicon#datetime
 */ const $8fa93f32b4709543$var$ensureValidDatetime = (dtStr)=>{
    const date = new Date(dtStr);
    // must parse as ISO 8601; this also verifies semantics like month is not 13 or 00
    if (isNaN(date.getTime())) throw new $8fa93f32b4709543$var$InvalidDatetimeError('datetime did not parse as ISO 8601');
    if (date.toISOString().startsWith('-')) throw new $8fa93f32b4709543$var$InvalidDatetimeError('datetime normalized to a negative time');
    // regex and other checks for RFC-3339
    if (!/^[0-9]{4}-[01][0-9]-[0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9](.[0-9]{1,20})?(Z|([+-][0-2][0-9]:[0-5][0-9]))$/.test(dtStr)) throw new $8fa93f32b4709543$var$InvalidDatetimeError("datetime didn't validate via regex");
    if (dtStr.length > 64) throw new $8fa93f32b4709543$var$InvalidDatetimeError('datetime is too long (64 chars max)');
    if (dtStr.endsWith('-00:00')) throw new $8fa93f32b4709543$var$InvalidDatetimeError('datetime can not use "-00:00" for UTC timezone');
    if (dtStr.startsWith('000')) throw new $8fa93f32b4709543$var$InvalidDatetimeError('datetime so close to year zero not allowed');
};
module.exports.ensureValidDatetime = $8fa93f32b4709543$var$ensureValidDatetime;
/* Same logic as ensureValidDatetime(), but returns a boolean instead of throwing an exception.
 */ const $8fa93f32b4709543$var$isValidDatetime = (dtStr)=>{
    try {
        (0, module.exports.ensureValidDatetime)(dtStr);
    } catch (err) {
        if (err instanceof $8fa93f32b4709543$var$InvalidDatetimeError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidDatetime = $8fa93f32b4709543$var$isValidDatetime;
/* Takes a flexible datetime string and normalizes representation.
 *
 * This function will work with any valid atproto datetime (eg, anything which isValidDatetime() is true for). It *additionally* is more flexible about accepting datetimes that don't comply to RFC 3339, or are missing timezone information, and normalizing them to a valid datetime.
 *
 * One use-case is a consistent, sortable string. Another is to work with older invalid createdAt datetimes.
 *
 * Successful output will be a valid atproto datetime with millisecond precision (3 sub-second digits) and UTC timezone with trailing 'Z' syntax. Throws `InvalidDatetimeError` if the input string could not be parsed as a datetime, even with permissive parsing.
 *
 * Expected output format: YYYY-MM-DDTHH:mm:ss.sssZ
 */ const $8fa93f32b4709543$var$normalizeDatetime = (dtStr)=>{
    if ((0, module.exports.isValidDatetime)(dtStr)) {
        const outStr = new Date(dtStr).toISOString();
        if ((0, module.exports.isValidDatetime)(outStr)) return outStr;
    }
    // check if this permissive datetime is missing a timezone
    if (!/.*(([+-]\d\d:?\d\d)|[a-zA-Z])$/.test(dtStr)) {
        const date = new Date(dtStr + 'Z');
        if (!isNaN(date.getTime())) {
            const tzStr = date.toISOString();
            if ((0, module.exports.isValidDatetime)(tzStr)) return tzStr;
        }
    }
    // finally try parsing as simple datetime
    const date = new Date(dtStr);
    if (isNaN(date.getTime())) throw new $8fa93f32b4709543$var$InvalidDatetimeError('datetime did not parse as any timestamp format');
    const isoStr = date.toISOString();
    if ((0, module.exports.isValidDatetime)(isoStr)) return isoStr;
    else throw new $8fa93f32b4709543$var$InvalidDatetimeError('datetime normalized to invalid timestamp string');
};
module.exports.normalizeDatetime = $8fa93f32b4709543$var$normalizeDatetime;
/* Variant of normalizeDatetime() which always returns a valid datetime strings.
 *
 * If a InvalidDatetimeError is encountered, returns the UNIX epoch time as a UTC datetime (1970-01-01T00:00:00.000Z).
 */ const $8fa93f32b4709543$var$normalizeDatetimeAlways = (dtStr)=>{
    try {
        return (0, module.exports.normalizeDatetime)(dtStr);
    } catch (err) {
        if (err instanceof $8fa93f32b4709543$var$InvalidDatetimeError) return new Date(0).toISOString();
        throw err;
    }
};
module.exports.normalizeDatetimeAlways = $8fa93f32b4709543$var$normalizeDatetimeAlways;
/* Indicates a datetime string did not pass full atproto Lexicon datetime string format checks.
 */ class $8fa93f32b4709543$var$InvalidDatetimeError extends Error {
}
module.exports.InvalidDatetimeError = $8fa93f32b4709543$var$InvalidDatetimeError;

});

parcelRegister("gAO5y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hPpei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BSKY_LABELER_DID = void 0;
module.exports.BSKY_LABELER_DID = 'did:plc:ar7c4by46qjdydhdevvrndac';

});

parcelRegister("bjLh7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.nuxSchema = module.exports.asDid = module.exports.isDid = void 0;
module.exports.sanitizeMutedWordValue = $83d623e9c5c691a9$var$sanitizeMutedWordValue;
module.exports.savedFeedsToUriArrays = $83d623e9c5c691a9$var$savedFeedsToUriArrays;
module.exports.getSavedFeedType = $83d623e9c5c691a9$var$getSavedFeedType;
module.exports.validateSavedFeed = $83d623e9c5c691a9$var$validateSavedFeed;
module.exports.validateNux = $83d623e9c5c691a9$var$validateNux;

var $2zDt6 = parcelRequire("2zDt6");

var $bc6Ix = parcelRequire("bc6Ix");

var $UiDXP = parcelRequire("UiDXP");
function $83d623e9c5c691a9$var$sanitizeMutedWordValue(value) {
    return value.trim().replace(/^#(?!\ufe0f)/, '')// eslint-disable-next-line no-misleading-character-class
    .replace(/[\r\n\u00AD\u2060\u200D\u200C\u200B]+/, '');
}
function $83d623e9c5c691a9$var$savedFeedsToUriArrays(savedFeeds) {
    const pinned = [];
    const saved = [];
    for (const feed of savedFeeds)if (feed.pinned) {
        pinned.push(feed.value);
        // saved in v1 includes pinned
        saved.push(feed.value);
    } else saved.push(feed.value);
    return {
        pinned: pinned,
        saved: saved
    };
}
/**
 * Get the type of a saved feed, used by deprecated methods for backwards
 * compat. Should not be used moving forward. *Invalid URIs will throw.*
 *
 * @param uri - The AT URI of the saved feed
 */ function $83d623e9c5c691a9$var$getSavedFeedType(uri) {
    const urip = new $UiDXP.AtUri(uri);
    switch(urip.collection){
        case 'app.bsky.feed.generator':
            return 'feed';
        case 'app.bsky.graph.list':
            return 'list';
        default:
            return 'unknown';
    }
}
function $83d623e9c5c691a9$var$validateSavedFeed(savedFeed) {
    new $bc6Ix.TID(savedFeed.id);
    if ([
        'feed',
        'list'
    ].includes(savedFeed.type)) {
        const uri = new $UiDXP.AtUri(savedFeed.value);
        const isFeed = uri.collection === 'app.bsky.feed.generator';
        const isList = uri.collection === 'app.bsky.graph.list';
        if (savedFeed.type === 'feed' && !isFeed) throw new Error(`Saved feed of type 'feed' must be a feed, got ${uri.collection}`);
        if (savedFeed.type === 'list' && !isList) throw new Error(`Saved feed of type 'list' must be a list, got ${uri.collection}`);
    }
}
// @TODO use tools from @atproto/did
const $83d623e9c5c691a9$var$isDid = (str)=>typeof str === 'string' && str.startsWith('did:') && str.includes(':', 4) && str.length > 8 && str.length <= 2048;
module.exports.isDid = $83d623e9c5c691a9$var$isDid;
const $83d623e9c5c691a9$var$asDid = (value)=>{
    if ((0, module.exports.isDid)(value)) return value;
    throw new TypeError(`Invalid DID: ${value}`);
};
module.exports.asDid = $83d623e9c5c691a9$var$asDid;
module.exports.nuxSchema = $2zDt6.z.object({
    id: $2zDt6.z.string().max(64),
    completed: $2zDt6.z.boolean(),
    data: $2zDt6.z.string().max(300).optional(),
    expiresAt: $2zDt6.z.string().datetime().optional()
}).strict();
function $83d623e9c5c691a9$var$validateNux(nux) {
    module.exports.nuxSchema.parse(nux);
}

});
parcelRegister("UiDXP", function(module, exports) {
"use strict";
var $0a93b14deb5a0596$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a93b14deb5a0596$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0a93b14deb5a0596$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0a93b14deb5a0596$var$__exportStar((parcelRequire("1MpES")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("3gKOw")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("hDhgK")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("lyyoE")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("s45NF")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("4mRLS")), module.exports);

$0a93b14deb5a0596$var$__exportStar((parcelRequire("ckHH9")), module.exports);

});


parcelRegister("2wqOO", function(module, exports) {
"use strict";
var $1d635f8a313474c1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1d635f8a313474c1$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1d635f8a313474c1$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1d635f8a313474c1$var$__createBinding(result, mod, k);
    }
    $1d635f8a313474c1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComAtprotoServerDeleteAccount = module.exports.ComAtprotoServerDefs = module.exports.ComAtprotoServerDeactivateAccount = module.exports.ComAtprotoServerCreateSession = module.exports.ComAtprotoServerCreateInviteCodes = module.exports.ComAtprotoServerCreateInviteCode = module.exports.ComAtprotoServerCreateAppPassword = module.exports.ComAtprotoServerCreateAccount = module.exports.ComAtprotoServerConfirmEmail = module.exports.ComAtprotoServerCheckAccountStatus = module.exports.ComAtprotoServerActivateAccount = module.exports.ComAtprotoRepoUploadBlob = module.exports.ComAtprotoRepoStrongRef = module.exports.ComAtprotoRepoPutRecord = module.exports.ComAtprotoRepoListRecords = module.exports.ComAtprotoRepoListMissingBlobs = module.exports.ComAtprotoRepoImportRepo = module.exports.ComAtprotoRepoGetRecord = module.exports.ComAtprotoRepoDescribeRepo = module.exports.ComAtprotoRepoDeleteRecord = module.exports.ComAtprotoRepoDefs = module.exports.ComAtprotoRepoCreateRecord = module.exports.ComAtprotoRepoApplyWrites = module.exports.ComAtprotoModerationDefs = module.exports.ComAtprotoModerationCreateReport = module.exports.ComAtprotoLexiconSchema = module.exports.ComAtprotoLabelSubscribeLabels = module.exports.ComAtprotoLabelQueryLabels = module.exports.ComAtprotoLabelDefs = module.exports.ComAtprotoIdentityUpdateHandle = module.exports.ComAtprotoIdentitySubmitPlcOperation = module.exports.ComAtprotoIdentitySignPlcOperation = module.exports.ComAtprotoIdentityResolveHandle = module.exports.ComAtprotoIdentityRequestPlcOperationSignature = module.exports.ComAtprotoIdentityGetRecommendedDidCredentials = module.exports.ComAtprotoAdminUpdateSubjectStatus = module.exports.ComAtprotoAdminUpdateAccountPassword = module.exports.ComAtprotoAdminUpdateAccountHandle = module.exports.ComAtprotoAdminUpdateAccountEmail = module.exports.ComAtprotoAdminSendEmail = module.exports.ComAtprotoAdminSearchAccounts = module.exports.ComAtprotoAdminGetSubjectStatus = module.exports.ComAtprotoAdminGetInviteCodes = module.exports.ComAtprotoAdminGetAccountInfos = module.exports.ComAtprotoAdminGetAccountInfo = module.exports.ComAtprotoAdminEnableAccountInvites = module.exports.ComAtprotoAdminDisableInviteCodes = module.exports.ComAtprotoAdminDisableAccountInvites = module.exports.ComAtprotoAdminDeleteAccount = module.exports.ComAtprotoAdminDefs = void 0;
module.exports.AppBskyFeedGenerator = module.exports.AppBskyFeedDescribeFeedGenerator = module.exports.AppBskyFeedDefs = module.exports.AppBskyEmbedVideo = module.exports.AppBskyEmbedRecordWithMedia = module.exports.AppBskyEmbedRecord = module.exports.AppBskyEmbedImages = module.exports.AppBskyEmbedExternal = module.exports.AppBskyEmbedDefs = module.exports.AppBskyActorSearchActorsTypeahead = module.exports.AppBskyActorSearchActors = module.exports.AppBskyActorPutPreferences = module.exports.AppBskyActorProfile = module.exports.AppBskyActorGetSuggestions = module.exports.AppBskyActorGetProfiles = module.exports.AppBskyActorGetProfile = module.exports.AppBskyActorGetPreferences = module.exports.AppBskyActorDefs = module.exports.ComAtprotoTempRequestPhoneVerification = module.exports.ComAtprotoTempFetchLabels = module.exports.ComAtprotoTempCheckSignupQueue = module.exports.ComAtprotoTempAddReservedHandle = module.exports.ComAtprotoSyncSubscribeRepos = module.exports.ComAtprotoSyncRequestCrawl = module.exports.ComAtprotoSyncNotifyOfUpdate = module.exports.ComAtprotoSyncListRepos = module.exports.ComAtprotoSyncListBlobs = module.exports.ComAtprotoSyncGetRepoStatus = module.exports.ComAtprotoSyncGetRepo = module.exports.ComAtprotoSyncGetRecord = module.exports.ComAtprotoSyncGetLatestCommit = module.exports.ComAtprotoSyncGetHead = module.exports.ComAtprotoSyncGetCheckout = module.exports.ComAtprotoSyncGetBlocks = module.exports.ComAtprotoSyncGetBlob = module.exports.ComAtprotoServerUpdateEmail = module.exports.ComAtprotoServerRevokeAppPassword = module.exports.ComAtprotoServerResetPassword = module.exports.ComAtprotoServerReserveSigningKey = module.exports.ComAtprotoServerRequestPasswordReset = module.exports.ComAtprotoServerRequestEmailUpdate = module.exports.ComAtprotoServerRequestEmailConfirmation = module.exports.ComAtprotoServerRequestAccountDelete = module.exports.ComAtprotoServerRefreshSession = module.exports.ComAtprotoServerListAppPasswords = module.exports.ComAtprotoServerGetSession = module.exports.ComAtprotoServerGetServiceAuth = module.exports.ComAtprotoServerGetAccountInviteCodes = module.exports.ComAtprotoServerDescribeServer = module.exports.ComAtprotoServerDeleteSession = void 0;
module.exports.AppBskyGraphUnmuteThread = module.exports.AppBskyGraphUnmuteActorList = module.exports.AppBskyGraphUnmuteActor = module.exports.AppBskyGraphStarterpack = module.exports.AppBskyGraphSearchStarterPacks = module.exports.AppBskyGraphMuteThread = module.exports.AppBskyGraphMuteActorList = module.exports.AppBskyGraphMuteActor = module.exports.AppBskyGraphListitem = module.exports.AppBskyGraphListblock = module.exports.AppBskyGraphList = module.exports.AppBskyGraphGetSuggestedFollowsByActor = module.exports.AppBskyGraphGetStarterPacks = module.exports.AppBskyGraphGetStarterPack = module.exports.AppBskyGraphGetRelationships = module.exports.AppBskyGraphGetMutes = module.exports.AppBskyGraphGetLists = module.exports.AppBskyGraphGetListMutes = module.exports.AppBskyGraphGetListBlocks = module.exports.AppBskyGraphGetList = module.exports.AppBskyGraphGetKnownFollowers = module.exports.AppBskyGraphGetFollows = module.exports.AppBskyGraphGetFollowers = module.exports.AppBskyGraphGetBlocks = module.exports.AppBskyGraphGetActorStarterPacks = module.exports.AppBskyGraphFollow = module.exports.AppBskyGraphDefs = module.exports.AppBskyGraphBlock = module.exports.AppBskyFeedThreadgate = module.exports.AppBskyFeedSendInteractions = module.exports.AppBskyFeedSearchPosts = module.exports.AppBskyFeedRepost = module.exports.AppBskyFeedPostgate = module.exports.AppBskyFeedPost = module.exports.AppBskyFeedLike = module.exports.AppBskyFeedGetTimeline = module.exports.AppBskyFeedGetSuggestedFeeds = module.exports.AppBskyFeedGetRepostedBy = module.exports.AppBskyFeedGetQuotes = module.exports.AppBskyFeedGetPosts = module.exports.AppBskyFeedGetPostThread = module.exports.AppBskyFeedGetListFeed = module.exports.AppBskyFeedGetLikes = module.exports.AppBskyFeedGetFeedSkeleton = module.exports.AppBskyFeedGetFeedGenerators = module.exports.AppBskyFeedGetFeedGenerator = module.exports.AppBskyFeedGetFeed = module.exports.AppBskyFeedGetAuthorFeed = module.exports.AppBskyFeedGetActorLikes = module.exports.AppBskyFeedGetActorFeeds = void 0;
module.exports.ToolsOzoneModerationGetEvent = module.exports.ToolsOzoneModerationEmitEvent = module.exports.ToolsOzoneModerationDefs = module.exports.ToolsOzoneCommunicationUpdateTemplate = module.exports.ToolsOzoneCommunicationListTemplates = module.exports.ToolsOzoneCommunicationDeleteTemplate = module.exports.ToolsOzoneCommunicationDefs = module.exports.ToolsOzoneCommunicationCreateTemplate = module.exports.ChatBskyModerationUpdateActorAccess = module.exports.ChatBskyModerationGetMessageContext = module.exports.ChatBskyModerationGetActorMetadata = module.exports.ChatBskyConvoUpdateRead = module.exports.ChatBskyConvoUnmuteConvo = module.exports.ChatBskyConvoSendMessageBatch = module.exports.ChatBskyConvoSendMessage = module.exports.ChatBskyConvoMuteConvo = module.exports.ChatBskyConvoListConvos = module.exports.ChatBskyConvoLeaveConvo = module.exports.ChatBskyConvoGetMessages = module.exports.ChatBskyConvoGetLog = module.exports.ChatBskyConvoGetConvoForMembers = module.exports.ChatBskyConvoGetConvo = module.exports.ChatBskyConvoDeleteMessageForSelf = module.exports.ChatBskyConvoDefs = module.exports.ChatBskyActorExportAccountData = module.exports.ChatBskyActorDeleteAccount = module.exports.ChatBskyActorDefs = module.exports.ChatBskyActorDeclaration = module.exports.AppBskyVideoUploadVideo = module.exports.AppBskyVideoGetUploadLimits = module.exports.AppBskyVideoGetJobStatus = module.exports.AppBskyVideoDefs = module.exports.AppBskyUnspeccedSearchStarterPacksSkeleton = module.exports.AppBskyUnspeccedSearchPostsSkeleton = module.exports.AppBskyUnspeccedSearchActorsSkeleton = module.exports.AppBskyUnspeccedGetTrendingTopics = module.exports.AppBskyUnspeccedGetTaggedSuggestions = module.exports.AppBskyUnspeccedGetSuggestionsSkeleton = module.exports.AppBskyUnspeccedGetPopularFeedGenerators = module.exports.AppBskyUnspeccedGetConfig = module.exports.AppBskyUnspeccedDefs = module.exports.AppBskyRichtextFacet = module.exports.AppBskyNotificationUpdateSeen = module.exports.AppBskyNotificationRegisterPush = module.exports.AppBskyNotificationPutPreferences = module.exports.AppBskyNotificationListNotifications = module.exports.AppBskyNotificationGetUnreadCount = module.exports.AppBskyLabelerService = module.exports.AppBskyLabelerGetServices = module.exports.AppBskyLabelerDefs = void 0;
module.exports.ProfileRecord = module.exports.AppBskyActorNS = module.exports.AppBskyNS = module.exports.AppNS = module.exports.ComAtprotoTempNS = module.exports.ComAtprotoSyncNS = module.exports.ComAtprotoServerNS = module.exports.ComAtprotoRepoNS = module.exports.ComAtprotoModerationNS = module.exports.SchemaRecord = module.exports.ComAtprotoLexiconNS = module.exports.ComAtprotoLabelNS = module.exports.ComAtprotoIdentityNS = module.exports.ComAtprotoAdminNS = module.exports.ComAtprotoNS = module.exports.ComNS = module.exports.AtpBaseClient = module.exports.TOOLS_OZONE_TEAM = module.exports.TOOLS_OZONE_MODERATION = module.exports.APP_BSKY_GRAPH = module.exports.APP_BSKY_FEED = module.exports.COM_ATPROTO_MODERATION = module.exports.ToolsOzoneTeamUpdateMember = module.exports.ToolsOzoneTeamListMembers = module.exports.ToolsOzoneTeamDeleteMember = module.exports.ToolsOzoneTeamDefs = module.exports.ToolsOzoneTeamAddMember = module.exports.ToolsOzoneSignatureSearchAccounts = module.exports.ToolsOzoneSignatureFindRelatedAccounts = module.exports.ToolsOzoneSignatureFindCorrelation = module.exports.ToolsOzoneSignatureDefs = module.exports.ToolsOzoneSettingUpsertOption = module.exports.ToolsOzoneSettingRemoveOptions = module.exports.ToolsOzoneSettingListOptions = module.exports.ToolsOzoneSettingDefs = module.exports.ToolsOzoneSetUpsertSet = module.exports.ToolsOzoneSetQuerySets = module.exports.ToolsOzoneSetGetValues = module.exports.ToolsOzoneSetDeleteValues = module.exports.ToolsOzoneSetDeleteSet = module.exports.ToolsOzoneSetDefs = module.exports.ToolsOzoneSetAddValues = module.exports.ToolsOzoneServerGetConfig = module.exports.ToolsOzoneModerationSearchRepos = module.exports.ToolsOzoneModerationQueryStatuses = module.exports.ToolsOzoneModerationQueryEvents = module.exports.ToolsOzoneModerationGetRepos = module.exports.ToolsOzoneModerationGetRepo = module.exports.ToolsOzoneModerationGetRecords = module.exports.ToolsOzoneModerationGetRecord = void 0;
module.exports.ToolsOzoneTeamNS = module.exports.ToolsOzoneSignatureNS = module.exports.ToolsOzoneSettingNS = module.exports.ToolsOzoneSetNS = module.exports.ToolsOzoneServerNS = module.exports.ToolsOzoneModerationNS = module.exports.ToolsOzoneCommunicationNS = module.exports.ToolsOzoneNS = module.exports.ToolsNS = module.exports.ChatBskyModerationNS = module.exports.ChatBskyConvoNS = module.exports.DeclarationRecord = module.exports.ChatBskyActorNS = module.exports.ChatBskyNS = module.exports.ChatNS = module.exports.AppBskyVideoNS = module.exports.AppBskyUnspeccedNS = module.exports.AppBskyRichtextNS = module.exports.AppBskyNotificationNS = module.exports.ServiceRecord = module.exports.AppBskyLabelerNS = module.exports.StarterpackRecord = module.exports.ListitemRecord = module.exports.ListblockRecord = module.exports.ListRecord = module.exports.FollowRecord = module.exports.BlockRecord = module.exports.AppBskyGraphNS = module.exports.ThreadgateRecord = module.exports.RepostRecord = module.exports.PostgateRecord = module.exports.PostRecord = module.exports.LikeRecord = module.exports.GeneratorRecord = module.exports.AppBskyFeedNS = module.exports.AppBskyEmbedNS = void 0;

var $al5Ta = parcelRequire("al5Ta");

var $8DB7o = parcelRequire("8DB7o");

const $1d635f8a313474c1$var$ComAtprotoRepoApplyWrites = $1d635f8a313474c1$var$__importStar((parcelRequire("cVdHh")));

const $1d635f8a313474c1$var$ComAtprotoRepoCreateRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("038a8")));

const $1d635f8a313474c1$var$ComAtprotoRepoDeleteRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("l5ZNc")));

const $1d635f8a313474c1$var$ComAtprotoRepoGetRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("rzd0a")));

const $1d635f8a313474c1$var$ComAtprotoRepoPutRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("9gufY")));

const $1d635f8a313474c1$var$ComAtprotoServerConfirmEmail = $1d635f8a313474c1$var$__importStar((parcelRequire("l8BOh")));

const $1d635f8a313474c1$var$ComAtprotoServerCreateAccount = $1d635f8a313474c1$var$__importStar((parcelRequire("hSgUY")));

const $1d635f8a313474c1$var$ComAtprotoServerCreateAppPassword = $1d635f8a313474c1$var$__importStar((parcelRequire("k6MKs")));

const $1d635f8a313474c1$var$ComAtprotoServerCreateSession = $1d635f8a313474c1$var$__importStar((parcelRequire("ixoHx")));

const $1d635f8a313474c1$var$ComAtprotoServerDeleteAccount = $1d635f8a313474c1$var$__importStar((parcelRequire("7zUbL")));

const $1d635f8a313474c1$var$ComAtprotoServerGetAccountInviteCodes = $1d635f8a313474c1$var$__importStar((parcelRequire("eneV1")));

const $1d635f8a313474c1$var$ComAtprotoServerGetServiceAuth = $1d635f8a313474c1$var$__importStar((parcelRequire("kdDGi")));

const $1d635f8a313474c1$var$ComAtprotoServerListAppPasswords = $1d635f8a313474c1$var$__importStar((parcelRequire("duByU")));

const $1d635f8a313474c1$var$ComAtprotoServerRefreshSession = $1d635f8a313474c1$var$__importStar((parcelRequire("lekR0")));

const $1d635f8a313474c1$var$ComAtprotoServerResetPassword = $1d635f8a313474c1$var$__importStar((parcelRequire("euqki")));

const $1d635f8a313474c1$var$ComAtprotoServerUpdateEmail = $1d635f8a313474c1$var$__importStar((parcelRequire("5iUWk")));

const $1d635f8a313474c1$var$ComAtprotoSyncGetBlob = $1d635f8a313474c1$var$__importStar((parcelRequire("11of0")));

const $1d635f8a313474c1$var$ComAtprotoSyncGetBlocks = $1d635f8a313474c1$var$__importStar((parcelRequire("fc5eY")));

const $1d635f8a313474c1$var$ComAtprotoSyncGetHead = $1d635f8a313474c1$var$__importStar((parcelRequire("785zH")));

const $1d635f8a313474c1$var$ComAtprotoSyncGetLatestCommit = $1d635f8a313474c1$var$__importStar((parcelRequire("cfaJo")));

const $1d635f8a313474c1$var$ComAtprotoSyncGetRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("4n1SW")));

const $1d635f8a313474c1$var$ComAtprotoSyncGetRepo = $1d635f8a313474c1$var$__importStar((parcelRequire("lfsPu")));

const $1d635f8a313474c1$var$ComAtprotoSyncGetRepoStatus = $1d635f8a313474c1$var$__importStar((parcelRequire("l99IV")));

const $1d635f8a313474c1$var$ComAtprotoSyncListBlobs = $1d635f8a313474c1$var$__importStar((parcelRequire("5i75s")));

const $1d635f8a313474c1$var$AppBskyFeedGetActorLikes = $1d635f8a313474c1$var$__importStar((parcelRequire("6XZma")));

const $1d635f8a313474c1$var$AppBskyFeedGetAuthorFeed = $1d635f8a313474c1$var$__importStar((parcelRequire("1p5kI")));

const $1d635f8a313474c1$var$AppBskyFeedGetFeed = $1d635f8a313474c1$var$__importStar((parcelRequire("7lME1")));

const $1d635f8a313474c1$var$AppBskyFeedGetFeedSkeleton = $1d635f8a313474c1$var$__importStar((parcelRequire("8HHJY")));

const $1d635f8a313474c1$var$AppBskyFeedGetListFeed = $1d635f8a313474c1$var$__importStar((parcelRequire("ba9K6")));

const $1d635f8a313474c1$var$AppBskyFeedGetPostThread = $1d635f8a313474c1$var$__importStar((parcelRequire("ddyeE")));

const $1d635f8a313474c1$var$AppBskyFeedSearchPosts = $1d635f8a313474c1$var$__importStar((parcelRequire("3m5z2")));

const $1d635f8a313474c1$var$AppBskyGraphGetRelationships = $1d635f8a313474c1$var$__importStar((parcelRequire("3M4Rp")));

const $1d635f8a313474c1$var$AppBskyUnspeccedSearchActorsSkeleton = $1d635f8a313474c1$var$__importStar((parcelRequire("a0RJn")));

const $1d635f8a313474c1$var$AppBskyUnspeccedSearchPostsSkeleton = $1d635f8a313474c1$var$__importStar((parcelRequire("6OWOv")));

const $1d635f8a313474c1$var$AppBskyUnspeccedSearchStarterPacksSkeleton = $1d635f8a313474c1$var$__importStar((parcelRequire("bpJIG")));

const $1d635f8a313474c1$var$ToolsOzoneCommunicationCreateTemplate = $1d635f8a313474c1$var$__importStar((parcelRequire("9tmUj")));

const $1d635f8a313474c1$var$ToolsOzoneCommunicationUpdateTemplate = $1d635f8a313474c1$var$__importStar((parcelRequire("3Vj9j")));

const $1d635f8a313474c1$var$ToolsOzoneModerationEmitEvent = $1d635f8a313474c1$var$__importStar((parcelRequire("aDbWo")));

const $1d635f8a313474c1$var$ToolsOzoneModerationGetRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("6zLJN")));

const $1d635f8a313474c1$var$ToolsOzoneModerationGetRepo = $1d635f8a313474c1$var$__importStar((parcelRequire("eewch")));

const $1d635f8a313474c1$var$ToolsOzoneSetDeleteSet = $1d635f8a313474c1$var$__importStar((parcelRequire("fXzWp")));

const $1d635f8a313474c1$var$ToolsOzoneSetDeleteValues = $1d635f8a313474c1$var$__importStar((parcelRequire("eduZ3")));

const $1d635f8a313474c1$var$ToolsOzoneSetGetValues = $1d635f8a313474c1$var$__importStar((parcelRequire("iuEPv")));

const $1d635f8a313474c1$var$ToolsOzoneTeamAddMember = $1d635f8a313474c1$var$__importStar((parcelRequire("8IiFc")));

const $1d635f8a313474c1$var$ToolsOzoneTeamDeleteMember = $1d635f8a313474c1$var$__importStar((parcelRequire("9X16d")));

const $1d635f8a313474c1$var$ToolsOzoneTeamUpdateMember = $1d635f8a313474c1$var$__importStar((parcelRequire("1o4e8")));

module.exports.ComAtprotoAdminDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("29HEg")));

module.exports.ComAtprotoAdminDeleteAccount = $1d635f8a313474c1$var$__importStar((parcelRequire("7W1iM")));

module.exports.ComAtprotoAdminDisableAccountInvites = $1d635f8a313474c1$var$__importStar((parcelRequire("2mykY")));

module.exports.ComAtprotoAdminDisableInviteCodes = $1d635f8a313474c1$var$__importStar((parcelRequire("6kVoY")));

module.exports.ComAtprotoAdminEnableAccountInvites = $1d635f8a313474c1$var$__importStar((parcelRequire("5ecBe")));

module.exports.ComAtprotoAdminGetAccountInfo = $1d635f8a313474c1$var$__importStar((parcelRequire("6AWKm")));

module.exports.ComAtprotoAdminGetAccountInfos = $1d635f8a313474c1$var$__importStar((parcelRequire("htooE")));

module.exports.ComAtprotoAdminGetInviteCodes = $1d635f8a313474c1$var$__importStar((parcelRequire("g4Dr0")));

module.exports.ComAtprotoAdminGetSubjectStatus = $1d635f8a313474c1$var$__importStar((parcelRequire("1u4wl")));

module.exports.ComAtprotoAdminSearchAccounts = $1d635f8a313474c1$var$__importStar((parcelRequire("eyHdJ")));

module.exports.ComAtprotoAdminSendEmail = $1d635f8a313474c1$var$__importStar((parcelRequire("aXH69")));

module.exports.ComAtprotoAdminUpdateAccountEmail = $1d635f8a313474c1$var$__importStar((parcelRequire("hfs1B")));

module.exports.ComAtprotoAdminUpdateAccountHandle = $1d635f8a313474c1$var$__importStar((parcelRequire("2WDSK")));

module.exports.ComAtprotoAdminUpdateAccountPassword = $1d635f8a313474c1$var$__importStar((parcelRequire("aPIOu")));

module.exports.ComAtprotoAdminUpdateSubjectStatus = $1d635f8a313474c1$var$__importStar((parcelRequire("6fqzZ")));

module.exports.ComAtprotoIdentityGetRecommendedDidCredentials = $1d635f8a313474c1$var$__importStar((parcelRequire("hIUy5")));

module.exports.ComAtprotoIdentityRequestPlcOperationSignature = $1d635f8a313474c1$var$__importStar((parcelRequire("k7wt1")));

module.exports.ComAtprotoIdentityResolveHandle = $1d635f8a313474c1$var$__importStar((parcelRequire("eVz2k")));

module.exports.ComAtprotoIdentitySignPlcOperation = $1d635f8a313474c1$var$__importStar((parcelRequire("kp9hl")));

module.exports.ComAtprotoIdentitySubmitPlcOperation = $1d635f8a313474c1$var$__importStar((parcelRequire("bp7XD")));

module.exports.ComAtprotoIdentityUpdateHandle = $1d635f8a313474c1$var$__importStar((parcelRequire("dvF4O")));

module.exports.ComAtprotoLabelDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("c4mKK")));

module.exports.ComAtprotoLabelQueryLabels = $1d635f8a313474c1$var$__importStar((parcelRequire("7Si05")));

module.exports.ComAtprotoLabelSubscribeLabels = $1d635f8a313474c1$var$__importStar((parcelRequire("4z0iR")));

module.exports.ComAtprotoLexiconSchema = $1d635f8a313474c1$var$__importStar((parcelRequire("fJ5UO")));

module.exports.ComAtprotoModerationCreateReport = $1d635f8a313474c1$var$__importStar((parcelRequire("1iivm")));

module.exports.ComAtprotoModerationDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("7cnqm")));

module.exports.ComAtprotoRepoApplyWrites = $1d635f8a313474c1$var$__importStar((parcelRequire("cVdHh")));

module.exports.ComAtprotoRepoCreateRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("038a8")));

module.exports.ComAtprotoRepoDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("irrDD")));

module.exports.ComAtprotoRepoDeleteRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("l5ZNc")));

module.exports.ComAtprotoRepoDescribeRepo = $1d635f8a313474c1$var$__importStar((parcelRequire("1pmxn")));

module.exports.ComAtprotoRepoGetRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("rzd0a")));

module.exports.ComAtprotoRepoImportRepo = $1d635f8a313474c1$var$__importStar((parcelRequire("aRJaV")));

module.exports.ComAtprotoRepoListMissingBlobs = $1d635f8a313474c1$var$__importStar((parcelRequire("kp1bp")));

module.exports.ComAtprotoRepoListRecords = $1d635f8a313474c1$var$__importStar((parcelRequire("lt5Eq")));

module.exports.ComAtprotoRepoPutRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("9gufY")));

module.exports.ComAtprotoRepoStrongRef = $1d635f8a313474c1$var$__importStar((parcelRequire("imENX")));

module.exports.ComAtprotoRepoUploadBlob = $1d635f8a313474c1$var$__importStar((parcelRequire("64xN1")));

module.exports.ComAtprotoServerActivateAccount = $1d635f8a313474c1$var$__importStar((parcelRequire("kRuuY")));

module.exports.ComAtprotoServerCheckAccountStatus = $1d635f8a313474c1$var$__importStar((parcelRequire("a2VvK")));

module.exports.ComAtprotoServerConfirmEmail = $1d635f8a313474c1$var$__importStar((parcelRequire("l8BOh")));

module.exports.ComAtprotoServerCreateAccount = $1d635f8a313474c1$var$__importStar((parcelRequire("hSgUY")));

module.exports.ComAtprotoServerCreateAppPassword = $1d635f8a313474c1$var$__importStar((parcelRequire("k6MKs")));

module.exports.ComAtprotoServerCreateInviteCode = $1d635f8a313474c1$var$__importStar((parcelRequire("2ZEuA")));

module.exports.ComAtprotoServerCreateInviteCodes = $1d635f8a313474c1$var$__importStar((parcelRequire("e3uhv")));

module.exports.ComAtprotoServerCreateSession = $1d635f8a313474c1$var$__importStar((parcelRequire("ixoHx")));

module.exports.ComAtprotoServerDeactivateAccount = $1d635f8a313474c1$var$__importStar((parcelRequire("fUfix")));

module.exports.ComAtprotoServerDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("3xRmd")));

module.exports.ComAtprotoServerDeleteAccount = $1d635f8a313474c1$var$__importStar((parcelRequire("7zUbL")));

module.exports.ComAtprotoServerDeleteSession = $1d635f8a313474c1$var$__importStar((parcelRequire("cR55u")));

module.exports.ComAtprotoServerDescribeServer = $1d635f8a313474c1$var$__importStar((parcelRequire("4Herq")));

module.exports.ComAtprotoServerGetAccountInviteCodes = $1d635f8a313474c1$var$__importStar((parcelRequire("eneV1")));

module.exports.ComAtprotoServerGetServiceAuth = $1d635f8a313474c1$var$__importStar((parcelRequire("kdDGi")));

module.exports.ComAtprotoServerGetSession = $1d635f8a313474c1$var$__importStar((parcelRequire("a2Q24")));

module.exports.ComAtprotoServerListAppPasswords = $1d635f8a313474c1$var$__importStar((parcelRequire("duByU")));

module.exports.ComAtprotoServerRefreshSession = $1d635f8a313474c1$var$__importStar((parcelRequire("lekR0")));

module.exports.ComAtprotoServerRequestAccountDelete = $1d635f8a313474c1$var$__importStar((parcelRequire("lFPfr")));

module.exports.ComAtprotoServerRequestEmailConfirmation = $1d635f8a313474c1$var$__importStar((parcelRequire("ad0jS")));

module.exports.ComAtprotoServerRequestEmailUpdate = $1d635f8a313474c1$var$__importStar((parcelRequire("i1Gy3")));

module.exports.ComAtprotoServerRequestPasswordReset = $1d635f8a313474c1$var$__importStar((parcelRequire("1Us3r")));

module.exports.ComAtprotoServerReserveSigningKey = $1d635f8a313474c1$var$__importStar((parcelRequire("kxLSS")));

module.exports.ComAtprotoServerResetPassword = $1d635f8a313474c1$var$__importStar((parcelRequire("euqki")));

module.exports.ComAtprotoServerRevokeAppPassword = $1d635f8a313474c1$var$__importStar((parcelRequire("gKkDr")));

module.exports.ComAtprotoServerUpdateEmail = $1d635f8a313474c1$var$__importStar((parcelRequire("5iUWk")));

module.exports.ComAtprotoSyncGetBlob = $1d635f8a313474c1$var$__importStar((parcelRequire("11of0")));

module.exports.ComAtprotoSyncGetBlocks = $1d635f8a313474c1$var$__importStar((parcelRequire("fc5eY")));

module.exports.ComAtprotoSyncGetCheckout = $1d635f8a313474c1$var$__importStar((parcelRequire("hJBkc")));

module.exports.ComAtprotoSyncGetHead = $1d635f8a313474c1$var$__importStar((parcelRequire("785zH")));

module.exports.ComAtprotoSyncGetLatestCommit = $1d635f8a313474c1$var$__importStar((parcelRequire("cfaJo")));

module.exports.ComAtprotoSyncGetRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("4n1SW")));

module.exports.ComAtprotoSyncGetRepo = $1d635f8a313474c1$var$__importStar((parcelRequire("lfsPu")));

module.exports.ComAtprotoSyncGetRepoStatus = $1d635f8a313474c1$var$__importStar((parcelRequire("l99IV")));

module.exports.ComAtprotoSyncListBlobs = $1d635f8a313474c1$var$__importStar((parcelRequire("5i75s")));

module.exports.ComAtprotoSyncListRepos = $1d635f8a313474c1$var$__importStar((parcelRequire("6TNBS")));

module.exports.ComAtprotoSyncNotifyOfUpdate = $1d635f8a313474c1$var$__importStar((parcelRequire("haofJ")));

module.exports.ComAtprotoSyncRequestCrawl = $1d635f8a313474c1$var$__importStar((parcelRequire("86PI9")));

module.exports.ComAtprotoSyncSubscribeRepos = $1d635f8a313474c1$var$__importStar((parcelRequire("5JMlg")));

module.exports.ComAtprotoTempAddReservedHandle = $1d635f8a313474c1$var$__importStar((parcelRequire("c4dVW")));

module.exports.ComAtprotoTempCheckSignupQueue = $1d635f8a313474c1$var$__importStar((parcelRequire("4aO2h")));

module.exports.ComAtprotoTempFetchLabels = $1d635f8a313474c1$var$__importStar((parcelRequire("7THHV")));

module.exports.ComAtprotoTempRequestPhoneVerification = $1d635f8a313474c1$var$__importStar((parcelRequire("lMEvy")));

module.exports.AppBskyActorDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("7qr1j")));

module.exports.AppBskyActorGetPreferences = $1d635f8a313474c1$var$__importStar((parcelRequire("ektCj")));

module.exports.AppBskyActorGetProfile = $1d635f8a313474c1$var$__importStar((parcelRequire("UWOoV")));

module.exports.AppBskyActorGetProfiles = $1d635f8a313474c1$var$__importStar((parcelRequire("1boL8")));

module.exports.AppBskyActorGetSuggestions = $1d635f8a313474c1$var$__importStar((parcelRequire("97RFR")));

module.exports.AppBskyActorProfile = $1d635f8a313474c1$var$__importStar((parcelRequire("gAULq")));

module.exports.AppBskyActorPutPreferences = $1d635f8a313474c1$var$__importStar((parcelRequire("aKnw9")));

module.exports.AppBskyActorSearchActors = $1d635f8a313474c1$var$__importStar((parcelRequire("8m1EY")));

module.exports.AppBskyActorSearchActorsTypeahead = $1d635f8a313474c1$var$__importStar((parcelRequire("jcqCU")));

module.exports.AppBskyEmbedDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("iZwOD")));

module.exports.AppBskyEmbedExternal = $1d635f8a313474c1$var$__importStar((parcelRequire("54gTd")));

module.exports.AppBskyEmbedImages = $1d635f8a313474c1$var$__importStar((parcelRequire("bpQxT")));

module.exports.AppBskyEmbedRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("lrQrc")));

module.exports.AppBskyEmbedRecordWithMedia = $1d635f8a313474c1$var$__importStar((parcelRequire("8BD8i")));

module.exports.AppBskyEmbedVideo = $1d635f8a313474c1$var$__importStar((parcelRequire("lY3vM")));

module.exports.AppBskyFeedDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("86MaN")));

module.exports.AppBskyFeedDescribeFeedGenerator = $1d635f8a313474c1$var$__importStar((parcelRequire("d3V3p")));

module.exports.AppBskyFeedGenerator = $1d635f8a313474c1$var$__importStar((parcelRequire("eHGxp")));

module.exports.AppBskyFeedGetActorFeeds = $1d635f8a313474c1$var$__importStar((parcelRequire("7yYE0")));

module.exports.AppBskyFeedGetActorLikes = $1d635f8a313474c1$var$__importStar((parcelRequire("6XZma")));

module.exports.AppBskyFeedGetAuthorFeed = $1d635f8a313474c1$var$__importStar((parcelRequire("1p5kI")));

module.exports.AppBskyFeedGetFeed = $1d635f8a313474c1$var$__importStar((parcelRequire("7lME1")));

module.exports.AppBskyFeedGetFeedGenerator = $1d635f8a313474c1$var$__importStar((parcelRequire("9MX52")));

module.exports.AppBskyFeedGetFeedGenerators = $1d635f8a313474c1$var$__importStar((parcelRequire("bDW3n")));

module.exports.AppBskyFeedGetFeedSkeleton = $1d635f8a313474c1$var$__importStar((parcelRequire("8HHJY")));

module.exports.AppBskyFeedGetLikes = $1d635f8a313474c1$var$__importStar((parcelRequire("kuzGC")));

module.exports.AppBskyFeedGetListFeed = $1d635f8a313474c1$var$__importStar((parcelRequire("ba9K6")));

module.exports.AppBskyFeedGetPostThread = $1d635f8a313474c1$var$__importStar((parcelRequire("ddyeE")));

module.exports.AppBskyFeedGetPosts = $1d635f8a313474c1$var$__importStar((parcelRequire("2qkY7")));

module.exports.AppBskyFeedGetQuotes = $1d635f8a313474c1$var$__importStar((parcelRequire("h1AAc")));

module.exports.AppBskyFeedGetRepostedBy = $1d635f8a313474c1$var$__importStar((parcelRequire("lR19r")));

module.exports.AppBskyFeedGetSuggestedFeeds = $1d635f8a313474c1$var$__importStar((parcelRequire("2yXex")));

module.exports.AppBskyFeedGetTimeline = $1d635f8a313474c1$var$__importStar((parcelRequire("49vCN")));

module.exports.AppBskyFeedLike = $1d635f8a313474c1$var$__importStar((parcelRequire("emCFC")));

module.exports.AppBskyFeedPost = $1d635f8a313474c1$var$__importStar((parcelRequire("dA4VG")));

module.exports.AppBskyFeedPostgate = $1d635f8a313474c1$var$__importStar((parcelRequire("lqVrJ")));

module.exports.AppBskyFeedRepost = $1d635f8a313474c1$var$__importStar((parcelRequire("aodyA")));

module.exports.AppBskyFeedSearchPosts = $1d635f8a313474c1$var$__importStar((parcelRequire("3m5z2")));

module.exports.AppBskyFeedSendInteractions = $1d635f8a313474c1$var$__importStar((parcelRequire("9FIoQ")));

module.exports.AppBskyFeedThreadgate = $1d635f8a313474c1$var$__importStar((parcelRequire("kJnJc")));

module.exports.AppBskyGraphBlock = $1d635f8a313474c1$var$__importStar((parcelRequire("ktNzM")));

module.exports.AppBskyGraphDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("9PmXs")));

module.exports.AppBskyGraphFollow = $1d635f8a313474c1$var$__importStar((parcelRequire("3vuZu")));

module.exports.AppBskyGraphGetActorStarterPacks = $1d635f8a313474c1$var$__importStar((parcelRequire("heCVf")));

module.exports.AppBskyGraphGetBlocks = $1d635f8a313474c1$var$__importStar((parcelRequire("8LdYU")));

module.exports.AppBskyGraphGetFollowers = $1d635f8a313474c1$var$__importStar((parcelRequire("7ifqL")));

module.exports.AppBskyGraphGetFollows = $1d635f8a313474c1$var$__importStar((parcelRequire("g7fnS")));

module.exports.AppBskyGraphGetKnownFollowers = $1d635f8a313474c1$var$__importStar((parcelRequire("PV2s8")));

module.exports.AppBskyGraphGetList = $1d635f8a313474c1$var$__importStar((parcelRequire("iGYFw")));

module.exports.AppBskyGraphGetListBlocks = $1d635f8a313474c1$var$__importStar((parcelRequire("kV7NH")));

module.exports.AppBskyGraphGetListMutes = $1d635f8a313474c1$var$__importStar((parcelRequire("32K4y")));

module.exports.AppBskyGraphGetLists = $1d635f8a313474c1$var$__importStar((parcelRequire("j5fp9")));

module.exports.AppBskyGraphGetMutes = $1d635f8a313474c1$var$__importStar((parcelRequire("bW3hd")));

module.exports.AppBskyGraphGetRelationships = $1d635f8a313474c1$var$__importStar((parcelRequire("3M4Rp")));

module.exports.AppBskyGraphGetStarterPack = $1d635f8a313474c1$var$__importStar((parcelRequire("3bkJ9")));

module.exports.AppBskyGraphGetStarterPacks = $1d635f8a313474c1$var$__importStar((parcelRequire("kgpaj")));

module.exports.AppBskyGraphGetSuggestedFollowsByActor = $1d635f8a313474c1$var$__importStar((parcelRequire("6ZI9T")));

module.exports.AppBskyGraphList = $1d635f8a313474c1$var$__importStar((parcelRequire("jbrBl")));

module.exports.AppBskyGraphListblock = $1d635f8a313474c1$var$__importStar((parcelRequire("eSEbx")));

module.exports.AppBskyGraphListitem = $1d635f8a313474c1$var$__importStar((parcelRequire("dbR2M")));

module.exports.AppBskyGraphMuteActor = $1d635f8a313474c1$var$__importStar((parcelRequire("7E8cO")));

module.exports.AppBskyGraphMuteActorList = $1d635f8a313474c1$var$__importStar((parcelRequire("11wXa")));

module.exports.AppBskyGraphMuteThread = $1d635f8a313474c1$var$__importStar((parcelRequire("lyqld")));

module.exports.AppBskyGraphSearchStarterPacks = $1d635f8a313474c1$var$__importStar((parcelRequire("cD0Si")));

module.exports.AppBskyGraphStarterpack = $1d635f8a313474c1$var$__importStar((parcelRequire("kICrf")));

module.exports.AppBskyGraphUnmuteActor = $1d635f8a313474c1$var$__importStar((parcelRequire("d5Ezz")));

module.exports.AppBskyGraphUnmuteActorList = $1d635f8a313474c1$var$__importStar((parcelRequire("3XytH")));

module.exports.AppBskyGraphUnmuteThread = $1d635f8a313474c1$var$__importStar((parcelRequire("7XzMt")));

module.exports.AppBskyLabelerDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("gaL4b")));

module.exports.AppBskyLabelerGetServices = $1d635f8a313474c1$var$__importStar((parcelRequire("do49g")));

module.exports.AppBskyLabelerService = $1d635f8a313474c1$var$__importStar((parcelRequire("kTb8K")));

module.exports.AppBskyNotificationGetUnreadCount = $1d635f8a313474c1$var$__importStar((parcelRequire("crsz1")));

module.exports.AppBskyNotificationListNotifications = $1d635f8a313474c1$var$__importStar((parcelRequire("a1dNC")));

module.exports.AppBskyNotificationPutPreferences = $1d635f8a313474c1$var$__importStar((parcelRequire("k5Cxj")));

module.exports.AppBskyNotificationRegisterPush = $1d635f8a313474c1$var$__importStar((parcelRequire("7Qgmk")));

module.exports.AppBskyNotificationUpdateSeen = $1d635f8a313474c1$var$__importStar((parcelRequire("lVw97")));

module.exports.AppBskyRichtextFacet = $1d635f8a313474c1$var$__importStar((parcelRequire("9A9dd")));

module.exports.AppBskyUnspeccedDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("eYq3K")));

module.exports.AppBskyUnspeccedGetConfig = $1d635f8a313474c1$var$__importStar((parcelRequire("9pS3C")));

module.exports.AppBskyUnspeccedGetPopularFeedGenerators = $1d635f8a313474c1$var$__importStar((parcelRequire("iipCK")));

module.exports.AppBskyUnspeccedGetSuggestionsSkeleton = $1d635f8a313474c1$var$__importStar((parcelRequire("8rKha")));

module.exports.AppBskyUnspeccedGetTaggedSuggestions = $1d635f8a313474c1$var$__importStar((parcelRequire("akzbJ")));

module.exports.AppBskyUnspeccedGetTrendingTopics = $1d635f8a313474c1$var$__importStar((parcelRequire("lBc7d")));

module.exports.AppBskyUnspeccedSearchActorsSkeleton = $1d635f8a313474c1$var$__importStar((parcelRequire("a0RJn")));

module.exports.AppBskyUnspeccedSearchPostsSkeleton = $1d635f8a313474c1$var$__importStar((parcelRequire("6OWOv")));

module.exports.AppBskyUnspeccedSearchStarterPacksSkeleton = $1d635f8a313474c1$var$__importStar((parcelRequire("bpJIG")));

module.exports.AppBskyVideoDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("elLFy")));

module.exports.AppBskyVideoGetJobStatus = $1d635f8a313474c1$var$__importStar((parcelRequire("c1XWu")));

module.exports.AppBskyVideoGetUploadLimits = $1d635f8a313474c1$var$__importStar((parcelRequire("lqvW5")));

module.exports.AppBskyVideoUploadVideo = $1d635f8a313474c1$var$__importStar((parcelRequire("732VG")));

module.exports.ChatBskyActorDeclaration = $1d635f8a313474c1$var$__importStar((parcelRequire("6RG6O")));

module.exports.ChatBskyActorDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("eCoUx")));

module.exports.ChatBskyActorDeleteAccount = $1d635f8a313474c1$var$__importStar((parcelRequire("cVrl3")));

module.exports.ChatBskyActorExportAccountData = $1d635f8a313474c1$var$__importStar((parcelRequire("fR30F")));

module.exports.ChatBskyConvoDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("ctaCe")));

module.exports.ChatBskyConvoDeleteMessageForSelf = $1d635f8a313474c1$var$__importStar((parcelRequire("f4THE")));

module.exports.ChatBskyConvoGetConvo = $1d635f8a313474c1$var$__importStar((parcelRequire("4CcW5")));

module.exports.ChatBskyConvoGetConvoForMembers = $1d635f8a313474c1$var$__importStar((parcelRequire("fBFuC")));

module.exports.ChatBskyConvoGetLog = $1d635f8a313474c1$var$__importStar((parcelRequire("k7g8q")));

module.exports.ChatBskyConvoGetMessages = $1d635f8a313474c1$var$__importStar((parcelRequire("4S3xN")));

module.exports.ChatBskyConvoLeaveConvo = $1d635f8a313474c1$var$__importStar((parcelRequire("2kE4B")));

module.exports.ChatBskyConvoListConvos = $1d635f8a313474c1$var$__importStar((parcelRequire("7vC3G")));

module.exports.ChatBskyConvoMuteConvo = $1d635f8a313474c1$var$__importStar((parcelRequire("ezKoq")));

module.exports.ChatBskyConvoSendMessage = $1d635f8a313474c1$var$__importStar((parcelRequire("bRCER")));

module.exports.ChatBskyConvoSendMessageBatch = $1d635f8a313474c1$var$__importStar((parcelRequire("f6UnX")));

module.exports.ChatBskyConvoUnmuteConvo = $1d635f8a313474c1$var$__importStar((parcelRequire("5iDv7")));

module.exports.ChatBskyConvoUpdateRead = $1d635f8a313474c1$var$__importStar((parcelRequire("kRS5s")));

module.exports.ChatBskyModerationGetActorMetadata = $1d635f8a313474c1$var$__importStar((parcelRequire("bISqi")));

module.exports.ChatBskyModerationGetMessageContext = $1d635f8a313474c1$var$__importStar((parcelRequire("9ef2S")));

module.exports.ChatBskyModerationUpdateActorAccess = $1d635f8a313474c1$var$__importStar((parcelRequire("8RhM1")));

module.exports.ToolsOzoneCommunicationCreateTemplate = $1d635f8a313474c1$var$__importStar((parcelRequire("9tmUj")));

module.exports.ToolsOzoneCommunicationDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("bzcjd")));

module.exports.ToolsOzoneCommunicationDeleteTemplate = $1d635f8a313474c1$var$__importStar((parcelRequire("jsnJH")));

module.exports.ToolsOzoneCommunicationListTemplates = $1d635f8a313474c1$var$__importStar((parcelRequire("5uR93")));

module.exports.ToolsOzoneCommunicationUpdateTemplate = $1d635f8a313474c1$var$__importStar((parcelRequire("3Vj9j")));

module.exports.ToolsOzoneModerationDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("2h9B2")));

module.exports.ToolsOzoneModerationEmitEvent = $1d635f8a313474c1$var$__importStar((parcelRequire("aDbWo")));

module.exports.ToolsOzoneModerationGetEvent = $1d635f8a313474c1$var$__importStar((parcelRequire("7wDkl")));

module.exports.ToolsOzoneModerationGetRecord = $1d635f8a313474c1$var$__importStar((parcelRequire("6zLJN")));

module.exports.ToolsOzoneModerationGetRecords = $1d635f8a313474c1$var$__importStar((parcelRequire("8GtpL")));

module.exports.ToolsOzoneModerationGetRepo = $1d635f8a313474c1$var$__importStar((parcelRequire("eewch")));

module.exports.ToolsOzoneModerationGetRepos = $1d635f8a313474c1$var$__importStar((parcelRequire("ODUzg")));

module.exports.ToolsOzoneModerationQueryEvents = $1d635f8a313474c1$var$__importStar((parcelRequire("dCYQy")));

module.exports.ToolsOzoneModerationQueryStatuses = $1d635f8a313474c1$var$__importStar((parcelRequire("5xWBm")));

module.exports.ToolsOzoneModerationSearchRepos = $1d635f8a313474c1$var$__importStar((parcelRequire("68WWJ")));

module.exports.ToolsOzoneServerGetConfig = $1d635f8a313474c1$var$__importStar((parcelRequire("bKN2D")));

module.exports.ToolsOzoneSetAddValues = $1d635f8a313474c1$var$__importStar((parcelRequire("eSuDp")));

module.exports.ToolsOzoneSetDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("VTs5u")));

module.exports.ToolsOzoneSetDeleteSet = $1d635f8a313474c1$var$__importStar((parcelRequire("fXzWp")));

module.exports.ToolsOzoneSetDeleteValues = $1d635f8a313474c1$var$__importStar((parcelRequire("eduZ3")));

module.exports.ToolsOzoneSetGetValues = $1d635f8a313474c1$var$__importStar((parcelRequire("iuEPv")));

module.exports.ToolsOzoneSetQuerySets = $1d635f8a313474c1$var$__importStar((parcelRequire("gtYSF")));

module.exports.ToolsOzoneSetUpsertSet = $1d635f8a313474c1$var$__importStar((parcelRequire("k0lX7")));

module.exports.ToolsOzoneSettingDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("3KwiU")));

module.exports.ToolsOzoneSettingListOptions = $1d635f8a313474c1$var$__importStar((parcelRequire("ijAql")));

module.exports.ToolsOzoneSettingRemoveOptions = $1d635f8a313474c1$var$__importStar((parcelRequire("1cOPh")));

module.exports.ToolsOzoneSettingUpsertOption = $1d635f8a313474c1$var$__importStar((parcelRequire("2dvK0")));

module.exports.ToolsOzoneSignatureDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("aJiE8")));

module.exports.ToolsOzoneSignatureFindCorrelation = $1d635f8a313474c1$var$__importStar((parcelRequire("lq560")));

module.exports.ToolsOzoneSignatureFindRelatedAccounts = $1d635f8a313474c1$var$__importStar((parcelRequire("fELNV")));

module.exports.ToolsOzoneSignatureSearchAccounts = $1d635f8a313474c1$var$__importStar((parcelRequire("hn4vV")));

module.exports.ToolsOzoneTeamAddMember = $1d635f8a313474c1$var$__importStar((parcelRequire("8IiFc")));

module.exports.ToolsOzoneTeamDefs = $1d635f8a313474c1$var$__importStar((parcelRequire("deow2")));

module.exports.ToolsOzoneTeamDeleteMember = $1d635f8a313474c1$var$__importStar((parcelRequire("9X16d")));

module.exports.ToolsOzoneTeamListMembers = $1d635f8a313474c1$var$__importStar((parcelRequire("2N6AW")));

module.exports.ToolsOzoneTeamUpdateMember = $1d635f8a313474c1$var$__importStar((parcelRequire("1o4e8")));
module.exports.COM_ATPROTO_MODERATION = {
    DefsReasonSpam: 'com.atproto.moderation.defs#reasonSpam',
    DefsReasonViolation: 'com.atproto.moderation.defs#reasonViolation',
    DefsReasonMisleading: 'com.atproto.moderation.defs#reasonMisleading',
    DefsReasonSexual: 'com.atproto.moderation.defs#reasonSexual',
    DefsReasonRude: 'com.atproto.moderation.defs#reasonRude',
    DefsReasonOther: 'com.atproto.moderation.defs#reasonOther',
    DefsReasonAppeal: 'com.atproto.moderation.defs#reasonAppeal'
};
module.exports.APP_BSKY_FEED = {
    DefsRequestLess: 'app.bsky.feed.defs#requestLess',
    DefsRequestMore: 'app.bsky.feed.defs#requestMore',
    DefsClickthroughItem: 'app.bsky.feed.defs#clickthroughItem',
    DefsClickthroughAuthor: 'app.bsky.feed.defs#clickthroughAuthor',
    DefsClickthroughReposter: 'app.bsky.feed.defs#clickthroughReposter',
    DefsClickthroughEmbed: 'app.bsky.feed.defs#clickthroughEmbed',
    DefsContentModeUnspecified: 'app.bsky.feed.defs#contentModeUnspecified',
    DefsContentModeVideo: 'app.bsky.feed.defs#contentModeVideo',
    DefsInteractionSeen: 'app.bsky.feed.defs#interactionSeen',
    DefsInteractionLike: 'app.bsky.feed.defs#interactionLike',
    DefsInteractionRepost: 'app.bsky.feed.defs#interactionRepost',
    DefsInteractionReply: 'app.bsky.feed.defs#interactionReply',
    DefsInteractionQuote: 'app.bsky.feed.defs#interactionQuote',
    DefsInteractionShare: 'app.bsky.feed.defs#interactionShare'
};
module.exports.APP_BSKY_GRAPH = {
    DefsModlist: 'app.bsky.graph.defs#modlist',
    DefsCuratelist: 'app.bsky.graph.defs#curatelist',
    DefsReferencelist: 'app.bsky.graph.defs#referencelist'
};
module.exports.TOOLS_OZONE_MODERATION = {
    DefsReviewOpen: 'tools.ozone.moderation.defs#reviewOpen',
    DefsReviewEscalated: 'tools.ozone.moderation.defs#reviewEscalated',
    DefsReviewClosed: 'tools.ozone.moderation.defs#reviewClosed',
    DefsReviewNone: 'tools.ozone.moderation.defs#reviewNone'
};
module.exports.TOOLS_OZONE_TEAM = {
    DefsRoleAdmin: 'tools.ozone.team.defs#roleAdmin',
    DefsRoleModerator: 'tools.ozone.team.defs#roleModerator',
    DefsRoleTriage: 'tools.ozone.team.defs#roleTriage'
};
class $1d635f8a313474c1$var$AtpBaseClient extends $al5Ta.XrpcClient {
    constructor(options){
        super(options, $8DB7o.schemas);
        Object.defineProperty(this, "com", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tools", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.com = new $1d635f8a313474c1$var$ComNS(this);
        this.app = new $1d635f8a313474c1$var$AppNS(this);
        this.chat = new $1d635f8a313474c1$var$ChatNS(this);
        this.tools = new $1d635f8a313474c1$var$ToolsNS(this);
    }
    /** @deprecated use `this` instead */ get xrpc() {
        return this;
    }
}
module.exports.AtpBaseClient = $1d635f8a313474c1$var$AtpBaseClient;
class $1d635f8a313474c1$var$ComNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "atproto", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.atproto = new $1d635f8a313474c1$var$ComAtprotoNS(client);
    }
}
module.exports.ComNS = $1d635f8a313474c1$var$ComNS;
class $1d635f8a313474c1$var$ComAtprotoNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "admin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "identity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "label", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lexicon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "moderation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "repo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "server", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sync", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "temp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.admin = new $1d635f8a313474c1$var$ComAtprotoAdminNS(client);
        this.identity = new $1d635f8a313474c1$var$ComAtprotoIdentityNS(client);
        this.label = new $1d635f8a313474c1$var$ComAtprotoLabelNS(client);
        this.lexicon = new $1d635f8a313474c1$var$ComAtprotoLexiconNS(client);
        this.moderation = new $1d635f8a313474c1$var$ComAtprotoModerationNS(client);
        this.repo = new $1d635f8a313474c1$var$ComAtprotoRepoNS(client);
        this.server = new $1d635f8a313474c1$var$ComAtprotoServerNS(client);
        this.sync = new $1d635f8a313474c1$var$ComAtprotoSyncNS(client);
        this.temp = new $1d635f8a313474c1$var$ComAtprotoTempNS(client);
    }
}
module.exports.ComAtprotoNS = $1d635f8a313474c1$var$ComAtprotoNS;
class $1d635f8a313474c1$var$ComAtprotoAdminNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    deleteAccount(data, opts) {
        return this._client.call('com.atproto.admin.deleteAccount', opts?.qp, data, opts);
    }
    disableAccountInvites(data, opts) {
        return this._client.call('com.atproto.admin.disableAccountInvites', opts?.qp, data, opts);
    }
    disableInviteCodes(data, opts) {
        return this._client.call('com.atproto.admin.disableInviteCodes', opts?.qp, data, opts);
    }
    enableAccountInvites(data, opts) {
        return this._client.call('com.atproto.admin.enableAccountInvites', opts?.qp, data, opts);
    }
    getAccountInfo(params, opts) {
        return this._client.call('com.atproto.admin.getAccountInfo', params, undefined, opts);
    }
    getAccountInfos(params, opts) {
        return this._client.call('com.atproto.admin.getAccountInfos', params, undefined, opts);
    }
    getInviteCodes(params, opts) {
        return this._client.call('com.atproto.admin.getInviteCodes', params, undefined, opts);
    }
    getSubjectStatus(params, opts) {
        return this._client.call('com.atproto.admin.getSubjectStatus', params, undefined, opts);
    }
    searchAccounts(params, opts) {
        return this._client.call('com.atproto.admin.searchAccounts', params, undefined, opts);
    }
    sendEmail(data, opts) {
        return this._client.call('com.atproto.admin.sendEmail', opts?.qp, data, opts);
    }
    updateAccountEmail(data, opts) {
        return this._client.call('com.atproto.admin.updateAccountEmail', opts?.qp, data, opts);
    }
    updateAccountHandle(data, opts) {
        return this._client.call('com.atproto.admin.updateAccountHandle', opts?.qp, data, opts);
    }
    updateAccountPassword(data, opts) {
        return this._client.call('com.atproto.admin.updateAccountPassword', opts?.qp, data, opts);
    }
    updateSubjectStatus(data, opts) {
        return this._client.call('com.atproto.admin.updateSubjectStatus', opts?.qp, data, opts);
    }
}
module.exports.ComAtprotoAdminNS = $1d635f8a313474c1$var$ComAtprotoAdminNS;
class $1d635f8a313474c1$var$ComAtprotoIdentityNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getRecommendedDidCredentials(params, opts) {
        return this._client.call('com.atproto.identity.getRecommendedDidCredentials', params, undefined, opts);
    }
    requestPlcOperationSignature(data, opts) {
        return this._client.call('com.atproto.identity.requestPlcOperationSignature', opts?.qp, data, opts);
    }
    resolveHandle(params, opts) {
        return this._client.call('com.atproto.identity.resolveHandle', params, undefined, opts);
    }
    signPlcOperation(data, opts) {
        return this._client.call('com.atproto.identity.signPlcOperation', opts?.qp, data, opts);
    }
    submitPlcOperation(data, opts) {
        return this._client.call('com.atproto.identity.submitPlcOperation', opts?.qp, data, opts);
    }
    updateHandle(data, opts) {
        return this._client.call('com.atproto.identity.updateHandle', opts?.qp, data, opts);
    }
}
module.exports.ComAtprotoIdentityNS = $1d635f8a313474c1$var$ComAtprotoIdentityNS;
class $1d635f8a313474c1$var$ComAtprotoLabelNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    queryLabels(params, opts) {
        return this._client.call('com.atproto.label.queryLabels', params, undefined, opts);
    }
}
module.exports.ComAtprotoLabelNS = $1d635f8a313474c1$var$ComAtprotoLabelNS;
class $1d635f8a313474c1$var$ComAtprotoLexiconNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.schema = new $1d635f8a313474c1$var$SchemaRecord(client);
    }
}
module.exports.ComAtprotoLexiconNS = $1d635f8a313474c1$var$ComAtprotoLexiconNS;
class $1d635f8a313474c1$var$SchemaRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'com.atproto.lexicon.schema',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'com.atproto.lexicon.schema',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'com.atproto.lexicon.schema';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'com.atproto.lexicon.schema',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'com.atproto.lexicon.schema',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.SchemaRecord = $1d635f8a313474c1$var$SchemaRecord;
class $1d635f8a313474c1$var$ComAtprotoModerationNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    createReport(data, opts) {
        return this._client.call('com.atproto.moderation.createReport', opts?.qp, data, opts);
    }
}
module.exports.ComAtprotoModerationNS = $1d635f8a313474c1$var$ComAtprotoModerationNS;
class $1d635f8a313474c1$var$ComAtprotoRepoNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    applyWrites(data, opts) {
        return this._client.call('com.atproto.repo.applyWrites', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoRepoApplyWrites.toKnownErr(e);
        });
    }
    createRecord(data, opts) {
        return this._client.call('com.atproto.repo.createRecord', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoRepoCreateRecord.toKnownErr(e);
        });
    }
    deleteRecord(data, opts) {
        return this._client.call('com.atproto.repo.deleteRecord', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoRepoDeleteRecord.toKnownErr(e);
        });
    }
    describeRepo(params, opts) {
        return this._client.call('com.atproto.repo.describeRepo', params, undefined, opts);
    }
    getRecord(params, opts) {
        return this._client.call('com.atproto.repo.getRecord', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoRepoGetRecord.toKnownErr(e);
        });
    }
    importRepo(data, opts) {
        return this._client.call('com.atproto.repo.importRepo', opts?.qp, data, opts);
    }
    listMissingBlobs(params, opts) {
        return this._client.call('com.atproto.repo.listMissingBlobs', params, undefined, opts);
    }
    listRecords(params, opts) {
        return this._client.call('com.atproto.repo.listRecords', params, undefined, opts);
    }
    putRecord(data, opts) {
        return this._client.call('com.atproto.repo.putRecord', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoRepoPutRecord.toKnownErr(e);
        });
    }
    uploadBlob(data, opts) {
        return this._client.call('com.atproto.repo.uploadBlob', opts?.qp, data, opts);
    }
}
module.exports.ComAtprotoRepoNS = $1d635f8a313474c1$var$ComAtprotoRepoNS;
class $1d635f8a313474c1$var$ComAtprotoServerNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    activateAccount(data, opts) {
        return this._client.call('com.atproto.server.activateAccount', opts?.qp, data, opts);
    }
    checkAccountStatus(params, opts) {
        return this._client.call('com.atproto.server.checkAccountStatus', params, undefined, opts);
    }
    confirmEmail(data, opts) {
        return this._client.call('com.atproto.server.confirmEmail', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoServerConfirmEmail.toKnownErr(e);
        });
    }
    createAccount(data, opts) {
        return this._client.call('com.atproto.server.createAccount', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoServerCreateAccount.toKnownErr(e);
        });
    }
    createAppPassword(data, opts) {
        return this._client.call('com.atproto.server.createAppPassword', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoServerCreateAppPassword.toKnownErr(e);
        });
    }
    createInviteCode(data, opts) {
        return this._client.call('com.atproto.server.createInviteCode', opts?.qp, data, opts);
    }
    createInviteCodes(data, opts) {
        return this._client.call('com.atproto.server.createInviteCodes', opts?.qp, data, opts);
    }
    createSession(data, opts) {
        return this._client.call('com.atproto.server.createSession', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoServerCreateSession.toKnownErr(e);
        });
    }
    deactivateAccount(data, opts) {
        return this._client.call('com.atproto.server.deactivateAccount', opts?.qp, data, opts);
    }
    deleteAccount(data, opts) {
        return this._client.call('com.atproto.server.deleteAccount', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoServerDeleteAccount.toKnownErr(e);
        });
    }
    deleteSession(data, opts) {
        return this._client.call('com.atproto.server.deleteSession', opts?.qp, data, opts);
    }
    describeServer(params, opts) {
        return this._client.call('com.atproto.server.describeServer', params, undefined, opts);
    }
    getAccountInviteCodes(params, opts) {
        return this._client.call('com.atproto.server.getAccountInviteCodes', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoServerGetAccountInviteCodes.toKnownErr(e);
        });
    }
    getServiceAuth(params, opts) {
        return this._client.call('com.atproto.server.getServiceAuth', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoServerGetServiceAuth.toKnownErr(e);
        });
    }
    getSession(params, opts) {
        return this._client.call('com.atproto.server.getSession', params, undefined, opts);
    }
    listAppPasswords(params, opts) {
        return this._client.call('com.atproto.server.listAppPasswords', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoServerListAppPasswords.toKnownErr(e);
        });
    }
    refreshSession(data, opts) {
        return this._client.call('com.atproto.server.refreshSession', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoServerRefreshSession.toKnownErr(e);
        });
    }
    requestAccountDelete(data, opts) {
        return this._client.call('com.atproto.server.requestAccountDelete', opts?.qp, data, opts);
    }
    requestEmailConfirmation(data, opts) {
        return this._client.call('com.atproto.server.requestEmailConfirmation', opts?.qp, data, opts);
    }
    requestEmailUpdate(data, opts) {
        return this._client.call('com.atproto.server.requestEmailUpdate', opts?.qp, data, opts);
    }
    requestPasswordReset(data, opts) {
        return this._client.call('com.atproto.server.requestPasswordReset', opts?.qp, data, opts);
    }
    reserveSigningKey(data, opts) {
        return this._client.call('com.atproto.server.reserveSigningKey', opts?.qp, data, opts);
    }
    resetPassword(data, opts) {
        return this._client.call('com.atproto.server.resetPassword', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoServerResetPassword.toKnownErr(e);
        });
    }
    revokeAppPassword(data, opts) {
        return this._client.call('com.atproto.server.revokeAppPassword', opts?.qp, data, opts);
    }
    updateEmail(data, opts) {
        return this._client.call('com.atproto.server.updateEmail', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoServerUpdateEmail.toKnownErr(e);
        });
    }
}
module.exports.ComAtprotoServerNS = $1d635f8a313474c1$var$ComAtprotoServerNS;
class $1d635f8a313474c1$var$ComAtprotoSyncNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getBlob(params, opts) {
        return this._client.call('com.atproto.sync.getBlob', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoSyncGetBlob.toKnownErr(e);
        });
    }
    getBlocks(params, opts) {
        return this._client.call('com.atproto.sync.getBlocks', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoSyncGetBlocks.toKnownErr(e);
        });
    }
    getCheckout(params, opts) {
        return this._client.call('com.atproto.sync.getCheckout', params, undefined, opts);
    }
    getHead(params, opts) {
        return this._client.call('com.atproto.sync.getHead', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoSyncGetHead.toKnownErr(e);
        });
    }
    getLatestCommit(params, opts) {
        return this._client.call('com.atproto.sync.getLatestCommit', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoSyncGetLatestCommit.toKnownErr(e);
        });
    }
    getRecord(params, opts) {
        return this._client.call('com.atproto.sync.getRecord', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoSyncGetRecord.toKnownErr(e);
        });
    }
    getRepo(params, opts) {
        return this._client.call('com.atproto.sync.getRepo', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoSyncGetRepo.toKnownErr(e);
        });
    }
    getRepoStatus(params, opts) {
        return this._client.call('com.atproto.sync.getRepoStatus', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoSyncGetRepoStatus.toKnownErr(e);
        });
    }
    listBlobs(params, opts) {
        return this._client.call('com.atproto.sync.listBlobs', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ComAtprotoSyncListBlobs.toKnownErr(e);
        });
    }
    listRepos(params, opts) {
        return this._client.call('com.atproto.sync.listRepos', params, undefined, opts);
    }
    notifyOfUpdate(data, opts) {
        return this._client.call('com.atproto.sync.notifyOfUpdate', opts?.qp, data, opts);
    }
    requestCrawl(data, opts) {
        return this._client.call('com.atproto.sync.requestCrawl', opts?.qp, data, opts);
    }
}
module.exports.ComAtprotoSyncNS = $1d635f8a313474c1$var$ComAtprotoSyncNS;
class $1d635f8a313474c1$var$ComAtprotoTempNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    addReservedHandle(data, opts) {
        return this._client.call('com.atproto.temp.addReservedHandle', opts?.qp, data, opts);
    }
    checkSignupQueue(params, opts) {
        return this._client.call('com.atproto.temp.checkSignupQueue', params, undefined, opts);
    }
    fetchLabels(params, opts) {
        return this._client.call('com.atproto.temp.fetchLabels', params, undefined, opts);
    }
    requestPhoneVerification(data, opts) {
        return this._client.call('com.atproto.temp.requestPhoneVerification', opts?.qp, data, opts);
    }
}
module.exports.ComAtprotoTempNS = $1d635f8a313474c1$var$ComAtprotoTempNS;
class $1d635f8a313474c1$var$AppNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bsky", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.bsky = new $1d635f8a313474c1$var$AppBskyNS(client);
    }
}
module.exports.AppNS = $1d635f8a313474c1$var$AppNS;
class $1d635f8a313474c1$var$AppBskyNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "actor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "embed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "feed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "graph", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "labeler", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notification", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "richtext", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unspecced", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "video", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.actor = new $1d635f8a313474c1$var$AppBskyActorNS(client);
        this.embed = new $1d635f8a313474c1$var$AppBskyEmbedNS(client);
        this.feed = new $1d635f8a313474c1$var$AppBskyFeedNS(client);
        this.graph = new $1d635f8a313474c1$var$AppBskyGraphNS(client);
        this.labeler = new $1d635f8a313474c1$var$AppBskyLabelerNS(client);
        this.notification = new $1d635f8a313474c1$var$AppBskyNotificationNS(client);
        this.richtext = new $1d635f8a313474c1$var$AppBskyRichtextNS(client);
        this.unspecced = new $1d635f8a313474c1$var$AppBskyUnspeccedNS(client);
        this.video = new $1d635f8a313474c1$var$AppBskyVideoNS(client);
    }
}
module.exports.AppBskyNS = $1d635f8a313474c1$var$AppBskyNS;
class $1d635f8a313474c1$var$AppBskyActorNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "profile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.profile = new $1d635f8a313474c1$var$ProfileRecord(client);
    }
    getPreferences(params, opts) {
        return this._client.call('app.bsky.actor.getPreferences', params, undefined, opts);
    }
    getProfile(params, opts) {
        return this._client.call('app.bsky.actor.getProfile', params, undefined, opts);
    }
    getProfiles(params, opts) {
        return this._client.call('app.bsky.actor.getProfiles', params, undefined, opts);
    }
    getSuggestions(params, opts) {
        return this._client.call('app.bsky.actor.getSuggestions', params, undefined, opts);
    }
    putPreferences(data, opts) {
        return this._client.call('app.bsky.actor.putPreferences', opts?.qp, data, opts);
    }
    searchActors(params, opts) {
        return this._client.call('app.bsky.actor.searchActors', params, undefined, opts);
    }
    searchActorsTypeahead(params, opts) {
        return this._client.call('app.bsky.actor.searchActorsTypeahead', params, undefined, opts);
    }
}
module.exports.AppBskyActorNS = $1d635f8a313474c1$var$AppBskyActorNS;
class $1d635f8a313474c1$var$ProfileRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.actor.profile',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.actor.profile',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.actor.profile';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.actor.profile',
            rkey: 'self',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.actor.profile',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.ProfileRecord = $1d635f8a313474c1$var$ProfileRecord;
class $1d635f8a313474c1$var$AppBskyEmbedNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
}
module.exports.AppBskyEmbedNS = $1d635f8a313474c1$var$AppBskyEmbedNS;
class $1d635f8a313474c1$var$AppBskyFeedNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "generator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "like", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "post", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "postgate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "repost", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "threadgate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.generator = new $1d635f8a313474c1$var$GeneratorRecord(client);
        this.like = new $1d635f8a313474c1$var$LikeRecord(client);
        this.post = new $1d635f8a313474c1$var$PostRecord(client);
        this.postgate = new $1d635f8a313474c1$var$PostgateRecord(client);
        this.repost = new $1d635f8a313474c1$var$RepostRecord(client);
        this.threadgate = new $1d635f8a313474c1$var$ThreadgateRecord(client);
    }
    describeFeedGenerator(params, opts) {
        return this._client.call('app.bsky.feed.describeFeedGenerator', params, undefined, opts);
    }
    getActorFeeds(params, opts) {
        return this._client.call('app.bsky.feed.getActorFeeds', params, undefined, opts);
    }
    getActorLikes(params, opts) {
        return this._client.call('app.bsky.feed.getActorLikes', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$AppBskyFeedGetActorLikes.toKnownErr(e);
        });
    }
    getAuthorFeed(params, opts) {
        return this._client.call('app.bsky.feed.getAuthorFeed', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$AppBskyFeedGetAuthorFeed.toKnownErr(e);
        });
    }
    getFeed(params, opts) {
        return this._client.call('app.bsky.feed.getFeed', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$AppBskyFeedGetFeed.toKnownErr(e);
        });
    }
    getFeedGenerator(params, opts) {
        return this._client.call('app.bsky.feed.getFeedGenerator', params, undefined, opts);
    }
    getFeedGenerators(params, opts) {
        return this._client.call('app.bsky.feed.getFeedGenerators', params, undefined, opts);
    }
    getFeedSkeleton(params, opts) {
        return this._client.call('app.bsky.feed.getFeedSkeleton', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$AppBskyFeedGetFeedSkeleton.toKnownErr(e);
        });
    }
    getLikes(params, opts) {
        return this._client.call('app.bsky.feed.getLikes', params, undefined, opts);
    }
    getListFeed(params, opts) {
        return this._client.call('app.bsky.feed.getListFeed', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$AppBskyFeedGetListFeed.toKnownErr(e);
        });
    }
    getPostThread(params, opts) {
        return this._client.call('app.bsky.feed.getPostThread', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$AppBskyFeedGetPostThread.toKnownErr(e);
        });
    }
    getPosts(params, opts) {
        return this._client.call('app.bsky.feed.getPosts', params, undefined, opts);
    }
    getQuotes(params, opts) {
        return this._client.call('app.bsky.feed.getQuotes', params, undefined, opts);
    }
    getRepostedBy(params, opts) {
        return this._client.call('app.bsky.feed.getRepostedBy', params, undefined, opts);
    }
    getSuggestedFeeds(params, opts) {
        return this._client.call('app.bsky.feed.getSuggestedFeeds', params, undefined, opts);
    }
    getTimeline(params, opts) {
        return this._client.call('app.bsky.feed.getTimeline', params, undefined, opts);
    }
    searchPosts(params, opts) {
        return this._client.call('app.bsky.feed.searchPosts', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$AppBskyFeedSearchPosts.toKnownErr(e);
        });
    }
    sendInteractions(data, opts) {
        return this._client.call('app.bsky.feed.sendInteractions', opts?.qp, data, opts);
    }
}
module.exports.AppBskyFeedNS = $1d635f8a313474c1$var$AppBskyFeedNS;
class $1d635f8a313474c1$var$GeneratorRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.generator',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.generator',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.feed.generator';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.feed.generator',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.generator',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.GeneratorRecord = $1d635f8a313474c1$var$GeneratorRecord;
class $1d635f8a313474c1$var$LikeRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.like',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.like',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.feed.like';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.feed.like',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.like',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.LikeRecord = $1d635f8a313474c1$var$LikeRecord;
class $1d635f8a313474c1$var$PostRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.post',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.post',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.feed.post';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.feed.post',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.post',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.PostRecord = $1d635f8a313474c1$var$PostRecord;
class $1d635f8a313474c1$var$PostgateRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.postgate',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.postgate',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.feed.postgate';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.feed.postgate',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.postgate',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.PostgateRecord = $1d635f8a313474c1$var$PostgateRecord;
class $1d635f8a313474c1$var$RepostRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.repost',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.repost',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.feed.repost';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.feed.repost',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.repost',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.RepostRecord = $1d635f8a313474c1$var$RepostRecord;
class $1d635f8a313474c1$var$ThreadgateRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.threadgate',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.threadgate',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.feed.threadgate';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.feed.threadgate',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.threadgate',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.ThreadgateRecord = $1d635f8a313474c1$var$ThreadgateRecord;
class $1d635f8a313474c1$var$AppBskyGraphNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "block", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "follow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "list", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "listblock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "listitem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "starterpack", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.block = new $1d635f8a313474c1$var$BlockRecord(client);
        this.follow = new $1d635f8a313474c1$var$FollowRecord(client);
        this.list = new $1d635f8a313474c1$var$ListRecord(client);
        this.listblock = new $1d635f8a313474c1$var$ListblockRecord(client);
        this.listitem = new $1d635f8a313474c1$var$ListitemRecord(client);
        this.starterpack = new $1d635f8a313474c1$var$StarterpackRecord(client);
    }
    getActorStarterPacks(params, opts) {
        return this._client.call('app.bsky.graph.getActorStarterPacks', params, undefined, opts);
    }
    getBlocks(params, opts) {
        return this._client.call('app.bsky.graph.getBlocks', params, undefined, opts);
    }
    getFollowers(params, opts) {
        return this._client.call('app.bsky.graph.getFollowers', params, undefined, opts);
    }
    getFollows(params, opts) {
        return this._client.call('app.bsky.graph.getFollows', params, undefined, opts);
    }
    getKnownFollowers(params, opts) {
        return this._client.call('app.bsky.graph.getKnownFollowers', params, undefined, opts);
    }
    getList(params, opts) {
        return this._client.call('app.bsky.graph.getList', params, undefined, opts);
    }
    getListBlocks(params, opts) {
        return this._client.call('app.bsky.graph.getListBlocks', params, undefined, opts);
    }
    getListMutes(params, opts) {
        return this._client.call('app.bsky.graph.getListMutes', params, undefined, opts);
    }
    getLists(params, opts) {
        return this._client.call('app.bsky.graph.getLists', params, undefined, opts);
    }
    getMutes(params, opts) {
        return this._client.call('app.bsky.graph.getMutes', params, undefined, opts);
    }
    getRelationships(params, opts) {
        return this._client.call('app.bsky.graph.getRelationships', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$AppBskyGraphGetRelationships.toKnownErr(e);
        });
    }
    getStarterPack(params, opts) {
        return this._client.call('app.bsky.graph.getStarterPack', params, undefined, opts);
    }
    getStarterPacks(params, opts) {
        return this._client.call('app.bsky.graph.getStarterPacks', params, undefined, opts);
    }
    getSuggestedFollowsByActor(params, opts) {
        return this._client.call('app.bsky.graph.getSuggestedFollowsByActor', params, undefined, opts);
    }
    muteActor(data, opts) {
        return this._client.call('app.bsky.graph.muteActor', opts?.qp, data, opts);
    }
    muteActorList(data, opts) {
        return this._client.call('app.bsky.graph.muteActorList', opts?.qp, data, opts);
    }
    muteThread(data, opts) {
        return this._client.call('app.bsky.graph.muteThread', opts?.qp, data, opts);
    }
    searchStarterPacks(params, opts) {
        return this._client.call('app.bsky.graph.searchStarterPacks', params, undefined, opts);
    }
    unmuteActor(data, opts) {
        return this._client.call('app.bsky.graph.unmuteActor', opts?.qp, data, opts);
    }
    unmuteActorList(data, opts) {
        return this._client.call('app.bsky.graph.unmuteActorList', opts?.qp, data, opts);
    }
    unmuteThread(data, opts) {
        return this._client.call('app.bsky.graph.unmuteThread', opts?.qp, data, opts);
    }
}
module.exports.AppBskyGraphNS = $1d635f8a313474c1$var$AppBskyGraphNS;
class $1d635f8a313474c1$var$BlockRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.block',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.block',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.graph.block';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.graph.block',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.block',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.BlockRecord = $1d635f8a313474c1$var$BlockRecord;
class $1d635f8a313474c1$var$FollowRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.follow',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.follow',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.graph.follow';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.graph.follow',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.follow',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.FollowRecord = $1d635f8a313474c1$var$FollowRecord;
class $1d635f8a313474c1$var$ListRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.list',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.list',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.graph.list';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.graph.list',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.list',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.ListRecord = $1d635f8a313474c1$var$ListRecord;
class $1d635f8a313474c1$var$ListblockRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.listblock',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.listblock',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.graph.listblock';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.graph.listblock',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.listblock',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.ListblockRecord = $1d635f8a313474c1$var$ListblockRecord;
class $1d635f8a313474c1$var$ListitemRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.listitem',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.listitem',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.graph.listitem';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.graph.listitem',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.listitem',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.ListitemRecord = $1d635f8a313474c1$var$ListitemRecord;
class $1d635f8a313474c1$var$StarterpackRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.starterpack',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.starterpack',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.graph.starterpack';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.graph.starterpack',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.starterpack',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.StarterpackRecord = $1d635f8a313474c1$var$StarterpackRecord;
class $1d635f8a313474c1$var$AppBskyLabelerNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "service", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.service = new $1d635f8a313474c1$var$ServiceRecord(client);
    }
    getServices(params, opts) {
        return this._client.call('app.bsky.labeler.getServices', params, undefined, opts);
    }
}
module.exports.AppBskyLabelerNS = $1d635f8a313474c1$var$AppBskyLabelerNS;
class $1d635f8a313474c1$var$ServiceRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.labeler.service',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.labeler.service',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'app.bsky.labeler.service';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'app.bsky.labeler.service',
            rkey: 'self',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.labeler.service',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.ServiceRecord = $1d635f8a313474c1$var$ServiceRecord;
class $1d635f8a313474c1$var$AppBskyNotificationNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getUnreadCount(params, opts) {
        return this._client.call('app.bsky.notification.getUnreadCount', params, undefined, opts);
    }
    listNotifications(params, opts) {
        return this._client.call('app.bsky.notification.listNotifications', params, undefined, opts);
    }
    putPreferences(data, opts) {
        return this._client.call('app.bsky.notification.putPreferences', opts?.qp, data, opts);
    }
    registerPush(data, opts) {
        return this._client.call('app.bsky.notification.registerPush', opts?.qp, data, opts);
    }
    updateSeen(data, opts) {
        return this._client.call('app.bsky.notification.updateSeen', opts?.qp, data, opts);
    }
}
module.exports.AppBskyNotificationNS = $1d635f8a313474c1$var$AppBskyNotificationNS;
class $1d635f8a313474c1$var$AppBskyRichtextNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
}
module.exports.AppBskyRichtextNS = $1d635f8a313474c1$var$AppBskyRichtextNS;
class $1d635f8a313474c1$var$AppBskyUnspeccedNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getConfig(params, opts) {
        return this._client.call('app.bsky.unspecced.getConfig', params, undefined, opts);
    }
    getPopularFeedGenerators(params, opts) {
        return this._client.call('app.bsky.unspecced.getPopularFeedGenerators', params, undefined, opts);
    }
    getSuggestionsSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.getSuggestionsSkeleton', params, undefined, opts);
    }
    getTaggedSuggestions(params, opts) {
        return this._client.call('app.bsky.unspecced.getTaggedSuggestions', params, undefined, opts);
    }
    getTrendingTopics(params, opts) {
        return this._client.call('app.bsky.unspecced.getTrendingTopics', params, undefined, opts);
    }
    searchActorsSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.searchActorsSkeleton', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$AppBskyUnspeccedSearchActorsSkeleton.toKnownErr(e);
        });
    }
    searchPostsSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.searchPostsSkeleton', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$AppBskyUnspeccedSearchPostsSkeleton.toKnownErr(e);
        });
    }
    searchStarterPacksSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.searchStarterPacksSkeleton', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$AppBskyUnspeccedSearchStarterPacksSkeleton.toKnownErr(e);
        });
    }
}
module.exports.AppBskyUnspeccedNS = $1d635f8a313474c1$var$AppBskyUnspeccedNS;
class $1d635f8a313474c1$var$AppBskyVideoNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getJobStatus(params, opts) {
        return this._client.call('app.bsky.video.getJobStatus', params, undefined, opts);
    }
    getUploadLimits(params, opts) {
        return this._client.call('app.bsky.video.getUploadLimits', params, undefined, opts);
    }
    uploadVideo(data, opts) {
        return this._client.call('app.bsky.video.uploadVideo', opts?.qp, data, opts);
    }
}
module.exports.AppBskyVideoNS = $1d635f8a313474c1$var$AppBskyVideoNS;
class $1d635f8a313474c1$var$ChatNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bsky", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.bsky = new $1d635f8a313474c1$var$ChatBskyNS(client);
    }
}
module.exports.ChatNS = $1d635f8a313474c1$var$ChatNS;
class $1d635f8a313474c1$var$ChatBskyNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "actor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "convo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "moderation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.actor = new $1d635f8a313474c1$var$ChatBskyActorNS(client);
        this.convo = new $1d635f8a313474c1$var$ChatBskyConvoNS(client);
        this.moderation = new $1d635f8a313474c1$var$ChatBskyModerationNS(client);
    }
}
module.exports.ChatBskyNS = $1d635f8a313474c1$var$ChatBskyNS;
class $1d635f8a313474c1$var$ChatBskyActorNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "declaration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.declaration = new $1d635f8a313474c1$var$DeclarationRecord(client);
    }
    deleteAccount(data, opts) {
        return this._client.call('chat.bsky.actor.deleteAccount', opts?.qp, data, opts);
    }
    exportAccountData(params, opts) {
        return this._client.call('chat.bsky.actor.exportAccountData', params, undefined, opts);
    }
}
module.exports.ChatBskyActorNS = $1d635f8a313474c1$var$ChatBskyActorNS;
class $1d635f8a313474c1$var$DeclarationRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'chat.bsky.actor.declaration',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'chat.bsky.actor.declaration',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        record.$type = 'chat.bsky.actor.declaration';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection: 'chat.bsky.actor.declaration',
            rkey: 'self',
            ...params,
            record: record
        }, {
            encoding: 'application/json',
            headers: headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'chat.bsky.actor.declaration',
            ...params
        }, {
            headers: headers
        });
    }
}
module.exports.DeclarationRecord = $1d635f8a313474c1$var$DeclarationRecord;
class $1d635f8a313474c1$var$ChatBskyConvoNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    deleteMessageForSelf(data, opts) {
        return this._client.call('chat.bsky.convo.deleteMessageForSelf', opts?.qp, data, opts);
    }
    getConvo(params, opts) {
        return this._client.call('chat.bsky.convo.getConvo', params, undefined, opts);
    }
    getConvoForMembers(params, opts) {
        return this._client.call('chat.bsky.convo.getConvoForMembers', params, undefined, opts);
    }
    getLog(params, opts) {
        return this._client.call('chat.bsky.convo.getLog', params, undefined, opts);
    }
    getMessages(params, opts) {
        return this._client.call('chat.bsky.convo.getMessages', params, undefined, opts);
    }
    leaveConvo(data, opts) {
        return this._client.call('chat.bsky.convo.leaveConvo', opts?.qp, data, opts);
    }
    listConvos(params, opts) {
        return this._client.call('chat.bsky.convo.listConvos', params, undefined, opts);
    }
    muteConvo(data, opts) {
        return this._client.call('chat.bsky.convo.muteConvo', opts?.qp, data, opts);
    }
    sendMessage(data, opts) {
        return this._client.call('chat.bsky.convo.sendMessage', opts?.qp, data, opts);
    }
    sendMessageBatch(data, opts) {
        return this._client.call('chat.bsky.convo.sendMessageBatch', opts?.qp, data, opts);
    }
    unmuteConvo(data, opts) {
        return this._client.call('chat.bsky.convo.unmuteConvo', opts?.qp, data, opts);
    }
    updateRead(data, opts) {
        return this._client.call('chat.bsky.convo.updateRead', opts?.qp, data, opts);
    }
}
module.exports.ChatBskyConvoNS = $1d635f8a313474c1$var$ChatBskyConvoNS;
class $1d635f8a313474c1$var$ChatBskyModerationNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getActorMetadata(params, opts) {
        return this._client.call('chat.bsky.moderation.getActorMetadata', params, undefined, opts);
    }
    getMessageContext(params, opts) {
        return this._client.call('chat.bsky.moderation.getMessageContext', params, undefined, opts);
    }
    updateActorAccess(data, opts) {
        return this._client.call('chat.bsky.moderation.updateActorAccess', opts?.qp, data, opts);
    }
}
module.exports.ChatBskyModerationNS = $1d635f8a313474c1$var$ChatBskyModerationNS;
class $1d635f8a313474c1$var$ToolsNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ozone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.ozone = new $1d635f8a313474c1$var$ToolsOzoneNS(client);
    }
}
module.exports.ToolsNS = $1d635f8a313474c1$var$ToolsNS;
class $1d635f8a313474c1$var$ToolsOzoneNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "communication", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "moderation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "server", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "set", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "team", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.communication = new $1d635f8a313474c1$var$ToolsOzoneCommunicationNS(client);
        this.moderation = new $1d635f8a313474c1$var$ToolsOzoneModerationNS(client);
        this.server = new $1d635f8a313474c1$var$ToolsOzoneServerNS(client);
        this.set = new $1d635f8a313474c1$var$ToolsOzoneSetNS(client);
        this.setting = new $1d635f8a313474c1$var$ToolsOzoneSettingNS(client);
        this.signature = new $1d635f8a313474c1$var$ToolsOzoneSignatureNS(client);
        this.team = new $1d635f8a313474c1$var$ToolsOzoneTeamNS(client);
    }
}
module.exports.ToolsOzoneNS = $1d635f8a313474c1$var$ToolsOzoneNS;
class $1d635f8a313474c1$var$ToolsOzoneCommunicationNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    createTemplate(data, opts) {
        return this._client.call('tools.ozone.communication.createTemplate', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ToolsOzoneCommunicationCreateTemplate.toKnownErr(e);
        });
    }
    deleteTemplate(data, opts) {
        return this._client.call('tools.ozone.communication.deleteTemplate', opts?.qp, data, opts);
    }
    listTemplates(params, opts) {
        return this._client.call('tools.ozone.communication.listTemplates', params, undefined, opts);
    }
    updateTemplate(data, opts) {
        return this._client.call('tools.ozone.communication.updateTemplate', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ToolsOzoneCommunicationUpdateTemplate.toKnownErr(e);
        });
    }
}
module.exports.ToolsOzoneCommunicationNS = $1d635f8a313474c1$var$ToolsOzoneCommunicationNS;
class $1d635f8a313474c1$var$ToolsOzoneModerationNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    emitEvent(data, opts) {
        return this._client.call('tools.ozone.moderation.emitEvent', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ToolsOzoneModerationEmitEvent.toKnownErr(e);
        });
    }
    getEvent(params, opts) {
        return this._client.call('tools.ozone.moderation.getEvent', params, undefined, opts);
    }
    getRecord(params, opts) {
        return this._client.call('tools.ozone.moderation.getRecord', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ToolsOzoneModerationGetRecord.toKnownErr(e);
        });
    }
    getRecords(params, opts) {
        return this._client.call('tools.ozone.moderation.getRecords', params, undefined, opts);
    }
    getRepo(params, opts) {
        return this._client.call('tools.ozone.moderation.getRepo', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ToolsOzoneModerationGetRepo.toKnownErr(e);
        });
    }
    getRepos(params, opts) {
        return this._client.call('tools.ozone.moderation.getRepos', params, undefined, opts);
    }
    queryEvents(params, opts) {
        return this._client.call('tools.ozone.moderation.queryEvents', params, undefined, opts);
    }
    queryStatuses(params, opts) {
        return this._client.call('tools.ozone.moderation.queryStatuses', params, undefined, opts);
    }
    searchRepos(params, opts) {
        return this._client.call('tools.ozone.moderation.searchRepos', params, undefined, opts);
    }
}
module.exports.ToolsOzoneModerationNS = $1d635f8a313474c1$var$ToolsOzoneModerationNS;
class $1d635f8a313474c1$var$ToolsOzoneServerNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getConfig(params, opts) {
        return this._client.call('tools.ozone.server.getConfig', params, undefined, opts);
    }
}
module.exports.ToolsOzoneServerNS = $1d635f8a313474c1$var$ToolsOzoneServerNS;
class $1d635f8a313474c1$var$ToolsOzoneSetNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    addValues(data, opts) {
        return this._client.call('tools.ozone.set.addValues', opts?.qp, data, opts);
    }
    deleteSet(data, opts) {
        return this._client.call('tools.ozone.set.deleteSet', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ToolsOzoneSetDeleteSet.toKnownErr(e);
        });
    }
    deleteValues(data, opts) {
        return this._client.call('tools.ozone.set.deleteValues', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ToolsOzoneSetDeleteValues.toKnownErr(e);
        });
    }
    getValues(params, opts) {
        return this._client.call('tools.ozone.set.getValues', params, undefined, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ToolsOzoneSetGetValues.toKnownErr(e);
        });
    }
    querySets(params, opts) {
        return this._client.call('tools.ozone.set.querySets', params, undefined, opts);
    }
    upsertSet(data, opts) {
        return this._client.call('tools.ozone.set.upsertSet', opts?.qp, data, opts);
    }
}
module.exports.ToolsOzoneSetNS = $1d635f8a313474c1$var$ToolsOzoneSetNS;
class $1d635f8a313474c1$var$ToolsOzoneSettingNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    listOptions(params, opts) {
        return this._client.call('tools.ozone.setting.listOptions', params, undefined, opts);
    }
    removeOptions(data, opts) {
        return this._client.call('tools.ozone.setting.removeOptions', opts?.qp, data, opts);
    }
    upsertOption(data, opts) {
        return this._client.call('tools.ozone.setting.upsertOption', opts?.qp, data, opts);
    }
}
module.exports.ToolsOzoneSettingNS = $1d635f8a313474c1$var$ToolsOzoneSettingNS;
class $1d635f8a313474c1$var$ToolsOzoneSignatureNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    findCorrelation(params, opts) {
        return this._client.call('tools.ozone.signature.findCorrelation', params, undefined, opts);
    }
    findRelatedAccounts(params, opts) {
        return this._client.call('tools.ozone.signature.findRelatedAccounts', params, undefined, opts);
    }
    searchAccounts(params, opts) {
        return this._client.call('tools.ozone.signature.searchAccounts', params, undefined, opts);
    }
}
module.exports.ToolsOzoneSignatureNS = $1d635f8a313474c1$var$ToolsOzoneSignatureNS;
class $1d635f8a313474c1$var$ToolsOzoneTeamNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    addMember(data, opts) {
        return this._client.call('tools.ozone.team.addMember', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ToolsOzoneTeamAddMember.toKnownErr(e);
        });
    }
    deleteMember(data, opts) {
        return this._client.call('tools.ozone.team.deleteMember', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ToolsOzoneTeamDeleteMember.toKnownErr(e);
        });
    }
    listMembers(params, opts) {
        return this._client.call('tools.ozone.team.listMembers', params, undefined, opts);
    }
    updateMember(data, opts) {
        return this._client.call('tools.ozone.team.updateMember', opts?.qp, data, opts).catch((e)=>{
            throw $1d635f8a313474c1$var$ToolsOzoneTeamUpdateMember.toKnownErr(e);
        });
    }
}
module.exports.ToolsOzoneTeamNS = $1d635f8a313474c1$var$ToolsOzoneTeamNS;

});
parcelRegister("al5Ta", function(module, exports) {
"use strict";
var $78706ef10842714f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $78706ef10842714f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $78706ef10842714f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$78706ef10842714f$var$__exportStar((parcelRequire("ge2Aa")), module.exports);

$78706ef10842714f$var$__exportStar((parcelRequire("iOpby")), module.exports);

$78706ef10842714f$var$__exportStar((parcelRequire("5CXSS")), module.exports);

$78706ef10842714f$var$__exportStar((parcelRequire("9l95l")), module.exports);

$78706ef10842714f$var$__exportStar((parcelRequire("l1Lz8")), module.exports);

/** @deprecated create a local {@link XrpcClient} instance instead */ const $78706ef10842714f$var$defaultInst = new (parcelRequire("ge2Aa")).Client();
module.exports.default = $78706ef10842714f$var$defaultInst; /* eslint-enable import/no-deprecated */ 

});
parcelRegister("ge2Aa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceClient = module.exports.Client = void 0;

var $3dCVT = parcelRequire("3dCVT");

var $9l95l = parcelRequire("9l95l");

var $l1Lz8 = parcelRequire("l1Lz8");
/** @deprecated Use {@link XrpcClient} instead */ class $bcfff4ef14849d7e$var$Client {
    constructor(){
        Object.defineProperty(this, "lex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new $3dCVT.Lexicons()
        });
    }
    /** @deprecated */ get fetch() {
        throw new Error('Client.fetch is no longer supported. Use an XrpcClient instead.');
    }
    /** @deprecated */ set fetch(_) {
        throw new Error('Client.fetch is no longer supported. Use an XrpcClient instead.');
    }
    // method calls
    //
    async call(serviceUri, methodNsid, params, data, opts) {
        return this.service(serviceUri).call(methodNsid, params, data, opts);
    }
    service(serviceUri) {
        return new $bcfff4ef14849d7e$var$ServiceClient(this, serviceUri);
    }
    // schemas
    // =
    addLexicon(doc) {
        this.lex.add(doc);
    }
    addLexicons(docs) {
        for (const doc of docs)this.addLexicon(doc);
    }
    removeLexicon(uri) {
        this.lex.remove(uri);
    }
}
module.exports.Client = $bcfff4ef14849d7e$var$Client;
/** @deprecated Use {@link XrpcClient} instead */ class $bcfff4ef14849d7e$var$ServiceClient extends $l1Lz8.XrpcClient {
    constructor(baseClient, serviceUri){
        super(async (input, init)=>{
            const headers = (0, $9l95l.combineHeaders)(init.headers, Object.entries(this.headers));
            return fetch(new URL(input, this.uri), {
                ...init,
                headers: headers
            });
        }, baseClient.lex);
        Object.defineProperty(this, "baseClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: baseClient
        });
        Object.defineProperty(this, "uri", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.uri = typeof serviceUri === 'string' ? new URL(serviceUri) : serviceUri;
    }
}
module.exports.ServiceClient = $bcfff4ef14849d7e$var$ServiceClient;

});
parcelRegister("3dCVT", function(module, exports) {
"use strict";
var $2580c9349c50da18$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2580c9349c50da18$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2580c9349c50da18$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2580c9349c50da18$var$__exportStar((parcelRequire("8gte5")), module.exports);

$2580c9349c50da18$var$__exportStar((parcelRequire("fqvnA")), module.exports);

$2580c9349c50da18$var$__exportStar((parcelRequire("9mWeA")), module.exports);

$2580c9349c50da18$var$__exportStar((parcelRequire("cjXJG")), module.exports);

});

parcelRegister("9l95l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isErrorResponseBody = $6ccd1f60994464e4$var$isErrorResponseBody;
module.exports.getMethodSchemaHTTPMethod = $6ccd1f60994464e4$var$getMethodSchemaHTTPMethod;
module.exports.constructMethodCallUri = $6ccd1f60994464e4$var$constructMethodCallUri;
module.exports.constructMethodCallUrl = $6ccd1f60994464e4$var$constructMethodCallUrl;
module.exports.encodeQueryParam = $6ccd1f60994464e4$var$encodeQueryParam;
module.exports.constructMethodCallHeaders = $6ccd1f60994464e4$var$constructMethodCallHeaders;
module.exports.combineHeaders = $6ccd1f60994464e4$var$combineHeaders;
module.exports.isBodyInit = $6ccd1f60994464e4$var$isBodyInit;
module.exports.isIterable = $6ccd1f60994464e4$var$isIterable;
module.exports.encodeMethodCallBody = $6ccd1f60994464e4$var$encodeMethodCallBody;
module.exports.httpResponseBodyParse = $6ccd1f60994464e4$var$httpResponseBodyParse;

var $3dCVT = parcelRequire("3dCVT");

var $5CXSS = parcelRequire("5CXSS");
const $6ccd1f60994464e4$var$ReadableStream = globalThis.ReadableStream || class {
    constructor(){
        // This anonymous class will never pass any "instanceof" check and cannot
        // be instantiated.
        throw new Error('ReadableStream is not supported in this environment');
    }
};
function $6ccd1f60994464e4$var$isErrorResponseBody(v) {
    return $5CXSS.errorResponseBody.safeParse(v).success;
}
function $6ccd1f60994464e4$var$getMethodSchemaHTTPMethod(schema) {
    if (schema.type === 'procedure') return 'post';
    return 'get';
}
function $6ccd1f60994464e4$var$constructMethodCallUri(nsid, schema, serviceUri, params) {
    const uri = new URL($6ccd1f60994464e4$var$constructMethodCallUrl(nsid, schema, params), serviceUri);
    return uri.toString();
}
function $6ccd1f60994464e4$var$constructMethodCallUrl(nsid, schema, params) {
    const pathname = `/xrpc/${encodeURIComponent(nsid)}`;
    if (!params) return pathname;
    const searchParams = [];
    for (const [key, value] of Object.entries(params)){
        const paramSchema = schema.parameters?.properties?.[key];
        if (!paramSchema) throw new Error(`Invalid query parameter: ${key}`);
        if (value !== undefined) {
            if (paramSchema.type === 'array') {
                const values = Array.isArray(value) ? value : [
                    value
                ];
                for (const val of values)searchParams.push([
                    key,
                    $6ccd1f60994464e4$var$encodeQueryParam(paramSchema.items.type, val)
                ]);
            } else searchParams.push([
                key,
                $6ccd1f60994464e4$var$encodeQueryParam(paramSchema.type, value)
            ]);
        }
    }
    if (!searchParams.length) return pathname;
    return `${pathname}?${new URLSearchParams(searchParams).toString()}`;
}
function $6ccd1f60994464e4$var$encodeQueryParam(type, value) {
    if (type === 'string' || type === 'unknown') return String(value);
    if (type === 'float') return String(Number(value));
    else if (type === 'integer') return String(Number(value) | 0);
    else if (type === 'boolean') return value ? 'true' : 'false';
    else if (type === 'datetime') {
        if (value instanceof Date) return value.toISOString();
        return String(value);
    }
    throw new Error(`Unsupported query param type: ${type}`);
}
function $6ccd1f60994464e4$var$constructMethodCallHeaders(schema, data, opts) {
    // Not using `new Headers(opts?.headers)` to avoid duplicating headers values
    // due to inconsistent casing in headers name. In case of multiple headers
    // with the same name (but using a different case), the last one will be used.
    // new Headers({ 'content-type': 'foo', 'Content-Type': 'bar' }).get('content-type')
    // => 'foo, bar'
    const headers = new Headers();
    if (opts?.headers) for(const name in opts.headers){
        if (headers.has(name)) throw new TypeError(`Duplicate header: ${name}`);
        const value = opts.headers[name];
        if (value != null) headers.set(name, value);
    }
    if (schema.type === 'procedure') {
        if (opts?.encoding) headers.set('content-type', opts.encoding);
        else if (!headers.has('content-type') && typeof data !== 'undefined') {
            // Special handling of BodyInit types before falling back to JSON encoding
            if (data instanceof ArrayBuffer || data instanceof $6ccd1f60994464e4$var$ReadableStream || ArrayBuffer.isView(data)) headers.set('content-type', 'application/octet-stream');
            else if (data instanceof FormData) // Note: The multipart form data boundary is missing from the header
            // we set here, making that header invalid. This special case will be
            // handled in encodeMethodCallBody()
            headers.set('content-type', 'multipart/form-data');
            else if (data instanceof URLSearchParams) headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            else if ($6ccd1f60994464e4$var$isBlobLike(data)) headers.set('content-type', data.type || 'application/octet-stream');
            else if (typeof data === 'string') headers.set('content-type', 'text/plain;charset=UTF-8');
            else if ($6ccd1f60994464e4$var$isIterable(data)) headers.set('content-type', 'application/octet-stream');
            else if (typeof data === 'boolean' || typeof data === 'number' || typeof data === 'string' || typeof data === 'object' // covers "null"
            ) headers.set('content-type', 'application/json');
            else // symbol, function, bigint
            throw new $5CXSS.XRPCError($5CXSS.ResponseType.InvalidRequest, `Unsupported data type: ${typeof data}`);
        }
    }
    return headers;
}
function $6ccd1f60994464e4$var$combineHeaders(headersInit, defaultHeaders) {
    if (!defaultHeaders) return headersInit;
    let headers = undefined;
    for (const [name, definition] of defaultHeaders){
        // Ignore undefined values (allowed for convenience when using
        // Object.entries).
        if (definition === undefined) continue;
        // Lazy initialization of the headers object
        headers ?? (headers = new Headers(headersInit));
        if (headers.has(name)) continue;
        const value = typeof definition === 'function' ? definition() : definition;
        if (typeof value === 'string') headers.set(name, value);
        else if (value === null) headers.delete(name);
        else throw new TypeError(`Invalid "${name}" header value: ${typeof value}`);
    }
    return headers ?? headersInit;
}
function $6ccd1f60994464e4$var$isBlobLike(value) {
    if (value == null) return false;
    if (typeof value !== 'object') return false;
    if (typeof Blob === 'function' && value instanceof Blob) return true;
    // Support for Blobs provided by libraries that don't use the native Blob
    // (e.g. fetch-blob from node-fetch).
    // https://github.com/node-fetch/fetch-blob/blob/a1a182e5978811407bef4ea1632b517567dda01f/index.js#L233-L244
    const tag = value[Symbol.toStringTag];
    if (tag === 'Blob' || tag === 'File') return 'stream' in value && typeof value.stream === 'function';
    return false;
}
function $6ccd1f60994464e4$var$isBodyInit(value) {
    switch(typeof value){
        case 'string':
            return true;
        case 'object':
            return value instanceof ArrayBuffer || value instanceof FormData || value instanceof URLSearchParams || value instanceof $6ccd1f60994464e4$var$ReadableStream || ArrayBuffer.isView(value) || $6ccd1f60994464e4$var$isBlobLike(value);
        default:
            return false;
    }
}
function $6ccd1f60994464e4$var$isIterable(value) {
    return value != null && typeof value === 'object' && (Symbol.iterator in value || Symbol.asyncIterator in value);
}
function $6ccd1f60994464e4$var$encodeMethodCallBody(headers, data) {
    // Silently ignore the body if there is no content-type header.
    const contentType = headers.get('content-type');
    if (!contentType) return undefined;
    if (typeof data === 'undefined') // This error would be returned by the server, but we can catch it earlier
    // to avoid un-necessary requests. Note that a content-length of 0 does not
    // necessary mean that the body is "empty" (e.g. an empty txt file).
    throw new $5CXSS.XRPCError($5CXSS.ResponseType.InvalidRequest, `A request body is expected but none was provided`);
    if ($6ccd1f60994464e4$var$isBodyInit(data)) {
        if (data instanceof FormData && contentType === 'multipart/form-data') // fetch() will encode FormData payload itself, but it won't override the
        // content-type header if already present. This would cause the boundary
        // to be missing from the content-type header, resulting in a 400 error.
        // Deleting the content-type header here to let fetch() re-create it.
        headers.delete('content-type');
        // Will be encoded by the fetch API.
        return data;
    }
    if ($6ccd1f60994464e4$var$isIterable(data)) // Note that some environments support using Iterable & AsyncIterable as the
    // body (e.g. Node's fetch), but not all of them do (browsers).
    return $6ccd1f60994464e4$var$iterableToReadableStream(data);
    if (contentType.startsWith('text/')) return new TextEncoder().encode(String(data));
    if (contentType.startsWith('application/json')) {
        const json = (0, $3dCVT.stringifyLex)(data);
        // Server would return a 400 error if the JSON is invalid (e.g. trying to
        // JSONify a function, or an object that implements toJSON() poorly).
        if (json === undefined) throw new $5CXSS.XRPCError($5CXSS.ResponseType.InvalidRequest, `Failed to encode request body as JSON`);
        return new TextEncoder().encode(json);
    }
    // At this point, "data" is not a valid BodyInit value, and we don't know how
    // to encode it into one. Passing it to fetch would result in an error. Let's
    // throw our own error instead.
    const type = !data || typeof data !== 'object' ? typeof data : data.constructor !== Object && typeof data.constructor === 'function' && typeof data.constructor?.name === 'string' ? data.constructor.name : 'object';
    throw new $5CXSS.XRPCError($5CXSS.ResponseType.InvalidRequest, `Unable to encode ${type} as ${contentType} data`);
}
/**
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream/from_static}
 */ function $6ccd1f60994464e4$var$iterableToReadableStream(iterable) {
    // Use the native ReadableStream.from() if available.
    if ('from' in $6ccd1f60994464e4$var$ReadableStream && typeof $6ccd1f60994464e4$var$ReadableStream.from === 'function') return $6ccd1f60994464e4$var$ReadableStream.from(iterable);
    // If you see this error, consider using a polyfill for ReadableStream. For
    // example, the "web-streams-polyfill" package:
    // https://github.com/MattiasBuelens/web-streams-polyfill
    throw new TypeError("ReadableStream.from() is not supported in this environment. It is required to support using iterables as the request body. Consider using a polyfill or re-write your code to use a different body type.");
}
function $6ccd1f60994464e4$var$httpResponseBodyParse(mimeType, data) {
    try {
        if (mimeType) {
            if (mimeType.includes('application/json')) {
                const str = new TextDecoder().decode(data);
                return (0, $3dCVT.jsonStringToLex)(str);
            }
            if (mimeType.startsWith('text/')) return new TextDecoder().decode(data);
        }
        if (data instanceof ArrayBuffer) return new Uint8Array(data);
        return data;
    } catch (cause) {
        throw new $5CXSS.XRPCError($5CXSS.ResponseType.InvalidResponse, undefined, `Failed to parse response body: ${String(cause)}`, undefined, {
            cause: cause
        });
    }
}

});
parcelRegister("5CXSS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XRPCInvalidResponseError = module.exports.XRPCError = module.exports.XRPCResponse = module.exports.ResponseTypeStrings = module.exports.ResponseTypeNames = module.exports.ResponseType = module.exports.errorResponseBody = void 0;
module.exports.httpResponseCodeToEnum = $418ef416f1322c8c$var$httpResponseCodeToEnum;
module.exports.httpResponseCodeToName = $418ef416f1322c8c$var$httpResponseCodeToName;
module.exports.httpResponseCodeToString = $418ef416f1322c8c$var$httpResponseCodeToString;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.errorResponseBody = $2zDt6.z.object({
    error: $2zDt6.z.string().optional(),
    message: $2zDt6.z.string().optional()
});
var $418ef416f1322c8c$var$ResponseType;
(function(ResponseType) {
    ResponseType[ResponseType["Unknown"] = 1] = "Unknown";
    ResponseType[ResponseType["InvalidResponse"] = 2] = "InvalidResponse";
    ResponseType[ResponseType["Success"] = 200] = "Success";
    ResponseType[ResponseType["InvalidRequest"] = 400] = "InvalidRequest";
    ResponseType[ResponseType["AuthRequired"] = 401] = "AuthRequired";
    ResponseType[ResponseType["Forbidden"] = 403] = "Forbidden";
    ResponseType[ResponseType["XRPCNotSupported"] = 404] = "XRPCNotSupported";
    ResponseType[ResponseType["NotAcceptable"] = 406] = "NotAcceptable";
    ResponseType[ResponseType["PayloadTooLarge"] = 413] = "PayloadTooLarge";
    ResponseType[ResponseType["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    ResponseType[ResponseType["RateLimitExceeded"] = 429] = "RateLimitExceeded";
    ResponseType[ResponseType["InternalServerError"] = 500] = "InternalServerError";
    ResponseType[ResponseType["MethodNotImplemented"] = 501] = "MethodNotImplemented";
    ResponseType[ResponseType["UpstreamFailure"] = 502] = "UpstreamFailure";
    ResponseType[ResponseType["NotEnoughResources"] = 503] = "NotEnoughResources";
    ResponseType[ResponseType["UpstreamTimeout"] = 504] = "UpstreamTimeout";
})($418ef416f1322c8c$var$ResponseType || (module.exports.ResponseType = $418ef416f1322c8c$var$ResponseType = {}));
function $418ef416f1322c8c$var$httpResponseCodeToEnum(status) {
    if (status in $418ef416f1322c8c$var$ResponseType) return status;
    else if (status >= 100 && status < 200) return $418ef416f1322c8c$var$ResponseType.XRPCNotSupported;
    else if (status >= 200 && status < 300) return $418ef416f1322c8c$var$ResponseType.Success;
    else if (status >= 300 && status < 400) return $418ef416f1322c8c$var$ResponseType.XRPCNotSupported;
    else if (status >= 400 && status < 500) return $418ef416f1322c8c$var$ResponseType.InvalidRequest;
    else return $418ef416f1322c8c$var$ResponseType.InternalServerError;
}
module.exports.ResponseTypeNames = {
    [$418ef416f1322c8c$var$ResponseType.Unknown]: 'Unknown',
    [$418ef416f1322c8c$var$ResponseType.InvalidResponse]: 'InvalidResponse',
    [$418ef416f1322c8c$var$ResponseType.Success]: 'Success',
    [$418ef416f1322c8c$var$ResponseType.InvalidRequest]: 'InvalidRequest',
    [$418ef416f1322c8c$var$ResponseType.AuthRequired]: 'AuthenticationRequired',
    [$418ef416f1322c8c$var$ResponseType.Forbidden]: 'Forbidden',
    [$418ef416f1322c8c$var$ResponseType.XRPCNotSupported]: 'XRPCNotSupported',
    [$418ef416f1322c8c$var$ResponseType.PayloadTooLarge]: 'PayloadTooLarge',
    [$418ef416f1322c8c$var$ResponseType.UnsupportedMediaType]: 'UnsupportedMediaType',
    [$418ef416f1322c8c$var$ResponseType.RateLimitExceeded]: 'RateLimitExceeded',
    [$418ef416f1322c8c$var$ResponseType.InternalServerError]: 'InternalServerError',
    [$418ef416f1322c8c$var$ResponseType.MethodNotImplemented]: 'MethodNotImplemented',
    [$418ef416f1322c8c$var$ResponseType.UpstreamFailure]: 'UpstreamFailure',
    [$418ef416f1322c8c$var$ResponseType.NotEnoughResources]: 'NotEnoughResources',
    [$418ef416f1322c8c$var$ResponseType.UpstreamTimeout]: 'UpstreamTimeout'
};
function $418ef416f1322c8c$var$httpResponseCodeToName(status) {
    return module.exports.ResponseTypeNames[$418ef416f1322c8c$var$httpResponseCodeToEnum(status)];
}
module.exports.ResponseTypeStrings = {
    [$418ef416f1322c8c$var$ResponseType.Unknown]: 'Unknown',
    [$418ef416f1322c8c$var$ResponseType.InvalidResponse]: 'Invalid Response',
    [$418ef416f1322c8c$var$ResponseType.Success]: 'Success',
    [$418ef416f1322c8c$var$ResponseType.InvalidRequest]: 'Invalid Request',
    [$418ef416f1322c8c$var$ResponseType.AuthRequired]: 'Authentication Required',
    [$418ef416f1322c8c$var$ResponseType.Forbidden]: 'Forbidden',
    [$418ef416f1322c8c$var$ResponseType.XRPCNotSupported]: 'XRPC Not Supported',
    [$418ef416f1322c8c$var$ResponseType.PayloadTooLarge]: 'Payload Too Large',
    [$418ef416f1322c8c$var$ResponseType.UnsupportedMediaType]: 'Unsupported Media Type',
    [$418ef416f1322c8c$var$ResponseType.RateLimitExceeded]: 'Rate Limit Exceeded',
    [$418ef416f1322c8c$var$ResponseType.InternalServerError]: 'Internal Server Error',
    [$418ef416f1322c8c$var$ResponseType.MethodNotImplemented]: 'Method Not Implemented',
    [$418ef416f1322c8c$var$ResponseType.UpstreamFailure]: 'Upstream Failure',
    [$418ef416f1322c8c$var$ResponseType.NotEnoughResources]: 'Not Enough Resources',
    [$418ef416f1322c8c$var$ResponseType.UpstreamTimeout]: 'Upstream Timeout'
};
function $418ef416f1322c8c$var$httpResponseCodeToString(status) {
    return module.exports.ResponseTypeStrings[$418ef416f1322c8c$var$httpResponseCodeToEnum(status)];
}
class $418ef416f1322c8c$var$XRPCResponse {
    constructor(data, headers){
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: data
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: headers
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
    }
}
module.exports.XRPCResponse = $418ef416f1322c8c$var$XRPCResponse;
class $418ef416f1322c8c$var$XRPCError extends Error {
    constructor(statusCode, error = $418ef416f1322c8c$var$httpResponseCodeToName(statusCode), message, headers, options){
        super(message || error || $418ef416f1322c8c$var$httpResponseCodeToString(statusCode), options);
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: error
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: headers
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.status = $418ef416f1322c8c$var$httpResponseCodeToEnum(statusCode);
        // Pre 2022 runtimes won't handle the "options" constructor argument
        const cause = options?.cause;
        if (this.cause === undefined && cause !== undefined) this.cause = cause;
    }
    static from(cause, fallbackStatus) {
        if (cause instanceof $418ef416f1322c8c$var$XRPCError) return cause;
        // Type cast the cause to an Error if it is one
        const causeErr = cause instanceof Error ? cause : undefined;
        // Try and find a Response object in the cause
        const causeResponse = cause instanceof Response ? cause : cause?.['response'] instanceof Response ? cause['response'] : undefined;
        const statusCode = // Extract status code from "http-errors" like errors
        causeErr?.['statusCode'] ?? causeErr?.['status'] ?? // Use the status code from the response object as fallback
        causeResponse?.status;
        // Convert the status code to a ResponseType
        const status = typeof statusCode === 'number' ? $418ef416f1322c8c$var$httpResponseCodeToEnum(statusCode) : fallbackStatus ?? $418ef416f1322c8c$var$ResponseType.Unknown;
        const message = causeErr?.message ?? String(cause);
        const headers = causeResponse ? Object.fromEntries(causeResponse.headers.entries()) : undefined;
        return new $418ef416f1322c8c$var$XRPCError(status, undefined, message, headers, {
            cause: cause
        });
    }
}
module.exports.XRPCError = $418ef416f1322c8c$var$XRPCError;
class $418ef416f1322c8c$var$XRPCInvalidResponseError extends $418ef416f1322c8c$var$XRPCError {
    constructor(lexiconNsid, validationError, responseBody){
        super($418ef416f1322c8c$var$ResponseType.InvalidResponse, module.exports.ResponseTypeStrings[$418ef416f1322c8c$var$ResponseType.InvalidResponse], `The server gave an invalid response and may be out of date.`, undefined, {
            cause: validationError
        });
        Object.defineProperty(this, "lexiconNsid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: lexiconNsid
        });
        Object.defineProperty(this, "validationError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: validationError
        });
        Object.defineProperty(this, "responseBody", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: responseBody
        });
    }
}
module.exports.XRPCInvalidResponseError = $418ef416f1322c8c$var$XRPCInvalidResponseError;

});


parcelRegister("l1Lz8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XrpcClient = void 0;

var $3dCVT = parcelRequire("3dCVT");

var $iOpby = parcelRequire("iOpby");

var $5CXSS = parcelRequire("5CXSS");

var $9l95l = parcelRequire("9l95l");
class $f4ee9688c6d57340$var$XrpcClient {
    constructor(fetchHandlerOpts, // "Lexicons" is redundant here (because that class implements
    // "Iterable<LexiconDoc>") but we keep it for explicitness:
    lex){
        Object.defineProperty(this, "fetchHandler", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "lex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fetchHandler = (0, $iOpby.buildFetchHandler)(fetchHandlerOpts);
        this.lex = lex instanceof $3dCVT.Lexicons ? lex : new $3dCVT.Lexicons(lex);
    }
    setHeader(key, value) {
        this.headers.set(key.toLowerCase(), value);
    }
    unsetHeader(key) {
        this.headers.delete(key.toLowerCase());
    }
    clearHeaders() {
        this.headers.clear();
    }
    async call(methodNsid, params, data, opts) {
        const def = this.lex.getDefOrThrow(methodNsid);
        if (!def || def.type !== 'query' && def.type !== 'procedure') throw new TypeError(`Invalid lexicon: ${methodNsid}. Must be a query or procedure.`);
        // @TODO: should we validate the params and data here?
        // this.lex.assertValidXrpcParams(methodNsid, params)
        // if (data !== undefined) {
        //   this.lex.assertValidXrpcInput(methodNsid, data)
        // }
        const reqUrl = (0, $9l95l.constructMethodCallUrl)(methodNsid, def, params);
        const reqMethod = (0, $9l95l.getMethodSchemaHTTPMethod)(def);
        const reqHeaders = (0, $9l95l.constructMethodCallHeaders)(def, data, opts);
        const reqBody = (0, $9l95l.encodeMethodCallBody)(reqHeaders, data);
        // The duplex field is required for streaming bodies, but not yet reflected
        // anywhere in docs or types. See whatwg/fetch#1438, nodejs/node#46221.
        const init = {
            method: reqMethod,
            headers: (0, $9l95l.combineHeaders)(reqHeaders, this.headers),
            body: reqBody,
            duplex: 'half',
            signal: opts?.signal
        };
        try {
            const response = await this.fetchHandler.call(undefined, reqUrl, init);
            const resStatus = response.status;
            const resHeaders = Object.fromEntries(response.headers.entries());
            const resBodyBytes = await response.arrayBuffer();
            const resBody = (0, $9l95l.httpResponseBodyParse)(response.headers.get('content-type'), resBodyBytes);
            const resCode = (0, $5CXSS.httpResponseCodeToEnum)(resStatus);
            if (resCode !== $5CXSS.ResponseType.Success) {
                const { error: error, message: message } = resBody && (0, $9l95l.isErrorResponseBody)(resBody) ? resBody : {};
                throw new $5CXSS.XRPCError(resCode, error, message, resHeaders);
            }
            try {
                this.lex.assertValidXrpcOutput(methodNsid, resBody);
            } catch (e) {
                if (e instanceof $3dCVT.ValidationError) throw new $5CXSS.XRPCInvalidResponseError(methodNsid, e, resBody);
                throw e;
            }
            return new $5CXSS.XRPCResponse(resBody, resHeaders);
        } catch (err) {
            throw $5CXSS.XRPCError.from(err);
        }
    }
}
module.exports.XrpcClient = $f4ee9688c6d57340$var$XrpcClient;

});
parcelRegister("iOpby", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildFetchHandler = $db206ecdf639b1b3$var$buildFetchHandler;

var $9l95l = parcelRequire("9l95l");
function $db206ecdf639b1b3$var$buildFetchHandler(options) {
    // Already a fetch handler (allowed for convenience)
    if (typeof options === 'function') return options;
    if (typeof options === 'object' && 'fetchHandler' in options) return options.fetchHandler.bind(options);
    const { service: service, headers: defaultHeaders, fetch: fetch = globalThis.fetch } = typeof options === 'string' || options instanceof URL ? {
        service: options
    } : options;
    if (typeof fetch !== 'function') throw new TypeError('XrpcDispatcher requires fetch() to be available in your environment.');
    const defaultHeadersEntries = defaultHeaders != null ? Object.entries(defaultHeaders) : undefined;
    return async function(url, init) {
        const base = typeof service === 'function' ? service() : service;
        const fullUrl = new URL(url, base);
        const headers = (0, $9l95l.combineHeaders)(init.headers, defaultHeadersEntries);
        return fetch(fullUrl, {
            ...init,
            headers: headers
        });
    };
}

});




parcelRegister("8DB7o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ids = module.exports.lexicons = module.exports.schemas = module.exports.schemaDict = void 0;

var $3dCVT = parcelRequire("3dCVT");
module.exports.schemaDict = {
    ComAtprotoAdminDefs: {
        lexicon: 1,
        id: 'com.atproto.admin.defs',
        defs: {
            statusAttr: {
                type: 'object',
                required: [
                    'applied'
                ],
                properties: {
                    applied: {
                        type: 'boolean'
                    },
                    ref: {
                        type: 'string'
                    }
                }
            },
            accountView: {
                type: 'object',
                required: [
                    'did',
                    'handle',
                    'indexedAt'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    email: {
                        type: 'string'
                    },
                    relatedRecords: {
                        type: 'array',
                        items: {
                            type: 'unknown'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    invitedBy: {
                        type: 'ref',
                        ref: 'lex:com.atproto.server.defs#inviteCode'
                    },
                    invites: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.server.defs#inviteCode'
                        }
                    },
                    invitesDisabled: {
                        type: 'boolean'
                    },
                    emailConfirmedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    inviteNote: {
                        type: 'string'
                    },
                    deactivatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    threatSignatures: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.admin.defs#threatSignature'
                        }
                    }
                }
            },
            repoRef: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            repoBlobRef: {
                type: 'object',
                required: [
                    'did',
                    'cid'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    recordUri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            threatSignature: {
                type: 'object',
                required: [
                    'property',
                    'value'
                ],
                properties: {
                    property: {
                        type: 'string'
                    },
                    value: {
                        type: 'string'
                    }
                }
            }
        }
    },
    ComAtprotoAdminDeleteAccount: {
        lexicon: 1,
        id: 'com.atproto.admin.deleteAccount',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete a user account as an administrator.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminDisableAccountInvites: {
        lexicon: 1,
        id: 'com.atproto.admin.disableAccountInvites',
        defs: {
            main: {
                type: 'procedure',
                description: 'Disable an account from receiving new invite codes, but does not invalidate existing codes.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'account'
                        ],
                        properties: {
                            account: {
                                type: 'string',
                                format: 'did'
                            },
                            note: {
                                type: 'string',
                                description: 'Optional reason for disabled invites.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminDisableInviteCodes: {
        lexicon: 1,
        id: 'com.atproto.admin.disableInviteCodes',
        defs: {
            main: {
                type: 'procedure',
                description: 'Disable some set of codes and/or all codes associated with a set of users.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            codes: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            accounts: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminEnableAccountInvites: {
        lexicon: 1,
        id: 'com.atproto.admin.enableAccountInvites',
        defs: {
            main: {
                type: 'procedure',
                description: "Re-enable an account's ability to receive invite codes.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'account'
                        ],
                        properties: {
                            account: {
                                type: 'string',
                                format: 'did'
                            },
                            note: {
                                type: 'string',
                                description: 'Optional reason for enabled invites.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminGetAccountInfo: {
        lexicon: 1,
        id: 'com.atproto.admin.getAccountInfo',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about an account.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:com.atproto.admin.defs#accountView'
                    }
                }
            }
        }
    },
    ComAtprotoAdminGetAccountInfos: {
        lexicon: 1,
        id: 'com.atproto.admin.getAccountInfos',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about some accounts.',
                parameters: {
                    type: 'params',
                    required: [
                        'dids'
                    ],
                    properties: {
                        dids: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'infos'
                        ],
                        properties: {
                            infos: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.admin.defs#accountView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminGetInviteCodes: {
        lexicon: 1,
        id: 'com.atproto.admin.getInviteCodes',
        defs: {
            main: {
                type: 'query',
                description: 'Get an admin view of invite codes.',
                parameters: {
                    type: 'params',
                    properties: {
                        sort: {
                            type: 'string',
                            knownValues: [
                                'recent',
                                'usage'
                            ],
                            default: 'recent'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 500,
                            default: 100
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'codes'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            codes: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.server.defs#inviteCode'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminGetSubjectStatus: {
        lexicon: 1,
        id: 'com.atproto.admin.getSubjectStatus',
        defs: {
            main: {
                type: 'query',
                description: 'Get the service-specific admin status of a subject (account, record, or blob).',
                parameters: {
                    type: 'params',
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        },
                        uri: {
                            type: 'string',
                            format: 'at-uri'
                        },
                        blob: {
                            type: 'string',
                            format: 'cid'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject'
                        ],
                        properties: {
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef',
                                    'lex:com.atproto.admin.defs#repoBlobRef'
                                ]
                            },
                            takedown: {
                                type: 'ref',
                                ref: 'lex:com.atproto.admin.defs#statusAttr'
                            },
                            deactivated: {
                                type: 'ref',
                                ref: 'lex:com.atproto.admin.defs#statusAttr'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminSearchAccounts: {
        lexicon: 1,
        id: 'com.atproto.admin.searchAccounts',
        defs: {
            main: {
                type: 'query',
                description: 'Get list of accounts that matches your search query.',
                parameters: {
                    type: 'params',
                    properties: {
                        email: {
                            type: 'string'
                        },
                        cursor: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'accounts'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            accounts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.admin.defs#accountView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminSendEmail: {
        lexicon: 1,
        id: 'com.atproto.admin.sendEmail',
        defs: {
            main: {
                type: 'procedure',
                description: "Send email to a user's account email address.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'recipientDid',
                            'content',
                            'senderDid'
                        ],
                        properties: {
                            recipientDid: {
                                type: 'string',
                                format: 'did'
                            },
                            content: {
                                type: 'string'
                            },
                            subject: {
                                type: 'string'
                            },
                            senderDid: {
                                type: 'string',
                                format: 'did'
                            },
                            comment: {
                                type: 'string',
                                description: "Additional comment by the sender that won't be used in the email itself but helpful to provide more context for moderators/reviewers"
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'sent'
                        ],
                        properties: {
                            sent: {
                                type: 'boolean'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminUpdateAccountEmail: {
        lexicon: 1,
        id: 'com.atproto.admin.updateAccountEmail',
        defs: {
            main: {
                type: 'procedure',
                description: "Administrative action to update an account's email.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'account',
                            'email'
                        ],
                        properties: {
                            account: {
                                type: 'string',
                                format: 'at-identifier',
                                description: 'The handle or DID of the repo.'
                            },
                            email: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminUpdateAccountHandle: {
        lexicon: 1,
        id: 'com.atproto.admin.updateAccountHandle',
        defs: {
            main: {
                type: 'procedure',
                description: "Administrative action to update an account's handle.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'handle'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminUpdateAccountPassword: {
        lexicon: 1,
        id: 'com.atproto.admin.updateAccountPassword',
        defs: {
            main: {
                type: 'procedure',
                description: 'Update the password for a user account as an administrator.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'password'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            password: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminUpdateSubjectStatus: {
        lexicon: 1,
        id: 'com.atproto.admin.updateSubjectStatus',
        defs: {
            main: {
                type: 'procedure',
                description: 'Update the service-specific admin status of a subject (account, record, or blob).',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject'
                        ],
                        properties: {
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef',
                                    'lex:com.atproto.admin.defs#repoBlobRef'
                                ]
                            },
                            takedown: {
                                type: 'ref',
                                ref: 'lex:com.atproto.admin.defs#statusAttr'
                            },
                            deactivated: {
                                type: 'ref',
                                ref: 'lex:com.atproto.admin.defs#statusAttr'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject'
                        ],
                        properties: {
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef',
                                    'lex:com.atproto.admin.defs#repoBlobRef'
                                ]
                            },
                            takedown: {
                                type: 'ref',
                                ref: 'lex:com.atproto.admin.defs#statusAttr'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoIdentityGetRecommendedDidCredentials: {
        lexicon: 1,
        id: 'com.atproto.identity.getRecommendedDidCredentials',
        defs: {
            main: {
                type: 'query',
                description: 'Describe the credentials that should be included in the DID doc of an account that is migrating to this service.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            rotationKeys: {
                                description: 'Recommended rotation keys for PLC dids. Should be undefined (or ignored) for did:webs.',
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            alsoKnownAs: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            verificationMethods: {
                                type: 'unknown'
                            },
                            services: {
                                type: 'unknown'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoIdentityRequestPlcOperationSignature: {
        lexicon: 1,
        id: 'com.atproto.identity.requestPlcOperationSignature',
        defs: {
            main: {
                type: 'procedure',
                description: 'Request an email with a code to in order to request a signed PLC operation. Requires Auth.'
            }
        }
    },
    ComAtprotoIdentityResolveHandle: {
        lexicon: 1,
        id: 'com.atproto.identity.resolveHandle',
        defs: {
            main: {
                type: 'query',
                description: 'Resolves a handle (domain name) to a DID.',
                parameters: {
                    type: 'params',
                    required: [
                        'handle'
                    ],
                    properties: {
                        handle: {
                            type: 'string',
                            format: 'handle',
                            description: 'The handle to resolve.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoIdentitySignPlcOperation: {
        lexicon: 1,
        id: 'com.atproto.identity.signPlcOperation',
        defs: {
            main: {
                type: 'procedure',
                description: "Signs a PLC operation to update some value(s) in the requesting DID's document.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            token: {
                                description: 'A token received through com.atproto.identity.requestPlcOperationSignature',
                                type: 'string'
                            },
                            rotationKeys: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            alsoKnownAs: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            verificationMethods: {
                                type: 'unknown'
                            },
                            services: {
                                type: 'unknown'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'operation'
                        ],
                        properties: {
                            operation: {
                                type: 'unknown',
                                description: 'A signed DID PLC operation.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoIdentitySubmitPlcOperation: {
        lexicon: 1,
        id: 'com.atproto.identity.submitPlcOperation',
        defs: {
            main: {
                type: 'procedure',
                description: "Validates a PLC operation to ensure that it doesn't violate a service's constraints or get the identity into a bad state, then submits it to the PLC registry",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'operation'
                        ],
                        properties: {
                            operation: {
                                type: 'unknown'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoIdentityUpdateHandle: {
        lexicon: 1,
        id: 'com.atproto.identity.updateHandle',
        defs: {
            main: {
                type: 'procedure',
                description: "Updates the current account's handle. Verifies handle validity, and updates did:plc document if necessary. Implemented by PDS, and requires auth.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'handle'
                        ],
                        properties: {
                            handle: {
                                type: 'string',
                                format: 'handle',
                                description: 'The new handle.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoLabelDefs: {
        lexicon: 1,
        id: 'com.atproto.label.defs',
        defs: {
            label: {
                type: 'object',
                description: 'Metadata tag on an atproto resource (eg, repo or record).',
                required: [
                    'src',
                    'uri',
                    'val',
                    'cts'
                ],
                properties: {
                    ver: {
                        type: 'integer',
                        description: 'The AT Protocol version of the label object.'
                    },
                    src: {
                        type: 'string',
                        format: 'did',
                        description: 'DID of the actor who created this label.'
                    },
                    uri: {
                        type: 'string',
                        format: 'uri',
                        description: 'AT URI of the record, repository (account), or other resource that this label applies to.'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid',
                        description: "Optionally, CID specifying the specific version of 'uri' resource this label applies to."
                    },
                    val: {
                        type: 'string',
                        maxLength: 128,
                        description: 'The short string name of the value or type of this label.'
                    },
                    neg: {
                        type: 'boolean',
                        description: 'If true, this is a negation label, overwriting a previous label.'
                    },
                    cts: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp when this label was created.'
                    },
                    exp: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp at which this label expires (no longer applies).'
                    },
                    sig: {
                        type: 'bytes',
                        description: 'Signature of dag-cbor encoded label.'
                    }
                }
            },
            selfLabels: {
                type: 'object',
                description: 'Metadata tags on an atproto record, published by the author within the record.',
                required: [
                    'values'
                ],
                properties: {
                    values: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#selfLabel'
                        },
                        maxLength: 10
                    }
                }
            },
            selfLabel: {
                type: 'object',
                description: 'Metadata tag on an atproto record, published by the author within the record. Note that schemas should use #selfLabels, not #selfLabel.',
                required: [
                    'val'
                ],
                properties: {
                    val: {
                        type: 'string',
                        maxLength: 128,
                        description: 'The short string name of the value or type of this label.'
                    }
                }
            },
            labelValueDefinition: {
                type: 'object',
                description: 'Declares a label value and its expected interpretations and behaviors.',
                required: [
                    'identifier',
                    'severity',
                    'blurs',
                    'locales'
                ],
                properties: {
                    identifier: {
                        type: 'string',
                        description: "The value of the label being defined. Must only include lowercase ascii and the '-' character ([a-z-]+).",
                        maxLength: 100,
                        maxGraphemes: 100
                    },
                    severity: {
                        type: 'string',
                        description: "How should a client visually convey this label? 'inform' means neutral and informational; 'alert' means negative and warning; 'none' means show nothing.",
                        knownValues: [
                            'inform',
                            'alert',
                            'none'
                        ]
                    },
                    blurs: {
                        type: 'string',
                        description: "What should this label hide in the UI, if applied? 'content' hides all of the target; 'media' hides the images/video/audio; 'none' hides nothing.",
                        knownValues: [
                            'content',
                            'media',
                            'none'
                        ]
                    },
                    defaultSetting: {
                        type: 'string',
                        description: 'The default setting for this label.',
                        knownValues: [
                            'ignore',
                            'warn',
                            'hide'
                        ],
                        default: 'warn'
                    },
                    adultOnly: {
                        type: 'boolean',
                        description: 'Does the user need to have adult content enabled in order to configure this label?'
                    },
                    locales: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#labelValueDefinitionStrings'
                        }
                    }
                }
            },
            labelValueDefinitionStrings: {
                type: 'object',
                description: 'Strings which describe the label in the UI, localized into a specific language.',
                required: [
                    'lang',
                    'name',
                    'description'
                ],
                properties: {
                    lang: {
                        type: 'string',
                        description: 'The code of the language these strings are written in.',
                        format: 'language'
                    },
                    name: {
                        type: 'string',
                        description: 'A short human-readable name for the label.',
                        maxGraphemes: 64,
                        maxLength: 640
                    },
                    description: {
                        type: 'string',
                        description: 'A longer description of what the label means and why it might be applied.',
                        maxGraphemes: 10000,
                        maxLength: 100000
                    }
                }
            },
            labelValue: {
                type: 'string',
                knownValues: [
                    '!hide',
                    '!no-promote',
                    '!warn',
                    '!no-unauthenticated',
                    'dmca-violation',
                    'doxxing',
                    'porn',
                    'sexual',
                    'nudity',
                    'nsfl',
                    'gore'
                ]
            }
        }
    },
    ComAtprotoLabelQueryLabels: {
        lexicon: 1,
        id: 'com.atproto.label.queryLabels',
        defs: {
            main: {
                type: 'query',
                description: 'Find labels relevant to the provided AT-URI patterns. Public endpoint for moderation services, though may return different or additional results with auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'uriPatterns'
                    ],
                    properties: {
                        uriPatterns: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: "List of AT URI patterns to match (boolean 'OR'). Each may be a prefix (ending with '*'; will match inclusive of the string leading to '*'), or a full URI."
                        },
                        sources: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'did'
                            },
                            description: 'Optional list of label sources (DIDs) to filter on.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 250,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'labels'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            labels: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.label.defs#label'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoLabelSubscribeLabels: {
        lexicon: 1,
        id: 'com.atproto.label.subscribeLabels',
        defs: {
            main: {
                type: 'subscription',
                description: 'Subscribe to stream of labels (and negations). Public endpoint implemented by mod services. Uses same sequencing scheme as repo event stream.',
                parameters: {
                    type: 'params',
                    properties: {
                        cursor: {
                            type: 'integer',
                            description: 'The last known event seq number to backfill from.'
                        }
                    }
                },
                message: {
                    schema: {
                        type: 'union',
                        refs: [
                            'lex:com.atproto.label.subscribeLabels#labels',
                            'lex:com.atproto.label.subscribeLabels#info'
                        ]
                    }
                },
                errors: [
                    {
                        name: 'FutureCursor'
                    }
                ]
            },
            labels: {
                type: 'object',
                required: [
                    'seq',
                    'labels'
                ],
                properties: {
                    seq: {
                        type: 'integer'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    }
                }
            },
            info: {
                type: 'object',
                required: [
                    'name'
                ],
                properties: {
                    name: {
                        type: 'string',
                        knownValues: [
                            'OutdatedCursor'
                        ]
                    },
                    message: {
                        type: 'string'
                    }
                }
            }
        }
    },
    ComAtprotoLexiconSchema: {
        lexicon: 1,
        id: 'com.atproto.lexicon.schema',
        defs: {
            main: {
                type: 'record',
                description: "Representation of Lexicon schemas themselves, when published as atproto records. Note that the schema language is not defined in Lexicon; this meta schema currently only includes a single version field ('lexicon'). See the atproto specifications for description of the other expected top-level fields ('id', 'defs', etc).",
                key: 'nsid',
                record: {
                    type: 'object',
                    required: [
                        'lexicon'
                    ],
                    properties: {
                        lexicon: {
                            type: 'integer',
                            description: "Indicates the 'version' of the Lexicon language. Must be '1' for the current atproto/Lexicon schema system."
                        }
                    }
                }
            }
        }
    },
    ComAtprotoModerationCreateReport: {
        lexicon: 1,
        id: 'com.atproto.moderation.createReport',
        defs: {
            main: {
                type: 'procedure',
                description: 'Submit a moderation report regarding an atproto account or record. Implemented by moderation services (with PDS proxying), and requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'reasonType',
                            'subject'
                        ],
                        properties: {
                            reasonType: {
                                type: 'ref',
                                description: 'Indicates the broad category of violation the report is for.',
                                ref: 'lex:com.atproto.moderation.defs#reasonType'
                            },
                            reason: {
                                type: 'string',
                                maxGraphemes: 2000,
                                maxLength: 20000,
                                description: 'Additional context about the content and violation.'
                            },
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'id',
                            'reasonType',
                            'subject',
                            'reportedBy',
                            'createdAt'
                        ],
                        properties: {
                            id: {
                                type: 'integer'
                            },
                            reasonType: {
                                type: 'ref',
                                ref: 'lex:com.atproto.moderation.defs#reasonType'
                            },
                            reason: {
                                type: 'string',
                                maxGraphemes: 2000,
                                maxLength: 20000
                            },
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef'
                                ]
                            },
                            reportedBy: {
                                type: 'string',
                                format: 'did'
                            },
                            createdAt: {
                                type: 'string',
                                format: 'datetime'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoModerationDefs: {
        lexicon: 1,
        id: 'com.atproto.moderation.defs',
        defs: {
            reasonType: {
                type: 'string',
                knownValues: [
                    'com.atproto.moderation.defs#reasonSpam',
                    'com.atproto.moderation.defs#reasonViolation',
                    'com.atproto.moderation.defs#reasonMisleading',
                    'com.atproto.moderation.defs#reasonSexual',
                    'com.atproto.moderation.defs#reasonRude',
                    'com.atproto.moderation.defs#reasonOther',
                    'com.atproto.moderation.defs#reasonAppeal'
                ]
            },
            reasonSpam: {
                type: 'token',
                description: 'Spam: frequent unwanted promotion, replies, mentions'
            },
            reasonViolation: {
                type: 'token',
                description: 'Direct violation of server rules, laws, terms of service'
            },
            reasonMisleading: {
                type: 'token',
                description: 'Misleading identity, affiliation, or content'
            },
            reasonSexual: {
                type: 'token',
                description: 'Unwanted or mislabeled sexual content'
            },
            reasonRude: {
                type: 'token',
                description: 'Rude, harassing, explicit, or otherwise unwelcoming behavior'
            },
            reasonOther: {
                type: 'token',
                description: 'Other: reports not falling under another report category'
            },
            reasonAppeal: {
                type: 'token',
                description: 'Appeal: appeal a previously taken moderation action'
            }
        }
    },
    ComAtprotoRepoApplyWrites: {
        lexicon: 1,
        id: 'com.atproto.repo.applyWrites',
        defs: {
            main: {
                type: 'procedure',
                description: 'Apply a batch transaction of repository creates, updates, and deletes. Requires auth, implemented by PDS.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repo',
                            'writes'
                        ],
                        properties: {
                            repo: {
                                type: 'string',
                                format: 'at-identifier',
                                description: 'The handle or DID of the repo (aka, current account).'
                            },
                            validate: {
                                type: 'boolean',
                                description: "Can be set to 'false' to skip Lexicon schema validation of record data across all operations, 'true' to require it, or leave unset to validate only for known Lexicons."
                            },
                            writes: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:com.atproto.repo.applyWrites#create',
                                        'lex:com.atproto.repo.applyWrites#update',
                                        'lex:com.atproto.repo.applyWrites#delete'
                                    ],
                                    closed: true
                                }
                            },
                            swapCommit: {
                                type: 'string',
                                description: 'If provided, the entire operation will fail if the current repo commit CID does not match this value. Used to prevent conflicting repo mutations.',
                                format: 'cid'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [],
                        properties: {
                            commit: {
                                type: 'ref',
                                ref: 'lex:com.atproto.repo.defs#commitMeta'
                            },
                            results: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:com.atproto.repo.applyWrites#createResult',
                                        'lex:com.atproto.repo.applyWrites#updateResult',
                                        'lex:com.atproto.repo.applyWrites#deleteResult'
                                    ],
                                    closed: true
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidSwap',
                        description: "Indicates that the 'swapCommit' parameter did not match current commit."
                    }
                ]
            },
            create: {
                type: 'object',
                description: 'Operation which creates a new record.',
                required: [
                    'collection',
                    'value'
                ],
                properties: {
                    collection: {
                        type: 'string',
                        format: 'nsid'
                    },
                    rkey: {
                        type: 'string',
                        maxLength: 512
                    },
                    value: {
                        type: 'unknown'
                    }
                }
            },
            update: {
                type: 'object',
                description: 'Operation which updates an existing record.',
                required: [
                    'collection',
                    'rkey',
                    'value'
                ],
                properties: {
                    collection: {
                        type: 'string',
                        format: 'nsid'
                    },
                    rkey: {
                        type: 'string'
                    },
                    value: {
                        type: 'unknown'
                    }
                }
            },
            delete: {
                type: 'object',
                description: 'Operation which deletes an existing record.',
                required: [
                    'collection',
                    'rkey'
                ],
                properties: {
                    collection: {
                        type: 'string',
                        format: 'nsid'
                    },
                    rkey: {
                        type: 'string'
                    }
                }
            },
            createResult: {
                type: 'object',
                required: [
                    'uri',
                    'cid'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    validationStatus: {
                        type: 'string',
                        knownValues: [
                            'valid',
                            'unknown'
                        ]
                    }
                }
            },
            updateResult: {
                type: 'object',
                required: [
                    'uri',
                    'cid'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    validationStatus: {
                        type: 'string',
                        knownValues: [
                            'valid',
                            'unknown'
                        ]
                    }
                }
            },
            deleteResult: {
                type: 'object',
                required: [],
                properties: {}
            }
        }
    },
    ComAtprotoRepoCreateRecord: {
        lexicon: 1,
        id: 'com.atproto.repo.createRecord',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create a single new repository record. Requires auth, implemented by PDS.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repo',
                            'collection',
                            'record'
                        ],
                        properties: {
                            repo: {
                                type: 'string',
                                format: 'at-identifier',
                                description: 'The handle or DID of the repo (aka, current account).'
                            },
                            collection: {
                                type: 'string',
                                format: 'nsid',
                                description: 'The NSID of the record collection.'
                            },
                            rkey: {
                                type: 'string',
                                description: 'The Record Key.',
                                maxLength: 512
                            },
                            validate: {
                                type: 'boolean',
                                description: "Can be set to 'false' to skip Lexicon schema validation of record data, 'true' to require it, or leave unset to validate only for known Lexicons."
                            },
                            record: {
                                type: 'unknown',
                                description: 'The record itself. Must contain a $type field.'
                            },
                            swapCommit: {
                                type: 'string',
                                format: 'cid',
                                description: 'Compare and swap with the previous commit by CID.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'cid'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            commit: {
                                type: 'ref',
                                ref: 'lex:com.atproto.repo.defs#commitMeta'
                            },
                            validationStatus: {
                                type: 'string',
                                knownValues: [
                                    'valid',
                                    'unknown'
                                ]
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidSwap',
                        description: "Indicates that 'swapCommit' didn't match current repo commit."
                    }
                ]
            }
        }
    },
    ComAtprotoRepoDefs: {
        lexicon: 1,
        id: 'com.atproto.repo.defs',
        defs: {
            commitMeta: {
                type: 'object',
                required: [
                    'cid',
                    'rev'
                ],
                properties: {
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    rev: {
                        type: 'string'
                    }
                }
            }
        }
    },
    ComAtprotoRepoDeleteRecord: {
        lexicon: 1,
        id: 'com.atproto.repo.deleteRecord',
        defs: {
            main: {
                type: 'procedure',
                description: "Delete a repository record, or ensure it doesn't exist. Requires auth, implemented by PDS.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repo',
                            'collection',
                            'rkey'
                        ],
                        properties: {
                            repo: {
                                type: 'string',
                                format: 'at-identifier',
                                description: 'The handle or DID of the repo (aka, current account).'
                            },
                            collection: {
                                type: 'string',
                                format: 'nsid',
                                description: 'The NSID of the record collection.'
                            },
                            rkey: {
                                type: 'string',
                                description: 'The Record Key.'
                            },
                            swapRecord: {
                                type: 'string',
                                format: 'cid',
                                description: 'Compare and swap with the previous record by CID.'
                            },
                            swapCommit: {
                                type: 'string',
                                format: 'cid',
                                description: 'Compare and swap with the previous commit by CID.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            commit: {
                                type: 'ref',
                                ref: 'lex:com.atproto.repo.defs#commitMeta'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidSwap'
                    }
                ]
            }
        }
    },
    ComAtprotoRepoDescribeRepo: {
        lexicon: 1,
        id: 'com.atproto.repo.describeRepo',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about an account and repository, including the list of collections. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'repo'
                    ],
                    properties: {
                        repo: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'The handle or DID of the repo.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'handle',
                            'did',
                            'didDoc',
                            'collections',
                            'handleIsCorrect'
                        ],
                        properties: {
                            handle: {
                                type: 'string',
                                format: 'handle'
                            },
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            didDoc: {
                                type: 'unknown',
                                description: 'The complete DID document for this account.'
                            },
                            collections: {
                                type: 'array',
                                description: 'List of all the collections (NSIDs) for which this repo contains at least one record.',
                                items: {
                                    type: 'string',
                                    format: 'nsid'
                                }
                            },
                            handleIsCorrect: {
                                type: 'boolean',
                                description: 'Indicates if handle is currently valid (resolves bi-directionally)'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoRepoGetRecord: {
        lexicon: 1,
        id: 'com.atproto.repo.getRecord',
        defs: {
            main: {
                type: 'query',
                description: 'Get a single record from a repository. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'repo',
                        'collection',
                        'rkey'
                    ],
                    properties: {
                        repo: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'The handle or DID of the repo.'
                        },
                        collection: {
                            type: 'string',
                            format: 'nsid',
                            description: 'The NSID of the record collection.'
                        },
                        rkey: {
                            type: 'string',
                            description: 'The Record Key.'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid',
                            description: 'The CID of the version of the record. If not specified, then return the most recent version.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'value'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            value: {
                                type: 'unknown'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'RecordNotFound'
                    }
                ]
            }
        }
    },
    ComAtprotoRepoImportRepo: {
        lexicon: 1,
        id: 'com.atproto.repo.importRepo',
        defs: {
            main: {
                type: 'procedure',
                description: 'Import a repo in the form of a CAR file. Requires Content-Length HTTP header to be set.',
                input: {
                    encoding: 'application/vnd.ipld.car'
                }
            }
        }
    },
    ComAtprotoRepoListMissingBlobs: {
        lexicon: 1,
        id: 'com.atproto.repo.listMissingBlobs',
        defs: {
            main: {
                type: 'query',
                description: 'Returns a list of missing blobs for the requesting account. Intended to be used in the account migration flow.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 1000,
                            default: 500
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'blobs'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            blobs: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.repo.listMissingBlobs#recordBlob'
                                }
                            }
                        }
                    }
                }
            },
            recordBlob: {
                type: 'object',
                required: [
                    'cid',
                    'recordUri'
                ],
                properties: {
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    recordUri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            }
        }
    },
    ComAtprotoRepoListRecords: {
        lexicon: 1,
        id: 'com.atproto.repo.listRecords',
        defs: {
            main: {
                type: 'query',
                description: 'List a range of records in a repository, matching a specific collection. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'repo',
                        'collection'
                    ],
                    properties: {
                        repo: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'The handle or DID of the repo.'
                        },
                        collection: {
                            type: 'string',
                            format: 'nsid',
                            description: 'The NSID of the record type.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50,
                            description: 'The number of records to return.'
                        },
                        cursor: {
                            type: 'string'
                        },
                        rkeyStart: {
                            type: 'string',
                            description: 'DEPRECATED: The lowest sort-ordered rkey to start from (exclusive)'
                        },
                        rkeyEnd: {
                            type: 'string',
                            description: 'DEPRECATED: The highest sort-ordered rkey to stop at (exclusive)'
                        },
                        reverse: {
                            type: 'boolean',
                            description: 'Flag to reverse the order of the returned records.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'records'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            records: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.repo.listRecords#record'
                                }
                            }
                        }
                    }
                }
            },
            record: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'value'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    value: {
                        type: 'unknown'
                    }
                }
            }
        }
    },
    ComAtprotoRepoPutRecord: {
        lexicon: 1,
        id: 'com.atproto.repo.putRecord',
        defs: {
            main: {
                type: 'procedure',
                description: 'Write a repository record, creating or updating it as needed. Requires auth, implemented by PDS.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repo',
                            'collection',
                            'rkey',
                            'record'
                        ],
                        nullable: [
                            'swapRecord'
                        ],
                        properties: {
                            repo: {
                                type: 'string',
                                format: 'at-identifier',
                                description: 'The handle or DID of the repo (aka, current account).'
                            },
                            collection: {
                                type: 'string',
                                format: 'nsid',
                                description: 'The NSID of the record collection.'
                            },
                            rkey: {
                                type: 'string',
                                description: 'The Record Key.',
                                maxLength: 512
                            },
                            validate: {
                                type: 'boolean',
                                description: "Can be set to 'false' to skip Lexicon schema validation of record data, 'true' to require it, or leave unset to validate only for known Lexicons."
                            },
                            record: {
                                type: 'unknown',
                                description: 'The record to write.'
                            },
                            swapRecord: {
                                type: 'string',
                                format: 'cid',
                                description: 'Compare and swap with the previous record by CID. WARNING: nullable and optional field; may cause problems with golang implementation'
                            },
                            swapCommit: {
                                type: 'string',
                                format: 'cid',
                                description: 'Compare and swap with the previous commit by CID.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'cid'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            commit: {
                                type: 'ref',
                                ref: 'lex:com.atproto.repo.defs#commitMeta'
                            },
                            validationStatus: {
                                type: 'string',
                                knownValues: [
                                    'valid',
                                    'unknown'
                                ]
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidSwap'
                    }
                ]
            }
        }
    },
    ComAtprotoRepoStrongRef: {
        lexicon: 1,
        id: 'com.atproto.repo.strongRef',
        description: 'A URI with a content-hash fingerprint.',
        defs: {
            main: {
                type: 'object',
                required: [
                    'uri',
                    'cid'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    }
                }
            }
        }
    },
    ComAtprotoRepoUploadBlob: {
        lexicon: 1,
        id: 'com.atproto.repo.uploadBlob',
        defs: {
            main: {
                type: 'procedure',
                description: 'Upload a new blob, to be referenced from a repository record. The blob will be deleted if it is not referenced within a time window (eg, minutes). Blob restrictions (mimetype, size, etc) are enforced when the reference is created. Requires auth, implemented by PDS.',
                input: {
                    encoding: '*/*'
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'blob'
                        ],
                        properties: {
                            blob: {
                                type: 'blob'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerActivateAccount: {
        lexicon: 1,
        id: 'com.atproto.server.activateAccount',
        defs: {
            main: {
                type: 'procedure',
                description: "Activates a currently deactivated account. Used to finalize account migration after the account's repo is imported and identity is setup."
            }
        }
    },
    ComAtprotoServerCheckAccountStatus: {
        lexicon: 1,
        id: 'com.atproto.server.checkAccountStatus',
        defs: {
            main: {
                type: 'query',
                description: 'Returns the status of an account, especially as pertaining to import or recovery. Can be called many times over the course of an account migration. Requires auth and can only be called pertaining to oneself.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'activated',
                            'validDid',
                            'repoCommit',
                            'repoRev',
                            'repoBlocks',
                            'indexedRecords',
                            'privateStateValues',
                            'expectedBlobs',
                            'importedBlobs'
                        ],
                        properties: {
                            activated: {
                                type: 'boolean'
                            },
                            validDid: {
                                type: 'boolean'
                            },
                            repoCommit: {
                                type: 'string',
                                format: 'cid'
                            },
                            repoRev: {
                                type: 'string'
                            },
                            repoBlocks: {
                                type: 'integer'
                            },
                            indexedRecords: {
                                type: 'integer'
                            },
                            privateStateValues: {
                                type: 'integer'
                            },
                            expectedBlobs: {
                                type: 'integer'
                            },
                            importedBlobs: {
                                type: 'integer'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerConfirmEmail: {
        lexicon: 1,
        id: 'com.atproto.server.confirmEmail',
        defs: {
            main: {
                type: 'procedure',
                description: 'Confirm an email using a token from com.atproto.server.requestEmailConfirmation.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'email',
                            'token'
                        ],
                        properties: {
                            email: {
                                type: 'string'
                            },
                            token: {
                                type: 'string'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'AccountNotFound'
                    },
                    {
                        name: 'ExpiredToken'
                    },
                    {
                        name: 'InvalidToken'
                    },
                    {
                        name: 'InvalidEmail'
                    }
                ]
            }
        }
    },
    ComAtprotoServerCreateAccount: {
        lexicon: 1,
        id: 'com.atproto.server.createAccount',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create an account. Implemented by PDS.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'handle'
                        ],
                        properties: {
                            email: {
                                type: 'string'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle',
                                description: 'Requested handle for the account.'
                            },
                            did: {
                                type: 'string',
                                format: 'did',
                                description: 'Pre-existing atproto DID, being imported to a new account.'
                            },
                            inviteCode: {
                                type: 'string'
                            },
                            verificationCode: {
                                type: 'string'
                            },
                            verificationPhone: {
                                type: 'string'
                            },
                            password: {
                                type: 'string',
                                description: 'Initial account password. May need to meet instance-specific password strength requirements.'
                            },
                            recoveryKey: {
                                type: 'string',
                                description: 'DID PLC rotation key (aka, recovery key) to be included in PLC creation operation.'
                            },
                            plcOp: {
                                type: 'unknown',
                                description: 'A signed DID PLC operation to be submitted as part of importing an existing account to this instance. NOTE: this optional field may be updated when full account migration is implemented.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        description: 'Account login session returned on successful account creation.',
                        required: [
                            'accessJwt',
                            'refreshJwt',
                            'handle',
                            'did'
                        ],
                        properties: {
                            accessJwt: {
                                type: 'string'
                            },
                            refreshJwt: {
                                type: 'string'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle'
                            },
                            did: {
                                type: 'string',
                                format: 'did',
                                description: 'The DID of the new account.'
                            },
                            didDoc: {
                                type: 'unknown',
                                description: 'Complete DID document.'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidHandle'
                    },
                    {
                        name: 'InvalidPassword'
                    },
                    {
                        name: 'InvalidInviteCode'
                    },
                    {
                        name: 'HandleNotAvailable'
                    },
                    {
                        name: 'UnsupportedDomain'
                    },
                    {
                        name: 'UnresolvableDid'
                    },
                    {
                        name: 'IncompatibleDidDoc'
                    }
                ]
            }
        }
    },
    ComAtprotoServerCreateAppPassword: {
        lexicon: 1,
        id: 'com.atproto.server.createAppPassword',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create an App Password.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'name'
                        ],
                        properties: {
                            name: {
                                type: 'string',
                                description: 'A short name for the App Password, to help distinguish them.'
                            },
                            privileged: {
                                type: 'boolean',
                                description: "If an app password has 'privileged' access to possibly sensitive account state. Meant for use with trusted clients."
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:com.atproto.server.createAppPassword#appPassword'
                    }
                },
                errors: [
                    {
                        name: 'AccountTakedown'
                    }
                ]
            },
            appPassword: {
                type: 'object',
                required: [
                    'name',
                    'password',
                    'createdAt'
                ],
                properties: {
                    name: {
                        type: 'string'
                    },
                    password: {
                        type: 'string'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    privileged: {
                        type: 'boolean'
                    }
                }
            }
        }
    },
    ComAtprotoServerCreateInviteCode: {
        lexicon: 1,
        id: 'com.atproto.server.createInviteCode',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create an invite code.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'useCount'
                        ],
                        properties: {
                            useCount: {
                                type: 'integer'
                            },
                            forAccount: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'code'
                        ],
                        properties: {
                            code: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerCreateInviteCodes: {
        lexicon: 1,
        id: 'com.atproto.server.createInviteCodes',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create invite codes.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'codeCount',
                            'useCount'
                        ],
                        properties: {
                            codeCount: {
                                type: 'integer',
                                default: 1
                            },
                            useCount: {
                                type: 'integer'
                            },
                            forAccounts: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                    format: 'did'
                                }
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'codes'
                        ],
                        properties: {
                            codes: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.server.createInviteCodes#accountCodes'
                                }
                            }
                        }
                    }
                }
            },
            accountCodes: {
                type: 'object',
                required: [
                    'account',
                    'codes'
                ],
                properties: {
                    account: {
                        type: 'string'
                    },
                    codes: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerCreateSession: {
        lexicon: 1,
        id: 'com.atproto.server.createSession',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create an authentication session.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'identifier',
                            'password'
                        ],
                        properties: {
                            identifier: {
                                type: 'string',
                                description: 'Handle or other identifier supported by the server for the authenticating user.'
                            },
                            password: {
                                type: 'string'
                            },
                            authFactorToken: {
                                type: 'string'
                            },
                            allowTakendown: {
                                type: 'boolean',
                                description: 'When true, instead of throwing error for takendown accounts, a valid response with a narrow scoped token will be returned'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'accessJwt',
                            'refreshJwt',
                            'handle',
                            'did'
                        ],
                        properties: {
                            accessJwt: {
                                type: 'string'
                            },
                            refreshJwt: {
                                type: 'string'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle'
                            },
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            didDoc: {
                                type: 'unknown'
                            },
                            email: {
                                type: 'string'
                            },
                            emailConfirmed: {
                                type: 'boolean'
                            },
                            emailAuthFactor: {
                                type: 'boolean'
                            },
                            active: {
                                type: 'boolean'
                            },
                            status: {
                                type: 'string',
                                description: 'If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.',
                                knownValues: [
                                    'takendown',
                                    'suspended',
                                    'deactivated'
                                ]
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'AccountTakedown'
                    },
                    {
                        name: 'AuthFactorTokenRequired'
                    }
                ]
            }
        }
    },
    ComAtprotoServerDeactivateAccount: {
        lexicon: 1,
        id: 'com.atproto.server.deactivateAccount',
        defs: {
            main: {
                type: 'procedure',
                description: 'Deactivates a currently active account. Stops serving of repo, and future writes to repo until reactivated. Used to finalize account migration with the old host after the account has been activated on the new host.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            deleteAfter: {
                                type: 'string',
                                format: 'datetime',
                                description: 'A recommendation to server as to how long they should hold onto the deactivated account before deleting.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerDefs: {
        lexicon: 1,
        id: 'com.atproto.server.defs',
        defs: {
            inviteCode: {
                type: 'object',
                required: [
                    'code',
                    'available',
                    'disabled',
                    'forAccount',
                    'createdBy',
                    'createdAt',
                    'uses'
                ],
                properties: {
                    code: {
                        type: 'string'
                    },
                    available: {
                        type: 'integer'
                    },
                    disabled: {
                        type: 'boolean'
                    },
                    forAccount: {
                        type: 'string'
                    },
                    createdBy: {
                        type: 'string'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    uses: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.server.defs#inviteCodeUse'
                        }
                    }
                }
            },
            inviteCodeUse: {
                type: 'object',
                required: [
                    'usedBy',
                    'usedAt'
                ],
                properties: {
                    usedBy: {
                        type: 'string',
                        format: 'did'
                    },
                    usedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            }
        }
    },
    ComAtprotoServerDeleteAccount: {
        lexicon: 1,
        id: 'com.atproto.server.deleteAccount',
        defs: {
            main: {
                type: 'procedure',
                description: "Delete an actor's account with a token and password. Can only be called after requesting a deletion token. Requires auth.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'password',
                            'token'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            password: {
                                type: 'string'
                            },
                            token: {
                                type: 'string'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'ExpiredToken'
                    },
                    {
                        name: 'InvalidToken'
                    }
                ]
            }
        }
    },
    ComAtprotoServerDeleteSession: {
        lexicon: 1,
        id: 'com.atproto.server.deleteSession',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete the current session. Requires auth.'
            }
        }
    },
    ComAtprotoServerDescribeServer: {
        lexicon: 1,
        id: 'com.atproto.server.describeServer',
        defs: {
            main: {
                type: 'query',
                description: "Describes the server's account creation requirements and capabilities. Implemented by PDS.",
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'availableUserDomains'
                        ],
                        properties: {
                            inviteCodeRequired: {
                                type: 'boolean',
                                description: 'If true, an invite code must be supplied to create an account on this instance.'
                            },
                            phoneVerificationRequired: {
                                type: 'boolean',
                                description: 'If true, a phone verification token must be supplied to create an account on this instance.'
                            },
                            availableUserDomains: {
                                type: 'array',
                                description: 'List of domain suffixes that can be used in account handles.',
                                items: {
                                    type: 'string'
                                }
                            },
                            links: {
                                type: 'ref',
                                description: 'URLs of service policy documents.',
                                ref: 'lex:com.atproto.server.describeServer#links'
                            },
                            contact: {
                                type: 'ref',
                                description: 'Contact information',
                                ref: 'lex:com.atproto.server.describeServer#contact'
                            },
                            did: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                }
            },
            links: {
                type: 'object',
                properties: {
                    privacyPolicy: {
                        type: 'string',
                        format: 'uri'
                    },
                    termsOfService: {
                        type: 'string',
                        format: 'uri'
                    }
                }
            },
            contact: {
                type: 'object',
                properties: {
                    email: {
                        type: 'string'
                    }
                }
            }
        }
    },
    ComAtprotoServerGetAccountInviteCodes: {
        lexicon: 1,
        id: 'com.atproto.server.getAccountInviteCodes',
        defs: {
            main: {
                type: 'query',
                description: 'Get all invite codes for the current account. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        includeUsed: {
                            type: 'boolean',
                            default: true
                        },
                        createAvailable: {
                            type: 'boolean',
                            default: true,
                            description: "Controls whether any new 'earned' but not 'created' invites should be created."
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'codes'
                        ],
                        properties: {
                            codes: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.server.defs#inviteCode'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'DuplicateCreate'
                    }
                ]
            }
        }
    },
    ComAtprotoServerGetServiceAuth: {
        lexicon: 1,
        id: 'com.atproto.server.getServiceAuth',
        defs: {
            main: {
                type: 'query',
                description: 'Get a signed token on behalf of the requesting DID for the requested service.',
                parameters: {
                    type: 'params',
                    required: [
                        'aud'
                    ],
                    properties: {
                        aud: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the service that the token will be used to authenticate with'
                        },
                        exp: {
                            type: 'integer',
                            description: 'The time in Unix Epoch seconds that the JWT expires. Defaults to 60 seconds in the future. The service may enforce certain time bounds on tokens depending on the requested scope.'
                        },
                        lxm: {
                            type: 'string',
                            format: 'nsid',
                            description: 'Lexicon (XRPC) method to bind the requested token to'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'token'
                        ],
                        properties: {
                            token: {
                                type: 'string'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BadExpiration',
                        description: 'Indicates that the requested expiration date is not a valid. May be in the past or may be reliant on the requested scopes.'
                    }
                ]
            }
        }
    },
    ComAtprotoServerGetSession: {
        lexicon: 1,
        id: 'com.atproto.server.getSession',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about the current auth session. Requires auth.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'handle',
                            'did'
                        ],
                        properties: {
                            handle: {
                                type: 'string',
                                format: 'handle'
                            },
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            email: {
                                type: 'string'
                            },
                            emailConfirmed: {
                                type: 'boolean'
                            },
                            emailAuthFactor: {
                                type: 'boolean'
                            },
                            didDoc: {
                                type: 'unknown'
                            },
                            active: {
                                type: 'boolean'
                            },
                            status: {
                                type: 'string',
                                description: 'If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.',
                                knownValues: [
                                    'takendown',
                                    'suspended',
                                    'deactivated'
                                ]
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerListAppPasswords: {
        lexicon: 1,
        id: 'com.atproto.server.listAppPasswords',
        defs: {
            main: {
                type: 'query',
                description: 'List all App Passwords.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'passwords'
                        ],
                        properties: {
                            passwords: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.server.listAppPasswords#appPassword'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'AccountTakedown'
                    }
                ]
            },
            appPassword: {
                type: 'object',
                required: [
                    'name',
                    'createdAt'
                ],
                properties: {
                    name: {
                        type: 'string'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    privileged: {
                        type: 'boolean'
                    }
                }
            }
        }
    },
    ComAtprotoServerRefreshSession: {
        lexicon: 1,
        id: 'com.atproto.server.refreshSession',
        defs: {
            main: {
                type: 'procedure',
                description: "Refresh an authentication session. Requires auth using the 'refreshJwt' (not the 'accessJwt').",
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'accessJwt',
                            'refreshJwt',
                            'handle',
                            'did'
                        ],
                        properties: {
                            accessJwt: {
                                type: 'string'
                            },
                            refreshJwt: {
                                type: 'string'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle'
                            },
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            didDoc: {
                                type: 'unknown'
                            },
                            active: {
                                type: 'boolean'
                            },
                            status: {
                                type: 'string',
                                description: "Hosting status of the account. If not specified, then assume 'active'.",
                                knownValues: [
                                    'takendown',
                                    'suspended',
                                    'deactivated'
                                ]
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'AccountTakedown'
                    }
                ]
            }
        }
    },
    ComAtprotoServerRequestAccountDelete: {
        lexicon: 1,
        id: 'com.atproto.server.requestAccountDelete',
        defs: {
            main: {
                type: 'procedure',
                description: 'Initiate a user account deletion via email.'
            }
        }
    },
    ComAtprotoServerRequestEmailConfirmation: {
        lexicon: 1,
        id: 'com.atproto.server.requestEmailConfirmation',
        defs: {
            main: {
                type: 'procedure',
                description: 'Request an email with a code to confirm ownership of email.'
            }
        }
    },
    ComAtprotoServerRequestEmailUpdate: {
        lexicon: 1,
        id: 'com.atproto.server.requestEmailUpdate',
        defs: {
            main: {
                type: 'procedure',
                description: 'Request a token in order to update email.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'tokenRequired'
                        ],
                        properties: {
                            tokenRequired: {
                                type: 'boolean'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerRequestPasswordReset: {
        lexicon: 1,
        id: 'com.atproto.server.requestPasswordReset',
        defs: {
            main: {
                type: 'procedure',
                description: 'Initiate a user account password reset via email.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'email'
                        ],
                        properties: {
                            email: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerReserveSigningKey: {
        lexicon: 1,
        id: 'com.atproto.server.reserveSigningKey',
        defs: {
            main: {
                type: 'procedure',
                description: 'Reserve a repo signing key, for use with account creation. Necessary so that a DID PLC update operation can be constructed during an account migraiton. Public and does not require auth; implemented by PDS. NOTE: this endpoint may change when full account migration is implemented.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did',
                                description: 'The DID to reserve a key for.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'signingKey'
                        ],
                        properties: {
                            signingKey: {
                                type: 'string',
                                description: 'The public key for the reserved signing key, in did:key serialization.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerResetPassword: {
        lexicon: 1,
        id: 'com.atproto.server.resetPassword',
        defs: {
            main: {
                type: 'procedure',
                description: 'Reset a user account password using a token.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'token',
                            'password'
                        ],
                        properties: {
                            token: {
                                type: 'string'
                            },
                            password: {
                                type: 'string'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'ExpiredToken'
                    },
                    {
                        name: 'InvalidToken'
                    }
                ]
            }
        }
    },
    ComAtprotoServerRevokeAppPassword: {
        lexicon: 1,
        id: 'com.atproto.server.revokeAppPassword',
        defs: {
            main: {
                type: 'procedure',
                description: 'Revoke an App Password by name.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'name'
                        ],
                        properties: {
                            name: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerUpdateEmail: {
        lexicon: 1,
        id: 'com.atproto.server.updateEmail',
        defs: {
            main: {
                type: 'procedure',
                description: "Update an account's email.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'email'
                        ],
                        properties: {
                            email: {
                                type: 'string'
                            },
                            emailAuthFactor: {
                                type: 'boolean'
                            },
                            token: {
                                type: 'string',
                                description: "Requires a token from com.atproto.sever.requestEmailUpdate if the account's email has been confirmed."
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'ExpiredToken'
                    },
                    {
                        name: 'InvalidToken'
                    },
                    {
                        name: 'TokenRequired'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetBlob: {
        lexicon: 1,
        id: 'com.atproto.sync.getBlob',
        defs: {
            main: {
                type: 'query',
                description: 'Get a blob associated with a given account. Returns the full blob as originally uploaded. Does not require auth; implemented by PDS.',
                parameters: {
                    type: 'params',
                    required: [
                        'did',
                        'cid'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the account.'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid',
                            description: 'The CID of the blob to fetch'
                        }
                    }
                },
                output: {
                    encoding: '*/*'
                },
                errors: [
                    {
                        name: 'BlobNotFound'
                    },
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetBlocks: {
        lexicon: 1,
        id: 'com.atproto.sync.getBlocks',
        defs: {
            main: {
                type: 'query',
                description: 'Get data blocks from a given repo, by CID. For example, intermediate MST nodes, or records. Does not require auth; implemented by PDS.',
                parameters: {
                    type: 'params',
                    required: [
                        'did',
                        'cids'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        },
                        cids: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'cid'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/vnd.ipld.car'
                },
                errors: [
                    {
                        name: 'BlockNotFound'
                    },
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetCheckout: {
        lexicon: 1,
        id: 'com.atproto.sync.getCheckout',
        defs: {
            main: {
                type: 'query',
                description: 'DEPRECATED - please use com.atproto.sync.getRepo instead',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        }
                    }
                },
                output: {
                    encoding: 'application/vnd.ipld.car'
                }
            }
        }
    },
    ComAtprotoSyncGetHead: {
        lexicon: 1,
        id: 'com.atproto.sync.getHead',
        defs: {
            main: {
                type: 'query',
                description: 'DEPRECATED - please use com.atproto.sync.getLatestCommit instead',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'root'
                        ],
                        properties: {
                            root: {
                                type: 'string',
                                format: 'cid'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'HeadNotFound'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetLatestCommit: {
        lexicon: 1,
        id: 'com.atproto.sync.getLatestCommit',
        defs: {
            main: {
                type: 'query',
                description: 'Get the current commit CID & revision of the specified repo. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'cid',
                            'rev'
                        ],
                        properties: {
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            rev: {
                                type: 'string'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetRecord: {
        lexicon: 1,
        id: 'com.atproto.sync.getRecord',
        defs: {
            main: {
                type: 'query',
                description: 'Get data blocks needed to prove the existence or non-existence of record in the current version of repo. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'did',
                        'collection',
                        'rkey'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        },
                        collection: {
                            type: 'string',
                            format: 'nsid'
                        },
                        rkey: {
                            type: 'string',
                            description: 'Record Key'
                        },
                        commit: {
                            type: 'string',
                            format: 'cid',
                            description: 'DEPRECATED: referenced a repo commit by CID, and retrieved record as of that commit'
                        }
                    }
                },
                output: {
                    encoding: 'application/vnd.ipld.car'
                },
                errors: [
                    {
                        name: 'RecordNotFound'
                    },
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetRepo: {
        lexicon: 1,
        id: 'com.atproto.sync.getRepo',
        defs: {
            main: {
                type: 'query',
                description: "Download a repository export as CAR file. Optionally only a 'diff' since a previous revision. Does not require auth; implemented by PDS.",
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        },
                        since: {
                            type: 'string',
                            description: "The revision ('rev') of the repo to create a diff from."
                        }
                    }
                },
                output: {
                    encoding: 'application/vnd.ipld.car'
                },
                errors: [
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetRepoStatus: {
        lexicon: 1,
        id: 'com.atproto.sync.getRepoStatus',
        defs: {
            main: {
                type: 'query',
                description: 'Get the hosting status for a repository, on this server. Expected to be implemented by PDS and Relay.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'active'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            active: {
                                type: 'boolean'
                            },
                            status: {
                                type: 'string',
                                description: 'If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.',
                                knownValues: [
                                    'takendown',
                                    'suspended',
                                    'deactivated'
                                ]
                            },
                            rev: {
                                type: 'string',
                                description: 'Optional field, the current rev of the repo, if active=true'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'RepoNotFound'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncListBlobs: {
        lexicon: 1,
        id: 'com.atproto.sync.listBlobs',
        defs: {
            main: {
                type: 'query',
                description: 'List blob CIDs for an account, since some repo revision. Does not require auth; implemented by PDS.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        },
                        since: {
                            type: 'string',
                            description: 'Optional revision of the repo to list blobs since.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 1000,
                            default: 500
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'cids'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            cids: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                    format: 'cid'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncListRepos: {
        lexicon: 1,
        id: 'com.atproto.sync.listRepos',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates all the DID, rev, and commit CID for all repos hosted by this service. Does not require auth; implemented by PDS and Relay.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 1000,
                            default: 500
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repos'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            repos: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.sync.listRepos#repo'
                                }
                            }
                        }
                    }
                }
            },
            repo: {
                type: 'object',
                required: [
                    'did',
                    'head',
                    'rev'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    head: {
                        type: 'string',
                        format: 'cid',
                        description: 'Current repo commit CID'
                    },
                    rev: {
                        type: 'string'
                    },
                    active: {
                        type: 'boolean'
                    },
                    status: {
                        type: 'string',
                        description: 'If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.',
                        knownValues: [
                            'takendown',
                            'suspended',
                            'deactivated'
                        ]
                    }
                }
            }
        }
    },
    ComAtprotoSyncNotifyOfUpdate: {
        lexicon: 1,
        id: 'com.atproto.sync.notifyOfUpdate',
        defs: {
            main: {
                type: 'procedure',
                description: 'Notify a crawling service of a recent update, and that crawling should resume. Intended use is after a gap between repo stream events caused the crawling service to disconnect. Does not require auth; implemented by Relay.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'hostname'
                        ],
                        properties: {
                            hostname: {
                                type: 'string',
                                description: 'Hostname of the current service (usually a PDS) that is notifying of update.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoSyncRequestCrawl: {
        lexicon: 1,
        id: 'com.atproto.sync.requestCrawl',
        defs: {
            main: {
                type: 'procedure',
                description: 'Request a service to persistently crawl hosted repos. Expected use is new PDS instances declaring their existence to Relays. Does not require auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'hostname'
                        ],
                        properties: {
                            hostname: {
                                type: 'string',
                                description: 'Hostname of the current service (eg, PDS) that is requesting to be crawled.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoSyncSubscribeRepos: {
        lexicon: 1,
        id: 'com.atproto.sync.subscribeRepos',
        defs: {
            main: {
                type: 'subscription',
                description: 'Repository event stream, aka Firehose endpoint. Outputs repo commits with diff data, and identity update events, for all repositories on the current server. See the atproto specifications for details around stream sequencing, repo versioning, CAR diff format, and more. Public and does not require auth; implemented by PDS and Relay.',
                parameters: {
                    type: 'params',
                    properties: {
                        cursor: {
                            type: 'integer',
                            description: 'The last known event seq number to backfill from.'
                        }
                    }
                },
                message: {
                    schema: {
                        type: 'union',
                        refs: [
                            'lex:com.atproto.sync.subscribeRepos#commit',
                            'lex:com.atproto.sync.subscribeRepos#identity',
                            'lex:com.atproto.sync.subscribeRepos#account',
                            'lex:com.atproto.sync.subscribeRepos#handle',
                            'lex:com.atproto.sync.subscribeRepos#migrate',
                            'lex:com.atproto.sync.subscribeRepos#tombstone',
                            'lex:com.atproto.sync.subscribeRepos#info'
                        ]
                    }
                },
                errors: [
                    {
                        name: 'FutureCursor'
                    },
                    {
                        name: 'ConsumerTooSlow',
                        description: 'If the consumer of the stream can not keep up with events, and a backlog gets too large, the server will drop the connection.'
                    }
                ]
            },
            commit: {
                type: 'object',
                description: 'Represents an update of repository state. Note that empty commits are allowed, which include no repo data changes, but an update to rev and signature.',
                required: [
                    'seq',
                    'rebase',
                    'tooBig',
                    'repo',
                    'commit',
                    'rev',
                    'since',
                    'blocks',
                    'ops',
                    'blobs',
                    'time'
                ],
                nullable: [
                    'prev',
                    'since'
                ],
                properties: {
                    seq: {
                        type: 'integer',
                        description: 'The stream sequence number of this message.'
                    },
                    rebase: {
                        type: 'boolean',
                        description: 'DEPRECATED -- unused'
                    },
                    tooBig: {
                        type: 'boolean',
                        description: 'Indicates that this commit contained too many ops, or data size was too large. Consumers will need to make a separate request to get missing data.'
                    },
                    repo: {
                        type: 'string',
                        format: 'did',
                        description: 'The repo this event comes from.'
                    },
                    commit: {
                        type: 'cid-link',
                        description: 'Repo commit object CID.'
                    },
                    prev: {
                        type: 'cid-link',
                        description: 'DEPRECATED -- unused. WARNING -- nullable and optional; stick with optional to ensure golang interoperability.'
                    },
                    rev: {
                        type: 'string',
                        description: 'The rev of the emitted commit. Note that this information is also in the commit object included in blocks, unless this is a tooBig event.'
                    },
                    since: {
                        type: 'string',
                        description: 'The rev of the last emitted commit from this repo (if any).'
                    },
                    blocks: {
                        type: 'bytes',
                        description: 'CAR file containing relevant blocks, as a diff since the previous repo state.',
                        maxLength: 1000000
                    },
                    ops: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.sync.subscribeRepos#repoOp',
                            description: 'List of repo mutation operations in this commit (eg, records created, updated, or deleted).'
                        },
                        maxLength: 200
                    },
                    blobs: {
                        type: 'array',
                        items: {
                            type: 'cid-link',
                            description: 'List of new blobs (by CID) referenced by records in this commit.'
                        }
                    },
                    time: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp of when this message was originally broadcast.'
                    }
                }
            },
            identity: {
                type: 'object',
                description: "Represents a change to an account's identity. Could be an updated handle, signing key, or pds hosting endpoint. Serves as a prod to all downstream services to refresh their identity cache.",
                required: [
                    'seq',
                    'did',
                    'time'
                ],
                properties: {
                    seq: {
                        type: 'integer'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    time: {
                        type: 'string',
                        format: 'datetime'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle',
                        description: "The current handle for the account, or 'handle.invalid' if validation fails. This field is optional, might have been validated or passed-through from an upstream source. Semantics and behaviors for PDS vs Relay may evolve in the future; see atproto specs for more details."
                    }
                }
            },
            account: {
                type: 'object',
                description: "Represents a change to an account's status on a host (eg, PDS or Relay). The semantics of this event are that the status is at the host which emitted the event, not necessarily that at the currently active PDS. Eg, a Relay takedown would emit a takedown with active=false, even if the PDS is still active.",
                required: [
                    'seq',
                    'did',
                    'time',
                    'active'
                ],
                properties: {
                    seq: {
                        type: 'integer'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    time: {
                        type: 'string',
                        format: 'datetime'
                    },
                    active: {
                        type: 'boolean',
                        description: 'Indicates that the account has a repository which can be fetched from the host that emitted this event.'
                    },
                    status: {
                        type: 'string',
                        description: 'If active=false, this optional field indicates a reason for why the account is not active.',
                        knownValues: [
                            'takendown',
                            'suspended',
                            'deleted',
                            'deactivated'
                        ]
                    }
                }
            },
            handle: {
                type: 'object',
                description: 'DEPRECATED -- Use #identity event instead',
                required: [
                    'seq',
                    'did',
                    'handle',
                    'time'
                ],
                properties: {
                    seq: {
                        type: 'integer'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    time: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            migrate: {
                type: 'object',
                description: 'DEPRECATED -- Use #account event instead',
                required: [
                    'seq',
                    'did',
                    'migrateTo',
                    'time'
                ],
                nullable: [
                    'migrateTo'
                ],
                properties: {
                    seq: {
                        type: 'integer'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    migrateTo: {
                        type: 'string'
                    },
                    time: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            tombstone: {
                type: 'object',
                description: 'DEPRECATED -- Use #account event instead',
                required: [
                    'seq',
                    'did',
                    'time'
                ],
                properties: {
                    seq: {
                        type: 'integer'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    time: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            info: {
                type: 'object',
                required: [
                    'name'
                ],
                properties: {
                    name: {
                        type: 'string',
                        knownValues: [
                            'OutdatedCursor'
                        ]
                    },
                    message: {
                        type: 'string'
                    }
                }
            },
            repoOp: {
                type: 'object',
                description: 'A repo operation, ie a mutation of a single record.',
                required: [
                    'action',
                    'path',
                    'cid'
                ],
                nullable: [
                    'cid'
                ],
                properties: {
                    action: {
                        type: 'string',
                        knownValues: [
                            'create',
                            'update',
                            'delete'
                        ]
                    },
                    path: {
                        type: 'string'
                    },
                    cid: {
                        type: 'cid-link',
                        description: 'For creates and updates, the new record CID. For deletions, null.'
                    }
                }
            }
        }
    },
    ComAtprotoTempAddReservedHandle: {
        lexicon: 1,
        id: 'com.atproto.temp.addReservedHandle',
        defs: {
            main: {
                type: 'procedure',
                description: 'Add a handle to the set of reserved handles.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'handle'
                        ],
                        properties: {
                            handle: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {}
                    }
                }
            }
        }
    },
    ComAtprotoTempCheckSignupQueue: {
        lexicon: 1,
        id: 'com.atproto.temp.checkSignupQueue',
        defs: {
            main: {
                type: 'query',
                description: 'Check accounts location in signup queue.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'activated'
                        ],
                        properties: {
                            activated: {
                                type: 'boolean'
                            },
                            placeInQueue: {
                                type: 'integer'
                            },
                            estimatedTimeMs: {
                                type: 'integer'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoTempFetchLabels: {
        lexicon: 1,
        id: 'com.atproto.temp.fetchLabels',
        defs: {
            main: {
                type: 'query',
                description: 'DEPRECATED: use queryLabels or subscribeLabels instead -- Fetch all labels from a labeler created after a certain date.',
                parameters: {
                    type: 'params',
                    properties: {
                        since: {
                            type: 'integer'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 250,
                            default: 50
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'labels'
                        ],
                        properties: {
                            labels: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.label.defs#label'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoTempRequestPhoneVerification: {
        lexicon: 1,
        id: 'com.atproto.temp.requestPhoneVerification',
        defs: {
            main: {
                type: 'procedure',
                description: 'Request a verification code to be sent to the supplied phone number',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'phoneNumber'
                        ],
                        properties: {
                            phoneNumber: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorDefs: {
        lexicon: 1,
        id: 'app.bsky.actor.defs',
        defs: {
            profileViewBasic: {
                type: 'object',
                required: [
                    'did',
                    'handle'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    displayName: {
                        type: 'string',
                        maxGraphemes: 64,
                        maxLength: 640
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    associated: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileAssociated'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#viewerState'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            profileView: {
                type: 'object',
                required: [
                    'did',
                    'handle'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    displayName: {
                        type: 'string',
                        maxGraphemes: 64,
                        maxLength: 640
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 256,
                        maxLength: 2560
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    associated: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileAssociated'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#viewerState'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    }
                }
            },
            profileViewDetailed: {
                type: 'object',
                required: [
                    'did',
                    'handle'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    displayName: {
                        type: 'string',
                        maxGraphemes: 64,
                        maxLength: 640
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 256,
                        maxLength: 2560
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    banner: {
                        type: 'string',
                        format: 'uri'
                    },
                    followersCount: {
                        type: 'integer'
                    },
                    followsCount: {
                        type: 'integer'
                    },
                    postsCount: {
                        type: 'integer'
                    },
                    associated: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileAssociated'
                    },
                    joinedViaStarterPack: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#starterPackViewBasic'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#viewerState'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    pinnedPost: {
                        type: 'ref',
                        ref: 'lex:com.atproto.repo.strongRef'
                    }
                }
            },
            profileAssociated: {
                type: 'object',
                properties: {
                    lists: {
                        type: 'integer'
                    },
                    feedgens: {
                        type: 'integer'
                    },
                    starterPacks: {
                        type: 'integer'
                    },
                    labeler: {
                        type: 'boolean'
                    },
                    chat: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileAssociatedChat'
                    }
                }
            },
            profileAssociatedChat: {
                type: 'object',
                required: [
                    'allowIncoming'
                ],
                properties: {
                    allowIncoming: {
                        type: 'string',
                        knownValues: [
                            'all',
                            'none',
                            'following'
                        ]
                    }
                }
            },
            viewerState: {
                type: 'object',
                description: "Metadata about the requesting account's relationship with the subject account. Only has meaningful content for authed requests.",
                properties: {
                    muted: {
                        type: 'boolean'
                    },
                    mutedByList: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listViewBasic'
                    },
                    blockedBy: {
                        type: 'boolean'
                    },
                    blocking: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    blockingByList: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listViewBasic'
                    },
                    following: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    followedBy: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    knownFollowers: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#knownFollowers'
                    }
                }
            },
            knownFollowers: {
                type: 'object',
                description: "The subject's followers whom you also follow",
                required: [
                    'count',
                    'followers'
                ],
                properties: {
                    count: {
                        type: 'integer'
                    },
                    followers: {
                        type: 'array',
                        minLength: 0,
                        maxLength: 5,
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                        }
                    }
                }
            },
            preferences: {
                type: 'array',
                items: {
                    type: 'union',
                    refs: [
                        'lex:app.bsky.actor.defs#adultContentPref',
                        'lex:app.bsky.actor.defs#contentLabelPref',
                        'lex:app.bsky.actor.defs#savedFeedsPref',
                        'lex:app.bsky.actor.defs#savedFeedsPrefV2',
                        'lex:app.bsky.actor.defs#personalDetailsPref',
                        'lex:app.bsky.actor.defs#feedViewPref',
                        'lex:app.bsky.actor.defs#threadViewPref',
                        'lex:app.bsky.actor.defs#interestsPref',
                        'lex:app.bsky.actor.defs#mutedWordsPref',
                        'lex:app.bsky.actor.defs#hiddenPostsPref',
                        'lex:app.bsky.actor.defs#bskyAppStatePref',
                        'lex:app.bsky.actor.defs#labelersPref',
                        'lex:app.bsky.actor.defs#postInteractionSettingsPref'
                    ]
                }
            },
            adultContentPref: {
                type: 'object',
                required: [
                    'enabled'
                ],
                properties: {
                    enabled: {
                        type: 'boolean',
                        default: false
                    }
                }
            },
            contentLabelPref: {
                type: 'object',
                required: [
                    'label',
                    'visibility'
                ],
                properties: {
                    labelerDid: {
                        type: 'string',
                        description: 'Which labeler does this preference apply to? If undefined, applies globally.',
                        format: 'did'
                    },
                    label: {
                        type: 'string'
                    },
                    visibility: {
                        type: 'string',
                        knownValues: [
                            'ignore',
                            'show',
                            'warn',
                            'hide'
                        ]
                    }
                }
            },
            savedFeed: {
                type: 'object',
                required: [
                    'id',
                    'type',
                    'value',
                    'pinned'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    type: {
                        type: 'string',
                        knownValues: [
                            'feed',
                            'list',
                            'timeline'
                        ]
                    },
                    value: {
                        type: 'string'
                    },
                    pinned: {
                        type: 'boolean'
                    }
                }
            },
            savedFeedsPrefV2: {
                type: 'object',
                required: [
                    'items'
                ],
                properties: {
                    items: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#savedFeed'
                        }
                    }
                }
            },
            savedFeedsPref: {
                type: 'object',
                required: [
                    'pinned',
                    'saved'
                ],
                properties: {
                    pinned: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'at-uri'
                        }
                    },
                    saved: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'at-uri'
                        }
                    },
                    timelineIndex: {
                        type: 'integer'
                    }
                }
            },
            personalDetailsPref: {
                type: 'object',
                properties: {
                    birthDate: {
                        type: 'string',
                        format: 'datetime',
                        description: 'The birth date of account owner.'
                    }
                }
            },
            feedViewPref: {
                type: 'object',
                required: [
                    'feed'
                ],
                properties: {
                    feed: {
                        type: 'string',
                        description: 'The URI of the feed, or an identifier which describes the feed.'
                    },
                    hideReplies: {
                        type: 'boolean',
                        description: 'Hide replies in the feed.'
                    },
                    hideRepliesByUnfollowed: {
                        type: 'boolean',
                        description: 'Hide replies in the feed if they are not by followed users.',
                        default: true
                    },
                    hideRepliesByLikeCount: {
                        type: 'integer',
                        description: 'Hide replies in the feed if they do not have this number of likes.'
                    },
                    hideReposts: {
                        type: 'boolean',
                        description: 'Hide reposts in the feed.'
                    },
                    hideQuotePosts: {
                        type: 'boolean',
                        description: 'Hide quote posts in the feed.'
                    }
                }
            },
            threadViewPref: {
                type: 'object',
                properties: {
                    sort: {
                        type: 'string',
                        description: 'Sorting mode for threads.',
                        knownValues: [
                            'oldest',
                            'newest',
                            'most-likes',
                            'random',
                            'hotness'
                        ]
                    },
                    prioritizeFollowedUsers: {
                        type: 'boolean',
                        description: 'Show followed users at the top of all replies.'
                    }
                }
            },
            interestsPref: {
                type: 'object',
                required: [
                    'tags'
                ],
                properties: {
                    tags: {
                        type: 'array',
                        maxLength: 100,
                        items: {
                            type: 'string',
                            maxLength: 640,
                            maxGraphemes: 64
                        },
                        description: "A list of tags which describe the account owner's interests gathered during onboarding."
                    }
                }
            },
            mutedWordTarget: {
                type: 'string',
                knownValues: [
                    'content',
                    'tag'
                ],
                maxLength: 640,
                maxGraphemes: 64
            },
            mutedWord: {
                type: 'object',
                description: 'A word that the account owner has muted.',
                required: [
                    'value',
                    'targets'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    value: {
                        type: 'string',
                        description: 'The muted word itself.',
                        maxLength: 10000,
                        maxGraphemes: 1000
                    },
                    targets: {
                        type: 'array',
                        description: 'The intended targets of the muted word.',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#mutedWordTarget'
                        }
                    },
                    actorTarget: {
                        type: 'string',
                        description: 'Groups of users to apply the muted word to. If undefined, applies to all users.',
                        knownValues: [
                            'all',
                            'exclude-following'
                        ],
                        default: 'all'
                    },
                    expiresAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'The date and time at which the muted word will expire and no longer be applied.'
                    }
                }
            },
            mutedWordsPref: {
                type: 'object',
                required: [
                    'items'
                ],
                properties: {
                    items: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#mutedWord'
                        },
                        description: 'A list of words the account owner has muted.'
                    }
                }
            },
            hiddenPostsPref: {
                type: 'object',
                required: [
                    'items'
                ],
                properties: {
                    items: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'at-uri'
                        },
                        description: 'A list of URIs of posts the account owner has hidden.'
                    }
                }
            },
            labelersPref: {
                type: 'object',
                required: [
                    'labelers'
                ],
                properties: {
                    labelers: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#labelerPrefItem'
                        }
                    }
                }
            },
            labelerPrefItem: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            bskyAppStatePref: {
                description: "A grab bag of state that's specific to the bsky.app program. Third-party apps shouldn't use this.",
                type: 'object',
                properties: {
                    activeProgressGuide: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#bskyAppProgressGuide'
                    },
                    queuedNudges: {
                        description: 'An array of tokens which identify nudges (modals, popups, tours, highlight dots) that should be shown to the user.',
                        type: 'array',
                        maxLength: 1000,
                        items: {
                            type: 'string',
                            maxLength: 100
                        }
                    },
                    nuxs: {
                        description: 'Storage for NUXs the user has encountered.',
                        type: 'array',
                        maxLength: 100,
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#nux'
                        }
                    }
                }
            },
            bskyAppProgressGuide: {
                description: 'If set, an active progress guide. Once completed, can be set to undefined. Should have unspecced fields tracking progress.',
                type: 'object',
                required: [
                    'guide'
                ],
                properties: {
                    guide: {
                        type: 'string',
                        maxLength: 100
                    }
                }
            },
            nux: {
                type: 'object',
                description: 'A new user experiences (NUX) storage object',
                required: [
                    'id',
                    'completed'
                ],
                properties: {
                    id: {
                        type: 'string',
                        maxLength: 100
                    },
                    completed: {
                        type: 'boolean',
                        default: false
                    },
                    data: {
                        description: 'Arbitrary data for the NUX. The structure is defined by the NUX itself. Limited to 300 characters.',
                        type: 'string',
                        maxLength: 3000,
                        maxGraphemes: 300
                    },
                    expiresAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'The date and time at which the NUX will expire and should be considered completed.'
                    }
                }
            },
            postInteractionSettingsPref: {
                type: 'object',
                description: 'Default post interaction settings for the account. These values should be applied as default values when creating new posts. These refs should mirror the threadgate and postgate records exactly.',
                required: [],
                properties: {
                    threadgateAllowRules: {
                        description: 'Matches threadgate record. List of rules defining who can reply to this users posts. If value is an empty array, no one can reply. If value is undefined, anyone can reply.',
                        type: 'array',
                        maxLength: 5,
                        items: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.feed.threadgate#mentionRule',
                                'lex:app.bsky.feed.threadgate#followerRule',
                                'lex:app.bsky.feed.threadgate#followingRule',
                                'lex:app.bsky.feed.threadgate#listRule'
                            ]
                        }
                    },
                    postgateEmbeddingRules: {
                        description: 'Matches postgate record. List of rules defining who can embed this users posts. If value is an empty array or is undefined, no particular rules apply and anyone can embed.',
                        type: 'array',
                        maxLength: 5,
                        items: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.feed.postgate#disableRule'
                            ]
                        }
                    }
                }
            }
        }
    },
    AppBskyActorGetPreferences: {
        lexicon: 1,
        id: 'app.bsky.actor.getPreferences',
        defs: {
            main: {
                type: 'query',
                description: 'Get private preferences attached to the current account. Expected use is synchronization between multiple devices, and import/export during account migration. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {}
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'preferences'
                        ],
                        properties: {
                            preferences: {
                                type: 'ref',
                                ref: 'lex:app.bsky.actor.defs#preferences'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorGetProfile: {
        lexicon: 1,
        id: 'app.bsky.actor.getProfile',
        defs: {
            main: {
                type: 'query',
                description: 'Get detailed profile view of an actor. Does not require auth, but contains relevant metadata with auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Handle or DID of account to fetch profile of.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewDetailed'
                    }
                }
            }
        }
    },
    AppBskyActorGetProfiles: {
        lexicon: 1,
        id: 'app.bsky.actor.getProfiles',
        defs: {
            main: {
                type: 'query',
                description: 'Get detailed profile views of multiple actors.',
                parameters: {
                    type: 'params',
                    required: [
                        'actors'
                    ],
                    properties: {
                        actors: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'at-identifier'
                            },
                            maxLength: 25
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'profiles'
                        ],
                        properties: {
                            profiles: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileViewDetailed'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorGetSuggestions: {
        lexicon: 1,
        id: 'app.bsky.actor.getSuggestions',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of suggested actors. Expected use is discovery of accounts to follow during new account onboarding.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actors'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            actors: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            },
                            recId: {
                                type: 'integer',
                                description: 'Snowflake for this recommendation, use when submitting recommendation events.'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorProfile: {
        lexicon: 1,
        id: 'app.bsky.actor.profile',
        defs: {
            main: {
                type: 'record',
                description: 'A declaration of a Bluesky account profile.',
                key: 'literal:self',
                record: {
                    type: 'object',
                    properties: {
                        displayName: {
                            type: 'string',
                            maxGraphemes: 64,
                            maxLength: 640
                        },
                        description: {
                            type: 'string',
                            description: 'Free-form profile description text.',
                            maxGraphemes: 256,
                            maxLength: 2560
                        },
                        avatar: {
                            type: 'blob',
                            description: "Small image to be displayed next to posts from account. AKA, 'profile picture'",
                            accept: [
                                'image/png',
                                'image/jpeg'
                            ],
                            maxSize: 1000000
                        },
                        banner: {
                            type: 'blob',
                            description: 'Larger horizontal image to display behind profile view.',
                            accept: [
                                'image/png',
                                'image/jpeg'
                            ],
                            maxSize: 1000000
                        },
                        labels: {
                            type: 'union',
                            description: 'Self-label values, specific to the Bluesky application, on the overall account.',
                            refs: [
                                'lex:com.atproto.label.defs#selfLabels'
                            ]
                        },
                        joinedViaStarterPack: {
                            type: 'ref',
                            ref: 'lex:com.atproto.repo.strongRef'
                        },
                        pinnedPost: {
                            type: 'ref',
                            ref: 'lex:com.atproto.repo.strongRef'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyActorPutPreferences: {
        lexicon: 1,
        id: 'app.bsky.actor.putPreferences',
        defs: {
            main: {
                type: 'procedure',
                description: 'Set the private preferences attached to the account.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'preferences'
                        ],
                        properties: {
                            preferences: {
                                type: 'ref',
                                ref: 'lex:app.bsky.actor.defs#preferences'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorSearchActors: {
        lexicon: 1,
        id: 'app.bsky.actor.searchActors',
        defs: {
            main: {
                type: 'query',
                description: 'Find actors (profiles) matching search criteria. Does not require auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        term: {
                            type: 'string',
                            description: "DEPRECATED: use 'q' instead."
                        },
                        q: {
                            type: 'string',
                            description: 'Search query string. Syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actors'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            actors: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorSearchActorsTypeahead: {
        lexicon: 1,
        id: 'app.bsky.actor.searchActorsTypeahead',
        defs: {
            main: {
                type: 'query',
                description: 'Find actor suggestions for a prefix search term. Expected use is for auto-completion during text field entry. Does not require auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        term: {
                            type: 'string',
                            description: "DEPRECATED: use 'q' instead."
                        },
                        q: {
                            type: 'string',
                            description: 'Search query prefix; not a full query string.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actors'
                        ],
                        properties: {
                            actors: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyEmbedDefs: {
        lexicon: 1,
        id: 'app.bsky.embed.defs',
        defs: {
            aspectRatio: {
                type: 'object',
                description: 'width:height represents an aspect ratio. It may be approximate, and may not correspond to absolute dimensions in any given unit.',
                required: [
                    'width',
                    'height'
                ],
                properties: {
                    width: {
                        type: 'integer',
                        minimum: 1
                    },
                    height: {
                        type: 'integer',
                        minimum: 1
                    }
                }
            }
        }
    },
    AppBskyEmbedExternal: {
        lexicon: 1,
        id: 'app.bsky.embed.external',
        defs: {
            main: {
                type: 'object',
                description: "A representation of some externally linked content (eg, a URL and 'card'), embedded in a Bluesky record (eg, a post).",
                required: [
                    'external'
                ],
                properties: {
                    external: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.external#external'
                    }
                }
            },
            external: {
                type: 'object',
                required: [
                    'uri',
                    'title',
                    'description'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'uri'
                    },
                    title: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    thumb: {
                        type: 'blob',
                        accept: [
                            'image/*'
                        ],
                        maxSize: 1000000
                    }
                }
            },
            view: {
                type: 'object',
                required: [
                    'external'
                ],
                properties: {
                    external: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.external#viewExternal'
                    }
                }
            },
            viewExternal: {
                type: 'object',
                required: [
                    'uri',
                    'title',
                    'description'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'uri'
                    },
                    title: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    thumb: {
                        type: 'string',
                        format: 'uri'
                    }
                }
            }
        }
    },
    AppBskyEmbedImages: {
        lexicon: 1,
        id: 'app.bsky.embed.images',
        description: 'A set of images embedded in a Bluesky record (eg, a post).',
        defs: {
            main: {
                type: 'object',
                required: [
                    'images'
                ],
                properties: {
                    images: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.embed.images#image'
                        },
                        maxLength: 4
                    }
                }
            },
            image: {
                type: 'object',
                required: [
                    'image',
                    'alt'
                ],
                properties: {
                    image: {
                        type: 'blob',
                        accept: [
                            'image/*'
                        ],
                        maxSize: 1000000
                    },
                    alt: {
                        type: 'string',
                        description: 'Alt text description of the image, for accessibility.'
                    },
                    aspectRatio: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.defs#aspectRatio'
                    }
                }
            },
            view: {
                type: 'object',
                required: [
                    'images'
                ],
                properties: {
                    images: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.embed.images#viewImage'
                        },
                        maxLength: 4
                    }
                }
            },
            viewImage: {
                type: 'object',
                required: [
                    'thumb',
                    'fullsize',
                    'alt'
                ],
                properties: {
                    thumb: {
                        type: 'string',
                        format: 'uri',
                        description: 'Fully-qualified URL where a thumbnail of the image can be fetched. For example, CDN location provided by the App View.'
                    },
                    fullsize: {
                        type: 'string',
                        format: 'uri',
                        description: 'Fully-qualified URL where a large version of the image can be fetched. May or may not be the exact original blob. For example, CDN location provided by the App View.'
                    },
                    alt: {
                        type: 'string',
                        description: 'Alt text description of the image, for accessibility.'
                    },
                    aspectRatio: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.defs#aspectRatio'
                    }
                }
            }
        }
    },
    AppBskyEmbedRecord: {
        lexicon: 1,
        id: 'app.bsky.embed.record',
        description: 'A representation of a record embedded in a Bluesky record (eg, a post). For example, a quote-post, or sharing a feed generator record.',
        defs: {
            main: {
                type: 'object',
                required: [
                    'record'
                ],
                properties: {
                    record: {
                        type: 'ref',
                        ref: 'lex:com.atproto.repo.strongRef'
                    }
                }
            },
            view: {
                type: 'object',
                required: [
                    'record'
                ],
                properties: {
                    record: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.record#viewRecord',
                            'lex:app.bsky.embed.record#viewNotFound',
                            'lex:app.bsky.embed.record#viewBlocked',
                            'lex:app.bsky.embed.record#viewDetached',
                            'lex:app.bsky.feed.defs#generatorView',
                            'lex:app.bsky.graph.defs#listView',
                            'lex:app.bsky.labeler.defs#labelerView',
                            'lex:app.bsky.graph.defs#starterPackViewBasic'
                        ]
                    }
                }
            },
            viewRecord: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'author',
                    'value',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    author: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                    },
                    value: {
                        type: 'unknown',
                        description: 'The record data itself.'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    replyCount: {
                        type: 'integer'
                    },
                    repostCount: {
                        type: 'integer'
                    },
                    likeCount: {
                        type: 'integer'
                    },
                    quoteCount: {
                        type: 'integer'
                    },
                    embeds: {
                        type: 'array',
                        items: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.embed.images#view',
                                'lex:app.bsky.embed.video#view',
                                'lex:app.bsky.embed.external#view',
                                'lex:app.bsky.embed.record#view',
                                'lex:app.bsky.embed.recordWithMedia#view'
                            ]
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            viewNotFound: {
                type: 'object',
                required: [
                    'uri',
                    'notFound'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    notFound: {
                        type: 'boolean',
                        const: true
                    }
                }
            },
            viewBlocked: {
                type: 'object',
                required: [
                    'uri',
                    'blocked',
                    'author'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    blocked: {
                        type: 'boolean',
                        const: true
                    },
                    author: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#blockedAuthor'
                    }
                }
            },
            viewDetached: {
                type: 'object',
                required: [
                    'uri',
                    'detached'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    detached: {
                        type: 'boolean',
                        const: true
                    }
                }
            }
        }
    },
    AppBskyEmbedRecordWithMedia: {
        lexicon: 1,
        id: 'app.bsky.embed.recordWithMedia',
        description: 'A representation of a record embedded in a Bluesky record (eg, a post), alongside other compatible embeds. For example, a quote post and image, or a quote post and external URL card.',
        defs: {
            main: {
                type: 'object',
                required: [
                    'record',
                    'media'
                ],
                properties: {
                    record: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.record'
                    },
                    media: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.images',
                            'lex:app.bsky.embed.video',
                            'lex:app.bsky.embed.external'
                        ]
                    }
                }
            },
            view: {
                type: 'object',
                required: [
                    'record',
                    'media'
                ],
                properties: {
                    record: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.record#view'
                    },
                    media: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.images#view',
                            'lex:app.bsky.embed.video#view',
                            'lex:app.bsky.embed.external#view'
                        ]
                    }
                }
            }
        }
    },
    AppBskyEmbedVideo: {
        lexicon: 1,
        id: 'app.bsky.embed.video',
        description: 'A video embedded in a Bluesky record (eg, a post).',
        defs: {
            main: {
                type: 'object',
                required: [
                    'video'
                ],
                properties: {
                    video: {
                        type: 'blob',
                        accept: [
                            'video/mp4'
                        ],
                        maxSize: 50000000
                    },
                    captions: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.embed.video#caption'
                        },
                        maxLength: 20
                    },
                    alt: {
                        type: 'string',
                        description: 'Alt text description of the video, for accessibility.',
                        maxGraphemes: 1000,
                        maxLength: 10000
                    },
                    aspectRatio: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.defs#aspectRatio'
                    }
                }
            },
            caption: {
                type: 'object',
                required: [
                    'lang',
                    'file'
                ],
                properties: {
                    lang: {
                        type: 'string',
                        format: 'language'
                    },
                    file: {
                        type: 'blob',
                        accept: [
                            'text/vtt'
                        ],
                        maxSize: 20000
                    }
                }
            },
            view: {
                type: 'object',
                required: [
                    'cid',
                    'playlist'
                ],
                properties: {
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    playlist: {
                        type: 'string',
                        format: 'uri'
                    },
                    thumbnail: {
                        type: 'string',
                        format: 'uri'
                    },
                    alt: {
                        type: 'string',
                        maxGraphemes: 1000,
                        maxLength: 10000
                    },
                    aspectRatio: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.defs#aspectRatio'
                    }
                }
            }
        }
    },
    AppBskyFeedDefs: {
        lexicon: 1,
        id: 'app.bsky.feed.defs',
        defs: {
            postView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'author',
                    'record',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    author: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                    },
                    record: {
                        type: 'unknown'
                    },
                    embed: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.images#view',
                            'lex:app.bsky.embed.video#view',
                            'lex:app.bsky.embed.external#view',
                            'lex:app.bsky.embed.record#view',
                            'lex:app.bsky.embed.recordWithMedia#view'
                        ]
                    },
                    replyCount: {
                        type: 'integer'
                    },
                    repostCount: {
                        type: 'integer'
                    },
                    likeCount: {
                        type: 'integer'
                    },
                    quoteCount: {
                        type: 'integer'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#viewerState'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    threadgate: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#threadgateView'
                    }
                }
            },
            viewerState: {
                type: 'object',
                description: "Metadata about the requesting account's relationship with the subject content. Only has meaningful content for authed requests.",
                properties: {
                    repost: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    like: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    threadMuted: {
                        type: 'boolean'
                    },
                    replyDisabled: {
                        type: 'boolean'
                    },
                    embeddingDisabled: {
                        type: 'boolean'
                    },
                    pinned: {
                        type: 'boolean'
                    }
                }
            },
            threadContext: {
                type: 'object',
                description: 'Metadata about this post within the context of the thread it is in.',
                properties: {
                    rootAuthorLike: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            feedViewPost: {
                type: 'object',
                required: [
                    'post'
                ],
                properties: {
                    post: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#postView'
                    },
                    reply: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#replyRef'
                    },
                    reason: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.feed.defs#reasonRepost',
                            'lex:app.bsky.feed.defs#reasonPin'
                        ]
                    },
                    feedContext: {
                        type: 'string',
                        description: 'Context provided by feed generator that may be passed back alongside interactions.',
                        maxLength: 2000
                    }
                }
            },
            replyRef: {
                type: 'object',
                required: [
                    'root',
                    'parent'
                ],
                properties: {
                    root: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.feed.defs#postView',
                            'lex:app.bsky.feed.defs#notFoundPost',
                            'lex:app.bsky.feed.defs#blockedPost'
                        ]
                    },
                    parent: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.feed.defs#postView',
                            'lex:app.bsky.feed.defs#notFoundPost',
                            'lex:app.bsky.feed.defs#blockedPost'
                        ]
                    },
                    grandparentAuthor: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic',
                        description: 'When parent is a reply to another post, this is the author of that post.'
                    }
                }
            },
            reasonRepost: {
                type: 'object',
                required: [
                    'by',
                    'indexedAt'
                ],
                properties: {
                    by: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            reasonPin: {
                type: 'object',
                properties: {}
            },
            threadViewPost: {
                type: 'object',
                required: [
                    'post'
                ],
                properties: {
                    post: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#postView'
                    },
                    parent: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.feed.defs#threadViewPost',
                            'lex:app.bsky.feed.defs#notFoundPost',
                            'lex:app.bsky.feed.defs#blockedPost'
                        ]
                    },
                    replies: {
                        type: 'array',
                        items: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.feed.defs#threadViewPost',
                                'lex:app.bsky.feed.defs#notFoundPost',
                                'lex:app.bsky.feed.defs#blockedPost'
                            ]
                        }
                    },
                    threadContext: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#threadContext'
                    }
                }
            },
            notFoundPost: {
                type: 'object',
                required: [
                    'uri',
                    'notFound'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    notFound: {
                        type: 'boolean',
                        const: true
                    }
                }
            },
            blockedPost: {
                type: 'object',
                required: [
                    'uri',
                    'blocked',
                    'author'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    blocked: {
                        type: 'boolean',
                        const: true
                    },
                    author: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#blockedAuthor'
                    }
                }
            },
            blockedAuthor: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#viewerState'
                    }
                }
            },
            generatorView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'did',
                    'creator',
                    'displayName',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    },
                    displayName: {
                        type: 'string'
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 300,
                        maxLength: 3000
                    },
                    descriptionFacets: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.richtext.facet'
                        }
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    likeCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    acceptsInteractions: {
                        type: 'boolean'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#generatorViewerState'
                    },
                    contentMode: {
                        type: 'string',
                        knownValues: [
                            'app.bsky.feed.defs#contentModeUnspecified',
                            'app.bsky.feed.defs#contentModeVideo'
                        ]
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            generatorViewerState: {
                type: 'object',
                properties: {
                    like: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            skeletonFeedPost: {
                type: 'object',
                required: [
                    'post'
                ],
                properties: {
                    post: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    reason: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.feed.defs#skeletonReasonRepost',
                            'lex:app.bsky.feed.defs#skeletonReasonPin'
                        ]
                    },
                    feedContext: {
                        type: 'string',
                        description: 'Context that will be passed through to client and may be passed to feed generator back alongside interactions.',
                        maxLength: 2000
                    }
                }
            },
            skeletonReasonRepost: {
                type: 'object',
                required: [
                    'repost'
                ],
                properties: {
                    repost: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            skeletonReasonPin: {
                type: 'object',
                properties: {}
            },
            threadgateView: {
                type: 'object',
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    record: {
                        type: 'unknown'
                    },
                    lists: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.graph.defs#listViewBasic'
                        }
                    }
                }
            },
            interaction: {
                type: 'object',
                properties: {
                    item: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    event: {
                        type: 'string',
                        knownValues: [
                            'app.bsky.feed.defs#requestLess',
                            'app.bsky.feed.defs#requestMore',
                            'app.bsky.feed.defs#clickthroughItem',
                            'app.bsky.feed.defs#clickthroughAuthor',
                            'app.bsky.feed.defs#clickthroughReposter',
                            'app.bsky.feed.defs#clickthroughEmbed',
                            'app.bsky.feed.defs#interactionSeen',
                            'app.bsky.feed.defs#interactionLike',
                            'app.bsky.feed.defs#interactionRepost',
                            'app.bsky.feed.defs#interactionReply',
                            'app.bsky.feed.defs#interactionQuote',
                            'app.bsky.feed.defs#interactionShare'
                        ]
                    },
                    feedContext: {
                        type: 'string',
                        description: 'Context on a feed item that was originally supplied by the feed generator on getFeedSkeleton.',
                        maxLength: 2000
                    }
                }
            },
            requestLess: {
                type: 'token',
                description: 'Request that less content like the given feed item be shown in the feed'
            },
            requestMore: {
                type: 'token',
                description: 'Request that more content like the given feed item be shown in the feed'
            },
            clickthroughItem: {
                type: 'token',
                description: 'User clicked through to the feed item'
            },
            clickthroughAuthor: {
                type: 'token',
                description: 'User clicked through to the author of the feed item'
            },
            clickthroughReposter: {
                type: 'token',
                description: 'User clicked through to the reposter of the feed item'
            },
            clickthroughEmbed: {
                type: 'token',
                description: 'User clicked through to the embedded content of the feed item'
            },
            contentModeUnspecified: {
                type: 'token',
                description: 'Declares the feed generator returns any types of posts.'
            },
            contentModeVideo: {
                type: 'token',
                description: 'Declares the feed generator returns posts containing app.bsky.embed.video embeds.'
            },
            interactionSeen: {
                type: 'token',
                description: 'Feed item was seen by user'
            },
            interactionLike: {
                type: 'token',
                description: 'User liked the feed item'
            },
            interactionRepost: {
                type: 'token',
                description: 'User reposted the feed item'
            },
            interactionReply: {
                type: 'token',
                description: 'User replied to the feed item'
            },
            interactionQuote: {
                type: 'token',
                description: 'User quoted the feed item'
            },
            interactionShare: {
                type: 'token',
                description: 'User shared the feed item'
            }
        }
    },
    AppBskyFeedDescribeFeedGenerator: {
        lexicon: 1,
        id: 'app.bsky.feed.describeFeedGenerator',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about a feed generator, including policies and offered feed URIs. Does not require auth; implemented by Feed Generator services (not App View).',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'feeds'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.describeFeedGenerator#feed'
                                }
                            },
                            links: {
                                type: 'ref',
                                ref: 'lex:app.bsky.feed.describeFeedGenerator#links'
                            }
                        }
                    }
                }
            },
            feed: {
                type: 'object',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            links: {
                type: 'object',
                properties: {
                    privacyPolicy: {
                        type: 'string'
                    },
                    termsOfService: {
                        type: 'string'
                    }
                }
            }
        }
    },
    AppBskyFeedGenerator: {
        lexicon: 1,
        id: 'app.bsky.feed.generator',
        defs: {
            main: {
                type: 'record',
                description: 'Record declaring of the existence of a feed generator, and containing metadata about it. The record can exist in any repository.',
                key: 'any',
                record: {
                    type: 'object',
                    required: [
                        'did',
                        'displayName',
                        'createdAt'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        },
                        displayName: {
                            type: 'string',
                            maxGraphemes: 24,
                            maxLength: 240
                        },
                        description: {
                            type: 'string',
                            maxGraphemes: 300,
                            maxLength: 3000
                        },
                        descriptionFacets: {
                            type: 'array',
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.richtext.facet'
                            }
                        },
                        avatar: {
                            type: 'blob',
                            accept: [
                                'image/png',
                                'image/jpeg'
                            ],
                            maxSize: 1000000
                        },
                        acceptsInteractions: {
                            type: 'boolean',
                            description: 'Declaration that a feed accepts feedback interactions from a client through app.bsky.feed.sendInteractions'
                        },
                        labels: {
                            type: 'union',
                            description: 'Self-label values',
                            refs: [
                                'lex:com.atproto.label.defs#selfLabels'
                            ]
                        },
                        contentMode: {
                            type: 'string',
                            knownValues: [
                                'app.bsky.feed.defs#contentModeUnspecified',
                                'app.bsky.feed.defs#contentModeVideo'
                            ]
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetActorFeeds: {
        lexicon: 1,
        id: 'app.bsky.feed.getActorFeeds',
        defs: {
            main: {
                type: 'query',
                description: "Get a list of feeds (feed generator records) created by the actor (in the actor's repo).",
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feeds'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#generatorView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetActorLikes: {
        lexicon: 1,
        id: 'app.bsky.feed.getActorLikes',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of posts liked by an actor. Requires auth, actor must be the requesting account.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#feedViewPost'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BlockedActor'
                    },
                    {
                        name: 'BlockedByActor'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetAuthorFeed: {
        lexicon: 1,
        id: 'app.bsky.feed.getAuthorFeed',
        defs: {
            main: {
                type: 'query',
                description: "Get a view of an actor's 'author feed' (post and reposts by the author). Does not require auth.",
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        filter: {
                            type: 'string',
                            description: 'Combinations of post/repost types to include in response.',
                            knownValues: [
                                'posts_with_replies',
                                'posts_no_replies',
                                'posts_with_media',
                                'posts_and_author_threads',
                                'posts_with_video'
                            ],
                            default: 'posts_with_replies'
                        },
                        includePins: {
                            type: 'boolean',
                            default: false
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#feedViewPost'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BlockedActor'
                    },
                    {
                        name: 'BlockedByActor'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetFeed: {
        lexicon: 1,
        id: 'app.bsky.feed.getFeed',
        defs: {
            main: {
                type: 'query',
                description: "Get a hydrated feed from an actor's selected feed generator. Implemented by App View.",
                parameters: {
                    type: 'params',
                    required: [
                        'feed'
                    ],
                    properties: {
                        feed: {
                            type: 'string',
                            format: 'at-uri'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#feedViewPost'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'UnknownFeed'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetFeedGenerator: {
        lexicon: 1,
        id: 'app.bsky.feed.getFeedGenerator',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about a feed generator. Implemented by AppView.',
                parameters: {
                    type: 'params',
                    required: [
                        'feed'
                    ],
                    properties: {
                        feed: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'AT-URI of the feed generator record.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'view',
                            'isOnline',
                            'isValid'
                        ],
                        properties: {
                            view: {
                                type: 'ref',
                                ref: 'lex:app.bsky.feed.defs#generatorView'
                            },
                            isOnline: {
                                type: 'boolean',
                                description: 'Indicates whether the feed generator service has been online recently, or else seems to be inactive.'
                            },
                            isValid: {
                                type: 'boolean',
                                description: 'Indicates whether the feed generator service is compatible with the record declaration.'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetFeedGenerators: {
        lexicon: 1,
        id: 'app.bsky.feed.getFeedGenerators',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about a list of feed generators.',
                parameters: {
                    type: 'params',
                    required: [
                        'feeds'
                    ],
                    properties: {
                        feeds: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feeds'
                        ],
                        properties: {
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#generatorView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetFeedSkeleton: {
        lexicon: 1,
        id: 'app.bsky.feed.getFeedSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Get a skeleton of a feed provided by a feed generator. Auth is optional, depending on provider requirements, and provides the DID of the requester. Implemented by Feed Generator Service.',
                parameters: {
                    type: 'params',
                    required: [
                        'feed'
                    ],
                    properties: {
                        feed: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference to feed generator record describing the specific feed being requested.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#skeletonFeedPost'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'UnknownFeed'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetLikes: {
        lexicon: 1,
        id: 'app.bsky.feed.getLikes',
        defs: {
            main: {
                type: 'query',
                description: 'Get like records which reference a subject (by AT-URI and CID).',
                parameters: {
                    type: 'params',
                    required: [
                        'uri'
                    ],
                    properties: {
                        uri: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'AT-URI of the subject (eg, a post record).'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid',
                            description: 'CID of the subject record (aka, specific version of record), to filter likes.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'likes'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            cursor: {
                                type: 'string'
                            },
                            likes: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.getLikes#like'
                                }
                            }
                        }
                    }
                }
            },
            like: {
                type: 'object',
                required: [
                    'indexedAt',
                    'createdAt',
                    'actor'
                ],
                properties: {
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    actor: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    }
                }
            }
        }
    },
    AppBskyFeedGetListFeed: {
        lexicon: 1,
        id: 'app.bsky.feed.getListFeed',
        defs: {
            main: {
                type: 'query',
                description: 'Get a feed of recent posts from a list (posts and reposts from any actors on the list). Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'list'
                    ],
                    properties: {
                        list: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the list record.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#feedViewPost'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'UnknownList'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetPostThread: {
        lexicon: 1,
        id: 'app.bsky.feed.getPostThread',
        defs: {
            main: {
                type: 'query',
                description: 'Get posts in a thread. Does not require auth, but additional metadata and filtering will be applied for authed requests.',
                parameters: {
                    type: 'params',
                    required: [
                        'uri'
                    ],
                    properties: {
                        uri: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to post record.'
                        },
                        depth: {
                            type: 'integer',
                            description: 'How many levels of reply depth should be included in response.',
                            default: 6,
                            minimum: 0,
                            maximum: 1000
                        },
                        parentHeight: {
                            type: 'integer',
                            description: 'How many levels of parent (and grandparent, etc) post to include.',
                            default: 80,
                            minimum: 0,
                            maximum: 1000
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'thread'
                        ],
                        properties: {
                            thread: {
                                type: 'union',
                                refs: [
                                    'lex:app.bsky.feed.defs#threadViewPost',
                                    'lex:app.bsky.feed.defs#notFoundPost',
                                    'lex:app.bsky.feed.defs#blockedPost'
                                ]
                            },
                            threadgate: {
                                type: 'ref',
                                ref: 'lex:app.bsky.feed.defs#threadgateView'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'NotFound'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetPosts: {
        lexicon: 1,
        id: 'app.bsky.feed.getPosts',
        defs: {
            main: {
                type: 'query',
                description: "Gets post views for a specified list of posts (by AT-URI). This is sometimes referred to as 'hydrating' a 'feed skeleton'.",
                parameters: {
                    type: 'params',
                    required: [
                        'uris'
                    ],
                    properties: {
                        uris: {
                            type: 'array',
                            description: 'List of post AT-URIs to return hydrated views for.',
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            maxLength: 25
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'posts'
                        ],
                        properties: {
                            posts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#postView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetQuotes: {
        lexicon: 1,
        id: 'app.bsky.feed.getQuotes',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of quotes for a given post.',
                parameters: {
                    type: 'params',
                    required: [
                        'uri'
                    ],
                    properties: {
                        uri: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) of post record'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid',
                            description: 'If supplied, filters to quotes of specific version (by CID) of the post record.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'posts'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            cursor: {
                                type: 'string'
                            },
                            posts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#postView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetRepostedBy: {
        lexicon: 1,
        id: 'app.bsky.feed.getRepostedBy',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of reposts for a given post.',
                parameters: {
                    type: 'params',
                    required: [
                        'uri'
                    ],
                    properties: {
                        uri: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) of post record'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid',
                            description: 'If supplied, filters to reposts of specific version (by CID) of the post record.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'repostedBy'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            cursor: {
                                type: 'string'
                            },
                            repostedBy: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetSuggestedFeeds: {
        lexicon: 1,
        id: 'app.bsky.feed.getSuggestedFeeds',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of suggested feeds (feed generators) for the requesting account.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feeds'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#generatorView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetTimeline: {
        lexicon: 1,
        id: 'app.bsky.feed.getTimeline',
        defs: {
            main: {
                type: 'query',
                description: "Get a view of the requesting account's home timeline. This is expected to be some form of reverse-chronological feed.",
                parameters: {
                    type: 'params',
                    properties: {
                        algorithm: {
                            type: 'string',
                            description: "Variant 'algorithm' for timeline. Implementation-specific. NOTE: most feed flexibility has been moved to feed generator mechanism."
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#feedViewPost'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedLike: {
        lexicon: 1,
        id: 'app.bsky.feed.like',
        defs: {
            main: {
                type: 'record',
                description: "Record declaring a 'like' of a piece of subject content.",
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'ref',
                            ref: 'lex:com.atproto.repo.strongRef'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedPost: {
        lexicon: 1,
        id: 'app.bsky.feed.post',
        defs: {
            main: {
                type: 'record',
                description: 'Record containing a Bluesky post.',
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'text',
                        'createdAt'
                    ],
                    properties: {
                        text: {
                            type: 'string',
                            maxLength: 3000,
                            maxGraphemes: 300,
                            description: 'The primary post content. May be an empty string, if there are embeds.'
                        },
                        entities: {
                            type: 'array',
                            description: 'DEPRECATED: replaced by app.bsky.richtext.facet.',
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.feed.post#entity'
                            }
                        },
                        facets: {
                            type: 'array',
                            description: 'Annotations of text (mentions, URLs, hashtags, etc)',
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.richtext.facet'
                            }
                        },
                        reply: {
                            type: 'ref',
                            ref: 'lex:app.bsky.feed.post#replyRef'
                        },
                        embed: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.embed.images',
                                'lex:app.bsky.embed.video',
                                'lex:app.bsky.embed.external',
                                'lex:app.bsky.embed.record',
                                'lex:app.bsky.embed.recordWithMedia'
                            ]
                        },
                        langs: {
                            type: 'array',
                            description: 'Indicates human language of post primary text content.',
                            maxLength: 3,
                            items: {
                                type: 'string',
                                format: 'language'
                            }
                        },
                        labels: {
                            type: 'union',
                            description: 'Self-label values for this post. Effectively content warnings.',
                            refs: [
                                'lex:com.atproto.label.defs#selfLabels'
                            ]
                        },
                        tags: {
                            type: 'array',
                            description: 'Additional hashtags, in addition to any included in post text and facets.',
                            maxLength: 8,
                            items: {
                                type: 'string',
                                maxLength: 640,
                                maxGraphemes: 64
                            }
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Client-declared timestamp when this post was originally created.'
                        }
                    }
                }
            },
            replyRef: {
                type: 'object',
                required: [
                    'root',
                    'parent'
                ],
                properties: {
                    root: {
                        type: 'ref',
                        ref: 'lex:com.atproto.repo.strongRef'
                    },
                    parent: {
                        type: 'ref',
                        ref: 'lex:com.atproto.repo.strongRef'
                    }
                }
            },
            entity: {
                type: 'object',
                description: 'Deprecated: use facets instead.',
                required: [
                    'index',
                    'type',
                    'value'
                ],
                properties: {
                    index: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.post#textSlice'
                    },
                    type: {
                        type: 'string',
                        description: "Expected values are 'mention' and 'link'."
                    },
                    value: {
                        type: 'string'
                    }
                }
            },
            textSlice: {
                type: 'object',
                description: 'Deprecated. Use app.bsky.richtext instead -- A text segment. Start is inclusive, end is exclusive. Indices are for utf16-encoded strings.',
                required: [
                    'start',
                    'end'
                ],
                properties: {
                    start: {
                        type: 'integer',
                        minimum: 0
                    },
                    end: {
                        type: 'integer',
                        minimum: 0
                    }
                }
            }
        }
    },
    AppBskyFeedPostgate: {
        lexicon: 1,
        id: 'app.bsky.feed.postgate',
        defs: {
            main: {
                type: 'record',
                key: 'tid',
                description: 'Record defining interaction rules for a post. The record key (rkey) of the postgate record must match the record key of the post, and that record must be in the same repository.',
                record: {
                    type: 'object',
                    required: [
                        'post',
                        'createdAt'
                    ],
                    properties: {
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        },
                        post: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the post record.'
                        },
                        detachedEmbeddingUris: {
                            type: 'array',
                            maxLength: 50,
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            description: 'List of AT-URIs embedding this post that the author has detached from.'
                        },
                        embeddingRules: {
                            description: 'List of rules defining who can embed this post. If value is an empty array or is undefined, no particular rules apply and anyone can embed.',
                            type: 'array',
                            maxLength: 5,
                            items: {
                                type: 'union',
                                refs: [
                                    'lex:app.bsky.feed.postgate#disableRule'
                                ]
                            }
                        }
                    }
                }
            },
            disableRule: {
                type: 'object',
                description: 'Disables embedding of this post.',
                properties: {}
            }
        }
    },
    AppBskyFeedRepost: {
        lexicon: 1,
        id: 'app.bsky.feed.repost',
        defs: {
            main: {
                description: "Record representing a 'repost' of an existing Bluesky post.",
                type: 'record',
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'ref',
                            ref: 'lex:com.atproto.repo.strongRef'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedSearchPosts: {
        lexicon: 1,
        id: 'app.bsky.feed.searchPosts',
        defs: {
            main: {
                type: 'query',
                description: 'Find posts matching search criteria, returning views of those posts.',
                parameters: {
                    type: 'params',
                    required: [
                        'q'
                    ],
                    properties: {
                        q: {
                            type: 'string',
                            description: 'Search query string; syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended.'
                        },
                        sort: {
                            type: 'string',
                            knownValues: [
                                'top',
                                'latest'
                            ],
                            default: 'latest',
                            description: 'Specifies the ranking order of results.'
                        },
                        since: {
                            type: 'string',
                            description: "Filter results for posts after the indicated datetime (inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYYY-MM-DD)."
                        },
                        until: {
                            type: 'string',
                            description: "Filter results for posts before the indicated datetime (not inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYY-MM-DD)."
                        },
                        mentions: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Filter to posts which mention the given account. Handles are resolved to DID before query-time. Only matches rich-text facet mentions.'
                        },
                        author: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Filter to posts by the given account. Handles are resolved to DID before query-time.'
                        },
                        lang: {
                            type: 'string',
                            format: 'language',
                            description: 'Filter to posts in the given language. Expected to be based on post language field, though server may override language detection.'
                        },
                        domain: {
                            type: 'string',
                            description: 'Filter to posts with URLs (facet links or embeds) linking to the given domain (hostname). Server may apply hostname normalization.'
                        },
                        url: {
                            type: 'string',
                            format: 'uri',
                            description: 'Filter to posts with links (facet links or embeds) pointing to this URL. Server may apply URL normalization or fuzzy matching.'
                        },
                        tag: {
                            type: 'array',
                            items: {
                                type: 'string',
                                maxLength: 640,
                                maxGraphemes: 64
                            },
                            description: "Filter to posts with the given tag (hashtag), based on rich-text facet or tag field. Do not include the hash (#) prefix. Multiple tags can be specified, with 'AND' matching."
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string',
                            description: 'Optional pagination mechanism; may not necessarily allow scrolling through entire result set.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'posts'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            hitsTotal: {
                                type: 'integer',
                                description: 'Count of search hits. Optional, may be rounded/truncated, and may not be possible to paginate through all hits.'
                            },
                            posts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#postView'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BadQueryString'
                    }
                ]
            }
        }
    },
    AppBskyFeedSendInteractions: {
        lexicon: 1,
        id: 'app.bsky.feed.sendInteractions',
        defs: {
            main: {
                type: 'procedure',
                description: 'Send information about interactions with feed items back to the feed generator that served them.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'interactions'
                        ],
                        properties: {
                            interactions: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#interaction'
                                }
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {}
                    }
                }
            }
        }
    },
    AppBskyFeedThreadgate: {
        lexicon: 1,
        id: 'app.bsky.feed.threadgate',
        defs: {
            main: {
                type: 'record',
                key: 'tid',
                description: "Record defining interaction gating rules for a thread (aka, reply controls). The record key (rkey) of the threadgate record must match the record key of the thread's root post, and that record must be in the same repository.",
                record: {
                    type: 'object',
                    required: [
                        'post',
                        'createdAt'
                    ],
                    properties: {
                        post: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the post record.'
                        },
                        allow: {
                            description: 'List of rules defining who can reply to this post. If value is an empty array, no one can reply. If value is undefined, anyone can reply.',
                            type: 'array',
                            maxLength: 5,
                            items: {
                                type: 'union',
                                refs: [
                                    'lex:app.bsky.feed.threadgate#mentionRule',
                                    'lex:app.bsky.feed.threadgate#followerRule',
                                    'lex:app.bsky.feed.threadgate#followingRule',
                                    'lex:app.bsky.feed.threadgate#listRule'
                                ]
                            }
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        },
                        hiddenReplies: {
                            type: 'array',
                            maxLength: 50,
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            description: 'List of hidden reply URIs.'
                        }
                    }
                }
            },
            mentionRule: {
                type: 'object',
                description: 'Allow replies from actors mentioned in your post.',
                properties: {}
            },
            followerRule: {
                type: 'object',
                description: 'Allow replies from actors who follow you.',
                properties: {}
            },
            followingRule: {
                type: 'object',
                description: 'Allow replies from actors you follow.',
                properties: {}
            },
            listRule: {
                type: 'object',
                description: 'Allow replies from actors on a list.',
                required: [
                    'list'
                ],
                properties: {
                    list: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            }
        }
    },
    AppBskyGraphBlock: {
        lexicon: 1,
        id: 'app.bsky.graph.block',
        defs: {
            main: {
                type: 'record',
                description: "Record declaring a 'block' relationship against another account. NOTE: blocks are public in Bluesky; see blog posts for details.",
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account to be blocked.'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphDefs: {
        lexicon: 1,
        id: 'app.bsky.graph.defs',
        defs: {
            listViewBasic: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'name',
                    'purpose'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    name: {
                        type: 'string',
                        maxLength: 64,
                        minLength: 1
                    },
                    purpose: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listPurpose'
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    listItemCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listViewerState'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            listView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'creator',
                    'name',
                    'purpose',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    },
                    name: {
                        type: 'string',
                        maxLength: 64,
                        minLength: 1
                    },
                    purpose: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listPurpose'
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 300,
                        maxLength: 3000
                    },
                    descriptionFacets: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.richtext.facet'
                        }
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    listItemCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listViewerState'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            listItemView: {
                type: 'object',
                required: [
                    'uri',
                    'subject'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    subject: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    }
                }
            },
            starterPackView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'record',
                    'creator',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    record: {
                        type: 'unknown'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                    },
                    list: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listViewBasic'
                    },
                    listItemsSample: {
                        type: 'array',
                        maxLength: 12,
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.graph.defs#listItemView'
                        }
                    },
                    feeds: {
                        type: 'array',
                        maxLength: 3,
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.feed.defs#generatorView'
                        }
                    },
                    joinedWeekCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    joinedAllTimeCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            starterPackViewBasic: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'record',
                    'creator',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    record: {
                        type: 'unknown'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                    },
                    listItemCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    joinedWeekCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    joinedAllTimeCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            listPurpose: {
                type: 'string',
                knownValues: [
                    'app.bsky.graph.defs#modlist',
                    'app.bsky.graph.defs#curatelist',
                    'app.bsky.graph.defs#referencelist'
                ]
            },
            modlist: {
                type: 'token',
                description: 'A list of actors to apply an aggregate moderation action (mute/block) on.'
            },
            curatelist: {
                type: 'token',
                description: 'A list of actors used for curation purposes such as list feeds or interaction gating.'
            },
            referencelist: {
                type: 'token',
                description: 'A list of actors used for only for reference purposes such as within a starter pack.'
            },
            listViewerState: {
                type: 'object',
                properties: {
                    muted: {
                        type: 'boolean'
                    },
                    blocked: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            notFoundActor: {
                type: 'object',
                description: 'indicates that a handle or DID could not be resolved',
                required: [
                    'actor',
                    'notFound'
                ],
                properties: {
                    actor: {
                        type: 'string',
                        format: 'at-identifier'
                    },
                    notFound: {
                        type: 'boolean',
                        const: true
                    }
                }
            },
            relationship: {
                type: 'object',
                description: 'lists the bi-directional graph relationships between one actor (not indicated in the object), and the target actors (the DID included in the object)',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    following: {
                        type: 'string',
                        format: 'at-uri',
                        description: 'if the actor follows this DID, this is the AT-URI of the follow record'
                    },
                    followedBy: {
                        type: 'string',
                        format: 'at-uri',
                        description: 'if the actor is followed by this DID, contains the AT-URI of the follow record'
                    }
                }
            }
        }
    },
    AppBskyGraphFollow: {
        lexicon: 1,
        id: 'app.bsky.graph.follow',
        defs: {
            main: {
                type: 'record',
                description: "Record declaring a social 'follow' relationship of another account. Duplicate follows will be ignored by the AppView.",
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'string',
                            format: 'did'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetActorStarterPacks: {
        lexicon: 1,
        id: 'app.bsky.graph.getActorStarterPacks',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of starter packs created by the actor.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#starterPackViewBasic'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetBlocks: {
        lexicon: 1,
        id: 'app.bsky.graph.getBlocks',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates which accounts the requesting account is currently blocking. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'blocks'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            blocks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetFollowers: {
        lexicon: 1,
        id: 'app.bsky.graph.getFollowers',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates accounts which follow a specified account (actor).',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject',
                            'followers'
                        ],
                        properties: {
                            subject: {
                                type: 'ref',
                                ref: 'lex:app.bsky.actor.defs#profileView'
                            },
                            cursor: {
                                type: 'string'
                            },
                            followers: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetFollows: {
        lexicon: 1,
        id: 'app.bsky.graph.getFollows',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates accounts which a specified account (actor) follows.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject',
                            'follows'
                        ],
                        properties: {
                            subject: {
                                type: 'ref',
                                ref: 'lex:app.bsky.actor.defs#profileView'
                            },
                            cursor: {
                                type: 'string'
                            },
                            follows: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetKnownFollowers: {
        lexicon: 1,
        id: 'app.bsky.graph.getKnownFollowers',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates accounts which follow a specified account (actor) and are followed by the viewer.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject',
                            'followers'
                        ],
                        properties: {
                            subject: {
                                type: 'ref',
                                ref: 'lex:app.bsky.actor.defs#profileView'
                            },
                            cursor: {
                                type: 'string'
                            },
                            followers: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetList: {
        lexicon: 1,
        id: 'app.bsky.graph.getList',
        defs: {
            main: {
                type: 'query',
                description: "Gets a 'view' (with additional context) of a specified list.",
                parameters: {
                    type: 'params',
                    required: [
                        'list'
                    ],
                    properties: {
                        list: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) of the list record to hydrate.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'list',
                            'items'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            list: {
                                type: 'ref',
                                ref: 'lex:app.bsky.graph.defs#listView'
                            },
                            items: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#listItemView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetListBlocks: {
        lexicon: 1,
        id: 'app.bsky.graph.getListBlocks',
        defs: {
            main: {
                type: 'query',
                description: 'Get mod lists that the requesting account (actor) is blocking. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'lists'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            lists: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#listView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetListMutes: {
        lexicon: 1,
        id: 'app.bsky.graph.getListMutes',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates mod lists that the requesting account (actor) currently has muted. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'lists'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            lists: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#listView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetLists: {
        lexicon: 1,
        id: 'app.bsky.graph.getLists',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates the lists created by a specified account (actor).',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'The account (actor) to enumerate lists from.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'lists'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            lists: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#listView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetMutes: {
        lexicon: 1,
        id: 'app.bsky.graph.getMutes',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates accounts that the requesting account (actor) currently has muted. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'mutes'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            mutes: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetRelationships: {
        lexicon: 1,
        id: 'app.bsky.graph.getRelationships',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates public relationships between one account, and a list of other accounts. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Primary account requesting relationships for.'
                        },
                        others: {
                            type: 'array',
                            description: "List of 'other' accounts to be related back to the primary.",
                            maxLength: 30,
                            items: {
                                type: 'string',
                                format: 'at-identifier'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'relationships'
                        ],
                        properties: {
                            actor: {
                                type: 'string',
                                format: 'did'
                            },
                            relationships: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:app.bsky.graph.defs#relationship',
                                        'lex:app.bsky.graph.defs#notFoundActor'
                                    ]
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'ActorNotFound',
                        description: 'the primary actor at-identifier could not be resolved'
                    }
                ]
            }
        }
    },
    AppBskyGraphGetStarterPack: {
        lexicon: 1,
        id: 'app.bsky.graph.getStarterPack',
        defs: {
            main: {
                type: 'query',
                description: 'Gets a view of a starter pack.',
                parameters: {
                    type: 'params',
                    required: [
                        'starterPack'
                    ],
                    properties: {
                        starterPack: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) of the starter pack record.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPack'
                        ],
                        properties: {
                            starterPack: {
                                type: 'ref',
                                ref: 'lex:app.bsky.graph.defs#starterPackView'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetStarterPacks: {
        lexicon: 1,
        id: 'app.bsky.graph.getStarterPacks',
        defs: {
            main: {
                type: 'query',
                description: 'Get views for a list of starter packs.',
                parameters: {
                    type: 'params',
                    required: [
                        'uris'
                    ],
                    properties: {
                        uris: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            maxLength: 25
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#starterPackViewBasic'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetSuggestedFollowsByActor: {
        lexicon: 1,
        id: 'app.bsky.graph.getSuggestedFollowsByActor',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates follows similar to a given account (actor). Expected use is to recommend additional accounts immediately after following one account.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'suggestions'
                        ],
                        properties: {
                            suggestions: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            },
                            isFallback: {
                                type: 'boolean',
                                description: 'If true, response has fallen-back to generic results, and is not scoped using relativeToDid',
                                default: false
                            },
                            recId: {
                                type: 'integer',
                                description: 'Snowflake for this recommendation, use when submitting recommendation events.'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphList: {
        lexicon: 1,
        id: 'app.bsky.graph.list',
        defs: {
            main: {
                type: 'record',
                description: 'Record representing a list of accounts (actors). Scope includes both moderation-oriented lists and curration-oriented lists.',
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'name',
                        'purpose',
                        'createdAt'
                    ],
                    properties: {
                        purpose: {
                            type: 'ref',
                            description: 'Defines the purpose of the list (aka, moderation-oriented or curration-oriented)',
                            ref: 'lex:app.bsky.graph.defs#listPurpose'
                        },
                        name: {
                            type: 'string',
                            maxLength: 64,
                            minLength: 1,
                            description: 'Display name for list; can not be empty.'
                        },
                        description: {
                            type: 'string',
                            maxGraphemes: 300,
                            maxLength: 3000
                        },
                        descriptionFacets: {
                            type: 'array',
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.richtext.facet'
                            }
                        },
                        avatar: {
                            type: 'blob',
                            accept: [
                                'image/png',
                                'image/jpeg'
                            ],
                            maxSize: 1000000
                        },
                        labels: {
                            type: 'union',
                            refs: [
                                'lex:com.atproto.label.defs#selfLabels'
                            ]
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphListblock: {
        lexicon: 1,
        id: 'app.bsky.graph.listblock',
        defs: {
            main: {
                type: 'record',
                description: 'Record representing a block relationship against an entire an entire list of accounts (actors).',
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the mod list record.'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphListitem: {
        lexicon: 1,
        id: 'app.bsky.graph.listitem',
        defs: {
            main: {
                type: 'record',
                description: "Record representing an account's inclusion on a specific list. The AppView will ignore duplicate listitem records.",
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'list',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'string',
                            format: 'did',
                            description: 'The account which is included on the list.'
                        },
                        list: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the list record (app.bsky.graph.list).'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphMuteActor: {
        lexicon: 1,
        id: 'app.bsky.graph.muteActor',
        defs: {
            main: {
                type: 'procedure',
                description: 'Creates a mute relationship for the specified account. Mutes are private in Bluesky. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actor'
                        ],
                        properties: {
                            actor: {
                                type: 'string',
                                format: 'at-identifier'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphMuteActorList: {
        lexicon: 1,
        id: 'app.bsky.graph.muteActorList',
        defs: {
            main: {
                type: 'procedure',
                description: 'Creates a mute relationship for the specified list of accounts. Mutes are private in Bluesky. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'list'
                        ],
                        properties: {
                            list: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphMuteThread: {
        lexicon: 1,
        id: 'app.bsky.graph.muteThread',
        defs: {
            main: {
                type: 'procedure',
                description: 'Mutes a thread preventing notifications from the thread and any of its children. Mutes are private in Bluesky. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'root'
                        ],
                        properties: {
                            root: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphSearchStarterPacks: {
        lexicon: 1,
        id: 'app.bsky.graph.searchStarterPacks',
        defs: {
            main: {
                type: 'query',
                description: 'Find starter packs matching search criteria. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'q'
                    ],
                    properties: {
                        q: {
                            type: 'string',
                            description: 'Search query string. Syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#starterPackViewBasic'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphStarterpack: {
        lexicon: 1,
        id: 'app.bsky.graph.starterpack',
        defs: {
            main: {
                type: 'record',
                description: 'Record defining a starter pack of actors and feeds for new users.',
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'name',
                        'list',
                        'createdAt'
                    ],
                    properties: {
                        name: {
                            type: 'string',
                            maxGraphemes: 50,
                            maxLength: 500,
                            minLength: 1,
                            description: 'Display name for starter pack; can not be empty.'
                        },
                        description: {
                            type: 'string',
                            maxGraphemes: 300,
                            maxLength: 3000
                        },
                        descriptionFacets: {
                            type: 'array',
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.richtext.facet'
                            }
                        },
                        list: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the list record.'
                        },
                        feeds: {
                            type: 'array',
                            maxLength: 3,
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.graph.starterpack#feedItem'
                            }
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            },
            feedItem: {
                type: 'object',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            }
        }
    },
    AppBskyGraphUnmuteActor: {
        lexicon: 1,
        id: 'app.bsky.graph.unmuteActor',
        defs: {
            main: {
                type: 'procedure',
                description: 'Unmutes the specified account. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actor'
                        ],
                        properties: {
                            actor: {
                                type: 'string',
                                format: 'at-identifier'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphUnmuteActorList: {
        lexicon: 1,
        id: 'app.bsky.graph.unmuteActorList',
        defs: {
            main: {
                type: 'procedure',
                description: 'Unmutes the specified list of accounts. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'list'
                        ],
                        properties: {
                            list: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphUnmuteThread: {
        lexicon: 1,
        id: 'app.bsky.graph.unmuteThread',
        defs: {
            main: {
                type: 'procedure',
                description: 'Unmutes the specified thread. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'root'
                        ],
                        properties: {
                            root: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyLabelerDefs: {
        lexicon: 1,
        id: 'app.bsky.labeler.defs',
        defs: {
            labelerView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'creator',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    },
                    likeCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.labeler.defs#labelerViewerState'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    }
                }
            },
            labelerViewDetailed: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'creator',
                    'policies',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    },
                    policies: {
                        type: 'ref',
                        ref: 'lex:app.bsky.labeler.defs#labelerPolicies'
                    },
                    likeCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.labeler.defs#labelerViewerState'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    }
                }
            },
            labelerViewerState: {
                type: 'object',
                properties: {
                    like: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            labelerPolicies: {
                type: 'object',
                required: [
                    'labelValues'
                ],
                properties: {
                    labelValues: {
                        type: 'array',
                        description: 'The label values which this labeler publishes. May include global or custom labels.',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#labelValue'
                        }
                    },
                    labelValueDefinitions: {
                        type: 'array',
                        description: 'Label values created by this labeler and scoped exclusively to it. Labels defined here will override global label definitions for this labeler.',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#labelValueDefinition'
                        }
                    }
                }
            }
        }
    },
    AppBskyLabelerGetServices: {
        lexicon: 1,
        id: 'app.bsky.labeler.getServices',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about a list of labeler services.',
                parameters: {
                    type: 'params',
                    required: [
                        'dids'
                    ],
                    properties: {
                        dids: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        },
                        detailed: {
                            type: 'boolean',
                            default: false
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'views'
                        ],
                        properties: {
                            views: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:app.bsky.labeler.defs#labelerView',
                                        'lex:app.bsky.labeler.defs#labelerViewDetailed'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyLabelerService: {
        lexicon: 1,
        id: 'app.bsky.labeler.service',
        defs: {
            main: {
                type: 'record',
                description: 'A declaration of the existence of labeler service.',
                key: 'literal:self',
                record: {
                    type: 'object',
                    required: [
                        'policies',
                        'createdAt'
                    ],
                    properties: {
                        policies: {
                            type: 'ref',
                            ref: 'lex:app.bsky.labeler.defs#labelerPolicies'
                        },
                        labels: {
                            type: 'union',
                            refs: [
                                'lex:com.atproto.label.defs#selfLabels'
                            ]
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationGetUnreadCount: {
        lexicon: 1,
        id: 'app.bsky.notification.getUnreadCount',
        defs: {
            main: {
                type: 'query',
                description: 'Count the number of unread notifications for the requesting account. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        priority: {
                            type: 'boolean'
                        },
                        seenAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'count'
                        ],
                        properties: {
                            count: {
                                type: 'integer'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationListNotifications: {
        lexicon: 1,
        id: 'app.bsky.notification.listNotifications',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerate notifications for the requesting account. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        reasons: {
                            description: 'Notification reasons to include in response.',
                            type: 'array',
                            items: {
                                type: 'string',
                                description: 'A reason that matches the reason property of #notification.'
                            }
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        priority: {
                            type: 'boolean'
                        },
                        cursor: {
                            type: 'string'
                        },
                        seenAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'notifications'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            notifications: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.notification.listNotifications#notification'
                                }
                            },
                            priority: {
                                type: 'boolean'
                            },
                            seenAt: {
                                type: 'string',
                                format: 'datetime'
                            }
                        }
                    }
                }
            },
            notification: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'author',
                    'reason',
                    'record',
                    'isRead',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    author: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    },
                    reason: {
                        type: 'string',
                        description: "Expected values are 'like', 'repost', 'follow', 'mention', 'reply', 'quote', and 'starterpack-joined'.",
                        knownValues: [
                            'like',
                            'repost',
                            'follow',
                            'mention',
                            'reply',
                            'quote',
                            'starterpack-joined'
                        ]
                    },
                    reasonSubject: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    record: {
                        type: 'unknown'
                    },
                    isRead: {
                        type: 'boolean'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationPutPreferences: {
        lexicon: 1,
        id: 'app.bsky.notification.putPreferences',
        defs: {
            main: {
                type: 'procedure',
                description: 'Set notification-related preferences for an account. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'priority'
                        ],
                        properties: {
                            priority: {
                                type: 'boolean'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationRegisterPush: {
        lexicon: 1,
        id: 'app.bsky.notification.registerPush',
        defs: {
            main: {
                type: 'procedure',
                description: 'Register to receive push notifications, via a specified service, for the requesting account. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'serviceDid',
                            'token',
                            'platform',
                            'appId'
                        ],
                        properties: {
                            serviceDid: {
                                type: 'string',
                                format: 'did'
                            },
                            token: {
                                type: 'string'
                            },
                            platform: {
                                type: 'string',
                                knownValues: [
                                    'ios',
                                    'android',
                                    'web'
                                ]
                            },
                            appId: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationUpdateSeen: {
        lexicon: 1,
        id: 'app.bsky.notification.updateSeen',
        defs: {
            main: {
                type: 'procedure',
                description: 'Notify server that the requesting account has seen notifications. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'seenAt'
                        ],
                        properties: {
                            seenAt: {
                                type: 'string',
                                format: 'datetime'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyRichtextFacet: {
        lexicon: 1,
        id: 'app.bsky.richtext.facet',
        defs: {
            main: {
                type: 'object',
                description: 'Annotation of a sub-string within rich text.',
                required: [
                    'index',
                    'features'
                ],
                properties: {
                    index: {
                        type: 'ref',
                        ref: 'lex:app.bsky.richtext.facet#byteSlice'
                    },
                    features: {
                        type: 'array',
                        items: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.richtext.facet#mention',
                                'lex:app.bsky.richtext.facet#link',
                                'lex:app.bsky.richtext.facet#tag'
                            ]
                        }
                    }
                }
            },
            mention: {
                type: 'object',
                description: "Facet feature for mention of another account. The text is usually a handle, including a '@' prefix, but the facet reference is a DID.",
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            link: {
                type: 'object',
                description: 'Facet feature for a URL. The text URL may have been simplified or truncated, but the facet reference should be a complete URL.',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'uri'
                    }
                }
            },
            tag: {
                type: 'object',
                description: "Facet feature for a hashtag. The text usually includes a '#' prefix, but the facet reference should not (except in the case of 'double hash tags').",
                required: [
                    'tag'
                ],
                properties: {
                    tag: {
                        type: 'string',
                        maxLength: 640,
                        maxGraphemes: 64
                    }
                }
            },
            byteSlice: {
                type: 'object',
                description: 'Specifies the sub-string range a facet feature applies to. Start index is inclusive, end index is exclusive. Indices are zero-indexed, counting bytes of the UTF-8 encoded text. NOTE: some languages, like Javascript, use UTF-16 or Unicode codepoints for string slice indexing; in these languages, convert to byte arrays before working with facets.',
                required: [
                    'byteStart',
                    'byteEnd'
                ],
                properties: {
                    byteStart: {
                        type: 'integer',
                        minimum: 0
                    },
                    byteEnd: {
                        type: 'integer',
                        minimum: 0
                    }
                }
            }
        }
    },
    AppBskyUnspeccedDefs: {
        lexicon: 1,
        id: 'app.bsky.unspecced.defs',
        defs: {
            skeletonSearchPost: {
                type: 'object',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            skeletonSearchActor: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            skeletonSearchStarterPack: {
                type: 'object',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            trendingTopic: {
                type: 'object',
                required: [
                    'topic',
                    'link'
                ],
                properties: {
                    topic: {
                        type: 'string'
                    },
                    displayName: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    link: {
                        type: 'string'
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetConfig: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getConfig',
        defs: {
            main: {
                type: 'query',
                description: 'Get miscellaneous runtime configuration.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [],
                        properties: {
                            checkEmailConfirmed: {
                                type: 'boolean'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetPopularFeedGenerators: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getPopularFeedGenerators',
        defs: {
            main: {
                type: 'query',
                description: 'An unspecced view of globally popular feed generators.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        query: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feeds'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#generatorView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetSuggestionsSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getSuggestionsSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Get a skeleton of suggested actors. Intended to be called and then hydrated through app.bsky.actor.getSuggestions',
                parameters: {
                    type: 'params',
                    properties: {
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries). Used to boost followed accounts in ranking.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        relativeToDid: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account to get suggestions relative to. If not provided, suggestions will be based on the viewer.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actors'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            actors: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#skeletonSearchActor'
                                }
                            },
                            relativeToDid: {
                                type: 'string',
                                format: 'did',
                                description: 'DID of the account these suggestions are relative to. If this is returned undefined, suggestions are based on the viewer.'
                            },
                            recId: {
                                type: 'integer',
                                description: 'Snowflake for this recommendation, use when submitting recommendation events.'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetTaggedSuggestions: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getTaggedSuggestions',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of suggestions (feeds and users) tagged with categories',
                parameters: {
                    type: 'params',
                    properties: {}
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'suggestions'
                        ],
                        properties: {
                            suggestions: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.getTaggedSuggestions#suggestion'
                                }
                            }
                        }
                    }
                }
            },
            suggestion: {
                type: 'object',
                required: [
                    'tag',
                    'subjectType',
                    'subject'
                ],
                properties: {
                    tag: {
                        type: 'string'
                    },
                    subjectType: {
                        type: 'string',
                        knownValues: [
                            'actor',
                            'feed'
                        ]
                    },
                    subject: {
                        type: 'string',
                        format: 'uri'
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetTrendingTopics: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getTrendingTopics',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of trending topics',
                parameters: {
                    type: 'params',
                    properties: {
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries). Used to boost followed accounts in ranking.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 25,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'topics',
                            'suggested'
                        ],
                        properties: {
                            topics: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#trendingTopic'
                                }
                            },
                            suggested: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#trendingTopic'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedSearchActorsSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.searchActorsSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Backend Actors (profile) search, returns only skeleton.',
                parameters: {
                    type: 'params',
                    required: [
                        'q'
                    ],
                    properties: {
                        q: {
                            type: 'string',
                            description: 'Search query string; syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended. For typeahead search, only simple term match is supported, not full syntax.'
                        },
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries). Used to boost followed accounts in ranking.'
                        },
                        typeahead: {
                            type: 'boolean',
                            description: "If true, acts as fast/simple 'typeahead' query."
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string',
                            description: 'Optional pagination mechanism; may not necessarily allow scrolling through entire result set.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actors'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            hitsTotal: {
                                type: 'integer',
                                description: 'Count of search hits. Optional, may be rounded/truncated, and may not be possible to paginate through all hits.'
                            },
                            actors: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#skeletonSearchActor'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BadQueryString'
                    }
                ]
            }
        }
    },
    AppBskyUnspeccedSearchPostsSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.searchPostsSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Backend Posts search, returns only skeleton',
                parameters: {
                    type: 'params',
                    required: [
                        'q'
                    ],
                    properties: {
                        q: {
                            type: 'string',
                            description: 'Search query string; syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended.'
                        },
                        sort: {
                            type: 'string',
                            knownValues: [
                                'top',
                                'latest'
                            ],
                            default: 'latest',
                            description: 'Specifies the ranking order of results.'
                        },
                        since: {
                            type: 'string',
                            description: "Filter results for posts after the indicated datetime (inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYYY-MM-DD)."
                        },
                        until: {
                            type: 'string',
                            description: "Filter results for posts before the indicated datetime (not inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYY-MM-DD)."
                        },
                        mentions: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Filter to posts which mention the given account. Handles are resolved to DID before query-time. Only matches rich-text facet mentions.'
                        },
                        author: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Filter to posts by the given account. Handles are resolved to DID before query-time.'
                        },
                        lang: {
                            type: 'string',
                            format: 'language',
                            description: 'Filter to posts in the given language. Expected to be based on post language field, though server may override language detection.'
                        },
                        domain: {
                            type: 'string',
                            description: 'Filter to posts with URLs (facet links or embeds) linking to the given domain (hostname). Server may apply hostname normalization.'
                        },
                        url: {
                            type: 'string',
                            format: 'uri',
                            description: 'Filter to posts with links (facet links or embeds) pointing to this URL. Server may apply URL normalization or fuzzy matching.'
                        },
                        tag: {
                            type: 'array',
                            items: {
                                type: 'string',
                                maxLength: 640,
                                maxGraphemes: 64
                            },
                            description: "Filter to posts with the given tag (hashtag), based on rich-text facet or tag field. Do not include the hash (#) prefix. Multiple tags can be specified, with 'AND' matching."
                        },
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: "DID of the account making the request (not included for public/unauthenticated queries). Used for 'from:me' queries."
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string',
                            description: 'Optional pagination mechanism; may not necessarily allow scrolling through entire result set.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'posts'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            hitsTotal: {
                                type: 'integer',
                                description: 'Count of search hits. Optional, may be rounded/truncated, and may not be possible to paginate through all hits.'
                            },
                            posts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#skeletonSearchPost'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BadQueryString'
                    }
                ]
            }
        }
    },
    AppBskyUnspeccedSearchStarterPacksSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.searchStarterPacksSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Backend Starter Pack search, returns only skeleton.',
                parameters: {
                    type: 'params',
                    required: [
                        'q'
                    ],
                    properties: {
                        q: {
                            type: 'string',
                            description: 'Search query string; syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended.'
                        },
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries).'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string',
                            description: 'Optional pagination mechanism; may not necessarily allow scrolling through entire result set.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            hitsTotal: {
                                type: 'integer',
                                description: 'Count of search hits. Optional, may be rounded/truncated, and may not be possible to paginate through all hits.'
                            },
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#skeletonSearchStarterPack'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BadQueryString'
                    }
                ]
            }
        }
    },
    AppBskyVideoDefs: {
        lexicon: 1,
        id: 'app.bsky.video.defs',
        defs: {
            jobStatus: {
                type: 'object',
                required: [
                    'jobId',
                    'did',
                    'state'
                ],
                properties: {
                    jobId: {
                        type: 'string'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    state: {
                        type: 'string',
                        description: 'The state of the video processing job. All values not listed as a known value indicate that the job is in process.',
                        knownValues: [
                            'JOB_STATE_COMPLETED',
                            'JOB_STATE_FAILED'
                        ]
                    },
                    progress: {
                        type: 'integer',
                        minimum: 0,
                        maximum: 100,
                        description: 'Progress within the current processing state.'
                    },
                    blob: {
                        type: 'blob'
                    },
                    error: {
                        type: 'string'
                    },
                    message: {
                        type: 'string'
                    }
                }
            }
        }
    },
    AppBskyVideoGetJobStatus: {
        lexicon: 1,
        id: 'app.bsky.video.getJobStatus',
        defs: {
            main: {
                type: 'query',
                description: 'Get status details for a video processing job.',
                parameters: {
                    type: 'params',
                    required: [
                        'jobId'
                    ],
                    properties: {
                        jobId: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'jobStatus'
                        ],
                        properties: {
                            jobStatus: {
                                type: 'ref',
                                ref: 'lex:app.bsky.video.defs#jobStatus'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyVideoGetUploadLimits: {
        lexicon: 1,
        id: 'app.bsky.video.getUploadLimits',
        defs: {
            main: {
                type: 'query',
                description: 'Get video upload limits for the authenticated user.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'canUpload'
                        ],
                        properties: {
                            canUpload: {
                                type: 'boolean'
                            },
                            remainingDailyVideos: {
                                type: 'integer'
                            },
                            remainingDailyBytes: {
                                type: 'integer'
                            },
                            message: {
                                type: 'string'
                            },
                            error: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyVideoUploadVideo: {
        lexicon: 1,
        id: 'app.bsky.video.uploadVideo',
        defs: {
            main: {
                type: 'procedure',
                description: 'Upload a video to be processed then stored on the PDS.',
                input: {
                    encoding: 'video/mp4'
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'jobStatus'
                        ],
                        properties: {
                            jobStatus: {
                                type: 'ref',
                                ref: 'lex:app.bsky.video.defs#jobStatus'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyActorDeclaration: {
        lexicon: 1,
        id: 'chat.bsky.actor.declaration',
        defs: {
            main: {
                type: 'record',
                description: 'A declaration of a Bluesky chat account.',
                key: 'literal:self',
                record: {
                    type: 'object',
                    required: [
                        'allowIncoming'
                    ],
                    properties: {
                        allowIncoming: {
                            type: 'string',
                            knownValues: [
                                'all',
                                'none',
                                'following'
                            ]
                        }
                    }
                }
            }
        }
    },
    ChatBskyActorDefs: {
        lexicon: 1,
        id: 'chat.bsky.actor.defs',
        defs: {
            profileViewBasic: {
                type: 'object',
                required: [
                    'did',
                    'handle'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    displayName: {
                        type: 'string',
                        maxGraphemes: 64,
                        maxLength: 640
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    associated: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileAssociated'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#viewerState'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    chatDisabled: {
                        type: 'boolean',
                        description: 'Set to true when the actor cannot actively participate in converations'
                    }
                }
            }
        }
    },
    ChatBskyActorDeleteAccount: {
        lexicon: 1,
        id: 'chat.bsky.actor.deleteAccount',
        defs: {
            main: {
                type: 'procedure',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {}
                    }
                }
            }
        }
    },
    ChatBskyActorExportAccountData: {
        lexicon: 1,
        id: 'chat.bsky.actor.exportAccountData',
        defs: {
            main: {
                type: 'query',
                output: {
                    encoding: 'application/jsonl'
                }
            }
        }
    },
    ChatBskyConvoDefs: {
        lexicon: 1,
        id: 'chat.bsky.convo.defs',
        defs: {
            messageRef: {
                type: 'object',
                required: [
                    'did',
                    'messageId',
                    'convoId'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    convoId: {
                        type: 'string'
                    },
                    messageId: {
                        type: 'string'
                    }
                }
            },
            messageInput: {
                type: 'object',
                required: [
                    'text'
                ],
                properties: {
                    text: {
                        type: 'string',
                        maxLength: 10000,
                        maxGraphemes: 1000
                    },
                    facets: {
                        type: 'array',
                        description: 'Annotations of text (mentions, URLs, hashtags, etc)',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.richtext.facet'
                        }
                    },
                    embed: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.record'
                        ]
                    }
                }
            },
            messageView: {
                type: 'object',
                required: [
                    'id',
                    'rev',
                    'text',
                    'sender',
                    'sentAt'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    rev: {
                        type: 'string'
                    },
                    text: {
                        type: 'string',
                        maxLength: 10000,
                        maxGraphemes: 1000
                    },
                    facets: {
                        type: 'array',
                        description: 'Annotations of text (mentions, URLs, hashtags, etc)',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.richtext.facet'
                        }
                    },
                    embed: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.record#view'
                        ]
                    },
                    sender: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#messageViewSender'
                    },
                    sentAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            deletedMessageView: {
                type: 'object',
                required: [
                    'id',
                    'rev',
                    'sender',
                    'sentAt'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    rev: {
                        type: 'string'
                    },
                    sender: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#messageViewSender'
                    },
                    sentAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            messageViewSender: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            convoView: {
                type: 'object',
                required: [
                    'id',
                    'rev',
                    'members',
                    'muted',
                    'unreadCount'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    rev: {
                        type: 'string'
                    },
                    members: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:chat.bsky.actor.defs#profileViewBasic'
                        }
                    },
                    lastMessage: {
                        type: 'union',
                        refs: [
                            'lex:chat.bsky.convo.defs#messageView',
                            'lex:chat.bsky.convo.defs#deletedMessageView'
                        ]
                    },
                    muted: {
                        type: 'boolean'
                    },
                    opened: {
                        type: 'boolean'
                    },
                    unreadCount: {
                        type: 'integer'
                    }
                }
            },
            logBeginConvo: {
                type: 'object',
                required: [
                    'rev',
                    'convoId'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    }
                }
            },
            logLeaveConvo: {
                type: 'object',
                required: [
                    'rev',
                    'convoId'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    }
                }
            },
            logCreateMessage: {
                type: 'object',
                required: [
                    'rev',
                    'convoId',
                    'message'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    },
                    message: {
                        type: 'union',
                        refs: [
                            'lex:chat.bsky.convo.defs#messageView',
                            'lex:chat.bsky.convo.defs#deletedMessageView'
                        ]
                    }
                }
            },
            logDeleteMessage: {
                type: 'object',
                required: [
                    'rev',
                    'convoId',
                    'message'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    },
                    message: {
                        type: 'union',
                        refs: [
                            'lex:chat.bsky.convo.defs#messageView',
                            'lex:chat.bsky.convo.defs#deletedMessageView'
                        ]
                    }
                }
            }
        }
    },
    ChatBskyConvoDeleteMessageForSelf: {
        lexicon: 1,
        id: 'chat.bsky.convo.deleteMessageForSelf',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId',
                            'messageId'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            },
                            messageId: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#deletedMessageView'
                    }
                }
            }
        }
    },
    ChatBskyConvoGetConvo: {
        lexicon: 1,
        id: 'chat.bsky.convo.getConvo',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [
                        'convoId'
                    ],
                    properties: {
                        convoId: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convo'
                        ],
                        properties: {
                            convo: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#convoView'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoGetConvoForMembers: {
        lexicon: 1,
        id: 'chat.bsky.convo.getConvoForMembers',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [
                        'members'
                    ],
                    properties: {
                        members: {
                            type: 'array',
                            minLength: 1,
                            maxLength: 10,
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convo'
                        ],
                        properties: {
                            convo: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#convoView'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoGetLog: {
        lexicon: 1,
        id: 'chat.bsky.convo.getLog',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [],
                    properties: {
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'logs'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            logs: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:chat.bsky.convo.defs#logBeginConvo',
                                        'lex:chat.bsky.convo.defs#logLeaveConvo',
                                        'lex:chat.bsky.convo.defs#logCreateMessage',
                                        'lex:chat.bsky.convo.defs#logDeleteMessage'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoGetMessages: {
        lexicon: 1,
        id: 'chat.bsky.convo.getMessages',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [
                        'convoId'
                    ],
                    properties: {
                        convoId: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'messages'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            messages: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:chat.bsky.convo.defs#messageView',
                                        'lex:chat.bsky.convo.defs#deletedMessageView'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoLeaveConvo: {
        lexicon: 1,
        id: 'chat.bsky.convo.leaveConvo',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId',
                            'rev'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            },
                            rev: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoListConvos: {
        lexicon: 1,
        id: 'chat.bsky.convo.listConvos',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convos'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            convos: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:chat.bsky.convo.defs#convoView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoMuteConvo: {
        lexicon: 1,
        id: 'chat.bsky.convo.muteConvo',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convo'
                        ],
                        properties: {
                            convo: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#convoView'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoSendMessage: {
        lexicon: 1,
        id: 'chat.bsky.convo.sendMessage',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId',
                            'message'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            },
                            message: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#messageInput'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#messageView'
                    }
                }
            }
        }
    },
    ChatBskyConvoSendMessageBatch: {
        lexicon: 1,
        id: 'chat.bsky.convo.sendMessageBatch',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'items'
                        ],
                        properties: {
                            items: {
                                type: 'array',
                                maxLength: 100,
                                items: {
                                    type: 'ref',
                                    ref: 'lex:chat.bsky.convo.sendMessageBatch#batchItem'
                                }
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'items'
                        ],
                        properties: {
                            items: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:chat.bsky.convo.defs#messageView'
                                }
                            }
                        }
                    }
                }
            },
            batchItem: {
                type: 'object',
                required: [
                    'convoId',
                    'message'
                ],
                properties: {
                    convoId: {
                        type: 'string'
                    },
                    message: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#messageInput'
                    }
                }
            }
        }
    },
    ChatBskyConvoUnmuteConvo: {
        lexicon: 1,
        id: 'chat.bsky.convo.unmuteConvo',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convo'
                        ],
                        properties: {
                            convo: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#convoView'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoUpdateRead: {
        lexicon: 1,
        id: 'chat.bsky.convo.updateRead',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            },
                            messageId: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convo'
                        ],
                        properties: {
                            convo: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#convoView'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyModerationGetActorMetadata: {
        lexicon: 1,
        id: 'chat.bsky.moderation.getActorMetadata',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'did'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'day',
                            'month',
                            'all'
                        ],
                        properties: {
                            day: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.moderation.getActorMetadata#metadata'
                            },
                            month: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.moderation.getActorMetadata#metadata'
                            },
                            all: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.moderation.getActorMetadata#metadata'
                            }
                        }
                    }
                }
            },
            metadata: {
                type: 'object',
                required: [
                    'messagesSent',
                    'messagesReceived',
                    'convos',
                    'convosStarted'
                ],
                properties: {
                    messagesSent: {
                        type: 'integer'
                    },
                    messagesReceived: {
                        type: 'integer'
                    },
                    convos: {
                        type: 'integer'
                    },
                    convosStarted: {
                        type: 'integer'
                    }
                }
            }
        }
    },
    ChatBskyModerationGetMessageContext: {
        lexicon: 1,
        id: 'chat.bsky.moderation.getMessageContext',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [
                        'messageId'
                    ],
                    properties: {
                        convoId: {
                            type: 'string',
                            description: 'Conversation that the message is from. NOTE: this field will eventually be required.'
                        },
                        messageId: {
                            type: 'string'
                        },
                        before: {
                            type: 'integer',
                            default: 5
                        },
                        after: {
                            type: 'integer',
                            default: 5
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'messages'
                        ],
                        properties: {
                            messages: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:chat.bsky.convo.defs#messageView',
                                        'lex:chat.bsky.convo.defs#deletedMessageView'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyModerationUpdateActorAccess: {
        lexicon: 1,
        id: 'chat.bsky.moderation.updateActorAccess',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actor',
                            'allowAccess'
                        ],
                        properties: {
                            actor: {
                                type: 'string',
                                format: 'did'
                            },
                            allowAccess: {
                                type: 'boolean'
                            },
                            ref: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneCommunicationCreateTemplate: {
        lexicon: 1,
        id: 'tools.ozone.communication.createTemplate',
        defs: {
            main: {
                type: 'procedure',
                description: 'Administrative action to create a new, re-usable communication (email for now) template.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject',
                            'contentMarkdown',
                            'name'
                        ],
                        properties: {
                            name: {
                                type: 'string',
                                description: 'Name of the template.'
                            },
                            contentMarkdown: {
                                type: 'string',
                                description: 'Content of the template, markdown supported, can contain variable placeholders.'
                            },
                            subject: {
                                type: 'string',
                                description: 'Subject of the message, used in emails.'
                            },
                            lang: {
                                type: 'string',
                                format: 'language',
                                description: 'Message language.'
                            },
                            createdBy: {
                                type: 'string',
                                format: 'did',
                                description: 'DID of the user who is creating the template.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.communication.defs#templateView'
                    }
                },
                errors: [
                    {
                        name: 'DuplicateTemplateName'
                    }
                ]
            }
        }
    },
    ToolsOzoneCommunicationDefs: {
        lexicon: 1,
        id: 'tools.ozone.communication.defs',
        defs: {
            templateView: {
                type: 'object',
                required: [
                    'id',
                    'name',
                    'contentMarkdown',
                    'disabled',
                    'lastUpdatedBy',
                    'createdAt',
                    'updatedAt'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string',
                        description: 'Name of the template.'
                    },
                    subject: {
                        type: 'string',
                        description: 'Content of the template, can contain markdown and variable placeholders.'
                    },
                    contentMarkdown: {
                        type: 'string',
                        description: 'Subject of the message, used in emails.'
                    },
                    disabled: {
                        type: 'boolean'
                    },
                    lang: {
                        type: 'string',
                        format: 'language',
                        description: 'Message language.'
                    },
                    lastUpdatedBy: {
                        type: 'string',
                        format: 'did',
                        description: 'DID of the user who last updated the template.'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            }
        }
    },
    ToolsOzoneCommunicationDeleteTemplate: {
        lexicon: 1,
        id: 'tools.ozone.communication.deleteTemplate',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete a communication template.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'id'
                        ],
                        properties: {
                            id: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneCommunicationListTemplates: {
        lexicon: 1,
        id: 'tools.ozone.communication.listTemplates',
        defs: {
            main: {
                type: 'query',
                description: 'Get list of all communication templates.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'communicationTemplates'
                        ],
                        properties: {
                            communicationTemplates: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.communication.defs#templateView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneCommunicationUpdateTemplate: {
        lexicon: 1,
        id: 'tools.ozone.communication.updateTemplate',
        defs: {
            main: {
                type: 'procedure',
                description: 'Administrative action to update an existing communication template. Allows passing partial fields to patch specific fields only.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'id'
                        ],
                        properties: {
                            id: {
                                type: 'string',
                                description: 'ID of the template to be updated.'
                            },
                            name: {
                                type: 'string',
                                description: 'Name of the template.'
                            },
                            lang: {
                                type: 'string',
                                format: 'language',
                                description: 'Message language.'
                            },
                            contentMarkdown: {
                                type: 'string',
                                description: 'Content of the template, markdown supported, can contain variable placeholders.'
                            },
                            subject: {
                                type: 'string',
                                description: 'Subject of the message, used in emails.'
                            },
                            updatedBy: {
                                type: 'string',
                                format: 'did',
                                description: 'DID of the user who is updating the template.'
                            },
                            disabled: {
                                type: 'boolean'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.communication.defs#templateView'
                    }
                },
                errors: [
                    {
                        name: 'DuplicateTemplateName'
                    }
                ]
            }
        }
    },
    ToolsOzoneModerationDefs: {
        lexicon: 1,
        id: 'tools.ozone.moderation.defs',
        defs: {
            modEventView: {
                type: 'object',
                required: [
                    'id',
                    'event',
                    'subject',
                    'subjectBlobCids',
                    'createdBy',
                    'createdAt'
                ],
                properties: {
                    id: {
                        type: 'integer'
                    },
                    event: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#modEventTakedown',
                            'lex:tools.ozone.moderation.defs#modEventReverseTakedown',
                            'lex:tools.ozone.moderation.defs#modEventComment',
                            'lex:tools.ozone.moderation.defs#modEventReport',
                            'lex:tools.ozone.moderation.defs#modEventLabel',
                            'lex:tools.ozone.moderation.defs#modEventAcknowledge',
                            'lex:tools.ozone.moderation.defs#modEventEscalate',
                            'lex:tools.ozone.moderation.defs#modEventMute',
                            'lex:tools.ozone.moderation.defs#modEventUnmute',
                            'lex:tools.ozone.moderation.defs#modEventMuteReporter',
                            'lex:tools.ozone.moderation.defs#modEventUnmuteReporter',
                            'lex:tools.ozone.moderation.defs#modEventEmail',
                            'lex:tools.ozone.moderation.defs#modEventResolveAppeal',
                            'lex:tools.ozone.moderation.defs#modEventDivert',
                            'lex:tools.ozone.moderation.defs#modEventTag',
                            'lex:tools.ozone.moderation.defs#accountEvent',
                            'lex:tools.ozone.moderation.defs#identityEvent',
                            'lex:tools.ozone.moderation.defs#recordEvent',
                            'lex:tools.ozone.moderation.defs#modEventPriorityScore'
                        ]
                    },
                    subject: {
                        type: 'union',
                        refs: [
                            'lex:com.atproto.admin.defs#repoRef',
                            'lex:com.atproto.repo.strongRef',
                            'lex:chat.bsky.convo.defs#messageRef'
                        ]
                    },
                    subjectBlobCids: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    },
                    createdBy: {
                        type: 'string',
                        format: 'did'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    creatorHandle: {
                        type: 'string'
                    },
                    subjectHandle: {
                        type: 'string'
                    }
                }
            },
            modEventViewDetail: {
                type: 'object',
                required: [
                    'id',
                    'event',
                    'subject',
                    'subjectBlobs',
                    'createdBy',
                    'createdAt'
                ],
                properties: {
                    id: {
                        type: 'integer'
                    },
                    event: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#modEventTakedown',
                            'lex:tools.ozone.moderation.defs#modEventReverseTakedown',
                            'lex:tools.ozone.moderation.defs#modEventComment',
                            'lex:tools.ozone.moderation.defs#modEventReport',
                            'lex:tools.ozone.moderation.defs#modEventLabel',
                            'lex:tools.ozone.moderation.defs#modEventAcknowledge',
                            'lex:tools.ozone.moderation.defs#modEventEscalate',
                            'lex:tools.ozone.moderation.defs#modEventMute',
                            'lex:tools.ozone.moderation.defs#modEventUnmute',
                            'lex:tools.ozone.moderation.defs#modEventMuteReporter',
                            'lex:tools.ozone.moderation.defs#modEventUnmuteReporter',
                            'lex:tools.ozone.moderation.defs#modEventEmail',
                            'lex:tools.ozone.moderation.defs#modEventResolveAppeal',
                            'lex:tools.ozone.moderation.defs#modEventDivert',
                            'lex:tools.ozone.moderation.defs#modEventTag',
                            'lex:tools.ozone.moderation.defs#accountEvent',
                            'lex:tools.ozone.moderation.defs#identityEvent',
                            'lex:tools.ozone.moderation.defs#recordEvent',
                            'lex:tools.ozone.moderation.defs#modEventPriorityScore'
                        ]
                    },
                    subject: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#repoView',
                            'lex:tools.ozone.moderation.defs#repoViewNotFound',
                            'lex:tools.ozone.moderation.defs#recordView',
                            'lex:tools.ozone.moderation.defs#recordViewNotFound'
                        ]
                    },
                    subjectBlobs: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:tools.ozone.moderation.defs#blobView'
                        }
                    },
                    createdBy: {
                        type: 'string',
                        format: 'did'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            subjectStatusView: {
                type: 'object',
                required: [
                    'id',
                    'subject',
                    'createdAt',
                    'updatedAt',
                    'reviewState'
                ],
                properties: {
                    id: {
                        type: 'integer'
                    },
                    subject: {
                        type: 'union',
                        refs: [
                            'lex:com.atproto.admin.defs#repoRef',
                            'lex:com.atproto.repo.strongRef'
                        ]
                    },
                    hosting: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#accountHosting',
                            'lex:tools.ozone.moderation.defs#recordHosting'
                        ]
                    },
                    subjectBlobCids: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'cid'
                        }
                    },
                    subjectRepoHandle: {
                        type: 'string'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp referencing when the last update was made to the moderation status of the subject'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp referencing the first moderation status impacting event was emitted on the subject'
                    },
                    reviewState: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#subjectReviewState'
                    },
                    comment: {
                        type: 'string',
                        description: 'Sticky comment on the subject.'
                    },
                    priorityScore: {
                        type: 'integer',
                        description: 'Numeric value representing the level of priority. Higher score means higher priority.',
                        minimum: 0,
                        maximum: 100
                    },
                    muteUntil: {
                        type: 'string',
                        format: 'datetime'
                    },
                    muteReportingUntil: {
                        type: 'string',
                        format: 'datetime'
                    },
                    lastReviewedBy: {
                        type: 'string',
                        format: 'did'
                    },
                    lastReviewedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    lastReportedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    lastAppealedAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp referencing when the author of the subject appealed a moderation action'
                    },
                    takendown: {
                        type: 'boolean'
                    },
                    appealed: {
                        type: 'boolean',
                        description: 'True indicates that the a previously taken moderator action was appealed against, by the author of the content. False indicates last appeal was resolved by moderators.'
                    },
                    suspendUntil: {
                        type: 'string',
                        format: 'datetime'
                    },
                    tags: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    },
                    accountStats: {
                        description: 'Statistics related to the account subject',
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#accountStats'
                    },
                    recordsStats: {
                        description: "Statistics related to the record subjects authored by the subject's account",
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#recordsStats'
                    }
                }
            },
            accountStats: {
                description: 'Statistics about a particular account subject',
                type: 'object',
                properties: {
                    reportCount: {
                        description: 'Total number of reports on the account',
                        type: 'integer'
                    },
                    appealCount: {
                        description: 'Total number of appeals against a moderation action on the account',
                        type: 'integer'
                    },
                    suspendCount: {
                        description: 'Number of times the account was suspended',
                        type: 'integer'
                    },
                    escalateCount: {
                        description: 'Number of times the account was escalated',
                        type: 'integer'
                    },
                    takedownCount: {
                        description: 'Number of times the account was taken down',
                        type: 'integer'
                    }
                }
            },
            recordsStats: {
                description: 'Statistics about a set of record subject items',
                type: 'object',
                properties: {
                    totalReports: {
                        description: 'Cumulative sum of the number of reports on the items in the set',
                        type: 'integer'
                    },
                    reportedCount: {
                        description: 'Number of items that were reported at least once',
                        type: 'integer'
                    },
                    escalatedCount: {
                        description: 'Number of items that were escalated at least once',
                        type: 'integer'
                    },
                    appealedCount: {
                        description: 'Number of items that were appealed at least once',
                        type: 'integer'
                    },
                    subjectCount: {
                        description: 'Total number of item in the set',
                        type: 'integer'
                    },
                    pendingCount: {
                        description: 'Number of item currently in "reviewOpen" or "reviewEscalated" state',
                        type: 'integer'
                    },
                    processedCount: {
                        description: 'Number of item currently in "reviewNone" or "reviewClosed" state',
                        type: 'integer'
                    },
                    takendownCount: {
                        description: 'Number of item currently taken down',
                        type: 'integer'
                    }
                }
            },
            subjectReviewState: {
                type: 'string',
                knownValues: [
                    'lex:tools.ozone.moderation.defs#reviewOpen',
                    'lex:tools.ozone.moderation.defs#reviewEscalated',
                    'lex:tools.ozone.moderation.defs#reviewClosed',
                    'lex:tools.ozone.moderation.defs#reviewNone'
                ]
            },
            reviewOpen: {
                type: 'token',
                description: 'Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator'
            },
            reviewEscalated: {
                type: 'token',
                description: 'Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator'
            },
            reviewClosed: {
                type: 'token',
                description: 'Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator'
            },
            reviewNone: {
                type: 'token',
                description: 'Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it'
            },
            modEventTakedown: {
                type: 'object',
                description: 'Take down a subject permanently or temporarily',
                properties: {
                    comment: {
                        type: 'string'
                    },
                    durationInHours: {
                        type: 'integer',
                        description: 'Indicates how long the takedown should be in effect before automatically expiring.'
                    },
                    acknowledgeAccountSubjects: {
                        type: 'boolean',
                        description: 'If true, all other reports on content authored by this account will be resolved (acknowledged).'
                    },
                    policies: {
                        type: 'array',
                        maxLength: 5,
                        items: {
                            type: 'string'
                        },
                        description: 'Names/Keywords of the policies that drove the decision.'
                    }
                }
            },
            modEventReverseTakedown: {
                type: 'object',
                description: 'Revert take down action on a subject',
                properties: {
                    comment: {
                        type: 'string',
                        description: 'Describe reasoning behind the reversal.'
                    }
                }
            },
            modEventResolveAppeal: {
                type: 'object',
                description: 'Resolve appeal on a subject',
                properties: {
                    comment: {
                        type: 'string',
                        description: 'Describe resolution.'
                    }
                }
            },
            modEventComment: {
                type: 'object',
                description: 'Add a comment to a subject',
                required: [
                    'comment'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    sticky: {
                        type: 'boolean',
                        description: 'Make the comment persistent on the subject'
                    }
                }
            },
            modEventReport: {
                type: 'object',
                description: 'Report a subject',
                required: [
                    'reportType'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    isReporterMuted: {
                        type: 'boolean',
                        description: "Set to true if the reporter was muted from reporting at the time of the event. These reports won't impact the reviewState of the subject."
                    },
                    reportType: {
                        type: 'ref',
                        ref: 'lex:com.atproto.moderation.defs#reasonType'
                    }
                }
            },
            modEventLabel: {
                type: 'object',
                description: 'Apply/Negate labels on a subject',
                required: [
                    'createLabelVals',
                    'negateLabelVals'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    createLabelVals: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    },
                    negateLabelVals: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    },
                    durationInHours: {
                        type: 'integer',
                        description: 'Indicates how long the label will remain on the subject. Only applies on labels that are being added.'
                    }
                }
            },
            modEventPriorityScore: {
                type: 'object',
                description: 'Set priority score of the subject. Higher score means higher priority.',
                required: [
                    'score'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    score: {
                        type: 'integer',
                        minimum: 0,
                        maximum: 100
                    }
                }
            },
            modEventAcknowledge: {
                type: 'object',
                properties: {
                    comment: {
                        type: 'string'
                    },
                    acknowledgeAccountSubjects: {
                        type: 'boolean',
                        description: 'If true, all other reports on content authored by this account will be resolved (acknowledged).'
                    }
                }
            },
            modEventEscalate: {
                type: 'object',
                properties: {
                    comment: {
                        type: 'string'
                    }
                }
            },
            modEventMute: {
                type: 'object',
                description: 'Mute incoming reports on a subject',
                required: [
                    'durationInHours'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    durationInHours: {
                        type: 'integer',
                        description: 'Indicates how long the subject should remain muted.'
                    }
                }
            },
            modEventUnmute: {
                type: 'object',
                description: 'Unmute action on a subject',
                properties: {
                    comment: {
                        type: 'string',
                        description: 'Describe reasoning behind the reversal.'
                    }
                }
            },
            modEventMuteReporter: {
                type: 'object',
                description: 'Mute incoming reports from an account',
                properties: {
                    comment: {
                        type: 'string'
                    },
                    durationInHours: {
                        type: 'integer',
                        description: 'Indicates how long the account should remain muted. Falsy value here means a permanent mute.'
                    }
                }
            },
            modEventUnmuteReporter: {
                type: 'object',
                description: 'Unmute incoming reports from an account',
                properties: {
                    comment: {
                        type: 'string',
                        description: 'Describe reasoning behind the reversal.'
                    }
                }
            },
            modEventEmail: {
                type: 'object',
                description: 'Keep a log of outgoing email to a user',
                required: [
                    'subjectLine'
                ],
                properties: {
                    subjectLine: {
                        type: 'string',
                        description: 'The subject line of the email sent to the user.'
                    },
                    content: {
                        type: 'string',
                        description: 'The content of the email sent to the user.'
                    },
                    comment: {
                        type: 'string',
                        description: 'Additional comment about the outgoing comm.'
                    }
                }
            },
            modEventDivert: {
                type: 'object',
                description: "Divert a record's blobs to a 3rd party service for further scanning/tagging",
                properties: {
                    comment: {
                        type: 'string'
                    }
                }
            },
            modEventTag: {
                type: 'object',
                description: 'Add/Remove a tag on a subject',
                required: [
                    'add',
                    'remove'
                ],
                properties: {
                    add: {
                        type: 'array',
                        items: {
                            type: 'string'
                        },
                        description: "Tags to be added to the subject. If already exists, won't be duplicated."
                    },
                    remove: {
                        type: 'array',
                        items: {
                            type: 'string'
                        },
                        description: "Tags to be removed to the subject. Ignores a tag If it doesn't exist, won't be duplicated."
                    },
                    comment: {
                        type: 'string',
                        description: 'Additional comment about added/removed tags.'
                    }
                }
            },
            accountEvent: {
                type: 'object',
                description: 'Logs account status related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking.',
                required: [
                    'timestamp',
                    'active'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    active: {
                        type: 'boolean',
                        description: 'Indicates that the account has a repository which can be fetched from the host that emitted this event.'
                    },
                    status: {
                        type: 'string',
                        knownValues: [
                            'unknown',
                            'deactivated',
                            'deleted',
                            'takendown',
                            'suspended',
                            'tombstoned'
                        ]
                    },
                    timestamp: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            identityEvent: {
                type: 'object',
                description: 'Logs identity related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking.',
                required: [
                    'timestamp'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    pdsHost: {
                        type: 'string',
                        format: 'uri'
                    },
                    tombstone: {
                        type: 'boolean'
                    },
                    timestamp: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            recordEvent: {
                type: 'object',
                description: 'Logs lifecycle event on a record subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking.',
                required: [
                    'timestamp',
                    'op'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    op: {
                        type: 'string',
                        knownValues: [
                            'create',
                            'update',
                            'delete'
                        ]
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    timestamp: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            repoView: {
                type: 'object',
                required: [
                    'did',
                    'handle',
                    'relatedRecords',
                    'indexedAt',
                    'moderation'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    email: {
                        type: 'string'
                    },
                    relatedRecords: {
                        type: 'array',
                        items: {
                            type: 'unknown'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    moderation: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#moderation'
                    },
                    invitedBy: {
                        type: 'ref',
                        ref: 'lex:com.atproto.server.defs#inviteCode'
                    },
                    invitesDisabled: {
                        type: 'boolean'
                    },
                    inviteNote: {
                        type: 'string'
                    },
                    deactivatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    threatSignatures: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.admin.defs#threatSignature'
                        }
                    }
                }
            },
            repoViewDetail: {
                type: 'object',
                required: [
                    'did',
                    'handle',
                    'relatedRecords',
                    'indexedAt',
                    'moderation'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    email: {
                        type: 'string'
                    },
                    relatedRecords: {
                        type: 'array',
                        items: {
                            type: 'unknown'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    moderation: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#moderationDetail'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    invitedBy: {
                        type: 'ref',
                        ref: 'lex:com.atproto.server.defs#inviteCode'
                    },
                    invites: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.server.defs#inviteCode'
                        }
                    },
                    invitesDisabled: {
                        type: 'boolean'
                    },
                    inviteNote: {
                        type: 'string'
                    },
                    emailConfirmedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    deactivatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    threatSignatures: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.admin.defs#threatSignature'
                        }
                    }
                }
            },
            repoViewNotFound: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            recordView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'value',
                    'blobCids',
                    'indexedAt',
                    'moderation',
                    'repo'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    value: {
                        type: 'unknown'
                    },
                    blobCids: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'cid'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    moderation: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#moderation'
                    },
                    repo: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#repoView'
                    }
                }
            },
            recordViewDetail: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'value',
                    'blobs',
                    'indexedAt',
                    'moderation',
                    'repo'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    value: {
                        type: 'unknown'
                    },
                    blobs: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:tools.ozone.moderation.defs#blobView'
                        }
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    moderation: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#moderationDetail'
                    },
                    repo: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#repoView'
                    }
                }
            },
            recordViewNotFound: {
                type: 'object',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            moderation: {
                type: 'object',
                properties: {
                    subjectStatus: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#subjectStatusView'
                    }
                }
            },
            moderationDetail: {
                type: 'object',
                properties: {
                    subjectStatus: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#subjectStatusView'
                    }
                }
            },
            blobView: {
                type: 'object',
                required: [
                    'cid',
                    'mimeType',
                    'size',
                    'createdAt'
                ],
                properties: {
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    mimeType: {
                        type: 'string'
                    },
                    size: {
                        type: 'integer'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    details: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#imageDetails',
                            'lex:tools.ozone.moderation.defs#videoDetails'
                        ]
                    },
                    moderation: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#moderation'
                    }
                }
            },
            imageDetails: {
                type: 'object',
                required: [
                    'width',
                    'height'
                ],
                properties: {
                    width: {
                        type: 'integer'
                    },
                    height: {
                        type: 'integer'
                    }
                }
            },
            videoDetails: {
                type: 'object',
                required: [
                    'width',
                    'height',
                    'length'
                ],
                properties: {
                    width: {
                        type: 'integer'
                    },
                    height: {
                        type: 'integer'
                    },
                    length: {
                        type: 'integer'
                    }
                }
            },
            accountHosting: {
                type: 'object',
                required: [
                    'status'
                ],
                properties: {
                    status: {
                        type: 'string',
                        knownValues: [
                            'takendown',
                            'suspended',
                            'deleted',
                            'deactivated',
                            'unknown'
                        ]
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    deletedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    deactivatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    reactivatedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            recordHosting: {
                type: 'object',
                required: [
                    'status'
                ],
                properties: {
                    status: {
                        type: 'string',
                        knownValues: [
                            'deleted',
                            'unknown'
                        ]
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    deletedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            }
        }
    },
    ToolsOzoneModerationEmitEvent: {
        lexicon: 1,
        id: 'tools.ozone.moderation.emitEvent',
        defs: {
            main: {
                type: 'procedure',
                description: 'Take a moderation action on an actor.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'event',
                            'subject',
                            'createdBy'
                        ],
                        properties: {
                            event: {
                                type: 'union',
                                refs: [
                                    'lex:tools.ozone.moderation.defs#modEventTakedown',
                                    'lex:tools.ozone.moderation.defs#modEventAcknowledge',
                                    'lex:tools.ozone.moderation.defs#modEventEscalate',
                                    'lex:tools.ozone.moderation.defs#modEventComment',
                                    'lex:tools.ozone.moderation.defs#modEventLabel',
                                    'lex:tools.ozone.moderation.defs#modEventReport',
                                    'lex:tools.ozone.moderation.defs#modEventMute',
                                    'lex:tools.ozone.moderation.defs#modEventUnmute',
                                    'lex:tools.ozone.moderation.defs#modEventMuteReporter',
                                    'lex:tools.ozone.moderation.defs#modEventUnmuteReporter',
                                    'lex:tools.ozone.moderation.defs#modEventReverseTakedown',
                                    'lex:tools.ozone.moderation.defs#modEventResolveAppeal',
                                    'lex:tools.ozone.moderation.defs#modEventEmail',
                                    'lex:tools.ozone.moderation.defs#modEventTag',
                                    'lex:tools.ozone.moderation.defs#accountEvent',
                                    'lex:tools.ozone.moderation.defs#identityEvent',
                                    'lex:tools.ozone.moderation.defs#recordEvent',
                                    'lex:tools.ozone.moderation.defs#modEventPriorityScore'
                                ]
                            },
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef'
                                ]
                            },
                            subjectBlobCids: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                    format: 'cid'
                                }
                            },
                            createdBy: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#modEventView'
                    }
                },
                errors: [
                    {
                        name: 'SubjectHasAction'
                    }
                ]
            }
        }
    },
    ToolsOzoneModerationGetEvent: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getEvent',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about a moderation event.',
                parameters: {
                    type: 'params',
                    required: [
                        'id'
                    ],
                    properties: {
                        id: {
                            type: 'integer'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#modEventViewDetail'
                    }
                }
            }
        }
    },
    ToolsOzoneModerationGetRecord: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getRecord',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about a record.',
                parameters: {
                    type: 'params',
                    required: [
                        'uri'
                    ],
                    properties: {
                        uri: {
                            type: 'string',
                            format: 'at-uri'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#recordViewDetail'
                    }
                },
                errors: [
                    {
                        name: 'RecordNotFound'
                    }
                ]
            }
        }
    },
    ToolsOzoneModerationGetRecords: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getRecords',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about some records.',
                parameters: {
                    type: 'params',
                    required: [
                        'uris'
                    ],
                    properties: {
                        uris: {
                            type: 'array',
                            maxLength: 100,
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'records'
                        ],
                        properties: {
                            records: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:tools.ozone.moderation.defs#recordViewDetail',
                                        'lex:tools.ozone.moderation.defs#recordViewNotFound'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneModerationGetRepo: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getRepo',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about a repository.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#repoViewDetail'
                    }
                },
                errors: [
                    {
                        name: 'RepoNotFound'
                    }
                ]
            }
        }
    },
    ToolsOzoneModerationGetRepos: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getRepos',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about some repositories.',
                parameters: {
                    type: 'params',
                    required: [
                        'dids'
                    ],
                    properties: {
                        dids: {
                            type: 'array',
                            maxLength: 100,
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repos'
                        ],
                        properties: {
                            repos: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:tools.ozone.moderation.defs#repoViewDetail',
                                        'lex:tools.ozone.moderation.defs#repoViewNotFound'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneModerationQueryEvents: {
        lexicon: 1,
        id: 'tools.ozone.moderation.queryEvents',
        defs: {
            main: {
                type: 'query',
                description: 'List moderation events related to a subject.',
                parameters: {
                    type: 'params',
                    properties: {
                        types: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'The types of events (fully qualified string in the format of tools.ozone.moderation.defs#modEvent<name>) to filter by. If not specified, all events are returned.'
                        },
                        createdBy: {
                            type: 'string',
                            format: 'did'
                        },
                        sortDirection: {
                            type: 'string',
                            default: 'desc',
                            enum: [
                                'asc',
                                'desc'
                            ],
                            description: 'Sort direction for the events. Defaults to descending order of created at timestamp.'
                        },
                        createdAfter: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Retrieve events created after a given timestamp'
                        },
                        createdBefore: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Retrieve events created before a given timestamp'
                        },
                        subject: {
                            type: 'string',
                            format: 'uri'
                        },
                        collections: {
                            type: 'array',
                            maxLength: 20,
                            description: "If specified, only events where the subject belongs to the given collections will be returned. When subjectType is set to 'account', this will be ignored.",
                            items: {
                                type: 'string',
                                format: 'nsid'
                            }
                        },
                        subjectType: {
                            type: 'string',
                            description: "If specified, only events where the subject is of the given type (account or record) will be returned. When this is set to 'account' the 'collections' parameter will be ignored. When includeAllUserRecords or subject is set, this will be ignored.",
                            knownValues: [
                                'account',
                                'record'
                            ]
                        },
                        includeAllUserRecords: {
                            type: 'boolean',
                            default: false,
                            description: "If true, events on all record types (posts, lists, profile etc.) or records from given 'collections' param, owned by the did are returned."
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        hasComment: {
                            type: 'boolean',
                            description: 'If true, only events with comments are returned'
                        },
                        comment: {
                            type: 'string',
                            description: 'If specified, only events with comments containing the keyword are returned. Apply || separator to use multiple keywords and match using OR condition.'
                        },
                        addedLabels: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'If specified, only events where all of these labels were added are returned'
                        },
                        removedLabels: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'If specified, only events where all of these labels were removed are returned'
                        },
                        addedTags: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'If specified, only events where all of these tags were added are returned'
                        },
                        removedTags: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'If specified, only events where all of these tags were removed are returned'
                        },
                        reportTypes: {
                            type: 'array',
                            items: {
                                type: 'string'
                            }
                        },
                        policies: {
                            type: 'array',
                            items: {
                                type: 'string',
                                description: 'If specified, only events where the action policies match any of the given policies are returned'
                            }
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'events'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            events: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.moderation.defs#modEventView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneModerationQueryStatuses: {
        lexicon: 1,
        id: 'tools.ozone.moderation.queryStatuses',
        defs: {
            main: {
                type: 'query',
                description: 'View moderation statuses of subjects (record or repo).',
                parameters: {
                    type: 'params',
                    properties: {
                        queueCount: {
                            type: 'integer',
                            description: 'Number of queues being used by moderators. Subjects will be split among all queues.'
                        },
                        queueIndex: {
                            type: 'integer',
                            description: 'Index of the queue to fetch subjects from. Works only when queueCount value is specified.'
                        },
                        queueSeed: {
                            type: 'string',
                            description: 'A seeder to shuffle/balance the queue items.'
                        },
                        includeAllUserRecords: {
                            type: 'boolean',
                            description: "All subjects, or subjects from given 'collections' param, belonging to the account specified in the 'subject' param will be returned."
                        },
                        subject: {
                            type: 'string',
                            format: 'uri',
                            description: 'The subject to get the status for.'
                        },
                        comment: {
                            type: 'string',
                            description: 'Search subjects by keyword from comments'
                        },
                        reportedAfter: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects reported after a given timestamp'
                        },
                        reportedBefore: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects reported before a given timestamp'
                        },
                        reviewedAfter: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects reviewed after a given timestamp'
                        },
                        hostingDeletedAfter: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects where the associated record/account was deleted after a given timestamp'
                        },
                        hostingDeletedBefore: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects where the associated record/account was deleted before a given timestamp'
                        },
                        hostingUpdatedAfter: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects where the associated record/account was updated after a given timestamp'
                        },
                        hostingUpdatedBefore: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects where the associated record/account was updated before a given timestamp'
                        },
                        hostingStatuses: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'Search subjects by the status of the associated record/account'
                        },
                        reviewedBefore: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects reviewed before a given timestamp'
                        },
                        includeMuted: {
                            type: 'boolean',
                            description: "By default, we don't include muted subjects in the results. Set this to true to include them."
                        },
                        onlyMuted: {
                            type: 'boolean',
                            description: 'When set to true, only muted subjects and reporters will be returned.'
                        },
                        reviewState: {
                            type: 'string',
                            description: 'Specify when fetching subjects in a certain state'
                        },
                        ignoreSubjects: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'uri'
                            }
                        },
                        lastReviewedBy: {
                            type: 'string',
                            format: 'did',
                            description: 'Get all subject statuses that were reviewed by a specific moderator'
                        },
                        sortField: {
                            type: 'string',
                            default: 'lastReportedAt',
                            enum: [
                                'lastReviewedAt',
                                'lastReportedAt',
                                'reportedRecordsCount',
                                'takendownRecordsCount',
                                'priorityScore'
                            ]
                        },
                        sortDirection: {
                            type: 'string',
                            default: 'desc',
                            enum: [
                                'asc',
                                'desc'
                            ]
                        },
                        takendown: {
                            type: 'boolean',
                            description: 'Get subjects that were taken down'
                        },
                        appealed: {
                            type: 'boolean',
                            description: 'Get subjects in unresolved appealed status'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        tags: {
                            type: 'array',
                            maxLength: 25,
                            items: {
                                type: 'string',
                                description: 'Items in this array are applied with OR filters. To apply AND filter, put all tags in the same string and separate using && characters'
                            }
                        },
                        excludeTags: {
                            type: 'array',
                            items: {
                                type: 'string'
                            }
                        },
                        cursor: {
                            type: 'string'
                        },
                        collections: {
                            type: 'array',
                            maxLength: 20,
                            description: "If specified, subjects belonging to the given collections will be returned. When subjectType is set to 'account', this will be ignored.",
                            items: {
                                type: 'string',
                                format: 'nsid'
                            }
                        },
                        subjectType: {
                            type: 'string',
                            description: "If specified, subjects of the given type (account or record) will be returned. When this is set to 'account' the 'collections' parameter will be ignored. When includeAllUserRecords or subject is set, this will be ignored.",
                            knownValues: [
                                'account',
                                'record'
                            ]
                        },
                        minAccountSuspendCount: {
                            type: 'integer',
                            description: 'If specified, only subjects that belong to an account that has at least this many suspensions will be returned.'
                        },
                        minReportedRecordsCount: {
                            type: 'integer',
                            description: 'If specified, only subjects that belong to an account that has at least this many reported records will be returned.'
                        },
                        minTakendownRecordsCount: {
                            type: 'integer',
                            description: 'If specified, only subjects that belong to an account that has at least this many taken down records will be returned.'
                        },
                        minPriorityScore: {
                            minimum: 0,
                            maximum: 100,
                            type: 'integer',
                            description: 'If specified, only subjects that have priority score value above the given value will be returned.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subjectStatuses'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            subjectStatuses: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.moderation.defs#subjectStatusView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneModerationSearchRepos: {
        lexicon: 1,
        id: 'tools.ozone.moderation.searchRepos',
        defs: {
            main: {
                type: 'query',
                description: 'Find repositories based on a search term.',
                parameters: {
                    type: 'params',
                    properties: {
                        term: {
                            type: 'string',
                            description: "DEPRECATED: use 'q' instead"
                        },
                        q: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repos'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            repos: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.moderation.defs#repoView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneServerGetConfig: {
        lexicon: 1,
        id: 'tools.ozone.server.getConfig',
        defs: {
            main: {
                type: 'query',
                description: "Get details about ozone's server configuration.",
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            appview: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.server.getConfig#serviceConfig'
                            },
                            pds: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.server.getConfig#serviceConfig'
                            },
                            blobDivert: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.server.getConfig#serviceConfig'
                            },
                            chat: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.server.getConfig#serviceConfig'
                            },
                            viewer: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.server.getConfig#viewerConfig'
                            }
                        }
                    }
                }
            },
            serviceConfig: {
                type: 'object',
                properties: {
                    url: {
                        type: 'string',
                        format: 'uri'
                    }
                }
            },
            viewerConfig: {
                type: 'object',
                properties: {
                    role: {
                        type: 'string',
                        knownValues: [
                            'tools.ozone.team.defs#roleAdmin',
                            'tools.ozone.team.defs#roleModerator',
                            'tools.ozone.team.defs#roleTriage'
                        ]
                    }
                }
            }
        }
    },
    ToolsOzoneSetAddValues: {
        lexicon: 1,
        id: 'tools.ozone.set.addValues',
        defs: {
            main: {
                type: 'procedure',
                description: 'Add values to a specific set. Attempting to add values to a set that does not exist will result in an error.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'name',
                            'values'
                        ],
                        properties: {
                            name: {
                                type: 'string',
                                description: 'Name of the set to add values to'
                            },
                            values: {
                                type: 'array',
                                minLength: 1,
                                maxLength: 1000,
                                items: {
                                    type: 'string'
                                },
                                description: 'Array of string values to add to the set'
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSetDefs: {
        lexicon: 1,
        id: 'tools.ozone.set.defs',
        defs: {
            set: {
                type: 'object',
                required: [
                    'name'
                ],
                properties: {
                    name: {
                        type: 'string',
                        minLength: 3,
                        maxLength: 128
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 1024,
                        maxLength: 10240
                    }
                }
            },
            setView: {
                type: 'object',
                required: [
                    'name',
                    'setSize',
                    'createdAt',
                    'updatedAt'
                ],
                properties: {
                    name: {
                        type: 'string',
                        minLength: 3,
                        maxLength: 128
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 1024,
                        maxLength: 10240
                    },
                    setSize: {
                        type: 'integer'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            }
        }
    },
    ToolsOzoneSetDeleteSet: {
        lexicon: 1,
        id: 'tools.ozone.set.deleteSet',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete an entire set. Attempting to delete a set that does not exist will result in an error.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'name'
                        ],
                        properties: {
                            name: {
                                type: 'string',
                                description: 'Name of the set to delete'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {}
                    }
                },
                errors: [
                    {
                        name: 'SetNotFound',
                        description: 'set with the given name does not exist'
                    }
                ]
            }
        }
    },
    ToolsOzoneSetDeleteValues: {
        lexicon: 1,
        id: 'tools.ozone.set.deleteValues',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete values from a specific set. Attempting to delete values that are not in the set will not result in an error',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'name',
                            'values'
                        ],
                        properties: {
                            name: {
                                type: 'string',
                                description: 'Name of the set to delete values from'
                            },
                            values: {
                                type: 'array',
                                minLength: 1,
                                items: {
                                    type: 'string'
                                },
                                description: 'Array of string values to delete from the set'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'SetNotFound',
                        description: 'set with the given name does not exist'
                    }
                ]
            }
        }
    },
    ToolsOzoneSetGetValues: {
        lexicon: 1,
        id: 'tools.ozone.set.getValues',
        defs: {
            main: {
                type: 'query',
                description: 'Get a specific set and its values',
                parameters: {
                    type: 'params',
                    required: [
                        'name'
                    ],
                    properties: {
                        name: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 1000,
                            default: 100
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'set',
                            'values'
                        ],
                        properties: {
                            set: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.set.defs#setView'
                            },
                            values: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            cursor: {
                                type: 'string'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'SetNotFound',
                        description: 'set with the given name does not exist'
                    }
                ]
            }
        }
    },
    ToolsOzoneSetQuerySets: {
        lexicon: 1,
        id: 'tools.ozone.set.querySets',
        defs: {
            main: {
                type: 'query',
                description: 'Query available sets',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        namePrefix: {
                            type: 'string'
                        },
                        sortBy: {
                            type: 'string',
                            enum: [
                                'name',
                                'createdAt',
                                'updatedAt'
                            ],
                            default: 'name'
                        },
                        sortDirection: {
                            type: 'string',
                            default: 'asc',
                            enum: [
                                'asc',
                                'desc'
                            ],
                            description: 'Defaults to ascending order of name field.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'sets'
                        ],
                        properties: {
                            sets: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.set.defs#setView'
                                }
                            },
                            cursor: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSetUpsertSet: {
        lexicon: 1,
        id: 'tools.ozone.set.upsertSet',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create or update set metadata',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.set.defs#set'
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.set.defs#setView'
                    }
                }
            }
        }
    },
    ToolsOzoneSettingDefs: {
        lexicon: 1,
        id: 'tools.ozone.setting.defs',
        defs: {
            option: {
                type: 'object',
                required: [
                    'key',
                    'value',
                    'did',
                    'scope',
                    'createdBy',
                    'lastUpdatedBy'
                ],
                properties: {
                    key: {
                        type: 'string',
                        format: 'nsid'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    value: {
                        type: 'unknown'
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 1024,
                        maxLength: 10240
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    managerRole: {
                        type: 'string',
                        knownValues: [
                            'tools.ozone.team.defs#roleModerator',
                            'tools.ozone.team.defs#roleTriage',
                            'tools.ozone.team.defs#roleAdmin'
                        ]
                    },
                    scope: {
                        type: 'string',
                        knownValues: [
                            'instance',
                            'personal'
                        ]
                    },
                    createdBy: {
                        type: 'string',
                        format: 'did'
                    },
                    lastUpdatedBy: {
                        type: 'string',
                        format: 'did'
                    }
                }
            }
        }
    },
    ToolsOzoneSettingListOptions: {
        lexicon: 1,
        id: 'tools.ozone.setting.listOptions',
        defs: {
            main: {
                type: 'query',
                description: 'List settings with optional filtering',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        scope: {
                            type: 'string',
                            knownValues: [
                                'instance',
                                'personal'
                            ],
                            default: 'instance'
                        },
                        prefix: {
                            type: 'string',
                            description: 'Filter keys by prefix'
                        },
                        keys: {
                            type: 'array',
                            maxLength: 100,
                            items: {
                                type: 'string',
                                format: 'nsid'
                            },
                            description: 'Filter for only the specified keys. Ignored if prefix is provided'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'options'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            options: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.setting.defs#option'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSettingRemoveOptions: {
        lexicon: 1,
        id: 'tools.ozone.setting.removeOptions',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete settings by key',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'keys',
                            'scope'
                        ],
                        properties: {
                            keys: {
                                type: 'array',
                                minLength: 1,
                                maxLength: 200,
                                items: {
                                    type: 'string',
                                    format: 'nsid'
                                }
                            },
                            scope: {
                                type: 'string',
                                knownValues: [
                                    'instance',
                                    'personal'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {}
                    }
                }
            }
        }
    },
    ToolsOzoneSettingUpsertOption: {
        lexicon: 1,
        id: 'tools.ozone.setting.upsertOption',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create or update setting option',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'key',
                            'scope',
                            'value'
                        ],
                        properties: {
                            key: {
                                type: 'string',
                                format: 'nsid'
                            },
                            scope: {
                                type: 'string',
                                knownValues: [
                                    'instance',
                                    'personal'
                                ]
                            },
                            value: {
                                type: 'unknown'
                            },
                            description: {
                                type: 'string',
                                maxLength: 2000
                            },
                            managerRole: {
                                type: 'string',
                                knownValues: [
                                    'tools.ozone.team.defs#roleModerator',
                                    'tools.ozone.team.defs#roleTriage',
                                    'tools.ozone.team.defs#roleAdmin'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'option'
                        ],
                        properties: {
                            option: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.setting.defs#option'
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSignatureDefs: {
        lexicon: 1,
        id: 'tools.ozone.signature.defs',
        defs: {
            sigDetail: {
                type: 'object',
                required: [
                    'property',
                    'value'
                ],
                properties: {
                    property: {
                        type: 'string'
                    },
                    value: {
                        type: 'string'
                    }
                }
            }
        }
    },
    ToolsOzoneSignatureFindCorrelation: {
        lexicon: 1,
        id: 'tools.ozone.signature.findCorrelation',
        defs: {
            main: {
                type: 'query',
                description: 'Find all correlated threat signatures between 2 or more accounts.',
                parameters: {
                    type: 'params',
                    required: [
                        'dids'
                    ],
                    properties: {
                        dids: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'details'
                        ],
                        properties: {
                            details: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.signature.defs#sigDetail'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSignatureFindRelatedAccounts: {
        lexicon: 1,
        id: 'tools.ozone.signature.findRelatedAccounts',
        defs: {
            main: {
                type: 'query',
                description: 'Get accounts that share some matching threat signatures with the root account.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        },
                        cursor: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'accounts'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            accounts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.signature.findRelatedAccounts#relatedAccount'
                                }
                            }
                        }
                    }
                }
            },
            relatedAccount: {
                type: 'object',
                required: [
                    'account'
                ],
                properties: {
                    account: {
                        type: 'ref',
                        ref: 'lex:com.atproto.admin.defs#accountView'
                    },
                    similarities: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:tools.ozone.signature.defs#sigDetail'
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSignatureSearchAccounts: {
        lexicon: 1,
        id: 'tools.ozone.signature.searchAccounts',
        defs: {
            main: {
                type: 'query',
                description: 'Search for accounts that match one or more threat signature values.',
                parameters: {
                    type: 'params',
                    required: [
                        'values'
                    ],
                    properties: {
                        values: {
                            type: 'array',
                            items: {
                                type: 'string'
                            }
                        },
                        cursor: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'accounts'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            accounts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.admin.defs#accountView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneTeamAddMember: {
        lexicon: 1,
        id: 'tools.ozone.team.addMember',
        defs: {
            main: {
                type: 'procedure',
                description: 'Add a member to the ozone team. Requires admin role.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'role'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            role: {
                                type: 'string',
                                knownValues: [
                                    'tools.ozone.team.defs#roleAdmin',
                                    'tools.ozone.team.defs#roleModerator',
                                    'tools.ozone.team.defs#roleTriage'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.team.defs#member'
                    }
                },
                errors: [
                    {
                        name: 'MemberAlreadyExists',
                        description: 'Member already exists in the team.'
                    }
                ]
            }
        }
    },
    ToolsOzoneTeamDefs: {
        lexicon: 1,
        id: 'tools.ozone.team.defs',
        defs: {
            member: {
                type: 'object',
                required: [
                    'did',
                    'role'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    disabled: {
                        type: 'boolean'
                    },
                    profile: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewDetailed'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    lastUpdatedBy: {
                        type: 'string'
                    },
                    role: {
                        type: 'string',
                        knownValues: [
                            'lex:tools.ozone.team.defs#roleAdmin',
                            'lex:tools.ozone.team.defs#roleModerator',
                            'lex:tools.ozone.team.defs#roleTriage'
                        ]
                    }
                }
            },
            roleAdmin: {
                type: 'token',
                description: 'Admin role. Highest level of access, can perform all actions.'
            },
            roleModerator: {
                type: 'token',
                description: 'Moderator role. Can perform most actions.'
            },
            roleTriage: {
                type: 'token',
                description: 'Triage role. Mostly intended for monitoring and escalating issues.'
            }
        }
    },
    ToolsOzoneTeamDeleteMember: {
        lexicon: 1,
        id: 'tools.ozone.team.deleteMember',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete a member from ozone team. Requires admin role.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'MemberNotFound',
                        description: 'The member being deleted does not exist'
                    },
                    {
                        name: 'CannotDeleteSelf',
                        description: 'You can not delete yourself from the team'
                    }
                ]
            }
        }
    },
    ToolsOzoneTeamListMembers: {
        lexicon: 1,
        id: 'tools.ozone.team.listMembers',
        defs: {
            main: {
                type: 'query',
                description: 'List all members with access to the ozone service.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'members'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            members: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.team.defs#member'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneTeamUpdateMember: {
        lexicon: 1,
        id: 'tools.ozone.team.updateMember',
        defs: {
            main: {
                type: 'procedure',
                description: 'Update a member in the ozone service. Requires admin role.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            disabled: {
                                type: 'boolean'
                            },
                            role: {
                                type: 'string',
                                knownValues: [
                                    'tools.ozone.team.defs#roleAdmin',
                                    'tools.ozone.team.defs#roleModerator',
                                    'tools.ozone.team.defs#roleTriage'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.team.defs#member'
                    }
                },
                errors: [
                    {
                        name: 'MemberNotFound',
                        description: 'The member being updated does not exist in the team'
                    }
                ]
            }
        }
    }
};
module.exports.schemas = Object.values(module.exports.schemaDict);
module.exports.lexicons = new $3dCVT.Lexicons(module.exports.schemas);
module.exports.ids = {
    ComAtprotoAdminDefs: 'com.atproto.admin.defs',
    ComAtprotoAdminDeleteAccount: 'com.atproto.admin.deleteAccount',
    ComAtprotoAdminDisableAccountInvites: 'com.atproto.admin.disableAccountInvites',
    ComAtprotoAdminDisableInviteCodes: 'com.atproto.admin.disableInviteCodes',
    ComAtprotoAdminEnableAccountInvites: 'com.atproto.admin.enableAccountInvites',
    ComAtprotoAdminGetAccountInfo: 'com.atproto.admin.getAccountInfo',
    ComAtprotoAdminGetAccountInfos: 'com.atproto.admin.getAccountInfos',
    ComAtprotoAdminGetInviteCodes: 'com.atproto.admin.getInviteCodes',
    ComAtprotoAdminGetSubjectStatus: 'com.atproto.admin.getSubjectStatus',
    ComAtprotoAdminSearchAccounts: 'com.atproto.admin.searchAccounts',
    ComAtprotoAdminSendEmail: 'com.atproto.admin.sendEmail',
    ComAtprotoAdminUpdateAccountEmail: 'com.atproto.admin.updateAccountEmail',
    ComAtprotoAdminUpdateAccountHandle: 'com.atproto.admin.updateAccountHandle',
    ComAtprotoAdminUpdateAccountPassword: 'com.atproto.admin.updateAccountPassword',
    ComAtprotoAdminUpdateSubjectStatus: 'com.atproto.admin.updateSubjectStatus',
    ComAtprotoIdentityGetRecommendedDidCredentials: 'com.atproto.identity.getRecommendedDidCredentials',
    ComAtprotoIdentityRequestPlcOperationSignature: 'com.atproto.identity.requestPlcOperationSignature',
    ComAtprotoIdentityResolveHandle: 'com.atproto.identity.resolveHandle',
    ComAtprotoIdentitySignPlcOperation: 'com.atproto.identity.signPlcOperation',
    ComAtprotoIdentitySubmitPlcOperation: 'com.atproto.identity.submitPlcOperation',
    ComAtprotoIdentityUpdateHandle: 'com.atproto.identity.updateHandle',
    ComAtprotoLabelDefs: 'com.atproto.label.defs',
    ComAtprotoLabelQueryLabels: 'com.atproto.label.queryLabels',
    ComAtprotoLabelSubscribeLabels: 'com.atproto.label.subscribeLabels',
    ComAtprotoLexiconSchema: 'com.atproto.lexicon.schema',
    ComAtprotoModerationCreateReport: 'com.atproto.moderation.createReport',
    ComAtprotoModerationDefs: 'com.atproto.moderation.defs',
    ComAtprotoRepoApplyWrites: 'com.atproto.repo.applyWrites',
    ComAtprotoRepoCreateRecord: 'com.atproto.repo.createRecord',
    ComAtprotoRepoDefs: 'com.atproto.repo.defs',
    ComAtprotoRepoDeleteRecord: 'com.atproto.repo.deleteRecord',
    ComAtprotoRepoDescribeRepo: 'com.atproto.repo.describeRepo',
    ComAtprotoRepoGetRecord: 'com.atproto.repo.getRecord',
    ComAtprotoRepoImportRepo: 'com.atproto.repo.importRepo',
    ComAtprotoRepoListMissingBlobs: 'com.atproto.repo.listMissingBlobs',
    ComAtprotoRepoListRecords: 'com.atproto.repo.listRecords',
    ComAtprotoRepoPutRecord: 'com.atproto.repo.putRecord',
    ComAtprotoRepoStrongRef: 'com.atproto.repo.strongRef',
    ComAtprotoRepoUploadBlob: 'com.atproto.repo.uploadBlob',
    ComAtprotoServerActivateAccount: 'com.atproto.server.activateAccount',
    ComAtprotoServerCheckAccountStatus: 'com.atproto.server.checkAccountStatus',
    ComAtprotoServerConfirmEmail: 'com.atproto.server.confirmEmail',
    ComAtprotoServerCreateAccount: 'com.atproto.server.createAccount',
    ComAtprotoServerCreateAppPassword: 'com.atproto.server.createAppPassword',
    ComAtprotoServerCreateInviteCode: 'com.atproto.server.createInviteCode',
    ComAtprotoServerCreateInviteCodes: 'com.atproto.server.createInviteCodes',
    ComAtprotoServerCreateSession: 'com.atproto.server.createSession',
    ComAtprotoServerDeactivateAccount: 'com.atproto.server.deactivateAccount',
    ComAtprotoServerDefs: 'com.atproto.server.defs',
    ComAtprotoServerDeleteAccount: 'com.atproto.server.deleteAccount',
    ComAtprotoServerDeleteSession: 'com.atproto.server.deleteSession',
    ComAtprotoServerDescribeServer: 'com.atproto.server.describeServer',
    ComAtprotoServerGetAccountInviteCodes: 'com.atproto.server.getAccountInviteCodes',
    ComAtprotoServerGetServiceAuth: 'com.atproto.server.getServiceAuth',
    ComAtprotoServerGetSession: 'com.atproto.server.getSession',
    ComAtprotoServerListAppPasswords: 'com.atproto.server.listAppPasswords',
    ComAtprotoServerRefreshSession: 'com.atproto.server.refreshSession',
    ComAtprotoServerRequestAccountDelete: 'com.atproto.server.requestAccountDelete',
    ComAtprotoServerRequestEmailConfirmation: 'com.atproto.server.requestEmailConfirmation',
    ComAtprotoServerRequestEmailUpdate: 'com.atproto.server.requestEmailUpdate',
    ComAtprotoServerRequestPasswordReset: 'com.atproto.server.requestPasswordReset',
    ComAtprotoServerReserveSigningKey: 'com.atproto.server.reserveSigningKey',
    ComAtprotoServerResetPassword: 'com.atproto.server.resetPassword',
    ComAtprotoServerRevokeAppPassword: 'com.atproto.server.revokeAppPassword',
    ComAtprotoServerUpdateEmail: 'com.atproto.server.updateEmail',
    ComAtprotoSyncGetBlob: 'com.atproto.sync.getBlob',
    ComAtprotoSyncGetBlocks: 'com.atproto.sync.getBlocks',
    ComAtprotoSyncGetCheckout: 'com.atproto.sync.getCheckout',
    ComAtprotoSyncGetHead: 'com.atproto.sync.getHead',
    ComAtprotoSyncGetLatestCommit: 'com.atproto.sync.getLatestCommit',
    ComAtprotoSyncGetRecord: 'com.atproto.sync.getRecord',
    ComAtprotoSyncGetRepo: 'com.atproto.sync.getRepo',
    ComAtprotoSyncGetRepoStatus: 'com.atproto.sync.getRepoStatus',
    ComAtprotoSyncListBlobs: 'com.atproto.sync.listBlobs',
    ComAtprotoSyncListRepos: 'com.atproto.sync.listRepos',
    ComAtprotoSyncNotifyOfUpdate: 'com.atproto.sync.notifyOfUpdate',
    ComAtprotoSyncRequestCrawl: 'com.atproto.sync.requestCrawl',
    ComAtprotoSyncSubscribeRepos: 'com.atproto.sync.subscribeRepos',
    ComAtprotoTempAddReservedHandle: 'com.atproto.temp.addReservedHandle',
    ComAtprotoTempCheckSignupQueue: 'com.atproto.temp.checkSignupQueue',
    ComAtprotoTempFetchLabels: 'com.atproto.temp.fetchLabels',
    ComAtprotoTempRequestPhoneVerification: 'com.atproto.temp.requestPhoneVerification',
    AppBskyActorDefs: 'app.bsky.actor.defs',
    AppBskyActorGetPreferences: 'app.bsky.actor.getPreferences',
    AppBskyActorGetProfile: 'app.bsky.actor.getProfile',
    AppBskyActorGetProfiles: 'app.bsky.actor.getProfiles',
    AppBskyActorGetSuggestions: 'app.bsky.actor.getSuggestions',
    AppBskyActorProfile: 'app.bsky.actor.profile',
    AppBskyActorPutPreferences: 'app.bsky.actor.putPreferences',
    AppBskyActorSearchActors: 'app.bsky.actor.searchActors',
    AppBskyActorSearchActorsTypeahead: 'app.bsky.actor.searchActorsTypeahead',
    AppBskyEmbedDefs: 'app.bsky.embed.defs',
    AppBskyEmbedExternal: 'app.bsky.embed.external',
    AppBskyEmbedImages: 'app.bsky.embed.images',
    AppBskyEmbedRecord: 'app.bsky.embed.record',
    AppBskyEmbedRecordWithMedia: 'app.bsky.embed.recordWithMedia',
    AppBskyEmbedVideo: 'app.bsky.embed.video',
    AppBskyFeedDefs: 'app.bsky.feed.defs',
    AppBskyFeedDescribeFeedGenerator: 'app.bsky.feed.describeFeedGenerator',
    AppBskyFeedGenerator: 'app.bsky.feed.generator',
    AppBskyFeedGetActorFeeds: 'app.bsky.feed.getActorFeeds',
    AppBskyFeedGetActorLikes: 'app.bsky.feed.getActorLikes',
    AppBskyFeedGetAuthorFeed: 'app.bsky.feed.getAuthorFeed',
    AppBskyFeedGetFeed: 'app.bsky.feed.getFeed',
    AppBskyFeedGetFeedGenerator: 'app.bsky.feed.getFeedGenerator',
    AppBskyFeedGetFeedGenerators: 'app.bsky.feed.getFeedGenerators',
    AppBskyFeedGetFeedSkeleton: 'app.bsky.feed.getFeedSkeleton',
    AppBskyFeedGetLikes: 'app.bsky.feed.getLikes',
    AppBskyFeedGetListFeed: 'app.bsky.feed.getListFeed',
    AppBskyFeedGetPostThread: 'app.bsky.feed.getPostThread',
    AppBskyFeedGetPosts: 'app.bsky.feed.getPosts',
    AppBskyFeedGetQuotes: 'app.bsky.feed.getQuotes',
    AppBskyFeedGetRepostedBy: 'app.bsky.feed.getRepostedBy',
    AppBskyFeedGetSuggestedFeeds: 'app.bsky.feed.getSuggestedFeeds',
    AppBskyFeedGetTimeline: 'app.bsky.feed.getTimeline',
    AppBskyFeedLike: 'app.bsky.feed.like',
    AppBskyFeedPost: 'app.bsky.feed.post',
    AppBskyFeedPostgate: 'app.bsky.feed.postgate',
    AppBskyFeedRepost: 'app.bsky.feed.repost',
    AppBskyFeedSearchPosts: 'app.bsky.feed.searchPosts',
    AppBskyFeedSendInteractions: 'app.bsky.feed.sendInteractions',
    AppBskyFeedThreadgate: 'app.bsky.feed.threadgate',
    AppBskyGraphBlock: 'app.bsky.graph.block',
    AppBskyGraphDefs: 'app.bsky.graph.defs',
    AppBskyGraphFollow: 'app.bsky.graph.follow',
    AppBskyGraphGetActorStarterPacks: 'app.bsky.graph.getActorStarterPacks',
    AppBskyGraphGetBlocks: 'app.bsky.graph.getBlocks',
    AppBskyGraphGetFollowers: 'app.bsky.graph.getFollowers',
    AppBskyGraphGetFollows: 'app.bsky.graph.getFollows',
    AppBskyGraphGetKnownFollowers: 'app.bsky.graph.getKnownFollowers',
    AppBskyGraphGetList: 'app.bsky.graph.getList',
    AppBskyGraphGetListBlocks: 'app.bsky.graph.getListBlocks',
    AppBskyGraphGetListMutes: 'app.bsky.graph.getListMutes',
    AppBskyGraphGetLists: 'app.bsky.graph.getLists',
    AppBskyGraphGetMutes: 'app.bsky.graph.getMutes',
    AppBskyGraphGetRelationships: 'app.bsky.graph.getRelationships',
    AppBskyGraphGetStarterPack: 'app.bsky.graph.getStarterPack',
    AppBskyGraphGetStarterPacks: 'app.bsky.graph.getStarterPacks',
    AppBskyGraphGetSuggestedFollowsByActor: 'app.bsky.graph.getSuggestedFollowsByActor',
    AppBskyGraphList: 'app.bsky.graph.list',
    AppBskyGraphListblock: 'app.bsky.graph.listblock',
    AppBskyGraphListitem: 'app.bsky.graph.listitem',
    AppBskyGraphMuteActor: 'app.bsky.graph.muteActor',
    AppBskyGraphMuteActorList: 'app.bsky.graph.muteActorList',
    AppBskyGraphMuteThread: 'app.bsky.graph.muteThread',
    AppBskyGraphSearchStarterPacks: 'app.bsky.graph.searchStarterPacks',
    AppBskyGraphStarterpack: 'app.bsky.graph.starterpack',
    AppBskyGraphUnmuteActor: 'app.bsky.graph.unmuteActor',
    AppBskyGraphUnmuteActorList: 'app.bsky.graph.unmuteActorList',
    AppBskyGraphUnmuteThread: 'app.bsky.graph.unmuteThread',
    AppBskyLabelerDefs: 'app.bsky.labeler.defs',
    AppBskyLabelerGetServices: 'app.bsky.labeler.getServices',
    AppBskyLabelerService: 'app.bsky.labeler.service',
    AppBskyNotificationGetUnreadCount: 'app.bsky.notification.getUnreadCount',
    AppBskyNotificationListNotifications: 'app.bsky.notification.listNotifications',
    AppBskyNotificationPutPreferences: 'app.bsky.notification.putPreferences',
    AppBskyNotificationRegisterPush: 'app.bsky.notification.registerPush',
    AppBskyNotificationUpdateSeen: 'app.bsky.notification.updateSeen',
    AppBskyRichtextFacet: 'app.bsky.richtext.facet',
    AppBskyUnspeccedDefs: 'app.bsky.unspecced.defs',
    AppBskyUnspeccedGetConfig: 'app.bsky.unspecced.getConfig',
    AppBskyUnspeccedGetPopularFeedGenerators: 'app.bsky.unspecced.getPopularFeedGenerators',
    AppBskyUnspeccedGetSuggestionsSkeleton: 'app.bsky.unspecced.getSuggestionsSkeleton',
    AppBskyUnspeccedGetTaggedSuggestions: 'app.bsky.unspecced.getTaggedSuggestions',
    AppBskyUnspeccedGetTrendingTopics: 'app.bsky.unspecced.getTrendingTopics',
    AppBskyUnspeccedSearchActorsSkeleton: 'app.bsky.unspecced.searchActorsSkeleton',
    AppBskyUnspeccedSearchPostsSkeleton: 'app.bsky.unspecced.searchPostsSkeleton',
    AppBskyUnspeccedSearchStarterPacksSkeleton: 'app.bsky.unspecced.searchStarterPacksSkeleton',
    AppBskyVideoDefs: 'app.bsky.video.defs',
    AppBskyVideoGetJobStatus: 'app.bsky.video.getJobStatus',
    AppBskyVideoGetUploadLimits: 'app.bsky.video.getUploadLimits',
    AppBskyVideoUploadVideo: 'app.bsky.video.uploadVideo',
    ChatBskyActorDeclaration: 'chat.bsky.actor.declaration',
    ChatBskyActorDefs: 'chat.bsky.actor.defs',
    ChatBskyActorDeleteAccount: 'chat.bsky.actor.deleteAccount',
    ChatBskyActorExportAccountData: 'chat.bsky.actor.exportAccountData',
    ChatBskyConvoDefs: 'chat.bsky.convo.defs',
    ChatBskyConvoDeleteMessageForSelf: 'chat.bsky.convo.deleteMessageForSelf',
    ChatBskyConvoGetConvo: 'chat.bsky.convo.getConvo',
    ChatBskyConvoGetConvoForMembers: 'chat.bsky.convo.getConvoForMembers',
    ChatBskyConvoGetLog: 'chat.bsky.convo.getLog',
    ChatBskyConvoGetMessages: 'chat.bsky.convo.getMessages',
    ChatBskyConvoLeaveConvo: 'chat.bsky.convo.leaveConvo',
    ChatBskyConvoListConvos: 'chat.bsky.convo.listConvos',
    ChatBskyConvoMuteConvo: 'chat.bsky.convo.muteConvo',
    ChatBskyConvoSendMessage: 'chat.bsky.convo.sendMessage',
    ChatBskyConvoSendMessageBatch: 'chat.bsky.convo.sendMessageBatch',
    ChatBskyConvoUnmuteConvo: 'chat.bsky.convo.unmuteConvo',
    ChatBskyConvoUpdateRead: 'chat.bsky.convo.updateRead',
    ChatBskyModerationGetActorMetadata: 'chat.bsky.moderation.getActorMetadata',
    ChatBskyModerationGetMessageContext: 'chat.bsky.moderation.getMessageContext',
    ChatBskyModerationUpdateActorAccess: 'chat.bsky.moderation.updateActorAccess',
    ToolsOzoneCommunicationCreateTemplate: 'tools.ozone.communication.createTemplate',
    ToolsOzoneCommunicationDefs: 'tools.ozone.communication.defs',
    ToolsOzoneCommunicationDeleteTemplate: 'tools.ozone.communication.deleteTemplate',
    ToolsOzoneCommunicationListTemplates: 'tools.ozone.communication.listTemplates',
    ToolsOzoneCommunicationUpdateTemplate: 'tools.ozone.communication.updateTemplate',
    ToolsOzoneModerationDefs: 'tools.ozone.moderation.defs',
    ToolsOzoneModerationEmitEvent: 'tools.ozone.moderation.emitEvent',
    ToolsOzoneModerationGetEvent: 'tools.ozone.moderation.getEvent',
    ToolsOzoneModerationGetRecord: 'tools.ozone.moderation.getRecord',
    ToolsOzoneModerationGetRecords: 'tools.ozone.moderation.getRecords',
    ToolsOzoneModerationGetRepo: 'tools.ozone.moderation.getRepo',
    ToolsOzoneModerationGetRepos: 'tools.ozone.moderation.getRepos',
    ToolsOzoneModerationQueryEvents: 'tools.ozone.moderation.queryEvents',
    ToolsOzoneModerationQueryStatuses: 'tools.ozone.moderation.queryStatuses',
    ToolsOzoneModerationSearchRepos: 'tools.ozone.moderation.searchRepos',
    ToolsOzoneServerGetConfig: 'tools.ozone.server.getConfig',
    ToolsOzoneSetAddValues: 'tools.ozone.set.addValues',
    ToolsOzoneSetDefs: 'tools.ozone.set.defs',
    ToolsOzoneSetDeleteSet: 'tools.ozone.set.deleteSet',
    ToolsOzoneSetDeleteValues: 'tools.ozone.set.deleteValues',
    ToolsOzoneSetGetValues: 'tools.ozone.set.getValues',
    ToolsOzoneSetQuerySets: 'tools.ozone.set.querySets',
    ToolsOzoneSetUpsertSet: 'tools.ozone.set.upsertSet',
    ToolsOzoneSettingDefs: 'tools.ozone.setting.defs',
    ToolsOzoneSettingListOptions: 'tools.ozone.setting.listOptions',
    ToolsOzoneSettingRemoveOptions: 'tools.ozone.setting.removeOptions',
    ToolsOzoneSettingUpsertOption: 'tools.ozone.setting.upsertOption',
    ToolsOzoneSignatureDefs: 'tools.ozone.signature.defs',
    ToolsOzoneSignatureFindCorrelation: 'tools.ozone.signature.findCorrelation',
    ToolsOzoneSignatureFindRelatedAccounts: 'tools.ozone.signature.findRelatedAccounts',
    ToolsOzoneSignatureSearchAccounts: 'tools.ozone.signature.searchAccounts',
    ToolsOzoneTeamAddMember: 'tools.ozone.team.addMember',
    ToolsOzoneTeamDefs: 'tools.ozone.team.defs',
    ToolsOzoneTeamDeleteMember: 'tools.ozone.team.deleteMember',
    ToolsOzoneTeamListMembers: 'tools.ozone.team.listMembers',
    ToolsOzoneTeamUpdateMember: 'tools.ozone.team.updateMember'
};

});

parcelRegister("cVdHh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidSwapError = void 0;
module.exports.toKnownErr = $026d81c9c3d8c5a9$var$toKnownErr;
module.exports.isCreate = $026d81c9c3d8c5a9$var$isCreate;
module.exports.validateCreate = $026d81c9c3d8c5a9$var$validateCreate;
module.exports.isUpdate = $026d81c9c3d8c5a9$var$isUpdate;
module.exports.validateUpdate = $026d81c9c3d8c5a9$var$validateUpdate;
module.exports.isDelete = $026d81c9c3d8c5a9$var$isDelete;
module.exports.validateDelete = $026d81c9c3d8c5a9$var$validateDelete;
module.exports.isCreateResult = $026d81c9c3d8c5a9$var$isCreateResult;
module.exports.validateCreateResult = $026d81c9c3d8c5a9$var$validateCreateResult;
module.exports.isUpdateResult = $026d81c9c3d8c5a9$var$isUpdateResult;
module.exports.validateUpdateResult = $026d81c9c3d8c5a9$var$validateUpdateResult;
module.exports.isDeleteResult = $026d81c9c3d8c5a9$var$isDeleteResult;
module.exports.validateDeleteResult = $026d81c9c3d8c5a9$var$validateDeleteResult;

var $al5Ta = parcelRequire("al5Ta");

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
class $026d81c9c3d8c5a9$var$InvalidSwapError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidSwapError = $026d81c9c3d8c5a9$var$InvalidSwapError;
function $026d81c9c3d8c5a9$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'InvalidSwap') return new $026d81c9c3d8c5a9$var$InvalidSwapError(e);
    }
    return e;
}
function $026d81c9c3d8c5a9$var$isCreate(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.repo.applyWrites#create';
}
function $026d81c9c3d8c5a9$var$validateCreate(v) {
    return $8DB7o.lexicons.validate('com.atproto.repo.applyWrites#create', v);
}
function $026d81c9c3d8c5a9$var$isUpdate(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.repo.applyWrites#update';
}
function $026d81c9c3d8c5a9$var$validateUpdate(v) {
    return $8DB7o.lexicons.validate('com.atproto.repo.applyWrites#update', v);
}
function $026d81c9c3d8c5a9$var$isDelete(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.repo.applyWrites#delete';
}
function $026d81c9c3d8c5a9$var$validateDelete(v) {
    return $8DB7o.lexicons.validate('com.atproto.repo.applyWrites#delete', v);
}
function $026d81c9c3d8c5a9$var$isCreateResult(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.repo.applyWrites#createResult';
}
function $026d81c9c3d8c5a9$var$validateCreateResult(v) {
    return $8DB7o.lexicons.validate('com.atproto.repo.applyWrites#createResult', v);
}
function $026d81c9c3d8c5a9$var$isUpdateResult(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.repo.applyWrites#updateResult';
}
function $026d81c9c3d8c5a9$var$validateUpdateResult(v) {
    return $8DB7o.lexicons.validate('com.atproto.repo.applyWrites#updateResult', v);
}
function $026d81c9c3d8c5a9$var$isDeleteResult(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.repo.applyWrites#deleteResult';
}
function $026d81c9c3d8c5a9$var$validateDeleteResult(v) {
    return $8DB7o.lexicons.validate('com.atproto.repo.applyWrites#deleteResult', v);
}

});
parcelRegister("9KXK3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isObj = $71a6c0671ff2bf15$var$isObj;
module.exports.hasProp = $71a6c0671ff2bf15$var$hasProp;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ function $71a6c0671ff2bf15$var$isObj(v) {
    return typeof v === 'object' && v !== null;
}
function $71a6c0671ff2bf15$var$hasProp(data, prop) {
    return prop in data;
}

});


parcelRegister("038a8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidSwapError = void 0;
module.exports.toKnownErr = $00969ccfce569794$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $00969ccfce569794$var$InvalidSwapError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidSwapError = $00969ccfce569794$var$InvalidSwapError;
function $00969ccfce569794$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'InvalidSwap') return new $00969ccfce569794$var$InvalidSwapError(e);
    }
    return e;
}

});

parcelRegister("l5ZNc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidSwapError = void 0;
module.exports.toKnownErr = $f5b9ff51d3e9ae80$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $f5b9ff51d3e9ae80$var$InvalidSwapError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidSwapError = $f5b9ff51d3e9ae80$var$InvalidSwapError;
function $f5b9ff51d3e9ae80$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'InvalidSwap') return new $f5b9ff51d3e9ae80$var$InvalidSwapError(e);
    }
    return e;
}

});

parcelRegister("rzd0a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecordNotFoundError = void 0;
module.exports.toKnownErr = $052dd5723a5b48af$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $052dd5723a5b48af$var$RecordNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RecordNotFoundError = $052dd5723a5b48af$var$RecordNotFoundError;
function $052dd5723a5b48af$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'RecordNotFound') return new $052dd5723a5b48af$var$RecordNotFoundError(e);
    }
    return e;
}

});

parcelRegister("9gufY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidSwapError = void 0;
module.exports.toKnownErr = $6bed140965ade029$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $6bed140965ade029$var$InvalidSwapError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidSwapError = $6bed140965ade029$var$InvalidSwapError;
function $6bed140965ade029$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'InvalidSwap') return new $6bed140965ade029$var$InvalidSwapError(e);
    }
    return e;
}

});

parcelRegister("l8BOh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidEmailError = module.exports.InvalidTokenError = module.exports.ExpiredTokenError = module.exports.AccountNotFoundError = void 0;
module.exports.toKnownErr = $f637ac954e575ec3$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $f637ac954e575ec3$var$AccountNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.AccountNotFoundError = $f637ac954e575ec3$var$AccountNotFoundError;
class $f637ac954e575ec3$var$ExpiredTokenError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.ExpiredTokenError = $f637ac954e575ec3$var$ExpiredTokenError;
class $f637ac954e575ec3$var$InvalidTokenError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidTokenError = $f637ac954e575ec3$var$InvalidTokenError;
class $f637ac954e575ec3$var$InvalidEmailError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidEmailError = $f637ac954e575ec3$var$InvalidEmailError;
function $f637ac954e575ec3$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'AccountNotFound') return new $f637ac954e575ec3$var$AccountNotFoundError(e);
        if (e.error === 'ExpiredToken') return new $f637ac954e575ec3$var$ExpiredTokenError(e);
        if (e.error === 'InvalidToken') return new $f637ac954e575ec3$var$InvalidTokenError(e);
        if (e.error === 'InvalidEmail') return new $f637ac954e575ec3$var$InvalidEmailError(e);
    }
    return e;
}

});

parcelRegister("hSgUY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IncompatibleDidDocError = module.exports.UnresolvableDidError = module.exports.UnsupportedDomainError = module.exports.HandleNotAvailableError = module.exports.InvalidInviteCodeError = module.exports.InvalidPasswordError = module.exports.InvalidHandleError = void 0;
module.exports.toKnownErr = $d0349a5faf2b6b01$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $d0349a5faf2b6b01$var$InvalidHandleError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidHandleError = $d0349a5faf2b6b01$var$InvalidHandleError;
class $d0349a5faf2b6b01$var$InvalidPasswordError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidPasswordError = $d0349a5faf2b6b01$var$InvalidPasswordError;
class $d0349a5faf2b6b01$var$InvalidInviteCodeError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidInviteCodeError = $d0349a5faf2b6b01$var$InvalidInviteCodeError;
class $d0349a5faf2b6b01$var$HandleNotAvailableError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.HandleNotAvailableError = $d0349a5faf2b6b01$var$HandleNotAvailableError;
class $d0349a5faf2b6b01$var$UnsupportedDomainError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.UnsupportedDomainError = $d0349a5faf2b6b01$var$UnsupportedDomainError;
class $d0349a5faf2b6b01$var$UnresolvableDidError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.UnresolvableDidError = $d0349a5faf2b6b01$var$UnresolvableDidError;
class $d0349a5faf2b6b01$var$IncompatibleDidDocError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.IncompatibleDidDocError = $d0349a5faf2b6b01$var$IncompatibleDidDocError;
function $d0349a5faf2b6b01$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'InvalidHandle') return new $d0349a5faf2b6b01$var$InvalidHandleError(e);
        if (e.error === 'InvalidPassword') return new $d0349a5faf2b6b01$var$InvalidPasswordError(e);
        if (e.error === 'InvalidInviteCode') return new $d0349a5faf2b6b01$var$InvalidInviteCodeError(e);
        if (e.error === 'HandleNotAvailable') return new $d0349a5faf2b6b01$var$HandleNotAvailableError(e);
        if (e.error === 'UnsupportedDomain') return new $d0349a5faf2b6b01$var$UnsupportedDomainError(e);
        if (e.error === 'UnresolvableDid') return new $d0349a5faf2b6b01$var$UnresolvableDidError(e);
        if (e.error === 'IncompatibleDidDoc') return new $d0349a5faf2b6b01$var$IncompatibleDidDocError(e);
    }
    return e;
}

});

parcelRegister("k6MKs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccountTakedownError = void 0;
module.exports.toKnownErr = $ea3a2e9a0db021c4$var$toKnownErr;
module.exports.isAppPassword = $ea3a2e9a0db021c4$var$isAppPassword;
module.exports.validateAppPassword = $ea3a2e9a0db021c4$var$validateAppPassword;

var $al5Ta = parcelRequire("al5Ta");

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
class $ea3a2e9a0db021c4$var$AccountTakedownError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.AccountTakedownError = $ea3a2e9a0db021c4$var$AccountTakedownError;
function $ea3a2e9a0db021c4$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'AccountTakedown') return new $ea3a2e9a0db021c4$var$AccountTakedownError(e);
    }
    return e;
}
function $ea3a2e9a0db021c4$var$isAppPassword(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.server.createAppPassword#appPassword';
}
function $ea3a2e9a0db021c4$var$validateAppPassword(v) {
    return $8DB7o.lexicons.validate('com.atproto.server.createAppPassword#appPassword', v);
}

});

parcelRegister("ixoHx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthFactorTokenRequiredError = module.exports.AccountTakedownError = void 0;
module.exports.toKnownErr = $d7ee7830179a5016$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $d7ee7830179a5016$var$AccountTakedownError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.AccountTakedownError = $d7ee7830179a5016$var$AccountTakedownError;
class $d7ee7830179a5016$var$AuthFactorTokenRequiredError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.AuthFactorTokenRequiredError = $d7ee7830179a5016$var$AuthFactorTokenRequiredError;
function $d7ee7830179a5016$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'AccountTakedown') return new $d7ee7830179a5016$var$AccountTakedownError(e);
        if (e.error === 'AuthFactorTokenRequired') return new $d7ee7830179a5016$var$AuthFactorTokenRequiredError(e);
    }
    return e;
}

});

parcelRegister("7zUbL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidTokenError = module.exports.ExpiredTokenError = void 0;
module.exports.toKnownErr = $58476338ae403915$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $58476338ae403915$var$ExpiredTokenError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.ExpiredTokenError = $58476338ae403915$var$ExpiredTokenError;
class $58476338ae403915$var$InvalidTokenError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidTokenError = $58476338ae403915$var$InvalidTokenError;
function $58476338ae403915$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'ExpiredToken') return new $58476338ae403915$var$ExpiredTokenError(e);
        if (e.error === 'InvalidToken') return new $58476338ae403915$var$InvalidTokenError(e);
    }
    return e;
}

});

parcelRegister("eneV1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DuplicateCreateError = void 0;
module.exports.toKnownErr = $a76ec93ad281c91f$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $a76ec93ad281c91f$var$DuplicateCreateError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.DuplicateCreateError = $a76ec93ad281c91f$var$DuplicateCreateError;
function $a76ec93ad281c91f$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'DuplicateCreate') return new $a76ec93ad281c91f$var$DuplicateCreateError(e);
    }
    return e;
}

});

parcelRegister("kdDGi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BadExpirationError = void 0;
module.exports.toKnownErr = $eb83cd6b6ecbaea3$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $eb83cd6b6ecbaea3$var$BadExpirationError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.BadExpirationError = $eb83cd6b6ecbaea3$var$BadExpirationError;
function $eb83cd6b6ecbaea3$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'BadExpiration') return new $eb83cd6b6ecbaea3$var$BadExpirationError(e);
    }
    return e;
}

});

parcelRegister("duByU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccountTakedownError = void 0;
module.exports.toKnownErr = $9d2b36c1d724c06d$var$toKnownErr;
module.exports.isAppPassword = $9d2b36c1d724c06d$var$isAppPassword;
module.exports.validateAppPassword = $9d2b36c1d724c06d$var$validateAppPassword;

var $al5Ta = parcelRequire("al5Ta");

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
class $9d2b36c1d724c06d$var$AccountTakedownError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.AccountTakedownError = $9d2b36c1d724c06d$var$AccountTakedownError;
function $9d2b36c1d724c06d$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'AccountTakedown') return new $9d2b36c1d724c06d$var$AccountTakedownError(e);
    }
    return e;
}
function $9d2b36c1d724c06d$var$isAppPassword(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.server.listAppPasswords#appPassword';
}
function $9d2b36c1d724c06d$var$validateAppPassword(v) {
    return $8DB7o.lexicons.validate('com.atproto.server.listAppPasswords#appPassword', v);
}

});

parcelRegister("lekR0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccountTakedownError = void 0;
module.exports.toKnownErr = $f74b14f2957fc164$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $f74b14f2957fc164$var$AccountTakedownError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.AccountTakedownError = $f74b14f2957fc164$var$AccountTakedownError;
function $f74b14f2957fc164$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'AccountTakedown') return new $f74b14f2957fc164$var$AccountTakedownError(e);
    }
    return e;
}

});

parcelRegister("euqki", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidTokenError = module.exports.ExpiredTokenError = void 0;
module.exports.toKnownErr = $a8c849df1ce8eff4$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $a8c849df1ce8eff4$var$ExpiredTokenError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.ExpiredTokenError = $a8c849df1ce8eff4$var$ExpiredTokenError;
class $a8c849df1ce8eff4$var$InvalidTokenError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidTokenError = $a8c849df1ce8eff4$var$InvalidTokenError;
function $a8c849df1ce8eff4$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'ExpiredToken') return new $a8c849df1ce8eff4$var$ExpiredTokenError(e);
        if (e.error === 'InvalidToken') return new $a8c849df1ce8eff4$var$InvalidTokenError(e);
    }
    return e;
}

});

parcelRegister("5iUWk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenRequiredError = module.exports.InvalidTokenError = module.exports.ExpiredTokenError = void 0;
module.exports.toKnownErr = $3dcacd386448553f$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $3dcacd386448553f$var$ExpiredTokenError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.ExpiredTokenError = $3dcacd386448553f$var$ExpiredTokenError;
class $3dcacd386448553f$var$InvalidTokenError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.InvalidTokenError = $3dcacd386448553f$var$InvalidTokenError;
class $3dcacd386448553f$var$TokenRequiredError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.TokenRequiredError = $3dcacd386448553f$var$TokenRequiredError;
function $3dcacd386448553f$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'ExpiredToken') return new $3dcacd386448553f$var$ExpiredTokenError(e);
        if (e.error === 'InvalidToken') return new $3dcacd386448553f$var$InvalidTokenError(e);
        if (e.error === 'TokenRequired') return new $3dcacd386448553f$var$TokenRequiredError(e);
    }
    return e;
}

});

parcelRegister("11of0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RepoDeactivatedError = module.exports.RepoSuspendedError = module.exports.RepoTakendownError = module.exports.RepoNotFoundError = module.exports.BlobNotFoundError = void 0;
module.exports.toKnownErr = $0be8b031852318e7$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $0be8b031852318e7$var$BlobNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.BlobNotFoundError = $0be8b031852318e7$var$BlobNotFoundError;
class $0be8b031852318e7$var$RepoNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoNotFoundError = $0be8b031852318e7$var$RepoNotFoundError;
class $0be8b031852318e7$var$RepoTakendownError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoTakendownError = $0be8b031852318e7$var$RepoTakendownError;
class $0be8b031852318e7$var$RepoSuspendedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoSuspendedError = $0be8b031852318e7$var$RepoSuspendedError;
class $0be8b031852318e7$var$RepoDeactivatedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoDeactivatedError = $0be8b031852318e7$var$RepoDeactivatedError;
function $0be8b031852318e7$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'BlobNotFound') return new $0be8b031852318e7$var$BlobNotFoundError(e);
        if (e.error === 'RepoNotFound') return new $0be8b031852318e7$var$RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new $0be8b031852318e7$var$RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new $0be8b031852318e7$var$RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new $0be8b031852318e7$var$RepoDeactivatedError(e);
    }
    return e;
}

});

parcelRegister("fc5eY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RepoDeactivatedError = module.exports.RepoSuspendedError = module.exports.RepoTakendownError = module.exports.RepoNotFoundError = module.exports.BlockNotFoundError = void 0;
module.exports.toKnownErr = $b0fc0aaf2ab9bc93$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $b0fc0aaf2ab9bc93$var$BlockNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.BlockNotFoundError = $b0fc0aaf2ab9bc93$var$BlockNotFoundError;
class $b0fc0aaf2ab9bc93$var$RepoNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoNotFoundError = $b0fc0aaf2ab9bc93$var$RepoNotFoundError;
class $b0fc0aaf2ab9bc93$var$RepoTakendownError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoTakendownError = $b0fc0aaf2ab9bc93$var$RepoTakendownError;
class $b0fc0aaf2ab9bc93$var$RepoSuspendedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoSuspendedError = $b0fc0aaf2ab9bc93$var$RepoSuspendedError;
class $b0fc0aaf2ab9bc93$var$RepoDeactivatedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoDeactivatedError = $b0fc0aaf2ab9bc93$var$RepoDeactivatedError;
function $b0fc0aaf2ab9bc93$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'BlockNotFound') return new $b0fc0aaf2ab9bc93$var$BlockNotFoundError(e);
        if (e.error === 'RepoNotFound') return new $b0fc0aaf2ab9bc93$var$RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new $b0fc0aaf2ab9bc93$var$RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new $b0fc0aaf2ab9bc93$var$RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new $b0fc0aaf2ab9bc93$var$RepoDeactivatedError(e);
    }
    return e;
}

});

parcelRegister("785zH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeadNotFoundError = void 0;
module.exports.toKnownErr = $530d9acda13802c8$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $530d9acda13802c8$var$HeadNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.HeadNotFoundError = $530d9acda13802c8$var$HeadNotFoundError;
function $530d9acda13802c8$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'HeadNotFound') return new $530d9acda13802c8$var$HeadNotFoundError(e);
    }
    return e;
}

});

parcelRegister("cfaJo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RepoDeactivatedError = module.exports.RepoSuspendedError = module.exports.RepoTakendownError = module.exports.RepoNotFoundError = void 0;
module.exports.toKnownErr = $8e9f35bd81874c6c$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $8e9f35bd81874c6c$var$RepoNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoNotFoundError = $8e9f35bd81874c6c$var$RepoNotFoundError;
class $8e9f35bd81874c6c$var$RepoTakendownError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoTakendownError = $8e9f35bd81874c6c$var$RepoTakendownError;
class $8e9f35bd81874c6c$var$RepoSuspendedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoSuspendedError = $8e9f35bd81874c6c$var$RepoSuspendedError;
class $8e9f35bd81874c6c$var$RepoDeactivatedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoDeactivatedError = $8e9f35bd81874c6c$var$RepoDeactivatedError;
function $8e9f35bd81874c6c$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'RepoNotFound') return new $8e9f35bd81874c6c$var$RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new $8e9f35bd81874c6c$var$RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new $8e9f35bd81874c6c$var$RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new $8e9f35bd81874c6c$var$RepoDeactivatedError(e);
    }
    return e;
}

});

parcelRegister("4n1SW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RepoDeactivatedError = module.exports.RepoSuspendedError = module.exports.RepoTakendownError = module.exports.RepoNotFoundError = module.exports.RecordNotFoundError = void 0;
module.exports.toKnownErr = $32eac5c5ef89d1b9$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $32eac5c5ef89d1b9$var$RecordNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RecordNotFoundError = $32eac5c5ef89d1b9$var$RecordNotFoundError;
class $32eac5c5ef89d1b9$var$RepoNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoNotFoundError = $32eac5c5ef89d1b9$var$RepoNotFoundError;
class $32eac5c5ef89d1b9$var$RepoTakendownError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoTakendownError = $32eac5c5ef89d1b9$var$RepoTakendownError;
class $32eac5c5ef89d1b9$var$RepoSuspendedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoSuspendedError = $32eac5c5ef89d1b9$var$RepoSuspendedError;
class $32eac5c5ef89d1b9$var$RepoDeactivatedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoDeactivatedError = $32eac5c5ef89d1b9$var$RepoDeactivatedError;
function $32eac5c5ef89d1b9$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'RecordNotFound') return new $32eac5c5ef89d1b9$var$RecordNotFoundError(e);
        if (e.error === 'RepoNotFound') return new $32eac5c5ef89d1b9$var$RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new $32eac5c5ef89d1b9$var$RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new $32eac5c5ef89d1b9$var$RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new $32eac5c5ef89d1b9$var$RepoDeactivatedError(e);
    }
    return e;
}

});

parcelRegister("lfsPu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RepoDeactivatedError = module.exports.RepoSuspendedError = module.exports.RepoTakendownError = module.exports.RepoNotFoundError = void 0;
module.exports.toKnownErr = $f7815c9d56ceaa79$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $f7815c9d56ceaa79$var$RepoNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoNotFoundError = $f7815c9d56ceaa79$var$RepoNotFoundError;
class $f7815c9d56ceaa79$var$RepoTakendownError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoTakendownError = $f7815c9d56ceaa79$var$RepoTakendownError;
class $f7815c9d56ceaa79$var$RepoSuspendedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoSuspendedError = $f7815c9d56ceaa79$var$RepoSuspendedError;
class $f7815c9d56ceaa79$var$RepoDeactivatedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoDeactivatedError = $f7815c9d56ceaa79$var$RepoDeactivatedError;
function $f7815c9d56ceaa79$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'RepoNotFound') return new $f7815c9d56ceaa79$var$RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new $f7815c9d56ceaa79$var$RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new $f7815c9d56ceaa79$var$RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new $f7815c9d56ceaa79$var$RepoDeactivatedError(e);
    }
    return e;
}

});

parcelRegister("l99IV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RepoNotFoundError = void 0;
module.exports.toKnownErr = $f651fb1f01dfcaa8$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $f651fb1f01dfcaa8$var$RepoNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoNotFoundError = $f651fb1f01dfcaa8$var$RepoNotFoundError;
function $f651fb1f01dfcaa8$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'RepoNotFound') return new $f651fb1f01dfcaa8$var$RepoNotFoundError(e);
    }
    return e;
}

});

parcelRegister("5i75s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RepoDeactivatedError = module.exports.RepoSuspendedError = module.exports.RepoTakendownError = module.exports.RepoNotFoundError = void 0;
module.exports.toKnownErr = $3da4218cbe6d683f$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $3da4218cbe6d683f$var$RepoNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoNotFoundError = $3da4218cbe6d683f$var$RepoNotFoundError;
class $3da4218cbe6d683f$var$RepoTakendownError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoTakendownError = $3da4218cbe6d683f$var$RepoTakendownError;
class $3da4218cbe6d683f$var$RepoSuspendedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoSuspendedError = $3da4218cbe6d683f$var$RepoSuspendedError;
class $3da4218cbe6d683f$var$RepoDeactivatedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoDeactivatedError = $3da4218cbe6d683f$var$RepoDeactivatedError;
function $3da4218cbe6d683f$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'RepoNotFound') return new $3da4218cbe6d683f$var$RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new $3da4218cbe6d683f$var$RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new $3da4218cbe6d683f$var$RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new $3da4218cbe6d683f$var$RepoDeactivatedError(e);
    }
    return e;
}

});

parcelRegister("6XZma", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockedByActorError = module.exports.BlockedActorError = void 0;
module.exports.toKnownErr = $5127d8e4d1b208b5$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $5127d8e4d1b208b5$var$BlockedActorError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.BlockedActorError = $5127d8e4d1b208b5$var$BlockedActorError;
class $5127d8e4d1b208b5$var$BlockedByActorError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.BlockedByActorError = $5127d8e4d1b208b5$var$BlockedByActorError;
function $5127d8e4d1b208b5$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'BlockedActor') return new $5127d8e4d1b208b5$var$BlockedActorError(e);
        if (e.error === 'BlockedByActor') return new $5127d8e4d1b208b5$var$BlockedByActorError(e);
    }
    return e;
}

});

parcelRegister("1p5kI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockedByActorError = module.exports.BlockedActorError = void 0;
module.exports.toKnownErr = $105c434643fe9ecb$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $105c434643fe9ecb$var$BlockedActorError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.BlockedActorError = $105c434643fe9ecb$var$BlockedActorError;
class $105c434643fe9ecb$var$BlockedByActorError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.BlockedByActorError = $105c434643fe9ecb$var$BlockedByActorError;
function $105c434643fe9ecb$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'BlockedActor') return new $105c434643fe9ecb$var$BlockedActorError(e);
        if (e.error === 'BlockedByActor') return new $105c434643fe9ecb$var$BlockedByActorError(e);
    }
    return e;
}

});

parcelRegister("7lME1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnknownFeedError = void 0;
module.exports.toKnownErr = $55a03a593e2de0a1$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $55a03a593e2de0a1$var$UnknownFeedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.UnknownFeedError = $55a03a593e2de0a1$var$UnknownFeedError;
function $55a03a593e2de0a1$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'UnknownFeed') return new $55a03a593e2de0a1$var$UnknownFeedError(e);
    }
    return e;
}

});

parcelRegister("8HHJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnknownFeedError = void 0;
module.exports.toKnownErr = $656444d6953dd25a$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $656444d6953dd25a$var$UnknownFeedError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.UnknownFeedError = $656444d6953dd25a$var$UnknownFeedError;
function $656444d6953dd25a$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'UnknownFeed') return new $656444d6953dd25a$var$UnknownFeedError(e);
    }
    return e;
}

});

parcelRegister("ba9K6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnknownListError = void 0;
module.exports.toKnownErr = $82082f8a72d11c3e$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $82082f8a72d11c3e$var$UnknownListError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.UnknownListError = $82082f8a72d11c3e$var$UnknownListError;
function $82082f8a72d11c3e$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'UnknownList') return new $82082f8a72d11c3e$var$UnknownListError(e);
    }
    return e;
}

});

parcelRegister("ddyeE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotFoundError = void 0;
module.exports.toKnownErr = $99f70bab3b6e3eb4$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $99f70bab3b6e3eb4$var$NotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.NotFoundError = $99f70bab3b6e3eb4$var$NotFoundError;
function $99f70bab3b6e3eb4$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'NotFound') return new $99f70bab3b6e3eb4$var$NotFoundError(e);
    }
    return e;
}

});

parcelRegister("3m5z2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BadQueryStringError = void 0;
module.exports.toKnownErr = $2717be13f69f645f$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $2717be13f69f645f$var$BadQueryStringError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.BadQueryStringError = $2717be13f69f645f$var$BadQueryStringError;
function $2717be13f69f645f$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'BadQueryString') return new $2717be13f69f645f$var$BadQueryStringError(e);
    }
    return e;
}

});

parcelRegister("3M4Rp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorNotFoundError = void 0;
module.exports.toKnownErr = $2bf99ff491b86c46$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $2bf99ff491b86c46$var$ActorNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.ActorNotFoundError = $2bf99ff491b86c46$var$ActorNotFoundError;
function $2bf99ff491b86c46$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'ActorNotFound') return new $2bf99ff491b86c46$var$ActorNotFoundError(e);
    }
    return e;
}

});

parcelRegister("a0RJn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BadQueryStringError = void 0;
module.exports.toKnownErr = $74a39547aada6ebe$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $74a39547aada6ebe$var$BadQueryStringError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.BadQueryStringError = $74a39547aada6ebe$var$BadQueryStringError;
function $74a39547aada6ebe$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'BadQueryString') return new $74a39547aada6ebe$var$BadQueryStringError(e);
    }
    return e;
}

});

parcelRegister("6OWOv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BadQueryStringError = void 0;
module.exports.toKnownErr = $4f7508c5b97dd4fb$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $4f7508c5b97dd4fb$var$BadQueryStringError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.BadQueryStringError = $4f7508c5b97dd4fb$var$BadQueryStringError;
function $4f7508c5b97dd4fb$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'BadQueryString') return new $4f7508c5b97dd4fb$var$BadQueryStringError(e);
    }
    return e;
}

});

parcelRegister("bpJIG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BadQueryStringError = void 0;
module.exports.toKnownErr = $84f57e7a9b3d4fcf$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $84f57e7a9b3d4fcf$var$BadQueryStringError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.BadQueryStringError = $84f57e7a9b3d4fcf$var$BadQueryStringError;
function $84f57e7a9b3d4fcf$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'BadQueryString') return new $84f57e7a9b3d4fcf$var$BadQueryStringError(e);
    }
    return e;
}

});

parcelRegister("9tmUj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DuplicateTemplateNameError = void 0;
module.exports.toKnownErr = $6e589760b708cde6$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $6e589760b708cde6$var$DuplicateTemplateNameError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.DuplicateTemplateNameError = $6e589760b708cde6$var$DuplicateTemplateNameError;
function $6e589760b708cde6$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'DuplicateTemplateName') return new $6e589760b708cde6$var$DuplicateTemplateNameError(e);
    }
    return e;
}

});

parcelRegister("3Vj9j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DuplicateTemplateNameError = void 0;
module.exports.toKnownErr = $2db58c99aa8470fc$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $2db58c99aa8470fc$var$DuplicateTemplateNameError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.DuplicateTemplateNameError = $2db58c99aa8470fc$var$DuplicateTemplateNameError;
function $2db58c99aa8470fc$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'DuplicateTemplateName') return new $2db58c99aa8470fc$var$DuplicateTemplateNameError(e);
    }
    return e;
}

});

parcelRegister("aDbWo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SubjectHasActionError = void 0;
module.exports.toKnownErr = $7bd6cf1e4a906945$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $7bd6cf1e4a906945$var$SubjectHasActionError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.SubjectHasActionError = $7bd6cf1e4a906945$var$SubjectHasActionError;
function $7bd6cf1e4a906945$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'SubjectHasAction') return new $7bd6cf1e4a906945$var$SubjectHasActionError(e);
    }
    return e;
}

});

parcelRegister("6zLJN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecordNotFoundError = void 0;
module.exports.toKnownErr = $4c9b0aadecf62614$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $4c9b0aadecf62614$var$RecordNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RecordNotFoundError = $4c9b0aadecf62614$var$RecordNotFoundError;
function $4c9b0aadecf62614$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'RecordNotFound') return new $4c9b0aadecf62614$var$RecordNotFoundError(e);
    }
    return e;
}

});

parcelRegister("eewch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RepoNotFoundError = void 0;
module.exports.toKnownErr = $a5cb592b210eb8b6$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $a5cb592b210eb8b6$var$RepoNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.RepoNotFoundError = $a5cb592b210eb8b6$var$RepoNotFoundError;
function $a5cb592b210eb8b6$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'RepoNotFound') return new $a5cb592b210eb8b6$var$RepoNotFoundError(e);
    }
    return e;
}

});

parcelRegister("fXzWp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetNotFoundError = void 0;
module.exports.toKnownErr = $b9e83edf5bb20437$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $b9e83edf5bb20437$var$SetNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.SetNotFoundError = $b9e83edf5bb20437$var$SetNotFoundError;
function $b9e83edf5bb20437$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'SetNotFound') return new $b9e83edf5bb20437$var$SetNotFoundError(e);
    }
    return e;
}

});

parcelRegister("eduZ3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetNotFoundError = void 0;
module.exports.toKnownErr = $a59a505346e005d6$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $a59a505346e005d6$var$SetNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.SetNotFoundError = $a59a505346e005d6$var$SetNotFoundError;
function $a59a505346e005d6$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'SetNotFound') return new $a59a505346e005d6$var$SetNotFoundError(e);
    }
    return e;
}

});

parcelRegister("iuEPv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetNotFoundError = void 0;
module.exports.toKnownErr = $d76ab3402db8628d$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $d76ab3402db8628d$var$SetNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.SetNotFoundError = $d76ab3402db8628d$var$SetNotFoundError;
function $d76ab3402db8628d$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'SetNotFound') return new $d76ab3402db8628d$var$SetNotFoundError(e);
    }
    return e;
}

});

parcelRegister("8IiFc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MemberAlreadyExistsError = void 0;
module.exports.toKnownErr = $6580e8f9d204ac8a$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $6580e8f9d204ac8a$var$MemberAlreadyExistsError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.MemberAlreadyExistsError = $6580e8f9d204ac8a$var$MemberAlreadyExistsError;
function $6580e8f9d204ac8a$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'MemberAlreadyExists') return new $6580e8f9d204ac8a$var$MemberAlreadyExistsError(e);
    }
    return e;
}

});

parcelRegister("9X16d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CannotDeleteSelfError = module.exports.MemberNotFoundError = void 0;
module.exports.toKnownErr = $73ea7a0c0da05447$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $73ea7a0c0da05447$var$MemberNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.MemberNotFoundError = $73ea7a0c0da05447$var$MemberNotFoundError;
class $73ea7a0c0da05447$var$CannotDeleteSelfError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.CannotDeleteSelfError = $73ea7a0c0da05447$var$CannotDeleteSelfError;
function $73ea7a0c0da05447$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'MemberNotFound') return new $73ea7a0c0da05447$var$MemberNotFoundError(e);
        if (e.error === 'CannotDeleteSelf') return new $73ea7a0c0da05447$var$CannotDeleteSelfError(e);
    }
    return e;
}

});

parcelRegister("1o4e8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MemberNotFoundError = void 0;
module.exports.toKnownErr = $102b4fbd57339456$var$toKnownErr;

var $al5Ta = parcelRequire("al5Ta");
class $102b4fbd57339456$var$MemberNotFoundError extends $al5Ta.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
module.exports.MemberNotFoundError = $102b4fbd57339456$var$MemberNotFoundError;
function $102b4fbd57339456$var$toKnownErr(e) {
    if (e instanceof $al5Ta.XRPCError) {
        if (e.error === 'MemberNotFound') return new $102b4fbd57339456$var$MemberNotFoundError(e);
    }
    return e;
}

});

parcelRegister("29HEg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isStatusAttr = $191e47b1e548aeac$var$isStatusAttr;
module.exports.validateStatusAttr = $191e47b1e548aeac$var$validateStatusAttr;
module.exports.isAccountView = $191e47b1e548aeac$var$isAccountView;
module.exports.validateAccountView = $191e47b1e548aeac$var$validateAccountView;
module.exports.isRepoRef = $191e47b1e548aeac$var$isRepoRef;
module.exports.validateRepoRef = $191e47b1e548aeac$var$validateRepoRef;
module.exports.isRepoBlobRef = $191e47b1e548aeac$var$isRepoBlobRef;
module.exports.validateRepoBlobRef = $191e47b1e548aeac$var$validateRepoBlobRef;
module.exports.isThreatSignature = $191e47b1e548aeac$var$isThreatSignature;
module.exports.validateThreatSignature = $191e47b1e548aeac$var$validateThreatSignature;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $191e47b1e548aeac$var$isStatusAttr(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.admin.defs#statusAttr';
}
function $191e47b1e548aeac$var$validateStatusAttr(v) {
    return $8DB7o.lexicons.validate('com.atproto.admin.defs#statusAttr', v);
}
function $191e47b1e548aeac$var$isAccountView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.admin.defs#accountView';
}
function $191e47b1e548aeac$var$validateAccountView(v) {
    return $8DB7o.lexicons.validate('com.atproto.admin.defs#accountView', v);
}
function $191e47b1e548aeac$var$isRepoRef(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.admin.defs#repoRef';
}
function $191e47b1e548aeac$var$validateRepoRef(v) {
    return $8DB7o.lexicons.validate('com.atproto.admin.defs#repoRef', v);
}
function $191e47b1e548aeac$var$isRepoBlobRef(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.admin.defs#repoBlobRef';
}
function $191e47b1e548aeac$var$validateRepoBlobRef(v) {
    return $8DB7o.lexicons.validate('com.atproto.admin.defs#repoBlobRef', v);
}
function $191e47b1e548aeac$var$isThreatSignature(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.admin.defs#threatSignature';
}
function $191e47b1e548aeac$var$validateThreatSignature(v) {
    return $8DB7o.lexicons.validate('com.atproto.admin.defs#threatSignature', v);
}

});

parcelRegister("7W1iM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $5c6ef5bb1aa9ab36$var$toKnownErr;
function $5c6ef5bb1aa9ab36$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("2mykY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $1b884588aaeef9da$var$toKnownErr;
function $1b884588aaeef9da$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("6kVoY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $49d1232857b9135e$var$toKnownErr;
function $49d1232857b9135e$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("5ecBe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $3ce8088c1ad83cfe$var$toKnownErr;
function $3ce8088c1ad83cfe$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("6AWKm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $4cd3acbc8c6f385c$var$toKnownErr;
function $4cd3acbc8c6f385c$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("htooE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $cb8811c3034d9ee2$var$toKnownErr;
function $cb8811c3034d9ee2$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("g4Dr0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $bb3b9bf2bcb7d7c1$var$toKnownErr;
function $bb3b9bf2bcb7d7c1$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("1u4wl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $114c198359d1bb2d$var$toKnownErr;
function $114c198359d1bb2d$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("eyHdJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $a995c45fb9f2393f$var$toKnownErr;
function $a995c45fb9f2393f$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("aXH69", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $7fb0d876a8be018a$var$toKnownErr;
function $7fb0d876a8be018a$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("hfs1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $c8e9938a15886126$var$toKnownErr;
function $c8e9938a15886126$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("2WDSK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $224fef47ac5638d3$var$toKnownErr;
function $224fef47ac5638d3$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("aPIOu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $7e316dc72f6ef68f$var$toKnownErr;
function $7e316dc72f6ef68f$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("6fqzZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $48c8c2f232c6096b$var$toKnownErr;
function $48c8c2f232c6096b$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("hIUy5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $ce72692868e05a31$var$toKnownErr;
function $ce72692868e05a31$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("k7wt1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $ea5da560bf2e3d0f$var$toKnownErr;
function $ea5da560bf2e3d0f$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("eVz2k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $ade191174024d2c6$var$toKnownErr;
function $ade191174024d2c6$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("kp9hl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $edad56fe728977e6$var$toKnownErr;
function $edad56fe728977e6$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("bp7XD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $84d8345ce41af0b2$var$toKnownErr;
function $84d8345ce41af0b2$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("dvF4O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $9d5e088c5b302807$var$toKnownErr;
function $9d5e088c5b302807$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("c4mKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isLabel = $8c97820a9044444b$var$isLabel;
module.exports.validateLabel = $8c97820a9044444b$var$validateLabel;
module.exports.isSelfLabels = $8c97820a9044444b$var$isSelfLabels;
module.exports.validateSelfLabels = $8c97820a9044444b$var$validateSelfLabels;
module.exports.isSelfLabel = $8c97820a9044444b$var$isSelfLabel;
module.exports.validateSelfLabel = $8c97820a9044444b$var$validateSelfLabel;
module.exports.isLabelValueDefinition = $8c97820a9044444b$var$isLabelValueDefinition;
module.exports.validateLabelValueDefinition = $8c97820a9044444b$var$validateLabelValueDefinition;
module.exports.isLabelValueDefinitionStrings = $8c97820a9044444b$var$isLabelValueDefinitionStrings;
module.exports.validateLabelValueDefinitionStrings = $8c97820a9044444b$var$validateLabelValueDefinitionStrings;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $8c97820a9044444b$var$isLabel(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.label.defs#label';
}
function $8c97820a9044444b$var$validateLabel(v) {
    return $8DB7o.lexicons.validate('com.atproto.label.defs#label', v);
}
function $8c97820a9044444b$var$isSelfLabels(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.label.defs#selfLabels';
}
function $8c97820a9044444b$var$validateSelfLabels(v) {
    return $8DB7o.lexicons.validate('com.atproto.label.defs#selfLabels', v);
}
function $8c97820a9044444b$var$isSelfLabel(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.label.defs#selfLabel';
}
function $8c97820a9044444b$var$validateSelfLabel(v) {
    return $8DB7o.lexicons.validate('com.atproto.label.defs#selfLabel', v);
}
function $8c97820a9044444b$var$isLabelValueDefinition(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.label.defs#labelValueDefinition';
}
function $8c97820a9044444b$var$validateLabelValueDefinition(v) {
    return $8DB7o.lexicons.validate('com.atproto.label.defs#labelValueDefinition', v);
}
function $8c97820a9044444b$var$isLabelValueDefinitionStrings(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.label.defs#labelValueDefinitionStrings';
}
function $8c97820a9044444b$var$validateLabelValueDefinitionStrings(v) {
    return $8DB7o.lexicons.validate('com.atproto.label.defs#labelValueDefinitionStrings', v);
}

});

parcelRegister("7Si05", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $5bbb8a116f45aa93$var$toKnownErr;
function $5bbb8a116f45aa93$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("4z0iR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isLabels = $352aaa8a7198fa4d$var$isLabels;
module.exports.validateLabels = $352aaa8a7198fa4d$var$validateLabels;
module.exports.isInfo = $352aaa8a7198fa4d$var$isInfo;
module.exports.validateInfo = $352aaa8a7198fa4d$var$validateInfo;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $352aaa8a7198fa4d$var$isLabels(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.label.subscribeLabels#labels';
}
function $352aaa8a7198fa4d$var$validateLabels(v) {
    return $8DB7o.lexicons.validate('com.atproto.label.subscribeLabels#labels', v);
}
function $352aaa8a7198fa4d$var$isInfo(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.label.subscribeLabels#info';
}
function $352aaa8a7198fa4d$var$validateInfo(v) {
    return $8DB7o.lexicons.validate('com.atproto.label.subscribeLabels#info', v);
}

});

parcelRegister("fJ5UO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $b72fa5a23b1a05a8$var$isRecord;
module.exports.validateRecord = $b72fa5a23b1a05a8$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $b72fa5a23b1a05a8$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'com.atproto.lexicon.schema#main' || v.$type === 'com.atproto.lexicon.schema');
}
function $b72fa5a23b1a05a8$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('com.atproto.lexicon.schema#main', v);
}

});

parcelRegister("1iivm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $0f15d388d4b10320$var$toKnownErr;
function $0f15d388d4b10320$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("7cnqm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.REASONAPPEAL = module.exports.REASONOTHER = module.exports.REASONRUDE = module.exports.REASONSEXUAL = module.exports.REASONMISLEADING = module.exports.REASONVIOLATION = module.exports.REASONSPAM = void 0;
/** Spam: frequent unwanted promotion, replies, mentions */ module.exports.REASONSPAM = 'com.atproto.moderation.defs#reasonSpam';
/** Direct violation of server rules, laws, terms of service */ module.exports.REASONVIOLATION = 'com.atproto.moderation.defs#reasonViolation';
/** Misleading identity, affiliation, or content */ module.exports.REASONMISLEADING = 'com.atproto.moderation.defs#reasonMisleading';
/** Unwanted or mislabeled sexual content */ module.exports.REASONSEXUAL = 'com.atproto.moderation.defs#reasonSexual';
/** Rude, harassing, explicit, or otherwise unwelcoming behavior */ module.exports.REASONRUDE = 'com.atproto.moderation.defs#reasonRude';
/** Other: reports not falling under another report category */ module.exports.REASONOTHER = 'com.atproto.moderation.defs#reasonOther';
/** Appeal: appeal a previously taken moderation action */ module.exports.REASONAPPEAL = 'com.atproto.moderation.defs#reasonAppeal';

});

parcelRegister("irrDD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isCommitMeta = $d6d03001436f7d28$var$isCommitMeta;
module.exports.validateCommitMeta = $d6d03001436f7d28$var$validateCommitMeta;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $d6d03001436f7d28$var$isCommitMeta(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.repo.defs#commitMeta';
}
function $d6d03001436f7d28$var$validateCommitMeta(v) {
    return $8DB7o.lexicons.validate('com.atproto.repo.defs#commitMeta', v);
}

});

parcelRegister("1pmxn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $10699bb72b792413$var$toKnownErr;
function $10699bb72b792413$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("aRJaV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $7e91e579a71d01e3$var$toKnownErr;
function $7e91e579a71d01e3$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("kp1bp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $eda70f641392bb93$var$toKnownErr;
module.exports.isRecordBlob = $eda70f641392bb93$var$isRecordBlob;
module.exports.validateRecordBlob = $eda70f641392bb93$var$validateRecordBlob;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $eda70f641392bb93$var$toKnownErr(e) {
    return e;
}
function $eda70f641392bb93$var$isRecordBlob(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.repo.listMissingBlobs#recordBlob';
}
function $eda70f641392bb93$var$validateRecordBlob(v) {
    return $8DB7o.lexicons.validate('com.atproto.repo.listMissingBlobs#recordBlob', v);
}

});

parcelRegister("lt5Eq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $fa10b094f3b997ae$var$toKnownErr;
module.exports.isRecord = $fa10b094f3b997ae$var$isRecord;
module.exports.validateRecord = $fa10b094f3b997ae$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $fa10b094f3b997ae$var$toKnownErr(e) {
    return e;
}
function $fa10b094f3b997ae$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.repo.listRecords#record';
}
function $fa10b094f3b997ae$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('com.atproto.repo.listRecords#record', v);
}

});

parcelRegister("imENX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMain = $d5e9ef0859eeb884$var$isMain;
module.exports.validateMain = $d5e9ef0859eeb884$var$validateMain;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $d5e9ef0859eeb884$var$isMain(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'com.atproto.repo.strongRef#main' || v.$type === 'com.atproto.repo.strongRef');
}
function $d5e9ef0859eeb884$var$validateMain(v) {
    return $8DB7o.lexicons.validate('com.atproto.repo.strongRef#main', v);
}

});

parcelRegister("64xN1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $46bd53b76f5ae45c$var$toKnownErr;
function $46bd53b76f5ae45c$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("kRuuY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $f3006a469246f569$var$toKnownErr;
function $f3006a469246f569$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("a2VvK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $7506b3cd36a3a464$var$toKnownErr;
function $7506b3cd36a3a464$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("2ZEuA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $22e0b032e8b6235b$var$toKnownErr;
function $22e0b032e8b6235b$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("e3uhv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $02a40372a2bef8b4$var$toKnownErr;
module.exports.isAccountCodes = $02a40372a2bef8b4$var$isAccountCodes;
module.exports.validateAccountCodes = $02a40372a2bef8b4$var$validateAccountCodes;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $02a40372a2bef8b4$var$toKnownErr(e) {
    return e;
}
function $02a40372a2bef8b4$var$isAccountCodes(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.server.createInviteCodes#accountCodes';
}
function $02a40372a2bef8b4$var$validateAccountCodes(v) {
    return $8DB7o.lexicons.validate('com.atproto.server.createInviteCodes#accountCodes', v);
}

});

parcelRegister("fUfix", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $b947f3d12a391a15$var$toKnownErr;
function $b947f3d12a391a15$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("3xRmd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isInviteCode = $294dd7cd1311ec0d$var$isInviteCode;
module.exports.validateInviteCode = $294dd7cd1311ec0d$var$validateInviteCode;
module.exports.isInviteCodeUse = $294dd7cd1311ec0d$var$isInviteCodeUse;
module.exports.validateInviteCodeUse = $294dd7cd1311ec0d$var$validateInviteCodeUse;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $294dd7cd1311ec0d$var$isInviteCode(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.server.defs#inviteCode';
}
function $294dd7cd1311ec0d$var$validateInviteCode(v) {
    return $8DB7o.lexicons.validate('com.atproto.server.defs#inviteCode', v);
}
function $294dd7cd1311ec0d$var$isInviteCodeUse(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.server.defs#inviteCodeUse';
}
function $294dd7cd1311ec0d$var$validateInviteCodeUse(v) {
    return $8DB7o.lexicons.validate('com.atproto.server.defs#inviteCodeUse', v);
}

});

parcelRegister("cR55u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $95be6193062d9794$var$toKnownErr;
function $95be6193062d9794$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("4Herq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $36b6614d7e14169b$var$toKnownErr;
module.exports.isLinks = $36b6614d7e14169b$var$isLinks;
module.exports.validateLinks = $36b6614d7e14169b$var$validateLinks;
module.exports.isContact = $36b6614d7e14169b$var$isContact;
module.exports.validateContact = $36b6614d7e14169b$var$validateContact;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $36b6614d7e14169b$var$toKnownErr(e) {
    return e;
}
function $36b6614d7e14169b$var$isLinks(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.server.describeServer#links';
}
function $36b6614d7e14169b$var$validateLinks(v) {
    return $8DB7o.lexicons.validate('com.atproto.server.describeServer#links', v);
}
function $36b6614d7e14169b$var$isContact(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.server.describeServer#contact';
}
function $36b6614d7e14169b$var$validateContact(v) {
    return $8DB7o.lexicons.validate('com.atproto.server.describeServer#contact', v);
}

});

parcelRegister("a2Q24", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $01e322e67a48fc02$var$toKnownErr;
function $01e322e67a48fc02$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("lFPfr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $fc752e1833ae8612$var$toKnownErr;
function $fc752e1833ae8612$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("ad0jS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $76eb5dc3c5b0e1c1$var$toKnownErr;
function $76eb5dc3c5b0e1c1$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("i1Gy3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $d1f9532bbb669ee2$var$toKnownErr;
function $d1f9532bbb669ee2$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("1Us3r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $1640c87593554a03$var$toKnownErr;
function $1640c87593554a03$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("kxLSS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $ef4c087f469c8b05$var$toKnownErr;
function $ef4c087f469c8b05$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("gKkDr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $c310f2f33cf73e0a$var$toKnownErr;
function $c310f2f33cf73e0a$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("hJBkc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $ce939795c4a3b9fa$var$toKnownErr;
function $ce939795c4a3b9fa$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("6TNBS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $505e5c9adb845548$var$toKnownErr;
module.exports.isRepo = $505e5c9adb845548$var$isRepo;
module.exports.validateRepo = $505e5c9adb845548$var$validateRepo;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $505e5c9adb845548$var$toKnownErr(e) {
    return e;
}
function $505e5c9adb845548$var$isRepo(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.sync.listRepos#repo';
}
function $505e5c9adb845548$var$validateRepo(v) {
    return $8DB7o.lexicons.validate('com.atproto.sync.listRepos#repo', v);
}

});

parcelRegister("haofJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $c7f62ef2de59e634$var$toKnownErr;
function $c7f62ef2de59e634$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("86PI9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $5e76ff0908aad30a$var$toKnownErr;
function $5e76ff0908aad30a$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("5JMlg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isCommit = $42d6a7732ecf4180$var$isCommit;
module.exports.validateCommit = $42d6a7732ecf4180$var$validateCommit;
module.exports.isIdentity = $42d6a7732ecf4180$var$isIdentity;
module.exports.validateIdentity = $42d6a7732ecf4180$var$validateIdentity;
module.exports.isAccount = $42d6a7732ecf4180$var$isAccount;
module.exports.validateAccount = $42d6a7732ecf4180$var$validateAccount;
module.exports.isHandle = $42d6a7732ecf4180$var$isHandle;
module.exports.validateHandle = $42d6a7732ecf4180$var$validateHandle;
module.exports.isMigrate = $42d6a7732ecf4180$var$isMigrate;
module.exports.validateMigrate = $42d6a7732ecf4180$var$validateMigrate;
module.exports.isTombstone = $42d6a7732ecf4180$var$isTombstone;
module.exports.validateTombstone = $42d6a7732ecf4180$var$validateTombstone;
module.exports.isInfo = $42d6a7732ecf4180$var$isInfo;
module.exports.validateInfo = $42d6a7732ecf4180$var$validateInfo;
module.exports.isRepoOp = $42d6a7732ecf4180$var$isRepoOp;
module.exports.validateRepoOp = $42d6a7732ecf4180$var$validateRepoOp;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $42d6a7732ecf4180$var$isCommit(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.sync.subscribeRepos#commit';
}
function $42d6a7732ecf4180$var$validateCommit(v) {
    return $8DB7o.lexicons.validate('com.atproto.sync.subscribeRepos#commit', v);
}
function $42d6a7732ecf4180$var$isIdentity(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.sync.subscribeRepos#identity';
}
function $42d6a7732ecf4180$var$validateIdentity(v) {
    return $8DB7o.lexicons.validate('com.atproto.sync.subscribeRepos#identity', v);
}
function $42d6a7732ecf4180$var$isAccount(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.sync.subscribeRepos#account';
}
function $42d6a7732ecf4180$var$validateAccount(v) {
    return $8DB7o.lexicons.validate('com.atproto.sync.subscribeRepos#account', v);
}
function $42d6a7732ecf4180$var$isHandle(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.sync.subscribeRepos#handle';
}
function $42d6a7732ecf4180$var$validateHandle(v) {
    return $8DB7o.lexicons.validate('com.atproto.sync.subscribeRepos#handle', v);
}
function $42d6a7732ecf4180$var$isMigrate(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.sync.subscribeRepos#migrate';
}
function $42d6a7732ecf4180$var$validateMigrate(v) {
    return $8DB7o.lexicons.validate('com.atproto.sync.subscribeRepos#migrate', v);
}
function $42d6a7732ecf4180$var$isTombstone(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.sync.subscribeRepos#tombstone';
}
function $42d6a7732ecf4180$var$validateTombstone(v) {
    return $8DB7o.lexicons.validate('com.atproto.sync.subscribeRepos#tombstone', v);
}
function $42d6a7732ecf4180$var$isInfo(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.sync.subscribeRepos#info';
}
function $42d6a7732ecf4180$var$validateInfo(v) {
    return $8DB7o.lexicons.validate('com.atproto.sync.subscribeRepos#info', v);
}
function $42d6a7732ecf4180$var$isRepoOp(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'com.atproto.sync.subscribeRepos#repoOp';
}
function $42d6a7732ecf4180$var$validateRepoOp(v) {
    return $8DB7o.lexicons.validate('com.atproto.sync.subscribeRepos#repoOp', v);
}

});

parcelRegister("c4dVW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $8c90aaa540e92aa5$var$toKnownErr;
function $8c90aaa540e92aa5$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("4aO2h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $309ee8ac8ce68fad$var$toKnownErr;
function $309ee8ac8ce68fad$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("7THHV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $5bff92d656dffc0f$var$toKnownErr;
function $5bff92d656dffc0f$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("lMEvy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $fdbd80b3dd048b8b$var$toKnownErr;
function $fdbd80b3dd048b8b$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("7qr1j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProfileViewBasic = $567febc34a4a0bc9$var$isProfileViewBasic;
module.exports.validateProfileViewBasic = $567febc34a4a0bc9$var$validateProfileViewBasic;
module.exports.isProfileView = $567febc34a4a0bc9$var$isProfileView;
module.exports.validateProfileView = $567febc34a4a0bc9$var$validateProfileView;
module.exports.isProfileViewDetailed = $567febc34a4a0bc9$var$isProfileViewDetailed;
module.exports.validateProfileViewDetailed = $567febc34a4a0bc9$var$validateProfileViewDetailed;
module.exports.isProfileAssociated = $567febc34a4a0bc9$var$isProfileAssociated;
module.exports.validateProfileAssociated = $567febc34a4a0bc9$var$validateProfileAssociated;
module.exports.isProfileAssociatedChat = $567febc34a4a0bc9$var$isProfileAssociatedChat;
module.exports.validateProfileAssociatedChat = $567febc34a4a0bc9$var$validateProfileAssociatedChat;
module.exports.isViewerState = $567febc34a4a0bc9$var$isViewerState;
module.exports.validateViewerState = $567febc34a4a0bc9$var$validateViewerState;
module.exports.isKnownFollowers = $567febc34a4a0bc9$var$isKnownFollowers;
module.exports.validateKnownFollowers = $567febc34a4a0bc9$var$validateKnownFollowers;
module.exports.isAdultContentPref = $567febc34a4a0bc9$var$isAdultContentPref;
module.exports.validateAdultContentPref = $567febc34a4a0bc9$var$validateAdultContentPref;
module.exports.isContentLabelPref = $567febc34a4a0bc9$var$isContentLabelPref;
module.exports.validateContentLabelPref = $567febc34a4a0bc9$var$validateContentLabelPref;
module.exports.isSavedFeed = $567febc34a4a0bc9$var$isSavedFeed;
module.exports.validateSavedFeed = $567febc34a4a0bc9$var$validateSavedFeed;
module.exports.isSavedFeedsPrefV2 = $567febc34a4a0bc9$var$isSavedFeedsPrefV2;
module.exports.validateSavedFeedsPrefV2 = $567febc34a4a0bc9$var$validateSavedFeedsPrefV2;
module.exports.isSavedFeedsPref = $567febc34a4a0bc9$var$isSavedFeedsPref;
module.exports.validateSavedFeedsPref = $567febc34a4a0bc9$var$validateSavedFeedsPref;
module.exports.isPersonalDetailsPref = $567febc34a4a0bc9$var$isPersonalDetailsPref;
module.exports.validatePersonalDetailsPref = $567febc34a4a0bc9$var$validatePersonalDetailsPref;
module.exports.isFeedViewPref = $567febc34a4a0bc9$var$isFeedViewPref;
module.exports.validateFeedViewPref = $567febc34a4a0bc9$var$validateFeedViewPref;
module.exports.isThreadViewPref = $567febc34a4a0bc9$var$isThreadViewPref;
module.exports.validateThreadViewPref = $567febc34a4a0bc9$var$validateThreadViewPref;
module.exports.isInterestsPref = $567febc34a4a0bc9$var$isInterestsPref;
module.exports.validateInterestsPref = $567febc34a4a0bc9$var$validateInterestsPref;
module.exports.isMutedWord = $567febc34a4a0bc9$var$isMutedWord;
module.exports.validateMutedWord = $567febc34a4a0bc9$var$validateMutedWord;
module.exports.isMutedWordsPref = $567febc34a4a0bc9$var$isMutedWordsPref;
module.exports.validateMutedWordsPref = $567febc34a4a0bc9$var$validateMutedWordsPref;
module.exports.isHiddenPostsPref = $567febc34a4a0bc9$var$isHiddenPostsPref;
module.exports.validateHiddenPostsPref = $567febc34a4a0bc9$var$validateHiddenPostsPref;
module.exports.isLabelersPref = $567febc34a4a0bc9$var$isLabelersPref;
module.exports.validateLabelersPref = $567febc34a4a0bc9$var$validateLabelersPref;
module.exports.isLabelerPrefItem = $567febc34a4a0bc9$var$isLabelerPrefItem;
module.exports.validateLabelerPrefItem = $567febc34a4a0bc9$var$validateLabelerPrefItem;
module.exports.isBskyAppStatePref = $567febc34a4a0bc9$var$isBskyAppStatePref;
module.exports.validateBskyAppStatePref = $567febc34a4a0bc9$var$validateBskyAppStatePref;
module.exports.isBskyAppProgressGuide = $567febc34a4a0bc9$var$isBskyAppProgressGuide;
module.exports.validateBskyAppProgressGuide = $567febc34a4a0bc9$var$validateBskyAppProgressGuide;
module.exports.isNux = $567febc34a4a0bc9$var$isNux;
module.exports.validateNux = $567febc34a4a0bc9$var$validateNux;
module.exports.isPostInteractionSettingsPref = $567febc34a4a0bc9$var$isPostInteractionSettingsPref;
module.exports.validatePostInteractionSettingsPref = $567febc34a4a0bc9$var$validatePostInteractionSettingsPref;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $567febc34a4a0bc9$var$isProfileViewBasic(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#profileViewBasic';
}
function $567febc34a4a0bc9$var$validateProfileViewBasic(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#profileViewBasic', v);
}
function $567febc34a4a0bc9$var$isProfileView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#profileView';
}
function $567febc34a4a0bc9$var$validateProfileView(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#profileView', v);
}
function $567febc34a4a0bc9$var$isProfileViewDetailed(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#profileViewDetailed';
}
function $567febc34a4a0bc9$var$validateProfileViewDetailed(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#profileViewDetailed', v);
}
function $567febc34a4a0bc9$var$isProfileAssociated(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#profileAssociated';
}
function $567febc34a4a0bc9$var$validateProfileAssociated(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#profileAssociated', v);
}
function $567febc34a4a0bc9$var$isProfileAssociatedChat(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#profileAssociatedChat';
}
function $567febc34a4a0bc9$var$validateProfileAssociatedChat(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#profileAssociatedChat', v);
}
function $567febc34a4a0bc9$var$isViewerState(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#viewerState';
}
function $567febc34a4a0bc9$var$validateViewerState(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#viewerState', v);
}
function $567febc34a4a0bc9$var$isKnownFollowers(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#knownFollowers';
}
function $567febc34a4a0bc9$var$validateKnownFollowers(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#knownFollowers', v);
}
function $567febc34a4a0bc9$var$isAdultContentPref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#adultContentPref';
}
function $567febc34a4a0bc9$var$validateAdultContentPref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#adultContentPref', v);
}
function $567febc34a4a0bc9$var$isContentLabelPref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#contentLabelPref';
}
function $567febc34a4a0bc9$var$validateContentLabelPref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#contentLabelPref', v);
}
function $567febc34a4a0bc9$var$isSavedFeed(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#savedFeed';
}
function $567febc34a4a0bc9$var$validateSavedFeed(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#savedFeed', v);
}
function $567febc34a4a0bc9$var$isSavedFeedsPrefV2(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#savedFeedsPrefV2';
}
function $567febc34a4a0bc9$var$validateSavedFeedsPrefV2(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#savedFeedsPrefV2', v);
}
function $567febc34a4a0bc9$var$isSavedFeedsPref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#savedFeedsPref';
}
function $567febc34a4a0bc9$var$validateSavedFeedsPref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#savedFeedsPref', v);
}
function $567febc34a4a0bc9$var$isPersonalDetailsPref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#personalDetailsPref';
}
function $567febc34a4a0bc9$var$validatePersonalDetailsPref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#personalDetailsPref', v);
}
function $567febc34a4a0bc9$var$isFeedViewPref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#feedViewPref';
}
function $567febc34a4a0bc9$var$validateFeedViewPref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#feedViewPref', v);
}
function $567febc34a4a0bc9$var$isThreadViewPref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#threadViewPref';
}
function $567febc34a4a0bc9$var$validateThreadViewPref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#threadViewPref', v);
}
function $567febc34a4a0bc9$var$isInterestsPref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#interestsPref';
}
function $567febc34a4a0bc9$var$validateInterestsPref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#interestsPref', v);
}
function $567febc34a4a0bc9$var$isMutedWord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#mutedWord';
}
function $567febc34a4a0bc9$var$validateMutedWord(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#mutedWord', v);
}
function $567febc34a4a0bc9$var$isMutedWordsPref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#mutedWordsPref';
}
function $567febc34a4a0bc9$var$validateMutedWordsPref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#mutedWordsPref', v);
}
function $567febc34a4a0bc9$var$isHiddenPostsPref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#hiddenPostsPref';
}
function $567febc34a4a0bc9$var$validateHiddenPostsPref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#hiddenPostsPref', v);
}
function $567febc34a4a0bc9$var$isLabelersPref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#labelersPref';
}
function $567febc34a4a0bc9$var$validateLabelersPref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#labelersPref', v);
}
function $567febc34a4a0bc9$var$isLabelerPrefItem(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#labelerPrefItem';
}
function $567febc34a4a0bc9$var$validateLabelerPrefItem(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#labelerPrefItem', v);
}
function $567febc34a4a0bc9$var$isBskyAppStatePref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#bskyAppStatePref';
}
function $567febc34a4a0bc9$var$validateBskyAppStatePref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#bskyAppStatePref', v);
}
function $567febc34a4a0bc9$var$isBskyAppProgressGuide(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#bskyAppProgressGuide';
}
function $567febc34a4a0bc9$var$validateBskyAppProgressGuide(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#bskyAppProgressGuide', v);
}
function $567febc34a4a0bc9$var$isNux(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#nux';
}
function $567febc34a4a0bc9$var$validateNux(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#nux', v);
}
function $567febc34a4a0bc9$var$isPostInteractionSettingsPref(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.actor.defs#postInteractionSettingsPref';
}
function $567febc34a4a0bc9$var$validatePostInteractionSettingsPref(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.defs#postInteractionSettingsPref', v);
}

});

parcelRegister("ektCj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $a6e9e83c3d54c580$var$toKnownErr;
function $a6e9e83c3d54c580$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("UWOoV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $0ab2d9e65c1f3cf7$var$toKnownErr;
function $0ab2d9e65c1f3cf7$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("1boL8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $0dca062bc99c61cd$var$toKnownErr;
function $0dca062bc99c61cd$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("97RFR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $6a4e67159dfc69cf$var$toKnownErr;
function $6a4e67159dfc69cf$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("gAULq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $c14c0a3fad87a1a7$var$isRecord;
module.exports.validateRecord = $c14c0a3fad87a1a7$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $c14c0a3fad87a1a7$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.actor.profile#main' || v.$type === 'app.bsky.actor.profile');
}
function $c14c0a3fad87a1a7$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.actor.profile#main', v);
}

});

parcelRegister("aKnw9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $7d30715580d87780$var$toKnownErr;
function $7d30715580d87780$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("8m1EY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $6151aa65eb4ebd1f$var$toKnownErr;
function $6151aa65eb4ebd1f$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("jcqCU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $dfa3cac4670f04ff$var$toKnownErr;
function $dfa3cac4670f04ff$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("iZwOD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isAspectRatio = $dd376100e79682dd$var$isAspectRatio;
module.exports.validateAspectRatio = $dd376100e79682dd$var$validateAspectRatio;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $dd376100e79682dd$var$isAspectRatio(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.defs#aspectRatio';
}
function $dd376100e79682dd$var$validateAspectRatio(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.defs#aspectRatio', v);
}

});

parcelRegister("54gTd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMain = $3b0a6d631211b601$var$isMain;
module.exports.validateMain = $3b0a6d631211b601$var$validateMain;
module.exports.isExternal = $3b0a6d631211b601$var$isExternal;
module.exports.validateExternal = $3b0a6d631211b601$var$validateExternal;
module.exports.isView = $3b0a6d631211b601$var$isView;
module.exports.validateView = $3b0a6d631211b601$var$validateView;
module.exports.isViewExternal = $3b0a6d631211b601$var$isViewExternal;
module.exports.validateViewExternal = $3b0a6d631211b601$var$validateViewExternal;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $3b0a6d631211b601$var$isMain(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.embed.external#main' || v.$type === 'app.bsky.embed.external');
}
function $3b0a6d631211b601$var$validateMain(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.external#main', v);
}
function $3b0a6d631211b601$var$isExternal(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.external#external';
}
function $3b0a6d631211b601$var$validateExternal(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.external#external', v);
}
function $3b0a6d631211b601$var$isView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.external#view';
}
function $3b0a6d631211b601$var$validateView(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.external#view', v);
}
function $3b0a6d631211b601$var$isViewExternal(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.external#viewExternal';
}
function $3b0a6d631211b601$var$validateViewExternal(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.external#viewExternal', v);
}

});

parcelRegister("bpQxT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMain = $84faca01e265c230$var$isMain;
module.exports.validateMain = $84faca01e265c230$var$validateMain;
module.exports.isImage = $84faca01e265c230$var$isImage;
module.exports.validateImage = $84faca01e265c230$var$validateImage;
module.exports.isView = $84faca01e265c230$var$isView;
module.exports.validateView = $84faca01e265c230$var$validateView;
module.exports.isViewImage = $84faca01e265c230$var$isViewImage;
module.exports.validateViewImage = $84faca01e265c230$var$validateViewImage;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $84faca01e265c230$var$isMain(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.embed.images#main' || v.$type === 'app.bsky.embed.images');
}
function $84faca01e265c230$var$validateMain(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.images#main', v);
}
function $84faca01e265c230$var$isImage(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.images#image';
}
function $84faca01e265c230$var$validateImage(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.images#image', v);
}
function $84faca01e265c230$var$isView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.images#view';
}
function $84faca01e265c230$var$validateView(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.images#view', v);
}
function $84faca01e265c230$var$isViewImage(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.images#viewImage';
}
function $84faca01e265c230$var$validateViewImage(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.images#viewImage', v);
}

});

parcelRegister("lrQrc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMain = $f9d4cb9f4ad7980f$var$isMain;
module.exports.validateMain = $f9d4cb9f4ad7980f$var$validateMain;
module.exports.isView = $f9d4cb9f4ad7980f$var$isView;
module.exports.validateView = $f9d4cb9f4ad7980f$var$validateView;
module.exports.isViewRecord = $f9d4cb9f4ad7980f$var$isViewRecord;
module.exports.validateViewRecord = $f9d4cb9f4ad7980f$var$validateViewRecord;
module.exports.isViewNotFound = $f9d4cb9f4ad7980f$var$isViewNotFound;
module.exports.validateViewNotFound = $f9d4cb9f4ad7980f$var$validateViewNotFound;
module.exports.isViewBlocked = $f9d4cb9f4ad7980f$var$isViewBlocked;
module.exports.validateViewBlocked = $f9d4cb9f4ad7980f$var$validateViewBlocked;
module.exports.isViewDetached = $f9d4cb9f4ad7980f$var$isViewDetached;
module.exports.validateViewDetached = $f9d4cb9f4ad7980f$var$validateViewDetached;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $f9d4cb9f4ad7980f$var$isMain(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.embed.record#main' || v.$type === 'app.bsky.embed.record');
}
function $f9d4cb9f4ad7980f$var$validateMain(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.record#main', v);
}
function $f9d4cb9f4ad7980f$var$isView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.record#view';
}
function $f9d4cb9f4ad7980f$var$validateView(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.record#view', v);
}
function $f9d4cb9f4ad7980f$var$isViewRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.record#viewRecord';
}
function $f9d4cb9f4ad7980f$var$validateViewRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.record#viewRecord', v);
}
function $f9d4cb9f4ad7980f$var$isViewNotFound(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.record#viewNotFound';
}
function $f9d4cb9f4ad7980f$var$validateViewNotFound(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.record#viewNotFound', v);
}
function $f9d4cb9f4ad7980f$var$isViewBlocked(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.record#viewBlocked';
}
function $f9d4cb9f4ad7980f$var$validateViewBlocked(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.record#viewBlocked', v);
}
function $f9d4cb9f4ad7980f$var$isViewDetached(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.record#viewDetached';
}
function $f9d4cb9f4ad7980f$var$validateViewDetached(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.record#viewDetached', v);
}

});

parcelRegister("8BD8i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMain = $644022659637669d$var$isMain;
module.exports.validateMain = $644022659637669d$var$validateMain;
module.exports.isView = $644022659637669d$var$isView;
module.exports.validateView = $644022659637669d$var$validateView;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $644022659637669d$var$isMain(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.embed.recordWithMedia#main' || v.$type === 'app.bsky.embed.recordWithMedia');
}
function $644022659637669d$var$validateMain(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.recordWithMedia#main', v);
}
function $644022659637669d$var$isView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.recordWithMedia#view';
}
function $644022659637669d$var$validateView(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.recordWithMedia#view', v);
}

});

parcelRegister("lY3vM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMain = $ffe1ece70112f17a$var$isMain;
module.exports.validateMain = $ffe1ece70112f17a$var$validateMain;
module.exports.isCaption = $ffe1ece70112f17a$var$isCaption;
module.exports.validateCaption = $ffe1ece70112f17a$var$validateCaption;
module.exports.isView = $ffe1ece70112f17a$var$isView;
module.exports.validateView = $ffe1ece70112f17a$var$validateView;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $ffe1ece70112f17a$var$isMain(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.embed.video#main' || v.$type === 'app.bsky.embed.video');
}
function $ffe1ece70112f17a$var$validateMain(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.video#main', v);
}
function $ffe1ece70112f17a$var$isCaption(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.video#caption';
}
function $ffe1ece70112f17a$var$validateCaption(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.video#caption', v);
}
function $ffe1ece70112f17a$var$isView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.embed.video#view';
}
function $ffe1ece70112f17a$var$validateView(v) {
    return $8DB7o.lexicons.validate('app.bsky.embed.video#view', v);
}

});

parcelRegister("86MaN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INTERACTIONSHARE = module.exports.INTERACTIONQUOTE = module.exports.INTERACTIONREPLY = module.exports.INTERACTIONREPOST = module.exports.INTERACTIONLIKE = module.exports.INTERACTIONSEEN = module.exports.CONTENTMODEVIDEO = module.exports.CONTENTMODEUNSPECIFIED = module.exports.CLICKTHROUGHEMBED = module.exports.CLICKTHROUGHREPOSTER = module.exports.CLICKTHROUGHAUTHOR = module.exports.CLICKTHROUGHITEM = module.exports.REQUESTMORE = module.exports.REQUESTLESS = void 0;
module.exports.isPostView = $5e74407107bc5380$var$isPostView;
module.exports.validatePostView = $5e74407107bc5380$var$validatePostView;
module.exports.isViewerState = $5e74407107bc5380$var$isViewerState;
module.exports.validateViewerState = $5e74407107bc5380$var$validateViewerState;
module.exports.isThreadContext = $5e74407107bc5380$var$isThreadContext;
module.exports.validateThreadContext = $5e74407107bc5380$var$validateThreadContext;
module.exports.isFeedViewPost = $5e74407107bc5380$var$isFeedViewPost;
module.exports.validateFeedViewPost = $5e74407107bc5380$var$validateFeedViewPost;
module.exports.isReplyRef = $5e74407107bc5380$var$isReplyRef;
module.exports.validateReplyRef = $5e74407107bc5380$var$validateReplyRef;
module.exports.isReasonRepost = $5e74407107bc5380$var$isReasonRepost;
module.exports.validateReasonRepost = $5e74407107bc5380$var$validateReasonRepost;
module.exports.isReasonPin = $5e74407107bc5380$var$isReasonPin;
module.exports.validateReasonPin = $5e74407107bc5380$var$validateReasonPin;
module.exports.isThreadViewPost = $5e74407107bc5380$var$isThreadViewPost;
module.exports.validateThreadViewPost = $5e74407107bc5380$var$validateThreadViewPost;
module.exports.isNotFoundPost = $5e74407107bc5380$var$isNotFoundPost;
module.exports.validateNotFoundPost = $5e74407107bc5380$var$validateNotFoundPost;
module.exports.isBlockedPost = $5e74407107bc5380$var$isBlockedPost;
module.exports.validateBlockedPost = $5e74407107bc5380$var$validateBlockedPost;
module.exports.isBlockedAuthor = $5e74407107bc5380$var$isBlockedAuthor;
module.exports.validateBlockedAuthor = $5e74407107bc5380$var$validateBlockedAuthor;
module.exports.isGeneratorView = $5e74407107bc5380$var$isGeneratorView;
module.exports.validateGeneratorView = $5e74407107bc5380$var$validateGeneratorView;
module.exports.isGeneratorViewerState = $5e74407107bc5380$var$isGeneratorViewerState;
module.exports.validateGeneratorViewerState = $5e74407107bc5380$var$validateGeneratorViewerState;
module.exports.isSkeletonFeedPost = $5e74407107bc5380$var$isSkeletonFeedPost;
module.exports.validateSkeletonFeedPost = $5e74407107bc5380$var$validateSkeletonFeedPost;
module.exports.isSkeletonReasonRepost = $5e74407107bc5380$var$isSkeletonReasonRepost;
module.exports.validateSkeletonReasonRepost = $5e74407107bc5380$var$validateSkeletonReasonRepost;
module.exports.isSkeletonReasonPin = $5e74407107bc5380$var$isSkeletonReasonPin;
module.exports.validateSkeletonReasonPin = $5e74407107bc5380$var$validateSkeletonReasonPin;
module.exports.isThreadgateView = $5e74407107bc5380$var$isThreadgateView;
module.exports.validateThreadgateView = $5e74407107bc5380$var$validateThreadgateView;
module.exports.isInteraction = $5e74407107bc5380$var$isInteraction;
module.exports.validateInteraction = $5e74407107bc5380$var$validateInteraction;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $5e74407107bc5380$var$isPostView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#postView';
}
function $5e74407107bc5380$var$validatePostView(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#postView', v);
}
function $5e74407107bc5380$var$isViewerState(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#viewerState';
}
function $5e74407107bc5380$var$validateViewerState(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#viewerState', v);
}
function $5e74407107bc5380$var$isThreadContext(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#threadContext';
}
function $5e74407107bc5380$var$validateThreadContext(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#threadContext', v);
}
function $5e74407107bc5380$var$isFeedViewPost(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#feedViewPost';
}
function $5e74407107bc5380$var$validateFeedViewPost(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#feedViewPost', v);
}
function $5e74407107bc5380$var$isReplyRef(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#replyRef';
}
function $5e74407107bc5380$var$validateReplyRef(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#replyRef', v);
}
function $5e74407107bc5380$var$isReasonRepost(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#reasonRepost';
}
function $5e74407107bc5380$var$validateReasonRepost(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#reasonRepost', v);
}
function $5e74407107bc5380$var$isReasonPin(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#reasonPin';
}
function $5e74407107bc5380$var$validateReasonPin(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#reasonPin', v);
}
function $5e74407107bc5380$var$isThreadViewPost(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#threadViewPost';
}
function $5e74407107bc5380$var$validateThreadViewPost(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#threadViewPost', v);
}
function $5e74407107bc5380$var$isNotFoundPost(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#notFoundPost';
}
function $5e74407107bc5380$var$validateNotFoundPost(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#notFoundPost', v);
}
function $5e74407107bc5380$var$isBlockedPost(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#blockedPost';
}
function $5e74407107bc5380$var$validateBlockedPost(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#blockedPost', v);
}
function $5e74407107bc5380$var$isBlockedAuthor(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#blockedAuthor';
}
function $5e74407107bc5380$var$validateBlockedAuthor(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#blockedAuthor', v);
}
function $5e74407107bc5380$var$isGeneratorView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#generatorView';
}
function $5e74407107bc5380$var$validateGeneratorView(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#generatorView', v);
}
function $5e74407107bc5380$var$isGeneratorViewerState(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#generatorViewerState';
}
function $5e74407107bc5380$var$validateGeneratorViewerState(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#generatorViewerState', v);
}
function $5e74407107bc5380$var$isSkeletonFeedPost(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#skeletonFeedPost';
}
function $5e74407107bc5380$var$validateSkeletonFeedPost(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#skeletonFeedPost', v);
}
function $5e74407107bc5380$var$isSkeletonReasonRepost(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#skeletonReasonRepost';
}
function $5e74407107bc5380$var$validateSkeletonReasonRepost(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#skeletonReasonRepost', v);
}
function $5e74407107bc5380$var$isSkeletonReasonPin(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#skeletonReasonPin';
}
function $5e74407107bc5380$var$validateSkeletonReasonPin(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#skeletonReasonPin', v);
}
function $5e74407107bc5380$var$isThreadgateView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#threadgateView';
}
function $5e74407107bc5380$var$validateThreadgateView(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#threadgateView', v);
}
function $5e74407107bc5380$var$isInteraction(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.defs#interaction';
}
function $5e74407107bc5380$var$validateInteraction(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.defs#interaction', v);
}
/** Request that less content like the given feed item be shown in the feed */ module.exports.REQUESTLESS = 'app.bsky.feed.defs#requestLess';
/** Request that more content like the given feed item be shown in the feed */ module.exports.REQUESTMORE = 'app.bsky.feed.defs#requestMore';
/** User clicked through to the feed item */ module.exports.CLICKTHROUGHITEM = 'app.bsky.feed.defs#clickthroughItem';
/** User clicked through to the author of the feed item */ module.exports.CLICKTHROUGHAUTHOR = 'app.bsky.feed.defs#clickthroughAuthor';
/** User clicked through to the reposter of the feed item */ module.exports.CLICKTHROUGHREPOSTER = 'app.bsky.feed.defs#clickthroughReposter';
/** User clicked through to the embedded content of the feed item */ module.exports.CLICKTHROUGHEMBED = 'app.bsky.feed.defs#clickthroughEmbed';
/** Declares the feed generator returns any types of posts. */ module.exports.CONTENTMODEUNSPECIFIED = 'app.bsky.feed.defs#contentModeUnspecified';
/** Declares the feed generator returns posts containing app.bsky.embed.video embeds. */ module.exports.CONTENTMODEVIDEO = 'app.bsky.feed.defs#contentModeVideo';
/** Feed item was seen by user */ module.exports.INTERACTIONSEEN = 'app.bsky.feed.defs#interactionSeen';
/** User liked the feed item */ module.exports.INTERACTIONLIKE = 'app.bsky.feed.defs#interactionLike';
/** User reposted the feed item */ module.exports.INTERACTIONREPOST = 'app.bsky.feed.defs#interactionRepost';
/** User replied to the feed item */ module.exports.INTERACTIONREPLY = 'app.bsky.feed.defs#interactionReply';
/** User quoted the feed item */ module.exports.INTERACTIONQUOTE = 'app.bsky.feed.defs#interactionQuote';
/** User shared the feed item */ module.exports.INTERACTIONSHARE = 'app.bsky.feed.defs#interactionShare';

});

parcelRegister("d3V3p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $9827cfea84374765$var$toKnownErr;
module.exports.isFeed = $9827cfea84374765$var$isFeed;
module.exports.validateFeed = $9827cfea84374765$var$validateFeed;
module.exports.isLinks = $9827cfea84374765$var$isLinks;
module.exports.validateLinks = $9827cfea84374765$var$validateLinks;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $9827cfea84374765$var$toKnownErr(e) {
    return e;
}
function $9827cfea84374765$var$isFeed(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.describeFeedGenerator#feed';
}
function $9827cfea84374765$var$validateFeed(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.describeFeedGenerator#feed', v);
}
function $9827cfea84374765$var$isLinks(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.describeFeedGenerator#links';
}
function $9827cfea84374765$var$validateLinks(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.describeFeedGenerator#links', v);
}

});

parcelRegister("eHGxp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $ab4613f361a2d6a9$var$isRecord;
module.exports.validateRecord = $ab4613f361a2d6a9$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $ab4613f361a2d6a9$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.feed.generator#main' || v.$type === 'app.bsky.feed.generator');
}
function $ab4613f361a2d6a9$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.generator#main', v);
}

});

parcelRegister("7yYE0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $581ac0175b30cc3b$var$toKnownErr;
function $581ac0175b30cc3b$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("9MX52", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $72066cdcd2590e2b$var$toKnownErr;
function $72066cdcd2590e2b$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("bDW3n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $87a05e72a1982c73$var$toKnownErr;
function $87a05e72a1982c73$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("kuzGC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $eeb24a951c76a7f6$var$toKnownErr;
module.exports.isLike = $eeb24a951c76a7f6$var$isLike;
module.exports.validateLike = $eeb24a951c76a7f6$var$validateLike;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $eeb24a951c76a7f6$var$toKnownErr(e) {
    return e;
}
function $eeb24a951c76a7f6$var$isLike(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.getLikes#like';
}
function $eeb24a951c76a7f6$var$validateLike(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.getLikes#like', v);
}

});

parcelRegister("2qkY7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $1c3e466947ed8e22$var$toKnownErr;
function $1c3e466947ed8e22$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("h1AAc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $c64ee83ec9ef0f02$var$toKnownErr;
function $c64ee83ec9ef0f02$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("lR19r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $fe8f70cf9c098344$var$toKnownErr;
function $fe8f70cf9c098344$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("2yXex", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $1ddcb44c57b10222$var$toKnownErr;
function $1ddcb44c57b10222$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("49vCN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $306088ba3bd99c9f$var$toKnownErr;
function $306088ba3bd99c9f$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("emCFC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $a7511dde7f719cc7$var$isRecord;
module.exports.validateRecord = $a7511dde7f719cc7$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $a7511dde7f719cc7$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.feed.like#main' || v.$type === 'app.bsky.feed.like');
}
function $a7511dde7f719cc7$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.like#main', v);
}

});

parcelRegister("dA4VG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $9e32760841150c1a$var$isRecord;
module.exports.validateRecord = $9e32760841150c1a$var$validateRecord;
module.exports.isReplyRef = $9e32760841150c1a$var$isReplyRef;
module.exports.validateReplyRef = $9e32760841150c1a$var$validateReplyRef;
module.exports.isEntity = $9e32760841150c1a$var$isEntity;
module.exports.validateEntity = $9e32760841150c1a$var$validateEntity;
module.exports.isTextSlice = $9e32760841150c1a$var$isTextSlice;
module.exports.validateTextSlice = $9e32760841150c1a$var$validateTextSlice;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $9e32760841150c1a$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.feed.post#main' || v.$type === 'app.bsky.feed.post');
}
function $9e32760841150c1a$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.post#main', v);
}
function $9e32760841150c1a$var$isReplyRef(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.post#replyRef';
}
function $9e32760841150c1a$var$validateReplyRef(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.post#replyRef', v);
}
function $9e32760841150c1a$var$isEntity(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.post#entity';
}
function $9e32760841150c1a$var$validateEntity(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.post#entity', v);
}
function $9e32760841150c1a$var$isTextSlice(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.post#textSlice';
}
function $9e32760841150c1a$var$validateTextSlice(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.post#textSlice', v);
}

});

parcelRegister("lqVrJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $f9a8965297fb1816$var$isRecord;
module.exports.validateRecord = $f9a8965297fb1816$var$validateRecord;
module.exports.isDisableRule = $f9a8965297fb1816$var$isDisableRule;
module.exports.validateDisableRule = $f9a8965297fb1816$var$validateDisableRule;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $f9a8965297fb1816$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.feed.postgate#main' || v.$type === 'app.bsky.feed.postgate');
}
function $f9a8965297fb1816$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.postgate#main', v);
}
function $f9a8965297fb1816$var$isDisableRule(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.postgate#disableRule';
}
function $f9a8965297fb1816$var$validateDisableRule(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.postgate#disableRule', v);
}

});

parcelRegister("aodyA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $7906a95ef8ac4075$var$isRecord;
module.exports.validateRecord = $7906a95ef8ac4075$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $7906a95ef8ac4075$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.feed.repost#main' || v.$type === 'app.bsky.feed.repost');
}
function $7906a95ef8ac4075$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.repost#main', v);
}

});

parcelRegister("9FIoQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $70aa623bdf5eec58$var$toKnownErr;
function $70aa623bdf5eec58$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("kJnJc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $f17a6a86360e785e$var$isRecord;
module.exports.validateRecord = $f17a6a86360e785e$var$validateRecord;
module.exports.isMentionRule = $f17a6a86360e785e$var$isMentionRule;
module.exports.validateMentionRule = $f17a6a86360e785e$var$validateMentionRule;
module.exports.isFollowerRule = $f17a6a86360e785e$var$isFollowerRule;
module.exports.validateFollowerRule = $f17a6a86360e785e$var$validateFollowerRule;
module.exports.isFollowingRule = $f17a6a86360e785e$var$isFollowingRule;
module.exports.validateFollowingRule = $f17a6a86360e785e$var$validateFollowingRule;
module.exports.isListRule = $f17a6a86360e785e$var$isListRule;
module.exports.validateListRule = $f17a6a86360e785e$var$validateListRule;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $f17a6a86360e785e$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.feed.threadgate#main' || v.$type === 'app.bsky.feed.threadgate');
}
function $f17a6a86360e785e$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.threadgate#main', v);
}
function $f17a6a86360e785e$var$isMentionRule(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.threadgate#mentionRule';
}
function $f17a6a86360e785e$var$validateMentionRule(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.threadgate#mentionRule', v);
}
function $f17a6a86360e785e$var$isFollowerRule(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.threadgate#followerRule';
}
function $f17a6a86360e785e$var$validateFollowerRule(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.threadgate#followerRule', v);
}
function $f17a6a86360e785e$var$isFollowingRule(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.threadgate#followingRule';
}
function $f17a6a86360e785e$var$validateFollowingRule(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.threadgate#followingRule', v);
}
function $f17a6a86360e785e$var$isListRule(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.feed.threadgate#listRule';
}
function $f17a6a86360e785e$var$validateListRule(v) {
    return $8DB7o.lexicons.validate('app.bsky.feed.threadgate#listRule', v);
}

});

parcelRegister("ktNzM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $ee8cf8d9452d07d7$var$isRecord;
module.exports.validateRecord = $ee8cf8d9452d07d7$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $ee8cf8d9452d07d7$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.graph.block#main' || v.$type === 'app.bsky.graph.block');
}
function $ee8cf8d9452d07d7$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.block#main', v);
}

});

parcelRegister("9PmXs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.REFERENCELIST = module.exports.CURATELIST = module.exports.MODLIST = void 0;
module.exports.isListViewBasic = $727aaf77d9c20efb$var$isListViewBasic;
module.exports.validateListViewBasic = $727aaf77d9c20efb$var$validateListViewBasic;
module.exports.isListView = $727aaf77d9c20efb$var$isListView;
module.exports.validateListView = $727aaf77d9c20efb$var$validateListView;
module.exports.isListItemView = $727aaf77d9c20efb$var$isListItemView;
module.exports.validateListItemView = $727aaf77d9c20efb$var$validateListItemView;
module.exports.isStarterPackView = $727aaf77d9c20efb$var$isStarterPackView;
module.exports.validateStarterPackView = $727aaf77d9c20efb$var$validateStarterPackView;
module.exports.isStarterPackViewBasic = $727aaf77d9c20efb$var$isStarterPackViewBasic;
module.exports.validateStarterPackViewBasic = $727aaf77d9c20efb$var$validateStarterPackViewBasic;
module.exports.isListViewerState = $727aaf77d9c20efb$var$isListViewerState;
module.exports.validateListViewerState = $727aaf77d9c20efb$var$validateListViewerState;
module.exports.isNotFoundActor = $727aaf77d9c20efb$var$isNotFoundActor;
module.exports.validateNotFoundActor = $727aaf77d9c20efb$var$validateNotFoundActor;
module.exports.isRelationship = $727aaf77d9c20efb$var$isRelationship;
module.exports.validateRelationship = $727aaf77d9c20efb$var$validateRelationship;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $727aaf77d9c20efb$var$isListViewBasic(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.graph.defs#listViewBasic';
}
function $727aaf77d9c20efb$var$validateListViewBasic(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.defs#listViewBasic', v);
}
function $727aaf77d9c20efb$var$isListView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.graph.defs#listView';
}
function $727aaf77d9c20efb$var$validateListView(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.defs#listView', v);
}
function $727aaf77d9c20efb$var$isListItemView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.graph.defs#listItemView';
}
function $727aaf77d9c20efb$var$validateListItemView(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.defs#listItemView', v);
}
function $727aaf77d9c20efb$var$isStarterPackView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.graph.defs#starterPackView';
}
function $727aaf77d9c20efb$var$validateStarterPackView(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.defs#starterPackView', v);
}
function $727aaf77d9c20efb$var$isStarterPackViewBasic(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.graph.defs#starterPackViewBasic';
}
function $727aaf77d9c20efb$var$validateStarterPackViewBasic(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.defs#starterPackViewBasic', v);
}
/** A list of actors to apply an aggregate moderation action (mute/block) on. */ module.exports.MODLIST = 'app.bsky.graph.defs#modlist';
/** A list of actors used for curation purposes such as list feeds or interaction gating. */ module.exports.CURATELIST = 'app.bsky.graph.defs#curatelist';
/** A list of actors used for only for reference purposes such as within a starter pack. */ module.exports.REFERENCELIST = 'app.bsky.graph.defs#referencelist';
function $727aaf77d9c20efb$var$isListViewerState(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.graph.defs#listViewerState';
}
function $727aaf77d9c20efb$var$validateListViewerState(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.defs#listViewerState', v);
}
function $727aaf77d9c20efb$var$isNotFoundActor(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.graph.defs#notFoundActor';
}
function $727aaf77d9c20efb$var$validateNotFoundActor(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.defs#notFoundActor', v);
}
function $727aaf77d9c20efb$var$isRelationship(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.graph.defs#relationship';
}
function $727aaf77d9c20efb$var$validateRelationship(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.defs#relationship', v);
}

});

parcelRegister("3vuZu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $28dc4e73814a1dd8$var$isRecord;
module.exports.validateRecord = $28dc4e73814a1dd8$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $28dc4e73814a1dd8$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.graph.follow#main' || v.$type === 'app.bsky.graph.follow');
}
function $28dc4e73814a1dd8$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.follow#main', v);
}

});

parcelRegister("heCVf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $c8c1efa21ad8d362$var$toKnownErr;
function $c8c1efa21ad8d362$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("8LdYU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $660d8eef3bef083a$var$toKnownErr;
function $660d8eef3bef083a$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("7ifqL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $54f62f080425f050$var$toKnownErr;
function $54f62f080425f050$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("g7fnS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $bbb93bbfda63d5f4$var$toKnownErr;
function $bbb93bbfda63d5f4$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("PV2s8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $09c1023469ceb2f1$var$toKnownErr;
function $09c1023469ceb2f1$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("iGYFw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $d9bb35c4f6f069b5$var$toKnownErr;
function $d9bb35c4f6f069b5$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("kV7NH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $f3af2e8d37dfe41d$var$toKnownErr;
function $f3af2e8d37dfe41d$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("32K4y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $23754c073c37fd86$var$toKnownErr;
function $23754c073c37fd86$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("j5fp9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $de4a6f047ecdd180$var$toKnownErr;
function $de4a6f047ecdd180$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("bW3hd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $8b07a72d0449695e$var$toKnownErr;
function $8b07a72d0449695e$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("3bkJ9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $25127a2a62005e8d$var$toKnownErr;
function $25127a2a62005e8d$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("kgpaj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $ec08d2932699f427$var$toKnownErr;
function $ec08d2932699f427$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("6ZI9T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $517ab18f21a074da$var$toKnownErr;
function $517ab18f21a074da$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("jbrBl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $df74746e0b7036a9$var$isRecord;
module.exports.validateRecord = $df74746e0b7036a9$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $df74746e0b7036a9$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.graph.list#main' || v.$type === 'app.bsky.graph.list');
}
function $df74746e0b7036a9$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.list#main', v);
}

});

parcelRegister("eSEbx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $ad5547bbd61766ce$var$isRecord;
module.exports.validateRecord = $ad5547bbd61766ce$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $ad5547bbd61766ce$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.graph.listblock#main' || v.$type === 'app.bsky.graph.listblock');
}
function $ad5547bbd61766ce$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.listblock#main', v);
}

});

parcelRegister("dbR2M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $99a572d5848c4a97$var$isRecord;
module.exports.validateRecord = $99a572d5848c4a97$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $99a572d5848c4a97$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.graph.listitem#main' || v.$type === 'app.bsky.graph.listitem');
}
function $99a572d5848c4a97$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.listitem#main', v);
}

});

parcelRegister("7E8cO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $5912a24c9a58ecd4$var$toKnownErr;
function $5912a24c9a58ecd4$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("11wXa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $0bef724c9e25bc17$var$toKnownErr;
function $0bef724c9e25bc17$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("lyqld", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $fb1134bcfc8f4f37$var$toKnownErr;
function $fb1134bcfc8f4f37$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("cD0Si", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $9319ce3e104e3d1e$var$toKnownErr;
function $9319ce3e104e3d1e$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("kICrf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $f155bbd08545a9d4$var$isRecord;
module.exports.validateRecord = $f155bbd08545a9d4$var$validateRecord;
module.exports.isFeedItem = $f155bbd08545a9d4$var$isFeedItem;
module.exports.validateFeedItem = $f155bbd08545a9d4$var$validateFeedItem;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $f155bbd08545a9d4$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.graph.starterpack#main' || v.$type === 'app.bsky.graph.starterpack');
}
function $f155bbd08545a9d4$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.starterpack#main', v);
}
function $f155bbd08545a9d4$var$isFeedItem(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.graph.starterpack#feedItem';
}
function $f155bbd08545a9d4$var$validateFeedItem(v) {
    return $8DB7o.lexicons.validate('app.bsky.graph.starterpack#feedItem', v);
}

});

parcelRegister("d5Ezz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $987b36e33d8563a3$var$toKnownErr;
function $987b36e33d8563a3$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("3XytH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $2e21a067f31c0138$var$toKnownErr;
function $2e21a067f31c0138$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("7XzMt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $5cb9cc670ff5cd33$var$toKnownErr;
function $5cb9cc670ff5cd33$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("gaL4b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isLabelerView = $bc6216f0921e1b78$var$isLabelerView;
module.exports.validateLabelerView = $bc6216f0921e1b78$var$validateLabelerView;
module.exports.isLabelerViewDetailed = $bc6216f0921e1b78$var$isLabelerViewDetailed;
module.exports.validateLabelerViewDetailed = $bc6216f0921e1b78$var$validateLabelerViewDetailed;
module.exports.isLabelerViewerState = $bc6216f0921e1b78$var$isLabelerViewerState;
module.exports.validateLabelerViewerState = $bc6216f0921e1b78$var$validateLabelerViewerState;
module.exports.isLabelerPolicies = $bc6216f0921e1b78$var$isLabelerPolicies;
module.exports.validateLabelerPolicies = $bc6216f0921e1b78$var$validateLabelerPolicies;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $bc6216f0921e1b78$var$isLabelerView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.labeler.defs#labelerView';
}
function $bc6216f0921e1b78$var$validateLabelerView(v) {
    return $8DB7o.lexicons.validate('app.bsky.labeler.defs#labelerView', v);
}
function $bc6216f0921e1b78$var$isLabelerViewDetailed(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.labeler.defs#labelerViewDetailed';
}
function $bc6216f0921e1b78$var$validateLabelerViewDetailed(v) {
    return $8DB7o.lexicons.validate('app.bsky.labeler.defs#labelerViewDetailed', v);
}
function $bc6216f0921e1b78$var$isLabelerViewerState(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.labeler.defs#labelerViewerState';
}
function $bc6216f0921e1b78$var$validateLabelerViewerState(v) {
    return $8DB7o.lexicons.validate('app.bsky.labeler.defs#labelerViewerState', v);
}
function $bc6216f0921e1b78$var$isLabelerPolicies(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.labeler.defs#labelerPolicies';
}
function $bc6216f0921e1b78$var$validateLabelerPolicies(v) {
    return $8DB7o.lexicons.validate('app.bsky.labeler.defs#labelerPolicies', v);
}

});

parcelRegister("do49g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $9bf0bc060e516299$var$toKnownErr;
function $9bf0bc060e516299$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("kTb8K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $f35195e7a45874bd$var$isRecord;
module.exports.validateRecord = $f35195e7a45874bd$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $f35195e7a45874bd$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.labeler.service#main' || v.$type === 'app.bsky.labeler.service');
}
function $f35195e7a45874bd$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('app.bsky.labeler.service#main', v);
}

});

parcelRegister("crsz1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $90ee29d7fd462702$var$toKnownErr;
function $90ee29d7fd462702$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("a1dNC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $74b4b39c4b67e031$var$toKnownErr;
module.exports.isNotification = $74b4b39c4b67e031$var$isNotification;
module.exports.validateNotification = $74b4b39c4b67e031$var$validateNotification;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $74b4b39c4b67e031$var$toKnownErr(e) {
    return e;
}
function $74b4b39c4b67e031$var$isNotification(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.notification.listNotifications#notification';
}
function $74b4b39c4b67e031$var$validateNotification(v) {
    return $8DB7o.lexicons.validate('app.bsky.notification.listNotifications#notification', v);
}

});

parcelRegister("k5Cxj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $ea022aced95afcbb$var$toKnownErr;
function $ea022aced95afcbb$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("7Qgmk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $5b5a1451f4776aec$var$toKnownErr;
function $5b5a1451f4776aec$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("lVw97", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $ff67db5faa34300f$var$toKnownErr;
function $ff67db5faa34300f$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("9A9dd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMain = $6f9e9f2bbb65e435$var$isMain;
module.exports.validateMain = $6f9e9f2bbb65e435$var$validateMain;
module.exports.isMention = $6f9e9f2bbb65e435$var$isMention;
module.exports.validateMention = $6f9e9f2bbb65e435$var$validateMention;
module.exports.isLink = $6f9e9f2bbb65e435$var$isLink;
module.exports.validateLink = $6f9e9f2bbb65e435$var$validateLink;
module.exports.isTag = $6f9e9f2bbb65e435$var$isTag;
module.exports.validateTag = $6f9e9f2bbb65e435$var$validateTag;
module.exports.isByteSlice = $6f9e9f2bbb65e435$var$isByteSlice;
module.exports.validateByteSlice = $6f9e9f2bbb65e435$var$validateByteSlice;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $6f9e9f2bbb65e435$var$isMain(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'app.bsky.richtext.facet#main' || v.$type === 'app.bsky.richtext.facet');
}
function $6f9e9f2bbb65e435$var$validateMain(v) {
    return $8DB7o.lexicons.validate('app.bsky.richtext.facet#main', v);
}
function $6f9e9f2bbb65e435$var$isMention(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.richtext.facet#mention';
}
function $6f9e9f2bbb65e435$var$validateMention(v) {
    return $8DB7o.lexicons.validate('app.bsky.richtext.facet#mention', v);
}
function $6f9e9f2bbb65e435$var$isLink(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.richtext.facet#link';
}
function $6f9e9f2bbb65e435$var$validateLink(v) {
    return $8DB7o.lexicons.validate('app.bsky.richtext.facet#link', v);
}
function $6f9e9f2bbb65e435$var$isTag(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.richtext.facet#tag';
}
function $6f9e9f2bbb65e435$var$validateTag(v) {
    return $8DB7o.lexicons.validate('app.bsky.richtext.facet#tag', v);
}
function $6f9e9f2bbb65e435$var$isByteSlice(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.richtext.facet#byteSlice';
}
function $6f9e9f2bbb65e435$var$validateByteSlice(v) {
    return $8DB7o.lexicons.validate('app.bsky.richtext.facet#byteSlice', v);
}

});

parcelRegister("eYq3K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSkeletonSearchPost = $ae6ae220d7de885f$var$isSkeletonSearchPost;
module.exports.validateSkeletonSearchPost = $ae6ae220d7de885f$var$validateSkeletonSearchPost;
module.exports.isSkeletonSearchActor = $ae6ae220d7de885f$var$isSkeletonSearchActor;
module.exports.validateSkeletonSearchActor = $ae6ae220d7de885f$var$validateSkeletonSearchActor;
module.exports.isSkeletonSearchStarterPack = $ae6ae220d7de885f$var$isSkeletonSearchStarterPack;
module.exports.validateSkeletonSearchStarterPack = $ae6ae220d7de885f$var$validateSkeletonSearchStarterPack;
module.exports.isTrendingTopic = $ae6ae220d7de885f$var$isTrendingTopic;
module.exports.validateTrendingTopic = $ae6ae220d7de885f$var$validateTrendingTopic;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $ae6ae220d7de885f$var$isSkeletonSearchPost(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.unspecced.defs#skeletonSearchPost';
}
function $ae6ae220d7de885f$var$validateSkeletonSearchPost(v) {
    return $8DB7o.lexicons.validate('app.bsky.unspecced.defs#skeletonSearchPost', v);
}
function $ae6ae220d7de885f$var$isSkeletonSearchActor(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.unspecced.defs#skeletonSearchActor';
}
function $ae6ae220d7de885f$var$validateSkeletonSearchActor(v) {
    return $8DB7o.lexicons.validate('app.bsky.unspecced.defs#skeletonSearchActor', v);
}
function $ae6ae220d7de885f$var$isSkeletonSearchStarterPack(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.unspecced.defs#skeletonSearchStarterPack';
}
function $ae6ae220d7de885f$var$validateSkeletonSearchStarterPack(v) {
    return $8DB7o.lexicons.validate('app.bsky.unspecced.defs#skeletonSearchStarterPack', v);
}
function $ae6ae220d7de885f$var$isTrendingTopic(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.unspecced.defs#trendingTopic';
}
function $ae6ae220d7de885f$var$validateTrendingTopic(v) {
    return $8DB7o.lexicons.validate('app.bsky.unspecced.defs#trendingTopic', v);
}

});

parcelRegister("9pS3C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $6db0618607a5eb22$var$toKnownErr;
function $6db0618607a5eb22$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("iipCK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $d51dc8cd410671be$var$toKnownErr;
function $d51dc8cd410671be$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("8rKha", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $6264bdc5f033a618$var$toKnownErr;
function $6264bdc5f033a618$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("akzbJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $78571147b107d050$var$toKnownErr;
module.exports.isSuggestion = $78571147b107d050$var$isSuggestion;
module.exports.validateSuggestion = $78571147b107d050$var$validateSuggestion;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $78571147b107d050$var$toKnownErr(e) {
    return e;
}
function $78571147b107d050$var$isSuggestion(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.unspecced.getTaggedSuggestions#suggestion';
}
function $78571147b107d050$var$validateSuggestion(v) {
    return $8DB7o.lexicons.validate('app.bsky.unspecced.getTaggedSuggestions#suggestion', v);
}

});

parcelRegister("lBc7d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $fb96738b77af5d0c$var$toKnownErr;
function $fb96738b77af5d0c$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("elLFy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isJobStatus = $a72800f91024b1a4$var$isJobStatus;
module.exports.validateJobStatus = $a72800f91024b1a4$var$validateJobStatus;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $a72800f91024b1a4$var$isJobStatus(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'app.bsky.video.defs#jobStatus';
}
function $a72800f91024b1a4$var$validateJobStatus(v) {
    return $8DB7o.lexicons.validate('app.bsky.video.defs#jobStatus', v);
}

});

parcelRegister("c1XWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $8c24135691848daf$var$toKnownErr;
function $8c24135691848daf$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("lqvW5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $f994cc7e1b53e0ed$var$toKnownErr;
function $f994cc7e1b53e0ed$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("732VG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $521b15e8c50c0a63$var$toKnownErr;
function $521b15e8c50c0a63$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("6RG6O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isRecord = $4ff85b44f915538f$var$isRecord;
module.exports.validateRecord = $4ff85b44f915538f$var$validateRecord;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $4ff85b44f915538f$var$isRecord(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && (v.$type === 'chat.bsky.actor.declaration#main' || v.$type === 'chat.bsky.actor.declaration');
}
function $4ff85b44f915538f$var$validateRecord(v) {
    return $8DB7o.lexicons.validate('chat.bsky.actor.declaration#main', v);
}

});

parcelRegister("eCoUx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProfileViewBasic = $aa47f01a97caac15$var$isProfileViewBasic;
module.exports.validateProfileViewBasic = $aa47f01a97caac15$var$validateProfileViewBasic;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $aa47f01a97caac15$var$isProfileViewBasic(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.actor.defs#profileViewBasic';
}
function $aa47f01a97caac15$var$validateProfileViewBasic(v) {
    return $8DB7o.lexicons.validate('chat.bsky.actor.defs#profileViewBasic', v);
}

});

parcelRegister("cVrl3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $969003c1477c2cd3$var$toKnownErr;
function $969003c1477c2cd3$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("fR30F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $b8ae23ece2cdb79b$var$toKnownErr;
function $b8ae23ece2cdb79b$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("ctaCe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMessageRef = $91406d7e3ac870b5$var$isMessageRef;
module.exports.validateMessageRef = $91406d7e3ac870b5$var$validateMessageRef;
module.exports.isMessageInput = $91406d7e3ac870b5$var$isMessageInput;
module.exports.validateMessageInput = $91406d7e3ac870b5$var$validateMessageInput;
module.exports.isMessageView = $91406d7e3ac870b5$var$isMessageView;
module.exports.validateMessageView = $91406d7e3ac870b5$var$validateMessageView;
module.exports.isDeletedMessageView = $91406d7e3ac870b5$var$isDeletedMessageView;
module.exports.validateDeletedMessageView = $91406d7e3ac870b5$var$validateDeletedMessageView;
module.exports.isMessageViewSender = $91406d7e3ac870b5$var$isMessageViewSender;
module.exports.validateMessageViewSender = $91406d7e3ac870b5$var$validateMessageViewSender;
module.exports.isConvoView = $91406d7e3ac870b5$var$isConvoView;
module.exports.validateConvoView = $91406d7e3ac870b5$var$validateConvoView;
module.exports.isLogBeginConvo = $91406d7e3ac870b5$var$isLogBeginConvo;
module.exports.validateLogBeginConvo = $91406d7e3ac870b5$var$validateLogBeginConvo;
module.exports.isLogLeaveConvo = $91406d7e3ac870b5$var$isLogLeaveConvo;
module.exports.validateLogLeaveConvo = $91406d7e3ac870b5$var$validateLogLeaveConvo;
module.exports.isLogCreateMessage = $91406d7e3ac870b5$var$isLogCreateMessage;
module.exports.validateLogCreateMessage = $91406d7e3ac870b5$var$validateLogCreateMessage;
module.exports.isLogDeleteMessage = $91406d7e3ac870b5$var$isLogDeleteMessage;
module.exports.validateLogDeleteMessage = $91406d7e3ac870b5$var$validateLogDeleteMessage;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $91406d7e3ac870b5$var$isMessageRef(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.convo.defs#messageRef';
}
function $91406d7e3ac870b5$var$validateMessageRef(v) {
    return $8DB7o.lexicons.validate('chat.bsky.convo.defs#messageRef', v);
}
function $91406d7e3ac870b5$var$isMessageInput(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.convo.defs#messageInput';
}
function $91406d7e3ac870b5$var$validateMessageInput(v) {
    return $8DB7o.lexicons.validate('chat.bsky.convo.defs#messageInput', v);
}
function $91406d7e3ac870b5$var$isMessageView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.convo.defs#messageView';
}
function $91406d7e3ac870b5$var$validateMessageView(v) {
    return $8DB7o.lexicons.validate('chat.bsky.convo.defs#messageView', v);
}
function $91406d7e3ac870b5$var$isDeletedMessageView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.convo.defs#deletedMessageView';
}
function $91406d7e3ac870b5$var$validateDeletedMessageView(v) {
    return $8DB7o.lexicons.validate('chat.bsky.convo.defs#deletedMessageView', v);
}
function $91406d7e3ac870b5$var$isMessageViewSender(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.convo.defs#messageViewSender';
}
function $91406d7e3ac870b5$var$validateMessageViewSender(v) {
    return $8DB7o.lexicons.validate('chat.bsky.convo.defs#messageViewSender', v);
}
function $91406d7e3ac870b5$var$isConvoView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.convo.defs#convoView';
}
function $91406d7e3ac870b5$var$validateConvoView(v) {
    return $8DB7o.lexicons.validate('chat.bsky.convo.defs#convoView', v);
}
function $91406d7e3ac870b5$var$isLogBeginConvo(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.convo.defs#logBeginConvo';
}
function $91406d7e3ac870b5$var$validateLogBeginConvo(v) {
    return $8DB7o.lexicons.validate('chat.bsky.convo.defs#logBeginConvo', v);
}
function $91406d7e3ac870b5$var$isLogLeaveConvo(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.convo.defs#logLeaveConvo';
}
function $91406d7e3ac870b5$var$validateLogLeaveConvo(v) {
    return $8DB7o.lexicons.validate('chat.bsky.convo.defs#logLeaveConvo', v);
}
function $91406d7e3ac870b5$var$isLogCreateMessage(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.convo.defs#logCreateMessage';
}
function $91406d7e3ac870b5$var$validateLogCreateMessage(v) {
    return $8DB7o.lexicons.validate('chat.bsky.convo.defs#logCreateMessage', v);
}
function $91406d7e3ac870b5$var$isLogDeleteMessage(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.convo.defs#logDeleteMessage';
}
function $91406d7e3ac870b5$var$validateLogDeleteMessage(v) {
    return $8DB7o.lexicons.validate('chat.bsky.convo.defs#logDeleteMessage', v);
}

});

parcelRegister("f4THE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $afa270311082edb1$var$toKnownErr;
function $afa270311082edb1$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("4CcW5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $35c4bed127d226b8$var$toKnownErr;
function $35c4bed127d226b8$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("fBFuC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $b5ca7f50fbe8a63a$var$toKnownErr;
function $b5ca7f50fbe8a63a$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("k7g8q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $ea50fa277b9512bf$var$toKnownErr;
function $ea50fa277b9512bf$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("4S3xN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $38bef45cb852a153$var$toKnownErr;
function $38bef45cb852a153$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("2kE4B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $1b2c88ba0c155e2c$var$toKnownErr;
function $1b2c88ba0c155e2c$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("7vC3G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $5778f3446f234c90$var$toKnownErr;
function $5778f3446f234c90$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("ezKoq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $a9c852406c029c8f$var$toKnownErr;
function $a9c852406c029c8f$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("bRCER", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $8a32a1a7884da942$var$toKnownErr;
function $8a32a1a7884da942$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("f6UnX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $b0032788fa0d77ea$var$toKnownErr;
module.exports.isBatchItem = $b0032788fa0d77ea$var$isBatchItem;
module.exports.validateBatchItem = $b0032788fa0d77ea$var$validateBatchItem;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $b0032788fa0d77ea$var$toKnownErr(e) {
    return e;
}
function $b0032788fa0d77ea$var$isBatchItem(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.convo.sendMessageBatch#batchItem';
}
function $b0032788fa0d77ea$var$validateBatchItem(v) {
    return $8DB7o.lexicons.validate('chat.bsky.convo.sendMessageBatch#batchItem', v);
}

});

parcelRegister("5iDv7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $3dbd463d5435eecb$var$toKnownErr;
function $3dbd463d5435eecb$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("kRS5s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $f312b66ef1bd7267$var$toKnownErr;
function $f312b66ef1bd7267$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("bISqi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $888e0511979a371d$var$toKnownErr;
module.exports.isMetadata = $888e0511979a371d$var$isMetadata;
module.exports.validateMetadata = $888e0511979a371d$var$validateMetadata;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $888e0511979a371d$var$toKnownErr(e) {
    return e;
}
function $888e0511979a371d$var$isMetadata(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'chat.bsky.moderation.getActorMetadata#metadata';
}
function $888e0511979a371d$var$validateMetadata(v) {
    return $8DB7o.lexicons.validate('chat.bsky.moderation.getActorMetadata#metadata', v);
}

});

parcelRegister("9ef2S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $6b81179553fc6805$var$toKnownErr;
function $6b81179553fc6805$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("8RhM1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $67310f6656c41ab3$var$toKnownErr;
function $67310f6656c41ab3$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("bzcjd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isTemplateView = $86bc82e0f06de38d$var$isTemplateView;
module.exports.validateTemplateView = $86bc82e0f06de38d$var$validateTemplateView;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $86bc82e0f06de38d$var$isTemplateView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.communication.defs#templateView';
}
function $86bc82e0f06de38d$var$validateTemplateView(v) {
    return $8DB7o.lexicons.validate('tools.ozone.communication.defs#templateView', v);
}

});

parcelRegister("jsnJH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $e2a30b5b0c6e5f57$var$toKnownErr;
function $e2a30b5b0c6e5f57$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("5uR93", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $4008fa943b0c83f6$var$toKnownErr;
function $4008fa943b0c83f6$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("2h9B2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.REVIEWNONE = module.exports.REVIEWCLOSED = module.exports.REVIEWESCALATED = module.exports.REVIEWOPEN = void 0;
module.exports.isModEventView = $1a849cef1fe06506$var$isModEventView;
module.exports.validateModEventView = $1a849cef1fe06506$var$validateModEventView;
module.exports.isModEventViewDetail = $1a849cef1fe06506$var$isModEventViewDetail;
module.exports.validateModEventViewDetail = $1a849cef1fe06506$var$validateModEventViewDetail;
module.exports.isSubjectStatusView = $1a849cef1fe06506$var$isSubjectStatusView;
module.exports.validateSubjectStatusView = $1a849cef1fe06506$var$validateSubjectStatusView;
module.exports.isAccountStats = $1a849cef1fe06506$var$isAccountStats;
module.exports.validateAccountStats = $1a849cef1fe06506$var$validateAccountStats;
module.exports.isRecordsStats = $1a849cef1fe06506$var$isRecordsStats;
module.exports.validateRecordsStats = $1a849cef1fe06506$var$validateRecordsStats;
module.exports.isModEventTakedown = $1a849cef1fe06506$var$isModEventTakedown;
module.exports.validateModEventTakedown = $1a849cef1fe06506$var$validateModEventTakedown;
module.exports.isModEventReverseTakedown = $1a849cef1fe06506$var$isModEventReverseTakedown;
module.exports.validateModEventReverseTakedown = $1a849cef1fe06506$var$validateModEventReverseTakedown;
module.exports.isModEventResolveAppeal = $1a849cef1fe06506$var$isModEventResolveAppeal;
module.exports.validateModEventResolveAppeal = $1a849cef1fe06506$var$validateModEventResolveAppeal;
module.exports.isModEventComment = $1a849cef1fe06506$var$isModEventComment;
module.exports.validateModEventComment = $1a849cef1fe06506$var$validateModEventComment;
module.exports.isModEventReport = $1a849cef1fe06506$var$isModEventReport;
module.exports.validateModEventReport = $1a849cef1fe06506$var$validateModEventReport;
module.exports.isModEventLabel = $1a849cef1fe06506$var$isModEventLabel;
module.exports.validateModEventLabel = $1a849cef1fe06506$var$validateModEventLabel;
module.exports.isModEventPriorityScore = $1a849cef1fe06506$var$isModEventPriorityScore;
module.exports.validateModEventPriorityScore = $1a849cef1fe06506$var$validateModEventPriorityScore;
module.exports.isModEventAcknowledge = $1a849cef1fe06506$var$isModEventAcknowledge;
module.exports.validateModEventAcknowledge = $1a849cef1fe06506$var$validateModEventAcknowledge;
module.exports.isModEventEscalate = $1a849cef1fe06506$var$isModEventEscalate;
module.exports.validateModEventEscalate = $1a849cef1fe06506$var$validateModEventEscalate;
module.exports.isModEventMute = $1a849cef1fe06506$var$isModEventMute;
module.exports.validateModEventMute = $1a849cef1fe06506$var$validateModEventMute;
module.exports.isModEventUnmute = $1a849cef1fe06506$var$isModEventUnmute;
module.exports.validateModEventUnmute = $1a849cef1fe06506$var$validateModEventUnmute;
module.exports.isModEventMuteReporter = $1a849cef1fe06506$var$isModEventMuteReporter;
module.exports.validateModEventMuteReporter = $1a849cef1fe06506$var$validateModEventMuteReporter;
module.exports.isModEventUnmuteReporter = $1a849cef1fe06506$var$isModEventUnmuteReporter;
module.exports.validateModEventUnmuteReporter = $1a849cef1fe06506$var$validateModEventUnmuteReporter;
module.exports.isModEventEmail = $1a849cef1fe06506$var$isModEventEmail;
module.exports.validateModEventEmail = $1a849cef1fe06506$var$validateModEventEmail;
module.exports.isModEventDivert = $1a849cef1fe06506$var$isModEventDivert;
module.exports.validateModEventDivert = $1a849cef1fe06506$var$validateModEventDivert;
module.exports.isModEventTag = $1a849cef1fe06506$var$isModEventTag;
module.exports.validateModEventTag = $1a849cef1fe06506$var$validateModEventTag;
module.exports.isAccountEvent = $1a849cef1fe06506$var$isAccountEvent;
module.exports.validateAccountEvent = $1a849cef1fe06506$var$validateAccountEvent;
module.exports.isIdentityEvent = $1a849cef1fe06506$var$isIdentityEvent;
module.exports.validateIdentityEvent = $1a849cef1fe06506$var$validateIdentityEvent;
module.exports.isRecordEvent = $1a849cef1fe06506$var$isRecordEvent;
module.exports.validateRecordEvent = $1a849cef1fe06506$var$validateRecordEvent;
module.exports.isRepoView = $1a849cef1fe06506$var$isRepoView;
module.exports.validateRepoView = $1a849cef1fe06506$var$validateRepoView;
module.exports.isRepoViewDetail = $1a849cef1fe06506$var$isRepoViewDetail;
module.exports.validateRepoViewDetail = $1a849cef1fe06506$var$validateRepoViewDetail;
module.exports.isRepoViewNotFound = $1a849cef1fe06506$var$isRepoViewNotFound;
module.exports.validateRepoViewNotFound = $1a849cef1fe06506$var$validateRepoViewNotFound;
module.exports.isRecordView = $1a849cef1fe06506$var$isRecordView;
module.exports.validateRecordView = $1a849cef1fe06506$var$validateRecordView;
module.exports.isRecordViewDetail = $1a849cef1fe06506$var$isRecordViewDetail;
module.exports.validateRecordViewDetail = $1a849cef1fe06506$var$validateRecordViewDetail;
module.exports.isRecordViewNotFound = $1a849cef1fe06506$var$isRecordViewNotFound;
module.exports.validateRecordViewNotFound = $1a849cef1fe06506$var$validateRecordViewNotFound;
module.exports.isModeration = $1a849cef1fe06506$var$isModeration;
module.exports.validateModeration = $1a849cef1fe06506$var$validateModeration;
module.exports.isModerationDetail = $1a849cef1fe06506$var$isModerationDetail;
module.exports.validateModerationDetail = $1a849cef1fe06506$var$validateModerationDetail;
module.exports.isBlobView = $1a849cef1fe06506$var$isBlobView;
module.exports.validateBlobView = $1a849cef1fe06506$var$validateBlobView;
module.exports.isImageDetails = $1a849cef1fe06506$var$isImageDetails;
module.exports.validateImageDetails = $1a849cef1fe06506$var$validateImageDetails;
module.exports.isVideoDetails = $1a849cef1fe06506$var$isVideoDetails;
module.exports.validateVideoDetails = $1a849cef1fe06506$var$validateVideoDetails;
module.exports.isAccountHosting = $1a849cef1fe06506$var$isAccountHosting;
module.exports.validateAccountHosting = $1a849cef1fe06506$var$validateAccountHosting;
module.exports.isRecordHosting = $1a849cef1fe06506$var$isRecordHosting;
module.exports.validateRecordHosting = $1a849cef1fe06506$var$validateRecordHosting;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $1a849cef1fe06506$var$isModEventView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventView';
}
function $1a849cef1fe06506$var$validateModEventView(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventView', v);
}
function $1a849cef1fe06506$var$isModEventViewDetail(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventViewDetail';
}
function $1a849cef1fe06506$var$validateModEventViewDetail(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventViewDetail', v);
}
function $1a849cef1fe06506$var$isSubjectStatusView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#subjectStatusView';
}
function $1a849cef1fe06506$var$validateSubjectStatusView(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#subjectStatusView', v);
}
function $1a849cef1fe06506$var$isAccountStats(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#accountStats';
}
function $1a849cef1fe06506$var$validateAccountStats(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#accountStats', v);
}
function $1a849cef1fe06506$var$isRecordsStats(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#recordsStats';
}
function $1a849cef1fe06506$var$validateRecordsStats(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#recordsStats', v);
}
/** Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator */ module.exports.REVIEWOPEN = 'tools.ozone.moderation.defs#reviewOpen';
/** Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator */ module.exports.REVIEWESCALATED = 'tools.ozone.moderation.defs#reviewEscalated';
/** Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator */ module.exports.REVIEWCLOSED = 'tools.ozone.moderation.defs#reviewClosed';
/** Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it */ module.exports.REVIEWNONE = 'tools.ozone.moderation.defs#reviewNone';
function $1a849cef1fe06506$var$isModEventTakedown(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventTakedown';
}
function $1a849cef1fe06506$var$validateModEventTakedown(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventTakedown', v);
}
function $1a849cef1fe06506$var$isModEventReverseTakedown(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventReverseTakedown';
}
function $1a849cef1fe06506$var$validateModEventReverseTakedown(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventReverseTakedown', v);
}
function $1a849cef1fe06506$var$isModEventResolveAppeal(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventResolveAppeal';
}
function $1a849cef1fe06506$var$validateModEventResolveAppeal(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventResolveAppeal', v);
}
function $1a849cef1fe06506$var$isModEventComment(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventComment';
}
function $1a849cef1fe06506$var$validateModEventComment(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventComment', v);
}
function $1a849cef1fe06506$var$isModEventReport(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventReport';
}
function $1a849cef1fe06506$var$validateModEventReport(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventReport', v);
}
function $1a849cef1fe06506$var$isModEventLabel(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventLabel';
}
function $1a849cef1fe06506$var$validateModEventLabel(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventLabel', v);
}
function $1a849cef1fe06506$var$isModEventPriorityScore(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventPriorityScore';
}
function $1a849cef1fe06506$var$validateModEventPriorityScore(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventPriorityScore', v);
}
function $1a849cef1fe06506$var$isModEventAcknowledge(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventAcknowledge';
}
function $1a849cef1fe06506$var$validateModEventAcknowledge(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventAcknowledge', v);
}
function $1a849cef1fe06506$var$isModEventEscalate(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventEscalate';
}
function $1a849cef1fe06506$var$validateModEventEscalate(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventEscalate', v);
}
function $1a849cef1fe06506$var$isModEventMute(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventMute';
}
function $1a849cef1fe06506$var$validateModEventMute(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventMute', v);
}
function $1a849cef1fe06506$var$isModEventUnmute(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventUnmute';
}
function $1a849cef1fe06506$var$validateModEventUnmute(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventUnmute', v);
}
function $1a849cef1fe06506$var$isModEventMuteReporter(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventMuteReporter';
}
function $1a849cef1fe06506$var$validateModEventMuteReporter(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventMuteReporter', v);
}
function $1a849cef1fe06506$var$isModEventUnmuteReporter(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventUnmuteReporter';
}
function $1a849cef1fe06506$var$validateModEventUnmuteReporter(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventUnmuteReporter', v);
}
function $1a849cef1fe06506$var$isModEventEmail(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventEmail';
}
function $1a849cef1fe06506$var$validateModEventEmail(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventEmail', v);
}
function $1a849cef1fe06506$var$isModEventDivert(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventDivert';
}
function $1a849cef1fe06506$var$validateModEventDivert(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventDivert', v);
}
function $1a849cef1fe06506$var$isModEventTag(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#modEventTag';
}
function $1a849cef1fe06506$var$validateModEventTag(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#modEventTag', v);
}
function $1a849cef1fe06506$var$isAccountEvent(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#accountEvent';
}
function $1a849cef1fe06506$var$validateAccountEvent(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#accountEvent', v);
}
function $1a849cef1fe06506$var$isIdentityEvent(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#identityEvent';
}
function $1a849cef1fe06506$var$validateIdentityEvent(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#identityEvent', v);
}
function $1a849cef1fe06506$var$isRecordEvent(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#recordEvent';
}
function $1a849cef1fe06506$var$validateRecordEvent(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#recordEvent', v);
}
function $1a849cef1fe06506$var$isRepoView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#repoView';
}
function $1a849cef1fe06506$var$validateRepoView(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#repoView', v);
}
function $1a849cef1fe06506$var$isRepoViewDetail(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#repoViewDetail';
}
function $1a849cef1fe06506$var$validateRepoViewDetail(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#repoViewDetail', v);
}
function $1a849cef1fe06506$var$isRepoViewNotFound(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#repoViewNotFound';
}
function $1a849cef1fe06506$var$validateRepoViewNotFound(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#repoViewNotFound', v);
}
function $1a849cef1fe06506$var$isRecordView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#recordView';
}
function $1a849cef1fe06506$var$validateRecordView(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#recordView', v);
}
function $1a849cef1fe06506$var$isRecordViewDetail(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#recordViewDetail';
}
function $1a849cef1fe06506$var$validateRecordViewDetail(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#recordViewDetail', v);
}
function $1a849cef1fe06506$var$isRecordViewNotFound(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#recordViewNotFound';
}
function $1a849cef1fe06506$var$validateRecordViewNotFound(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#recordViewNotFound', v);
}
function $1a849cef1fe06506$var$isModeration(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#moderation';
}
function $1a849cef1fe06506$var$validateModeration(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#moderation', v);
}
function $1a849cef1fe06506$var$isModerationDetail(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#moderationDetail';
}
function $1a849cef1fe06506$var$validateModerationDetail(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#moderationDetail', v);
}
function $1a849cef1fe06506$var$isBlobView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#blobView';
}
function $1a849cef1fe06506$var$validateBlobView(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#blobView', v);
}
function $1a849cef1fe06506$var$isImageDetails(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#imageDetails';
}
function $1a849cef1fe06506$var$validateImageDetails(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#imageDetails', v);
}
function $1a849cef1fe06506$var$isVideoDetails(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#videoDetails';
}
function $1a849cef1fe06506$var$validateVideoDetails(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#videoDetails', v);
}
function $1a849cef1fe06506$var$isAccountHosting(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#accountHosting';
}
function $1a849cef1fe06506$var$validateAccountHosting(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#accountHosting', v);
}
function $1a849cef1fe06506$var$isRecordHosting(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.moderation.defs#recordHosting';
}
function $1a849cef1fe06506$var$validateRecordHosting(v) {
    return $8DB7o.lexicons.validate('tools.ozone.moderation.defs#recordHosting', v);
}

});

parcelRegister("7wDkl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $57aa071b348d85ca$var$toKnownErr;
function $57aa071b348d85ca$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("8GtpL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $65291017c9929979$var$toKnownErr;
function $65291017c9929979$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("ODUzg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $0983a13232f43356$var$toKnownErr;
function $0983a13232f43356$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("dCYQy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $9ebe05d3026ddf58$var$toKnownErr;
function $9ebe05d3026ddf58$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("5xWBm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $409d7ddc786647df$var$toKnownErr;
function $409d7ddc786647df$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("68WWJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $479136ef2723209b$var$toKnownErr;
function $479136ef2723209b$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("bKN2D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $88ea0832e48688ec$var$toKnownErr;
module.exports.isServiceConfig = $88ea0832e48688ec$var$isServiceConfig;
module.exports.validateServiceConfig = $88ea0832e48688ec$var$validateServiceConfig;
module.exports.isViewerConfig = $88ea0832e48688ec$var$isViewerConfig;
module.exports.validateViewerConfig = $88ea0832e48688ec$var$validateViewerConfig;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $88ea0832e48688ec$var$toKnownErr(e) {
    return e;
}
function $88ea0832e48688ec$var$isServiceConfig(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.server.getConfig#serviceConfig';
}
function $88ea0832e48688ec$var$validateServiceConfig(v) {
    return $8DB7o.lexicons.validate('tools.ozone.server.getConfig#serviceConfig', v);
}
function $88ea0832e48688ec$var$isViewerConfig(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.server.getConfig#viewerConfig';
}
function $88ea0832e48688ec$var$validateViewerConfig(v) {
    return $8DB7o.lexicons.validate('tools.ozone.server.getConfig#viewerConfig', v);
}

});

parcelRegister("eSuDp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $ad4ddf39b3318630$var$toKnownErr;
function $ad4ddf39b3318630$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("VTs5u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSet = $0ae0569a5ef92551$var$isSet;
module.exports.validateSet = $0ae0569a5ef92551$var$validateSet;
module.exports.isSetView = $0ae0569a5ef92551$var$isSetView;
module.exports.validateSetView = $0ae0569a5ef92551$var$validateSetView;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $0ae0569a5ef92551$var$isSet(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.set.defs#set';
}
function $0ae0569a5ef92551$var$validateSet(v) {
    return $8DB7o.lexicons.validate('tools.ozone.set.defs#set', v);
}
function $0ae0569a5ef92551$var$isSetView(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.set.defs#setView';
}
function $0ae0569a5ef92551$var$validateSetView(v) {
    return $8DB7o.lexicons.validate('tools.ozone.set.defs#setView', v);
}

});

parcelRegister("gtYSF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $bffe9472093662f6$var$toKnownErr;
function $bffe9472093662f6$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("k0lX7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $e904d610bb40b8c2$var$toKnownErr;
function $e904d610bb40b8c2$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("3KwiU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isOption = $2baeb9e25559778a$var$isOption;
module.exports.validateOption = $2baeb9e25559778a$var$validateOption;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $2baeb9e25559778a$var$isOption(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.setting.defs#option';
}
function $2baeb9e25559778a$var$validateOption(v) {
    return $8DB7o.lexicons.validate('tools.ozone.setting.defs#option', v);
}

});

parcelRegister("ijAql", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $d556415ec284919e$var$toKnownErr;
function $d556415ec284919e$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("1cOPh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $0e0e567087215636$var$toKnownErr;
function $0e0e567087215636$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("2dvK0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $19d56ac9ed423b89$var$toKnownErr;
function $19d56ac9ed423b89$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("aJiE8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSigDetail = $7cfc92256998e66d$var$isSigDetail;
module.exports.validateSigDetail = $7cfc92256998e66d$var$validateSigDetail;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $7cfc92256998e66d$var$isSigDetail(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.signature.defs#sigDetail';
}
function $7cfc92256998e66d$var$validateSigDetail(v) {
    return $8DB7o.lexicons.validate('tools.ozone.signature.defs#sigDetail', v);
}

});

parcelRegister("lq560", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $f97ffa9e915582d6$var$toKnownErr;
function $f97ffa9e915582d6$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("fELNV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $b65fac5def5925d9$var$toKnownErr;
module.exports.isRelatedAccount = $b65fac5def5925d9$var$isRelatedAccount;
module.exports.validateRelatedAccount = $b65fac5def5925d9$var$validateRelatedAccount;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $b65fac5def5925d9$var$toKnownErr(e) {
    return e;
}
function $b65fac5def5925d9$var$isRelatedAccount(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.signature.findRelatedAccounts#relatedAccount';
}
function $b65fac5def5925d9$var$validateRelatedAccount(v) {
    return $8DB7o.lexicons.validate('tools.ozone.signature.findRelatedAccounts#relatedAccount', v);
}

});

parcelRegister("hn4vV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $ca581608cc950b5d$var$toKnownErr;
function $ca581608cc950b5d$var$toKnownErr(e) {
    return e;
}

});

parcelRegister("deow2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ROLETRIAGE = module.exports.ROLEMODERATOR = module.exports.ROLEADMIN = void 0;
module.exports.isMember = $9a1f997789751650$var$isMember;
module.exports.validateMember = $9a1f997789751650$var$validateMember;

var $9KXK3 = parcelRequire("9KXK3");

var $8DB7o = parcelRequire("8DB7o");
function $9a1f997789751650$var$isMember(v) {
    return (0, $9KXK3.isObj)(v) && (0, $9KXK3.hasProp)(v, '$type') && v.$type === 'tools.ozone.team.defs#member';
}
function $9a1f997789751650$var$validateMember(v) {
    return $8DB7o.lexicons.validate('tools.ozone.team.defs#member', v);
}
/** Admin role. Highest level of access, can perform all actions. */ module.exports.ROLEADMIN = 'tools.ozone.team.defs#roleAdmin';
/** Moderator role. Can perform most actions. */ module.exports.ROLEMODERATOR = 'tools.ozone.team.defs#roleModerator';
/** Triage role. Mostly intended for monitoring and escalating issues. */ module.exports.ROLETRIAGE = 'tools.ozone.team.defs#roleTriage';

});

parcelRegister("2N6AW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toKnownErr = $208545fa994d2b16$var$toKnownErr;
function $208545fa994d2b16$var$toKnownErr(e) {
    return e;
}

});


parcelRegister("hPzsQ", function(module, exports) {
"use strict";
/*
= Rich Text Manipulation

When we sanitize rich text, we have to update the entity indices as the
text is modified. This can be modeled as inserts() and deletes() of the
rich text string. The possible scenarios are outlined below, along with
their expected behaviors.

NOTE: Slices are start inclusive, end exclusive

== richTextInsert()

Target string:

   0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l o   w o r l d   // string value
       ^-------^           // target slice {start: 2, end: 7}

Scenarios:

A: ^                       // insert "test" at 0
B:        ^                // insert "test" at 4
C:                 ^       // insert "test" at 8

A = before           -> move both by num added
B = inner            -> move end by num added
C = after            -> noop

Results:

A: 0 1 2 3 4 5 6 7 8 910   // string indices
   t e s t h e l l o   w   // string value
               ^-------^   // target slice {start: 6, end: 11}

B: 0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l t e s t o   w   // string value
       ^---------------^   // target slice {start: 2, end: 11}

C: 0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l o   w o t e s   // string value
       ^-------^           // target slice {start: 2, end: 7}

== richTextDelete()

Target string:

   0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l o   w o r l d   // string value
       ^-------^           // target slice {start: 2, end: 7}

Scenarios:

A: ^---------------^       // remove slice {start: 0, end: 9}
B:               ^-----^   // remove slice {start: 7, end: 11}
C:         ^-----------^   // remove slice {start: 4, end: 11}
D:       ^-^               // remove slice {start: 3, end: 5}
E:   ^-----^               // remove slice {start: 1, end: 5}
F: ^-^                     // remove slice {start: 0, end: 2}

A = entirely outer   -> delete slice
B = entirely after   -> noop
C = partially after  -> move end to remove-start
D = entirely inner   -> move end by num removed
E = partially before -> move start to remove-start index, move end by num removed
F = entirely before  -> move both by num removed

Results:

A: 0 1 2 3 4 5 6 7 8 910   // string indices
   l d                     // string value
                           // target slice (deleted)

B: 0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l o   w           // string value
       ^-------^           // target slice {start: 2, end: 7}

C: 0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l                 // string value
       ^-^                 // target slice {start: 2, end: 4}

D: 0 1 2 3 4 5 6 7 8 910   // string indices
   h e l   w o r l d       // string value
       ^---^               // target slice {start: 2, end: 5}

E: 0 1 2 3 4 5 6 7 8 910   // string indices
   h   w o r l d           // string value
     ^-^                   // target slice {start: 1, end: 3}

F: 0 1 2 3 4 5 6 7 8 910   // string indices
   l l o   w o r l d       // string value
   ^-------^               // target slice {start: 0, end: 5}
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RichText = module.exports.RichTextSegment = void 0;

var $2wqOO = parcelRequire("2wqOO");

var $6QmC0 = parcelRequire("6QmC0");

var $gRg7n = parcelRequire("gRg7n");

var $f8MrZ = parcelRequire("f8MrZ");
class $cfb2b588d750b571$var$RichTextSegment {
    constructor(text, facet){
        Object.defineProperty(this, "text", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: text
        });
        Object.defineProperty(this, "facet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: facet
        });
    }
    get link() {
        const link = this.facet?.features.find($2wqOO.AppBskyRichtextFacet.isLink);
        if ($2wqOO.AppBskyRichtextFacet.isLink(link)) return link;
        return undefined;
    }
    isLink() {
        return !!this.link;
    }
    get mention() {
        const mention = this.facet?.features.find($2wqOO.AppBskyRichtextFacet.isMention);
        if ($2wqOO.AppBskyRichtextFacet.isMention(mention)) return mention;
        return undefined;
    }
    isMention() {
        return !!this.mention;
    }
    get tag() {
        const tag = this.facet?.features.find($2wqOO.AppBskyRichtextFacet.isTag);
        if ($2wqOO.AppBskyRichtextFacet.isTag(tag)) return tag;
        return undefined;
    }
    isTag() {
        return !!this.tag;
    }
}
module.exports.RichTextSegment = $cfb2b588d750b571$var$RichTextSegment;
class $cfb2b588d750b571$var$RichText {
    constructor(props, opts){
        Object.defineProperty(this, "unicodeText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "facets", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.unicodeText = new $f8MrZ.UnicodeString(props.text);
        this.facets = props.facets;
        if (!this.facets?.length && props.entities?.length) this.facets = $cfb2b588d750b571$var$entitiesToFacets(this.unicodeText, props.entities);
        if (this.facets) this.facets = this.facets.filter($cfb2b588d750b571$var$facetFilter).sort($cfb2b588d750b571$var$facetSort);
        if (opts?.cleanNewlines) (0, $gRg7n.sanitizeRichText)(this, {
            cleanNewlines: true
        }).copyInto(this);
    }
    get text() {
        return this.unicodeText.toString();
    }
    get length() {
        return this.unicodeText.length;
    }
    get graphemeLength() {
        return this.unicodeText.graphemeLength;
    }
    clone() {
        return new $cfb2b588d750b571$var$RichText({
            text: this.unicodeText.utf16,
            facets: $cfb2b588d750b571$var$cloneDeep(this.facets)
        });
    }
    copyInto(target) {
        target.unicodeText = this.unicodeText;
        target.facets = $cfb2b588d750b571$var$cloneDeep(this.facets);
    }
    *segments() {
        const facets = this.facets || [];
        if (!facets.length) {
            yield new $cfb2b588d750b571$var$RichTextSegment(this.unicodeText.utf16);
            return;
        }
        let textCursor = 0;
        let facetCursor = 0;
        do {
            const currFacet = facets[facetCursor];
            if (textCursor < currFacet.index.byteStart) yield new $cfb2b588d750b571$var$RichTextSegment(this.unicodeText.slice(textCursor, currFacet.index.byteStart));
            else if (textCursor > currFacet.index.byteStart) {
                facetCursor++;
                continue;
            }
            if (currFacet.index.byteStart < currFacet.index.byteEnd) {
                const subtext = this.unicodeText.slice(currFacet.index.byteStart, currFacet.index.byteEnd);
                if (!subtext.trim()) // dont empty string entities
                yield new $cfb2b588d750b571$var$RichTextSegment(subtext);
                else yield new $cfb2b588d750b571$var$RichTextSegment(subtext, currFacet);
            }
            textCursor = currFacet.index.byteEnd;
            facetCursor++;
        }while (facetCursor < facets.length);
        if (textCursor < this.unicodeText.length) yield new $cfb2b588d750b571$var$RichTextSegment(this.unicodeText.slice(textCursor, this.unicodeText.length));
    }
    insert(insertIndex, insertText) {
        this.unicodeText = new $f8MrZ.UnicodeString(this.unicodeText.slice(0, insertIndex) + insertText + this.unicodeText.slice(insertIndex));
        if (!this.facets?.length) return this;
        const numCharsAdded = insertText.length;
        for (const ent of this.facets){
            // see comment at top of file for labels of each scenario
            // scenario A (before)
            if (insertIndex <= ent.index.byteStart) {
                // move both by num added
                ent.index.byteStart += numCharsAdded;
                ent.index.byteEnd += numCharsAdded;
            } else if (insertIndex >= ent.index.byteStart && insertIndex < ent.index.byteEnd) // move end by num added
            ent.index.byteEnd += numCharsAdded;
        // scenario C (after)
        // noop
        }
        return this;
    }
    delete(removeStartIndex, removeEndIndex) {
        this.unicodeText = new $f8MrZ.UnicodeString(this.unicodeText.slice(0, removeStartIndex) + this.unicodeText.slice(removeEndIndex));
        if (!this.facets?.length) return this;
        const numCharsRemoved = removeEndIndex - removeStartIndex;
        for (const ent of this.facets){
            // see comment at top of file for labels of each scenario
            // scenario A (entirely outer)
            if (removeStartIndex <= ent.index.byteStart && removeEndIndex >= ent.index.byteEnd) {
                // delete slice (will get removed in final pass)
                ent.index.byteStart = 0;
                ent.index.byteEnd = 0;
            } else if (removeStartIndex > ent.index.byteEnd) ;
            else if (removeStartIndex > ent.index.byteStart && removeStartIndex <= ent.index.byteEnd && removeEndIndex > ent.index.byteEnd) // move end to remove start
            ent.index.byteEnd = removeStartIndex;
            else if (removeStartIndex >= ent.index.byteStart && removeEndIndex <= ent.index.byteEnd) // move end by num removed
            ent.index.byteEnd -= numCharsRemoved;
            else if (removeStartIndex < ent.index.byteStart && removeEndIndex >= ent.index.byteStart && removeEndIndex <= ent.index.byteEnd) {
                // move start to remove-start index, move end by num removed
                ent.index.byteStart = removeStartIndex;
                ent.index.byteEnd -= numCharsRemoved;
            } else if (removeEndIndex < ent.index.byteStart) {
                // move both by num removed
                ent.index.byteStart -= numCharsRemoved;
                ent.index.byteEnd -= numCharsRemoved;
            }
        }
        // filter out any facets that were made irrelevant
        this.facets = this.facets.filter((ent)=>ent.index.byteStart < ent.index.byteEnd);
        return this;
    }
    /**
     * Detects facets such as links and mentions
     * Note: Overwrites the existing facets with auto-detected facets
     */ async detectFacets(agent) {
        this.facets = (0, $6QmC0.detectFacets)(this.unicodeText);
        if (this.facets) {
            const promises = [];
            for (const facet of this.facets){
                for (const feature of facet.features)if ($2wqOO.AppBskyRichtextFacet.isMention(feature)) promises.push(agent.com.atproto.identity.resolveHandle({
                    handle: feature.did
                }).then((res)=>res?.data.did).catch((_)=>undefined).then((did)=>{
                    feature.did = did || '';
                }));
            }
            await Promise.allSettled(promises);
            this.facets.sort($cfb2b588d750b571$var$facetSort);
        }
    }
    /**
     * Detects facets such as links and mentions but does not resolve them
     * Will produce invalid facets! For instance, mentions will not have their DIDs set.
     * Note: Overwrites the existing facets with auto-detected facets
     */ detectFacetsWithoutResolution() {
        this.facets = (0, $6QmC0.detectFacets)(this.unicodeText);
        if (this.facets) this.facets.sort($cfb2b588d750b571$var$facetSort);
    }
}
module.exports.RichText = $cfb2b588d750b571$var$RichText;
const $cfb2b588d750b571$var$facetSort = (a, b)=>a.index.byteStart - b.index.byteStart;
const $cfb2b588d750b571$var$facetFilter = (facet)=>// discard negative-length facets. zero-length facets are valid
    facet.index.byteStart <= facet.index.byteEnd;
function $cfb2b588d750b571$var$entitiesToFacets(text, entities) {
    const facets = [];
    for (const ent of entities){
        if (ent.type === 'link') facets.push({
            $type: 'app.bsky.richtext.facet',
            index: {
                byteStart: text.utf16IndexToUtf8Index(ent.index.start),
                byteEnd: text.utf16IndexToUtf8Index(ent.index.end)
            },
            features: [
                {
                    $type: 'app.bsky.richtext.facet#link',
                    uri: ent.value
                }
            ]
        });
        else if (ent.type === 'mention') facets.push({
            $type: 'app.bsky.richtext.facet',
            index: {
                byteStart: text.utf16IndexToUtf8Index(ent.index.start),
                byteEnd: text.utf16IndexToUtf8Index(ent.index.end)
            },
            features: [
                {
                    $type: 'app.bsky.richtext.facet#mention',
                    did: ent.value
                }
            ]
        });
    }
    return facets;
}
function $cfb2b588d750b571$var$cloneDeep(v) {
    if (typeof v === 'undefined') return v;
    return JSON.parse(JSON.stringify(v));
}

});
parcelRegister("6QmC0", function(module, exports) {
"use strict";
var $4fb923b1c296e30d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.detectFacets = $4fb923b1c296e30d$var$detectFacets;

const $4fb923b1c296e30d$var$tlds_1 = $4fb923b1c296e30d$var$__importDefault((parcelRequire("2c9BA")));

var $lbDJ5 = parcelRequire("lbDJ5");
function $4fb923b1c296e30d$var$detectFacets(text) {
    let match;
    const facets = [];
    {
        // mentions
        const re = $lbDJ5.MENTION_REGEX;
        while(match = re.exec(text.utf16)){
            if (!$4fb923b1c296e30d$var$isValidDomain(match[3]) && !match[3].endsWith('.test')) continue; // probably not a handle
            const start = text.utf16.indexOf(match[3], match.index) - 1;
            facets.push({
                $type: 'app.bsky.richtext.facet',
                index: {
                    byteStart: text.utf16IndexToUtf8Index(start),
                    byteEnd: text.utf16IndexToUtf8Index(start + match[3].length + 1)
                },
                features: [
                    {
                        $type: 'app.bsky.richtext.facet#mention',
                        did: match[3]
                    }
                ]
            });
        }
    }
    {
        // links
        const re = $lbDJ5.URL_REGEX;
        while(match = re.exec(text.utf16)){
            let uri = match[2];
            if (!uri.startsWith('http')) {
                const domain = match.groups?.domain;
                if (!domain || !$4fb923b1c296e30d$var$isValidDomain(domain)) continue;
                uri = `https://${uri}`;
            }
            const start = text.utf16.indexOf(match[2], match.index);
            const index = {
                start: start,
                end: start + match[2].length
            };
            // strip ending puncuation
            if (/[.,;:!?]$/.test(uri)) {
                uri = uri.slice(0, -1);
                index.end--;
            }
            if (/[)]$/.test(uri) && !uri.includes('(')) {
                uri = uri.slice(0, -1);
                index.end--;
            }
            facets.push({
                index: {
                    byteStart: text.utf16IndexToUtf8Index(index.start),
                    byteEnd: text.utf16IndexToUtf8Index(index.end)
                },
                features: [
                    {
                        $type: 'app.bsky.richtext.facet#link',
                        uri: uri
                    }
                ]
            });
        }
    }
    {
        const re = $lbDJ5.TAG_REGEX;
        while(match = re.exec(text.utf16)){
            const leading = match[1];
            let tag = match[2];
            if (!tag) continue;
            // strip ending punctuation and any spaces
            tag = tag.trim().replace($lbDJ5.TRAILING_PUNCTUATION_REGEX, '');
            if (tag.length === 0 || tag.length > 64) continue;
            const index = match.index + leading.length;
            facets.push({
                index: {
                    byteStart: text.utf16IndexToUtf8Index(index),
                    byteEnd: text.utf16IndexToUtf8Index(index + 1 + tag.length)
                },
                features: [
                    {
                        $type: 'app.bsky.richtext.facet#tag',
                        tag: tag
                    }
                ]
            });
        }
    }
    return facets.length > 0 ? facets : undefined;
}
function $4fb923b1c296e30d$var$isValidDomain(str) {
    return !!$4fb923b1c296e30d$var$tlds_1.default.find((tld)=>{
        const i = str.lastIndexOf(tld);
        if (i === -1) return false;
        return str.charAt(i - 1) === '.' && i === str.length - tld.length;
    });
}

});
parcelRegister("2c9BA", function(module, exports) {
module.exports = JSON.parse('["aaa","aarp","abb","abbott","abbvie","abc","able","abogado","abudhabi","ac","academy","accenture","accountant","accountants","aco","actor","ad","ads","adult","ae","aeg","aero","aetna","af","afl","africa","ag","agakhan","agency","ai","aig","airbus","airforce","airtel","akdn","al","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","am","amazon","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","ao","aol","apartments","app","apple","aq","aquarelle","ar","arab","aramco","archi","army","arpa","art","arte","as","asda","asia","associates","at","athleta","attorney","au","auction","audi","audible","audio","auspost","author","auto","autos","aw","aws","ax","axa","az","azure","ba","baby","baidu","banamex","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bb","bbc","bbt","bbva","bcg","bcn","bd","be","beats","beauty","beer","bentley","berlin","best","bestbuy","bet","bf","bg","bh","bharti","bi","bible","bid","bike","bing","bingo","bio","biz","bj","black","blackfriday","blockbuster","blog","bloomberg","blue","bm","bms","bmw","bn","bnpparibas","bo","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","br","bradesco","bridgestone","broadway","broker","brother","brussels","bs","bt","build","builders","business","buy","buzz","bv","bw","by","bz","bzh","ca","cab","cafe","cal","call","calvinklein","cam","camera","camp","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","casa","case","cash","casino","cat","catering","catholic","cba","cbn","cbre","cc","cd","center","ceo","cern","cf","cfa","cfd","cg","ch","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","church","ci","cipriani","circle","cisco","citadel","citi","citic","city","ck","cl","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","cm","cn","co","coach","codes","coffee","college","cologne","com","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cool","coop","corsica","country","coupon","coupons","courses","cpa","cr","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","cu","cuisinella","cv","cw","cx","cy","cymru","cyou","cz","dad","dance","data","date","dating","datsun","day","dclk","dds","de","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dj","dk","dm","dnp","do","docs","doctor","dog","domains","dot","download","drive","dtv","dubai","dunlop","dupont","durban","dvag","dvr","dz","earth","eat","ec","eco","edeka","edu","education","ee","eg","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","er","ericsson","erni","es","esq","estate","et","eu","eurovision","eus","events","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fi","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","fj","fk","flickr","flights","flir","florist","flowers","fly","fm","fo","foo","food","football","ford","forex","forsale","forum","foundation","fox","fr","free","fresenius","frl","frogans","frontier","ftr","fujitsu","fun","fund","furniture","futbol","fyi","ga","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gb","gbiz","gd","gdn","ge","gea","gent","genting","george","gf","gg","ggee","gh","gi","gift","gifts","gives","giving","gl","glass","gle","global","globo","gm","gmail","gmbh","gmo","gmx","gn","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","gov","gp","gq","gr","grainger","graphics","gratis","green","gripe","grocery","group","gs","gt","gu","gucci","guge","guide","guitars","guru","gw","gy","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hiphop","hisamitsu","hitachi","hiv","hk","hkt","hm","hn","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hotels","hotmail","house","how","hr","hsbc","ht","hu","hughes","hyatt","hyundai","ibm","icbc","ice","icu","id","ie","ieee","ifm","ikano","il","im","imamat","imdb","immo","immobilien","in","inc","industries","infiniti","info","ing","ink","institute","insurance","insure","int","international","intuit","investments","io","ipiranga","iq","ir","irish","is","ismaili","ist","istanbul","it","itau","itv","jaguar","java","jcb","je","jeep","jetzt","jewelry","jio","jll","jm","jmp","jnj","jo","jobs","joburg","jot","joy","jp","jpmorgan","jprs","juegos","juniper","kaufen","kddi","ke","kerryhotels","kerryproperties","kfh","kg","kh","ki","kia","kids","kim","kindle","kitchen","kiwi","km","kn","koeln","komatsu","kosher","kp","kpmg","kpn","kr","krd","kred","kuokgroup","kw","ky","kyoto","kz","la","lacaixa","lamborghini","lamer","lancaster","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lb","lc","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","li","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","link","live","living","lk","llc","llp","loan","loans","locker","locus","lol","london","lotte","lotto","love","lpl","lplfinancial","lr","ls","lt","ltd","ltda","lu","lundbeck","luxe","luxury","lv","ly","ma","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","mattel","mba","mc","mckinsey","md","me","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","mg","mh","miami","microsoft","mil","mini","mint","mit","mitsubishi","mk","ml","mlb","mls","mm","mma","mn","mo","mobi","mobile","moda","moe","moi","mom","monash","money","monster","mormon","mortgage","moscow","moto","motorcycles","mov","movie","mp","mq","mr","ms","msd","mt","mtn","mtr","mu","museum","music","mv","mw","mx","my","mz","na","nab","nagoya","name","navy","nba","nc","ne","nec","net","netbank","netflix","network","neustar","new","news","next","nextdirect","nexus","nf","nfl","ng","ngo","nhk","ni","nico","nike","nikon","ninja","nissan","nissay","nl","no","nokia","norton","now","nowruz","nowtv","np","nr","nra","nrw","ntt","nu","nyc","nz","obi","observer","office","okinawa","olayan","olayangroup","ollo","om","omega","one","ong","onl","online","ooo","open","oracle","orange","org","organic","origins","osaka","otsuka","ott","ovh","pa","page","panasonic","paris","pars","partners","parts","party","pay","pccw","pe","pet","pf","pfizer","pg","ph","pharmacy","phd","philips","phone","photo","photography","photos","physio","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","pk","pl","place","play","playstation","plumbing","plus","pm","pn","pnc","pohl","poker","politie","porn","post","pr","pramerica","praxi","press","prime","pro","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","ps","pt","pub","pw","pwc","py","qa","qpon","quebec","quest","racing","radio","re","read","realestate","realtor","realty","recipes","red","redstone","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","ril","rio","rip","ro","rocks","rodeo","rogers","room","rs","rsvp","ru","rugby","ruhr","run","rw","rwe","ryukyu","sa","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sb","sbi","sbs","sc","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scot","sd","se","search","seat","secure","security","seek","select","sener","services","seven","sew","sex","sexy","sfr","sg","sh","shangrila","sharp","shell","shia","shiksha","shoes","shop","shopping","shouji","show","si","silk","sina","singles","site","sj","sk","ski","skin","sky","skype","sl","sling","sm","smart","smile","sn","sncf","so","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","spa","space","sport","spot","sr","srl","ss","st","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","su","sucks","supplies","supply","support","surf","surgery","suzuki","sv","swatch","swiss","sx","sy","sydney","systems","sz","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tc","tci","td","tdk","team","tech","technology","tel","temasek","tennis","teva","tf","tg","th","thd","theater","theatre","tiaa","tickets","tienda","tips","tires","tirol","tj","tjmaxx","tjx","tk","tkmaxx","tl","tm","tmall","tn","to","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","tr","trade","trading","training","travel","travelers","travelersinsurance","trust","trv","tt","tube","tui","tunes","tushu","tv","tvs","tw","tz","ua","ubank","ubs","ug","uk","unicom","university","uno","uol","ups","us","uy","uz","va","vacations","vana","vanguard","vc","ve","vegas","ventures","verisign","verm\xf6gensberater","verm\xf6gensberatung","versicherung","vet","vg","vi","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","viva","vivo","vlaanderen","vn","vodka","volvo","vote","voting","voto","voyage","vu","wales","walmart","walter","wang","wanggou","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","wf","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","ws","wtc","wtf","xbox","xerox","xihuan","xin","xxx","xyz","yachts","yahoo","yamaxun","yandex","ye","yodobashi","yoga","yokohama","you","youtube","yt","yun","za","zappos","zara","zero","zip","zm","zone","zuerich","zw","\u03B5\u03BB","\u03B5\u03C5","\u0431\u0433","\u0431\u0435\u043B","\u0434\u0435\u0442\u0438","\u0435\u044E","\u043A\u0430\u0442\u043E\u043B\u0438\u043A","\u043A\u043E\u043C","\u043C\u043A\u0434","\u043C\u043E\u043D","\u043C\u043E\u0441\u043A\u0432\u0430","\u043E\u043D\u043B\u0430\u0439\u043D","\u043E\u0440\u0433","\u0440\u0443\u0441","\u0440\u0444","\u0441\u0430\u0439\u0442","\u0441\u0440\u0431","\u0443\u043A\u0440","\u049B\u0430\u0437","\u0570\u0561\u0575","\u05D9\u05E9\u05E8\u05D0\u05DC","\u05E7\u05D5\u05DD","\u0627\u0628\u0648\u0638\u0628\u064A","\u0627\u0631\u0627\u0645\u0643\u0648","\u0627\u0644\u0627\u0631\u062F\u0646","\u0627\u0644\u0628\u062D\u0631\u064A\u0646","\u0627\u0644\u062C\u0632\u0627\u0626\u0631","\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629","\u0627\u0644\u0639\u0644\u064A\u0627\u0646","\u0627\u0644\u0645\u063A\u0631\u0628","\u0627\u0645\u0627\u0631\u0627\u062A","\u0627\u06CC\u0631\u0627\u0646","\u0628\u0627\u0631\u062A","\u0628\u0627\u0632\u0627\u0631","\u0628\u064A\u062A\u0643","\u0628\u06BE\u0627\u0631\u062A","\u062A\u0648\u0646\u0633","\u0633\u0648\u062F\u0627\u0646","\u0633\u0648\u0631\u064A\u0629","\u0634\u0628\u0643\u0629","\u0639\u0631\u0627\u0642","\u0639\u0631\u0628","\u0639\u0645\u0627\u0646","\u0641\u0644\u0633\u0637\u064A\u0646","\u0642\u0637\u0631","\u0643\u0627\u062B\u0648\u0644\u064A\u0643","\u0643\u0648\u0645","\u0645\u0635\u0631","\u0645\u0644\u064A\u0633\u064A\u0627","\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627","\u0645\u0648\u0642\u0639","\u0647\u0645\u0631\u0627\u0647","\u067E\u0627\u06A9\u0633\u062A\u0627\u0646","\u0680\u0627\u0631\u062A","\u0915\u0949\u092E","\u0928\u0947\u091F","\u092D\u093E\u0930\u0924","\u092D\u093E\u0930\u0924\u092E\u094D","\u092D\u093E\u0930\u094B\u0924","\u0938\u0902\u0917\u0920\u0928","\u09AC\u09BE\u0982\u09B2\u09BE","\u09AD\u09BE\u09B0\u09A4","\u09AD\u09BE\u09F0\u09A4","\u0A2D\u0A3E\u0A30\u0A24","\u0AAD\u0ABE\u0AB0\u0AA4","\u0B2D\u0B3E\u0B30\u0B24","\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE","\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8","\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD","\u0C2D\u0C3E\u0C30\u0C24\u0C4D","\u0CAD\u0CBE\u0CB0\u0CA4","\u0D2D\u0D3E\u0D30\u0D24\u0D02","\u0DBD\u0D82\u0D9A\u0DCF","\u0E04\u0E2D\u0E21","\u0E44\u0E17\u0E22","\u0EA5\u0EB2\u0EA7","\u10D2\u10D4","\u307F\u3093\u306A","\u30A2\u30DE\u30BE\u30F3","\u30AF\u30E9\u30A6\u30C9","\u30B0\u30FC\u30B0\u30EB","\u30B3\u30E0","\u30B9\u30C8\u30A2","\u30BB\u30FC\u30EB","\u30D5\u30A1\u30C3\u30B7\u30E7\u30F3","\u30DD\u30A4\u30F3\u30C8","\u4E16\u754C","\u4E2D\u4FE1","\u4E2D\u56FD","\u4E2D\u570B","\u4E2D\u6587\u7F51","\u4E9A\u9A6C\u900A","\u4F01\u4E1A","\u4F5B\u5C71","\u4FE1\u606F","\u5065\u5EB7","\u516B\u5366","\u516C\u53F8","\u516C\u76CA","\u53F0\u6E7E","\u53F0\u7063","\u5546\u57CE","\u5546\u5E97","\u5546\u6807","\u5609\u91CC","\u5609\u91CC\u5927\u9152\u5E97","\u5728\u7EBF","\u5927\u62FF","\u5929\u4E3B\u6559","\u5A31\u4E50","\u5BB6\u96FB","\u5E7F\u4E1C","\u5FAE\u535A","\u6148\u5584","\u6211\u7231\u4F60","\u624B\u673A","\u62DB\u8058","\u653F\u52A1","\u653F\u5E9C","\u65B0\u52A0\u5761","\u65B0\u95FB","\u65F6\u5C1A","\u66F8\u7C4D","\u673A\u6784","\u6DE1\u9A6C\u9521","\u6E38\u620F","\u6FB3\u9580","\u70B9\u770B","\u79FB\u52A8","\u7EC4\u7EC7\u673A\u6784","\u7F51\u5740","\u7F51\u5E97","\u7F51\u7AD9","\u7F51\u7EDC","\u8054\u901A","\u8C37\u6B4C","\u8D2D\u7269","\u901A\u8CA9","\u96C6\u56E2","\u96FB\u8A0A\u76C8\u79D1","\u98DE\u5229\u6D66","\u98DF\u54C1","\u9910\u5385","\u9999\u683C\u91CC\u62C9","\u9999\u6E2F","\uB2F7\uB137","\uB2F7\uCEF4","\uC0BC\uC131","\uD55C\uAD6D"]');

});

parcelRegister("lbDJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TAG_REGEX = module.exports.TRAILING_PUNCTUATION_REGEX = module.exports.URL_REGEX = module.exports.MENTION_REGEX = void 0;
module.exports.MENTION_REGEX = /(^|\s|\()(@)([a-zA-Z0-9.-]+)(\b)/g;
module.exports.URL_REGEX = /(^|\s|\()((https?:\/\/[\S]+)|((?<domain>[a-z][a-z0-9]*(\.[a-z0-9]+)+)[\S]*))/gim;
module.exports.TRAILING_PUNCTUATION_REGEX = /\p{P}+$/gu;
/**
 * `\ufe0f` emoji modifier
 * `\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2` zero-width spaces (likely incomplete)
 */ module.exports.TAG_REGEX = // eslint-disable-next-line no-misleading-character-class
/(^|\s)[#＃]((?!\ufe0f)[^\s\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2]*[^\d\s\p{P}\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2]+[^\s\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2]*)?/gu;

});


parcelRegister("gRg7n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sanitizeRichText = $c45e19450f71dc67$var$sanitizeRichText;

var $f8MrZ = parcelRequire("f8MrZ");
// this regex is intentionally matching on the zero-with-separator codepoint
// eslint-disable-next-line no-misleading-character-class
const $c45e19450f71dc67$var$EXCESS_SPACE_RE = /[\r\n]([\u00AD\u2060\u200D\u200C\u200B\s]*[\r\n]){2,}/;
const $c45e19450f71dc67$var$REPLACEMENT_STR = '\n\n';
function $c45e19450f71dc67$var$sanitizeRichText(richText, opts) {
    if (opts.cleanNewlines) richText = $c45e19450f71dc67$var$clean(richText, $c45e19450f71dc67$var$EXCESS_SPACE_RE, $c45e19450f71dc67$var$REPLACEMENT_STR);
    return richText;
}
function $c45e19450f71dc67$var$clean(richText, targetRegexp, replacementString) {
    richText = richText.clone();
    let match = richText.unicodeText.utf16.match(targetRegexp);
    while(match && typeof match.index !== 'undefined'){
        const oldText = richText.unicodeText;
        const removeStartIndex = richText.unicodeText.utf16IndexToUtf8Index(match.index);
        const removeEndIndex = removeStartIndex + new $f8MrZ.UnicodeString(match[0]).length;
        richText.delete(removeStartIndex, removeEndIndex);
        if (richText.unicodeText.utf16 === oldText.utf16) break; // sanity check
        richText.insert(removeStartIndex, replacementString);
        match = richText.unicodeText.utf16.match(targetRegexp);
    }
    return richText;
}

});
parcelRegister("f8MrZ", function(module, exports) {
"use strict";
/**
 * Javascript uses utf16-encoded strings while most environments and specs
 * have standardized around utf8 (including JSON).
 *
 * After some lengthy debated we decided that richtext facets need to use
 * utf8 indices. This means we need tools to convert indices between utf8
 * and utf16, and that's precisely what this library handles.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnicodeString = void 0;

var $bc6Ix = parcelRequire("bc6Ix");
const $b05d2f9d8a8c2b3d$var$encoder = new TextEncoder();
const $b05d2f9d8a8c2b3d$var$decoder = new TextDecoder();
class $b05d2f9d8a8c2b3d$var$UnicodeString {
    constructor(utf16){
        Object.defineProperty(this, "utf16", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "utf8", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_graphemeLen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.utf16 = utf16;
        this.utf8 = $b05d2f9d8a8c2b3d$var$encoder.encode(utf16);
    }
    get length() {
        return this.utf8.byteLength;
    }
    get graphemeLength() {
        if (!this._graphemeLen) this._graphemeLen = (0, $bc6Ix.graphemeLen)(this.utf16);
        return this._graphemeLen;
    }
    slice(start, end) {
        return $b05d2f9d8a8c2b3d$var$decoder.decode(this.utf8.slice(start, end));
    }
    utf16IndexToUtf8Index(i) {
        return $b05d2f9d8a8c2b3d$var$encoder.encode(this.utf16.slice(0, i)).byteLength;
    }
    toString() {
        return this.utf16;
    }
}
module.exports.UnicodeString = $b05d2f9d8a8c2b3d$var$UnicodeString;

});



parcelRegister("3Dbjc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpretLabelValueDefinitions = module.exports.interpretLabelValueDefinition = module.exports.hasMutedWord = module.exports.ModerationDecision = module.exports.ModerationUI = void 0;
module.exports.moderateProfile = $2a4dc9447d6443a4$var$moderateProfile;
module.exports.moderatePost = $2a4dc9447d6443a4$var$moderatePost;
module.exports.moderateNotification = $2a4dc9447d6443a4$var$moderateNotification;
module.exports.moderateFeedGenerator = $2a4dc9447d6443a4$var$moderateFeedGenerator;
module.exports.moderateUserList = $2a4dc9447d6443a4$var$moderateUserList;

var $er2NY = parcelRequire("er2NY");

var $alh2j = parcelRequire("alh2j");

var $6yD8s = parcelRequire("6yD8s");

var $3s6Bk = parcelRequire("3s6Bk");

var $ioi7g = parcelRequire("ioi7g");

var $7oJ4P = parcelRequire("7oJ4P");

var $6mZTV = parcelRequire("6mZTV");

var $cXmGp = parcelRequire("cXmGp");
Object.defineProperty(module.exports, "ModerationUI", {
    enumerable: true,
    get: function() {
        return $cXmGp.ModerationUI;
    }
});

var $er2NY = parcelRequire("er2NY");
Object.defineProperty(module.exports, "ModerationDecision", {
    enumerable: true,
    get: function() {
        return $er2NY.ModerationDecision;
    }
});

var $hikNL = parcelRequire("hikNL");
Object.defineProperty(module.exports, "hasMutedWord", {
    enumerable: true,
    get: function() {
        return $hikNL.hasMutedWord;
    }
});

var $fEzqd = parcelRequire("fEzqd");
Object.defineProperty(module.exports, "interpretLabelValueDefinition", {
    enumerable: true,
    get: function() {
        return $fEzqd.interpretLabelValueDefinition;
    }
});
Object.defineProperty(module.exports, "interpretLabelValueDefinitions", {
    enumerable: true,
    get: function() {
        return $fEzqd.interpretLabelValueDefinitions;
    }
});
function $2a4dc9447d6443a4$var$moderateProfile(subject, opts) {
    return $er2NY.ModerationDecision.merge((0, $alh2j.decideAccount)(subject, opts), (0, $7oJ4P.decideProfile)(subject, opts));
}
function $2a4dc9447d6443a4$var$moderatePost(subject, opts) {
    return (0, $ioi7g.decidePost)(subject, opts);
}
function $2a4dc9447d6443a4$var$moderateNotification(subject, opts) {
    return (0, $3s6Bk.decideNotification)(subject, opts);
}
function $2a4dc9447d6443a4$var$moderateFeedGenerator(subject, opts) {
    return (0, $6yD8s.decideFeedGenerator)(subject, opts);
}
function $2a4dc9447d6443a4$var$moderateUserList(subject, opts) {
    return (0, $6mZTV.decideUserList)(subject, opts);
}

});
parcelRegister("er2NY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModerationDecision = void 0;

var $fAi2h = parcelRequire("fAi2h");

var $6pyjK = parcelRequire("6pyjK");

var $cXmGp = parcelRequire("cXmGp");
var $a825c350e2a9027b$var$ModerationBehaviorSeverity;
(function(ModerationBehaviorSeverity) {
    ModerationBehaviorSeverity[ModerationBehaviorSeverity["High"] = 0] = "High";
    ModerationBehaviorSeverity[ModerationBehaviorSeverity["Medium"] = 1] = "Medium";
    ModerationBehaviorSeverity[ModerationBehaviorSeverity["Low"] = 2] = "Low";
})($a825c350e2a9027b$var$ModerationBehaviorSeverity || ($a825c350e2a9027b$var$ModerationBehaviorSeverity = {}));
class $a825c350e2a9027b$var$ModerationDecision {
    constructor(){
        Object.defineProperty(this, "did", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "isMe", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "causes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    static merge(...decisions) {
        const decisionsFiltered = decisions.filter((v)=>!!v);
        const decision = new $a825c350e2a9027b$var$ModerationDecision();
        if (decisionsFiltered[0]) {
            decision.did = decisionsFiltered[0].did;
            decision.isMe = decisionsFiltered[0].isMe;
        }
        decision.causes = decisionsFiltered.flatMap((d)=>d.causes);
        return decision;
    }
    downgrade() {
        for (const cause of this.causes)cause.downgraded = true;
        return this;
    }
    get blocked() {
        return !!this.blockCause;
    }
    get muted() {
        return !!this.muteCause;
    }
    get blockCause() {
        return this.causes.find((cause)=>cause.type === 'blocking' || cause.type === 'blocked-by' || cause.type === 'block-other');
    }
    get muteCause() {
        return this.causes.find((cause)=>cause.type === 'muted');
    }
    get labelCauses() {
        return this.causes.filter((cause)=>cause.type === 'label');
    }
    ui(context) {
        const ui = new $cXmGp.ModerationUI();
        for (const cause of this.causes){
            if (cause.type === 'blocking' || cause.type === 'blocked-by' || cause.type === 'block-other') {
                if (this.isMe) continue;
                if (context === 'profileList' || context === 'contentList') ui.filters.push(cause);
                if (!cause.downgraded) {
                    if ($6pyjK.BLOCK_BEHAVIOR[context] === 'blur') {
                        ui.noOverride = true;
                        ui.blurs.push(cause);
                    } else if ($6pyjK.BLOCK_BEHAVIOR[context] === 'alert') ui.alerts.push(cause);
                    else if ($6pyjK.BLOCK_BEHAVIOR[context] === 'inform') ui.informs.push(cause);
                }
            } else if (cause.type === 'muted') {
                if (this.isMe) continue;
                if (context === 'profileList' || context === 'contentList') ui.filters.push(cause);
                if (!cause.downgraded) {
                    if ($6pyjK.MUTE_BEHAVIOR[context] === 'blur') ui.blurs.push(cause);
                    else if ($6pyjK.MUTE_BEHAVIOR[context] === 'alert') ui.alerts.push(cause);
                    else if ($6pyjK.MUTE_BEHAVIOR[context] === 'inform') ui.informs.push(cause);
                }
            } else if (cause.type === 'mute-word') {
                if (this.isMe) continue;
                if (context === 'contentList') ui.filters.push(cause);
                if (!cause.downgraded) {
                    if ($6pyjK.MUTEWORD_BEHAVIOR[context] === 'blur') ui.blurs.push(cause);
                    else if ($6pyjK.MUTEWORD_BEHAVIOR[context] === 'alert') ui.alerts.push(cause);
                    else if ($6pyjK.MUTEWORD_BEHAVIOR[context] === 'inform') ui.informs.push(cause);
                }
            } else if (cause.type === 'hidden') {
                if (context === 'profileList' || context === 'contentList') ui.filters.push(cause);
                if (!cause.downgraded) {
                    if ($6pyjK.HIDE_BEHAVIOR[context] === 'blur') ui.blurs.push(cause);
                    else if ($6pyjK.HIDE_BEHAVIOR[context] === 'alert') ui.alerts.push(cause);
                    else if ($6pyjK.HIDE_BEHAVIOR[context] === 'inform') ui.informs.push(cause);
                }
            } else if (cause.type === 'label') {
                if (context === 'profileList' && cause.target === 'account') {
                    if (cause.setting === 'hide' && !this.isMe) ui.filters.push(cause);
                } else if (context === 'contentList' && (cause.target === 'account' || cause.target === 'content')) {
                    if (cause.setting === 'hide' && !this.isMe) ui.filters.push(cause);
                }
                if (!cause.downgraded) {
                    if (cause.behavior[context] === 'blur') {
                        ui.blurs.push(cause);
                        if (cause.noOverride && !this.isMe) ui.noOverride = true;
                    } else if (cause.behavior[context] === 'alert') ui.alerts.push(cause);
                    else if (cause.behavior[context] === 'inform') ui.informs.push(cause);
                }
            }
        }
        ui.filters.sort($a825c350e2a9027b$var$sortByPriority);
        ui.blurs.sort($a825c350e2a9027b$var$sortByPriority);
        return ui;
    }
    setDid(did) {
        this.did = did;
    }
    setIsMe(isMe) {
        this.isMe = isMe;
    }
    addHidden(hidden) {
        if (hidden) this.causes.push({
            type: 'hidden',
            source: {
                type: 'user'
            },
            priority: 6
        });
    }
    addMutedWord(mutedWord) {
        if (mutedWord) this.causes.push({
            type: 'mute-word',
            source: {
                type: 'user'
            },
            priority: 6
        });
    }
    addBlocking(blocking) {
        if (blocking) this.causes.push({
            type: 'blocking',
            source: {
                type: 'user'
            },
            priority: 3
        });
    }
    addBlockingByList(blockingByList) {
        if (blockingByList) this.causes.push({
            type: 'blocking',
            source: {
                type: 'list',
                list: blockingByList
            },
            priority: 3
        });
    }
    addBlockedBy(blockedBy) {
        if (blockedBy) this.causes.push({
            type: 'blocked-by',
            source: {
                type: 'user'
            },
            priority: 4
        });
    }
    addBlockOther(blockOther) {
        if (blockOther) this.causes.push({
            type: 'block-other',
            source: {
                type: 'user'
            },
            priority: 4
        });
    }
    addLabel(target, label, opts) {
        // look up the label definition
        const labelDef = $6pyjK.CUSTOM_LABEL_VALUE_RE.test(label.val) ? opts.labelDefs?.[label.src]?.find((def)=>def.identifier === label.val) || $fAi2h.LABELS[label.val] : $fAi2h.LABELS[label.val];
        if (!labelDef) // ignore labels we don't understand
        return;
        // look up the label preference
        const isSelf = label.src === this.did;
        const labeler = isSelf ? undefined : opts.prefs.labelers.find((s)=>s.did === label.src);
        if (!isSelf && !labeler) return; // skip labelers not configured by the user
        if (isSelf && labelDef.flags.includes('no-self')) return; // skip self-labels that aren't supported
        // establish the label preference for interpretation
        let labelPref = labelDef.defaultSetting || 'ignore';
        if (!labelDef.configurable) labelPref = labelDef.defaultSetting || 'hide';
        else if (labelDef.flags.includes('adult') && !opts.prefs.adultContentEnabled) labelPref = 'hide';
        else if (labeler?.labels[labelDef.identifier]) labelPref = labeler?.labels[labelDef.identifier];
        else if (opts.prefs.labels[labelDef.identifier]) labelPref = opts.prefs.labels[labelDef.identifier];
        // ignore labels the user has asked to ignore
        if (labelPref === 'ignore') return;
        // ignore 'unauthed' labels when the user is authed
        if (labelDef.flags.includes('unauthed') && !!opts.userDid) return;
        // establish the priority of the label
        let priority;
        const severity = $a825c350e2a9027b$var$measureModerationBehaviorSeverity(labelDef.behaviors[target]);
        if (labelDef.flags.includes('no-override') || labelDef.flags.includes('adult') && !opts.prefs.adultContentEnabled) priority = 1;
        else if (labelPref === 'hide') priority = 2;
        else if (severity === $a825c350e2a9027b$var$ModerationBehaviorSeverity.High) // blurring profile view or content view
        priority = 5;
        else if (severity === $a825c350e2a9027b$var$ModerationBehaviorSeverity.Medium) // blurring content list or content media
        priority = 7;
        else // blurring avatar, adding alerts
        priority = 8;
        let noOverride = false;
        if (labelDef.flags.includes('no-override')) noOverride = true;
        else if (labelDef.flags.includes('adult') && !opts.prefs.adultContentEnabled) noOverride = true;
        this.causes.push({
            type: 'label',
            source: isSelf || !labeler ? {
                type: 'user'
            } : {
                type: 'labeler',
                did: labeler.did
            },
            label: label,
            labelDef: labelDef,
            target: target,
            setting: labelPref,
            behavior: labelDef.behaviors[target] || $6pyjK.NOOP_BEHAVIOR,
            noOverride: noOverride,
            priority: priority
        });
    }
    addMuted(muted) {
        if (muted) this.causes.push({
            type: 'muted',
            source: {
                type: 'user'
            },
            priority: 6
        });
    }
    addMutedByList(mutedByList) {
        if (mutedByList) this.causes.push({
            type: 'muted',
            source: {
                type: 'list',
                list: mutedByList
            },
            priority: 6
        });
    }
}
module.exports.ModerationDecision = $a825c350e2a9027b$var$ModerationDecision;
function $a825c350e2a9027b$var$measureModerationBehaviorSeverity(beh) {
    if (!beh) return $a825c350e2a9027b$var$ModerationBehaviorSeverity.Low;
    if (beh.profileView === 'blur' || beh.contentView === 'blur') return $a825c350e2a9027b$var$ModerationBehaviorSeverity.High;
    if (beh.contentList === 'blur' || beh.contentMedia === 'blur') return $a825c350e2a9027b$var$ModerationBehaviorSeverity.Medium;
    return $a825c350e2a9027b$var$ModerationBehaviorSeverity.Low;
}
function $a825c350e2a9027b$var$sortByPriority(a, b) {
    return a.priority - b.priority;
}

});
parcelRegister("fAi2h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LABELS = module.exports.DEFAULT_LABEL_SETTINGS = void 0;
module.exports.DEFAULT_LABEL_SETTINGS = {
    porn: 'hide',
    sexual: 'warn',
    nudity: 'ignore',
    'graphic-media': 'warn'
};
module.exports.LABELS = {
    '!hide': {
        identifier: '!hide',
        configurable: false,
        defaultSetting: 'hide',
        flags: [
            'no-override',
            'no-self'
        ],
        severity: 'alert',
        blurs: 'content',
        behaviors: {
            account: {
                profileList: 'blur',
                profileView: 'blur',
                avatar: 'blur',
                banner: 'blur',
                displayName: 'blur',
                contentList: 'blur',
                contentView: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur',
                displayName: 'blur'
            },
            content: {
                contentList: 'blur',
                contentView: 'blur'
            }
        },
        locales: []
    },
    '!warn': {
        identifier: '!warn',
        configurable: false,
        defaultSetting: 'warn',
        flags: [
            'no-self'
        ],
        severity: 'none',
        blurs: 'content',
        behaviors: {
            account: {
                profileList: 'blur',
                profileView: 'blur',
                avatar: 'blur',
                banner: 'blur',
                contentList: 'blur',
                contentView: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur',
                displayName: 'blur'
            },
            content: {
                contentList: 'blur',
                contentView: 'blur'
            }
        },
        locales: []
    },
    '!no-unauthenticated': {
        identifier: '!no-unauthenticated',
        configurable: false,
        defaultSetting: 'hide',
        flags: [
            'no-override',
            'unauthed'
        ],
        severity: 'none',
        blurs: 'content',
        behaviors: {
            account: {
                profileList: 'blur',
                profileView: 'blur',
                avatar: 'blur',
                banner: 'blur',
                displayName: 'blur',
                contentList: 'blur',
                contentView: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur',
                displayName: 'blur'
            },
            content: {
                contentList: 'blur',
                contentView: 'blur'
            }
        },
        locales: []
    },
    porn: {
        identifier: 'porn',
        configurable: true,
        defaultSetting: 'hide',
        flags: [
            'adult'
        ],
        severity: 'none',
        blurs: 'media',
        behaviors: {
            account: {
                avatar: 'blur',
                banner: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur'
            },
            content: {
                contentMedia: 'blur'
            }
        },
        locales: []
    },
    sexual: {
        identifier: 'sexual',
        configurable: true,
        defaultSetting: 'warn',
        flags: [
            'adult'
        ],
        severity: 'none',
        blurs: 'media',
        behaviors: {
            account: {
                avatar: 'blur',
                banner: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur'
            },
            content: {
                contentMedia: 'blur'
            }
        },
        locales: []
    },
    nudity: {
        identifier: 'nudity',
        configurable: true,
        defaultSetting: 'ignore',
        flags: [],
        severity: 'none',
        blurs: 'media',
        behaviors: {
            account: {
                avatar: 'blur',
                banner: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur'
            },
            content: {
                contentMedia: 'blur'
            }
        },
        locales: []
    },
    'graphic-media': {
        identifier: 'graphic-media',
        flags: [
            'adult'
        ],
        configurable: true,
        defaultSetting: 'warn',
        severity: 'none',
        blurs: 'media',
        behaviors: {
            account: {
                avatar: 'blur',
                banner: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur'
            },
            content: {
                contentMedia: 'blur'
            }
        },
        locales: []
    },
    /** @deprecated alias for `graphic-media` */ gore: {
        identifier: 'gore',
        flags: [
            'adult'
        ],
        configurable: true,
        defaultSetting: 'warn',
        severity: 'none',
        blurs: 'media',
        behaviors: {
            account: {
                avatar: 'blur',
                banner: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur'
            },
            content: {
                contentMedia: 'blur'
            }
        },
        locales: []
    }
};

});

parcelRegister("6pyjK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NOOP_BEHAVIOR = module.exports.HIDE_BEHAVIOR = module.exports.MUTEWORD_BEHAVIOR = module.exports.MUTE_BEHAVIOR = module.exports.BLOCK_BEHAVIOR = module.exports.CUSTOM_LABEL_VALUE_RE = void 0;
// syntax
// =
module.exports.CUSTOM_LABEL_VALUE_RE = /^[a-z-]+$/;
module.exports.BLOCK_BEHAVIOR = {
    profileList: 'blur',
    profileView: 'alert',
    avatar: 'blur',
    banner: 'blur',
    contentList: 'blur',
    contentView: 'blur'
};
module.exports.MUTE_BEHAVIOR = {
    profileList: 'inform',
    profileView: 'alert',
    contentList: 'blur',
    contentView: 'inform'
};
module.exports.MUTEWORD_BEHAVIOR = {
    contentList: 'blur',
    contentView: 'blur'
};
module.exports.HIDE_BEHAVIOR = {
    contentList: 'blur',
    contentView: 'blur'
};
module.exports.NOOP_BEHAVIOR = {};

});

parcelRegister("cXmGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModerationUI = void 0;
class $96ec971f8d731da9$var$ModerationUI {
    constructor(){
        Object.defineProperty(this, "noOverride", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "filters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "blurs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "alerts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "informs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    get filter() {
        return this.filters.length !== 0;
    }
    get blur() {
        return this.blurs.length !== 0;
    }
    get alert() {
        return this.alerts.length !== 0;
    }
    get inform() {
        return this.informs.length !== 0;
    }
}
module.exports.ModerationUI = $96ec971f8d731da9$var$ModerationUI;

});


parcelRegister("alh2j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decideAccount = $7879149d9540fbfd$var$decideAccount;
module.exports.filterAccountLabels = $7879149d9540fbfd$var$filterAccountLabels;

var $er2NY = parcelRequire("er2NY");
function $7879149d9540fbfd$var$decideAccount(subject, opts) {
    const acc = new $er2NY.ModerationDecision();
    acc.setDid(subject.did);
    acc.setIsMe(subject.did === opts.userDid);
    if (subject.viewer?.muted) {
        if (subject.viewer?.mutedByList) acc.addMutedByList(subject.viewer?.mutedByList);
        else acc.addMuted(subject.viewer?.muted);
    }
    if (subject.viewer?.blocking) {
        if (subject.viewer?.blockingByList) acc.addBlockingByList(subject.viewer?.blockingByList);
        else acc.addBlocking(subject.viewer?.blocking);
    }
    acc.addBlockedBy(subject.viewer?.blockedBy);
    for (const label of $7879149d9540fbfd$var$filterAccountLabels(subject.labels))acc.addLabel('account', label, opts);
    return acc;
}
function $7879149d9540fbfd$var$filterAccountLabels(labels) {
    if (!labels) return [];
    return labels.filter((label)=>!label.uri.endsWith('/app.bsky.actor.profile/self') || label.val === '!no-unauthenticated');
}

});

parcelRegister("6yD8s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decideFeedGenerator = $4c64468680fd5782$var$decideFeedGenerator;

var $er2NY = parcelRequire("er2NY");

var $alh2j = parcelRequire("alh2j");

var $7oJ4P = parcelRequire("7oJ4P");
function $4c64468680fd5782$var$decideFeedGenerator(subject, opts) {
    const acc = new $er2NY.ModerationDecision();
    acc.setDid(subject.creator.did);
    acc.setIsMe(subject.creator.did === opts.userDid);
    if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
    return $er2NY.ModerationDecision.merge(acc, (0, $alh2j.decideAccount)(subject.creator, opts), (0, $7oJ4P.decideProfile)(subject.creator, opts));
}

});
parcelRegister("7oJ4P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decideProfile = $562dbda5d0c75205$var$decideProfile;
module.exports.filterProfileLabels = $562dbda5d0c75205$var$filterProfileLabels;

var $er2NY = parcelRequire("er2NY");
function $562dbda5d0c75205$var$decideProfile(subject, opts) {
    const acc = new $er2NY.ModerationDecision();
    acc.setDid(subject.did);
    acc.setIsMe(subject.did === opts.userDid);
    for (const label of $562dbda5d0c75205$var$filterProfileLabels(subject.labels))acc.addLabel('profile', label, opts);
    return acc;
}
function $562dbda5d0c75205$var$filterProfileLabels(labels) {
    if (!labels) return [];
    return labels.filter((label)=>label.uri.endsWith('/app.bsky.actor.profile/self'));
}

});


parcelRegister("3s6Bk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decideNotification = $28391b779923adb7$var$decideNotification;

var $er2NY = parcelRequire("er2NY");

var $alh2j = parcelRequire("alh2j");

var $7oJ4P = parcelRequire("7oJ4P");
function $28391b779923adb7$var$decideNotification(subject, opts) {
    const acc = new $er2NY.ModerationDecision();
    acc.setDid(subject.author.did);
    acc.setIsMe(subject.author.did === opts.userDid);
    if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
    return $er2NY.ModerationDecision.merge(acc, (0, $alh2j.decideAccount)(subject.author, opts), (0, $7oJ4P.decideProfile)(subject.author, opts));
}

});

parcelRegister("ioi7g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decidePost = $d638856701b4e35d$var$decidePost;

var $2wqOO = parcelRequire("2wqOO");

var $er2NY = parcelRequire("er2NY");

var $hikNL = parcelRequire("hikNL");

var $alh2j = parcelRequire("alh2j");

var $7oJ4P = parcelRequire("7oJ4P");
function $d638856701b4e35d$var$decidePost(subject, opts) {
    const acc = new $er2NY.ModerationDecision();
    acc.setDid(subject.author.did);
    acc.setIsMe(subject.author.did === opts.userDid);
    if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
    acc.addHidden($d638856701b4e35d$var$checkHiddenPost(subject, opts.prefs.hiddenPosts));
    if (!acc.isMe) acc.addMutedWord($d638856701b4e35d$var$checkMutedWords(subject, opts.prefs.mutedWords));
    let embedAcc;
    if (subject.embed) {
        if ($2wqOO.AppBskyEmbedRecord.isViewRecord(subject.embed.record)) // quote post
        embedAcc = $d638856701b4e35d$var$decideQuotedPost(subject.embed.record, opts);
        else if ($2wqOO.AppBskyEmbedRecordWithMedia.isView(subject.embed) && $2wqOO.AppBskyEmbedRecord.isViewRecord(subject.embed.record.record)) // quoted post with media
        embedAcc = $d638856701b4e35d$var$decideQuotedPost(subject.embed.record.record, opts);
        else if ($2wqOO.AppBskyEmbedRecord.isViewBlocked(subject.embed.record)) // blocked quote post
        embedAcc = $d638856701b4e35d$var$decideBlockedQuotedPost(subject.embed.record, opts);
        else if ($2wqOO.AppBskyEmbedRecordWithMedia.isView(subject.embed) && $2wqOO.AppBskyEmbedRecord.isViewBlocked(subject.embed.record.record)) // blocked quoted post with media
        embedAcc = $d638856701b4e35d$var$decideBlockedQuotedPost(subject.embed.record.record, opts);
    }
    return $er2NY.ModerationDecision.merge(acc, embedAcc?.downgrade(), (0, $alh2j.decideAccount)(subject.author, opts), (0, $7oJ4P.decideProfile)(subject.author, opts));
}
function $d638856701b4e35d$var$decideQuotedPost(subject, opts) {
    const acc = new $er2NY.ModerationDecision();
    acc.setDid(subject.author.did);
    acc.setIsMe(subject.author.did === opts.userDid);
    if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
    return $er2NY.ModerationDecision.merge(acc, (0, $alh2j.decideAccount)(subject.author, opts), (0, $7oJ4P.decideProfile)(subject.author, opts));
}
function $d638856701b4e35d$var$decideBlockedQuotedPost(subject, opts) {
    const acc = new $er2NY.ModerationDecision();
    acc.setDid(subject.author.did);
    acc.setIsMe(subject.author.did === opts.userDid);
    if (subject.author.viewer?.muted) {
        if (subject.author.viewer?.mutedByList) acc.addMutedByList(subject.author.viewer?.mutedByList);
        else acc.addMuted(subject.author.viewer?.muted);
    }
    if (subject.author.viewer?.blocking) {
        if (subject.author.viewer?.blockingByList) acc.addBlockingByList(subject.author.viewer?.blockingByList);
        else acc.addBlocking(subject.author.viewer?.blocking);
    }
    acc.addBlockedBy(subject.author.viewer?.blockedBy);
    return acc;
}
function $d638856701b4e35d$var$checkHiddenPost(subject, hiddenPosts) {
    if (!hiddenPosts?.length) return false;
    if (hiddenPosts.includes(subject.uri)) return true;
    if (subject.embed) {
        if ($2wqOO.AppBskyEmbedRecord.isViewRecord(subject.embed.record) && hiddenPosts.includes(subject.embed.record.uri)) return true;
        if ($2wqOO.AppBskyEmbedRecordWithMedia.isView(subject.embed) && $2wqOO.AppBskyEmbedRecord.isViewRecord(subject.embed.record.record) && hiddenPosts.includes(subject.embed.record.record.uri)) return true;
    }
    return false;
}
function $d638856701b4e35d$var$checkMutedWords(subject, mutedWords) {
    if (!mutedWords?.length) return false;
    const postAuthor = subject.author;
    if ($2wqOO.AppBskyFeedPost.isRecord(subject.record)) {
        // post text
        if ((0, $hikNL.hasMutedWord)({
            mutedWords: mutedWords,
            text: subject.record.text,
            facets: subject.record.facets,
            outlineTags: subject.record.tags,
            languages: subject.record.langs,
            actor: postAuthor
        })) return true;
        if (subject.record.embed && $2wqOO.AppBskyEmbedImages.isMain(subject.record.embed)) // post images
        for (const image of subject.record.embed.images){
            if ((0, $hikNL.hasMutedWord)({
                mutedWords: mutedWords,
                text: image.alt,
                languages: subject.record.langs,
                actor: postAuthor
            })) return true;
        }
    }
    if (subject.embed) {
        // quote post
        if ($2wqOO.AppBskyEmbedRecord.isViewRecord(subject.embed.record)) {
            if ($2wqOO.AppBskyFeedPost.isRecord(subject.embed.record.value)) {
                const embeddedPost = subject.embed.record.value;
                const embedAuthor = subject.embed.record.author;
                // quoted post text
                if ((0, $hikNL.hasMutedWord)({
                    mutedWords: mutedWords,
                    text: embeddedPost.text,
                    facets: embeddedPost.facets,
                    outlineTags: embeddedPost.tags,
                    languages: embeddedPost.langs,
                    actor: embedAuthor
                })) return true;
                // quoted post's images
                if ($2wqOO.AppBskyEmbedImages.isMain(embeddedPost.embed)) for (const image of embeddedPost.embed.images){
                    if ((0, $hikNL.hasMutedWord)({
                        mutedWords: mutedWords,
                        text: image.alt,
                        languages: embeddedPost.langs,
                        actor: embedAuthor
                    })) return true;
                }
                // quoted post's link card
                if ($2wqOO.AppBskyEmbedExternal.isMain(embeddedPost.embed)) {
                    const { external: external } = embeddedPost.embed;
                    if ((0, $hikNL.hasMutedWord)({
                        mutedWords: mutedWords,
                        text: external.title + ' ' + external.description,
                        languages: [],
                        actor: embedAuthor
                    })) return true;
                }
                if ($2wqOO.AppBskyEmbedRecordWithMedia.isMain(embeddedPost.embed)) {
                    // quoted post's link card when it did a quote + media
                    if ($2wqOO.AppBskyEmbedExternal.isMain(embeddedPost.embed.media)) {
                        const { external: external } = embeddedPost.embed.media;
                        if ((0, $hikNL.hasMutedWord)({
                            mutedWords: mutedWords,
                            text: external.title + ' ' + external.description,
                            languages: [],
                            actor: embedAuthor
                        })) return true;
                    }
                    // quoted post's images when it did a quote + media
                    if ($2wqOO.AppBskyEmbedImages.isMain(embeddedPost.embed.media)) for (const image of embeddedPost.embed.media.images){
                        if ((0, $hikNL.hasMutedWord)({
                            mutedWords: mutedWords,
                            text: image.alt,
                            languages: $2wqOO.AppBskyFeedPost.isRecord(embeddedPost.record) ? embeddedPost.langs : [],
                            actor: embedAuthor
                        })) return true;
                    }
                }
            }
        } else if ($2wqOO.AppBskyEmbedExternal.isView(subject.embed)) {
            const { external: external } = subject.embed;
            if ((0, $hikNL.hasMutedWord)({
                mutedWords: mutedWords,
                text: external.title + ' ' + external.description,
                languages: [],
                actor: postAuthor
            })) return true;
        } else if ($2wqOO.AppBskyEmbedRecordWithMedia.isView(subject.embed) && $2wqOO.AppBskyEmbedRecord.isViewRecord(subject.embed.record.record)) {
            const embedAuthor = subject.embed.record.record.author;
            // quoted post text
            if ($2wqOO.AppBskyFeedPost.isRecord(subject.embed.record.record.value)) {
                const post = subject.embed.record.record.value;
                if ((0, $hikNL.hasMutedWord)({
                    mutedWords: mutedWords,
                    text: post.text,
                    facets: post.facets,
                    outlineTags: post.tags,
                    languages: post.langs,
                    actor: embedAuthor
                })) return true;
            }
            // quoted post images
            if ($2wqOO.AppBskyEmbedImages.isView(subject.embed.media)) for (const image of subject.embed.media.images){
                if ((0, $hikNL.hasMutedWord)({
                    mutedWords: mutedWords,
                    text: image.alt,
                    languages: $2wqOO.AppBskyFeedPost.isRecord(subject.record) ? subject.record.langs : [],
                    actor: embedAuthor
                })) return true;
            }
            if ($2wqOO.AppBskyEmbedExternal.isView(subject.embed.media)) {
                const { external: external } = subject.embed.media;
                if ((0, $hikNL.hasMutedWord)({
                    mutedWords: mutedWords,
                    text: external.title + ' ' + external.description,
                    languages: [],
                    actor: embedAuthor
                })) return true;
            }
        }
    }
    return false;
}

});
parcelRegister("hikNL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasMutedWord = $c97440e1cfd9d29e$var$hasMutedWord;

var $2wqOO = parcelRequire("2wqOO");
const $c97440e1cfd9d29e$var$REGEX = {
    LEADING_TRAILING_PUNCTUATION: /(?:^\p{P}+|\p{P}+$)/gu,
    ESCAPE: /[[\]{}()*+?.\\^$|\s]/g,
    SEPARATORS: /[/\-–—()[\]_]+/g,
    WORD_BOUNDARY: /[\s\n\t\r\f\v]+?/g
};
/**
 * List of 2-letter lang codes for languages that either don't use spaces, or
 * don't use spaces in a way conducive to word-based filtering.
 *
 * For these, we use a simple `String.includes` to check for a match.
 */ const $c97440e1cfd9d29e$var$LANGUAGE_EXCEPTIONS = [
    'ja',
    'zh',
    'ko',
    'th',
    'vi'
];
function $c97440e1cfd9d29e$var$hasMutedWord({ mutedWords: mutedWords, text: text, facets: facets, outlineTags: outlineTags, languages: languages, actor: actor }) {
    const exception = $c97440e1cfd9d29e$var$LANGUAGE_EXCEPTIONS.includes(languages?.[0] || '');
    const tags = [].concat(outlineTags || []).concat((facets || []).flatMap((facet)=>facet.features.filter($2wqOO.AppBskyRichtextFacet.isTag).map((tag)=>tag.tag))).map((t)=>t.toLowerCase());
    for (const mute of mutedWords){
        const mutedWord = mute.value.toLowerCase();
        const postText = text.toLowerCase();
        // expired, ignore
        if (mute.expiresAt && mute.expiresAt < new Date().toISOString()) continue;
        if (mute.actorTarget === 'exclude-following' && Boolean(actor?.viewer?.following)) continue;
        // `content` applies to tags as well
        if (tags.includes(mutedWord)) return true;
        // rest of the checks are for `content` only
        if (!mute.targets.includes('content')) continue;
        // single character or other exception, has to use includes
        if ((mutedWord.length === 1 || exception) && postText.includes(mutedWord)) return true;
        // too long
        if (mutedWord.length > postText.length) continue;
        // exact match
        if (mutedWord === postText) return true;
        // any muted phrase with space or punctuation
        if (/(?:\s|\p{P})+?/u.test(mutedWord) && postText.includes(mutedWord)) return true;
        // check individual character groups
        const words = postText.split($c97440e1cfd9d29e$var$REGEX.WORD_BOUNDARY);
        for (const word of words){
            if (word === mutedWord) return true;
            // compare word without leading/trailing punctuation, but allow internal
            // punctuation (such as `s@ssy`)
            const wordTrimmedPunctuation = word.replace($c97440e1cfd9d29e$var$REGEX.LEADING_TRAILING_PUNCTUATION, '');
            if (mutedWord === wordTrimmedPunctuation) return true;
            if (mutedWord.length > wordTrimmedPunctuation.length) continue;
            if (/\p{P}+/u.test(wordTrimmedPunctuation)) {
                const spacedWord = wordTrimmedPunctuation.replace(/\p{P}+/gu, ' ');
                if (spacedWord === mutedWord) return true;
                const contiguousWord = spacedWord.replace(/\s/gu, '');
                if (contiguousWord === mutedWord) return true;
                const wordParts = wordTrimmedPunctuation.split(/\p{P}+/u);
                for (const wordPart of wordParts){
                    if (wordPart === mutedWord) return true;
                }
            }
        }
    }
    return false;
}

});


parcelRegister("6mZTV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decideUserList = $4a34d06dcee64a1b$var$decideUserList;

var $UiDXP = parcelRequire("UiDXP");

var $er2NY = parcelRequire("er2NY");

var $alh2j = parcelRequire("alh2j");

var $7oJ4P = parcelRequire("7oJ4P");
function $4a34d06dcee64a1b$var$decideUserList(subject, opts) {
    const acc = new $er2NY.ModerationDecision();
    const creator = $4a34d06dcee64a1b$var$isProfile(subject.creator) ? subject.creator : undefined;
    if (creator) {
        acc.setDid(creator.did);
        acc.setIsMe(creator.did === opts.userDid);
        if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
        return $er2NY.ModerationDecision.merge(acc, (0, $alh2j.decideAccount)(creator, opts), (0, $7oJ4P.decideProfile)(creator, opts));
    }
    const creatorDid = new $UiDXP.AtUri(subject.uri).hostname;
    acc.setDid(creatorDid);
    acc.setIsMe(creatorDid === opts.userDid);
    if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
    return acc;
}
function $4a34d06dcee64a1b$var$isProfile(v) {
    return v && typeof v === 'object' && 'did' in v;
}

});

parcelRegister("fEzqd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isQuotedPost = $b656117d25d7a6aa$var$isQuotedPost;
module.exports.isQuotedPostWithMedia = $b656117d25d7a6aa$var$isQuotedPostWithMedia;
module.exports.interpretLabelValueDefinition = $b656117d25d7a6aa$var$interpretLabelValueDefinition;
module.exports.interpretLabelValueDefinitions = $b656117d25d7a6aa$var$interpretLabelValueDefinitions;

var $2wqOO = parcelRequire("2wqOO");
function $b656117d25d7a6aa$var$isQuotedPost(embed) {
    return Boolean(embed && $2wqOO.AppBskyEmbedRecord.isView(embed));
}
function $b656117d25d7a6aa$var$isQuotedPostWithMedia(embed) {
    return Boolean(embed && $2wqOO.AppBskyEmbedRecordWithMedia.isView(embed));
}
function $b656117d25d7a6aa$var$interpretLabelValueDefinition(def, definedBy) {
    const behaviors = {
        account: {},
        profile: {},
        content: {}
    };
    const alertOrInform = def.severity === 'alert' ? 'alert' : def.severity === 'inform' ? 'inform' : undefined;
    if (def.blurs === 'content') {
        // target=account, blurs=content
        behaviors.account.profileList = alertOrInform;
        behaviors.account.profileView = alertOrInform;
        behaviors.account.contentList = 'blur';
        behaviors.account.contentView = def.adultOnly ? 'blur' : alertOrInform;
        // target=profile, blurs=content
        behaviors.profile.profileList = alertOrInform;
        behaviors.profile.profileView = alertOrInform;
        // target=content, blurs=content
        behaviors.content.contentList = 'blur';
        behaviors.content.contentView = def.adultOnly ? 'blur' : alertOrInform;
    } else if (def.blurs === 'media') {
        // target=account, blurs=media
        behaviors.account.profileList = alertOrInform;
        behaviors.account.profileView = alertOrInform;
        behaviors.account.avatar = 'blur';
        behaviors.account.banner = 'blur';
        // target=profile, blurs=media
        behaviors.profile.profileList = alertOrInform;
        behaviors.profile.profileView = alertOrInform;
        behaviors.profile.avatar = 'blur';
        behaviors.profile.banner = 'blur';
        // target=content, blurs=media
        behaviors.content.contentMedia = 'blur';
    } else if (def.blurs === 'none') {
        // target=account, blurs=none
        behaviors.account.profileList = alertOrInform;
        behaviors.account.profileView = alertOrInform;
        behaviors.account.contentList = alertOrInform;
        behaviors.account.contentView = alertOrInform;
        // target=profile, blurs=none
        behaviors.profile.profileList = alertOrInform;
        behaviors.profile.profileView = alertOrInform;
        // target=content, blurs=none
        behaviors.content.contentList = alertOrInform;
        behaviors.content.contentView = alertOrInform;
    }
    let defaultSetting = 'warn';
    if (def.defaultSetting === 'hide' || def.defaultSetting === 'ignore') defaultSetting = def.defaultSetting;
    const flags = [
        'no-self'
    ];
    if (def.adultOnly) flags.push('adult');
    return {
        ...def,
        definedBy: definedBy,
        configurable: true,
        defaultSetting: defaultSetting,
        flags: flags,
        behaviors: behaviors
    };
}
function $b656117d25d7a6aa$var$interpretLabelValueDefinitions(labelerView) {
    return (labelerView.policies?.labelValueDefinitions || []).filter((labelValDef)=>$2wqOO.ComAtprotoLabelDefs.validateLabelValueDefinition(labelValDef).success).map((labelValDef)=>$b656117d25d7a6aa$var$interpretLabelValueDefinition(labelValDef, labelerView.creator.did));
}

});


parcelRegister("lV5Zn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mock = void 0;
const $ff539120aa4b777e$var$FAKE_CID = 'bafyreiclp443lavogvhj3d2ob2cxbfuscni2k5jk7bebjzg7khl3esabwq';
module.exports.mock = {
    post ({ text: text, facets: facets, reply: reply, embed: embed }) {
        return {
            $type: 'app.bsky.feed.post',
            text: text,
            facets: facets,
            reply: reply,
            embed: embed,
            langs: [
                'en'
            ],
            createdAt: new Date().toISOString()
        };
    },
    postView ({ record: record, author: author, embed: embed, replyCount: replyCount, repostCount: repostCount, likeCount: likeCount, viewer: viewer, labels: labels }) {
        return {
            $type: 'app.bsky.feed.defs#postView',
            uri: `at://${author.did}/app.bsky.feed.post/fake`,
            cid: $ff539120aa4b777e$var$FAKE_CID,
            author: author,
            record: record,
            embed: embed,
            replyCount: replyCount,
            repostCount: repostCount,
            likeCount: likeCount,
            indexedAt: new Date().toISOString(),
            viewer: viewer,
            labels: labels
        };
    },
    embedRecordView ({ record: record, author: author, labels: labels }) {
        return {
            $type: 'app.bsky.embed.record#view',
            record: {
                $type: 'app.bsky.embed.record#viewRecord',
                uri: `at://${author.did}/app.bsky.feed.post/fake`,
                cid: $ff539120aa4b777e$var$FAKE_CID,
                author: author,
                value: record,
                labels: labels,
                indexedAt: new Date().toISOString()
            }
        };
    },
    profileViewBasic ({ handle: handle, displayName: displayName, description: description, viewer: viewer, labels: labels }) {
        return {
            did: `did:web:${handle}`,
            handle: handle,
            displayName: displayName,
            description: description,
            viewer: viewer,
            labels: labels
        };
    },
    actorViewerState ({ muted: muted, mutedByList: mutedByList, blockedBy: blockedBy, blocking: blocking, blockingByList: blockingByList, following: following, followedBy: followedBy }) {
        return {
            muted: muted,
            mutedByList: mutedByList,
            blockedBy: blockedBy,
            blocking: blocking,
            blockingByList: blockingByList,
            following: following,
            followedBy: followedBy
        };
    },
    listViewBasic ({ name: name }) {
        return {
            uri: 'at://did:plc:fake/app.bsky.graph.list/fake',
            cid: $ff539120aa4b777e$var$FAKE_CID,
            name: name,
            purpose: 'app.bsky.graph.defs#modlist',
            indexedAt: new Date().toISOString()
        };
    },
    replyNotification ({ author: author, record: record, labels: labels }) {
        return {
            uri: `at://${author.did}/app.bsky.feed.post/fake`,
            cid: $ff539120aa4b777e$var$FAKE_CID,
            author: author,
            reason: 'reply',
            reasonSubject: `at://${author.did}/app.bsky.feed.post/fake-parent`,
            record: record,
            isRead: false,
            indexedAt: new Date().toISOString(),
            labels: labels
        };
    },
    followNotification ({ author: author, subjectDid: subjectDid, labels: labels }) {
        return {
            uri: `at://${author.did}/app.bsky.graph.follow/fake`,
            cid: $ff539120aa4b777e$var$FAKE_CID,
            author: author,
            reason: 'follow',
            record: {
                $type: 'app.bsky.graph.follow',
                createdAt: new Date().toISOString(),
                subject: subjectDid
            },
            isRead: false,
            indexedAt: new Date().toISOString(),
            labels: labels
        };
    },
    label ({ val: val, uri: uri, src: src }) {
        return {
            src: src || 'did:plc:fake-labeler',
            uri: uri,
            val: val,
            cts: new Date().toISOString()
        };
    }
};

});

parcelRegister("8rHSu", function(module, exports) {
"use strict";
var $6262e194320d7061$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6262e194320d7061$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6262e194320d7061$var$_AwaitLock_acquired, $6262e194320d7061$var$_AwaitLock_waitingResolvers;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * A mutex lock for coordination across async functions
 */ class $6262e194320d7061$var$AwaitLock {
    constructor(){
        $6262e194320d7061$var$_AwaitLock_acquired.set(this, false);
        $6262e194320d7061$var$_AwaitLock_waitingResolvers.set(this, new Set());
    }
    /**
     * Whether the lock is currently acquired or not. Accessing this property does not affect the
     * status of the lock.
     */ get acquired() {
        return $6262e194320d7061$var$__classPrivateFieldGet(this, $6262e194320d7061$var$_AwaitLock_acquired, "f");
    }
    /**
     * Acquires the lock, waiting if necessary for it to become free if it is already locked. The
     * returned promise is fulfilled once the lock is acquired.
     *
     * A timeout (in milliseconds) may be optionally provided. If the lock cannot be acquired before
     * the timeout elapses, the returned promise is rejected with an error. The behavior of invalid
     * timeout values depends on how `setTimeout` handles those values.
     *
     * After acquiring the lock, you **must** call `release` when you are done with it.
     */ acquireAsync({ timeout: timeout } = {}) {
        if (!$6262e194320d7061$var$__classPrivateFieldGet(this, $6262e194320d7061$var$_AwaitLock_acquired, "f")) {
            $6262e194320d7061$var$__classPrivateFieldSet(this, $6262e194320d7061$var$_AwaitLock_acquired, true, "f");
            return Promise.resolve();
        }
        if (timeout == null) return new Promise((resolve)=>{
            $6262e194320d7061$var$__classPrivateFieldGet(this, $6262e194320d7061$var$_AwaitLock_waitingResolvers, "f").add(resolve);
        });
        let resolver;
        let timer;
        return Promise.race([
            new Promise((resolve)=>{
                resolver = ()=>{
                    clearTimeout(timer);
                    resolve();
                };
                $6262e194320d7061$var$__classPrivateFieldGet(this, $6262e194320d7061$var$_AwaitLock_waitingResolvers, "f").add(resolver);
            }),
            new Promise((_, reject)=>{
                timer = setTimeout(()=>{
                    $6262e194320d7061$var$__classPrivateFieldGet(this, $6262e194320d7061$var$_AwaitLock_waitingResolvers, "f").delete(resolver);
                    reject(new Error(`Timed out waiting for lock`));
                }, timeout);
            })
        ]);
    }
    /**
     * Acquires the lock if it is free and otherwise returns immediately without waiting. Returns
     * `true` if the lock was free and is now acquired, and `false` otherwise.
     *
     * This method differs from calling `acquireAsync` with a zero-millisecond timeout in that it runs
     * synchronously without waiting for the JavaScript task queue.
     */ tryAcquire() {
        if (!$6262e194320d7061$var$__classPrivateFieldGet(this, $6262e194320d7061$var$_AwaitLock_acquired, "f")) {
            $6262e194320d7061$var$__classPrivateFieldSet(this, $6262e194320d7061$var$_AwaitLock_acquired, true, "f");
            return true;
        }
        return false;
    }
    /**
     * Releases the lock and gives it to the next waiting acquirer, if there is one. Each acquirer
     * must release the lock exactly once.
     */ release() {
        if (!$6262e194320d7061$var$__classPrivateFieldGet(this, $6262e194320d7061$var$_AwaitLock_acquired, "f")) throw new Error(`Cannot release an unacquired lock`);
        if ($6262e194320d7061$var$__classPrivateFieldGet(this, $6262e194320d7061$var$_AwaitLock_waitingResolvers, "f").size > 0) {
            // Sets preserve insertion order like a queue
            const [resolve] = $6262e194320d7061$var$__classPrivateFieldGet(this, $6262e194320d7061$var$_AwaitLock_waitingResolvers, "f");
            $6262e194320d7061$var$__classPrivateFieldGet(this, $6262e194320d7061$var$_AwaitLock_waitingResolvers, "f").delete(resolve);
            resolve();
        } else $6262e194320d7061$var$__classPrivateFieldSet(this, $6262e194320d7061$var$_AwaitLock_acquired, false, "f");
    }
}
module.exports.default = $6262e194320d7061$var$AwaitLock;
$6262e194320d7061$var$_AwaitLock_acquired = new WeakMap(), $6262e194320d7061$var$_AwaitLock_waitingResolvers = new WeakMap();

});

parcelRegister("h3MMF", function(module, exports) {
"use strict";
var $c6b88ef8ba6a41da$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c6b88ef8ba6a41da$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c6b88ef8ba6a41da$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c6b88ef8ba6a41da$var$__exportStar((parcelRequire("iz3n1")), module.exports);

});
parcelRegister("iz3n1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebcryptoKey = void 0;

var $4EOoK = parcelRequire("4EOoK");

var $gWe7n = parcelRequire("gWe7n");

var $24DA2 = parcelRequire("24DA2");
class $d83e1c28351a485b$var$WebcryptoKey extends $gWe7n.JoseKey {
    // We need to override the static method generate from JoseKey because
    // the browser needs both the private and public keys
    static async generate(allowedAlgos = [
        'ES256'
    ], kid = crypto.randomUUID(), options) {
        const keyPair = await this.generateKeyPair(allowedAlgos, options);
        // Type safety only: in the browser, 'jose' always generates a CryptoKeyPair
        if (!(0, $24DA2.isCryptoKeyPair)(keyPair)) throw new TypeError('Invalid CryptoKeyPair');
        return this.fromKeypair(keyPair, kid);
    }
    static async fromKeypair(cryptoKeyPair, kid) {
        // https://datatracker.ietf.org/doc/html/rfc7517
        // > The "use" and "key_ops" JWK members SHOULD NOT be used together; [...]
        // > Applications should specify which of these members they use.
        const { key_ops: _, ...jwk } = await crypto.subtle.exportKey('jwk', cryptoKeyPair.privateKey.extractable ? cryptoKeyPair.privateKey : cryptoKeyPair.publicKey);
        const use = jwk.use ?? 'sig';
        const alg = jwk.alg ?? (0, $24DA2.fromSubtleAlgorithm)(cryptoKeyPair.privateKey.algorithm);
        if (use !== 'sig') throw new TypeError('Unsupported JWK use');
        return new $d83e1c28351a485b$var$WebcryptoKey($4EOoK.jwkSchema.parse({
            ...jwk,
            use: use,
            kid: kid,
            alg: alg
        }), cryptoKeyPair);
    }
    constructor(jwk, cryptoKeyPair){
        super(jwk);
        Object.defineProperty(this, "cryptoKeyPair", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: cryptoKeyPair
        });
    }
    get isPrivate() {
        return true;
    }
    get privateJwk() {
        if (super.isPrivate) return this.jwk;
        throw new Error('Private Webcrypto Key not exportable');
    }
    async getKey() {
        return this.cryptoKeyPair.privateKey;
    }
}
module.exports.WebcryptoKey = $d83e1c28351a485b$var$WebcryptoKey;

});
parcelRegister("4EOoK", function(module, exports) {
"use strict";
var $3641fde537da1b69$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3641fde537da1b69$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3641fde537da1b69$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3641fde537da1b69$var$__exportStar((parcelRequire("cTCpq")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("32upx")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("apYKl")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("5C5JC")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("3crJS")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("1vWbg")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("9mG6e")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("32AL6")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("5gaBM")), module.exports);

$3641fde537da1b69$var$__exportStar((parcelRequire("6M5ug")), module.exports);

});
parcelRegister("cTCpq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jwkAlgorithms = void 0;

var $32upx = parcelRequire("32upx");
// Copy variable to prevent bundlers from automatically polyfilling "process" (e.g. parcel)
const { process: $96386a570b6a8e50$var$process } = globalThis;
const $96386a570b6a8e50$var$IS_NODE_RUNTIME = typeof $96386a570b6a8e50$var$process !== 'undefined' && typeof $96386a570b6a8e50$var$process?.versions?.node === 'string';
function* $96386a570b6a8e50$var$jwkAlgorithms(jwk) {
    // Ed25519, Ed448, and secp256k1 always have "alg"
    // OKP always has "use"
    if (jwk.alg) {
        yield jwk.alg;
        return;
    }
    switch(jwk.kty){
        case 'EC':
            if (jwk.use === 'enc' || jwk.use === undefined) {
                yield 'ECDH-ES';
                yield 'ECDH-ES+A128KW';
                yield 'ECDH-ES+A192KW';
                yield 'ECDH-ES+A256KW';
            }
            if (jwk.use === 'sig' || jwk.use === undefined) {
                const crv = 'crv' in jwk ? jwk.crv : undefined;
                switch(crv){
                    case 'P-256':
                    case 'P-384':
                        yield `ES${crv.slice(-3)}`;
                        break;
                    case 'P-521':
                        yield 'ES512';
                        break;
                    case 'secp256k1':
                        if ($96386a570b6a8e50$var$IS_NODE_RUNTIME) yield 'ES256K';
                        break;
                    default:
                        throw new $32upx.JwkError(`Unsupported crv "${crv}"`);
                }
            }
            return;
        case 'OKP':
            if (!jwk.use) throw new $32upx.JwkError('Missing "use" Parameter value');
            yield 'ECDH-ES';
            yield 'ECDH-ES+A128KW';
            yield 'ECDH-ES+A192KW';
            yield 'ECDH-ES+A256KW';
            return;
        case 'RSA':
            if (jwk.use === 'enc' || jwk.use === undefined) {
                yield 'RSA-OAEP';
                yield 'RSA-OAEP-256';
                yield 'RSA-OAEP-384';
                yield 'RSA-OAEP-512';
                if ($96386a570b6a8e50$var$IS_NODE_RUNTIME) yield 'RSA1_5';
            }
            if (jwk.use === 'sig' || jwk.use === undefined) {
                yield 'PS256';
                yield 'PS384';
                yield 'PS512';
                yield 'RS256';
                yield 'RS384';
                yield 'RS512';
            }
            return;
        case 'oct':
            if (jwk.use === 'enc' || jwk.use === undefined) {
                yield 'A128GCMKW';
                yield 'A192GCMKW';
                yield 'A256GCMKW';
                yield 'A128KW';
                yield 'A192KW';
                yield 'A256KW';
            }
            if (jwk.use === 'sig' || jwk.use === undefined) {
                yield 'HS256';
                yield 'HS384';
                yield 'HS512';
            }
            return;
        default:
            throw new $32upx.JwkError(`Unsupported kty "${jwk.kty}"`);
    }
}
module.exports.jwkAlgorithms = $96386a570b6a8e50$var$jwkAlgorithms;

});
parcelRegister("32upx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JwtVerifyError = module.exports.JwtCreateError = module.exports.JwkError = module.exports.ERR_JWT_VERIFY = module.exports.ERR_JWT_CREATE = module.exports.ERR_JWT_INVALID = module.exports.ERR_JWK_NOT_FOUND = module.exports.ERR_JWK_INVALID = module.exports.ERR_JWKS_NO_MATCHING_KEY = void 0;
module.exports.ERR_JWKS_NO_MATCHING_KEY = 'ERR_JWKS_NO_MATCHING_KEY';
module.exports.ERR_JWK_INVALID = 'ERR_JWK_INVALID';
module.exports.ERR_JWK_NOT_FOUND = 'ERR_JWK_NOT_FOUND';
module.exports.ERR_JWT_INVALID = 'ERR_JWT_INVALID';
module.exports.ERR_JWT_CREATE = 'ERR_JWT_CREATE';
module.exports.ERR_JWT_VERIFY = 'ERR_JWT_VERIFY';
class $236925f78d1b8093$var$JwkError extends TypeError {
    constructor(message = 'JWK error', code = module.exports.ERR_JWK_INVALID, options){
        super(message, options);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: code
        });
    }
}
module.exports.JwkError = $236925f78d1b8093$var$JwkError;
class $236925f78d1b8093$var$JwtCreateError extends Error {
    constructor(message = 'Unable to create JWT', code = module.exports.ERR_JWT_CREATE, options){
        super(message, options);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: code
        });
    }
    static from(cause, code, message) {
        if (cause instanceof $236925f78d1b8093$var$JwtCreateError) return cause;
        if (cause instanceof $236925f78d1b8093$var$JwkError) return new $236925f78d1b8093$var$JwtCreateError(message, cause.code, {
            cause: cause
        });
        return new $236925f78d1b8093$var$JwtCreateError(message, code, {
            cause: cause
        });
    }
}
module.exports.JwtCreateError = $236925f78d1b8093$var$JwtCreateError;
class $236925f78d1b8093$var$JwtVerifyError extends Error {
    constructor(message = 'Invalid JWT', code = module.exports.ERR_JWT_VERIFY, options){
        super(message, options);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: code
        });
    }
    static from(cause, code, message) {
        if (cause instanceof $236925f78d1b8093$var$JwtVerifyError) return cause;
        if (cause instanceof $236925f78d1b8093$var$JwkError) return new $236925f78d1b8093$var$JwtVerifyError(message, cause.code, {
            cause: cause
        });
        return new $236925f78d1b8093$var$JwtVerifyError(message, code, {
            cause: cause
        });
    }
}
module.exports.JwtVerifyError = $236925f78d1b8093$var$JwtVerifyError;

});


parcelRegister("apYKl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jwkPubSchema = module.exports.jwkValidator = module.exports.jwkSchema = module.exports.jwkUnknownKeySchema = module.exports.jwkSymKeySchema = module.exports.jwkOkpKeySchema = module.exports.jwkEcSecp256k1KeySchema = module.exports.jwkEcKeySchema = module.exports.jwkRsaKeySchema = module.exports.jwkBaseSchema = module.exports.keyUsageSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.keyUsageSchema = $2zDt6.z.enum([
    'sign',
    'verify',
    'encrypt',
    'decrypt',
    'wrapKey',
    'unwrapKey',
    'deriveKey',
    'deriveBits'
]);
/**
 * The "use" and "key_ops" JWK members SHOULD NOT be used together;
 * however, if both are used, the information they convey MUST be
 * consistent.  Applications should specify which of these members they
 * use, if either is to be used by the application.
 *
 * @todo Actually check that "use" and "key_ops" are consistent when both are present.
 * @see {@link https://datatracker.ietf.org/doc/html/rfc7517#section-4.3}
 */ module.exports.jwkBaseSchema = $2zDt6.z.object({
    kty: $2zDt6.z.string().min(1),
    alg: $2zDt6.z.string().min(1).optional(),
    kid: $2zDt6.z.string().min(1).optional(),
    ext: $2zDt6.z.boolean().optional(),
    use: $2zDt6.z.enum([
        'sig',
        'enc'
    ]).optional(),
    key_ops: $2zDt6.z.array(module.exports.keyUsageSchema).optional(),
    x5c: $2zDt6.z.array($2zDt6.z.string()).optional(),
    x5t: $2zDt6.z.string().min(1).optional(),
    'x5t#S256': $2zDt6.z.string().min(1).optional(),
    x5u: $2zDt6.z.string().url().optional()
});
/**
 * @todo: properly implement this
 */ module.exports.jwkRsaKeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.literal('RSA'),
    alg: $2zDt6.z.enum([
        'RS256',
        'RS384',
        'RS512',
        'PS256',
        'PS384',
        'PS512'
    ]).optional(),
    n: $2zDt6.z.string().min(1),
    e: $2zDt6.z.string().min(1),
    d: $2zDt6.z.string().min(1).optional(),
    p: $2zDt6.z.string().min(1).optional(),
    q: $2zDt6.z.string().min(1).optional(),
    dp: $2zDt6.z.string().min(1).optional(),
    dq: $2zDt6.z.string().min(1).optional(),
    qi: $2zDt6.z.string().min(1).optional(),
    oth: $2zDt6.z.array($2zDt6.z.object({
        r: $2zDt6.z.string().optional(),
        d: $2zDt6.z.string().optional(),
        t: $2zDt6.z.string().optional()
    })).nonempty().optional()
});
module.exports.jwkEcKeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.literal('EC'),
    alg: $2zDt6.z.enum([
        'ES256',
        'ES384',
        'ES512'
    ]).optional(),
    crv: $2zDt6.z.enum([
        'P-256',
        'P-384',
        'P-521'
    ]),
    x: $2zDt6.z.string().min(1),
    y: $2zDt6.z.string().min(1),
    d: $2zDt6.z.string().min(1).optional()
});
module.exports.jwkEcSecp256k1KeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.literal('EC'),
    alg: $2zDt6.z.enum([
        'ES256K'
    ]).optional(),
    crv: $2zDt6.z.enum([
        'secp256k1'
    ]),
    x: $2zDt6.z.string().min(1),
    y: $2zDt6.z.string().min(1),
    d: $2zDt6.z.string().min(1).optional()
});
module.exports.jwkOkpKeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.literal('OKP'),
    alg: $2zDt6.z.enum([
        'EdDSA'
    ]).optional(),
    crv: $2zDt6.z.enum([
        'Ed25519',
        'Ed448'
    ]),
    x: $2zDt6.z.string().min(1),
    d: $2zDt6.z.string().min(1).optional()
});
module.exports.jwkSymKeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.literal('oct'),
    alg: $2zDt6.z.enum([
        'HS256',
        'HS384',
        'HS512'
    ]).optional(),
    k: $2zDt6.z.string()
});
module.exports.jwkUnknownKeySchema = module.exports.jwkBaseSchema.extend({
    kty: $2zDt6.z.string().refine((v)=>v !== 'RSA' && v !== 'EC' && v !== 'OKP' && v !== 'oct')
});
module.exports.jwkSchema = $2zDt6.z.union([
    module.exports.jwkUnknownKeySchema,
    module.exports.jwkRsaKeySchema,
    module.exports.jwkEcKeySchema,
    module.exports.jwkEcSecp256k1KeySchema,
    module.exports.jwkOkpKeySchema,
    module.exports.jwkSymKeySchema
]);
module.exports.jwkValidator = module.exports.jwkSchema.refine((k)=>k.use != null || k.key_ops != null, 'use or key_ops required').refine((k)=>!k.use || !k.key_ops || k.key_ops.every((o)=>k.use === 'sig' ? o === 'sign' || o === 'verify' : o === 'encrypt' || o === 'decrypt'), 'use and key_ops must be consistent');
module.exports.jwkPubSchema = module.exports.jwkValidator.refine((k)=>k.kid != null, 'kid is required').refine((k)=>!('k' in k) && !('d' in k), 'private key not allowed');

});

parcelRegister("5C5JC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jwksPubSchema = module.exports.jwksSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $apYKl = parcelRequire("apYKl");
module.exports.jwksSchema = $2zDt6.z.object({
    keys: $2zDt6.z.array($apYKl.jwkSchema)
});
module.exports.jwksPubSchema = $2zDt6.z.object({
    keys: $2zDt6.z.array($apYKl.jwkPubSchema)
});

});

parcelRegister("3crJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unsafeDecodeJwt = void 0;

var $32upx = parcelRequire("32upx");

var $9mG6e = parcelRequire("9mG6e");

var $6M5ug = parcelRequire("6M5ug");
function $2548027a7e677e98$var$unsafeDecodeJwt(jwt) {
    const { 0: headerEnc, 1: payloadEnc, length: length } = jwt.split('.');
    if (length > 3 || length < 2) throw new $32upx.JwtVerifyError(undefined, $32upx.ERR_JWT_INVALID);
    const header = $9mG6e.jwtHeaderSchema.parse((0, $6M5ug.parseB64uJson)(headerEnc));
    if (length === 2 && header?.alg !== 'none') throw new $32upx.JwtVerifyError(undefined, $32upx.ERR_JWT_INVALID);
    const payload = $9mG6e.jwtPayloadSchema.parse((0, $6M5ug.parseB64uJson)(payloadEnc));
    return {
        header: header,
        payload: payload
    };
}
module.exports.unsafeDecodeJwt = $2548027a7e677e98$var$unsafeDecodeJwt;

});
parcelRegister("9mG6e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jwtPayloadSchema = module.exports.jwtHeaderSchema = module.exports.isUnsignedJwt = module.exports.unsignedJwtSchema = module.exports.isSignedJwt = module.exports.signedJwtSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $apYKl = parcelRequire("apYKl");

var $6M5ug = parcelRequire("6M5ug");
module.exports.signedJwtSchema = $2zDt6.z.string().superRefine($6M5ug.jwtCharsRefinement).superRefine((0, $6M5ug.segmentedStringRefinementFactory)(3));
const $6d16d339d26710f4$var$isSignedJwt = (data)=>module.exports.signedJwtSchema.safeParse(data).success;
module.exports.isSignedJwt = $6d16d339d26710f4$var$isSignedJwt;
module.exports.unsignedJwtSchema = $2zDt6.z.string().superRefine($6M5ug.jwtCharsRefinement).superRefine((0, $6M5ug.segmentedStringRefinementFactory)(2));
const $6d16d339d26710f4$var$isUnsignedJwt = (data)=>module.exports.unsignedJwtSchema.safeParse(data).success;
module.exports.isUnsignedJwt = $6d16d339d26710f4$var$isUnsignedJwt;
/**
 * @see {@link https://www.rfc-editor.org/rfc/rfc7515.html#section-4}
 */ module.exports.jwtHeaderSchema = $2zDt6.z.object({
    /** "alg" (Algorithm) Header Parameter */ alg: $2zDt6.z.string(),
    /** "jku" (JWK Set URL) Header Parameter */ jku: $2zDt6.z.string().url().optional(),
    /** "jwk" (JSON Web Key) Header Parameter */ jwk: $2zDt6.z.object({
        kty: $2zDt6.z.string(),
        crv: $2zDt6.z.string().optional(),
        x: $2zDt6.z.string().optional(),
        y: $2zDt6.z.string().optional(),
        e: $2zDt6.z.string().optional(),
        n: $2zDt6.z.string().optional()
    }).optional(),
    /** "kid" (Key ID) Header Parameter */ kid: $2zDt6.z.string().optional(),
    /** "x5u" (X.509 URL) Header Parameter */ x5u: $2zDt6.z.string().optional(),
    /** "x5c" (X.509 Certificate Chain) Header Parameter */ x5c: $2zDt6.z.array($2zDt6.z.string()).optional(),
    /** "x5t" (X.509 Certificate SHA-1 Thumbprint) Header Parameter */ x5t: $2zDt6.z.string().optional(),
    /** "x5t#S256" (X.509 Certificate SHA-256 Thumbprint) Header Parameter */ 'x5t#S256': $2zDt6.z.string().optional(),
    /** "typ" (Type) Header Parameter */ typ: $2zDt6.z.string().optional(),
    /** "cty" (Content Type) Header Parameter */ cty: $2zDt6.z.string().optional(),
    /** "crit" (Critical) Header Parameter */ crit: $2zDt6.z.array($2zDt6.z.string()).optional()
});
// https://www.iana.org/assignments/jwt/jwt.xhtml
module.exports.jwtPayloadSchema = $2zDt6.z.object({
    iss: $2zDt6.z.string().optional(),
    aud: $2zDt6.z.union([
        $2zDt6.z.string(),
        $2zDt6.z.array($2zDt6.z.string()).nonempty()
    ]).optional(),
    sub: $2zDt6.z.string().optional(),
    exp: $2zDt6.z.number().int().optional(),
    nbf: $2zDt6.z.number().int().optional(),
    iat: $2zDt6.z.number().int().optional(),
    jti: $2zDt6.z.string().optional(),
    htm: $2zDt6.z.string().optional(),
    htu: $2zDt6.z.string().optional(),
    ath: $2zDt6.z.string().optional(),
    acr: $2zDt6.z.string().optional(),
    azp: $2zDt6.z.string().optional(),
    amr: $2zDt6.z.array($2zDt6.z.string()).optional(),
    // https://datatracker.ietf.org/doc/html/rfc7800
    cnf: $2zDt6.z.object({
        kid: $2zDt6.z.string().optional(),
        jwk: $apYKl.jwkPubSchema.optional(),
        jwe: $2zDt6.z.string().optional(),
        jku: $2zDt6.z.string().url().optional(),
        // https://datatracker.ietf.org/doc/html/rfc9449#section-6.1
        jkt: $2zDt6.z.string().optional(),
        // https://datatracker.ietf.org/doc/html/rfc8705
        'x5t#S256': $2zDt6.z.string().optional(),
        // https://datatracker.ietf.org/doc/html/rfc9203
        osc: $2zDt6.z.string().optional()
    }).optional(),
    client_id: $2zDt6.z.string().optional(),
    scope: $2zDt6.z.string().optional(),
    nonce: $2zDt6.z.string().optional(),
    at_hash: $2zDt6.z.string().optional(),
    c_hash: $2zDt6.z.string().optional(),
    s_hash: $2zDt6.z.string().optional(),
    auth_time: $2zDt6.z.number().int().optional(),
    // https://openid.net/specs/openid-connect-core-1_0.html#StandardClaims
    // OpenID: "profile" scope
    name: $2zDt6.z.string().optional(),
    family_name: $2zDt6.z.string().optional(),
    given_name: $2zDt6.z.string().optional(),
    middle_name: $2zDt6.z.string().optional(),
    nickname: $2zDt6.z.string().optional(),
    preferred_username: $2zDt6.z.string().optional(),
    gender: $2zDt6.z.string().optional(),
    picture: $2zDt6.z.string().url().optional(),
    profile: $2zDt6.z.string().url().optional(),
    website: $2zDt6.z.string().url().optional(),
    birthdate: $2zDt6.z.string().regex(/\d{4}-\d{2}-\d{2}/) // YYYY-MM-DD
    .optional(),
    zoneinfo: $2zDt6.z.string().regex(/^[A-Za-z0-9_/]+$/).optional(),
    locale: $2zDt6.z.string().regex(/^[a-z]{2}(-[A-Z]{2})?$/).optional(),
    updated_at: $2zDt6.z.number().int().optional(),
    // OpenID: "email" scope
    email: $2zDt6.z.string().optional(),
    email_verified: $2zDt6.z.boolean().optional(),
    // OpenID: "phone" scope
    phone_number: $2zDt6.z.string().optional(),
    phone_number_verified: $2zDt6.z.boolean().optional(),
    // OpenID: "address" scope
    // https://openid.net/specs/openid-connect-core-1_0.html#AddressClaim
    address: $2zDt6.z.object({
        formatted: $2zDt6.z.string().optional(),
        street_address: $2zDt6.z.string().optional(),
        locality: $2zDt6.z.string().optional(),
        region: $2zDt6.z.string().optional(),
        postal_code: $2zDt6.z.string().optional(),
        country: $2zDt6.z.string().optional()
    }).optional(),
    // https://datatracker.ietf.org/doc/html/rfc9396#section-14.2
    authorization_details: $2zDt6.z.array($2zDt6.z.object({
        type: $2zDt6.z.string(),
        // https://datatracker.ietf.org/doc/html/rfc9396#section-2.2
        locations: $2zDt6.z.array($2zDt6.z.string()).optional(),
        actions: $2zDt6.z.array($2zDt6.z.string()).optional(),
        datatypes: $2zDt6.z.array($2zDt6.z.string()).optional(),
        identifier: $2zDt6.z.string().optional(),
        privileges: $2zDt6.z.array($2zDt6.z.string()).optional()
    }).passthrough()).optional()
});

});
parcelRegister("6M5ug", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.segmentedStringRefinementFactory = module.exports.jwtCharsRefinement = module.exports.parseB64uJson = module.exports.cachedGetter = module.exports.matchesAny = module.exports.preferredOrderCmp = module.exports.isDefined = void 0;

var $j3YM6 = parcelRequire("j3YM6");

var $2zDt6 = parcelRequire("2zDt6");
const $4eeb7b6a289d901e$var$isDefined = (i)=>i !== undefined;
module.exports.isDefined = $4eeb7b6a289d901e$var$isDefined;
const $4eeb7b6a289d901e$var$preferredOrderCmp = (order)=>(a, b)=>{
        const aIdx = order.indexOf(a);
        const bIdx = order.indexOf(b);
        if (aIdx === bIdx) return 0;
        if (aIdx === -1) return 1;
        if (bIdx === -1) return -1;
        return aIdx - bIdx;
    };
module.exports.preferredOrderCmp = $4eeb7b6a289d901e$var$preferredOrderCmp;
function $4eeb7b6a289d901e$var$matchesAny(value) {
    return value == null ? (v)=>true : Array.isArray(value) ? (v)=>value.includes(v) : (v)=>v === value;
}
module.exports.matchesAny = $4eeb7b6a289d901e$var$matchesAny;
/**
 * Decorator to cache the result of a getter on a class instance.
 */ const $4eeb7b6a289d901e$var$cachedGetter = (target, _context)=>{
    return function() {
        const value = target.call(this);
        Object.defineProperty(this, target.name, {
            get: ()=>value,
            enumerable: true,
            configurable: true
        });
        return value;
    };
};
module.exports.cachedGetter = $4eeb7b6a289d901e$var$cachedGetter;
const $4eeb7b6a289d901e$var$decoder = new TextDecoder();
function $4eeb7b6a289d901e$var$parseB64uJson(input) {
    const inputBytes = $j3YM6.base64url.baseDecode(input);
    const json = $4eeb7b6a289d901e$var$decoder.decode(inputBytes);
    return JSON.parse(json);
}
module.exports.parseB64uJson = $4eeb7b6a289d901e$var$parseB64uJson;
/**
 * @example
 * ```ts
 * // jwtSchema will only allow base64url chars & "." (dot)
 * const jwtSchema = z.string().superRefine(jwtCharsRefinement)
 * ```
 */ const $4eeb7b6a289d901e$var$jwtCharsRefinement = (data, ctx)=>{
    // Note: this is a hot path, let's avoid using a RegExp
    let char;
    for(let i = 0; i < data.length; i++){
        char = data.charCodeAt(i);
        if (// Base64 URL encoding (most frequent)
        65 <= char && char <= 90 || // A-Z
        97 <= char && char <= 122 || // a-z
        48 <= char && char <= 57 || // 0-9
        char === 45 || // -
        char === 95 || // _
        // Boundary (least frequent, check last)
        char === 46 // .
        ) ;
        else {
            // Invalid char might be a surrogate pair
            const invalidChar = String.fromCodePoint(data.codePointAt(i));
            return ctx.addIssue({
                code: $2zDt6.ZodIssueCode.custom,
                message: `Invalid character "${invalidChar}" in JWT at position ${i}`
            });
        }
    }
};
module.exports.jwtCharsRefinement = $4eeb7b6a289d901e$var$jwtCharsRefinement;
/**
 * @example
 * ```ts
 * const jwtSchema = z.string().superRefine(segmentedStringRefinementFactory(3))
 * type Jwt = z.infer<typeof jwtSchema> // `${string}.${string}.${string}`
 * ```
 */ const $4eeb7b6a289d901e$var$segmentedStringRefinementFactory = (count, minPartLength = 2)=>{
    if (!Number.isFinite(count) || count < 1 || (count | 0) !== count) throw new TypeError(`Count must be a natural number (got ${count})`);
    const minTotalLength = count * minPartLength + (count - 1);
    const errorPrefix = `Invalid JWT format`;
    return (data, ctx)=>{
        if (data.length < minTotalLength) {
            ctx.addIssue({
                code: $2zDt6.ZodIssueCode.custom,
                message: `${errorPrefix}: too short`
            });
            return false;
        }
        let currentStart = 0;
        for(let i = 0; i < count - 1; i++){
            const nextDot = data.indexOf('.', currentStart);
            if (nextDot === -1) {
                ctx.addIssue({
                    code: $2zDt6.ZodIssueCode.custom,
                    message: `${errorPrefix}: expected ${count} segments, got ${i + 1}`
                });
                return false;
            }
            if (nextDot - currentStart < minPartLength) {
                ctx.addIssue({
                    code: $2zDt6.ZodIssueCode.custom,
                    message: `${errorPrefix}: segment ${i + 1} is too short`
                });
                return false;
            }
            currentStart = nextDot + 1;
        }
        if (data.indexOf('.', currentStart) !== -1) {
            ctx.addIssue({
                code: $2zDt6.ZodIssueCode.custom,
                message: `${errorPrefix}: too many segments`
            });
            return false;
        }
        if (data.length - currentStart < minPartLength) {
            ctx.addIssue({
                code: $2zDt6.ZodIssueCode.custom,
                message: `${errorPrefix}: last segment is too short`
            });
            return false;
        }
        return true;
    };
};
module.exports.segmentedStringRefinementFactory = $4eeb7b6a289d901e$var$segmentedStringRefinementFactory;

});



parcelRegister("1vWbg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("32AL6", function(module, exports) {
"use strict";
var $236e12839ef7900f$var$__runInitializers = module.exports && module.exports.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $236e12839ef7900f$var$__esDecorate = module.exports && module.exports.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Key = void 0;

var $cTCpq = parcelRequire("cTCpq");

var $32upx = parcelRequire("32upx");

var $apYKl = parcelRequire("apYKl");

var $6M5ug = parcelRequire("6M5ug");
let $236e12839ef7900f$var$Key = (()=>{
    var _a;
    let _instanceExtraInitializers = [];
    let _get_publicJwk_decorators;
    let _get_bareJwk_decorators;
    let _get_algorithms_decorators;
    return _a = class Key {
        constructor(jwk){
            Object.defineProperty(this, "jwk", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($236e12839ef7900f$var$__runInitializers(this, _instanceExtraInitializers), jwk)
            });
            // A key should always be used either for signing or encryption.
            if (!jwk.use) throw new $32upx.JwkError('Missing "use" Parameter value');
        }
        get isPrivate() {
            const { jwk: jwk } = this;
            if ('d' in jwk && jwk.d !== undefined) return true;
            if ('k' in jwk && jwk.k !== undefined) return true;
            return false;
        }
        get isSymetric() {
            const { jwk: jwk } = this;
            if ('k' in jwk && jwk.k !== undefined) return true;
            return false;
        }
        get privateJwk() {
            return this.isPrivate ? this.jwk : undefined;
        }
        get publicJwk() {
            if (this.isSymetric) return undefined;
            if (this.isPrivate) {
                const { d: _, ...jwk } = this.jwk;
                return jwk;
            }
            return this.jwk;
        }
        get bareJwk() {
            if (this.isSymetric) return undefined;
            const { kty: kty, crv: crv, e: e, n: n, x: x, y: y } = this.jwk;
            return $apYKl.jwkSchema.parse({
                crv: crv,
                e: e,
                kty: kty,
                n: n,
                x: x,
                y: y
            });
        }
        get use() {
            return this.jwk.use;
        }
        /**
             * The (forced) algorithm to use. If not provided, the key will be usable with
             * any of the algorithms in {@link algorithms}.
             *
             * @see {@link https://datatracker.ietf.org/doc/html/rfc7518#section-3.1 | "alg" (Algorithm) Header Parameter Values for JWS}
             */ get alg() {
            return this.jwk.alg;
        }
        get kid() {
            return this.jwk.kid;
        }
        get crv() {
            return this.jwk.crv;
        }
        /**
             * All the algorithms that this key can be used with. If `alg` is provided,
             * this set will only contain that algorithm.
             */ get algorithms() {
            return Array.from((0, $cTCpq.jwkAlgorithms)(this.jwk));
        }
    }, (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _get_publicJwk_decorators = [
            $6M5ug.cachedGetter
        ];
        _get_bareJwk_decorators = [
            $6M5ug.cachedGetter
        ];
        _get_algorithms_decorators = [
            $6M5ug.cachedGetter
        ];
        $236e12839ef7900f$var$__esDecorate(_a, null, _get_publicJwk_decorators, {
            kind: "getter",
            name: "publicJwk",
            static: false,
            private: false,
            access: {
                has: (obj)=>"publicJwk" in obj,
                get: (obj)=>obj.publicJwk
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $236e12839ef7900f$var$__esDecorate(_a, null, _get_bareJwk_decorators, {
            kind: "getter",
            name: "bareJwk",
            static: false,
            private: false,
            access: {
                has: (obj)=>"bareJwk" in obj,
                get: (obj)=>obj.bareJwk
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $236e12839ef7900f$var$__esDecorate(_a, null, _get_algorithms_decorators, {
            kind: "getter",
            name: "algorithms",
            static: false,
            private: false,
            access: {
                has: (obj)=>"algorithms" in obj,
                get: (obj)=>obj.algorithms
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
module.exports.Key = $236e12839ef7900f$var$Key;

});

parcelRegister("5gaBM", function(module, exports) {
"use strict";
var $3d46acfa9f3c7959$var$__runInitializers = module.exports && module.exports.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $3d46acfa9f3c7959$var$__esDecorate = module.exports && module.exports.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Keyset = void 0;

var $32upx = parcelRequire("32upx");

var $3crJS = parcelRequire("3crJS");

var $6M5ug = parcelRequire("6M5ug");
const $3d46acfa9f3c7959$var$extractPrivateJwk = (key)=>key.privateJwk;
const $3d46acfa9f3c7959$var$extractPublicJwk = (key)=>key.publicJwk;
let $3d46acfa9f3c7959$var$Keyset = (()=>{
    var _a;
    let _instanceExtraInitializers = [];
    let _get_signAlgorithms_decorators;
    let _get_publicJwks_decorators;
    let _get_privateJwks_decorators;
    return _a = class Keyset {
        constructor(iterable, /**
             * The preferred algorithms to use when signing a JWT using this keyset.
             *
             * @see {@link https://datatracker.ietf.org/doc/html/rfc7518#section-3.1}
             */ preferredSigningAlgorithms = iterable instanceof _a ? [
            ...iterable.preferredSigningAlgorithms
        ] : [
            // Prefer elliptic curve algorithms
            'EdDSA',
            'ES256K',
            'ES256',
            // https://datatracker.ietf.org/doc/html/rfc7518#section-3.5
            'PS256',
            'PS384',
            'PS512',
            'HS256',
            'HS384',
            'HS512'
        ]){
            Object.defineProperty(this, "preferredSigningAlgorithms", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($3d46acfa9f3c7959$var$__runInitializers(this, _instanceExtraInitializers), preferredSigningAlgorithms)
            });
            Object.defineProperty(this, "keys", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            const keys = [];
            const kids = new Set();
            for (const key of iterable){
                if (!key) continue;
                keys.push(key);
                if (key.kid) {
                    if (kids.has(key.kid)) throw new $32upx.JwkError(`Duplicate key: ${key.kid}`);
                    else kids.add(key.kid);
                }
            }
            this.keys = Object.freeze(keys);
        }
        get size() {
            return this.keys.length;
        }
        get signAlgorithms() {
            const algorithms = new Set();
            for (const key of this){
                if (key.use !== 'sig') continue;
                for (const alg of key.algorithms)algorithms.add(alg);
            }
            return Object.freeze([
                ...algorithms
            ].sort((0, $6M5ug.preferredOrderCmp)(this.preferredSigningAlgorithms)));
        }
        get publicJwks() {
            return {
                keys: Array.from(this, $3d46acfa9f3c7959$var$extractPublicJwk).filter($6M5ug.isDefined)
            };
        }
        get privateJwks() {
            return {
                keys: Array.from(this, $3d46acfa9f3c7959$var$extractPrivateJwk).filter($6M5ug.isDefined)
            };
        }
        has(kid) {
            return this.keys.some((key)=>key.kid === kid);
        }
        get(search) {
            for (const key of this.list(search))return key;
            throw new $32upx.JwkError(`Key not found ${search.kid || search.alg || '<unknown>'}`, $32upx.ERR_JWK_NOT_FOUND);
        }
        *list(search) {
            // Optimization: Empty string or empty array will not match any key
            if (search.kid?.length === 0) return;
            if (search.alg?.length === 0) return;
            for (const key of this){
                if (search.use && key.use !== search.use) continue;
                if (Array.isArray(search.kid)) {
                    if (!key.kid || !search.kid.includes(key.kid)) continue;
                } else if (search.kid) {
                    if (key.kid !== search.kid) continue;
                }
                if (Array.isArray(search.alg)) {
                    if (!search.alg.some((a)=>key.algorithms.includes(a))) continue;
                } else if (typeof search.alg === 'string') {
                    if (!key.algorithms.includes(search.alg)) continue;
                }
                yield key;
            }
        }
        findKey({ kid: kid, alg: alg, use: use }) {
            const matchingKeys = [];
            for (const key of this.list({
                kid: kid,
                alg: alg,
                use: use
            })){
                // Not a signing key
                if (!key.isPrivate) continue;
                // Skip negotiation if a specific "alg" was provided
                if (typeof alg === 'string') return [
                    key,
                    alg
                ];
                matchingKeys.push(key);
            }
            const isAllowedAlg = (0, $6M5ug.matchesAny)(alg);
            const candidates = matchingKeys.map((key)=>[
                    key,
                    key.algorithms.filter(isAllowedAlg)
                ]);
            // Return the first candidates that matches the preferred algorithms
            for (const prefAlg of this.preferredSigningAlgorithms)for (const [matchingKey, matchingAlgs] of candidates){
                if (matchingAlgs.includes(prefAlg)) return [
                    matchingKey,
                    prefAlg
                ];
            }
            // Return any candidate
            for (const [matchingKey, matchingAlgs] of candidates){
                for (const alg of matchingAlgs)return [
                    matchingKey,
                    alg
                ];
            }
            throw new $32upx.JwkError(`No singing key found for ${kid || alg || use || '<unknown>'}`, $32upx.ERR_JWK_NOT_FOUND);
        }
        [(_get_signAlgorithms_decorators = [
            $6M5ug.cachedGetter
        ], _get_publicJwks_decorators = [
            $6M5ug.cachedGetter
        ], _get_privateJwks_decorators = [
            $6M5ug.cachedGetter
        ], Symbol.iterator)]() {
            return this.keys.values();
        }
        async createJwt({ alg: sAlg, kid: sKid, ...header }, payload) {
            try {
                const [key, alg] = this.findKey({
                    alg: sAlg,
                    kid: sKid,
                    use: 'sig'
                });
                const protectedHeader = {
                    ...header,
                    alg: alg,
                    kid: key.kid
                };
                if (typeof payload === 'function') payload = await payload(protectedHeader, key);
                return await key.createJwt(protectedHeader, payload);
            } catch (err) {
                throw $32upx.JwtCreateError.from(err);
            }
        }
        async verifyJwt(token, options) {
            const { header: header } = (0, $3crJS.unsafeDecodeJwt)(token);
            const { kid: kid, alg: alg } = header;
            const errors = [];
            for (const key of this.list({
                kid: kid,
                alg: alg
            }))try {
                const result = await key.verifyJwt(token, options);
                return {
                    ...result,
                    key: key
                };
            } catch (err) {
                errors.push(err);
            }
            switch(errors.length){
                case 0:
                    throw new $32upx.JwtVerifyError('No key matched', $32upx.ERR_JWKS_NO_MATCHING_KEY);
                case 1:
                    throw $32upx.JwtVerifyError.from(errors[0], $32upx.ERR_JWT_INVALID);
                default:
                    throw $32upx.JwtVerifyError.from(errors, $32upx.ERR_JWT_INVALID);
            }
        }
        toJSON() {
            // Make a copy to prevent mutation of the original keyset
            return structuredClone(this.publicJwks);
        }
    }, (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        $3d46acfa9f3c7959$var$__esDecorate(_a, null, _get_signAlgorithms_decorators, {
            kind: "getter",
            name: "signAlgorithms",
            static: false,
            private: false,
            access: {
                has: (obj)=>"signAlgorithms" in obj,
                get: (obj)=>obj.signAlgorithms
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $3d46acfa9f3c7959$var$__esDecorate(_a, null, _get_publicJwks_decorators, {
            kind: "getter",
            name: "publicJwks",
            static: false,
            private: false,
            access: {
                has: (obj)=>"publicJwks" in obj,
                get: (obj)=>obj.publicJwks
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $3d46acfa9f3c7959$var$__esDecorate(_a, null, _get_privateJwks_decorators, {
            kind: "getter",
            name: "privateJwks",
            static: false,
            private: false,
            access: {
                has: (obj)=>"privateJwks" in obj,
                get: (obj)=>obj.privateJwks
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
module.exports.Keyset = $3d46acfa9f3c7959$var$Keyset;

});


parcelRegister("gWe7n", function(module, exports) {
"use strict";
var $c54d03a50c745a72$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c54d03a50c745a72$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c54d03a50c745a72$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c54d03a50c745a72$var$__exportStar((parcelRequire("7diKV")), module.exports);

});
parcelRegister("7diKV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JoseKey = void 0;

var $4EOoK = parcelRequire("4EOoK");

var $7GXIC = parcelRequire("7GXIC");
var $dDGOp = parcelRequire("dDGOp");
var $lwVFZ = parcelRequire("lwVFZ");
var $icdnu = parcelRequire("icdnu");
var $tU6kV = parcelRequire("tU6kV");
var $hrT3a = parcelRequire("hrT3a");

var $4EOoK = parcelRequire("4EOoK");

var $akcrY = parcelRequire("akcrY");
const { JOSEError: $54084bcc5c0d4685$var$JOSEError } = $7GXIC;
class $54084bcc5c0d4685$var$JoseKey extends $4EOoK.Key {
    #keyObj;
    async getKey() {
        try {
            return this.#keyObj ||= await (0, $icdnu.importJWK)(this.jwk);
        } catch (cause) {
            throw new $4EOoK.JwkError('Failed to import JWK', undefined, {
                cause: cause
            });
        }
    }
    async createJwt(header, payload) {
        if (header.kid && header.kid !== this.kid) throw new $4EOoK.JwtCreateError(`Invalid "kid" (${header.kid}) used to sign with key "${this.kid}"`);
        if (!header.alg || !this.algorithms.includes(header.alg)) throw new $4EOoK.JwtCreateError(`Invalid "alg" (${header.alg}) used to sign with key "${this.kid}"`);
        const keyObj = await this.getKey();
        return new $hrT3a.SignJWT(payload).setProtectedHeader({
            ...header,
            kid: this.kid
        }).sign(keyObj);
    }
    async verifyJwt(token, options) {
        try {
            const keyObj = await this.getKey();
            const result = await (0, $tU6kV.jwtVerify)(token, keyObj, {
                ...options,
                algorithms: this.algorithms
            });
            return result;
        } catch (error) {
            if (error instanceof $54084bcc5c0d4685$var$JOSEError) throw new $4EOoK.JwtVerifyError(error.message, error.code, {
                cause: error
            });
            else throw $4EOoK.JwtVerifyError.from(error);
        }
    }
    static async generateKeyPair(allowedAlgos = [
        'ES256'
    ], options) {
        if (!allowedAlgos.length) throw new $4EOoK.JwkError('No algorithms provided for key generation');
        const errors = [];
        for (const alg of allowedAlgos)try {
            return await (0, $lwVFZ.generateKeyPair)(alg, options);
        } catch (err) {
            errors.push(err);
        }
        throw new $4EOoK.JwkError('Failed to generate key pair', undefined, {
            cause: new AggregateError(errors, 'None of the algorithms worked')
        });
    }
    static async generate(allowedAlgos = [
        'ES256'
    ], kid, options) {
        const kp = await this.generateKeyPair(allowedAlgos, {
            ...options,
            extractable: true
        });
        return this.fromImportable(kp.privateKey, kid);
    }
    static async fromImportable(input, kid) {
        if (typeof input === 'string') {
            // PKCS8
            if (input.startsWith('-----')) // The "alg" is only needed in WebCrypto (NodeJS will be fine)
            return this.fromPKCS8(input, '', kid);
            // Jwk (string)
            if (input.startsWith('{')) return this.fromJWK(input, kid);
            throw new $4EOoK.JwkError('Invalid input');
        }
        if (typeof input === 'object') {
            // Jwk
            if ('kty' in input || 'alg' in input) return this.fromJWK(input, kid);
            // KeyLike
            return this.fromKeyLike(input, kid);
        }
        throw new $4EOoK.JwkError('Invalid input');
    }
    /**
     * @see {@link exportJWK}
     */ static async fromKeyLike(keyLike, kid, alg) {
        const jwk = await (0, $dDGOp.exportJWK)(keyLike);
        if (alg) {
            if (!jwk.alg) jwk.alg = alg;
            else if (jwk.alg !== alg) throw new $4EOoK.JwkError('Invalid "alg" in JWK');
        }
        return this.fromJWK(jwk, kid);
    }
    /**
     * @see {@link importPKCS8}
     */ static async fromPKCS8(pem, alg, kid) {
        const keyLike = await (0, $icdnu.importPKCS8)(pem, alg, {
            extractable: true
        });
        return this.fromKeyLike(keyLike, kid);
    }
    static async fromJWK(input, inputKid) {
        const jwk = typeof input === 'string' ? JSON.parse(input) : input;
        if (!jwk || typeof jwk !== 'object') throw new $4EOoK.JwkError('Invalid JWK');
        const kid = (0, $akcrY.either)(jwk.kid, inputKid);
        const use = jwk.use || 'sig';
        return new $54084bcc5c0d4685$var$JoseKey($4EOoK.jwkValidator.parse({
            ...jwk,
            kid: kid,
            use: use
        }));
    }
}
module.exports.JoseKey = $54084bcc5c0d4685$var$JoseKey;

});
parcelRegister("7GXIC", function(module, exports) {

$parcel$export(module.exports, "JOSEError", () => $599ac781534a947a$export$f754d6850d76bf87);
$parcel$export(module.exports, "JWTClaimValidationFailed", () => $599ac781534a947a$export$f1e14efb908196e9);
$parcel$export(module.exports, "JWTExpired", () => $599ac781534a947a$export$4b386bf852b7863d);
$parcel$export(module.exports, "JOSEAlgNotAllowed", () => $599ac781534a947a$export$d51fd7fedeccc338);
$parcel$export(module.exports, "JOSENotSupported", () => $599ac781534a947a$export$19ddbcbf2016ab28);
$parcel$export(module.exports, "JWEDecryptionFailed", () => $599ac781534a947a$export$1a57512ad9773b2a);
$parcel$export(module.exports, "JWEInvalid", () => $599ac781534a947a$export$19f281f2275f6a15);
$parcel$export(module.exports, "JWSInvalid", () => $599ac781534a947a$export$e838de724af3d116);
$parcel$export(module.exports, "JWTInvalid", () => $599ac781534a947a$export$936b39ada0bbfceb);
$parcel$export(module.exports, "JWKInvalid", () => $599ac781534a947a$export$b3992e0f88fb07e3);
$parcel$export(module.exports, "JWKSInvalid", () => $599ac781534a947a$export$9b22c2a1e2403b8e);
$parcel$export(module.exports, "JWKSNoMatchingKey", () => $599ac781534a947a$export$3d5ed1a538bed04e);
$parcel$export(module.exports, "JWKSMultipleMatchingKeys", () => $599ac781534a947a$export$dc036de401a5c284);
$parcel$export(module.exports, "JWKSTimeout", () => $599ac781534a947a$export$3f30acebf25c04e6);
$parcel$export(module.exports, "JWSSignatureVerificationFailed", () => $599ac781534a947a$export$c67a0218e7c50378);
class $599ac781534a947a$export$f754d6850d76bf87 extends Error {
    constructor(message, options){
        super(message, options);
        this.code = 'ERR_JOSE_GENERIC';
        this.name = this.constructor.name;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
$599ac781534a947a$export$f754d6850d76bf87.code = 'ERR_JOSE_GENERIC';
class $599ac781534a947a$export$f1e14efb908196e9 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message, payload, claim = 'unspecified', reason = 'unspecified'){
        super(message, {
            cause: {
                claim: claim,
                reason: reason,
                payload: payload
            }
        });
        this.code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
$599ac781534a947a$export$f1e14efb908196e9.code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
class $599ac781534a947a$export$4b386bf852b7863d extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message, payload, claim = 'unspecified', reason = 'unspecified'){
        super(message, {
            cause: {
                claim: claim,
                reason: reason,
                payload: payload
            }
        });
        this.code = 'ERR_JWT_EXPIRED';
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
$599ac781534a947a$export$4b386bf852b7863d.code = 'ERR_JWT_EXPIRED';
class $599ac781534a947a$export$d51fd7fedeccc338 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JOSE_ALG_NOT_ALLOWED';
    }
}
$599ac781534a947a$export$d51fd7fedeccc338.code = 'ERR_JOSE_ALG_NOT_ALLOWED';
class $599ac781534a947a$export$19ddbcbf2016ab28 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JOSE_NOT_SUPPORTED';
    }
}
$599ac781534a947a$export$19ddbcbf2016ab28.code = 'ERR_JOSE_NOT_SUPPORTED';
class $599ac781534a947a$export$1a57512ad9773b2a extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message = 'decryption operation failed', options){
        super(message, options);
        this.code = 'ERR_JWE_DECRYPTION_FAILED';
    }
}
$599ac781534a947a$export$1a57512ad9773b2a.code = 'ERR_JWE_DECRYPTION_FAILED';
class $599ac781534a947a$export$19f281f2275f6a15 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWE_INVALID';
    }
}
$599ac781534a947a$export$19f281f2275f6a15.code = 'ERR_JWE_INVALID';
class $599ac781534a947a$export$e838de724af3d116 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWS_INVALID';
    }
}
$599ac781534a947a$export$e838de724af3d116.code = 'ERR_JWS_INVALID';
class $599ac781534a947a$export$936b39ada0bbfceb extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWT_INVALID';
    }
}
$599ac781534a947a$export$936b39ada0bbfceb.code = 'ERR_JWT_INVALID';
class $599ac781534a947a$export$b3992e0f88fb07e3 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWK_INVALID';
    }
}
$599ac781534a947a$export$b3992e0f88fb07e3.code = 'ERR_JWK_INVALID';
class $599ac781534a947a$export$9b22c2a1e2403b8e extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWKS_INVALID';
    }
}
$599ac781534a947a$export$9b22c2a1e2403b8e.code = 'ERR_JWKS_INVALID';
class $599ac781534a947a$export$3d5ed1a538bed04e extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message = 'no applicable key found in the JSON Web Key Set', options){
        super(message, options);
        this.code = 'ERR_JWKS_NO_MATCHING_KEY';
    }
}
$599ac781534a947a$export$3d5ed1a538bed04e.code = 'ERR_JWKS_NO_MATCHING_KEY';
class $599ac781534a947a$export$dc036de401a5c284 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message = 'multiple matching keys found in the JSON Web Key Set', options){
        super(message, options);
        this.code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
    }
}
Symbol.asyncIterator;
$599ac781534a947a$export$dc036de401a5c284.code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
class $599ac781534a947a$export$3f30acebf25c04e6 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message = 'request timed out', options){
        super(message, options);
        this.code = 'ERR_JWKS_TIMEOUT';
    }
}
$599ac781534a947a$export$3f30acebf25c04e6.code = 'ERR_JWKS_TIMEOUT';
class $599ac781534a947a$export$c67a0218e7c50378 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(message = 'signature verification failed', options){
        super(message, options);
        this.code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';
    }
}
$599ac781534a947a$export$c67a0218e7c50378.code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';

});

parcelRegister("dDGOp", function(module, exports) {

$parcel$export(module.exports, "exportJWK", () => $9ee02072b0883f32$export$ffb510cfd482ce82);

var $fPTdg = parcelRequire("fPTdg");

var $bLBy3 = parcelRequire("bLBy3");
async function $9ee02072b0883f32$export$7f687badbeed246d(key) {
    return (0, $fPTdg.toSPKI)(key);
}
async function $9ee02072b0883f32$export$ba4a7192ac1a47fe(key) {
    return (0, $fPTdg.toPKCS8)(key);
}
async function $9ee02072b0883f32$export$ffb510cfd482ce82(key) {
    return (0, $bLBy3.default)(key);
}

});
parcelRegister("fPTdg", function(module, exports) {

$parcel$export(module.exports, "toSPKI", () => $b876728f20516af6$export$cfba7e924fe414ca);
$parcel$export(module.exports, "toPKCS8", () => $b876728f20516af6$export$cac76a78a90b914d);
$parcel$export(module.exports, "fromPKCS8", () => $b876728f20516af6$export$224b0a6339c7267f);
$parcel$export(module.exports, "fromSPKI", () => $b876728f20516af6$export$f9a3505cdaa1fb3e);
$parcel$export(module.exports, "fromX509", () => $b876728f20516af6$export$ed788b6a8533858f);

var $5pzZh = parcelRequire("5pzZh");

var $31Bep = parcelRequire("31Bep");

var $7gBc4 = parcelRequire("7gBc4");

var $dJzoD = parcelRequire("dJzoD");

var $7GXIC = parcelRequire("7GXIC");

var $0UxFO = parcelRequire("0UxFO");
const $b876728f20516af6$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $5pzZh.isCryptoKey)(key)) throw new TypeError((0, $31Bep.default)(key, ...(0, $0UxFO.types)));
    if (!key.extractable) throw new TypeError('CryptoKey is not extractable');
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $dJzoD.default)((0, $7gBc4.encodeBase64)(new Uint8Array(await (0, $5pzZh.default).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $b876728f20516af6$export$cfba7e924fe414ca = (key)=>{
    return $b876728f20516af6$var$genericExport('public', 'spki', key);
};
const $b876728f20516af6$export$cac76a78a90b914d = (key)=>{
    return $b876728f20516af6$var$genericExport('private', 'pkcs8', key);
};
const $b876728f20516af6$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    const i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $b876728f20516af6$var$findOid(keyData, oid, i + 1);
};
const $b876728f20516af6$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $b876728f20516af6$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return 'P-256';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return 'P-384';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return 'P-521';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return 'X25519';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return 'X448';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return 'Ed25519';
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return 'Ed448';
        default:
            throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported EC Key Curve or OKP Key Sub Type');
    }
};
const $b876728f20516af6$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, '')).split('').map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === 'spki';
    switch(alg){
        case 'PS256':
        case 'PS384':
        case 'PS512':
            algorithm = {
                name: 'RSA-PSS',
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'RS256':
        case 'RS384':
        case 'RS512':
            algorithm = {
                name: 'RSASSA-PKCS1-v1_5',
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'RSA-OAEP':
        case 'RSA-OAEP-256':
        case 'RSA-OAEP-384':
        case 'RSA-OAEP-512':
            algorithm = {
                name: 'RSA-OAEP',
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                'encrypt',
                'wrapKey'
            ] : [
                'decrypt',
                'unwrapKey'
            ];
            break;
        case 'ES256':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-256'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'ES384':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-384'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'ES512':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-521'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'ECDH-ES':
        case 'ECDH-ES+A128KW':
        case 'ECDH-ES+A192KW':
        case 'ECDH-ES+A256KW':
            {
                const namedCurve = $b876728f20516af6$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith('P-') ? {
                    name: 'ECDH',
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    'deriveBits'
                ];
                break;
            }
        case 'Ed25519':
            algorithm = {
                name: 'Ed25519'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'EdDSA':
            algorithm = {
                name: $b876728f20516af6$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        default:
            throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, $5pzZh.default).subtle.importKey(keyFormat, keyData, algorithm, options?.extractable ?? false, keyUsages);
};
const $b876728f20516af6$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $b876728f20516af6$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, 'pkcs8', pem, alg, options);
};
const $b876728f20516af6$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $b876728f20516af6$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, 'spki', pem, alg, options);
};
function $b876728f20516af6$var$getElement(seq) {
    const result = [];
    let next = 0;
    while(next < seq.length){
        const nextPart = $b876728f20516af6$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $b876728f20516af6$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError('invalid indefinite form length');
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        const numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $b876728f20516af6$var$spkiFromX509(buf) {
    const tbsCertificate = $b876728f20516af6$var$getElement($b876728f20516af6$var$getElement($b876728f20516af6$var$parseElement(buf).contents)[0].contents);
    return (0, $7gBc4.encodeBase64)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $b876728f20516af6$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, '');
    const raw = (0, $7gBc4.decodeBase64)(pem);
    return (0, $dJzoD.default)($b876728f20516af6$var$spkiFromX509(raw), 'PUBLIC KEY');
}
const $b876728f20516af6$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $b876728f20516af6$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError('Failed to parse the X.509 certificate', {
            cause: cause
        });
    }
    return $b876728f20516af6$export$f9a3505cdaa1fb3e(spki, alg, options);
};

});
parcelRegister("5pzZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f0b33e7ccc65ae0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isCryptoKey", () => $3f0b33e7ccc65ae0$export$600b5603bbac4c6);
var $3f0b33e7ccc65ae0$export$2e2bcd8739ae039 = crypto;
const $3f0b33e7ccc65ae0$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;

});

parcelRegister("31Bep", function(module, exports) {

$parcel$export(module.exports, "default", () => $233e587bc0c17441$export$2e2bcd8739ae039);
$parcel$export(module.exports, "withAlg", () => $233e587bc0c17441$export$e94f758d09bc1828);
function $233e587bc0c17441$var$message(msg, actual, ...types) {
    types = types.filter(Boolean);
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(', ')}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === 'object' && actual != null) {
        if (actual.constructor?.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $233e587bc0c17441$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $233e587bc0c17441$var$message('Key must be ', actual, ...types);
};
function $233e587bc0c17441$export$e94f758d09bc1828(alg, actual, ...types) {
    return $233e587bc0c17441$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}

});

parcelRegister("7gBc4", function(module, exports) {

$parcel$export(module.exports, "encodeBase64", () => $54a6e0e463467b0a$export$8fb536984ec8b4d7);
$parcel$export(module.exports, "encode", () => $54a6e0e463467b0a$export$c564cdbbe6da493);
$parcel$export(module.exports, "decodeBase64", () => $54a6e0e463467b0a$export$94fdf11bafc8de6b);
$parcel$export(module.exports, "decode", () => $54a6e0e463467b0a$export$2f872c0f2117be69);

var $c2uWE = parcelRequire("c2uWE");
const $54a6e0e463467b0a$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === 'string') unencoded = (0, $c2uWE.encoder).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(''));
};
const $54a6e0e463467b0a$export$c564cdbbe6da493 = (input)=>{
    return $54a6e0e463467b0a$export$8fb536984ec8b4d7(input).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};
const $54a6e0e463467b0a$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $54a6e0e463467b0a$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $c2uWE.decoder).decode(encoded);
    encoded = encoded.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
    try {
        return $54a6e0e463467b0a$export$94fdf11bafc8de6b(encoded);
    } catch  {
        throw new TypeError('The input to be decoded is not correctly encoded.');
    }
};

});
parcelRegister("c2uWE", function(module, exports) {

$parcel$export(module.exports, "encoder", () => $8c3dacf85b96b392$export$5486af06137bf21a);
$parcel$export(module.exports, "decoder", () => $8c3dacf85b96b392$export$124c96e6ce37090b);
$parcel$export(module.exports, "concat", () => $8c3dacf85b96b392$export$ee1b3e54f0441b22);

var $6h3SS = parcelRequire("6h3SS");
const $8c3dacf85b96b392$export$5486af06137bf21a = new TextEncoder();
const $8c3dacf85b96b392$export$124c96e6ce37090b = new TextDecoder();
const $8c3dacf85b96b392$var$MAX_INT32 = 2 ** 32;
function $8c3dacf85b96b392$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    for (const buffer of buffers){
        buf.set(buffer, i);
        i += buffer.length;
    }
    return buf;
}
function $8c3dacf85b96b392$export$256d3ca12372f112(alg, p2sInput) {
    return $8c3dacf85b96b392$export$ee1b3e54f0441b22($8c3dacf85b96b392$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $8c3dacf85b96b392$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $8c3dacf85b96b392$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$8c3dacf85b96b392$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $8c3dacf85b96b392$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $8c3dacf85b96b392$var$MAX_INT32);
    const low = value % $8c3dacf85b96b392$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, high, 0);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $8c3dacf85b96b392$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, value);
    return buf;
}
function $8c3dacf85b96b392$export$c1498c4a3718d967(input) {
    return $8c3dacf85b96b392$export$ee1b3e54f0441b22($8c3dacf85b96b392$export$74c16dba6c885532(input.length), input);
}
async function $8c3dacf85b96b392$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($8c3dacf85b96b392$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $6h3SS.default)('sha256', buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}

});
parcelRegister("6h3SS", function(module, exports) {

$parcel$export(module.exports, "default", () => $491757e359519ceb$export$2e2bcd8739ae039);

var $5pzZh = parcelRequire("5pzZh");
const $491757e359519ceb$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $5pzZh.default).subtle.digest(subtleDigest, data));
};
var $491757e359519ceb$export$2e2bcd8739ae039 = $491757e359519ceb$var$digest;

});



parcelRegister("dJzoD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ffaef5451229e15$export$2e2bcd8739ae039);
var $9ffaef5451229e15$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join('\n');
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};

});

parcelRegister("0UxFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $002bdc4a0215a55c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "types", () => $002bdc4a0215a55c$export$b14ad400b1d09e0f);

var $5pzZh = parcelRequire("5pzZh");
var $002bdc4a0215a55c$export$2e2bcd8739ae039 = (key)=>{
    if ((0, $5pzZh.isCryptoKey)(key)) return true;
    return key?.[Symbol.toStringTag] === 'KeyObject';
};
const $002bdc4a0215a55c$export$b14ad400b1d09e0f = [
    'CryptoKey'
];

});


parcelRegister("bLBy3", function(module, exports) {

$parcel$export(module.exports, "default", () => $891135ce5ed081a3$export$2e2bcd8739ae039);

var $5pzZh = parcelRequire("5pzZh");

var $31Bep = parcelRequire("31Bep");

var $7gBc4 = parcelRequire("7gBc4");

var $0UxFO = parcelRequire("0UxFO");
const $891135ce5ed081a3$var$keyToJWK = async (key)=>{
    if (key instanceof Uint8Array) return {
        kty: 'oct',
        k: (0, $7gBc4.encode)(key)
    };
    if (!(0, $5pzZh.isCryptoKey)(key)) throw new TypeError((0, $31Bep.default)(key, ...(0, $0UxFO.types), 'Uint8Array'));
    if (!key.extractable) throw new TypeError('non-extractable CryptoKey cannot be exported as a JWK');
    const { ext: ext, key_ops: key_ops, alg: alg, use: use, ...jwk } = await (0, $5pzZh.default).subtle.exportKey('jwk', key);
    return jwk;
};
var $891135ce5ed081a3$export$2e2bcd8739ae039 = $891135ce5ed081a3$var$keyToJWK;

});


parcelRegister("lwVFZ", function(module, exports) {

$parcel$export(module.exports, "generateKeyPair", () => $fac953757d12c296$export$a949d36eab55b41f);

var $3qqU2 = parcelRequire("3qqU2");
async function $fac953757d12c296$export$a949d36eab55b41f(alg, options) {
    return (0, $3qqU2.generateKeyPair)(alg, options);
}

});
parcelRegister("3qqU2", function(module, exports) {

$parcel$export(module.exports, "generateKeyPair", () => $27e8ab24924f68d3$export$a949d36eab55b41f);

var $5pzZh = parcelRequire("5pzZh");

var $7GXIC = parcelRequire("7GXIC");

var $eVkwU = parcelRequire("eVkwU");
async function $27e8ab24924f68d3$export$25395fe8d170ad7(alg, options) {
    let length;
    let algorithm;
    let keyUsages;
    switch(alg){
        case 'HS256':
        case 'HS384':
        case 'HS512':
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
                name: 'HMAC',
                hash: `SHA-${length}`,
                length: length
            };
            keyUsages = [
                'sign',
                'verify'
            ];
            break;
        case 'A128CBC-HS256':
        case 'A192CBC-HS384':
        case 'A256CBC-HS512':
            length = parseInt(alg.slice(-3), 10);
            return (0, $eVkwU.default)(new Uint8Array(length >> 3));
        case 'A128KW':
        case 'A192KW':
        case 'A256KW':
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: 'AES-KW',
                length: length
            };
            keyUsages = [
                'wrapKey',
                'unwrapKey'
            ];
            break;
        case 'A128GCMKW':
        case 'A192GCMKW':
        case 'A256GCMKW':
        case 'A128GCM':
        case 'A192GCM':
        case 'A256GCM':
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: 'AES-GCM',
                length: length
            };
            keyUsages = [
                'encrypt',
                'decrypt'
            ];
            break;
        default:
            throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $5pzZh.default).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}
function $27e8ab24924f68d3$var$getModulusLengthOption(options) {
    const modulusLength = options?.modulusLength ?? 2048;
    if (typeof modulusLength !== 'number' || modulusLength < 2048) throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used');
    return modulusLength;
}
async function $27e8ab24924f68d3$export$a949d36eab55b41f(alg, options) {
    let algorithm;
    let keyUsages;
    switch(alg){
        case 'PS256':
        case 'PS384':
        case 'PS512':
            algorithm = {
                name: 'RSA-PSS',
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $27e8ab24924f68d3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                'sign',
                'verify'
            ];
            break;
        case 'RS256':
        case 'RS384':
        case 'RS512':
            algorithm = {
                name: 'RSASSA-PKCS1-v1_5',
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $27e8ab24924f68d3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                'sign',
                'verify'
            ];
            break;
        case 'RSA-OAEP':
        case 'RSA-OAEP-256':
        case 'RSA-OAEP-384':
        case 'RSA-OAEP-512':
            algorithm = {
                name: 'RSA-OAEP',
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $27e8ab24924f68d3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                'decrypt',
                'unwrapKey',
                'encrypt',
                'wrapKey'
            ];
            break;
        case 'ES256':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-256'
            };
            keyUsages = [
                'sign',
                'verify'
            ];
            break;
        case 'ES384':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-384'
            };
            keyUsages = [
                'sign',
                'verify'
            ];
            break;
        case 'ES512':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-521'
            };
            keyUsages = [
                'sign',
                'verify'
            ];
            break;
        case 'Ed25519':
            algorithm = {
                name: 'Ed25519'
            };
            keyUsages = [
                'sign',
                'verify'
            ];
            break;
        case 'EdDSA':
            {
                keyUsages = [
                    'sign',
                    'verify'
                ];
                const crv = options?.crv ?? 'Ed25519';
                switch(crv){
                    case 'Ed25519':
                    case 'Ed448':
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported crv option provided');
                }
                break;
            }
        case 'ECDH-ES':
        case 'ECDH-ES+A128KW':
        case 'ECDH-ES+A192KW':
        case 'ECDH-ES+A256KW':
            {
                keyUsages = [
                    'deriveKey',
                    'deriveBits'
                ];
                const crv = options?.crv ?? 'P-256';
                switch(crv){
                    case 'P-256':
                    case 'P-384':
                    case 'P-521':
                        algorithm = {
                            name: 'ECDH',
                            namedCurve: crv
                        };
                        break;
                    case 'X25519':
                    case 'X448':
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448');
                }
                break;
            }
        default:
            throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $5pzZh.default).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}

});
parcelRegister("eVkwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $add6505a95ba3e92$export$2e2bcd8739ae039);

var $5pzZh = parcelRequire("5pzZh");
var $add6505a95ba3e92$export$2e2bcd8739ae039 = (0, $5pzZh.default).getRandomValues.bind((0, $5pzZh.default));

});



parcelRegister("icdnu", function(module, exports) {

$parcel$export(module.exports, "importPKCS8", () => $d3f3b992c534ed5a$export$17f5e7f6d2848df5);
$parcel$export(module.exports, "importJWK", () => $d3f3b992c534ed5a$export$2b70d37b4d0b888b);

var $7gBc4 = parcelRequire("7gBc4");

var $fPTdg = parcelRequire("fPTdg");

var $4pRQo = parcelRequire("4pRQo");

var $7GXIC = parcelRequire("7GXIC");

var $4g1L0 = parcelRequire("4g1L0");
async function $d3f3b992c534ed5a$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== 'string' || spki.indexOf('-----BEGIN PUBLIC KEY-----') !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $fPTdg.fromSPKI)(spki, alg, options);
}
async function $d3f3b992c534ed5a$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== 'string' || x509.indexOf('-----BEGIN CERTIFICATE-----') !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $fPTdg.fromX509)(x509, alg, options);
}
async function $d3f3b992c534ed5a$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== 'string' || pkcs8.indexOf('-----BEGIN PRIVATE KEY-----') !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $fPTdg.fromPKCS8)(pkcs8, alg, options);
}
async function $d3f3b992c534ed5a$export$2b70d37b4d0b888b(jwk, alg) {
    if (!(0, $4g1L0.default)(jwk)) throw new TypeError('JWK must be an object');
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case 'oct':
            if (typeof jwk.k !== 'string' || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            return (0, $7gBc4.decode)(jwk.k);
        case 'RSA':
            if ('oth' in jwk && jwk.oth !== undefined) throw new (0, $7GXIC.JOSENotSupported)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case 'EC':
        case 'OKP':
            return (0, $4pRQo.default)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $7GXIC.JOSENotSupported)('Unsupported "kty" (Key Type) Parameter value');
    }
}

});
parcelRegister("4pRQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $337343867c42a494$export$2e2bcd8739ae039);

var $5pzZh = parcelRequire("5pzZh");

var $7GXIC = parcelRequire("7GXIC");
function $337343867c42a494$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case 'RSA':
            switch(jwk.alg){
                case 'PS256':
                case 'PS384':
                case 'PS512':
                    algorithm = {
                        name: 'RSA-PSS',
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'RS256':
                case 'RS384':
                case 'RS512':
                    algorithm = {
                        name: 'RSASSA-PKCS1-v1_5',
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'RSA-OAEP':
                case 'RSA-OAEP-256':
                case 'RSA-OAEP-384':
                case 'RSA-OAEP-512':
                    algorithm = {
                        name: 'RSA-OAEP',
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        'decrypt',
                        'unwrapKey'
                    ] : [
                        'encrypt',
                        'wrapKey'
                    ];
                    break;
                default:
                    throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case 'EC':
            switch(jwk.alg){
                case 'ES256':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-256'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ES384':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-384'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ES512':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-521'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ECDH-ES':
                case 'ECDH-ES+A128KW':
                case 'ECDH-ES+A192KW':
                case 'ECDH-ES+A256KW':
                    algorithm = {
                        name: 'ECDH',
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        'deriveBits'
                    ] : [];
                    break;
                default:
                    throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case 'OKP':
            switch(jwk.alg){
                case 'Ed25519':
                    algorithm = {
                        name: 'Ed25519'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'EdDSA':
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ECDH-ES':
                case 'ECDH-ES+A128KW':
                case 'ECDH-ES+A192KW':
                case 'ECDH-ES+A256KW':
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        'deriveBits'
                    ] : [];
                    break;
                default:
                    throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $7GXIC.JOSENotSupported)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $337343867c42a494$var$parse = async (jwk)=>{
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $337343867c42a494$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        jwk.ext ?? false,
        jwk.key_ops ?? keyUsages
    ];
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, $5pzZh.default).subtle.importKey('jwk', keyData, ...rest);
};
var $337343867c42a494$export$2e2bcd8739ae039 = $337343867c42a494$var$parse;

});

parcelRegister("4g1L0", function(module, exports) {

$parcel$export(module.exports, "default", () => $319a04fbce04ffdb$export$2e2bcd8739ae039);
function $319a04fbce04ffdb$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}
function $319a04fbce04ffdb$export$2e2bcd8739ae039(input) {
    if (!$319a04fbce04ffdb$var$isObjectLike(input) || Object.prototype.toString.call(input) !== '[object Object]') return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}

});


parcelRegister("tU6kV", function(module, exports) {

$parcel$export(module.exports, "jwtVerify", () => $059e3a140d30ed13$export$c878fd0f8381da51);

var $8BLzp = parcelRequire("8BLzp");

var $fwBhj = parcelRequire("fwBhj");

var $7GXIC = parcelRequire("7GXIC");
async function $059e3a140d30ed13$export$c878fd0f8381da51(jwt, key, options) {
    const verified = await (0, $8BLzp.compactVerify)(jwt, key, options);
    if (verified.protectedHeader.crit?.includes('b64') && verified.protectedHeader.b64 === false) throw new (0, $7GXIC.JWTInvalid)('JWTs MUST NOT use unencoded payload');
    const payload = (0, $fwBhj.default)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload: payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === 'function') return {
        ...result,
        key: verified.key
    };
    return result;
}

});
parcelRegister("8BLzp", function(module, exports) {

$parcel$export(module.exports, "compactVerify", () => $6446add785626fa5$export$996150e72a8992e);

var $ffAor = parcelRequire("ffAor");

var $7GXIC = parcelRequire("7GXIC");

var $c2uWE = parcelRequire("c2uWE");
async function $6446add785626fa5$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $c2uWE.decoder).decode(jws);
    if (typeof jws !== 'string') throw new (0, $7GXIC.JWSInvalid)('Compact JWS must be a string or Uint8Array');
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split('.');
    if (length !== 3) throw new (0, $7GXIC.JWSInvalid)('Invalid Compact JWS');
    const verified = await (0, $ffAor.flattenedVerify)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === 'function') return {
        ...result,
        key: verified.key
    };
    return result;
}

});
parcelRegister("ffAor", function(module, exports) {

$parcel$export(module.exports, "flattenedVerify", () => $b1a47cad1ba554c8$export$b2614975507c40c9);

var $7gBc4 = parcelRequire("7gBc4");

var $iRtjS = parcelRequire("iRtjS");

var $7GXIC = parcelRequire("7GXIC");

var $c2uWE = parcelRequire("c2uWE");

var $a3qBq = parcelRequire("a3qBq");

var $4g1L0 = parcelRequire("4g1L0");

var $bSsO7 = parcelRequire("bSsO7");

var $YmF4A = parcelRequire("YmF4A");

var $4peTa = parcelRequire("4peTa");

var $5pkO0 = parcelRequire("5pkO0");

var $icdnu = parcelRequire("icdnu");
async function $b1a47cad1ba554c8$export$b2614975507c40c9(jws, key, options) {
    if (!(0, $4g1L0.default)(jws)) throw new (0, $7GXIC.JWSInvalid)('Flattened JWS must be an object');
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $7GXIC.JWSInvalid)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== 'string') throw new (0, $7GXIC.JWSInvalid)('JWS Protected Header incorrect type');
    if (jws.payload === undefined) throw new (0, $7GXIC.JWSInvalid)('JWS Payload missing');
    if (typeof jws.signature !== 'string') throw new (0, $7GXIC.JWSInvalid)('JWS Signature missing or incorrect type');
    if (jws.header !== undefined && !(0, $4g1L0.default)(jws.header)) throw new (0, $7GXIC.JWSInvalid)('JWS Unprotected Header incorrect type');
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $7gBc4.decode)(jws.protected);
        parsedProt = JSON.parse((0, $c2uWE.decoder).decode(protectedHeader));
    } catch  {
        throw new (0, $7GXIC.JWSInvalid)('JWS Protected Header is invalid');
    }
    if (!(0, $a3qBq.default)(parsedProt, jws.header)) throw new (0, $7GXIC.JWSInvalid)('JWS Protected and JWS Unprotected Header Parameter names must be disjoint');
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $YmF4A.default)((0, $7GXIC.JWSInvalid), new Map([
        [
            'b64',
            true
        ]
    ]), options?.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has('b64')) {
        b64 = parsedProt.b64;
        if (typeof b64 !== 'boolean') throw new (0, $7GXIC.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== 'string' || !alg) throw new (0, $7GXIC.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $4peTa.default)('algorithms', options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $7GXIC.JOSEAlgNotAllowed)('"alg" (Algorithm) Header Parameter value not allowed');
    if (b64) {
        if (typeof jws.payload !== 'string') throw new (0, $7GXIC.JWSInvalid)('JWS Payload must be a string');
    } else if (typeof jws.payload !== 'string' && !(jws.payload instanceof Uint8Array)) throw new (0, $7GXIC.JWSInvalid)('JWS Payload must be a string or an Uint8Array instance');
    let resolvedKey = false;
    if (typeof key === 'function') {
        key = await key(parsedProt, jws);
        resolvedKey = true;
        (0, $bSsO7.checkKeyTypeWithJwk)(alg, key, 'verify');
        if ((0, $5pkO0.isJWK)(key)) key = await (0, $icdnu.importJWK)(key, alg);
    } else (0, $bSsO7.checkKeyTypeWithJwk)(alg, key, 'verify');
    const data = (0, $c2uWE.concat)((0, $c2uWE.encoder).encode(jws.protected ?? ''), (0, $c2uWE.encoder).encode('.'), typeof jws.payload === 'string' ? (0, $c2uWE.encoder).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, $7gBc4.decode)(jws.signature);
    } catch  {
        throw new (0, $7GXIC.JWSInvalid)('Failed to base64url decode the signature');
    }
    const verified = await (0, $iRtjS.default)(alg, key, signature, data);
    if (!verified) throw new (0, $7GXIC.JWSSignatureVerificationFailed)();
    let payload;
    if (b64) try {
        payload = (0, $7gBc4.decode)(jws.payload);
    } catch  {
        throw new (0, $7GXIC.JWSInvalid)('Failed to base64url decode the payload');
    }
    else if (typeof jws.payload === 'string') payload = (0, $c2uWE.encoder).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}

});
parcelRegister("iRtjS", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbb3eb797cbe0e44$export$2e2bcd8739ae039);

var $lM2r3 = parcelRequire("lM2r3");

var $5pzZh = parcelRequire("5pzZh");

var $3OU1R = parcelRequire("3OU1R");

var $j15wt = parcelRequire("j15wt");
const $dbb3eb797cbe0e44$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $j15wt.default)(alg, key, 'verify');
    (0, $3OU1R.default)(alg, cryptoKey);
    const algorithm = (0, $lM2r3.default)(alg, cryptoKey.algorithm);
    try {
        return await (0, $5pzZh.default).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch  {
        return false;
    }
};
var $dbb3eb797cbe0e44$export$2e2bcd8739ae039 = $dbb3eb797cbe0e44$var$verify;

});
parcelRegister("lM2r3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd9ff84d4ad74129$export$2e2bcd8739ae039);

var $7GXIC = parcelRequire("7GXIC");
function $fd9ff84d4ad74129$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case 'HS256':
        case 'HS384':
        case 'HS512':
            return {
                hash: hash,
                name: 'HMAC'
            };
        case 'PS256':
        case 'PS384':
        case 'PS512':
            return {
                hash: hash,
                name: 'RSA-PSS',
                saltLength: alg.slice(-3) >> 3
            };
        case 'RS256':
        case 'RS384':
        case 'RS512':
            return {
                hash: hash,
                name: 'RSASSA-PKCS1-v1_5'
            };
        case 'ES256':
        case 'ES384':
        case 'ES512':
            return {
                hash: hash,
                name: 'ECDSA',
                namedCurve: algorithm.namedCurve
            };
        case 'Ed25519':
            return {
                name: 'Ed25519'
            };
        case 'EdDSA':
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $7GXIC.JOSENotSupported)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}

});

parcelRegister("3OU1R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c8180cef663e103$export$2e2bcd8739ae039);
var $2c8180cef663e103$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith('RS') || alg.startsWith('PS')) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== 'number' || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};

});

parcelRegister("j15wt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd8265016b6a4c59$export$2e2bcd8739ae039);

var $5pzZh = parcelRequire("5pzZh");

var $geh5Z = parcelRequire("geh5Z");

var $31Bep = parcelRequire("31Bep");

var $0UxFO = parcelRequire("0UxFO");

var $cK18k = parcelRequire("cK18k");
async function $dd8265016b6a4c59$export$2e2bcd8739ae039(alg, key, usage) {
    if (usage === 'sign') key = await (0, $cK18k.default).normalizePrivateKey(key, alg);
    if (usage === 'verify') key = await (0, $cK18k.default).normalizePublicKey(key, alg);
    if ((0, $5pzZh.isCryptoKey)(key)) {
        (0, $geh5Z.checkSigCryptoKey)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith('HS')) throw new TypeError((0, $31Bep.default)(key, ...(0, $0UxFO.types)));
        return (0, $5pzZh.default).subtle.importKey('raw', key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: 'HMAC'
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $31Bep.default)(key, ...(0, $0UxFO.types), 'Uint8Array', 'JSON Web Key'));
}

});
parcelRegister("geh5Z", function(module, exports) {

$parcel$export(module.exports, "checkSigCryptoKey", () => $bd0b36fb17abf4f5$export$39a36029eee6729);
function $bd0b36fb17abf4f5$var$unusable(name, prop = 'algorithm.name') {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $bd0b36fb17abf4f5$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $bd0b36fb17abf4f5$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $bd0b36fb17abf4f5$var$getNamedCurve(alg) {
    switch(alg){
        case 'ES256':
            return 'P-256';
        case 'ES384':
            return 'P-384';
        case 'ES512':
            return 'P-521';
        default:
            throw new Error('unreachable');
    }
}
function $bd0b36fb17abf4f5$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = 'CryptoKey does not support this operation, its usages must include ';
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(', ')}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $bd0b36fb17abf4f5$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case 'HS256':
        case 'HS384':
        case 'HS512':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'HMAC')) throw $bd0b36fb17abf4f5$var$unusable('HMAC');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'RS256':
        case 'RS384':
        case 'RS512':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'RSASSA-PKCS1-v1_5')) throw $bd0b36fb17abf4f5$var$unusable('RSASSA-PKCS1-v1_5');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'PS256':
        case 'PS384':
        case 'PS512':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'RSA-PSS')) throw $bd0b36fb17abf4f5$var$unusable('RSA-PSS');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'EdDSA':
            if (key.algorithm.name !== 'Ed25519' && key.algorithm.name !== 'Ed448') throw $bd0b36fb17abf4f5$var$unusable('Ed25519 or Ed448');
            break;
        case 'Ed25519':
            if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'Ed25519')) throw $bd0b36fb17abf4f5$var$unusable('Ed25519');
            break;
        case 'ES256':
        case 'ES384':
        case 'ES512':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'ECDSA')) throw $bd0b36fb17abf4f5$var$unusable('ECDSA');
                const expected = $bd0b36fb17abf4f5$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, 'algorithm.namedCurve');
                break;
            }
        default:
            throw new TypeError('CryptoKey does not support this operation');
    }
    $bd0b36fb17abf4f5$var$checkUsage(key, usages);
}
function $bd0b36fb17abf4f5$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case 'A128GCM':
        case 'A192GCM':
        case 'A256GCM':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'AES-GCM')) throw $bd0b36fb17abf4f5$var$unusable('AES-GCM');
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, 'algorithm.length');
                break;
            }
        case 'A128KW':
        case 'A192KW':
        case 'A256KW':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'AES-KW')) throw $bd0b36fb17abf4f5$var$unusable('AES-KW');
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, 'algorithm.length');
                break;
            }
        case 'ECDH':
            switch(key.algorithm.name){
                case 'ECDH':
                case 'X25519':
                case 'X448':
                    break;
                default:
                    throw $bd0b36fb17abf4f5$var$unusable('ECDH, X25519, or X448');
            }
            break;
        case 'PBES2-HS256+A128KW':
        case 'PBES2-HS384+A192KW':
        case 'PBES2-HS512+A256KW':
            if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'PBKDF2')) throw $bd0b36fb17abf4f5$var$unusable('PBKDF2');
            break;
        case 'RSA-OAEP':
        case 'RSA-OAEP-256':
        case 'RSA-OAEP-384':
        case 'RSA-OAEP-512':
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, 'RSA-OAEP')) throw $bd0b36fb17abf4f5$var$unusable('RSA-OAEP');
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        default:
            throw new TypeError('CryptoKey does not support this operation');
    }
    $bd0b36fb17abf4f5$var$checkUsage(key, usages);
}

});

parcelRegister("cK18k", function(module, exports) {

$parcel$export(module.exports, "default", () => $946aa8f62005044f$export$2e2bcd8739ae039);

var $5pkO0 = parcelRequire("5pkO0");

var $7gBc4 = parcelRequire("7gBc4");

var $4pRQo = parcelRequire("4pRQo");
const $946aa8f62005044f$var$exportKeyValue = (k)=>(0, $7gBc4.decode)(k);
let $946aa8f62005044f$var$privCache;
let $946aa8f62005044f$var$pubCache;
const $946aa8f62005044f$var$isKeyObject = (key)=>{
    return key?.[Symbol.toStringTag] === 'KeyObject';
};
const $946aa8f62005044f$var$importAndCache = async (cache, key, jwk, alg, freeze = false)=>{
    let cached = cache.get(key);
    if (cached?.[alg]) return cached[alg];
    const cryptoKey = await (0, $4pRQo.default)({
        ...jwk,
        alg: alg
    });
    if (freeze) Object.freeze(key);
    if (!cached) cache.set(key, {
        [alg]: cryptoKey
    });
    else cached[alg] = cryptoKey;
    return cryptoKey;
};
const $946aa8f62005044f$var$normalizePublicKey = (key, alg)=>{
    if ($946aa8f62005044f$var$isKeyObject(key)) {
        let jwk = key.export({
            format: 'jwk'
        });
        delete jwk.d;
        delete jwk.dp;
        delete jwk.dq;
        delete jwk.p;
        delete jwk.q;
        delete jwk.qi;
        if (jwk.k) return $946aa8f62005044f$var$exportKeyValue(jwk.k);
        $946aa8f62005044f$var$pubCache || ($946aa8f62005044f$var$pubCache = new WeakMap());
        return $946aa8f62005044f$var$importAndCache($946aa8f62005044f$var$pubCache, key, jwk, alg);
    }
    if ((0, $5pkO0.isJWK)(key)) {
        if (key.k) return (0, $7gBc4.decode)(key.k);
        $946aa8f62005044f$var$pubCache || ($946aa8f62005044f$var$pubCache = new WeakMap());
        const cryptoKey = $946aa8f62005044f$var$importAndCache($946aa8f62005044f$var$pubCache, key, key, alg, true);
        return cryptoKey;
    }
    return key;
};
const $946aa8f62005044f$var$normalizePrivateKey = (key, alg)=>{
    if ($946aa8f62005044f$var$isKeyObject(key)) {
        let jwk = key.export({
            format: 'jwk'
        });
        if (jwk.k) return $946aa8f62005044f$var$exportKeyValue(jwk.k);
        $946aa8f62005044f$var$privCache || ($946aa8f62005044f$var$privCache = new WeakMap());
        return $946aa8f62005044f$var$importAndCache($946aa8f62005044f$var$privCache, key, jwk, alg);
    }
    if ((0, $5pkO0.isJWK)(key)) {
        if (key.k) return (0, $7gBc4.decode)(key.k);
        $946aa8f62005044f$var$privCache || ($946aa8f62005044f$var$privCache = new WeakMap());
        const cryptoKey = $946aa8f62005044f$var$importAndCache($946aa8f62005044f$var$privCache, key, key, alg, true);
        return cryptoKey;
    }
    return key;
};
var $946aa8f62005044f$export$2e2bcd8739ae039 = {
    normalizePublicKey: $946aa8f62005044f$var$normalizePublicKey,
    normalizePrivateKey: $946aa8f62005044f$var$normalizePrivateKey
};

});
parcelRegister("5pkO0", function(module, exports) {

$parcel$export(module.exports, "isJWK", () => $3eff6d14b0ca9812$export$9a44c2ef7e3b3dad);
$parcel$export(module.exports, "isPrivateJWK", () => $3eff6d14b0ca9812$export$431699a4f17ba0e);
$parcel$export(module.exports, "isPublicJWK", () => $3eff6d14b0ca9812$export$b786616db1cddf3);
$parcel$export(module.exports, "isSecretJWK", () => $3eff6d14b0ca9812$export$f8ecf533504bc7ad);

var $4g1L0 = parcelRequire("4g1L0");
function $3eff6d14b0ca9812$export$9a44c2ef7e3b3dad(key) {
    return (0, $4g1L0.default)(key) && typeof key.kty === 'string';
}
function $3eff6d14b0ca9812$export$431699a4f17ba0e(key) {
    return key.kty !== 'oct' && typeof key.d === 'string';
}
function $3eff6d14b0ca9812$export$b786616db1cddf3(key) {
    return key.kty !== 'oct' && typeof key.d === 'undefined';
}
function $3eff6d14b0ca9812$export$f8ecf533504bc7ad(key) {
    return $3eff6d14b0ca9812$export$9a44c2ef7e3b3dad(key) && key.kty === 'oct' && typeof key.k === 'string';
}

});




parcelRegister("a3qBq", function(module, exports) {

$parcel$export(module.exports, "default", () => $751ed1ebc64f8b96$export$2e2bcd8739ae039);
const $751ed1ebc64f8b96$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $751ed1ebc64f8b96$export$2e2bcd8739ae039 = $751ed1ebc64f8b96$var$isDisjoint;

});

parcelRegister("bSsO7", function(module, exports) {

$parcel$export(module.exports, "checkKeyTypeWithJwk", () => $8a5b1565e0dee973$export$d7fd0dd52697ff18);

var $31Bep = parcelRequire("31Bep");

var $0UxFO = parcelRequire("0UxFO");

var $5pkO0 = parcelRequire("5pkO0");
const $8a5b1565e0dee973$var$tag = (key)=>key?.[Symbol.toStringTag];
const $8a5b1565e0dee973$var$jwkMatchesOp = (alg, key, usage)=>{
    if (key.use !== undefined && key.use !== 'sig') throw new TypeError('Invalid key for this operation, when present its use must be sig');
    if (key.key_ops !== undefined && key.key_ops.includes?.(usage) !== true) throw new TypeError(`Invalid key for this operation, when present its key_ops must include ${usage}`);
    if (key.alg !== undefined && key.alg !== alg) throw new TypeError(`Invalid key for this operation, when present its alg must be ${alg}`);
    return true;
};
const $8a5b1565e0dee973$var$symmetricTypeCheck = (alg, key, usage, allowJwk)=>{
    if (key instanceof Uint8Array) return;
    if (allowJwk && $5pkO0.isJWK(key)) {
        if ($5pkO0.isSecretJWK(key) && $8a5b1565e0dee973$var$jwkMatchesOp(alg, key, usage)) return;
        throw new TypeError(`JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present`);
    }
    if (!(0, $0UxFO.default)(key)) throw new TypeError((0, $31Bep.withAlg)(alg, key, ...(0, $0UxFO.types), 'Uint8Array', allowJwk ? 'JSON Web Key' : null));
    if (key.type !== 'secret') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for symmetric algorithms must be of type "secret"`);
};
const $8a5b1565e0dee973$var$asymmetricTypeCheck = (alg, key, usage, allowJwk)=>{
    if (allowJwk && $5pkO0.isJWK(key)) switch(usage){
        case 'sign':
            if ($5pkO0.isPrivateJWK(key) && $8a5b1565e0dee973$var$jwkMatchesOp(alg, key, usage)) return;
            throw new TypeError(`JSON Web Key for this operation be a private JWK`);
        case 'verify':
            if ($5pkO0.isPublicJWK(key) && $8a5b1565e0dee973$var$jwkMatchesOp(alg, key, usage)) return;
            throw new TypeError(`JSON Web Key for this operation be a public JWK`);
    }
    if (!(0, $0UxFO.default)(key)) throw new TypeError((0, $31Bep.withAlg)(alg, key, ...(0, $0UxFO.types), allowJwk ? 'JSON Web Key' : null));
    if (key.type === 'secret') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === 'sign' && key.type === 'public') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === 'decrypt' && key.type === 'public') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === 'verify' && key.type === 'private') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === 'encrypt' && key.type === 'private') throw new TypeError(`${$8a5b1565e0dee973$var$tag(key)} instances for asymmetric algorithm encryption must be of type "public"`);
};
function $8a5b1565e0dee973$var$checkKeyType(allowJwk, alg, key, usage) {
    const symmetric = alg.startsWith('HS') || alg === 'dir' || alg.startsWith('PBES2') || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $8a5b1565e0dee973$var$symmetricTypeCheck(alg, key, usage, allowJwk);
    else $8a5b1565e0dee973$var$asymmetricTypeCheck(alg, key, usage, allowJwk);
}
var $8a5b1565e0dee973$export$2e2bcd8739ae039 = $8a5b1565e0dee973$var$checkKeyType.bind(undefined, false);
const $8a5b1565e0dee973$export$d7fd0dd52697ff18 = $8a5b1565e0dee973$var$checkKeyType.bind(undefined, true);

});

parcelRegister("YmF4A", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b572ece71b785f0$export$2e2bcd8739ae039);

var $7GXIC = parcelRequire("7GXIC");
function $0b572ece71b785f0$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader?.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== 'string' || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $7GXIC.JOSENotSupported)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $0b572ece71b785f0$export$2e2bcd8739ae039 = $0b572ece71b785f0$var$validateCrit;

});

parcelRegister("4peTa", function(module, exports) {

$parcel$export(module.exports, "default", () => $33550bd8f4719411$export$2e2bcd8739ae039);
const $33550bd8f4719411$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== 'string'))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $33550bd8f4719411$export$2e2bcd8739ae039 = $33550bd8f4719411$var$validateAlgorithms;

});



parcelRegister("fwBhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d6c2e00c056d92$export$2e2bcd8739ae039);

var $7GXIC = parcelRequire("7GXIC");

var $c2uWE = parcelRequire("c2uWE");

var $hmjA4 = parcelRequire("hmjA4");

var $jeEIZ = parcelRequire("jeEIZ");

var $4g1L0 = parcelRequire("4g1L0");
const $b4d6c2e00c056d92$var$normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, '');
const $b4d6c2e00c056d92$var$checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === 'string') return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
var $b4d6c2e00c056d92$export$2e2bcd8739ae039 = (protectedHeader, encodedPayload, options = {})=>{
    let payload;
    try {
        payload = JSON.parse((0, $c2uWE.decoder).decode(encodedPayload));
    } catch  {}
    if (!(0, $4g1L0.default)(payload)) throw new (0, $7GXIC.JWTInvalid)('JWT Claims Set must be a top-level JSON object');
    const { typ: typ } = options;
    if (typ && (typeof protectedHeader.typ !== 'string' || $b4d6c2e00c056d92$var$normalizeTyp(protectedHeader.typ) !== $b4d6c2e00c056d92$var$normalizeTyp(typ))) throw new (0, $7GXIC.JWTClaimValidationFailed)('unexpected "typ" JWT header value', payload, 'typ', 'check_failed');
    const { requiredClaims: requiredClaims = [], issuer: issuer, subject: subject, audience: audience, maxTokenAge: maxTokenAge } = options;
    const presenceCheck = [
        ...requiredClaims
    ];
    if (maxTokenAge !== undefined) presenceCheck.push('iat');
    if (audience !== undefined) presenceCheck.push('aud');
    if (subject !== undefined) presenceCheck.push('sub');
    if (issuer !== undefined) presenceCheck.push('iss');
    for (const claim of new Set(presenceCheck.reverse())){
        if (!(claim in payload)) throw new (0, $7GXIC.JWTClaimValidationFailed)(`missing required "${claim}" claim`, payload, claim, 'missing');
    }
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, $7GXIC.JWTClaimValidationFailed)('unexpected "iss" claim value', payload, 'iss', 'check_failed');
    if (subject && payload.sub !== subject) throw new (0, $7GXIC.JWTClaimValidationFailed)('unexpected "sub" claim value', payload, 'sub', 'check_failed');
    if (audience && !$b4d6c2e00c056d92$var$checkAudiencePresence(payload.aud, typeof audience === 'string' ? [
        audience
    ] : audience)) throw new (0, $7GXIC.JWTClaimValidationFailed)('unexpected "aud" claim value', payload, 'aud', 'check_failed');
    let tolerance;
    switch(typeof options.clockTolerance){
        case 'string':
            tolerance = (0, $jeEIZ.default)(options.clockTolerance);
            break;
        case 'number':
            tolerance = options.clockTolerance;
            break;
        case 'undefined':
            tolerance = 0;
            break;
        default:
            throw new TypeError('Invalid clockTolerance option type');
    }
    const { currentDate: currentDate } = options;
    const now = (0, $hmjA4.default)(currentDate || new Date());
    if ((payload.iat !== undefined || maxTokenAge) && typeof payload.iat !== 'number') throw new (0, $7GXIC.JWTClaimValidationFailed)('"iat" claim must be a number', payload, 'iat', 'invalid');
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== 'number') throw new (0, $7GXIC.JWTClaimValidationFailed)('"nbf" claim must be a number', payload, 'nbf', 'invalid');
        if (payload.nbf > now + tolerance) throw new (0, $7GXIC.JWTClaimValidationFailed)('"nbf" claim timestamp check failed', payload, 'nbf', 'check_failed');
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== 'number') throw new (0, $7GXIC.JWTClaimValidationFailed)('"exp" claim must be a number', payload, 'exp', 'invalid');
        if (payload.exp <= now - tolerance) throw new (0, $7GXIC.JWTExpired)('"exp" claim timestamp check failed', payload, 'exp', 'check_failed');
    }
    if (maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof maxTokenAge === 'number' ? maxTokenAge : (0, $jeEIZ.default)(maxTokenAge);
        if (age - tolerance > max) throw new (0, $7GXIC.JWTExpired)('"iat" claim timestamp check failed (too far in the past)', payload, 'iat', 'check_failed');
        if (age < 0 - tolerance) throw new (0, $7GXIC.JWTClaimValidationFailed)('"iat" claim timestamp check failed (it should be in the past)', payload, 'iat', 'check_failed');
    }
    return payload;
};

});
parcelRegister("hmjA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca33ae1426f1aba8$export$2e2bcd8739ae039);
var $ca33ae1426f1aba8$export$2e2bcd8739ae039 = (date)=>Math.floor(date.getTime() / 1000);

});

parcelRegister("jeEIZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e00eea37b383aa7e$export$2e2bcd8739ae039);
const $e00eea37b383aa7e$var$minute = 60;
const $e00eea37b383aa7e$var$hour = $e00eea37b383aa7e$var$minute * 60;
const $e00eea37b383aa7e$var$day = $e00eea37b383aa7e$var$hour * 24;
const $e00eea37b383aa7e$var$week = $e00eea37b383aa7e$var$day * 7;
const $e00eea37b383aa7e$var$year = $e00eea37b383aa7e$var$day * 365.25;
const $e00eea37b383aa7e$var$REGEX = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
var $e00eea37b383aa7e$export$2e2bcd8739ae039 = (str)=>{
    const matched = $e00eea37b383aa7e$var$REGEX.exec(str);
    if (!matched || matched[4] && matched[1]) throw new TypeError('Invalid time period format');
    const value = parseFloat(matched[2]);
    const unit = matched[3].toLowerCase();
    let numericDate;
    switch(unit){
        case 'sec':
        case 'secs':
        case 'second':
        case 'seconds':
        case 's':
            numericDate = Math.round(value);
            break;
        case 'minute':
        case 'minutes':
        case 'min':
        case 'mins':
        case 'm':
            numericDate = Math.round(value * $e00eea37b383aa7e$var$minute);
            break;
        case 'hour':
        case 'hours':
        case 'hr':
        case 'hrs':
        case 'h':
            numericDate = Math.round(value * $e00eea37b383aa7e$var$hour);
            break;
        case 'day':
        case 'days':
        case 'd':
            numericDate = Math.round(value * $e00eea37b383aa7e$var$day);
            break;
        case 'week':
        case 'weeks':
        case 'w':
            numericDate = Math.round(value * $e00eea37b383aa7e$var$week);
            break;
        default:
            numericDate = Math.round(value * $e00eea37b383aa7e$var$year);
            break;
    }
    if (matched[1] === '-' || matched[4] === 'ago') return -numericDate;
    return numericDate;
};

});



parcelRegister("hrT3a", function(module, exports) {

$parcel$export(module.exports, "SignJWT", () => $cb3fa919fa1549c0$export$88d4e5d23fbe6c84);

var $1ChXF = parcelRequire("1ChXF");

var $7GXIC = parcelRequire("7GXIC");

var $c2uWE = parcelRequire("c2uWE");

var $65ENa = parcelRequire("65ENa");
class $cb3fa919fa1549c0$export$88d4e5d23fbe6c84 extends (0, $65ENa.ProduceJWT) {
    setProtectedHeader(protectedHeader) {
        this._protectedHeader = protectedHeader;
        return this;
    }
    async sign(key, options) {
        const sig = new (0, $1ChXF.CompactSign)((0, $c2uWE.encoder).encode(JSON.stringify(this._payload)));
        sig.setProtectedHeader(this._protectedHeader);
        if (Array.isArray(this._protectedHeader?.crit) && this._protectedHeader.crit.includes('b64') && this._protectedHeader.b64 === false) throw new (0, $7GXIC.JWTInvalid)('JWTs MUST NOT use unencoded payload');
        return sig.sign(key, options);
    }
}

});
parcelRegister("1ChXF", function(module, exports) {

$parcel$export(module.exports, "CompactSign", () => $12d745ca26469470$export$b6738d8e70498d17);

var $kymxc = parcelRequire("kymxc");
class $12d745ca26469470$export$b6738d8e70498d17 {
    constructor(payload){
        this._flattened = new (0, $kymxc.FlattenedSign)(payload);
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    async sign(key, options) {
        const jws = await this._flattened.sign(key, options);
        if (jws.payload === undefined) throw new TypeError('use the flattened module for creating JWS with b64: false');
        return `${jws.protected}.${jws.payload}.${jws.signature}`;
    }
}

});
parcelRegister("kymxc", function(module, exports) {

$parcel$export(module.exports, "FlattenedSign", () => $ef6876836c58b0e4$export$9a8af5200da5ddb1);

var $7gBc4 = parcelRequire("7gBc4");

var $f3gN6 = parcelRequire("f3gN6");

var $a3qBq = parcelRequire("a3qBq");

var $7GXIC = parcelRequire("7GXIC");

var $c2uWE = parcelRequire("c2uWE");

var $bSsO7 = parcelRequire("bSsO7");

var $YmF4A = parcelRequire("YmF4A");
class $ef6876836c58b0e4$export$9a8af5200da5ddb1 {
    constructor(payload){
        if (!(payload instanceof Uint8Array)) throw new TypeError('payload must be an instance of Uint8Array');
        this._payload = payload;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError('setProtectedHeader can only be called once');
        this._protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError('setUnprotectedHeader can only be called once');
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    async sign(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader) throw new (0, $7GXIC.JWSInvalid)('either setProtectedHeader or setUnprotectedHeader must be called before #sign()');
        if (!(0, $a3qBq.default)(this._protectedHeader, this._unprotectedHeader)) throw new (0, $7GXIC.JWSInvalid)('JWS Protected and JWS Unprotected Header Parameter names must be disjoint');
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader
        };
        const extensions = (0, $YmF4A.default)((0, $7GXIC.JWSInvalid), new Map([
            [
                'b64',
                true
            ]
        ]), options?.crit, this._protectedHeader, joseHeader);
        let b64 = true;
        if (extensions.has('b64')) {
            b64 = this._protectedHeader.b64;
            if (typeof b64 !== 'boolean') throw new (0, $7GXIC.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        }
        const { alg: alg } = joseHeader;
        if (typeof alg !== 'string' || !alg) throw new (0, $7GXIC.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        (0, $bSsO7.checkKeyTypeWithJwk)(alg, key, 'sign');
        let payload = this._payload;
        if (b64) payload = (0, $c2uWE.encoder).encode((0, $7gBc4.encode)(payload));
        let protectedHeader;
        if (this._protectedHeader) protectedHeader = (0, $c2uWE.encoder).encode((0, $7gBc4.encode)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $c2uWE.encoder).encode('');
        const data = (0, $c2uWE.concat)(protectedHeader, (0, $c2uWE.encoder).encode('.'), payload);
        const signature = await (0, $f3gN6.default)(alg, key, data);
        const jws = {
            signature: (0, $7gBc4.encode)(signature),
            payload: ''
        };
        if (b64) jws.payload = (0, $c2uWE.decoder).decode(payload);
        if (this._unprotectedHeader) jws.header = this._unprotectedHeader;
        if (this._protectedHeader) jws.protected = (0, $c2uWE.decoder).decode(protectedHeader);
        return jws;
    }
}

});
parcelRegister("f3gN6", function(module, exports) {

$parcel$export(module.exports, "default", () => $af54292801bcc1f9$export$2e2bcd8739ae039);

var $lM2r3 = parcelRequire("lM2r3");

var $5pzZh = parcelRequire("5pzZh");

var $3OU1R = parcelRequire("3OU1R");

var $j15wt = parcelRequire("j15wt");
const $af54292801bcc1f9$var$sign = async (alg, key, data)=>{
    const cryptoKey = await (0, $j15wt.default)(alg, key, 'sign');
    (0, $3OU1R.default)(alg, cryptoKey);
    const signature = await (0, $5pzZh.default).subtle.sign((0, $lM2r3.default)(alg, cryptoKey.algorithm), cryptoKey, data);
    return new Uint8Array(signature);
};
var $af54292801bcc1f9$export$2e2bcd8739ae039 = $af54292801bcc1f9$var$sign;

});



parcelRegister("65ENa", function(module, exports) {

$parcel$export(module.exports, "ProduceJWT", () => $46f2da2b3de4ed34$export$2ef1b74b7c7e6eb3);

var $hmjA4 = parcelRequire("hmjA4");

var $4g1L0 = parcelRequire("4g1L0");

var $jeEIZ = parcelRequire("jeEIZ");
function $46f2da2b3de4ed34$var$validateInput(label, input) {
    if (!Number.isFinite(input)) throw new TypeError(`Invalid ${label} input`);
    return input;
}
class $46f2da2b3de4ed34$export$2ef1b74b7c7e6eb3 {
    constructor(payload = {}){
        if (!(0, $4g1L0.default)(payload)) throw new TypeError('JWT Claims Set MUST be an object');
        this._payload = payload;
    }
    setIssuer(issuer) {
        this._payload = {
            ...this._payload,
            iss: issuer
        };
        return this;
    }
    setSubject(subject) {
        this._payload = {
            ...this._payload,
            sub: subject
        };
        return this;
    }
    setAudience(audience) {
        this._payload = {
            ...this._payload,
            aud: audience
        };
        return this;
    }
    setJti(jwtId) {
        this._payload = {
            ...this._payload,
            jti: jwtId
        };
        return this;
    }
    setNotBefore(input) {
        if (typeof input === 'number') this._payload = {
            ...this._payload,
            nbf: $46f2da2b3de4ed34$var$validateInput('setNotBefore', input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            nbf: $46f2da2b3de4ed34$var$validateInput('setNotBefore', (0, $hmjA4.default)(input))
        };
        else this._payload = {
            ...this._payload,
            nbf: (0, $hmjA4.default)(new Date()) + (0, $jeEIZ.default)(input)
        };
        return this;
    }
    setExpirationTime(input) {
        if (typeof input === 'number') this._payload = {
            ...this._payload,
            exp: $46f2da2b3de4ed34$var$validateInput('setExpirationTime', input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            exp: $46f2da2b3de4ed34$var$validateInput('setExpirationTime', (0, $hmjA4.default)(input))
        };
        else this._payload = {
            ...this._payload,
            exp: (0, $hmjA4.default)(new Date()) + (0, $jeEIZ.default)(input)
        };
        return this;
    }
    setIssuedAt(input) {
        if (typeof input === 'undefined') this._payload = {
            ...this._payload,
            iat: (0, $hmjA4.default)(new Date())
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            iat: $46f2da2b3de4ed34$var$validateInput('setIssuedAt', (0, $hmjA4.default)(input))
        };
        else if (typeof input === 'string') this._payload = {
            ...this._payload,
            iat: $46f2da2b3de4ed34$var$validateInput('setIssuedAt', (0, $hmjA4.default)(new Date()) + (0, $jeEIZ.default)(input))
        };
        else this._payload = {
            ...this._payload,
            iat: $46f2da2b3de4ed34$var$validateInput('setIssuedAt', input)
        };
        return this;
    }
}

});


parcelRegister("akcrY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.either = void 0;
function $78456df826f6a4d3$var$either(a, b) {
    if (a != null && b != null && a !== b) throw new TypeError(`Expected "${b}", got "${a}"`);
    return a ?? b ?? undefined;
}
module.exports.either = $78456df826f6a4d3$var$either;

});



parcelRegister("24DA2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isCryptoKeyPair = module.exports.fromSubtleAlgorithm = module.exports.toSubtleAlgorithm = void 0;
function $182aa850173982cc$var$toSubtleAlgorithm(alg, crv, options) {
    switch(alg){
        case 'PS256':
        case 'PS384':
        case 'PS512':
            return {
                name: 'RSA-PSS',
                hash: `SHA-${alg.slice(-3)}`,
                modulusLength: options?.modulusLength ?? 2048,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ])
            };
        case 'RS256':
        case 'RS384':
        case 'RS512':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: `SHA-${alg.slice(-3)}`,
                modulusLength: options?.modulusLength ?? 2048,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ])
            };
        case 'ES256':
        case 'ES384':
            return {
                name: 'ECDSA',
                namedCurve: `P-${alg.slice(-3)}`
            };
        case 'ES512':
            return {
                name: 'ECDSA',
                namedCurve: 'P-521'
            };
        default:
            // https://github.com/w3c/webcrypto/issues/82#issuecomment-849856773
            throw new TypeError(`Unsupported alg "${alg}"`);
    }
}
module.exports.toSubtleAlgorithm = $182aa850173982cc$var$toSubtleAlgorithm;
function $182aa850173982cc$var$fromSubtleAlgorithm(algorithm) {
    switch(algorithm.name){
        case 'RSA-PSS':
        case 'RSASSA-PKCS1-v1_5':
            {
                const hash = algorithm.hash.name;
                switch(hash){
                    case 'SHA-256':
                    case 'SHA-384':
                    case 'SHA-512':
                        {
                            const prefix = algorithm.name === 'RSA-PSS' ? 'PS' : 'RS';
                            return `${prefix}${hash.slice(-3)}`;
                        }
                    default:
                        throw new TypeError('unsupported RsaHashedKeyAlgorithm hash');
                }
            }
        case 'ECDSA':
            {
                const namedCurve = algorithm.namedCurve;
                switch(namedCurve){
                    case 'P-256':
                    case 'P-384':
                    case 'P-512':
                        return `ES${namedCurve.slice(-3)}`;
                    case 'P-521':
                        return 'ES512';
                    default:
                        throw new TypeError('unsupported EcKeyAlgorithm namedCurve');
                }
            }
        case 'Ed448':
        case 'Ed25519':
            return 'EdDSA';
        default:
            // https://github.com/w3c/webcrypto/issues/82#issuecomment-849856773
            throw new TypeError(`Unexpected algorithm "${algorithm.name}"`);
    }
}
module.exports.fromSubtleAlgorithm = $182aa850173982cc$var$fromSubtleAlgorithm;
function $182aa850173982cc$var$isCryptoKeyPair(v, extractable) {
    return typeof v === 'object' && v !== null && 'privateKey' in v && v.privateKey instanceof CryptoKey && v.privateKey.type === 'private' && (extractable == null || v.privateKey.extractable === extractable) && v.privateKey.usages.includes('sign') && 'publicKey' in v && v.publicKey instanceof CryptoKey && v.publicKey.type === 'public' && v.publicKey.extractable === true && v.publicKey.usages.includes('verify');
}
module.exports.isCryptoKeyPair = $182aa850173982cc$var$isCryptoKeyPair;

});



parcelRegister("cNZAj", function(module, exports) {
"use strict";
var $9529d518a516ff35$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9529d518a516ff35$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9529d518a516ff35$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchResponseError = module.exports.FetchRequestError = module.exports.FetchError = void 0;

$9529d518a516ff35$var$__exportStar((parcelRequire("k2dJf")), module.exports);

var $8oTqd = parcelRequire("8oTqd");
Object.defineProperty(module.exports, "FetchError", {
    enumerable: true,
    get: function() {
        return $8oTqd.FetchError;
    }
});
Object.defineProperty(module.exports, "FetchRequestError", {
    enumerable: true,
    get: function() {
        return $8oTqd.FetchRequestError;
    }
});
Object.defineProperty(module.exports, "FetchResponseError", {
    enumerable: true,
    get: function() {
        return $8oTqd.FetchResponseError;
    }
});

$9529d518a516ff35$var$__exportStar((parcelRequire("fYfau")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("hoXKl")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("auA9I")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("6oTi5")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("lfpNx")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("gwEzH")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("fFwT5")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("90baw")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("3e91q")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("eXxXt")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("4H3QM")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("6aqH9")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("8vaR3")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("5u6ZB")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("lfiD0")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("fr8VS")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("5F6X2")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("gbHhk")), module.exports);

$9529d518a516ff35$var$__exportStar((parcelRequire("5QfU8")), module.exports);

});
parcelRegister("k2dJf", function(module, exports) {
"use strict";
var $03c3974dafbe68ad$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $03c3974dafbe68ad$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $03c3974dafbe68ad$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$03c3974dafbe68ad$var$__exportStar((parcelRequire("hoXKl")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("h8kQI")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("9NhYU")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("9x0MW")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("h0Y9m")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("fNvbt")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("kLeG9")), module.exports);

$03c3974dafbe68ad$var$__exportStar((parcelRequire("iPo4S")), module.exports);

});
parcelRegister("hoXKl", function(module, exports) {
"use strict";
var $cab305fac27e14fb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cab305fac27e14fb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cab305fac27e14fb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cab305fac27e14fb$var$__exportStar((parcelRequire("di7jZ")), module.exports);

$cab305fac27e14fb$var$__exportStar((parcelRequire("4vBZ2")), module.exports);

$cab305fac27e14fb$var$__exportStar((parcelRequire("1ucW1")), module.exports);

$cab305fac27e14fb$var$__exportStar((parcelRequire("8xDRX")), module.exports);

$cab305fac27e14fb$var$__exportStar((parcelRequire("2imNQ")), module.exports);

});
parcelRegister("di7jZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isAtprotoDidWeb = module.exports.assertAtprotoDidWeb = module.exports.assertAtprotoDid = module.exports.asAtprotoDid = module.exports.isAtprotoDid = void 0;

var $1ucW1 = parcelRequire("1ucW1");

var $2imNQ = parcelRequire("2imNQ");
function $9ad2a2b3a965ea28$var$isAtprotoDid(input) {
    // Optimized equivalent of:
    // return isDidPlc(input) || isAtprotoDidWeb(input)
    if (typeof input !== 'string') return false;
    else if (input.startsWith($2imNQ.DID_PLC_PREFIX)) return (0, $2imNQ.isDidPlc)(input);
    else if (input.startsWith($2imNQ.DID_WEB_PREFIX)) return $9ad2a2b3a965ea28$var$isAtprotoDidWeb(input);
    else return false;
}
module.exports.isAtprotoDid = $9ad2a2b3a965ea28$var$isAtprotoDid;
function $9ad2a2b3a965ea28$var$asAtprotoDid(input) {
    $9ad2a2b3a965ea28$var$assertAtprotoDid(input);
    return input;
}
module.exports.asAtprotoDid = $9ad2a2b3a965ea28$var$asAtprotoDid;
function $9ad2a2b3a965ea28$var$assertAtprotoDid(input) {
    if (typeof input !== 'string') throw new $1ucW1.InvalidDidError(typeof input, `DID must be a string`);
    else if (input.startsWith($2imNQ.DID_PLC_PREFIX)) (0, $2imNQ.assertDidPlc)(input);
    else if (input.startsWith($2imNQ.DID_WEB_PREFIX)) $9ad2a2b3a965ea28$var$assertAtprotoDidWeb(input);
    else throw new $1ucW1.InvalidDidError(input, `Atproto only allows "plc" and "web" DID methods`);
}
module.exports.assertAtprotoDid = $9ad2a2b3a965ea28$var$assertAtprotoDid;
function $9ad2a2b3a965ea28$var$assertAtprotoDidWeb(input) {
    (0, $2imNQ.assertDidWeb)(input);
    if (input.includes(':', $2imNQ.DID_WEB_PREFIX.length)) throw new $1ucW1.InvalidDidError(input, `Atproto does not allow path components in Web DIDs`);
    if (input.includes('%3A', $2imNQ.DID_WEB_PREFIX.length) && !input.startsWith('did:web:localhost%3A')) throw new $1ucW1.InvalidDidError(input, `Atproto does not allow port numbers in Web DIDs, except for localhost`);
}
module.exports.assertAtprotoDidWeb = $9ad2a2b3a965ea28$var$assertAtprotoDidWeb;
/**
 * @see {@link https://atproto.com/specs/did#blessed-did-methods}
 */ function $9ad2a2b3a965ea28$var$isAtprotoDidWeb(input) {
    try {
        $9ad2a2b3a965ea28$var$assertAtprotoDidWeb(input);
        return true;
    } catch  {
        return false;
    }
}
module.exports.isAtprotoDidWeb = $9ad2a2b3a965ea28$var$isAtprotoDidWeb;

});
parcelRegister("1ucW1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidDidError = module.exports.DidError = void 0;
class $1152a06229c1f991$var$DidError extends Error {
    constructor(did, message, code, status = 400, cause){
        super(message, {
            cause: cause
        });
        Object.defineProperty(this, "did", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: did
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: code
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: status
        });
    }
    /**
     * For compatibility with error handlers in common HTTP frameworks.
     */ get statusCode() {
        return this.status;
    }
    toString() {
        return `${this.constructor.name} ${this.code} (${this.did}): ${this.message}`;
    }
    static from(cause, did) {
        if (cause instanceof $1152a06229c1f991$var$DidError) return cause;
        const message = cause instanceof Error ? cause.message : typeof cause === 'string' ? cause : 'An unknown error occurred';
        const status = (typeof cause?.['statusCode'] === 'number' ? cause['statusCode'] : undefined) ?? (typeof cause?.['status'] === 'number' ? cause['status'] : undefined);
        return new $1152a06229c1f991$var$DidError(did, message, 'did-unknown-error', status, cause);
    }
}
module.exports.DidError = $1152a06229c1f991$var$DidError;
class $1152a06229c1f991$var$InvalidDidError extends $1152a06229c1f991$var$DidError {
    constructor(did, message, cause){
        super(did, message, 'did-invalid', 400, cause);
    }
}
module.exports.InvalidDidError = $1152a06229c1f991$var$InvalidDidError;

});

parcelRegister("2imNQ", function(module, exports) {
"use strict";
var $1abef36158b9e510$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1abef36158b9e510$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1abef36158b9e510$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1abef36158b9e510$var$__exportStar((parcelRequire("h8Isf")), module.exports);

$1abef36158b9e510$var$__exportStar((parcelRequire("aujvv")), module.exports);

});
parcelRegister("h8Isf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDidPlc = module.exports.asDidPlc = module.exports.isDidPlc = module.exports.DID_PLC_PREFIX = void 0;

var $1ucW1 = parcelRequire("1ucW1");
const $c7a5aac2ff3431d2$var$DID_PLC_PREFIX = `did:plc:`;
module.exports.DID_PLC_PREFIX = $c7a5aac2ff3431d2$var$DID_PLC_PREFIX;
const $c7a5aac2ff3431d2$var$DID_PLC_PREFIX_LENGTH = $c7a5aac2ff3431d2$var$DID_PLC_PREFIX.length;
const $c7a5aac2ff3431d2$var$DID_PLC_LENGTH = 32;
function $c7a5aac2ff3431d2$var$isDidPlc(input) {
    // Optimization: equivalent to try/catch around "assertDidPlc"
    if (typeof input !== 'string') return false;
    if (input.length !== $c7a5aac2ff3431d2$var$DID_PLC_LENGTH) return false;
    if (!input.startsWith($c7a5aac2ff3431d2$var$DID_PLC_PREFIX)) return false;
    for(let i = $c7a5aac2ff3431d2$var$DID_PLC_PREFIX_LENGTH; i < $c7a5aac2ff3431d2$var$DID_PLC_LENGTH; i++){
        if (!$c7a5aac2ff3431d2$var$isBase32Char(input.charCodeAt(i))) return false;
    }
    return true;
}
module.exports.isDidPlc = $c7a5aac2ff3431d2$var$isDidPlc;
function $c7a5aac2ff3431d2$var$asDidPlc(input) {
    $c7a5aac2ff3431d2$var$assertDidPlc(input);
    return input;
}
module.exports.asDidPlc = $c7a5aac2ff3431d2$var$asDidPlc;
function $c7a5aac2ff3431d2$var$assertDidPlc(input) {
    if (typeof input !== 'string') throw new $1ucW1.InvalidDidError(typeof input, `DID must be a string`);
    if (input.length !== $c7a5aac2ff3431d2$var$DID_PLC_LENGTH) throw new $1ucW1.InvalidDidError(input, `did:plc must be ${$c7a5aac2ff3431d2$var$DID_PLC_LENGTH} characters long`);
    if (!input.startsWith($c7a5aac2ff3431d2$var$DID_PLC_PREFIX)) throw new $1ucW1.InvalidDidError(input, `Invalid did:plc prefix`);
    // The following check is not necessary, as the check below is more strict:
    // assertDidMsid(input, DID_PLC_PREFIX.length)
    for(let i = $c7a5aac2ff3431d2$var$DID_PLC_PREFIX_LENGTH; i < $c7a5aac2ff3431d2$var$DID_PLC_LENGTH; i++){
        if (!$c7a5aac2ff3431d2$var$isBase32Char(input.charCodeAt(i))) throw new $1ucW1.InvalidDidError(input, `Invalid character at position ${i}`);
    }
}
module.exports.assertDidPlc = $c7a5aac2ff3431d2$var$assertDidPlc;
const $c7a5aac2ff3431d2$var$isBase32Char = (c)=>c >= 0x61 && c <= 0x7a || c >= 0x32 && c <= 0x37; // [a-z2-7]

});

parcelRegister("aujvv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.urlToDidWeb = module.exports.didWebToUrl = module.exports.assertDidWeb = module.exports.asDidWeb = module.exports.isDidWeb = module.exports.DID_WEB_PREFIX = void 0;

var $1ucW1 = parcelRequire("1ucW1");

var $8xDRX = parcelRequire("8xDRX");
module.exports.DID_WEB_PREFIX = `did:web:`;
/**
 * This function checks if the input is a valid Web DID, as per DID spec.
 */ function $7a2bd670f2648172$var$isDidWeb(input) {
    // Optimization: make cheap checks first
    if (typeof input !== 'string') return false;
    try {
        $7a2bd670f2648172$var$assertDidWeb(input);
        return true;
    } catch  {
        return false;
    }
}
module.exports.isDidWeb = $7a2bd670f2648172$var$isDidWeb;
function $7a2bd670f2648172$var$asDidWeb(input) {
    $7a2bd670f2648172$var$assertDidWeb(input);
    return input;
}
module.exports.asDidWeb = $7a2bd670f2648172$var$asDidWeb;
function $7a2bd670f2648172$var$assertDidWeb(input) {
    if (typeof input !== 'string') throw new $1ucW1.InvalidDidError(typeof input, `DID must be a string`);
    $7a2bd670f2648172$var$didWebToUrl(input);
}
module.exports.assertDidWeb = $7a2bd670f2648172$var$assertDidWeb;
function $7a2bd670f2648172$var$didWebToUrl(did) {
    if (!did.startsWith(module.exports.DID_WEB_PREFIX)) throw new $1ucW1.InvalidDidError(did, `did:web must start with ${module.exports.DID_WEB_PREFIX}`);
    if (did.charAt(module.exports.DID_WEB_PREFIX.length) === ':') throw new $1ucW1.InvalidDidError(did, 'did:web MSID must not start with a colon');
    // Make sure every char is valid (per DID spec)
    (0, $8xDRX.assertDidMsid)(did, module.exports.DID_WEB_PREFIX.length);
    try {
        const msid = did.slice(module.exports.DID_WEB_PREFIX.length);
        const parts = msid.split(':').map(decodeURIComponent);
        const url = new URL(`https://${parts.join('/')}`);
        if (url.hostname === 'localhost') url.protocol = 'http:';
        return url;
    } catch (cause) {
        throw new $1ucW1.InvalidDidError(did, 'Invalid Web DID', cause);
    }
}
module.exports.didWebToUrl = $7a2bd670f2648172$var$didWebToUrl;
function $7a2bd670f2648172$var$urlToDidWeb(url) {
    const path = url.pathname === '/' ? '' : url.pathname.slice(1).split('/').map(encodeURIComponent).join(':');
    return `did:web:${encodeURIComponent(url.host)}${path ? `:${path}` : ''}`;
}
module.exports.urlToDidWeb = $7a2bd670f2648172$var$urlToDidWeb;

});
parcelRegister("8xDRX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.didSchema = module.exports.asDid = module.exports.isDid = module.exports.assertDid = module.exports.assertDidMsid = module.exports.extractDidMethod = module.exports.assertDidMethod = module.exports.DID_PREFIX = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $1ucW1 = parcelRequire("1ucW1");
const $6380550494a93d86$var$DID_PREFIX = 'did:';
module.exports.DID_PREFIX = $6380550494a93d86$var$DID_PREFIX;
const $6380550494a93d86$var$DID_PREFIX_LENGTH = $6380550494a93d86$var$DID_PREFIX.length;
/**
 * DID Method-name check function.
 *
 * Check if the input is a valid DID method name, at the position between
 * `start` (inclusive) and `end` (exclusive).
 */ function $6380550494a93d86$var$assertDidMethod(input, start = 0, end = input.length) {
    if (!Number.isFinite(end) || !Number.isFinite(start) || end < start || end > input.length) throw new TypeError('Invalid start or end position');
    if (end === start) throw new $1ucW1.InvalidDidError(input, `Empty method name`);
    let c;
    for(let i = start; i < end; i++){
        c = input.charCodeAt(i);
        if ((c < 0x61 || c > 0x7a) && // a-z
        (c < 0x30 || c > 0x39 // 0-9
        )) throw new $1ucW1.InvalidDidError(input, `Invalid character at position ${i} in DID method name`);
    }
}
module.exports.assertDidMethod = $6380550494a93d86$var$assertDidMethod;
/**
 * This method assumes the input is a valid Did
 */ function $6380550494a93d86$var$extractDidMethod(did) {
    const msidSep = did.indexOf(':', $6380550494a93d86$var$DID_PREFIX_LENGTH);
    const method = did.slice($6380550494a93d86$var$DID_PREFIX_LENGTH, msidSep);
    return method;
}
module.exports.extractDidMethod = $6380550494a93d86$var$extractDidMethod;
/**
 * DID Method-specific identifier check function.
 *
 * Check if the input is a valid DID method-specific identifier, at the position
 * between `start` (inclusive) and `end` (exclusive).
 */ function $6380550494a93d86$var$assertDidMsid(input, start = 0, end = input.length) {
    if (!Number.isFinite(end) || !Number.isFinite(start) || end < start || end > input.length) throw new TypeError('Invalid start or end position');
    if (end === start) throw new $1ucW1.InvalidDidError(input, `DID method-specific id must not be empty`);
    let c;
    for(let i = start; i < end; i++){
        c = input.charCodeAt(i);
        // Check for frequent chars first
        if ((c < 0x61 || c > 0x7a) && // a-z
        (c < 0x41 || c > 0x5a) && // A-Z
        (c < 0x30 || c > 0x39) && // 0-9
        c !== 0x2e && // .
        c !== 0x2d && // -
        c !== 0x5f // _
        ) {
            // Less frequent chars are checked here
            // ":"
            if (c === 0x3a) {
                if (i === end - 1) throw new $1ucW1.InvalidDidError(input, `DID cannot end with ":"`);
                continue;
            }
            // pct-encoded
            if (c === 0x25) {
                c = input.charCodeAt(++i);
                if ((c < 0x30 || c > 0x39) && (c < 0x41 || c > 0x46)) throw new $1ucW1.InvalidDidError(input, `Invalid pct-encoded character at position ${i}`);
                c = input.charCodeAt(++i);
                if ((c < 0x30 || c > 0x39) && (c < 0x41 || c > 0x46)) throw new $1ucW1.InvalidDidError(input, `Invalid pct-encoded character at position ${i}`);
                // There must always be 2 HEXDIG after a "%"
                if (i >= end) throw new $1ucW1.InvalidDidError(input, `Incomplete pct-encoded character at position ${i - 2}`);
                continue;
            }
            throw new $1ucW1.InvalidDidError(input, `Disallowed character in DID at position ${i}`);
        }
    }
}
module.exports.assertDidMsid = $6380550494a93d86$var$assertDidMsid;
function $6380550494a93d86$var$assertDid(input) {
    if (typeof input !== 'string') throw new $1ucW1.InvalidDidError(typeof input, `DID must be a string`);
    const { length: length } = input;
    if (length > 2048) throw new $1ucW1.InvalidDidError(input, `DID is too long (2048 chars max)`);
    if (!input.startsWith($6380550494a93d86$var$DID_PREFIX)) throw new $1ucW1.InvalidDidError(input, `DID requires "${$6380550494a93d86$var$DID_PREFIX}" prefix`);
    const idSep = input.indexOf(':', $6380550494a93d86$var$DID_PREFIX_LENGTH);
    if (idSep === -1) throw new $1ucW1.InvalidDidError(input, `Missing colon after method name`);
    $6380550494a93d86$var$assertDidMethod(input, $6380550494a93d86$var$DID_PREFIX_LENGTH, idSep);
    $6380550494a93d86$var$assertDidMsid(input, idSep + 1, length);
}
module.exports.assertDid = $6380550494a93d86$var$assertDid;
function $6380550494a93d86$var$isDid(input) {
    try {
        $6380550494a93d86$var$assertDid(input);
        return true;
    } catch (err) {
        if (err instanceof $1ucW1.DidError) return false;
        // Unexpected TypeError (should never happen)
        throw err;
    }
}
module.exports.isDid = $6380550494a93d86$var$isDid;
function $6380550494a93d86$var$asDid(input) {
    $6380550494a93d86$var$assertDid(input);
    return input;
}
module.exports.asDid = $6380550494a93d86$var$asDid;
module.exports.didSchema = $2zDt6.z.string().superRefine((value, ctx)=>{
    try {
        $6380550494a93d86$var$assertDid(value);
        return true;
    } catch (err) {
        ctx.addIssue({
            code: $2zDt6.z.ZodIssueCode.custom,
            message: err instanceof Error ? err.message : 'Unexpected error'
        });
        return false;
    }
});

});




parcelRegister("4vBZ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.didDocumentValidator = module.exports.didDocumentSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $8xDRX = parcelRequire("8xDRX");
/**
 * RFC3968 compliant URI
 *
 * @see {@link https://www.rfc-editor.org/rfc/rfc3986}
 */ const $34878568ec6ab058$var$rfc3968UriSchema = $2zDt6.z.string().refine((data)=>{
    try {
        new URL(data);
        return true;
    } catch  {
        return false;
    }
}, 'RFC3968 compliant URI');
const $34878568ec6ab058$var$didControllerSchema = $2zDt6.z.union([
    $8xDRX.didSchema,
    $2zDt6.z.array($8xDRX.didSchema)
]);
/**
 * @note this schema might be too permissive
 */ const $34878568ec6ab058$var$didRelativeUriSchema = $2zDt6.z.union([
    $34878568ec6ab058$var$rfc3968UriSchema,
    $2zDt6.z.string().regex(/^#[^#]+$/)
]);
const $34878568ec6ab058$var$didVerificationMethodSchema = $2zDt6.z.object({
    id: $34878568ec6ab058$var$didRelativeUriSchema,
    type: $2zDt6.z.string().min(1),
    controller: $34878568ec6ab058$var$didControllerSchema,
    publicKeyJwk: $2zDt6.z.record($2zDt6.z.string(), $2zDt6.z.unknown()).optional(),
    publicKeyMultibase: $2zDt6.z.string().optional()
});
/**
 * The value of the id property MUST be a URI conforming to [RFC3986]. A
 * conforming producer MUST NOT produce multiple service entries with the same
 * id. A conforming consumer MUST produce an error if it detects multiple
 * service entries with the same id.
 *
 * @note Normally, only rfc3968UriSchema should be allowed here. However, the
 *   did:plc uses relative URI. For this reason, we also allow relative URIs
 *   here.
 */ const $34878568ec6ab058$var$didServiceIdSchema = $34878568ec6ab058$var$didRelativeUriSchema;
/**
 * The value of the type property MUST be a string or a set of strings. In order
 * to maximize interoperability, the service type and its associated properties
 * SHOULD be registered in the DID Specification Registries
 * [DID-SPEC-REGISTRIES].
 */ const $34878568ec6ab058$var$didServiceTypeSchema = $2zDt6.z.union([
    $2zDt6.z.string(),
    $2zDt6.z.array($2zDt6.z.string())
]);
/**
 * The value of the serviceEndpoint property MUST be a string, a map, or a set
 * composed of one or more strings and/or maps. All string values MUST be valid
 * URIs conforming to [RFC3986] and normalized according to the Normalization
 * and Comparison rules in RFC3986 and to any normalization rules in its
 * applicable URI scheme specification.
 */ const $34878568ec6ab058$var$didServiceEndpointSchema = $2zDt6.z.union([
    $34878568ec6ab058$var$rfc3968UriSchema,
    $2zDt6.z.record($2zDt6.z.string(), $34878568ec6ab058$var$rfc3968UriSchema),
    $2zDt6.z.array($2zDt6.z.union([
        $34878568ec6ab058$var$rfc3968UriSchema,
        $2zDt6.z.record($2zDt6.z.string(), $34878568ec6ab058$var$rfc3968UriSchema)
    ])).nonempty()
]);
/**
 * Each service map MUST contain id, type, and serviceEndpoint properties.
 * @see {@link https://www.w3.org/TR/did-core/#services}
 */ const $34878568ec6ab058$var$didServiceSchema = $2zDt6.z.object({
    id: $34878568ec6ab058$var$didServiceIdSchema,
    type: $34878568ec6ab058$var$didServiceTypeSchema,
    serviceEndpoint: $34878568ec6ab058$var$didServiceEndpointSchema
});
const $34878568ec6ab058$var$didAuthenticationSchema = $2zDt6.z.union([
    //
    $34878568ec6ab058$var$didRelativeUriSchema,
    $34878568ec6ab058$var$didVerificationMethodSchema
]);
/**
 * @note This schema is incomplete
 * @see {@link https://www.w3.org/TR/did-core/#production-0}
 */ module.exports.didDocumentSchema = $2zDt6.z.object({
    '@context': $2zDt6.z.union([
        $2zDt6.z.literal('https://www.w3.org/ns/did/v1'),
        $2zDt6.z.array($2zDt6.z.string().url()).nonempty().refine((data)=>data[0] === 'https://www.w3.org/ns/did/v1', {
            message: 'First @context must be https://www.w3.org/ns/did/v1'
        })
    ]),
    id: $8xDRX.didSchema,
    controller: $34878568ec6ab058$var$didControllerSchema.optional(),
    alsoKnownAs: $2zDt6.z.array($34878568ec6ab058$var$rfc3968UriSchema).optional(),
    service: $2zDt6.z.array($34878568ec6ab058$var$didServiceSchema).optional(),
    authentication: $2zDt6.z.array($34878568ec6ab058$var$didAuthenticationSchema).optional(),
    verificationMethod: $2zDt6.z.array($2zDt6.z.union([
        $34878568ec6ab058$var$didVerificationMethodSchema,
        $34878568ec6ab058$var$didRelativeUriSchema
    ])).optional()
});
// @TODO: add other refinements ?
module.exports.didDocumentValidator = module.exports.didDocumentSchema// Ensure that every service id is unique
.superRefine(({ id: did, service: service }, ctx)=>{
    if (service) {
        const visited = new Set();
        for(let i = 0; i < service.length; i++){
            const current = service[i];
            const serviceId = current.id.startsWith('#') ? `${did}${current.id}` : current.id;
            if (!visited.has(serviceId)) visited.add(serviceId);
            else ctx.addIssue({
                code: $2zDt6.z.ZodIssueCode.custom,
                message: `Duplicate service id (${current.id}) found in the document`,
                path: [
                    'service',
                    i,
                    'id'
                ]
            });
        }
    }
});

});


parcelRegister("h8kQI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidCacheMemory = void 0;

var $9eBhV = parcelRequire("9eBhV");
const $c7935b41b3a49136$var$DEFAULT_TTL = 3600000; // 1 hour
const $c7935b41b3a49136$var$DEFAULT_MAX_SIZE = 52428800; // ~50MB
class $c7935b41b3a49136$var$DidCacheMemory extends $9eBhV.SimpleStoreMemory {
    constructor(options){
        super(options?.max == null ? {
            ttl: $c7935b41b3a49136$var$DEFAULT_TTL,
            maxSize: $c7935b41b3a49136$var$DEFAULT_MAX_SIZE,
            ...options
        } : {
            ttl: $c7935b41b3a49136$var$DEFAULT_TTL,
            ...options
        });
    }
}
module.exports.DidCacheMemory = $c7935b41b3a49136$var$DidCacheMemory;

});
parcelRegister("9eBhV", function(module, exports) {
"use strict";
var $6b92587be94aa254$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6b92587be94aa254$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6b92587be94aa254$var$_SimpleStoreMemory_cache;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleStoreMemory = void 0;

var $cqpOy = parcelRequire("cqpOy");

var $Xr4fk = parcelRequire("Xr4fk");
// LRUCache does not allow storing "null", so we use a symbol to represent it.
const $6b92587be94aa254$var$nullSymbol = Symbol('nullItem');
const $6b92587be94aa254$var$toLruValue = (value)=>value === null ? $6b92587be94aa254$var$nullSymbol : value;
const $6b92587be94aa254$var$fromLruValue = (value)=>value === $6b92587be94aa254$var$nullSymbol ? null : value;
class $6b92587be94aa254$var$SimpleStoreMemory {
    constructor({ sizeCalculation: sizeCalculation, ...options }){
        $6b92587be94aa254$var$_SimpleStoreMemory_cache.set(this, void 0);
        $6b92587be94aa254$var$__classPrivateFieldSet(this, $6b92587be94aa254$var$_SimpleStoreMemory_cache, new $cqpOy.LRUCache({
            ...options,
            allowStale: false,
            updateAgeOnGet: false,
            updateAgeOnHas: false,
            sizeCalculation: sizeCalculation ? (value, key)=>sizeCalculation($6b92587be94aa254$var$fromLruValue(value), key) : options.maxEntrySize != null || options.maxSize != null ? $Xr4fk.roughSizeOfObject : undefined
        }), "f");
    }
    get(key) {
        const value = $6b92587be94aa254$var$__classPrivateFieldGet(this, $6b92587be94aa254$var$_SimpleStoreMemory_cache, "f").get(key);
        if (value === undefined) return undefined;
        return $6b92587be94aa254$var$fromLruValue(value);
    }
    set(key, value) {
        $6b92587be94aa254$var$__classPrivateFieldGet(this, $6b92587be94aa254$var$_SimpleStoreMemory_cache, "f").set(key, $6b92587be94aa254$var$toLruValue(value));
    }
    del(key) {
        $6b92587be94aa254$var$__classPrivateFieldGet(this, $6b92587be94aa254$var$_SimpleStoreMemory_cache, "f").delete(key);
    }
    clear() {
        $6b92587be94aa254$var$__classPrivateFieldGet(this, $6b92587be94aa254$var$_SimpleStoreMemory_cache, "f").clear();
    }
}
module.exports.SimpleStoreMemory = $6b92587be94aa254$var$SimpleStoreMemory;
$6b92587be94aa254$var$_SimpleStoreMemory_cache = new WeakMap();

});
parcelRegister("cqpOy", function(module, exports) {

$parcel$export(module.exports, "LRUCache", () => $90bbefef4dc25bab$export$182500e6725aad9a);
/**
 * @module LRUCache
 */ const $90bbefef4dc25bab$var$perf = typeof performance === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
const $90bbefef4dc25bab$var$warned = new Set();
/* c8 ignore start */ const $90bbefef4dc25bab$var$PROCESS = {};
/* c8 ignore start */ const $90bbefef4dc25bab$var$emitWarning = (msg, type, code, fn)=>{
    typeof $90bbefef4dc25bab$var$PROCESS.emitWarning === 'function' ? $90bbefef4dc25bab$var$PROCESS.emitWarning(msg, type, code, fn) : console.error(`[${code}] ${type}: ${msg}`);
};
let $90bbefef4dc25bab$var$AC = globalThis.AbortController;
let $90bbefef4dc25bab$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $90bbefef4dc25bab$var$AC === 'undefined') {
    //@ts-ignore
    $90bbefef4dc25bab$var$AS = class AbortSignal {
        onabort;
        _onabort = [];
        reason;
        aborted = false;
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
    };
    //@ts-ignore
    $90bbefef4dc25bab$var$AC = class AbortController {
        constructor(){
            warnACPolyfill();
        }
        signal = new $90bbefef4dc25bab$var$AS();
        abort(reason) {
            if (this.signal.aborted) return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort)fn(reason);
            this.signal.onabort?.(reason);
        }
    };
    let printACPolyfillWarning = $90bbefef4dc25bab$var$PROCESS.env?.LRU_CACHE_IGNORE_AC_WARNING !== '1';
    const warnACPolyfill = ()=>{
        if (!printACPolyfillWarning) return;
        printACPolyfillWarning = false;
        $90bbefef4dc25bab$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
    };
}
/* c8 ignore stop */ const $90bbefef4dc25bab$var$shouldWarn = (code)=>!$90bbefef4dc25bab$var$warned.has(code);
const $90bbefef4dc25bab$var$TYPE = Symbol('type');
const $90bbefef4dc25bab$var$isPosInt = (n)=>n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const $90bbefef4dc25bab$var$getUintArray = (max)=>!$90bbefef4dc25bab$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $90bbefef4dc25bab$var$ZeroArray : null;
/* c8 ignore stop */ class $90bbefef4dc25bab$var$ZeroArray extends Array {
    constructor(size){
        super(size);
        this.fill(0);
    }
}
class $90bbefef4dc25bab$var$Stack {
    heap;
    length;
    // private constructor
    static #constructing = false;
    static create(max) {
        const HeapCls = $90bbefef4dc25bab$var$getUintArray(max);
        if (!HeapCls) return [];
        $90bbefef4dc25bab$var$Stack.#constructing = true;
        const s = new $90bbefef4dc25bab$var$Stack(max, HeapCls);
        $90bbefef4dc25bab$var$Stack.#constructing = false;
        return s;
    }
    constructor(max, HeapCls){
        /* c8 ignore start */ if (!$90bbefef4dc25bab$var$Stack.#constructing) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
}
class $90bbefef4dc25bab$export$182500e6725aad9a {
    // options that cannot be changed without disaster
    #max;
    #maxSize;
    #dispose;
    #disposeAfter;
    #fetchMethod;
    #memoMethod;
    /**
     * {@link LRUCache.OptionsBase.ttl}
     */ ttl;
    /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ ttlResolution;
    /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ ttlAutopurge;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ updateAgeOnGet;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ updateAgeOnHas;
    /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ allowStale;
    /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ noDisposeOnSet;
    /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ noUpdateTTL;
    /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ maxEntrySize;
    /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ sizeCalculation;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ noDeleteOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ noDeleteOnStaleGet;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ allowStaleOnFetchAbort;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ allowStaleOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ ignoreFetchAbort;
    // computed properties
    #size;
    #calculatedSize;
    #keyMap;
    #keyList;
    #valList;
    #next;
    #prev;
    #head;
    #tail;
    #free;
    #disposed;
    #sizes;
    #starts;
    #ttls;
    #hasDispose;
    #hasFetchMethod;
    #hasDisposeAfter;
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ static unsafeExposeInternals(c) {
        return {
            // properties
            starts: c.#starts,
            ttls: c.#ttls,
            sizes: c.#sizes,
            keyMap: c.#keyMap,
            keyList: c.#keyList,
            valList: c.#valList,
            next: c.#next,
            prev: c.#prev,
            get head () {
                return c.#head;
            },
            get tail () {
                return c.#tail;
            },
            free: c.#free,
            // methods
            isBackgroundFetch: (p)=>c.#isBackgroundFetch(p),
            backgroundFetch: (k, index, options, context)=>c.#backgroundFetch(k, index, options, context),
            moveToTail: (index)=>c.#moveToTail(index),
            indexes: (options)=>c.#indexes(options),
            rindexes: (options)=>c.#rindexes(options),
            isStale: (index)=>c.#isStale(index)
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ get max() {
        return this.#max;
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ get maxSize() {
        return this.#maxSize;
    }
    /**
     * The total computed size of items in the cache (read-only)
     */ get calculatedSize() {
        return this.#calculatedSize;
    }
    /**
     * The number of items stored in the cache (read-only)
     */ get size() {
        return this.#size;
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ get fetchMethod() {
        return this.#fetchMethod;
    }
    get memoMethod() {
        return this.#memoMethod;
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ get dispose() {
        return this.#dispose;
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ get disposeAfter() {
        return this.#disposeAfter;
    }
    constructor(options){
        const { max: max = 0, ttl: ttl, ttlResolution: ttlResolution = 1, ttlAutopurge: ttlAutopurge, updateAgeOnGet: updateAgeOnGet, updateAgeOnHas: updateAgeOnHas, allowStale: allowStale, dispose: dispose, disposeAfter: disposeAfter, noDisposeOnSet: noDisposeOnSet, noUpdateTTL: noUpdateTTL, maxSize: maxSize = 0, maxEntrySize: maxEntrySize = 0, sizeCalculation: sizeCalculation, fetchMethod: fetchMethod, memoMethod: memoMethod, noDeleteOnFetchRejection: noDeleteOnFetchRejection, noDeleteOnStaleGet: noDeleteOnStaleGet, allowStaleOnFetchRejection: allowStaleOnFetchRejection, allowStaleOnFetchAbort: allowStaleOnFetchAbort, ignoreFetchAbort: ignoreFetchAbort } = options;
        if (max !== 0 && !$90bbefef4dc25bab$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        const UintArray = max ? $90bbefef4dc25bab$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        this.#max = max;
        this.#maxSize = maxSize;
        this.maxEntrySize = maxEntrySize || this.#maxSize;
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!this.#maxSize && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        this.#memoMethod = memoMethod;
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        this.#fetchMethod = fetchMethod;
        this.#hasFetchMethod = !!fetchMethod;
        this.#keyMap = new Map();
        this.#keyList = new Array(max).fill(undefined);
        this.#valList = new Array(max).fill(undefined);
        this.#next = new UintArray(max);
        this.#prev = new UintArray(max);
        this.#head = 0;
        this.#tail = 0;
        this.#free = $90bbefef4dc25bab$var$Stack.create(max);
        this.#size = 0;
        this.#calculatedSize = 0;
        if (typeof dispose === 'function') this.#dispose = dispose;
        if (typeof disposeAfter === 'function') {
            this.#disposeAfter = disposeAfter;
            this.#disposed = [];
        } else {
            this.#disposeAfter = undefined;
            this.#disposed = undefined;
        }
        this.#hasDispose = !!this.#dispose;
        this.#hasDisposeAfter = !!this.#disposeAfter;
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if (this.#maxSize !== 0) {
                if (!$90bbefef4dc25bab$var$isPosInt(this.#maxSize)) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$90bbefef4dc25bab$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            this.#initializeSizeTracking();
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $90bbefef4dc25bab$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$90bbefef4dc25bab$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            this.#initializeTTLTracking();
        }
        // do not allow completely unbounded caches
        if (this.#max === 0 && this.ttl === 0 && this.#maxSize === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !this.#max && !this.#maxSize) {
            const code = 'LRU_CACHE_UNBOUNDED';
            if ($90bbefef4dc25bab$var$shouldWarn(code)) {
                $90bbefef4dc25bab$var$warned.add(code);
                const msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $90bbefef4dc25bab$var$emitWarning(msg, 'UnboundedCacheWarning', code, $90bbefef4dc25bab$export$182500e6725aad9a);
            }
        }
    }
    /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ getRemainingTTL(key) {
        return this.#keyMap.has(key) ? Infinity : 0;
    }
    #initializeTTLTracking() {
        const ttls = new $90bbefef4dc25bab$var$ZeroArray(this.#max);
        const starts = new $90bbefef4dc25bab$var$ZeroArray(this.#max);
        this.#ttls = ttls;
        this.#starts = starts;
        this.#setItemTTL = (index, ttl, start = $90bbefef4dc25bab$var$perf.now())=>{
            starts[index] = ttl !== 0 ? start : 0;
            ttls[index] = ttl;
            if (ttl !== 0 && this.ttlAutopurge) {
                const t = setTimeout(()=>{
                    if (this.#isStale(index)) this.#delete(this.#keyList[index], 'expire');
                }, ttl + 1);
                // unref() not supported on all platforms
                /* c8 ignore start */ if (t.unref) t.unref();
            /* c8 ignore stop */ }
        };
        this.#updateItemAge = (index)=>{
            starts[index] = ttls[index] !== 0 ? $90bbefef4dc25bab$var$perf.now() : 0;
        };
        this.#statusTTL = (status, index)=>{
            if (ttls[index]) {
                const ttl = ttls[index];
                const start = starts[index];
                /* c8 ignore next */ if (!ttl || !start) return;
                status.ttl = ttl;
                status.start = start;
                status.now = cachedNow || getNow();
                const age = status.now - start;
                status.remainingTTL = ttl - age;
            }
        };
        // debounce calls to perf.now() to 1s so we're not hitting
        // that costly call repeatedly.
        let cachedNow = 0;
        const getNow = ()=>{
            const n = $90bbefef4dc25bab$var$perf.now();
            if (this.ttlResolution > 0) {
                cachedNow = n;
                const t = setTimeout(()=>cachedNow = 0, this.ttlResolution);
                // not available on all platforms
                /* c8 ignore start */ if (t.unref) t.unref();
            /* c8 ignore stop */ }
            return n;
        };
        this.getRemainingTTL = (key)=>{
            const index = this.#keyMap.get(key);
            if (index === undefined) return 0;
            const ttl = ttls[index];
            const start = starts[index];
            if (!ttl || !start) return Infinity;
            const age = (cachedNow || getNow()) - start;
            return ttl - age;
        };
        this.#isStale = (index)=>{
            const s = starts[index];
            const t = ttls[index];
            return !!t && !!s && (cachedNow || getNow()) - s > t;
        };
    }
    // conditionally set private methods related to TTL
    #updateItemAge = ()=>{};
    #statusTTL = ()=>{};
    #setItemTTL = ()=>{};
    /* c8 ignore stop */ #isStale = ()=>false;
    #initializeSizeTracking() {
        const sizes = new $90bbefef4dc25bab$var$ZeroArray(this.#max);
        this.#calculatedSize = 0;
        this.#sizes = sizes;
        this.#removeItemSize = (index)=>{
            this.#calculatedSize -= sizes[index];
            sizes[index] = 0;
        };
        this.#requireSize = (k, v, size, sizeCalculation)=>{
            // provisionally accept background fetches.
            // actual value size will be checked when they return.
            if (this.#isBackgroundFetch(v)) return 0;
            if (!$90bbefef4dc25bab$var$isPosInt(size)) {
                if (sizeCalculation) {
                    if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                    size = sizeCalculation(v, k);
                    if (!$90bbefef4dc25bab$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
                } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
            }
            return size;
        };
        this.#addItemSize = (index, size, status)=>{
            sizes[index] = size;
            if (this.#maxSize) {
                const maxSize = this.#maxSize - sizes[index];
                while(this.#calculatedSize > maxSize)this.#evict(true);
            }
            this.#calculatedSize += sizes[index];
            if (status) {
                status.entrySize = size;
                status.totalCalculatedSize = this.#calculatedSize;
            }
        };
    }
    #removeItemSize = (_i)=>{};
    #addItemSize = (_i, _s, _st)=>{};
    #requireSize = (_k, _v, size, sizeCalculation)=>{
        if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
        return 0;
    };
    *#indexes({ allowStale: allowStale = this.allowStale } = {}) {
        if (this.#size) for(let i = this.#tail;;){
            if (!this.#isValidIndex(i)) break;
            if (allowStale || !this.#isStale(i)) yield i;
            if (i === this.#head) break;
            else i = this.#prev[i];
        }
    }
    *#rindexes({ allowStale: allowStale = this.allowStale } = {}) {
        if (this.#size) for(let i = this.#head;;){
            if (!this.#isValidIndex(i)) break;
            if (allowStale || !this.#isStale(i)) yield i;
            if (i === this.#tail) break;
            else i = this.#next[i];
        }
    }
    #isValidIndex(index) {
        return index !== undefined && this.#keyMap.get(this.#keyList[index]) === index;
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ *entries() {
        for (const i of this.#indexes())if (this.#valList[i] !== undefined && this.#keyList[i] !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield [
            this.#keyList[i],
            this.#valList[i]
        ];
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ *rentries() {
        for (const i of this.#rindexes())if (this.#valList[i] !== undefined && this.#keyList[i] !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield [
            this.#keyList[i],
            this.#valList[i]
        ];
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ *keys() {
        for (const i of this.#indexes()){
            const k = this.#keyList[i];
            if (k !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield k;
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ *rkeys() {
        for (const i of this.#rindexes()){
            const k = this.#keyList[i];
            if (k !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield k;
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ *values() {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            if (v !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield this.#valList[i];
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ *rvalues() {
        for (const i of this.#rindexes()){
            const v = this.#valList[i];
            if (v !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield this.#valList[i];
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ [Symbol.toStringTag] = 'LRUCache';
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ find(fn, getOptions = {}) {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            if (fn(value, this.#keyList[i], this)) return this.get(this.#keyList[i], getOptions);
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ forEach(fn, thisp = this) {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ rforEach(fn, thisp = this) {
        for (const i of this.#rindexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ purgeStale() {
        let deleted = false;
        for (const i of this.#rindexes({
            allowStale: true
        }))if (this.#isStale(i)) {
            this.#delete(this.#keyList[i], 'expire');
            deleted = true;
        }
        return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ info(key) {
        const i = this.#keyMap.get(key);
        if (i === undefined) return undefined;
        const v = this.#valList[i];
        const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
        if (value === undefined) return undefined;
        const entry = {
            value: value
        };
        if (this.#ttls && this.#starts) {
            const ttl = this.#ttls[i];
            const start = this.#starts[i];
            if (ttl && start) {
                const remain = ttl - ($90bbefef4dc25bab$var$perf.now() - start);
                entry.ttl = remain;
                entry.start = Date.now();
            }
        }
        if (this.#sizes) entry.size = this.#sizes[i];
        return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ dump() {
        const arr = [];
        for (const i of this.#indexes({
            allowStale: true
        })){
            const key = this.#keyList[i];
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined || key === undefined) continue;
            const entry = {
                value: value
            };
            if (this.#ttls && this.#starts) {
                entry.ttl = this.#ttls[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = $90bbefef4dc25bab$var$perf.now() - this.#starts[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if (this.#sizes) entry.size = this.#sizes[i];
            arr.unshift([
                key,
                entry
            ]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ load(arr) {
        this.clear();
        for (const [key, entry] of arr){
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = $90bbefef4dc25bab$var$perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ set(k, v, setOptions = {}) {
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl: ttl = this.ttl, start: start, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, sizeCalculation: sizeCalculation = this.sizeCalculation, status: status } = setOptions;
        let { noUpdateTTL: noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = this.#requireSize(k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = 'miss';
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            this.#delete(k, 'set');
            return this;
        }
        let index = this.#size === 0 ? undefined : this.#keyMap.get(k);
        if (index === undefined) {
            // addition
            index = this.#size === 0 ? this.#tail : this.#free.length !== 0 ? this.#free.pop() : this.#size === this.#max ? this.#evict(false) : this.#size;
            this.#keyList[index] = k;
            this.#valList[index] = v;
            this.#keyMap.set(k, index);
            this.#next[this.#tail] = index;
            this.#prev[index] = this.#tail;
            this.#tail = index;
            this.#size++;
            this.#addItemSize(index, size, status);
            if (status) status.set = 'add';
            noUpdateTTL = false;
        } else {
            // update
            this.#moveToTail(index);
            const oldVal = this.#valList[index];
            if (v !== oldVal) {
                if (this.#hasFetchMethod && this.#isBackgroundFetch(oldVal)) {
                    oldVal.__abortController.abort(new Error('replaced'));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        if (this.#hasDispose) this.#dispose?.(s, k, 'set');
                        if (this.#hasDisposeAfter) this.#disposed?.push([
                            s,
                            k,
                            'set'
                        ]);
                    }
                } else if (!noDisposeOnSet) {
                    if (this.#hasDispose) this.#dispose?.(oldVal, k, 'set');
                    if (this.#hasDisposeAfter) this.#disposed?.push([
                        oldVal,
                        k,
                        'set'
                    ]);
                }
                this.#removeItemSize(index);
                this.#addItemSize(index, size, status);
                this.#valList[index] = v;
                if (status) {
                    status.set = 'replace';
                    const oldValue = oldVal && this.#isBackgroundFetch(oldVal) ? oldVal.__staleWhileFetching : oldVal;
                    if (oldValue !== undefined) status.oldValue = oldValue;
                }
            } else if (status) status.set = 'update';
        }
        if (ttl !== 0 && !this.#ttls) this.#initializeTTLTracking();
        if (this.#ttls) {
            if (!noUpdateTTL) this.#setItemTTL(index, ttl, start);
            if (status) this.#statusTTL(status, index);
        }
        if (!noDisposeOnSet && this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ pop() {
        try {
            while(this.#size){
                const val = this.#valList[this.#head];
                this.#evict(true);
                if (this.#isBackgroundFetch(val)) {
                    if (val.__staleWhileFetching) return val.__staleWhileFetching;
                } else if (val !== undefined) return val;
            }
        } finally{
            if (this.#hasDisposeAfter && this.#disposed) {
                const dt = this.#disposed;
                let task;
                while(task = dt?.shift())this.#disposeAfter?.(...task);
            }
        }
    }
    #evict(free) {
        const head = this.#head;
        const k = this.#keyList[head];
        const v = this.#valList[head];
        if (this.#hasFetchMethod && this.#isBackgroundFetch(v)) v.__abortController.abort(new Error('evicted'));
        else if (this.#hasDispose || this.#hasDisposeAfter) {
            if (this.#hasDispose) this.#dispose?.(v, k, 'evict');
            if (this.#hasDisposeAfter) this.#disposed?.push([
                v,
                k,
                'evict'
            ]);
        }
        this.#removeItemSize(head);
        // if we aren't about to use the index, then null these out
        if (free) {
            this.#keyList[head] = undefined;
            this.#valList[head] = undefined;
            this.#free.push(head);
        }
        if (this.#size === 1) {
            this.#head = this.#tail = 0;
            this.#free.length = 0;
        } else this.#head = this.#next[head];
        this.#keyMap.delete(k);
        this.#size--;
        return head;
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ has(k, hasOptions = {}) {
        const { updateAgeOnHas: updateAgeOnHas = this.updateAgeOnHas, status: status } = hasOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v) && v.__staleWhileFetching === undefined) return false;
            if (!this.#isStale(index)) {
                if (updateAgeOnHas) this.#updateItemAge(index);
                if (status) {
                    status.has = 'hit';
                    this.#statusTTL(status, index);
                }
                return true;
            } else if (status) {
                status.has = 'stale';
                this.#statusTTL(status, index);
            }
        } else if (status) status.has = 'miss';
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ peek(k, peekOptions = {}) {
        const { allowStale: allowStale = this.allowStale } = peekOptions;
        const index = this.#keyMap.get(k);
        if (index === undefined || !allowStale && this.#isStale(index)) return;
        const v = this.#valList[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
    }
    #backgroundFetch(k, index, options, context) {
        const v = index === undefined ? undefined : this.#valList[index];
        if (this.#isBackgroundFetch(v)) return v;
        const ac = new $90bbefef4dc25bab$var$AC();
        const { signal: signal } = options;
        // when/if our AC signals, then stop listening to theirs.
        signal?.addEventListener('abort', ()=>ac.abort(signal.reason), {
            signal: ac.signal
        });
        const fetchOpts = {
            signal: ac.signal,
            options: options,
            context: context
        };
        const cb = (v, updateCache = false)=>{
            const { aborted: aborted } = ac.signal;
            const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
            if (options.status) {
                if (aborted && !updateCache) {
                    options.status.fetchAborted = true;
                    options.status.fetchError = ac.signal.reason;
                    if (ignoreAbort) options.status.fetchAbortIgnored = true;
                } else options.status.fetchResolved = true;
            }
            if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
            // either we didn't abort, and are still here, or we did, and ignored
            const bf = p;
            if (this.#valList[index] === p) {
                if (v === undefined) {
                    if (bf.__staleWhileFetching) this.#valList[index] = bf.__staleWhileFetching;
                    else this.#delete(k, 'fetch');
                } else {
                    if (options.status) options.status.fetchUpdated = true;
                    this.set(k, v, fetchOpts.options);
                }
            }
            return v;
        };
        const eb = (er)=>{
            if (options.status) {
                options.status.fetchRejected = true;
                options.status.fetchError = er;
            }
            return fetchFail(er);
        };
        const fetchFail = (er)=>{
            const { aborted: aborted } = ac.signal;
            const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
            const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
            const noDelete = allowStale || options.noDeleteOnFetchRejection;
            const bf = p;
            if (this.#valList[index] === p) {
                // if we allow stale on fetch rejections, then we need to ensure that
                // the stale value is not removed from the cache when the fetch fails.
                const del = !noDelete || bf.__staleWhileFetching === undefined;
                if (del) this.#delete(k, 'fetch');
                else if (!allowStaleAborted) // still replace the *promise* with the stale value,
                // since we are done with the promise at this point.
                // leave it untouched if we're still waiting for an
                // aborted background fetch that hasn't yet returned.
                this.#valList[index] = bf.__staleWhileFetching;
            }
            if (allowStale) {
                if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
                return bf.__staleWhileFetching;
            } else if (bf.__returned === bf) throw er;
        };
        const pcall = (res, rej)=>{
            const fmp = this.#fetchMethod?.(k, v, fetchOpts);
            if (fmp && fmp instanceof Promise) fmp.then((v)=>res(v === undefined ? undefined : v), rej);
            // ignored, we go until we finish, regardless.
            // defer check until we are actually aborting,
            // so fetchMethod can override.
            ac.signal.addEventListener('abort', ()=>{
                if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                    res(undefined);
                    // when it eventually resolves, update the cache.
                    if (options.allowStaleOnFetchAbort) res = (v)=>cb(v, true);
                }
            });
        };
        if (options.status) options.status.fetchDispatched = true;
        const p = new Promise(pcall).then(cb, eb);
        const bf = Object.assign(p, {
            __abortController: ac,
            __staleWhileFetching: v,
            __returned: undefined
        });
        if (index === undefined) {
            // internal, don't expose status.
            this.set(k, bf, {
                ...fetchOpts.options,
                status: undefined
            });
            index = this.#keyMap.get(k);
        } else this.#valList[index] = bf;
        return bf;
    }
    #isBackgroundFetch(p) {
        if (!this.#hasFetchMethod) return false;
        const b = p;
        return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $90bbefef4dc25bab$var$AC;
    }
    async fetch(k, fetchOptions = {}) {
        const { allowStale: // get options
        allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, ttl: // set options
        ttl = this.ttl, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, noDeleteOnFetchRejection: // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort: ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort: allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context: context, forceRefresh: forceRefresh = false, status: status, signal: signal } = fetchOptions;
        if (!this.#hasFetchMethod) {
            if (status) status.fetch = 'get';
            return this.get(k, {
                allowStale: allowStale,
                updateAgeOnGet: updateAgeOnGet,
                noDeleteOnStaleGet: noDeleteOnStaleGet,
                status: status
            });
        }
        const options = {
            allowStale: allowStale,
            updateAgeOnGet: updateAgeOnGet,
            noDeleteOnStaleGet: noDeleteOnStaleGet,
            ttl: ttl,
            noDisposeOnSet: noDisposeOnSet,
            size: size,
            sizeCalculation: sizeCalculation,
            noUpdateTTL: noUpdateTTL,
            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
            ignoreFetchAbort: ignoreFetchAbort,
            status: status,
            signal: signal
        };
        let index = this.#keyMap.get(k);
        if (index === undefined) {
            if (status) status.fetch = 'miss';
            const p = this.#backgroundFetch(k, index, options, context);
            return p.__returned = p;
        } else {
            // in cache, maybe already fetching
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = 'inflight';
                    if (stale) status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : v.__returned = v;
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = this.#isStale(index);
            if (!forceRefresh && !isStale) {
                if (status) status.fetch = 'hit';
                this.#moveToTail(index);
                if (updateAgeOnGet) this.#updateItemAge(index);
                if (status) this.#statusTTL(status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = this.#backgroundFetch(k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? 'stale' : 'refresh';
                if (staleVal && isStale) status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : p.__returned = p;
        }
    }
    async forceFetch(k, fetchOptions = {}) {
        const v = await this.fetch(k, fetchOptions);
        if (v === undefined) throw new Error('fetch() returned undefined');
        return v;
    }
    memo(k, memoOptions = {}) {
        const memoMethod = this.#memoMethod;
        if (!memoMethod) throw new Error('no memoMethod provided to constructor');
        const { context: context, forceRefresh: forceRefresh, ...options } = memoOptions;
        const v = this.get(k, options);
        if (!forceRefresh && v !== undefined) return v;
        const vv = memoMethod(k, v, {
            options: options,
            context: context
        });
        this.set(k, vv, options);
        return vv;
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ get(k, getOptions = {}) {
        const { allowStale: allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, status: status } = getOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const value = this.#valList[index];
            const fetching = this.#isBackgroundFetch(value);
            if (status) this.#statusTTL(status, index);
            if (this.#isStale(index)) {
                if (status) status.get = 'stale';
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) this.#delete(k, 'expire');
                    if (status && allowStale) status.returnedStale = true;
                    return allowStale ? value : undefined;
                } else {
                    if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            } else {
                if (status) status.get = 'hit';
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) return value.__staleWhileFetching;
                this.#moveToTail(index);
                if (updateAgeOnGet) this.#updateItemAge(index);
                return value;
            }
        } else if (status) status.get = 'miss';
    }
    #connect(p, n) {
        this.#prev[n] = p;
        this.#next[p] = n;
    }
    #moveToTail(index) {
        // if tail already, nothing to do
        // if head, move head to next[index]
        // else
        //   move next[prev[index]] to next[index] (head has no prev)
        //   move prev[next[index]] to prev[index]
        // prev[index] = tail
        // next[tail] = index
        // tail = index
        if (index !== this.#tail) {
            if (index === this.#head) this.#head = this.#next[index];
            else this.#connect(this.#prev[index], this.#next[index]);
            this.#connect(this.#tail, index);
            this.#tail = index;
        }
    }
    /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ delete(k) {
        return this.#delete(k, 'delete');
    }
    #delete(k, reason) {
        let deleted = false;
        if (this.#size !== 0) {
            const index = this.#keyMap.get(k);
            if (index !== undefined) {
                deleted = true;
                if (this.#size === 1) this.#clear(reason);
                else {
                    this.#removeItemSize(index);
                    const v = this.#valList[index];
                    if (this.#isBackgroundFetch(v)) v.__abortController.abort(new Error('deleted'));
                    else if (this.#hasDispose || this.#hasDisposeAfter) {
                        if (this.#hasDispose) this.#dispose?.(v, k, reason);
                        if (this.#hasDisposeAfter) this.#disposed?.push([
                            v,
                            k,
                            reason
                        ]);
                    }
                    this.#keyMap.delete(k);
                    this.#keyList[index] = undefined;
                    this.#valList[index] = undefined;
                    if (index === this.#tail) this.#tail = this.#prev[index];
                    else if (index === this.#head) this.#head = this.#next[index];
                    else {
                        const pi = this.#prev[index];
                        this.#next[pi] = this.#next[index];
                        const ni = this.#next[index];
                        this.#prev[ni] = this.#prev[index];
                    }
                    this.#size--;
                    this.#free.push(index);
                }
            }
        }
        if (this.#hasDisposeAfter && this.#disposed?.length) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
        return deleted;
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */ clear() {
        return this.#clear('delete');
    }
    #clear(reason) {
        for (const index of this.#rindexes({
            allowStale: true
        })){
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) v.__abortController.abort(new Error('deleted'));
            else {
                const k = this.#keyList[index];
                if (this.#hasDispose) this.#dispose?.(v, k, reason);
                if (this.#hasDisposeAfter) this.#disposed?.push([
                    v,
                    k,
                    reason
                ]);
            }
        }
        this.#keyMap.clear();
        this.#valList.fill(undefined);
        this.#keyList.fill(undefined);
        if (this.#ttls && this.#starts) {
            this.#ttls.fill(0);
            this.#starts.fill(0);
        }
        if (this.#sizes) this.#sizes.fill(0);
        this.#head = 0;
        this.#tail = 0;
        this.#free.length = 0;
        this.#calculatedSize = 0;
        this.#size = 0;
        if (this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
    }
}

});

parcelRegister("Xr4fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.roughSizeOfObject = void 0;
const $0b2a81d79110b115$var$knownSizes = new WeakMap();
/**
 * @see {@link https://stackoverflow.com/a/11900218/356537}
 */ function $0b2a81d79110b115$var$roughSizeOfObject(value) {
    const objectList = new Set();
    const stack = [
        value
    ]; // This would be more efficient using a circular buffer
    let bytes = 0;
    while(stack.length){
        const value = stack.pop();
        // > All objects on the heap start with a shape descriptor, which takes one
        // > pointer size (usually 4 bytes these days, thanks to "pointer
        // > compression" on 64-bit platforms).
        switch(typeof value){
            // Types are ordered by frequency
            case 'string':
                // https://stackoverflow.com/a/68791382/356537
                bytes += 12 + 4 * Math.ceil(value.length / 4);
                break;
            case 'number':
                bytes += 12; // Shape descriptor + double
                break;
            case 'boolean':
                bytes += 4; // Shape descriptor
                break;
            case 'object':
                bytes += 4; // Shape descriptor
                if (value === null) break;
                if ($0b2a81d79110b115$var$knownSizes.has(value)) {
                    bytes += $0b2a81d79110b115$var$knownSizes.get(value);
                    break;
                }
                if (objectList.has(value)) continue;
                objectList.add(value);
                if (Array.isArray(value)) {
                    bytes += 4;
                    stack.push(...value);
                } else {
                    bytes += 8;
                    const keys = Object.getOwnPropertyNames(value);
                    for(let i = 0; i < keys.length; i++){
                        bytes += 4;
                        const key = keys[i];
                        const val = value[key];
                        if (val !== undefined) stack.push(val);
                        stack.push(key);
                    }
                }
                break;
            case 'function':
                bytes += 8; // Shape descriptor + pointer (assuming functions are shared)
                break;
            case 'symbol':
                bytes += 8; // Shape descriptor + pointer
                break;
            case 'bigint':
                bytes += 16; // Shape descriptor + BigInt
                break;
        }
    }
    if (typeof value === 'object' && value !== null) $0b2a81d79110b115$var$knownSizes.set(value, bytes);
    return bytes;
}
module.exports.roughSizeOfObject = $0b2a81d79110b115$var$roughSizeOfObject;

});



parcelRegister("9NhYU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidResolverCached = void 0;

var $559MJ = parcelRequire("559MJ");

var $h8kQI = parcelRequire("h8kQI");
class $7216a363f3af6f09$var$DidResolverCached {
    constructor(resolver, cache = new $h8kQI.DidCacheMemory()){
        Object.defineProperty(this, "getter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.getter = new $559MJ.CachedGetter((did, options)=>resolver.resolve(did, options), cache);
    }
    async resolve(did, options) {
        return this.getter.get(did, options);
    }
}
module.exports.DidResolverCached = $7216a363f3af6f09$var$DidResolverCached;

});
parcelRegister("559MJ", function(module, exports) {
"use strict";
var $3b350277c85e809c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3b350277c85e809c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3b350277c85e809c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3b350277c85e809c$var$__exportStar((parcelRequire("gGU8b")), module.exports);

$3b350277c85e809c$var$__exportStar((parcelRequire("4vlHV")), module.exports);

});
parcelRegister("gGU8b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CachedGetter = void 0;
const $c26c1c02bd1549ff$var$returnTrue = ()=>true;
const $c26c1c02bd1549ff$var$returnFalse = ()=>false;
/**
 * Wrapper utility that uses a store to speed up the retrieval of values from an
 * (expensive) getter function.
 */ class $c26c1c02bd1549ff$var$CachedGetter {
    constructor(getter, store, options){
        Object.defineProperty(this, "getter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: getter
        });
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: store
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(this, "pending", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    async get(key, options) {
        options?.signal?.throwIfAborted();
        const isStale = this.options?.isStale;
        const allowStored = options?.noCache ? $c26c1c02bd1549ff$var$returnFalse // Never allow stored values to be returned
         : options?.allowStale || isStale == null ? $c26c1c02bd1549ff$var$returnTrue // Always allow stored values to be returned
         : async (value)=>!await isStale(key, value);
        // As long as concurrent requests are made for the same key, only one
        // request will be made to the cache & getter function at a time. This works
        // because there is no async operation between the while() loop and the
        // pending.set() call. Because of the "single threaded" nature of
        // JavaScript, the pending item will be set before the next iteration of the
        // while loop.
        let previousExecutionFlow;
        while(previousExecutionFlow = this.pending.get(key)){
            try {
                const { isFresh: isFresh, value: value } = await previousExecutionFlow;
                if (isFresh) return value;
                if (await allowStored(value)) return value;
            } catch  {
            // Ignore errors from previous execution flows (they will have been
            // propagated by that flow).
            }
            options?.signal?.throwIfAborted();
        }
        const currentExecutionFlow = Promise.resolve().then(async ()=>{
            const storedValue = await this.getStored(key, options);
            if (storedValue !== undefined && await allowStored(storedValue)) // Use the stored value as return value for the current execution
            // flow. Notify other concurrent execution flows (that should be
            // "stuck" in the loop before until this promise resolves) that we got
            // a value, but that it came from the store (isFresh = false).
            return {
                isFresh: false,
                value: storedValue
            };
            return Promise.resolve().then(async ()=>(0, this.getter)(key, options, storedValue)).catch(async (err)=>{
                if (storedValue !== undefined) try {
                    const deleteOnError = this.options?.deleteOnError;
                    if (await deleteOnError?.(err, key, storedValue)) await this.delStored(key, err);
                } catch (error) {
                    throw new AggregateError([
                        err,
                        error
                    ], 'Error while deleting stored value');
                }
                throw err;
            }).then(async (value)=>{
                // The value should be stored even is the signal was aborted.
                await this.setStored(key, value);
                return {
                    isFresh: true,
                    value: value
                };
            });
        }).finally(()=>{
            this.pending.delete(key);
        });
        if (this.pending.has(key)) // This should never happen. Indeed, there must not be any 'await'
        // statement between this and the loop iteration check meaning that
        // this.pending.get returned undefined. It is there to catch bugs that
        // would occur in future changes to the code.
        throw new Error('Concurrent request for the same key');
        this.pending.set(key, currentExecutionFlow);
        const { value: value } = await currentExecutionFlow;
        return value;
    }
    bind(key) {
        return async (options)=>this.get(key, options);
    }
    async getStored(key, options) {
        try {
            return await this.store.get(key, options);
        } catch (err) {
            return undefined;
        }
    }
    async setStored(key, value) {
        try {
            await this.store.set(key, value);
        } catch (err) {
            const onStoreError = this.options?.onStoreError;
            await onStoreError?.(err, key, value);
        }
    }
    async delStored(key, _cause) {
        await this.store.del(key);
    }
}
module.exports.CachedGetter = $c26c1c02bd1549ff$var$CachedGetter;

});

parcelRegister("4vlHV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("9x0MW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("h0Y9m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidResolverCommon = void 0;

var $44L7D = parcelRequire("44L7D");

var $jrEAi = parcelRequire("jrEAi");

var $dAkxw = parcelRequire("dAkxw");
class $c631185004327223$var$DidResolverCommon extends $44L7D.DidResolverBase {
    constructor(options){
        super({
            plc: new $jrEAi.DidPlcMethod(options),
            web: new $dAkxw.DidWebMethod(options)
        });
    }
}
module.exports.DidResolverCommon = $c631185004327223$var$DidResolverCommon;

});
parcelRegister("44L7D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidResolverBase = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $hoXKl = parcelRequire("hoXKl");

var $2zDt6 = parcelRequire("2zDt6");
class $2f7c16a23592308b$var$DidResolverBase {
    constructor(methods){
        Object.defineProperty(this, "methods", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.methods = new Map(Object.entries(methods));
    }
    async resolve(did, options) {
        options?.signal?.throwIfAborted();
        const method = (0, $hoXKl.extractDidMethod)(did);
        const resolver = this.methods.get(method);
        if (!resolver) throw new $hoXKl.DidError(did, `Unsupported DID method`, 'did-method-invalid', 400);
        try {
            const document = await resolver.resolve(did, options);
            if (document.id !== did) throw new $hoXKl.DidError(did, `DID document id (${document.id}) does not match DID`, 'did-document-id-mismatch', 400);
            return document;
        } catch (err) {
            if (err instanceof $8oTqd.FetchRequestError) throw new $hoXKl.DidError(did, err.message, 'did-fetch-error', 400, err);
            if (err instanceof $2zDt6.ZodError) throw new $hoXKl.DidError(did, err.message, 'did-document-format-error', 503, err);
            throw $hoXKl.DidError.from(err, did);
        }
    }
}
module.exports.DidResolverBase = $2f7c16a23592308b$var$DidResolverBase;

});
parcelRegister("8oTqd", function(module, exports) {
"use strict";
var $61db8e3f82f60462$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $61db8e3f82f60462$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $61db8e3f82f60462$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$61db8e3f82f60462$var$__exportStar((parcelRequire("bZDQr")), module.exports);

$61db8e3f82f60462$var$__exportStar((parcelRequire("7jgWp")), module.exports);

$61db8e3f82f60462$var$__exportStar((parcelRequire("eVzTV")), module.exports);

$61db8e3f82f60462$var$__exportStar((parcelRequire("gnp1v")), module.exports);

$61db8e3f82f60462$var$__exportStar((parcelRequire("5Qs1e")), module.exports);

$61db8e3f82f60462$var$__exportStar((parcelRequire("skwSd")), module.exports);

});
parcelRegister("bZDQr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchError = void 0;
class $8bb44c94f2804457$var$FetchError extends Error {
    constructor(statusCode, message, options){
        if (statusCode == null || !message) {
            const info = $8bb44c94f2804457$var$extractInfo($8bb44c94f2804457$var$extractRootCause(options?.cause));
            statusCode = statusCode ?? info[0];
            message = message || info[1];
        }
        super(message, options);
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.statusCode = statusCode;
    }
}
module.exports.FetchError = $8bb44c94f2804457$var$FetchError;
function $8bb44c94f2804457$var$extractRootCause(err) {
    // Unwrap the Network error from undici (i.e. Node's internal fetch() implementation)
    // https://github.com/nodejs/undici/blob/3274c975947ce11a08508743df026f73598bfead/lib/web/fetch/index.js#L223-L228
    if (err instanceof TypeError && err.message === 'fetch failed' && err.cause !== undefined) return err.cause;
    return err;
}
function $8bb44c94f2804457$var$extractInfo(err) {
    if (typeof err === 'string' && err.length > 0) return [
        500,
        err
    ];
    if (!(err instanceof Error)) return [
        500,
        'Failed to fetch'
    ];
    const code = err['code'];
    if (typeof code === 'string') switch(true){
        case code === 'ENOTFOUND':
            return [
                400,
                'Invalid hostname'
            ];
        case code === 'ECONNREFUSED':
            return [
                502,
                'Connection refused'
            ];
        case code === 'DEPTH_ZERO_SELF_SIGNED_CERT':
            return [
                502,
                'Self-signed certificate'
            ];
        case code.startsWith('ERR_TLS'):
            return [
                502,
                'TLS error'
            ];
        case code.startsWith('ECONN'):
            return [
                502,
                'Connection error'
            ];
        default:
            return [
                500,
                `${code} error`
            ];
    }
    return [
        500,
        err.message
    ];
}

});

parcelRegister("7jgWp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.forbiddenDomainNameRequestTransform = module.exports.DEFAULT_FORBIDDEN_DOMAIN_NAMES = module.exports.requireHostHeaderTransform = module.exports.redirectCheckRequestTransform = module.exports.protocolCheckRequestTransform = module.exports.FetchRequestError = void 0;

var $bZDQr = parcelRequire("bZDQr");

var $5Qs1e = parcelRequire("5Qs1e");

var $skwSd = parcelRequire("skwSd");
class $552772e14e4a289c$var$FetchRequestError extends $bZDQr.FetchError {
    constructor(request, statusCode, message, options){
        super(statusCode, message, options);
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: request
        });
    }
    static from(request, cause) {
        if (cause instanceof $552772e14e4a289c$var$FetchRequestError) return cause;
        return new $552772e14e4a289c$var$FetchRequestError(request, undefined, undefined, {
            cause: cause
        });
    }
}
module.exports.FetchRequestError = $552772e14e4a289c$var$FetchRequestError;
function $552772e14e4a289c$var$protocolCheckRequestTransform(protocols) {
    return (input, init)=>{
        const { protocol: protocol, port: port } = (0, $skwSd.extractUrl)(input);
        const request = (0, $5Qs1e.asRequest)(input, init);
        const config = Object.hasOwn(protocols, protocol) ? protocols[protocol] : undefined;
        if (!config) throw new $552772e14e4a289c$var$FetchRequestError(request, 400, `Forbidden protocol "${protocol}"`);
        else if (config === true) ;
        else if (!config['allowCustomPort'] && port !== '') throw new $552772e14e4a289c$var$FetchRequestError(request, 400, `Custom ${protocol} ports not allowed`);
        return request;
    };
}
module.exports.protocolCheckRequestTransform = $552772e14e4a289c$var$protocolCheckRequestTransform;
function $552772e14e4a289c$var$redirectCheckRequestTransform() {
    return (input, init)=>{
        const request = (0, $5Qs1e.asRequest)(input, init);
        if (request.redirect === 'follow') throw new $552772e14e4a289c$var$FetchRequestError(request, 500, 'Request redirect must be "error" or "manual"');
        return request;
    };
}
module.exports.redirectCheckRequestTransform = $552772e14e4a289c$var$redirectCheckRequestTransform;
function $552772e14e4a289c$var$requireHostHeaderTransform() {
    return (input, init)=>{
        // Note that fetch() will automatically add the Host header from the URL and
        // discard any Host header manually set in the request.
        const { protocol: protocol, hostname: hostname } = (0, $skwSd.extractUrl)(input);
        const request = (0, $5Qs1e.asRequest)(input, init);
        // "Host" header only makes sense in the context of an HTTP request
        if (protocol !== 'http:' && protocol !== 'https:') throw new $552772e14e4a289c$var$FetchRequestError(request, 400, `"${protocol}" requests are not allowed`);
        if (!hostname || (0, $skwSd.isIp)(hostname)) throw new $552772e14e4a289c$var$FetchRequestError(request, 400, 'Invalid hostname');
        return request;
    };
}
module.exports.requireHostHeaderTransform = $552772e14e4a289c$var$requireHostHeaderTransform;
module.exports.DEFAULT_FORBIDDEN_DOMAIN_NAMES = [
    'example.com',
    '*.example.com',
    'example.org',
    '*.example.org',
    'example.net',
    '*.example.net',
    'googleusercontent.com',
    '*.googleusercontent.com'
];
function $552772e14e4a289c$var$forbiddenDomainNameRequestTransform(denyList = module.exports.DEFAULT_FORBIDDEN_DOMAIN_NAMES) {
    const denySet = new Set(denyList);
    // Optimization: if no forbidden domain names are provided, we can skip the
    // check entirely.
    if (denySet.size === 0) return $5Qs1e.asRequest;
    return async (input, init)=>{
        const { hostname: hostname } = (0, $skwSd.extractUrl)(input);
        const request = (0, $5Qs1e.asRequest)(input, init);
        // Full domain name check
        if (denySet.has(hostname)) throw new $552772e14e4a289c$var$FetchRequestError(request, 403, 'Forbidden hostname');
        // Sub domain name check
        let curDot = hostname.indexOf('.');
        while(curDot !== -1){
            const subdomain = hostname.slice(curDot + 1);
            if (denySet.has(`*.${subdomain}`)) throw new $552772e14e4a289c$var$FetchRequestError(request, 403, 'Forbidden hostname');
            curDot = hostname.indexOf('.', curDot + 1);
        }
        return request;
    };
}
module.exports.forbiddenDomainNameRequestTransform = $552772e14e4a289c$var$forbiddenDomainNameRequestTransform;

});
parcelRegister("5Qs1e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.asRequest = module.exports.toRequestTransformer = void 0;
function $44178b09bc5a15bc$var$toRequestTransformer(requestTransformer) {
    return function(input, init) {
        return requestTransformer.call(this, $44178b09bc5a15bc$var$asRequest(input, init));
    };
}
module.exports.toRequestTransformer = $44178b09bc5a15bc$var$toRequestTransformer;
function $44178b09bc5a15bc$var$asRequest(input, init) {
    if (!init && input instanceof Request) return input;
    return new Request(input, init);
}
module.exports.asRequest = $44178b09bc5a15bc$var$asRequest;

});

parcelRegister("skwSd", function(module, exports) {
"use strict";
// @TODO: Move some of these to a shared package ?
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractUrl = module.exports.stringifyMessage = module.exports.logCancellationError = module.exports.cancelBody = module.exports.padLines = module.exports.MaxBytesTransformStream = module.exports.ifString = module.exports.ifObject = module.exports.isIp = void 0;
function $05528a5088791459$var$isIp(hostname) {
    // IPv4
    if (hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) return true;
    // IPv6
    if (hostname.startsWith('[') && hostname.endsWith(']')) return true;
    return false;
}
module.exports.isIp = $05528a5088791459$var$isIp;
const $05528a5088791459$var$plainObjectProto = Object.prototype;
const $05528a5088791459$var$ifObject = (v)=>{
    if (typeof v === 'object' && v != null && !Array.isArray(v)) {
        const proto = Object.getPrototypeOf(v);
        if (proto === null || proto === $05528a5088791459$var$plainObjectProto) // eslint-disable-next-line @typescript-eslint/ban-types
        return v;
    }
    return undefined;
};
module.exports.ifObject = $05528a5088791459$var$ifObject;
const $05528a5088791459$var$ifString = (v)=>typeof v === 'string' ? v : undefined;
module.exports.ifString = $05528a5088791459$var$ifString;
class $05528a5088791459$var$MaxBytesTransformStream extends TransformStream {
    constructor(maxBytes){
        // Note: negation accounts for invalid value types (NaN, non numbers)
        if (!(maxBytes >= 0)) throw new TypeError('maxBytes must be a non-negative number');
        let bytesRead = 0;
        super({
            transform: (chunk, ctrl)=>{
                if ((bytesRead += chunk.length) <= maxBytes) ctrl.enqueue(chunk);
                else ctrl.error(new Error('Response too large'));
            }
        });
    }
}
module.exports.MaxBytesTransformStream = $05528a5088791459$var$MaxBytesTransformStream;
const $05528a5088791459$var$LINE_BREAK = /\r?\n/g;
function $05528a5088791459$var$padLines(input, pad) {
    if (!input) return input;
    return pad + input.replace($05528a5088791459$var$LINE_BREAK, `$&${pad}`);
}
module.exports.padLines = $05528a5088791459$var$padLines;
/**
 * @param [onCancellationError] - Callback that will trigger to asynchronously
 * handle any error that occurs while cancelling the response body. Providing
 * this will speed up the process and avoid potential deadlocks. Defaults to
 * awaiting the cancellation operation. use `"log"` to log the error.
 * @see {@link https://undici.nodejs.org/#/?id=garbage-collection}
 * @note awaiting this function's result, when no `onCancellationError` is
 * provided, might result in a dead lock. Indeed, if the response was cloned(),
 * the response.body.cancel() method will not resolve until the other response's
 * body is consumed/cancelled.
 *
 * @example
 * ```ts
 * // Make sure response was not cloned, or that every cloned response was
 * // consumed/cancelled before awaiting this function's result.
 * await cancelBody(response)
 * ```
 * @example
 * ```ts
 * await cancelBody(response, (err) => {
 *   // No biggie, let's just log the error
 *   console.warn('Failed to cancel response body', err)
 * })
 * ```
 * @example
 * ```ts
 * // Will generate an "unhandledRejection" if an error occurs while cancelling
 * // the response body. This will likely crash the process.
 * await cancelBody(response, (err) => { throw err })
 * ```
 */ async function $05528a5088791459$var$cancelBody(body, onCancellationError) {
    if (body.body && !body.bodyUsed && !body.body.locked && // Support for alternative fetch implementations
    typeof body.body.cancel === 'function') {
        if (typeof onCancellationError === 'function') body.body.cancel().catch(onCancellationError);
        else if (onCancellationError === 'log') body.body.cancel().catch($05528a5088791459$var$logCancellationError);
        else await body.body.cancel();
    }
}
module.exports.cancelBody = $05528a5088791459$var$cancelBody;
function $05528a5088791459$var$logCancellationError(err) {
    console.warn('Failed to cancel response body', err);
}
module.exports.logCancellationError = $05528a5088791459$var$logCancellationError;
async function $05528a5088791459$var$stringifyMessage(input) {
    try {
        const headers = $05528a5088791459$var$stringifyHeaders(input.headers);
        const payload = await $05528a5088791459$var$stringifyBody(input);
        return headers && payload ? `${headers}\n${payload}` : headers || payload;
    } finally{
        $05528a5088791459$var$cancelBody(input, 'log');
    }
}
module.exports.stringifyMessage = $05528a5088791459$var$stringifyMessage;
function $05528a5088791459$var$stringifyHeaders(headers) {
    return Array.from(headers).map(([name, value])=>`${name}: ${value}`).join('\n');
}
async function $05528a5088791459$var$stringifyBody(body) {
    try {
        const blob = await body.blob();
        if (blob.type?.startsWith('text/')) {
            const text = await blob.text();
            return JSON.stringify(text);
        }
        if (/application\/(?:\w+\+)?json/.test(blob.type)) {
            const text = await blob.text();
            return text.includes('\n') ? JSON.stringify(JSON.parse(text)) : text;
        }
        return `[Body size: ${blob.size}, type: ${JSON.stringify(blob.type)} ]`;
    } catch  {
        return '[Body could not be read]';
    }
}
const $05528a5088791459$var$extractUrl = (input)=>typeof input === 'string' ? new URL(input) : input instanceof URL ? input : new URL(input.url);
module.exports.extractUrl = $05528a5088791459$var$extractUrl;

});


parcelRegister("eVzTV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchJsonZodProcessor = module.exports.fetchJsonProcessor = module.exports.fetchResponseJsonTranformer = module.exports.fetchResponseTypeChecker = module.exports.fetchTypeProcessor = module.exports.fetchResponseMaxSizeChecker = module.exports.fetchMaxSizeProcessor = module.exports.fetchOkTransformer = module.exports.fetchOkProcessor = module.exports.cancelBodyOnError = module.exports.extractMime = module.exports.extractLength = module.exports.checkLength = module.exports.peekJson = module.exports.FetchResponseError = void 0;

var $dmR8n = parcelRequire("dmR8n");

var $bZDQr = parcelRequire("bZDQr");

var $70tGi = parcelRequire("70tGi");

var $skwSd = parcelRequire("skwSd");
class $ade23cc36d243777$var$FetchResponseError extends $bZDQr.FetchError {
    constructor(response, statusCode = response.status, message = response.statusText, options){
        super(statusCode, message, options);
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: response
        });
    }
    static async from(response, customMessage = $ade23cc36d243777$var$extractResponseMessage, statusCode = response.status, options) {
        const message = typeof customMessage === 'string' ? customMessage : typeof customMessage === 'function' ? await customMessage(response) : undefined;
        return new $ade23cc36d243777$var$FetchResponseError(response, statusCode, message, options);
    }
}
module.exports.FetchResponseError = $ade23cc36d243777$var$FetchResponseError;
const $ade23cc36d243777$var$extractResponseMessage = async (response)=>{
    const mimeType = $ade23cc36d243777$var$extractMime(response);
    if (!mimeType) return undefined;
    try {
        if (mimeType === 'text/plain') return await response.text();
        else if (/^application\/(?:[^+]+\+)?json$/i.test(mimeType)) {
            const json = await response.json();
            if (typeof json === 'string') return json;
            const errorDescription = (0, $skwSd.ifString)((0, $skwSd.ifObject)(json)?.['error_description']);
            if (errorDescription) return errorDescription;
            const error = (0, $skwSd.ifString)((0, $skwSd.ifObject)(json)?.['error']);
            if (error) return error;
            const message = (0, $skwSd.ifString)((0, $skwSd.ifObject)(json)?.['message']);
            if (message) return message;
        }
    } catch  {
    // noop
    }
    return undefined;
};
async function $ade23cc36d243777$var$peekJson(response, maxSize = Infinity) {
    const type = $ade23cc36d243777$var$extractMime(response);
    if (type !== 'application/json') return undefined;
    $ade23cc36d243777$var$checkLength(response, maxSize);
    // 1) Clone the request so we can consume the body
    const clonedResponse = response.clone();
    // 2) Make sure the request's body is not too large
    const limitedResponse = response.body && maxSize < Infinity ? new $70tGi.TransformedResponse(clonedResponse, new $skwSd.MaxBytesTransformStream(maxSize)) : clonedResponse;
    // 3) Parse the JSON
    return limitedResponse.json();
}
module.exports.peekJson = $ade23cc36d243777$var$peekJson;
function $ade23cc36d243777$var$checkLength(response, maxBytes) {
    // Note: negation accounts for invalid value types (NaN, non numbers)
    if (!(maxBytes >= 0)) throw new TypeError('maxBytes must be a non-negative number');
    const length = $ade23cc36d243777$var$extractLength(response);
    if (length != null && length > maxBytes) throw new $ade23cc36d243777$var$FetchResponseError(response, 502, 'Response too large');
    return length;
}
module.exports.checkLength = $ade23cc36d243777$var$checkLength;
function $ade23cc36d243777$var$extractLength(response) {
    const contentLength = response.headers.get('Content-Length');
    if (contentLength == null) return undefined;
    if (!/^\d+$/.test(contentLength)) throw new $ade23cc36d243777$var$FetchResponseError(response, 502, 'Invalid Content-Length');
    const length = Number(contentLength);
    if (!Number.isSafeInteger(length)) throw new $ade23cc36d243777$var$FetchResponseError(response, 502, 'Content-Length too large');
    return length;
}
module.exports.extractLength = $ade23cc36d243777$var$extractLength;
function $ade23cc36d243777$var$extractMime(response) {
    const contentType = response.headers.get('Content-Type');
    if (contentType == null) return undefined;
    return contentType.split(';', 1)[0].trim();
}
module.exports.extractMime = $ade23cc36d243777$var$extractMime;
/**
 * If the transformer results in an error, ensure that the response body is
 * consumed as, in some environments (Node 👀), the response will not
 * automatically be GC'd.
 *
 * @see {@link https://undici.nodejs.org/#/?id=garbage-collection}
 * @param [onCancellationError] - Callback to handle any async body cancelling
 * error. Defaults to logging the error. Do not use `null` if the request is
 * cloned.
 */ function $ade23cc36d243777$var$cancelBodyOnError(transformer, onCancellationError = $skwSd.logCancellationError) {
    return async (response)=>{
        try {
            return await transformer(response);
        } catch (err) {
            await (0, $skwSd.cancelBody)(response, onCancellationError ?? undefined);
            throw err;
        }
    };
}
module.exports.cancelBodyOnError = $ade23cc36d243777$var$cancelBodyOnError;
function $ade23cc36d243777$var$fetchOkProcessor(customMessage) {
    return $ade23cc36d243777$var$cancelBodyOnError((response)=>{
        return $ade23cc36d243777$var$fetchOkTransformer(response, customMessage);
    });
}
module.exports.fetchOkProcessor = $ade23cc36d243777$var$fetchOkProcessor;
async function $ade23cc36d243777$var$fetchOkTransformer(response, customMessage) {
    if (response.ok) return response;
    throw await $ade23cc36d243777$var$FetchResponseError.from(response, customMessage);
}
module.exports.fetchOkTransformer = $ade23cc36d243777$var$fetchOkTransformer;
function $ade23cc36d243777$var$fetchMaxSizeProcessor(maxBytes) {
    if (maxBytes === Infinity) return (response)=>response;
    if (!Number.isFinite(maxBytes) || maxBytes < 0) throw new TypeError('maxBytes must be a 0, Infinity or a positive number');
    return $ade23cc36d243777$var$cancelBodyOnError((response)=>{
        return $ade23cc36d243777$var$fetchResponseMaxSizeChecker(response, maxBytes);
    });
}
module.exports.fetchMaxSizeProcessor = $ade23cc36d243777$var$fetchMaxSizeProcessor;
function $ade23cc36d243777$var$fetchResponseMaxSizeChecker(response, maxBytes) {
    if (maxBytes === Infinity) return response;
    $ade23cc36d243777$var$checkLength(response, maxBytes);
    // Some engines (react-native 👀) don't expose a body property. In that case,
    // we will only rely on the Content-Length header.
    if (!response.body) return response;
    const transform = new $skwSd.MaxBytesTransformStream(maxBytes);
    return new $70tGi.TransformedResponse(response, transform);
}
module.exports.fetchResponseMaxSizeChecker = $ade23cc36d243777$var$fetchResponseMaxSizeChecker;
function $ade23cc36d243777$var$fetchTypeProcessor(expectedMime, contentTypeRequired = true) {
    const isExpected = typeof expectedMime === 'string' ? (mimeType)=>mimeType === expectedMime : expectedMime instanceof RegExp ? (mimeType)=>expectedMime.test(mimeType) : expectedMime;
    return $ade23cc36d243777$var$cancelBodyOnError((response)=>{
        return $ade23cc36d243777$var$fetchResponseTypeChecker(response, isExpected, contentTypeRequired);
    });
}
module.exports.fetchTypeProcessor = $ade23cc36d243777$var$fetchTypeProcessor;
async function $ade23cc36d243777$var$fetchResponseTypeChecker(response, isExpectedMime, contentTypeRequired = true) {
    const mimeType = $ade23cc36d243777$var$extractMime(response);
    if (mimeType) {
        if (!isExpectedMime(mimeType)) throw await $ade23cc36d243777$var$FetchResponseError.from(response, `Unexpected response Content-Type (${mimeType})`, 502);
    } else if (contentTypeRequired) throw await $ade23cc36d243777$var$FetchResponseError.from(response, 'Missing response Content-Type header', 502);
    return response;
}
module.exports.fetchResponseTypeChecker = $ade23cc36d243777$var$fetchResponseTypeChecker;
async function $ade23cc36d243777$var$fetchResponseJsonTranformer(response) {
    try {
        const json = await response.json();
        return {
            response: response,
            json: json
        };
    } catch (cause) {
        throw new $ade23cc36d243777$var$FetchResponseError(response, 502, 'Unable to parse response as JSON', {
            cause: cause
        });
    }
}
module.exports.fetchResponseJsonTranformer = $ade23cc36d243777$var$fetchResponseJsonTranformer;
function $ade23cc36d243777$var$fetchJsonProcessor(expectedMime = /^application\/(?:[^+]+\+)?json$/, contentTypeRequired = true) {
    return (0, $dmR8n.pipe)($ade23cc36d243777$var$fetchTypeProcessor(expectedMime, contentTypeRequired), $ade23cc36d243777$var$cancelBodyOnError($ade23cc36d243777$var$fetchResponseJsonTranformer));
}
module.exports.fetchJsonProcessor = $ade23cc36d243777$var$fetchJsonProcessor;
function $ade23cc36d243777$var$fetchJsonZodProcessor(schema, params) {
    return async (jsonResponse)=>schema.parseAsync(jsonResponse.json, params);
}
module.exports.fetchJsonZodProcessor = $ade23cc36d243777$var$fetchJsonZodProcessor;

});
parcelRegister("dmR8n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipeTwo = module.exports.pipe = void 0;

var $eQ1TI = parcelRequire("eQ1TI");
Object.defineProperty(module.exports, "pipe", {
    enumerable: true,
    get: function() {
        return $eQ1TI.pipe;
    }
});
Object.defineProperty(module.exports, "pipeTwo", {
    enumerable: true,
    get: function() {
        return $eQ1TI.pipeTwo;
    }
});

});
parcelRegister("eQ1TI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipeTwo = module.exports.pipe = void 0;
function $acd764de3baec96c$var$pipe(...pipeline) {
    return pipeline.reduce($acd764de3baec96c$var$pipeTwo);
}
module.exports.pipe = $acd764de3baec96c$var$pipe;
function $acd764de3baec96c$var$pipeTwo(first, second) {
    return async (input)=>second(await first(input));
}
module.exports.pipeTwo = $acd764de3baec96c$var$pipeTwo;

});


parcelRegister("70tGi", function(module, exports) {
"use strict";
var $519f8e89d169ba72$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $519f8e89d169ba72$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $519f8e89d169ba72$var$_TransformedResponse_response;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransformedResponse = void 0;
class $519f8e89d169ba72$var$TransformedResponse extends Response {
    constructor(response, transform){
        if (!response.body) throw new TypeError('Response body is not available');
        if (response.bodyUsed) throw new TypeError('Response body is already used');
        super(response.body.pipeThrough(transform), {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
        $519f8e89d169ba72$var$_TransformedResponse_response.set(this, void 0);
        $519f8e89d169ba72$var$__classPrivateFieldSet(this, $519f8e89d169ba72$var$_TransformedResponse_response, response, "f");
    }
    /**
     * Some props can't be set through ResponseInit, so we need to proxy them
     */ get url() {
        return $519f8e89d169ba72$var$__classPrivateFieldGet(this, $519f8e89d169ba72$var$_TransformedResponse_response, "f").url;
    }
    get redirected() {
        return $519f8e89d169ba72$var$__classPrivateFieldGet(this, $519f8e89d169ba72$var$_TransformedResponse_response, "f").redirected;
    }
    get type() {
        return $519f8e89d169ba72$var$__classPrivateFieldGet(this, $519f8e89d169ba72$var$_TransformedResponse_response, "f").type;
    }
    get statusText() {
        return $519f8e89d169ba72$var$__classPrivateFieldGet(this, $519f8e89d169ba72$var$_TransformedResponse_response, "f").statusText;
    }
}
module.exports.TransformedResponse = $519f8e89d169ba72$var$TransformedResponse;
$519f8e89d169ba72$var$_TransformedResponse_response = new WeakMap();

});


parcelRegister("gnp1v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindFetch = module.exports.timedFetch = module.exports.loggedFetch = void 0;

var $7jgWp = parcelRequire("7jgWp");

var $5Qs1e = parcelRequire("5Qs1e");

var $70tGi = parcelRequire("70tGi");

var $skwSd = parcelRequire("skwSd");
function $bec234688d1d501f$var$loggedFetch({ fetch: fetch = globalThis.fetch, logRequest: logRequest = true, logResponse: logResponse = true, logError: logError = true }) {
    const onRequest = logRequest === true ? async (request)=>{
        const requestMessage = await (0, $skwSd.stringifyMessage)(request);
        console.info(`> ${request.method} ${request.url}\n${(0, $skwSd.padLines)(requestMessage, '  ')}`);
    } : logRequest || undefined;
    const onResponse = logResponse === true ? async (response)=>{
        const responseMessage = await (0, $skwSd.stringifyMessage)(response.clone());
        console.info(`< HTTP/1.1 ${response.status} ${response.statusText}\n${(0, $skwSd.padLines)(responseMessage, '  ')}`);
    } : logResponse || undefined;
    const onError = logError === true ? async (error)=>{
        console.error(`< Error:`, error);
    } : logError || undefined;
    if (!onRequest && !onResponse && !onError) return fetch;
    return (0, $5Qs1e.toRequestTransformer)(async function(request) {
        if (onRequest) await onRequest(request);
        try {
            const response = await fetch.call(this, request);
            if (onResponse) await onResponse(response, request);
            return response;
        } catch (error) {
            if (onError) await onError(error, request);
            throw error;
        }
    });
}
module.exports.loggedFetch = $bec234688d1d501f$var$loggedFetch;
const $bec234688d1d501f$var$timedFetch = (timeout = 60e3, fetch = globalThis.fetch)=>{
    if (timeout === Infinity) return fetch;
    if (!Number.isFinite(timeout) || timeout <= 0) throw new TypeError('Timeout must be positive');
    return (0, $5Qs1e.toRequestTransformer)(async function(request) {
        const controller = new AbortController();
        const signal = controller.signal;
        const abort = ()=>{
            controller.abort();
        };
        const cleanup = ()=>{
            clearTimeout(timer);
            request.signal?.removeEventListener('abort', abort);
        };
        const timer = setTimeout(abort, timeout);
        if (typeof timer === 'object') timer.unref?.(); // only on node
        request.signal?.addEventListener('abort', abort);
        signal.addEventListener('abort', cleanup);
        const response = await fetch.call(this, request, {
            signal: signal
        });
        if (!response.body) {
            cleanup();
            return response;
        } else {
            // Cleanup the timer & event listeners when the body stream is closed
            const transform = new TransformStream({
                flush: cleanup
            });
            return new $70tGi.TransformedResponse(response, transform);
        }
    });
};
module.exports.timedFetch = $bec234688d1d501f$var$timedFetch;
/**
 * Wraps a fetch function to bind it to a specific context, and wrap any thrown
 * errors into a FetchRequestError.
 *
 * @example
 *
 * ```ts
 * class MyClient {
 *   constructor(private fetch = globalThis.fetch) {}
 *
 *   async get(url: string) {
 *     // This will generate an error, because the context used is not a
 *     // FetchContext (it's a MyClient instance).
 *     return this.fetch(url)
 *   }
 * }
 * ```
 *
 * @example
 *
 * ```ts
 * class MyClient {
 *   private fetch: Fetch<unknown>
 *
 *   constructor(fetch = globalThis.fetch) {
 *     this.fetch = bindFetch(fetch)
 *   }
 *
 *   async get(url: string) {
 *     return this.fetch(url) // no more error
 *   }
 * }
 * ```
 */ function $bec234688d1d501f$var$bindFetch(fetch = globalThis.fetch, context = globalThis) {
    return (0, $5Qs1e.toRequestTransformer)(async (request)=>{
        try {
            return await fetch.call(context, request);
        } catch (err) {
            throw $7jgWp.FetchRequestError.from(request, err);
        }
    });
}
module.exports.bindFetch = $bec234688d1d501f$var$bindFetch;

});



parcelRegister("jrEAi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidPlcMethod = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $dmR8n = parcelRequire("dmR8n");

var $hoXKl = parcelRequire("hoXKl");
const $e280052c183723fd$var$fetchSuccessHandler = (0, $dmR8n.pipe)((0, $8oTqd.fetchOkProcessor)(), (0, $8oTqd.fetchJsonProcessor)(/^application\/(did\+ld\+)?json$/), (0, $8oTqd.fetchJsonZodProcessor)($hoXKl.didDocumentValidator));
class $e280052c183723fd$var$DidPlcMethod {
    constructor(options){
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "plcDirectoryUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.plcDirectoryUrl = new URL(options?.plcDirectoryUrl || 'https://plc.directory/');
        this.fetch = (0, $8oTqd.bindFetch)(options?.fetch);
    }
    async resolve(did, options) {
        // Although the did should start with `did:plc:` (thanks to typings), we
        // should still check if the msid is valid.
        (0, $hoXKl.assertDidPlc)(did);
        const url = new URL(`/${did}`, this.plcDirectoryUrl);
        return this.fetch(url, {
            redirect: 'error',
            headers: {
                accept: 'application/did+ld+json,application/json'
            },
            signal: options?.signal
        }).then($e280052c183723fd$var$fetchSuccessHandler);
    }
}
module.exports.DidPlcMethod = $e280052c183723fd$var$DidPlcMethod;

});

parcelRegister("dAkxw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildDidWebDocumentUrl = module.exports.DidWebMethod = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $dmR8n = parcelRequire("dmR8n");

var $hoXKl = parcelRequire("hoXKl");
const $9e3e91e53a82a00f$var$fetchSuccessHandler = (0, $dmR8n.pipe)((0, $8oTqd.fetchOkProcessor)(), (0, $8oTqd.fetchJsonProcessor)(/^application\/(did\+ld\+)?json$/), (0, $8oTqd.fetchJsonZodProcessor)($hoXKl.didDocumentValidator));
class $9e3e91e53a82a00f$var$DidWebMethod {
    constructor({ fetch: fetch = globalThis.fetch } = {}){
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fetch = (0, $8oTqd.bindFetch)(fetch);
    }
    async resolve(did, options) {
        const didDocumentUrl = $9e3e91e53a82a00f$var$buildDidWebDocumentUrl(did);
        // Note we do not explicitly check for "localhost" here. Instead, we rely on
        // the injected 'fetch' function to handle the URL. If the URL is
        // "localhost", or resolves to a private IP address, the fetch function is
        // responsible for handling it.
        return this.fetch(didDocumentUrl, {
            redirect: 'error',
            headers: {
                accept: 'application/did+ld+json,application/json'
            },
            signal: options?.signal
        }).then($9e3e91e53a82a00f$var$fetchSuccessHandler);
    }
}
module.exports.DidWebMethod = $9e3e91e53a82a00f$var$DidWebMethod;
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc8615}
 * @see {@link https://w3c-ccg.github.io/did-method-web/#create-register}
 */ function $9e3e91e53a82a00f$var$buildDidWebDocumentUrl(did) {
    const url = (0, $hoXKl.didWebToUrl)(did); // Will throw if the DID is invalid
    // Note: DID cannot end with an `:`, so they cannot end with a `/`. This is
    // true unless when there is no path at all, in which case the URL constructor
    // will set the pathname to `/`.
    // https://w3c-ccg.github.io/did-method-web/#read-resolve
    if (url.pathname === '/') return new URL(`/.well-known/did.json`, url);
    else return new URL(`${url.pathname}/did.json`, url);
}
module.exports.buildDidWebDocumentUrl = $9e3e91e53a82a00f$var$buildDidWebDocumentUrl;

});


parcelRegister("fNvbt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kLeG9", function(module, exports) {
"use strict";
var $f1d3955421a30bd7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f1d3955421a30bd7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f1d3955421a30bd7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f1d3955421a30bd7$var$__exportStar((parcelRequire("jrEAi")), module.exports);

$f1d3955421a30bd7$var$__exportStar((parcelRequire("dAkxw")), module.exports);

});

parcelRegister("iPo4S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("fYfau", function(module, exports) {
"use strict";
var $ba0839b071ae6a44$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba0839b071ae6a44$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ba0839b071ae6a44$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ba0839b071ae6a44$var$__exportStar((parcelRequire("hIqij")), module.exports);

// Main Handle Resolvers strategies
$ba0839b071ae6a44$var$__exportStar((parcelRequire("g4U3T")), module.exports);

$ba0839b071ae6a44$var$__exportStar((parcelRequire("kZxhz")), module.exports);

$ba0839b071ae6a44$var$__exportStar((parcelRequire("4bQfa")), module.exports);

// Handle Resolver Caching utility
$ba0839b071ae6a44$var$__exportStar((parcelRequire("6hYWA")), module.exports);

});
parcelRegister("hIqij", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isResolvedHandle = void 0;

var $hoXKl = parcelRequire("hoXKl");
/**
 * @see {@link https://atproto.com/specs/did#blessed-did-methods}
 */ function $03540c2640144fd2$var$isResolvedHandle(value) {
    return value === null || (0, $hoXKl.isAtprotoDid)(value);
}
module.exports.isResolvedHandle = $03540c2640144fd2$var$isResolvedHandle;

});

parcelRegister("g4U3T", function(module, exports) {
"use strict";
var $bb4881c1563dc6f9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppViewHandleResolver = module.exports.xrpcErrorSchema = void 0;

const $bb4881c1563dc6f9$var$zod_1 = $bb4881c1563dc6f9$var$__importDefault((parcelRequire("2zDt6")));

var $hIqij = parcelRequire("hIqij");
module.exports.xrpcErrorSchema = $bb4881c1563dc6f9$var$zod_1.default.object({
    error: $bb4881c1563dc6f9$var$zod_1.default.string(),
    message: $bb4881c1563dc6f9$var$zod_1.default.string().optional()
});
class $bb4881c1563dc6f9$var$AppViewHandleResolver {
    static from(service, options) {
        if (typeof service === 'string' || service instanceof URL) return new $bb4881c1563dc6f9$var$AppViewHandleResolver(service, options);
        return service;
    }
    constructor(service, options){
        /**
         * URL of the atproto lexicon server. This is the base URL where the
         * `com.atproto.identity.resolveHandle` XRPC method is located.
         */ Object.defineProperty(this, "serviceUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serviceUrl = new URL(service);
        this.fetch = options?.fetch ?? globalThis.fetch;
    }
    async resolve(handle, options) {
        const url = new URL('/xrpc/com.atproto.identity.resolveHandle', this.serviceUrl);
        url.searchParams.set('handle', handle);
        const headers = new Headers();
        if (options?.noCache) headers.set('cache-control', 'no-cache');
        const response = await this.fetch.call(null, url, {
            headers: headers,
            signal: options?.signal,
            redirect: 'error'
        });
        const payload = await response.json();
        // The response should either be
        // - 400 Bad Request with { error: 'InvalidRequest', message: 'Unable to resolve handle' }
        // - 200 OK with { did: NonNullable<ResolvedHandle> }
        // Any other response is considered unexpected behavior an should throw an error.
        if (response.status === 400) {
            const data = module.exports.xrpcErrorSchema.parse(payload);
            if (data.error === 'InvalidRequest' && data.message === 'Unable to resolve handle') return null;
        }
        if (!response.ok) throw new TypeError('Invalid response from resolveHandle method');
        const value = payload?.did;
        if (!(0, $hIqij.isResolvedHandle)(value)) throw new TypeError('Invalid DID returned from resolveHandle method');
        return value;
    }
}
module.exports.AppViewHandleResolver = $bb4881c1563dc6f9$var$AppViewHandleResolver;

});

parcelRegister("kZxhz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtprotoDohHandleResolver = void 0;

var $4bQfa = parcelRequire("4bQfa");
class $f483525dff0d1f66$var$AtprotoDohHandleResolver extends $4bQfa.AtprotoHandleResolver {
    constructor(options){
        super({
            ...options,
            resolveTxt: $f483525dff0d1f66$var$dohResolveTxtFactory(options),
            resolveTxtFallback: undefined
        });
    }
}
module.exports.AtprotoDohHandleResolver = $f483525dff0d1f66$var$AtprotoDohHandleResolver;
/**
 * Resolver for DNS-over-HTTPS (DoH) handles. Only works with servers supporting
 * Google Flavoured "application/dns-json" queries.
 *
 * @see {@link https://developers.google.com/speed/public-dns/docs/doh/json}
 * @see {@link https://developers.cloudflare.com/1.1.1.1/encryption/dns-over-https/make-api-requests/dns-json/}
 * @todo Add support for DoH using application/dns-message (?)
 */ function $f483525dff0d1f66$var$dohResolveTxtFactory({ dohEndpoint: dohEndpoint, fetch: fetch = globalThis.fetch }) {
    return async (hostname)=>{
        const url = new URL(dohEndpoint);
        url.searchParams.set('type', 'TXT');
        url.searchParams.set('name', hostname);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                accept: 'application/dns-json'
            },
            redirect: 'follow'
        });
        try {
            const contentType = response.headers.get('content-type')?.trim();
            if (!response.ok) {
                const message = contentType?.startsWith('text/plain') ? await response.text() : `Failed to resolve ${hostname}`;
                throw new TypeError(message);
            } else if (contentType !== 'application/dns-json') throw new TypeError('Unexpected response from DoH server');
            const result = $f483525dff0d1f66$var$asResult(await response.json());
            return result.Answer?.filter($f483525dff0d1f66$var$isAnswerTxt).map($f483525dff0d1f66$var$extractTxtData) ?? null;
        } finally{
            // Make sure to always cancel the response body as some engines (Node 👀)
            // do not do this automatically.
            // https://undici.nodejs.org/#/?id=garbage-collection
            if (response.bodyUsed === false) // Handle rejection asynchronously
            response.body?.cancel().catch($f483525dff0d1f66$var$onCancelError);
        }
    };
}
function $f483525dff0d1f66$var$onCancelError(err) {
    if (!(err instanceof DOMException) || err.name !== 'AbortError') console.error('An error occurred while cancelling the response body:', err);
}
function $f483525dff0d1f66$var$isResult(result) {
    if (typeof result !== 'object' || result === null) return false;
    if (!('Status' in result) || typeof result.Status !== 'number') return false;
    if ('Answer' in result && !$f483525dff0d1f66$var$isArrayOf(result.Answer, $f483525dff0d1f66$var$isAnswer)) return false;
    return true;
}
function $f483525dff0d1f66$var$asResult(result) {
    if ($f483525dff0d1f66$var$isResult(result)) return result;
    throw new TypeError('Invalid DoH response');
}
function $f483525dff0d1f66$var$isArrayOf(value, predicate) {
    return Array.isArray(value) && value.every(predicate);
}
function $f483525dff0d1f66$var$isAnswer(answer) {
    return typeof answer === 'object' && answer !== null && 'name' in answer && typeof answer.name === 'string' && 'type' in answer && typeof answer.type === 'number' && 'data' in answer && typeof answer.data === 'string' && 'TTL' in answer && typeof answer.TTL === 'number';
}
function $f483525dff0d1f66$var$isAnswerTxt(answer) {
    return answer.type === 16;
}
function $f483525dff0d1f66$var$extractTxtData(answer) {
    return answer.data.replace(/^"|"$/g, '').replace(/\\"/g, '"');
}

});
parcelRegister("4bQfa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtprotoHandleResolver = void 0;

var $bBMsq = parcelRequire("bBMsq");

var $aIOLP = parcelRequire("aIOLP");
const $30d0b6fed86c608b$var$noop = ()=>{};
/**
 * Implementation of the official ATPROTO handle resolution strategy.
 * This implementation relies on two primitives:
 * - HTTP Well-Known URI resolution (requires a `fetch()` implementation)
 * - DNS TXT record resolution (requires a `resolveTxt()` function)
 */ class $30d0b6fed86c608b$var$AtprotoHandleResolver {
    constructor(options){
        Object.defineProperty(this, "httpResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dnsResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dnsResolverFallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.httpResolver = new $aIOLP.WellKnownHandleResolver(options);
        this.dnsResolver = new $bBMsq.DnsHandleResolver(options.resolveTxt);
        this.dnsResolverFallback = options.resolveTxtFallback ? new $bBMsq.DnsHandleResolver(options.resolveTxtFallback) : undefined;
    }
    async resolve(handle, options) {
        options?.signal?.throwIfAborted();
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        options?.signal?.addEventListener('abort', ()=>abortController.abort(), {
            signal: signal
        });
        const wrappedOptions = {
            ...options,
            signal: signal
        };
        try {
            const dnsPromise = this.dnsResolver.resolve(handle, wrappedOptions);
            const httpPromise = this.httpResolver.resolve(handle, wrappedOptions);
            // Prevent uncaught promise rejection
            httpPromise.catch($30d0b6fed86c608b$var$noop);
            const dnsRes = await dnsPromise;
            if (dnsRes) return dnsRes;
            signal.throwIfAborted();
            const res = await httpPromise;
            if (res) return res;
            signal.throwIfAborted();
            return this.dnsResolverFallback?.resolve(handle, wrappedOptions) ?? null;
        } finally{
            // Cancel pending requests, and remove "abort" listener on incoming signal
            abortController.abort();
        }
    }
}
module.exports.AtprotoHandleResolver = $30d0b6fed86c608b$var$AtprotoHandleResolver;

});
parcelRegister("bBMsq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DnsHandleResolver = void 0;

var $hIqij = parcelRequire("hIqij");
const $8738bd0ae628d690$var$SUBDOMAIN = '_atproto';
const $8738bd0ae628d690$var$PREFIX = 'did=';
class $8738bd0ae628d690$var$DnsHandleResolver {
    constructor(resolveTxt){
        Object.defineProperty(this, "resolveTxt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: resolveTxt
        });
    }
    async resolve(handle) {
        const results = await this.resolveTxt.call(null, `${$8738bd0ae628d690$var$SUBDOMAIN}.${handle}`);
        if (!results) return null;
        for(let i = 0; i < results.length; i++){
            // If the line does not start with "did=", skip it
            if (!results[i].startsWith($8738bd0ae628d690$var$PREFIX)) continue;
            // Ensure no other entry starting with "did=" follows
            for(let j = i + 1; j < results.length; j++){
                if (results[j].startsWith($8738bd0ae628d690$var$PREFIX)) return null;
            }
            // Note: No trimming (to be consistent with spec)
            const did = results[i].slice($8738bd0ae628d690$var$PREFIX.length);
            // Invalid DBS record
            return (0, $hIqij.isResolvedHandle)(did) ? did : null;
        }
        return null;
    }
}
module.exports.DnsHandleResolver = $8738bd0ae628d690$var$DnsHandleResolver;

});

parcelRegister("aIOLP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WellKnownHandleResolver = void 0;

var $hIqij = parcelRequire("hIqij");
class $7ce565633a992eb6$var$WellKnownHandleResolver {
    constructor(options){
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fetch = options?.fetch ?? globalThis.fetch;
    }
    async resolve(handle, options) {
        const url = new URL('/.well-known/atproto-did', `https://${handle}`);
        const headers = new Headers();
        if (options?.noCache) headers.set('cache-control', 'no-cache');
        try {
            const response = await this.fetch.call(null, url, {
                headers: headers,
                signal: options?.signal,
                redirect: 'error'
            });
            const text = await response.text();
            const firstLine = text.split('\n')[0].trim();
            if ((0, $hIqij.isResolvedHandle)(firstLine)) return firstLine;
            return null;
        } catch (err) {
            // The the request failed, assume the handle does not resolve to a DID,
            // unless the failure was due to the signal being aborted.
            options?.signal?.throwIfAborted();
            return null;
        }
    }
}
module.exports.WellKnownHandleResolver = $7ce565633a992eb6$var$WellKnownHandleResolver;

});



parcelRegister("6hYWA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CachedHandleResolver = void 0;

var $559MJ = parcelRequire("559MJ");

var $9eBhV = parcelRequire("9eBhV");
class $49439ad30d73ba85$var$CachedHandleResolver {
    constructor(/**
     * The resolver that will be used to resolve handles.
     */ resolver, cache = new $9eBhV.SimpleStoreMemory({
        max: 1000,
        ttl: 600000
    })){
        Object.defineProperty(this, "getter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.getter = new $559MJ.CachedGetter((handle, options)=>resolver.resolve(handle, options), cache);
    }
    async resolve(handle, options) {
        return this.getter.get(handle, options);
    }
}
module.exports.CachedHandleResolver = $49439ad30d73ba85$var$CachedHandleResolver;

});


parcelRegister("auA9I", function(module, exports) {
"use strict";
var $7a38c0810ae37db1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7a38c0810ae37db1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7a38c0810ae37db1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7a38c0810ae37db1$var$__exportStar((parcelRequire("9Vu2E")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("3bKHb")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("iRQEE")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("62uEt")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("dLdH2")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("cICSH")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("h1D42")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("90bfC")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("87okk")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("gha4i")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("lqUbY")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("8bc9R")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("eEZzb")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("iUYkl")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("k1LCj")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("iWdLz")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("kcXek")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("kBqrl")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("4Z3I5")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("invkT")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("cDexx")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("dSdJY")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("i3oKx")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("jlwgK")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("66cmL")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("3ibUR")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("loGgV")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("acMnd")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("lWKRr")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("7eEuQ")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("1Da3V")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("cCp1o")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("7JYvn")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("fHDFK")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("ln2nq")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("e9eSC")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("1MJGm")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("LmBbd")), module.exports);

$7a38c0810ae37db1$var$__exportStar((parcelRequire("9Ql4e")), module.exports);

});
parcelRegister("9Vu2E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CLIENT_ASSERTION_TYPE_JWT_BEARER = module.exports.ALLOW_UNSECURE_ORIGINS = void 0;
/**
 * A variable that allows to determine if unsecure origins should be allowed
 * in OAuth related URI's. This variable is only set to `true` when NODE_ENV
 * is either `development` or `test`.
 */ module.exports.ALLOW_UNSECURE_ORIGINS = (()=>{
    // try/catch to support running in a browser, including when process.env is
    // shimmed (e.g. by webpack)
    try {
        const env = "production";
        return env === 'development' || env === 'test';
    } catch  {
        return false;
    }
})();
module.exports.CLIENT_ASSERTION_TYPE_JWT_BEARER = 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer';

});

parcelRegister("3bKHb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractUrlPath = module.exports.safeUrl = module.exports.isLoopbackUrl = module.exports.isLoopbackHost = module.exports.isHostnameIP = void 0;
function $25269ee9f76f0609$var$isHostnameIP(hostname) {
    // IPv4
    if (hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) return true;
    // IPv6
    if (hostname.startsWith('[') && hostname.endsWith(']')) return true;
    return false;
}
module.exports.isHostnameIP = $25269ee9f76f0609$var$isHostnameIP;
function $25269ee9f76f0609$var$isLoopbackHost(host) {
    return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
}
module.exports.isLoopbackHost = $25269ee9f76f0609$var$isLoopbackHost;
function $25269ee9f76f0609$var$isLoopbackUrl(input) {
    const url = typeof input === 'string' ? new URL(input) : input;
    return $25269ee9f76f0609$var$isLoopbackHost(url.hostname);
}
module.exports.isLoopbackUrl = $25269ee9f76f0609$var$isLoopbackUrl;
function $25269ee9f76f0609$var$safeUrl(input) {
    try {
        return new URL(input);
    } catch  {
        return null;
    }
}
module.exports.safeUrl = $25269ee9f76f0609$var$safeUrl;
function $25269ee9f76f0609$var$extractUrlPath(url) {
    // Extracts the path from a URL, without relying on the URL constructor
    // (because it normalizes the URL)
    const endOfProtocol = url.startsWith('https://') ? 8 : url.startsWith('http://') ? 7 : -1;
    if (endOfProtocol === -1) throw new TypeError('URL must use the "https:" or "http:" protocol');
    const hashIdx = url.indexOf('#', endOfProtocol);
    const questionIdx = url.indexOf('?', endOfProtocol);
    const queryStrIdx = questionIdx !== -1 && (hashIdx === -1 || questionIdx < hashIdx) ? questionIdx : -1;
    const pathEnd = hashIdx === -1 ? queryStrIdx === -1 ? url.length : queryStrIdx : queryStrIdx === -1 ? hashIdx : Math.min(hashIdx, queryStrIdx);
    const slashIdx = url.indexOf('/', endOfProtocol);
    const pathStart = slashIdx === -1 || slashIdx > pathEnd ? pathEnd : slashIdx;
    if (endOfProtocol === pathStart) throw new TypeError('URL must contain a host');
    return url.substring(pathStart, pathEnd);
}
module.exports.extractUrlPath = $25269ee9f76f0609$var$extractUrlPath;

});

parcelRegister("iRQEE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.atprotoLoopbackClientMetadata = void 0;

var $iWdLz = parcelRequire("iWdLz");
function $dbc6055dc564f417$var$atprotoLoopbackClientMetadata(clientId) {
    const { scope: scope = 'atproto', redirect_uris: redirect_uris = [
        `http://127.0.0.1/`,
        `http://[::1]/`
    ] } = (0, $iWdLz.parseOAuthLoopbackClientId)(clientId);
    return {
        client_id: clientId,
        scope: scope,
        redirect_uris: redirect_uris,
        client_name: 'Loopback client',
        response_types: [
            'code'
        ],
        grant_types: [
            'authorization_code',
            'refresh_token'
        ],
        token_endpoint_auth_method: 'none',
        application_type: 'native',
        dpop_bound_access_tokens: true
    };
}
module.exports.atprotoLoopbackClientMetadata = $dbc6055dc564f417$var$atprotoLoopbackClientMetadata;

});
parcelRegister("iWdLz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseOAuthLoopbackClientId = module.exports.assertOAuthLoopbackClientId = module.exports.isOAuthClientIdLoopback = void 0;

var $cCp1o = parcelRequire("cCp1o");

var $3bKHb = parcelRequire("3bKHb");
const $dc9852751fa33862$var$OAUTH_CLIENT_ID_LOOPBACK_URL = 'http://localhost';
function $dc9852751fa33862$var$isOAuthClientIdLoopback(clientId) {
    try {
        $dc9852751fa33862$var$parseOAuthLoopbackClientId(clientId);
        return true;
    } catch  {
        return false;
    }
}
module.exports.isOAuthClientIdLoopback = $dc9852751fa33862$var$isOAuthClientIdLoopback;
function $dc9852751fa33862$var$assertOAuthLoopbackClientId(clientId) {
    $dc9852751fa33862$var$parseOAuthLoopbackClientId(clientId);
}
module.exports.assertOAuthLoopbackClientId = $dc9852751fa33862$var$assertOAuthLoopbackClientId;
// @TODO: should we turn this into a zod schema? (more coherent error with other
// validation functions)
function $dc9852751fa33862$var$parseOAuthLoopbackClientId(clientId) {
    if (!clientId.startsWith($dc9852751fa33862$var$OAUTH_CLIENT_ID_LOOPBACK_URL)) throw new TypeError(`Loopback ClientID must start with "${$dc9852751fa33862$var$OAUTH_CLIENT_ID_LOOPBACK_URL}"`);
    else if (clientId.includes('#', $dc9852751fa33862$var$OAUTH_CLIENT_ID_LOOPBACK_URL.length)) throw new TypeError('Loopback ClientID must not contain a hash component');
    const queryStringIdx = clientId.length > $dc9852751fa33862$var$OAUTH_CLIENT_ID_LOOPBACK_URL.length && clientId[$dc9852751fa33862$var$OAUTH_CLIENT_ID_LOOPBACK_URL.length] === '/' ? $dc9852751fa33862$var$OAUTH_CLIENT_ID_LOOPBACK_URL.length + 1 : $dc9852751fa33862$var$OAUTH_CLIENT_ID_LOOPBACK_URL.length;
    if (clientId.length === queryStringIdx) return {}; // no query string to parse
    if (clientId[queryStringIdx] !== '?') throw new TypeError('Loopback ClientID must not contain a path component');
    const searchParams = new URLSearchParams(clientId.slice(queryStringIdx + 1));
    for (const name of searchParams.keys()){
        if (name !== 'redirect_uri' && name !== 'scope') throw new TypeError(`Invalid query parameter "${name}" in client ID`);
    }
    const scope = searchParams.get('scope') ?? undefined;
    if (scope != null) {
        if (searchParams.getAll('scope').length > 1) throw new TypeError('Loopback ClientID must contain at most one scope query parameter');
        else if (!$cCp1o.oauthScopeSchema.safeParse(scope).success) throw new TypeError('Invalid scope query parameter in client ID');
    }
    const redirect_uris = searchParams.has('redirect_uri') ? searchParams.getAll('redirect_uri') : undefined;
    if (redirect_uris) for (const uri of redirect_uris){
        const url = (0, $3bKHb.safeUrl)(uri);
        if (!url) throw new TypeError(`Invalid redirect_uri in client ID: ${uri}`);
        if (url.protocol !== 'http:') throw new TypeError(`Loopback ClientID must use "http:" redirect_uri's (got ${uri})`);
        if (url.hostname === 'localhost') throw new TypeError(`Loopback ClientID must not use "localhost" as redirect_uri hostname (got ${uri})`);
        if (!(0, $3bKHb.isLoopbackHost)(url.hostname)) throw new TypeError(`Loopback ClientID must use loopback addresses as redirect_uri's (got ${uri})`);
    }
    return {
        scope: scope,
        redirect_uris: redirect_uris
    };
}
module.exports.parseOAuthLoopbackClientId = $dc9852751fa33862$var$parseOAuthLoopbackClientId;

});
parcelRegister("cCp1o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthScopeSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
/**
 * A space separated list of most non-control ASCII characters except backslash
 * and double quote.
 *
 * @see {@link https://datatracker.ietf.org/doc/html/draft-ietf-oauth-v2-1-11#section-1.4.1}
 */ module.exports.oauthScopeSchema = $2zDt6.z.string()// scope       = scope-token *( SP scope-token )
// scope-token = 1*( %x21 / %x23-5B / %x5D-7E )
.regex(/^[\x21\x23-\x5B\x5D-\x7E]+(?: [\x21\x23-\x5B\x5D-\x7E]+)*$/);

});



parcelRegister("62uEt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAccessTokenSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthAccessTokenSchema = $2zDt6.z.string().min(1);

});

parcelRegister("dLdH2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAuthorizationCodeGrantTokenRequestSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthAuthorizationCodeGrantTokenRequestSchema = $2zDt6.z.object({
    grant_type: $2zDt6.z.literal('authorization_code'),
    code: $2zDt6.z.string().min(1),
    redirect_uri: $2zDt6.z.string().url(),
    /** @see {@link https://datatracker.ietf.org/doc/html/rfc7636#section-4.1} */ code_verifier: $2zDt6.z.string().min(43).max(128).regex(/^[a-zA-Z0-9-._~]+$/).optional()
});

});

parcelRegister("cICSH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAuthorizationDetailsSchema = module.exports.oauthAuthorizationDetailSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc9396#section-2 | RFC 9396, Section 2}
 */ module.exports.oauthAuthorizationDetailSchema = $2zDt6.z.object({
    type: $2zDt6.z.string(),
    locations: $2zDt6.z.array($2zDt6.z.string().url()).optional(),
    actions: $2zDt6.z.array($2zDt6.z.string()).optional(),
    datatypes: $2zDt6.z.array($2zDt6.z.string()).optional(),
    identifier: $2zDt6.z.string().optional(),
    privileges: $2zDt6.z.array($2zDt6.z.string()).optional()
});
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc9396#section-2 | RFC 9396, Section 2}
 */ module.exports.oauthAuthorizationDetailsSchema = $2zDt6.z.array(module.exports.oauthAuthorizationDetailSchema);

});

parcelRegister("h1D42", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAuthorizationRequestJarSchema = void 0;

var $4EOoK = parcelRequire("4EOoK");

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthAuthorizationRequestJarSchema = $2zDt6.z.object({
    /**
     * AuthorizationRequest inside a JWT:
     * - "iat" is required and **MUST** be less than one minute
     *
     * @see {@link https://datatracker.ietf.org/doc/html/rfc9101}
     */ request: $2zDt6.z.union([
        $4EOoK.signedJwtSchema,
        $4EOoK.unsignedJwtSchema
    ])
});

});

parcelRegister("90bfC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAuthorizationRequestParSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $h1D42 = parcelRequire("h1D42");

var $87okk = parcelRequire("87okk");
module.exports.oauthAuthorizationRequestParSchema = $2zDt6.z.union([
    $87okk.oauthAuthorizationRequestParametersSchema,
    $h1D42.oauthAuthorizationRequestJarSchema
]);

});
parcelRegister("87okk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAuthorizationRequestParametersSchema = void 0;

var $4EOoK = parcelRequire("4EOoK");

var $2zDt6 = parcelRequire("2zDt6");

var $cICSH = parcelRequire("cICSH");

var $kcXek = parcelRequire("kcXek");

var $fKrbw = parcelRequire("fKrbw");

var $1Da3V = parcelRequire("1Da3V");

var $cCp1o = parcelRequire("cCp1o");

var $1MJGm = parcelRequire("1MJGm");

var $LmBbd = parcelRequire("LmBbd");

var $9Ql4e = parcelRequire("9Ql4e");
/**
 * @see {@link https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest | OIDC}
 */ module.exports.oauthAuthorizationRequestParametersSchema = $2zDt6.z.object({
    client_id: $kcXek.oauthClientIdSchema,
    state: $2zDt6.z.string().optional(),
    redirect_uri: $2zDt6.z.string().url().optional(),
    scope: $cCp1o.oauthScopeSchema.optional(),
    response_type: $1Da3V.oauthResponseTypeSchema,
    // PKCE
    code_challenge: $2zDt6.z.string().optional(),
    code_challenge_method: $fKrbw.oauthCodeChallengeMethodSchema.default('S256').optional(),
    // DPOP
    // https://datatracker.ietf.org/doc/html/rfc9449#section-12.3
    dpop_jkt: $2zDt6.z.string().optional(),
    // OIDC
    // Default depend on response_type
    response_mode: $2zDt6.z.enum([
        'query',
        'fragment',
        'form_post'
    ]).optional(),
    nonce: $2zDt6.z.string().optional(),
    // Specifies the allowable elapsed time in seconds since the last time the
    // End-User was actively authenticated by the OP. If the elapsed time is
    // greater than this value, the OP MUST attempt to actively re-authenticate
    // the End-User. (The max_age request parameter corresponds to the OpenID 2.0
    // PAPE [OpenID.PAPE] max_auth_age request parameter.) When max_age is used,
    // the ID Token returned MUST include an auth_time Claim Value. Note that
    // max_age=0 is equivalent to prompt=login.
    max_age: $2zDt6.z.number().int().min(0).optional(),
    claims: $2zDt6.z.record($9Ql4e.oidcEntityTypeSchema, $2zDt6.z.record($1MJGm.oidcClaimsParameterSchema, $2zDt6.z.union([
        $2zDt6.z.literal(null),
        $LmBbd.oidcClaimsPropertiesSchema
    ]))).optional(),
    // https://openid.net/specs/openid-connect-core-1_0.html#RegistrationParameter
    // Not supported by this library (yet?)
    // registration: clientMetadataSchema.optional(),
    login_hint: $2zDt6.z.string().min(1).optional(),
    ui_locales: $2zDt6.z.string().regex(/^[a-z]{2}(-[A-Z]{2})?( [a-z]{2}(-[A-Z]{2})?)*$/) // fr-CA fr en
    .optional(),
    // Previous ID Token, should be provided when prompt=none is used
    id_token_hint: $4EOoK.signedJwtSchema.optional(),
    // Type of UI the AS is displayed on
    display: $2zDt6.z.enum([
        'page',
        'popup',
        'touch'
    ]).optional(),
    /**
     * - "none" will only be allowed if the user already allowed the client on the same device
     * - "login" will force the user to login again, unless he very recently logged in
     * - "consent" will force the user to consent again
     * - "select_account" will force the user to select an account
     */ prompt: $2zDt6.z.enum([
        'none',
        'login',
        'consent',
        'select_account'
    ]).optional(),
    // https://datatracker.ietf.org/doc/html/rfc9396
    authorization_details: $cICSH.oauthAuthorizationDetailsSchema.optional()
});

});
parcelRegister("kcXek", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthClientIdSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthClientIdSchema = $2zDt6.z.string().min(1);

});

parcelRegister("fKrbw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthCodeChallengeMethodSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthCodeChallengeMethodSchema = $2zDt6.z.enum([
    'S256',
    'plain'
]);

});

parcelRegister("1Da3V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthResponseTypeSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthResponseTypeSchema = $2zDt6.z.enum([
    // OAuth2 (https://datatracker.ietf.org/doc/html/draft-ietf-oauth-v2-1-10#section-4.1.1)
    'code',
    'token',
    // OIDC (https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html)
    'none',
    'code id_token token',
    'code id_token',
    'code token',
    'id_token token',
    'id_token'
]);

});

parcelRegister("1MJGm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oidcClaimsParameterSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oidcClaimsParameterSchema = $2zDt6.z.enum([
    // https://openid.net/specs/openid-provider-authentication-policy-extension-1_0.html#rfc.section.5.2
    // if client metadata "require_auth_time" is true, this *must* be provided
    'auth_time',
    // OIDC
    'nonce',
    'acr',
    // OpenID: "profile" scope
    'name',
    'family_name',
    'given_name',
    'middle_name',
    'nickname',
    'preferred_username',
    'gender',
    'picture',
    'profile',
    'website',
    'birthdate',
    'zoneinfo',
    'locale',
    'updated_at',
    // OpenID: "email" scope
    'email',
    'email_verified',
    // OpenID: "phone" scope
    'phone_number',
    'phone_number_verified',
    // OpenID: "address" scope
    'address'
]);

});

parcelRegister("LmBbd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oidcClaimsPropertiesSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
const $08e5eb870ba9a4ad$var$oidcClaimsValueSchema = $2zDt6.z.union([
    $2zDt6.z.string(),
    $2zDt6.z.number(),
    $2zDt6.z.boolean()
]);
module.exports.oidcClaimsPropertiesSchema = $2zDt6.z.object({
    essential: $2zDt6.z.boolean().optional(),
    value: $08e5eb870ba9a4ad$var$oidcClaimsValueSchema.optional(),
    values: $2zDt6.z.array($08e5eb870ba9a4ad$var$oidcClaimsValueSchema).optional()
});

});

parcelRegister("9Ql4e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oidcEntityTypeSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oidcEntityTypeSchema = $2zDt6.z.enum([
    'userinfo',
    'id_token'
]);

});



parcelRegister("gha4i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAuthorizationRequestQuerySchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $h1D42 = parcelRequire("h1D42");

var $87okk = parcelRequire("87okk");

var $lqUbY = parcelRequire("lqUbY");
module.exports.oauthAuthorizationRequestQuerySchema = $2zDt6.z.union([
    $87okk.oauthAuthorizationRequestParametersSchema,
    $h1D42.oauthAuthorizationRequestJarSchema,
    $lqUbY.oauthAuthorizationRequestUriSchema
]);

});
parcelRegister("lqUbY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAuthorizationRequestUriSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $lWKRr = parcelRequire("lWKRr");
module.exports.oauthAuthorizationRequestUriSchema = $2zDt6.z.object({
    request_uri: $lWKRr.oauthRequestUriSchema
});

});
parcelRegister("lWKRr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthRequestUriSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthRequestUriSchema = $2zDt6.z.string();

});



parcelRegister("8bc9R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthAuthorizationServerMetadataValidator = module.exports.oauthAuthorizationServerMetadataSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $fKrbw = parcelRequire("fKrbw");

var $i3oKx = parcelRequire("i3oKx");
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc8414}
 */ module.exports.oauthAuthorizationServerMetadataSchema = $2zDt6.z.object({
    issuer: $i3oKx.oauthIssuerIdentifierSchema,
    claims_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    claims_locales_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    claims_parameter_supported: $2zDt6.z.boolean().optional(),
    request_parameter_supported: $2zDt6.z.boolean().optional(),
    request_uri_parameter_supported: $2zDt6.z.boolean().optional(),
    require_request_uri_registration: $2zDt6.z.boolean().optional(),
    scopes_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    subject_types_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    response_types_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    response_modes_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    grant_types_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    code_challenge_methods_supported: $2zDt6.z.array($fKrbw.oauthCodeChallengeMethodSchema).min(1).optional(),
    ui_locales_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    id_token_signing_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    display_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    request_object_signing_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    authorization_response_iss_parameter_supported: $2zDt6.z.boolean().optional(),
    authorization_details_types_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    request_object_encryption_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    request_object_encryption_enc_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    jwks_uri: $2zDt6.z.string().url().optional(),
    authorization_endpoint: $2zDt6.z.string().url(),
    token_endpoint: $2zDt6.z.string().url(),
    token_endpoint_auth_methods_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    token_endpoint_auth_signing_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    revocation_endpoint: $2zDt6.z.string().url().optional(),
    introspection_endpoint: $2zDt6.z.string().url().optional(),
    pushed_authorization_request_endpoint: $2zDt6.z.string().url().optional(),
    require_pushed_authorization_requests: $2zDt6.z.boolean().optional(),
    userinfo_endpoint: $2zDt6.z.string().url().optional(),
    end_session_endpoint: $2zDt6.z.string().url().optional(),
    registration_endpoint: $2zDt6.z.string().url().optional(),
    // https://datatracker.ietf.org/doc/html/rfc9449#section-5.1
    dpop_signing_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    // https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05#section-4
    protected_resources: $2zDt6.z.array($2zDt6.z.string().url()).optional(),
    // https://drafts.aaronpk.com/draft-parecki-oauth-client-id-metadata-document/draft-parecki-oauth-client-id-metadata-document.html
    client_id_metadata_document_supported: $2zDt6.z.boolean().optional()
});
module.exports.oauthAuthorizationServerMetadataValidator = module.exports.oauthAuthorizationServerMetadataSchema.superRefine((data, ctx)=>{
    if (data.require_pushed_authorization_requests && !data.pushed_authorization_request_endpoint) ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: '"pushed_authorization_request_endpoint" required when "require_pushed_authorization_requests" is true'
    });
}).superRefine((data, ctx)=>{
    if (data.response_types_supported) {
        if (!data.response_types_supported.includes('code')) ctx.addIssue({
            code: $2zDt6.z.ZodIssueCode.custom,
            message: 'Response type "code" is required'
        });
    }
});

});
parcelRegister("i3oKx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthIssuerIdentifierSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $9Vu2E = parcelRequire("9Vu2E");

var $3bKHb = parcelRequire("3bKHb");
module.exports.oauthIssuerIdentifierSchema = $2zDt6.z.string().superRefine((value, ctx)=>{
    // Validate the issuer (MIX-UP attacks)
    if (value.endsWith('/')) ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: 'Issuer URL must not end with a slash'
    });
    const url = (0, $3bKHb.safeUrl)(value);
    if (!url) return ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: 'Invalid url'
    });
    if (url.protocol !== 'https:') {
        if ($9Vu2E.ALLOW_UNSECURE_ORIGINS && url.protocol === 'http:') ;
        else ctx.addIssue({
            code: $2zDt6.z.ZodIssueCode.custom,
            message: 'Issuer must be an HTTPS URL'
        });
    }
    if (url.username || url.password) ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: 'Issuer URL must not contain a username or password'
    });
    if (url.hash || url.search) ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: 'Issuer URL must not contain a query or fragment'
    });
    const canonicalValue = url.pathname === '/' ? url.origin : url.href;
    if (value !== canonicalValue) ctx.addIssue({
        code: $2zDt6.z.ZodIssueCode.custom,
        message: 'Issuer URL must be in the canonical form'
    });
});

});


parcelRegister("eEZzb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthClientCredentialsGrantTokenRequestSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthClientCredentialsGrantTokenRequestSchema = $2zDt6.z.object({
    grant_type: $2zDt6.z.literal('client_credentials')
});

});

parcelRegister("iUYkl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthClientCredentialsSchema = module.exports.oauthClientCredentialsNoneSchema = module.exports.oauthClientCredentialsSecretPostSchema = module.exports.oauthClientCredentialsJwtBearerSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $4EOoK = parcelRequire("4EOoK");

var $kcXek = parcelRequire("kcXek");

var $9Vu2E = parcelRequire("9Vu2E");
module.exports.oauthClientCredentialsJwtBearerSchema = $2zDt6.z.object({
    client_id: $kcXek.oauthClientIdSchema,
    client_assertion_type: $2zDt6.z.literal($9Vu2E.CLIENT_ASSERTION_TYPE_JWT_BEARER),
    /**
     * - "sub" the subject MUST be the "client_id" of the OAuth client
     * - "iat" is required and MUST be less than one minute
     * - "aud" must containing a value that identifies the authorization server
     * - The JWT MAY contain a "jti" (JWT ID) claim that provides a unique identifier for the token.
     * - Note that the authorization server may reject JWTs with an "exp" claim value that is unreasonably far in the future.
     *
     * @see {@link https://datatracker.ietf.org/doc/html/rfc7523#section-3}
     */ client_assertion: $4EOoK.signedJwtSchema
});
module.exports.oauthClientCredentialsSecretPostSchema = $2zDt6.z.object({
    client_id: $kcXek.oauthClientIdSchema,
    client_secret: $2zDt6.z.string()
});
module.exports.oauthClientCredentialsNoneSchema = $2zDt6.z.object({
    client_id: $kcXek.oauthClientIdSchema
});
//
module.exports.oauthClientCredentialsSchema = $2zDt6.z.union([
    module.exports.oauthClientCredentialsJwtBearerSchema,
    module.exports.oauthClientCredentialsSecretPostSchema,
    // Must be last since it is less specific
    module.exports.oauthClientCredentialsNoneSchema
]);

});

parcelRegister("k1LCj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseOAuthDiscoverableClientId = module.exports.assertOAuthDiscoverableClientId = module.exports.isOAuthClientIdDiscoverable = void 0;

var $3bKHb = parcelRequire("3bKHb");
function $e948d659bf33c2b7$var$isOAuthClientIdDiscoverable(clientId) {
    try {
        $e948d659bf33c2b7$var$parseOAuthDiscoverableClientId(clientId);
        return true;
    } catch  {
        return false;
    }
}
module.exports.isOAuthClientIdDiscoverable = $e948d659bf33c2b7$var$isOAuthClientIdDiscoverable;
function $e948d659bf33c2b7$var$assertOAuthDiscoverableClientId(value) {
    $e948d659bf33c2b7$var$parseOAuthDiscoverableClientId(value);
}
module.exports.assertOAuthDiscoverableClientId = $e948d659bf33c2b7$var$assertOAuthDiscoverableClientId;
function $e948d659bf33c2b7$var$parseOAuthDiscoverableClientId(clientId) {
    const url = new URL(clientId);
    if (url.protocol !== 'https:') throw new TypeError('ClientID must use the "https:" protocol');
    if (url.username || url.password) throw new TypeError('ClientID must not contain credentials');
    if (url.hash) throw new TypeError('ClientID must not contain a fragment');
    if (url.hostname === 'localhost') throw new TypeError('ClientID hostname must not be "localhost"');
    if (url.pathname === '/') throw new TypeError('ClientID must contain a path component (e.g. "/client-metadata.json")');
    if (url.pathname.endsWith('/')) throw new TypeError('ClientID path must not end with a trailing slash');
    if ((0, $3bKHb.isHostnameIP)(url.hostname)) throw new TypeError('ClientID hostname must not be an IP address');
    // URL constructor normalizes the URL, so we extract the path manually to
    // avoid normalization, then compare it to the normalized path to ensure
    // that the URL does not contain path traversal or other unexpected characters
    if ((0, $3bKHb.extractUrlPath)(clientId) !== url.pathname) throw new TypeError(`ClientID must be in canonical form ("${url.href}", got "${clientId}")`);
    return url;
}
module.exports.parseOAuthDiscoverableClientId = $e948d659bf33c2b7$var$parseOAuthDiscoverableClientId;

});

parcelRegister("kBqrl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthClientMetadataSchema = void 0;

var $4EOoK = parcelRequire("4EOoK");

var $2zDt6 = parcelRequire("2zDt6");

var $kcXek = parcelRequire("kcXek");

var $4Z3I5 = parcelRequire("4Z3I5");

var $cDexx = parcelRequire("cDexx");

var $1Da3V = parcelRequire("1Da3V");

var $cCp1o = parcelRequire("cCp1o");
// https://openid.net/specs/openid-connect-registration-1_0.html
// https://datatracker.ietf.org/doc/html/rfc7591
module.exports.oauthClientMetadataSchema = $2zDt6.z.object({
    redirect_uris: $2zDt6.z.array($2zDt6.z.string().url()).nonempty(),
    response_types: $2zDt6.z.array($1Da3V.oauthResponseTypeSchema).nonempty()// > If omitted, the default is that the client will use only the "code"
    // > response type.
    .default([
        'code'
    ]),
    grant_types: $2zDt6.z.array($cDexx.oauthGrantTypeSchema).nonempty()// > If omitted, the default behavior is that the client will use only the
    // > "authorization_code" Grant Type.
    .default([
        'authorization_code'
    ]),
    scope: $cCp1o.oauthScopeSchema.optional(),
    token_endpoint_auth_method: $4Z3I5.oauthEndpointAuthMethod.default('none').optional(),
    token_endpoint_auth_signing_alg: $2zDt6.z.string().optional(),
    userinfo_signed_response_alg: $2zDt6.z.string().optional(),
    userinfo_encrypted_response_alg: $2zDt6.z.string().optional(),
    jwks_uri: $2zDt6.z.string().url().optional(),
    jwks: $4EOoK.jwksPubSchema.optional(),
    application_type: $2zDt6.z.enum([
        'web',
        'native'
    ]).default('web').optional(),
    subject_type: $2zDt6.z.enum([
        'public',
        'pairwise'
    ]).default('public').optional(),
    request_object_signing_alg: $2zDt6.z.string().optional(),
    id_token_signed_response_alg: $2zDt6.z.string().optional(),
    authorization_signed_response_alg: $2zDt6.z.string().default('RS256').optional(),
    authorization_encrypted_response_enc: $2zDt6.z.enum([
        'A128CBC-HS256'
    ]).optional(),
    authorization_encrypted_response_alg: $2zDt6.z.string().optional(),
    client_id: $kcXek.oauthClientIdSchema.optional(),
    client_name: $2zDt6.z.string().optional(),
    client_uri: $2zDt6.z.string().url().optional(),
    policy_uri: $2zDt6.z.string().url().optional(),
    tos_uri: $2zDt6.z.string().url().optional(),
    logo_uri: $2zDt6.z.string().url().optional(),
    /**
     * Default Maximum Authentication Age. Specifies that the End-User MUST be
     * actively authenticated if the End-User was authenticated longer ago than
     * the specified number of seconds. The max_age request parameter overrides
     * this default value. If omitted, no default Maximum Authentication Age is
     * specified.
     */ default_max_age: $2zDt6.z.number().optional(),
    require_auth_time: $2zDt6.z.boolean().optional(),
    contacts: $2zDt6.z.array($2zDt6.z.string().email()).optional(),
    tls_client_certificate_bound_access_tokens: $2zDt6.z.boolean().optional(),
    // https://datatracker.ietf.org/doc/html/rfc9449#section-5.2
    dpop_bound_access_tokens: $2zDt6.z.boolean().optional(),
    // https://datatracker.ietf.org/doc/html/rfc9396#section-14.5
    authorization_details_types: $2zDt6.z.array($2zDt6.z.string()).optional()
});

});
parcelRegister("4Z3I5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthEndpointAuthMethod = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthEndpointAuthMethod = $2zDt6.z.enum([
    'client_secret_basic',
    'client_secret_jwt',
    'client_secret_post',
    'none',
    'private_key_jwt',
    'self_signed_tls_client_auth',
    'tls_client_auth'
]);

});

parcelRegister("cDexx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthGrantTypeSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthGrantTypeSchema = $2zDt6.z.enum([
    'authorization_code',
    'implicit',
    'refresh_token',
    'password',
    'client_credentials',
    'urn:ietf:params:oauth:grant-type:jwt-bearer',
    'urn:ietf:params:oauth:grant-type:saml2-bearer'
]);

});


parcelRegister("invkT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAUTH_ENDPOINT_NAMES = void 0;
module.exports.OAUTH_ENDPOINT_NAMES = [
    'token',
    'revocation',
    'introspection',
    'pushed_authorization_request'
];

});

parcelRegister("dSdJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jlwgK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthParResponseSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthParResponseSchema = $2zDt6.z.object({
    request_uri: $2zDt6.z.string(),
    expires_in: $2zDt6.z.number().int().positive()
});

});

parcelRegister("66cmL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthPasswordGrantTokenRequestSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthPasswordGrantTokenRequestSchema = $2zDt6.z.object({
    grant_type: $2zDt6.z.literal('password'),
    username: $2zDt6.z.string(),
    password: $2zDt6.z.string()
});

});

parcelRegister("3ibUR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthProtectedResourceMetadataSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $i3oKx = parcelRequire("i3oKx");
/**
 * @see {@link https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05#name-protected-resource-metadata-r}
 */ module.exports.oauthProtectedResourceMetadataSchema = $2zDt6.z.object({
    /**
     * REQUIRED. The protected resource's resource identifier, which is a URL that
     * uses the https scheme and has no query or fragment components. Using these
     * well-known resources is described in Section 3.
     */ resource: $2zDt6.z.string().url(),
    /**
     * OPTIONAL. JSON array containing a list of OAuth authorization server issuer
     * identifiers, as defined in [RFC8414], for authorization servers that can be
     * used with this protected resource. Protected resources MAY choose not to
     * advertise some supported authorization servers even when this parameter is
     * used. In some use cases, the set of authorization servers will not be
     * enumerable, in which case this metadata parameter would not be used.
     */ authorization_servers: $2zDt6.z.array($i3oKx.oauthIssuerIdentifierSchema).optional(),
    /**
     * OPTIONAL. URL of the protected resource's JWK Set [JWK] document. This
     * contains public keys belonging to the protected resource, such as signing
     * key(s) that the resource server uses to sign resource responses. This URL
     * MUST use the https scheme. When both signing and encryption keys are made
     * available, a use (public key use) parameter value is REQUIRED for all keys
     * in the referenced JWK Set to indicate each key's intended usage.
     */ jwks_uri: $2zDt6.z.string().url().optional(),
    /**
     * RECOMMENDED. JSON array containing a list of the OAuth 2.0 [RFC6749] scope
     * values that are used in authorization requests to request access to this
     * protected resource. Protected resources MAY choose not to advertise some
     * scope values supported even when this parameter is used.
     */ scopes_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    /**
     * OPTIONAL. JSON array containing a list of the supported methods of sending
     * an OAuth 2.0 Bearer Token [RFC6750] to the protected resource. Defined
     * values are ["header", "body", "query"], corresponding to Sections 2.1, 2.2,
     * and 2.3 of RFC 6750.
     */ bearer_methods_supported: $2zDt6.z.array($2zDt6.z.enum([
        'header',
        'body',
        'query'
    ])).optional(),
    /**
     * OPTIONAL. JSON array containing a list of the JWS [JWS] signing algorithms
     * (alg values) [JWA] supported by the protected resource for signing resource
     * responses, for instance, as described in [FAPI.MessageSigning]. No default
     * algorithms are implied if this entry is omitted. The value none MUST NOT be
     * used.
     */ resource_signing_alg_values_supported: $2zDt6.z.array($2zDt6.z.string()).optional(),
    /**
     * OPTIONAL. URL of a page containing human-readable information that
     * developers might want or need to know when using the protected resource
     */ resource_documentation: $2zDt6.z.string().url().optional(),
    /**
     * OPTIONAL. URL that the protected resource provides to read about the
     * protected resource's requirements on how the client can use the data
     * provided by the protected resource
     */ resource_policy_uri: $2zDt6.z.string().url().optional(),
    /**
     * OPTIONAL. URL that the protected resource provides to read about the
     * protected resource's terms of service
     */ resource_tos_uri: $2zDt6.z.string().url().optional()
});

});

parcelRegister("loGgV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthRefreshTokenGrantTokenRequestSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $kcXek = parcelRequire("kcXek");

var $acMnd = parcelRequire("acMnd");
module.exports.oauthRefreshTokenGrantTokenRequestSchema = $2zDt6.z.object({
    grant_type: $2zDt6.z.literal('refresh_token'),
    refresh_token: $acMnd.oauthRefreshTokenSchema,
    client_id: $kcXek.oauthClientIdSchema
});

});
parcelRegister("acMnd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthRefreshTokenSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthRefreshTokenSchema = $2zDt6.z.string().min(1);

});


parcelRegister("7eEuQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthResponseModeSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
module.exports.oauthResponseModeSchema = $2zDt6.z.enum([
    'query',
    'fragment',
    'form_post'
]);

});

parcelRegister("7JYvn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthTokenIdentificationSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $62uEt = parcelRequire("62uEt");

var $acMnd = parcelRequire("acMnd");
module.exports.oauthTokenIdentificationSchema = $2zDt6.z.object({
    token: $2zDt6.z.union([
        $62uEt.oauthAccessTokenSchema,
        $acMnd.oauthRefreshTokenSchema
    ]),
    token_type_hint: $2zDt6.z.enum([
        'access_token',
        'refresh_token'
    ]).optional()
});

});

parcelRegister("fHDFK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthTokenRequestSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");

var $dLdH2 = parcelRequire("dLdH2");

var $eEZzb = parcelRequire("eEZzb");

var $66cmL = parcelRequire("66cmL");

var $loGgV = parcelRequire("loGgV");
module.exports.oauthTokenRequestSchema = $2zDt6.z.discriminatedUnion('grant_type', [
    $dLdH2.oauthAuthorizationCodeGrantTokenRequestSchema,
    $loGgV.oauthRefreshTokenGrantTokenRequestSchema,
    $66cmL.oauthPasswordGrantTokenRequestSchema,
    $eEZzb.oauthClientCredentialsGrantTokenRequestSchema
]);

});

parcelRegister("ln2nq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthTokenResponseSchema = void 0;

var $4EOoK = parcelRequire("4EOoK");

var $2zDt6 = parcelRequire("2zDt6");

var $cICSH = parcelRequire("cICSH");

var $e9eSC = parcelRequire("e9eSC");
/**
 * @see {@link https://www.rfc-editor.org/rfc/rfc6749.html#section-5.1 | RFC 6749 (OAuth2), Section 5.1}
 */ module.exports.oauthTokenResponseSchema = $2zDt6.z.object({
    access_token: $2zDt6.z.string(),
    token_type: $e9eSC.oauthTokenTypeSchema,
    issuer: $2zDt6.z.string().url().optional(),
    scope: $2zDt6.z.string().optional(),
    id_token: $4EOoK.signedJwtSchema.optional(),
    refresh_token: $2zDt6.z.string().optional(),
    expires_in: $2zDt6.z.number().optional(),
    authorization_details: $cICSH.oauthAuthorizationDetailsSchema.optional()
})// https://www.rfc-editor.org/rfc/rfc6749.html#section-5.1
// > The client MUST ignore unrecognized value names in the response.
.passthrough();

});
parcelRegister("e9eSC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oauthTokenTypeSchema = void 0;

var $2zDt6 = parcelRequire("2zDt6");
// Case insensitive input, normalized output
module.exports.oauthTokenTypeSchema = $2zDt6.z.union([
    $2zDt6.z.string().regex(/^DPoP$/i).transform(()=>'DPoP'),
    $2zDt6.z.string().regex(/^Bearer$/i).transform(()=>'Bearer')
]);

});



parcelRegister("6oTi5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthAuthorizationServerMetadataResolver = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $559MJ = parcelRequire("559MJ");

var $auA9I = parcelRequire("auA9I");

var $96UnS = parcelRequire("96UnS");
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc8414}
 */ class $4a8fdf8c389ec91b$var$OAuthAuthorizationServerMetadataResolver extends $559MJ.CachedGetter {
    constructor(cache, fetch){
        super(async (issuer, options)=>this.fetchMetadata(issuer, options), cache);
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fetch = (0, $8oTqd.bindFetch)(fetch);
    }
    async get(issuer, options) {
        return super.get($auA9I.oauthIssuerIdentifierSchema.parse(issuer), options);
    }
    async fetchMetadata(issuer, options) {
        const headers = new Headers([
            [
                'accept',
                'application/json'
            ]
        ]);
        if (options?.noCache) headers.set('cache-control', 'no-cache');
        const url = new URL(`/.well-known/oauth-authorization-server`, issuer);
        const request = new Request(url, {
            signal: options?.signal,
            headers: headers,
            redirect: 'manual'
        });
        const response = await this.fetch(request);
        // https://datatracker.ietf.org/doc/html/rfc8414#section-3.2
        if (response.status !== 200) {
            await (0, $8oTqd.cancelBody)(response, 'log');
            throw await $8oTqd.FetchResponseError.from(response, `Unexpected status code ${response.status} for "${url}"`, undefined, {
                cause: request
            });
        }
        if ((0, $96UnS.contentMime)(response.headers) !== 'application/json') {
            await (0, $8oTqd.cancelBody)(response, 'log');
            throw await $8oTqd.FetchResponseError.from(response, `Unexpected content type for "${url}"`, undefined, {
                cause: request
            });
        }
        const metadata = $auA9I.oauthAuthorizationServerMetadataValidator.parse(await response.json());
        // Validate the issuer (MIX-UP attacks)
        // https://datatracker.ietf.org/doc/html/draft-ietf-oauth-security-topics#name-mix-up-attacks
        // https://datatracker.ietf.org/doc/html/rfc8414#section-2
        if (metadata.issuer !== issuer) throw new TypeError(`Invalid issuer ${metadata.issuer}`);
        // ATPROTO requires client_id_metadata_document
        // http://drafts.aaronpk.com/draft-parecki-oauth-client-id-metadata-document/draft-parecki-oauth-client-id-metadata-document.html
        if (metadata.client_id_metadata_document_supported !== true) throw new TypeError(`Authorization server "${issuer}" does not support client_id_metadata_document`);
        return metadata;
    }
}
module.exports.OAuthAuthorizationServerMetadataResolver = $4a8fdf8c389ec91b$var$OAuthAuthorizationServerMetadataResolver;

});
parcelRegister("96UnS", function(module, exports) {
"use strict";
var $6a2069511784c76e$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6a2069511784c76e$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomEventTarget = module.exports.CustomEvent = module.exports.contentMime = module.exports.timeoutSignal = void 0;
// @ts-expect-error
Symbol.dispose ?? (Symbol.dispose = Symbol('@@dispose'));
/**
 * @todo (?) move to common package
 */ const $6a2069511784c76e$var$timeoutSignal = (timeout, options)=>{
    if (!Number.isInteger(timeout) || timeout < 0) throw new TypeError('Expected a positive integer');
    options?.signal?.throwIfAborted();
    const controller = new AbortController();
    const { signal: signal } = controller;
    options?.signal?.addEventListener('abort', (reason)=>controller.abort(reason), {
        once: true,
        signal: signal
    });
    const timeoutId = setTimeout((err)=>controller.abort(err), timeout, // create Error here to keep original stack trace
    new Error('Timeout'));
    timeoutId?.unref?.(); // NodeJS only
    signal.addEventListener('abort', ()=>clearTimeout(timeoutId), {
        once: true,
        signal: signal
    });
    Object.defineProperty(signal, Symbol.dispose, {
        value: ()=>controller.abort()
    });
    return signal;
};
module.exports.timeoutSignal = $6a2069511784c76e$var$timeoutSignal;
function $6a2069511784c76e$var$contentMime(headers) {
    return headers.get('content-type')?.split(';')[0].trim();
}
module.exports.contentMime = $6a2069511784c76e$var$contentMime;
/**
 * Ponyfill for `CustomEvent` constructor.
 */ module.exports.CustomEvent = globalThis.CustomEvent ?? (()=>{
    var _CustomEvent_detail;
    class CustomEvent extends Event {
        constructor(type, options){
            if (!arguments.length) throw new TypeError('type argument is required');
            super(type, options);
            _CustomEvent_detail.set(this, void 0);
            $6a2069511784c76e$var$__classPrivateFieldSet(this, _CustomEvent_detail, options?.detail ?? null, "f");
        }
        get detail() {
            return $6a2069511784c76e$var$__classPrivateFieldGet(this, _CustomEvent_detail, "f");
        }
    }
    _CustomEvent_detail = new WeakMap();
    Object.defineProperties(CustomEvent.prototype, {
        [Symbol.toStringTag]: {
            writable: false,
            enumerable: false,
            configurable: true,
            value: 'CustomEvent'
        },
        detail: {
            enumerable: true
        }
    });
    return CustomEvent;
})();
class $6a2069511784c76e$var$CustomEventTarget {
    constructor(){
        Object.defineProperty(this, "eventTarget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new EventTarget()
        });
    }
    addEventListener(type, callback, options) {
        this.eventTarget.addEventListener(type, callback, options);
    }
    removeEventListener(type, callback, options) {
        this.eventTarget.removeEventListener(type, callback, options);
    }
    dispatchCustomEvent(type, detail, init) {
        return this.eventTarget.dispatchEvent(new module.exports.CustomEvent(type, {
            ...init,
            detail: detail
        }));
    }
}
module.exports.CustomEventTarget = $6a2069511784c76e$var$CustomEventTarget;

});


parcelRegister("lfpNx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthCallbackError = void 0;
class $f77f02a138075c32$var$OAuthCallbackError extends Error {
    static from(err, params, state) {
        if (err instanceof $f77f02a138075c32$var$OAuthCallbackError) return err;
        const message = err instanceof Error ? err.message : undefined;
        return new $f77f02a138075c32$var$OAuthCallbackError(params, message, state, err);
    }
    constructor(params, message = params.get('error_description') || 'OAuth callback error', state, cause){
        super(message, {
            cause: cause
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: params
        });
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: state
        });
    }
}
module.exports.OAuthCallbackError = $f77f02a138075c32$var$OAuthCallbackError;

});

parcelRegister("gwEzH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthClient = void 0;

var $k2dJf = parcelRequire("k2dJf");

var $fYfau = parcelRequire("fYfau");

var $bGbIW = parcelRequire("bGbIW");

var $9eBhV = parcelRequire("9eBhV");

var $4EOoK = parcelRequire("4EOoK");

var $auA9I = parcelRequire("auA9I");

var $59fWx = parcelRequire("59fWx");

var $5QfU8 = parcelRequire("5QfU8");

var $6oTi5 = parcelRequire("6oTi5");

var $lfpNx = parcelRequire("lfpNx");

var $fFwT5 = parcelRequire("fFwT5");

var $b1J1b = parcelRequire("b1J1b");

var $4H3QM = parcelRequire("4H3QM");

var $6aqH9 = parcelRequire("6aqH9");

var $f60TT = parcelRequire("f60TT");

var $5u6ZB = parcelRequire("5u6ZB");

var $96UnS = parcelRequire("96UnS");

var $5cQ7D = parcelRequire("5cQ7D");
class $c07f1bc9b04139ab$var$OAuthClient extends $96UnS.CustomEventTarget {
    static async fetchMetadata({ clientId: clientId, fetch: fetch = globalThis.fetch, signal: signal }) {
        signal?.throwIfAborted();
        const request = new Request(clientId, {
            redirect: 'error',
            signal: signal
        });
        const response = await fetch(request);
        if (response.status !== 200) {
            response.body?.cancel?.();
            throw new TypeError(`Failed to fetch client metadata: ${response.status}`);
        }
        // https://drafts.aaronpk.com/draft-parecki-oauth-client-id-metadata-document/draft-parecki-oauth-client-id-metadata-document.html#section-4.1
        const mime = response.headers.get('content-type')?.split(';')[0].trim();
        if (mime !== 'application/json') {
            response.body?.cancel?.();
            throw new TypeError(`Invalid client metadata content type: ${mime}`);
        }
        const json = await response.json();
        signal?.throwIfAborted();
        return $auA9I.oauthClientMetadataSchema.parse(json);
    }
    constructor({ fetch: fetch = globalThis.fetch, stateStore: stateStore, sessionStore: sessionStore, didCache: didCache, dpopNonceCache: dpopNonceCache = new $9eBhV.SimpleStoreMemory({
        ttl: 60e3,
        max: 100
    }), handleCache: handleCache, authorizationServerMetadataCache: authorizationServerMetadataCache = new $9eBhV.SimpleStoreMemory({
        ttl: 60e3,
        max: 100
    }), protectedResourceMetadataCache: protectedResourceMetadataCache = new $9eBhV.SimpleStoreMemory({
        ttl: 60e3,
        max: 100
    }), responseMode: responseMode, clientMetadata: clientMetadata, handleResolver: handleResolver, plcDirectoryUrl: plcDirectoryUrl, runtimeImplementation: runtimeImplementation, keyset: keyset }){
        super();
        // Config
        Object.defineProperty(this, "clientMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "responseMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "keyset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Services
        Object.defineProperty(this, "runtime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "oauthResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "serverFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Stores
        Object.defineProperty(this, "sessionGetter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.keyset = keyset ? keyset instanceof $4EOoK.Keyset ? keyset : new $4EOoK.Keyset(keyset) : undefined;
        this.clientMetadata = (0, $5cQ7D.validateClientMetadata)(clientMetadata, this.keyset);
        this.responseMode = responseMode;
        this.runtime = new $f60TT.Runtime(runtimeImplementation);
        this.fetch = fetch;
        this.oauthResolver = new $b1J1b.OAuthResolver(new $bGbIW.IdentityResolver(new $k2dJf.DidResolverCached(new $k2dJf.DidResolverCommon({
            fetch: fetch,
            plcDirectoryUrl: plcDirectoryUrl
        }), didCache), new $fYfau.CachedHandleResolver($fYfau.AppViewHandleResolver.from(handleResolver, {
            fetch: fetch
        }), handleCache)), new $fFwT5.OAuthProtectedResourceMetadataResolver(protectedResourceMetadataCache, fetch), new $6oTi5.OAuthAuthorizationServerMetadataResolver(authorizationServerMetadataCache, fetch));
        this.serverFactory = new $4H3QM.OAuthServerFactory(this.clientMetadata, this.runtime, this.oauthResolver, this.fetch, this.keyset, dpopNonceCache);
        this.sessionGetter = new $5u6ZB.SessionGetter(sessionStore, this.serverFactory, this.runtime);
        this.stateStore = stateStore;
        // Proxy sessionGetter events
        for (const type of [
            'deleted',
            'updated'
        ])this.sessionGetter.addEventListener(type, (event)=>{
            if (!this.dispatchCustomEvent(type, event.detail)) event.preventDefault();
        });
    }
    // Exposed as public API for convenience
    get identityResolver() {
        return this.oauthResolver.identityResolver;
    }
    // Exposed as public API for convenience
    get didResolver() {
        return this.identityResolver.didResolver;
    }
    // Exposed as public API for convenience
    get handleResolver() {
        return this.identityResolver.handleResolver;
    }
    get jwks() {
        return this.keyset?.publicJwks ?? {
            keys: []
        };
    }
    async authorize(input, options) {
        const redirectUri = options?.redirect_uri ?? this.clientMetadata.redirect_uris[0];
        if (!this.clientMetadata.redirect_uris.includes(redirectUri)) // The server will enforce this, but let's catch it early
        throw new TypeError('Invalid redirect_uri');
        const { identity: identity, metadata: metadata } = await this.oauthResolver.resolve(input, options);
        const pkce = await this.runtime.generatePKCE();
        const dpopKey = await this.runtime.generateKey(metadata.dpop_signing_alg_values_supported || [
            $59fWx.FALLBACK_ALG
        ]);
        const state = await this.runtime.generateNonce();
        await this.stateStore.set(state, {
            iss: metadata.issuer,
            dpopKey: dpopKey,
            verifier: pkce.verifier,
            appState: options?.state
        });
        const parameters = {
            client_id: this.clientMetadata.client_id,
            redirect_uri: redirectUri,
            code_challenge: pkce.challenge,
            code_challenge_method: pkce.method,
            state: state,
            login_hint: identity ? input // If input is a handle or a DID, use it as a login_hint
             : undefined,
            response_mode: this.responseMode,
            response_type: 'code',
            display: options?.display,
            prompt: options?.prompt,
            scope: options?.scope ?? this.clientMetadata.scope,
            ui_locales: options?.ui_locales
        };
        if (metadata.pushed_authorization_request_endpoint) {
            const server = await this.serverFactory.fromMetadata(metadata, dpopKey);
            const parResponse = await server.request('pushed_authorization_request', parameters);
            const authorizationUrl = new URL(metadata.authorization_endpoint);
            authorizationUrl.searchParams.set('client_id', this.clientMetadata.client_id);
            authorizationUrl.searchParams.set('request_uri', parResponse.request_uri);
            return authorizationUrl;
        } else if (metadata.require_pushed_authorization_requests) throw new Error('Server requires pushed authorization requests (PAR) but no PAR endpoint is available');
        else {
            const authorizationUrl = new URL(metadata.authorization_endpoint);
            for (const [key, value] of Object.entries(parameters))if (value) authorizationUrl.searchParams.set(key, String(value));
            // Length of the URL that will be sent to the server
            const urlLength = authorizationUrl.pathname.length + authorizationUrl.search.length;
            if (urlLength < 2048) return authorizationUrl;
            else if (!metadata.pushed_authorization_request_endpoint) throw new Error('Login URL too long');
        }
        throw new Error('Server does not support pushed authorization requests (PAR)');
    }
    /**
     * This method allows the client to proactively revoke the request_uri it
     * created through PAR.
     */ async abortRequest(authorizeUrl) {
        const requestUri = authorizeUrl.searchParams.get('request_uri');
        if (!requestUri) return;
    // @NOTE This is not implemented here because, 1) the request server should
    // invalidate the request_uri after some delay anyways, and 2) I am not sure
    // that the revocation endpoint is even supposed to support this (and I
    // don't want to spend the time checking now).
    // @TODO investigate actual necessity & feasibility of this feature
    }
    async callback(params) {
        const responseJwt = params.get('response');
        if (responseJwt != null) // https://openid.net/specs/oauth-v2-jarm.html
        throw new $lfpNx.OAuthCallbackError(params, 'JARM not supported');
        const issuerParam = params.get('iss');
        const stateParam = params.get('state');
        const errorParam = params.get('error');
        const codeParam = params.get('code');
        if (!stateParam) throw new $lfpNx.OAuthCallbackError(params, 'Missing "state" parameter');
        const stateData = await this.stateStore.get(stateParam);
        if (stateData) // Prevent any kind of replay
        await this.stateStore.del(stateParam);
        else throw new $lfpNx.OAuthCallbackError(params, `Unknown authorization session "${stateParam}"`);
        try {
            if (errorParam != null) throw new $lfpNx.OAuthCallbackError(params, undefined, stateData.appState);
            if (!codeParam) throw new $lfpNx.OAuthCallbackError(params, 'Missing "code" query param', stateData.appState);
            const server = await this.serverFactory.fromIssuer(stateData.iss, stateData.dpopKey);
            if (issuerParam != null) {
                if (!server.serverMetadata.issuer) throw new $lfpNx.OAuthCallbackError(params, 'Issuer not found in metadata', stateData.appState);
                if (server.serverMetadata.issuer !== issuerParam) throw new $lfpNx.OAuthCallbackError(params, 'Issuer mismatch', stateData.appState);
            } else if (server.serverMetadata.authorization_response_iss_parameter_supported) throw new $lfpNx.OAuthCallbackError(params, 'iss missing from the response', stateData.appState);
            const tokenSet = await server.exchangeCode(codeParam, stateData.verifier);
            try {
                await this.sessionGetter.setStored(tokenSet.sub, {
                    dpopKey: stateData.dpopKey,
                    tokenSet: tokenSet
                });
                const session = this.createSession(server, tokenSet.sub);
                return {
                    session: session,
                    state: stateData.appState ?? null
                };
            } catch (err) {
                await server.revoke(tokenSet.access_token);
                throw err;
            }
        } catch (err) {
            // Make sure, whatever the underlying error, that the appState is
            // available in the calling code
            throw $lfpNx.OAuthCallbackError.from(err, params, stateData.appState);
        }
    }
    /**
     * Load a stored session. This will refresh the token only if needed (about to
     * expire) by default.
     *
     * @param refresh See {@link SessionGetter.getSession}
     */ async restore(sub, refresh) {
        const { dpopKey: dpopKey, tokenSet: tokenSet } = await this.sessionGetter.getSession(sub, refresh);
        const server = await this.serverFactory.fromIssuer(tokenSet.iss, dpopKey, {
            noCache: refresh === true,
            allowStale: refresh === false
        });
        return this.createSession(server, sub);
    }
    async revoke(sub) {
        const { dpopKey: dpopKey, tokenSet: tokenSet } = await this.sessionGetter.getSession(sub, false);
        // NOT using `;(await this.restore(sub, false)).signOut()` because we want
        // the tokens to be deleted even if it was not possible to fetch the issuer
        // data.
        try {
            const server = await this.serverFactory.fromIssuer(tokenSet.iss, dpopKey);
            await server.revoke(tokenSet.access_token);
        } finally{
            await this.sessionGetter.delStored(sub, new $5QfU8.TokenRevokedError(sub));
        }
    }
    createSession(server, sub) {
        return new $6aqH9.OAuthSession(server, sub, this.sessionGetter, this.fetch);
    }
}
module.exports.OAuthClient = $c07f1bc9b04139ab$var$OAuthClient;

});
parcelRegister("bGbIW", function(module, exports) {
"use strict";
var $880cb614e83fc2ef$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $880cb614e83fc2ef$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $880cb614e83fc2ef$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$880cb614e83fc2ef$var$__exportStar((parcelRequire("kSYEu")), module.exports);

});
parcelRegister("kSYEu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IdentityResolver = void 0;

var $fYfau = parcelRequire("fYfau");

var $h5r8w = parcelRequire("h5r8w");
class $f347e6040623c103$var$IdentityResolver {
    constructor(didResolver, handleResolver){
        Object.defineProperty(this, "didResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: didResolver
        });
        Object.defineProperty(this, "handleResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: handleResolver
        });
    }
    async resolve(input, options) {
        const document = (0, $fYfau.isResolvedHandle)(input) ? await this.getDocumentFromDid(input, options) : await this.getDocumentFromHandle(input, options);
        const service = document.service?.find($f347e6040623c103$var$isAtprotoPersonalDataServerService, document);
        if (!service) throw new TypeError(`No valid "AtprotoPersonalDataServer" service found in "${document.id}" DID document`);
        return {
            did: document.id,
            pds: new URL(service.serviceEndpoint)
        };
    }
    async getDocumentFromDid(did, options) {
        return this.didResolver.resolve(did, options);
    }
    async getDocumentFromHandle(input, options) {
        const handle = (0, $h5r8w.normalizeAndEnsureValidHandle)(input);
        const did = await this.handleResolver.resolve(handle, options);
        if (!did) throw new TypeError(`Handle "${handle}" does not resolve to a DID`);
        options?.signal?.throwIfAborted();
        // Note: Not using "return this.resolveDid(did, options)" to make the extra
        // check for the handle in the DID document:
        const document = await this.didResolver.resolve(did, options);
        // Ensure that the handle is included in the document
        if (!document.alsoKnownAs?.includes(`at://${handle}`)) throw new TypeError(`Did document for "${did}" does not include the handle "${handle}"`);
        return document;
    }
}
module.exports.IdentityResolver = $f347e6040623c103$var$IdentityResolver;
function $f347e6040623c103$var$isAtprotoPersonalDataServerService(s) {
    return typeof s.serviceEndpoint === 'string' && s.type === 'AtprotoPersonalDataServer' && (s.id.startsWith('#') ? s.id === '#atproto_pds' : s.id === `${this.id}#atproto_pds`);
}

});
parcelRegister("h5r8w", function(module, exports) {
"use strict";
var $c707f40717943086$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c707f40717943086$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c707f40717943086$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c707f40717943086$var$__exportStar((parcelRequire("4tBIV")), module.exports);

$c707f40717943086$var$__exportStar((parcelRequire("4DsPP")), module.exports);

$c707f40717943086$var$__exportStar((parcelRequire("fnyxZ")), module.exports);

$c707f40717943086$var$__exportStar((parcelRequire("kLKEm")), module.exports);

$c707f40717943086$var$__exportStar((parcelRequire("iBz1I")), module.exports);

$c707f40717943086$var$__exportStar((parcelRequire("3Io1N")), module.exports);

$c707f40717943086$var$__exportStar((parcelRequire("eSljK")), module.exports);

});
parcelRegister("4tBIV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DisallowedDomainError = module.exports.UnsupportedDomainError = module.exports.ReservedHandleError = module.exports.InvalidHandleError = module.exports.isValidTld = module.exports.isValidHandle = module.exports.normalizeAndEnsureValidHandle = module.exports.normalizeHandle = module.exports.ensureValidHandleRegex = module.exports.ensureValidHandle = module.exports.DISALLOWED_TLDS = module.exports.INVALID_HANDLE = void 0;
module.exports.INVALID_HANDLE = 'handle.invalid';
// Currently these are registration-time restrictions, not protocol-level
// restrictions. We have a couple accounts in the wild that we need to clean up
// before hard-disallow.
// See also: https://en.wikipedia.org/wiki/Top-level_domain#Reserved_domains
module.exports.DISALLOWED_TLDS = [
    '.local',
    '.arpa',
    '.invalid',
    '.localhost',
    '.internal',
    '.example',
    '.alt',
    // policy could concievably change on ".onion" some day
    '.onion'
];
// Handle constraints, in English:
//  - must be a possible domain name
//    - RFC-1035 is commonly referenced, but has been updated. eg, RFC-3696,
//      section 2. and RFC-3986, section 3. can now have leading numbers (eg,
//      4chan.org)
//    - "labels" (sub-names) are made of ASCII letters, digits, hyphens
//    - can not start or end with a hyphen
//    - TLD (last component) should not start with a digit
//    - can't end with a hyphen (can end with digit)
//    - each segment must be between 1 and 63 characters (not including any periods)
//    - overall length can't be more than 253 characters
//    - separated by (ASCII) periods; does not start or end with period
//    - case insensitive
//    - domains (handles) are equal if they are the same lower-case
//    - punycode allowed for internationalization
//  - no whitespace, null bytes, joining chars, etc
//  - does not validate whether domain or TLD exists, or is a reserved or
//    special TLD (eg, .onion or .local)
//  - does not validate punycode
const $342721fdb4f12da2$var$ensureValidHandle = (handle)=>{
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9.-]*$/.test(handle)) throw new $342721fdb4f12da2$var$InvalidHandleError('Disallowed characters in handle (ASCII letters, digits, dashes, periods only)');
    if (handle.length > 253) throw new $342721fdb4f12da2$var$InvalidHandleError('Handle is too long (253 chars max)');
    const labels = handle.split('.');
    if (labels.length < 2) throw new $342721fdb4f12da2$var$InvalidHandleError('Handle domain needs at least two parts');
    for(let i = 0; i < labels.length; i++){
        const l = labels[i];
        if (l.length < 1) throw new $342721fdb4f12da2$var$InvalidHandleError('Handle parts can not be empty');
        if (l.length > 63) throw new $342721fdb4f12da2$var$InvalidHandleError('Handle part too long (max 63 chars)');
        if (l.endsWith('-') || l.startsWith('-')) throw new $342721fdb4f12da2$var$InvalidHandleError('Handle parts can not start or end with hyphens');
        if (i + 1 == labels.length && !/^[a-zA-Z]/.test(l)) throw new $342721fdb4f12da2$var$InvalidHandleError('Handle final component (TLD) must start with ASCII letter');
    }
};
module.exports.ensureValidHandle = $342721fdb4f12da2$var$ensureValidHandle;
// simple regex translation of above constraints
const $342721fdb4f12da2$var$ensureValidHandleRegex = (handle)=>{
    if (!/^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/.test(handle)) throw new $342721fdb4f12da2$var$InvalidHandleError("Handle didn't validate via regex");
    if (handle.length > 253) throw new $342721fdb4f12da2$var$InvalidHandleError('Handle is too long (253 chars max)');
};
module.exports.ensureValidHandleRegex = $342721fdb4f12da2$var$ensureValidHandleRegex;
const $342721fdb4f12da2$var$normalizeHandle = (handle)=>{
    return handle.toLowerCase();
};
module.exports.normalizeHandle = $342721fdb4f12da2$var$normalizeHandle;
const $342721fdb4f12da2$var$normalizeAndEnsureValidHandle = (handle)=>{
    const normalized = (0, module.exports.normalizeHandle)(handle);
    (0, module.exports.ensureValidHandle)(normalized);
    return normalized;
};
module.exports.normalizeAndEnsureValidHandle = $342721fdb4f12da2$var$normalizeAndEnsureValidHandle;
const $342721fdb4f12da2$var$isValidHandle = (handle)=>{
    try {
        (0, module.exports.ensureValidHandle)(handle);
    } catch (err) {
        if (err instanceof $342721fdb4f12da2$var$InvalidHandleError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidHandle = $342721fdb4f12da2$var$isValidHandle;
const $342721fdb4f12da2$var$isValidTld = (handle)=>{
    return !module.exports.DISALLOWED_TLDS.some((domain)=>handle.endsWith(domain));
};
module.exports.isValidTld = $342721fdb4f12da2$var$isValidTld;
class $342721fdb4f12da2$var$InvalidHandleError extends Error {
}
module.exports.InvalidHandleError = $342721fdb4f12da2$var$InvalidHandleError;
class $342721fdb4f12da2$var$ReservedHandleError extends Error {
}
module.exports.ReservedHandleError = $342721fdb4f12da2$var$ReservedHandleError;
class $342721fdb4f12da2$var$UnsupportedDomainError extends Error {
}
module.exports.UnsupportedDomainError = $342721fdb4f12da2$var$UnsupportedDomainError;
class $342721fdb4f12da2$var$DisallowedDomainError extends Error {
}
module.exports.DisallowedDomainError = $342721fdb4f12da2$var$DisallowedDomainError;

});

parcelRegister("4DsPP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidDidError = module.exports.ensureValidDidRegex = module.exports.ensureValidDid = void 0;
// Human-readable constraints:
//   - valid W3C DID (https://www.w3.org/TR/did-core/#did-syntax)
//      - entire URI is ASCII: [a-zA-Z0-9._:%-]
//      - always starts "did:" (lower-case)
//      - method name is one or more lower-case letters, followed by ":"
//      - remaining identifier can have any of the above chars, but can not end in ":"
//      - it seems that a bunch of ":" can be included, and don't need spaces between
//      - "%" is used only for "percent encoding" and must be followed by two hex characters (and thus can't end in "%")
//      - query ("?") and fragment ("#") stuff is defined for "DID URIs", but not as part of identifier itself
//      - "The current specification does not take a position on the maximum length of a DID"
//   - in current atproto, only allowing did:plc and did:web. But not *forcing* this at lexicon layer
//   - hard length limit of 8KBytes
//   - not going to validate "percent encoding" here
const $36012bf3e7a2a5e6$var$ensureValidDid = (did)=>{
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9._:%-]*$/.test(did)) throw new $36012bf3e7a2a5e6$var$InvalidDidError('Disallowed characters in DID (ASCII letters, digits, and a couple other characters only)');
    const parts = did.split(':');
    if (parts.length < 3) throw new $36012bf3e7a2a5e6$var$InvalidDidError('DID requires prefix, method, and method-specific content');
    if (parts[0] != 'did') throw new $36012bf3e7a2a5e6$var$InvalidDidError('DID requires "did:" prefix');
    if (!/^[a-z]+$/.test(parts[1])) throw new $36012bf3e7a2a5e6$var$InvalidDidError('DID method must be lower-case letters');
    if (did.endsWith(':') || did.endsWith('%')) throw new $36012bf3e7a2a5e6$var$InvalidDidError('DID can not end with ":" or "%"');
    if (did.length > 2048) throw new $36012bf3e7a2a5e6$var$InvalidDidError('DID is too long (2048 chars max)');
};
module.exports.ensureValidDid = $36012bf3e7a2a5e6$var$ensureValidDid;
const $36012bf3e7a2a5e6$var$ensureValidDidRegex = (did)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints
    if (!/^did:[a-z]+:[a-zA-Z0-9._:%-]*[a-zA-Z0-9._-]$/.test(did)) throw new $36012bf3e7a2a5e6$var$InvalidDidError("DID didn't validate via regex");
    if (did.length > 2048) throw new $36012bf3e7a2a5e6$var$InvalidDidError('DID is too long (2048 chars max)');
};
module.exports.ensureValidDidRegex = $36012bf3e7a2a5e6$var$ensureValidDidRegex;
class $36012bf3e7a2a5e6$var$InvalidDidError extends Error {
}
module.exports.InvalidDidError = $36012bf3e7a2a5e6$var$InvalidDidError;

});

parcelRegister("fnyxZ", function(module, exports) {
"use strict";
/*
Grammar:

alpha     = "a" / "b" / "c" / "d" / "e" / "f" / "g" / "h" / "i" / "j" / "k" / "l" / "m" / "n" / "o" / "p" / "q" / "r" / "s" / "t" / "u" / "v" / "w" / "x" / "y" / "z" / "A" / "B" / "C" / "D" / "E" / "F" / "G" / "H" / "I" / "J" / "K" / "L" / "M" / "N" / "O" / "P" / "Q" / "R" / "S" / "T" / "U" / "V" / "W" / "X" / "Y" / "Z"
number    = "1" / "2" / "3" / "4" / "5" / "6" / "7" / "8" / "9" / "0"
delim     = "."
segment   = alpha *( alpha / number / "-" )
authority = segment *( delim segment )
name      = alpha *( alpha )
nsid      = authority delim name

*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidNsidError = module.exports.ensureValidNsidRegex = module.exports.ensureValidNsid = module.exports.NSID = void 0;
class $b323cd5724ddfca0$var$NSID {
    static parse(nsid) {
        return new $b323cd5724ddfca0$var$NSID(nsid);
    }
    static create(authority, name) {
        const segments = [
            ...authority.split('.').reverse(),
            name
        ].join('.');
        return new $b323cd5724ddfca0$var$NSID(segments);
    }
    static isValid(nsid) {
        try {
            $b323cd5724ddfca0$var$NSID.parse(nsid);
            return true;
        } catch (e) {
            return false;
        }
    }
    constructor(nsid){
        Object.defineProperty(this, "segments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        (0, module.exports.ensureValidNsid)(nsid);
        this.segments = nsid.split('.');
    }
    get authority() {
        return this.segments.slice(0, this.segments.length - 1).reverse().join('.');
    }
    get name() {
        return this.segments.at(this.segments.length - 1);
    }
    toString() {
        return this.segments.join('.');
    }
}
module.exports.NSID = $b323cd5724ddfca0$var$NSID;
// Human readable constraints on NSID:
// - a valid domain in reversed notation
// - followed by an additional period-separated name, which is camel-case letters
const $b323cd5724ddfca0$var$ensureValidNsid = (nsid)=>{
    const toCheck = nsid;
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9.-]*$/.test(toCheck)) throw new $b323cd5724ddfca0$var$InvalidNsidError('Disallowed characters in NSID (ASCII letters, digits, dashes, periods only)');
    if (toCheck.length > 317) throw new $b323cd5724ddfca0$var$InvalidNsidError('NSID is too long (317 chars max)');
    const labels = toCheck.split('.');
    if (labels.length < 3) throw new $b323cd5724ddfca0$var$InvalidNsidError('NSID needs at least three parts');
    for(let i = 0; i < labels.length; i++){
        const l = labels[i];
        if (l.length < 1) throw new $b323cd5724ddfca0$var$InvalidNsidError('NSID parts can not be empty');
        if (l.length > 63) throw new $b323cd5724ddfca0$var$InvalidNsidError('NSID part too long (max 63 chars)');
        if (l.endsWith('-') || l.startsWith('-')) throw new $b323cd5724ddfca0$var$InvalidNsidError('NSID parts can not start or end with hyphen');
        if (/^[0-9]/.test(l) && i == 0) throw new $b323cd5724ddfca0$var$InvalidNsidError('NSID first part may not start with a digit');
        if (!/^[a-zA-Z]+$/.test(l) && i + 1 == labels.length) throw new $b323cd5724ddfca0$var$InvalidNsidError('NSID name part must be only letters');
    }
};
module.exports.ensureValidNsid = $b323cd5724ddfca0$var$ensureValidNsid;
const $b323cd5724ddfca0$var$ensureValidNsidRegex = (nsid)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints
    if (!/^[a-zA-Z]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(\.[a-zA-Z]([a-zA-Z]{0,61}[a-zA-Z])?)$/.test(nsid)) throw new $b323cd5724ddfca0$var$InvalidNsidError("NSID didn't validate via regex");
    if (nsid.length > 317) throw new $b323cd5724ddfca0$var$InvalidNsidError('NSID is too long (317 chars max)');
};
module.exports.ensureValidNsidRegex = $b323cd5724ddfca0$var$ensureValidNsidRegex;
class $b323cd5724ddfca0$var$InvalidNsidError extends Error {
}
module.exports.InvalidNsidError = $b323cd5724ddfca0$var$InvalidNsidError;

});

parcelRegister("kLKEm", function(module, exports) {
"use strict";
var $f1ec6223a4828cb0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f1ec6223a4828cb0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f1ec6223a4828cb0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtUri = module.exports.ATP_URI_REGEX = void 0;

$f1ec6223a4828cb0$var$__exportStar((parcelRequire("9AoyM")), module.exports);
module.exports.ATP_URI_REGEX = // proto-    --did--------------   --name----------------   --path----   --query--   --hash--
/^(at:\/\/)?((?:did:[a-z0-9:%-]+)|(?:[a-z0-9][a-z0-9.:-]*))(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
//                       --path-----   --query--  --hash--
const $f1ec6223a4828cb0$var$RELATIVE_REGEX = /^(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
class $f1ec6223a4828cb0$var$AtUri {
    constructor(uri, base){
        Object.defineProperty(this, "hash", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "host", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pathname", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "searchParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        let parsed;
        if (base) {
            parsed = $f1ec6223a4828cb0$var$parse(base);
            if (!parsed) throw new Error(`Invalid at uri: ${base}`);
            const relativep = $f1ec6223a4828cb0$var$parseRelative(uri);
            if (!relativep) throw new Error(`Invalid path: ${uri}`);
            Object.assign(parsed, relativep);
        } else {
            parsed = $f1ec6223a4828cb0$var$parse(uri);
            if (!parsed) throw new Error(`Invalid at uri: ${uri}`);
        }
        this.hash = parsed.hash;
        this.host = parsed.host;
        this.pathname = parsed.pathname;
        this.searchParams = parsed.searchParams;
    }
    static make(handleOrDid, collection, rkey) {
        let str = handleOrDid;
        if (collection) str += '/' + collection;
        if (rkey) str += '/' + rkey;
        return new $f1ec6223a4828cb0$var$AtUri(str);
    }
    get protocol() {
        return 'at:';
    }
    get origin() {
        return `at://${this.host}`;
    }
    get hostname() {
        return this.host;
    }
    set hostname(v) {
        this.host = v;
    }
    get search() {
        return this.searchParams.toString();
    }
    set search(v) {
        this.searchParams = new URLSearchParams(v);
    }
    get collection() {
        return this.pathname.split('/').filter(Boolean)[0] || '';
    }
    set collection(v) {
        const parts = this.pathname.split('/').filter(Boolean);
        parts[0] = v;
        this.pathname = parts.join('/');
    }
    get rkey() {
        return this.pathname.split('/').filter(Boolean)[1] || '';
    }
    set rkey(v) {
        const parts = this.pathname.split('/').filter(Boolean);
        if (!parts[0]) parts[0] = 'undefined';
        parts[1] = v;
        this.pathname = parts.join('/');
    }
    get href() {
        return this.toString();
    }
    toString() {
        let path = this.pathname || '/';
        if (!path.startsWith('/')) path = `/${path}`;
        let qs = this.searchParams.toString();
        if (qs && !qs.startsWith('?')) qs = `?${qs}`;
        let hash = this.hash;
        if (hash && !hash.startsWith('#')) hash = `#${hash}`;
        return `at://${this.host}${path}${qs}${hash}`;
    }
}
module.exports.AtUri = $f1ec6223a4828cb0$var$AtUri;
function $f1ec6223a4828cb0$var$parse(str) {
    const match = module.exports.ATP_URI_REGEX.exec(str);
    if (match) return {
        hash: match[5] || '',
        host: match[2] || '',
        pathname: match[3] || '',
        searchParams: new URLSearchParams(match[4] || '')
    };
    return undefined;
}
function $f1ec6223a4828cb0$var$parseRelative(str) {
    const match = $f1ec6223a4828cb0$var$RELATIVE_REGEX.exec(str);
    if (match) return {
        hash: match[3] || '',
        pathname: match[1] || '',
        searchParams: new URLSearchParams(match[2] || '')
    };
    return undefined;
}

});
parcelRegister("9AoyM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ensureValidAtUriRegex = module.exports.ensureValidAtUri = void 0;

var $4tBIV = parcelRequire("4tBIV");

var $4DsPP = parcelRequire("4DsPP");

var $fnyxZ = parcelRequire("fnyxZ");
// Human-readable constraints on ATURI:
//   - following regular URLs, a 8KByte hard total length limit
//   - follows ATURI docs on website
//      - all ASCII characters, no whitespace. non-ASCII could be URL-encoded
//      - starts "at://"
//      - "authority" is a valid DID or a valid handle
//      - optionally, follow "authority" with "/" and valid NSID as start of path
//      - optionally, if NSID given, follow that with "/" and rkey
//      - rkey path component can include URL-encoded ("percent encoded"), or:
//          ALPHA / DIGIT / "-" / "." / "_" / "~" / ":" / "@" / "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
//          [a-zA-Z0-9._~:@!$&'\(\)*+,;=-]
//      - rkey must have at least one char
//      - regardless of path component, a fragment can follow  as "#" and then a JSON pointer (RFC-6901)
const $6faa86f6e2022f08$var$ensureValidAtUri = (uri)=>{
    // JSON pointer is pretty different from rest of URI, so split that out first
    const uriParts = uri.split('#');
    if (uriParts.length > 2) throw new Error('ATURI can have at most one "#", separating fragment out');
    const fragmentPart = uriParts[1] || null;
    uri = uriParts[0];
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9._~:@!$&')(*+,;=%/-]*$/.test(uri)) throw new Error('Disallowed characters in ATURI (ASCII)');
    const parts = uri.split('/');
    if (parts.length >= 3 && (parts[0] != 'at:' || parts[1].length != 0)) throw new Error('ATURI must start with "at://"');
    if (parts.length < 3) throw new Error('ATURI requires at least method and authority sections');
    try {
        if (parts[2].startsWith('did:')) (0, $4DsPP.ensureValidDid)(parts[2]);
        else (0, $4tBIV.ensureValidHandle)(parts[2]);
    } catch  {
        throw new Error('ATURI authority must be a valid handle or DID');
    }
    if (parts.length >= 4) {
        if (parts[3].length == 0) throw new Error('ATURI can not have a slash after authority without a path segment');
        try {
            (0, $fnyxZ.ensureValidNsid)(parts[3]);
        } catch  {
            throw new Error('ATURI requires first path segment (if supplied) to be valid NSID');
        }
    }
    if (parts.length >= 5) {
        if (parts[4].length == 0) throw new Error('ATURI can not have a slash after collection, unless record key is provided');
    // would validate rkey here, but there are basically no constraints!
    }
    if (parts.length >= 6) throw new Error('ATURI path can have at most two parts, and no trailing slash');
    if (uriParts.length >= 2 && fragmentPart == null) throw new Error('ATURI fragment must be non-empty and start with slash');
    if (fragmentPart != null) {
        if (fragmentPart.length == 0 || fragmentPart[0] != '/') throw new Error('ATURI fragment must be non-empty and start with slash');
        // NOTE: enforcing *some* checks here for sanity. Eg, at least no whitespace
        if (!/^\/[a-zA-Z0-9._~:@!$&')(*+,;=%[\]/-]*$/.test(fragmentPart)) throw new Error('Disallowed characters in ATURI fragment (ASCII)');
    }
    if (uri.length > 8192) throw new Error('ATURI is far too long');
};
module.exports.ensureValidAtUri = $6faa86f6e2022f08$var$ensureValidAtUri;
const $6faa86f6e2022f08$var$ensureValidAtUriRegex = (uri)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints. whew!
    const aturiRegex = /^at:\/\/(?<authority>[a-zA-Z0-9._:%-]+)(\/(?<collection>[a-zA-Z0-9-.]+)(\/(?<rkey>[a-zA-Z0-9._~:@!$&%')(*+,;=-]+))?)?(#(?<fragment>\/[a-zA-Z0-9._~:@!$&%')(*+,;=\-[\]/\\]*))?$/;
    const rm = uri.match(aturiRegex);
    if (!rm || !rm.groups) throw new Error("ATURI didn't validate via regex");
    const groups = rm.groups;
    try {
        (0, $4tBIV.ensureValidHandleRegex)(groups.authority);
    } catch  {
        try {
            (0, $4DsPP.ensureValidDidRegex)(groups.authority);
        } catch  {
            throw new Error('ATURI authority must be a valid handle or DID');
        }
    }
    if (groups.collection) try {
        (0, $fnyxZ.ensureValidNsidRegex)(groups.collection);
    } catch  {
        throw new Error('ATURI collection path segment must be a valid NSID');
    }
    if (uri.length > 8192) throw new Error('ATURI is far too long');
};
module.exports.ensureValidAtUriRegex = $6faa86f6e2022f08$var$ensureValidAtUriRegex;

});


parcelRegister("iBz1I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidTidError = module.exports.isValidTid = module.exports.ensureValidTid = void 0;
const $d8b6da47d8e52c70$var$ensureValidTid = (tid)=>{
    if (tid.length != 13) throw new $d8b6da47d8e52c70$var$InvalidTidError('TID must be 13 characters');
    // simple regex to enforce most constraints via just regex and length.
    if (!/^[234567abcdefghij][234567abcdefghijklmnopqrstuvwxyz]{12}$/.test(tid)) throw new $d8b6da47d8e52c70$var$InvalidTidError('TID syntax not valid (regex)');
};
module.exports.ensureValidTid = $d8b6da47d8e52c70$var$ensureValidTid;
const $d8b6da47d8e52c70$var$isValidTid = (tid)=>{
    try {
        (0, module.exports.ensureValidTid)(tid);
    } catch (err) {
        if (err instanceof $d8b6da47d8e52c70$var$InvalidTidError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidTid = $d8b6da47d8e52c70$var$isValidTid;
class $d8b6da47d8e52c70$var$InvalidTidError extends Error {
}
module.exports.InvalidTidError = $d8b6da47d8e52c70$var$InvalidTidError;

});

parcelRegister("3Io1N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidRecordKeyError = module.exports.isValidRecordKey = module.exports.ensureValidRecordKey = void 0;
const $2b481ea17ad510fc$var$ensureValidRecordKey = (rkey)=>{
    if (rkey.length > 512 || rkey.length < 1) throw new $2b481ea17ad510fc$var$InvalidRecordKeyError('record key must be 1 to 512 characters');
    // simple regex to enforce most constraints via just regex and length.
    if (!/^[a-zA-Z0-9_~.:-]{1,512}$/.test(rkey)) throw new $2b481ea17ad510fc$var$InvalidRecordKeyError('record key syntax not valid (regex)');
    if (rkey == '.' || rkey == '..') throw new $2b481ea17ad510fc$var$InvalidRecordKeyError('record key can not be "." or ".."');
};
module.exports.ensureValidRecordKey = $2b481ea17ad510fc$var$ensureValidRecordKey;
const $2b481ea17ad510fc$var$isValidRecordKey = (rkey)=>{
    try {
        (0, module.exports.ensureValidRecordKey)(rkey);
    } catch (err) {
        if (err instanceof $2b481ea17ad510fc$var$InvalidRecordKeyError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidRecordKey = $2b481ea17ad510fc$var$isValidRecordKey;
class $2b481ea17ad510fc$var$InvalidRecordKeyError extends Error {
}
module.exports.InvalidRecordKeyError = $2b481ea17ad510fc$var$InvalidRecordKeyError;

});

parcelRegister("eSljK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidDatetimeError = module.exports.normalizeDatetimeAlways = module.exports.normalizeDatetime = module.exports.isValidDatetime = module.exports.ensureValidDatetime = void 0;
/* Validates datetime string against atproto Lexicon 'datetime' format.
 * Syntax is described at: https://atproto.com/specs/lexicon#datetime
 */ const $ad46a50b184c9dea$var$ensureValidDatetime = (dtStr)=>{
    const date = new Date(dtStr);
    // must parse as ISO 8601; this also verifies semantics like month is not 13 or 00
    if (isNaN(date.getTime())) throw new $ad46a50b184c9dea$var$InvalidDatetimeError('datetime did not parse as ISO 8601');
    if (date.toISOString().startsWith('-')) throw new $ad46a50b184c9dea$var$InvalidDatetimeError('datetime normalized to a negative time');
    // regex and other checks for RFC-3339
    if (!/^[0-9]{4}-[01][0-9]-[0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9](.[0-9]{1,20})?(Z|([+-][0-2][0-9]:[0-5][0-9]))$/.test(dtStr)) throw new $ad46a50b184c9dea$var$InvalidDatetimeError("datetime didn't validate via regex");
    if (dtStr.length > 64) throw new $ad46a50b184c9dea$var$InvalidDatetimeError('datetime is too long (64 chars max)');
    if (dtStr.endsWith('-00:00')) throw new $ad46a50b184c9dea$var$InvalidDatetimeError('datetime can not use "-00:00" for UTC timezone');
    if (dtStr.startsWith('000')) throw new $ad46a50b184c9dea$var$InvalidDatetimeError('datetime so close to year zero not allowed');
};
module.exports.ensureValidDatetime = $ad46a50b184c9dea$var$ensureValidDatetime;
/* Same logic as ensureValidDatetime(), but returns a boolean instead of throwing an exception.
 */ const $ad46a50b184c9dea$var$isValidDatetime = (dtStr)=>{
    try {
        (0, module.exports.ensureValidDatetime)(dtStr);
    } catch (err) {
        if (err instanceof $ad46a50b184c9dea$var$InvalidDatetimeError) return false;
        throw err;
    }
    return true;
};
module.exports.isValidDatetime = $ad46a50b184c9dea$var$isValidDatetime;
/* Takes a flexible datetime string and normalizes representation.
 *
 * This function will work with any valid atproto datetime (eg, anything which isValidDatetime() is true for). It *additionally* is more flexible about accepting datetimes that don't comply to RFC 3339, or are missing timezone information, and normalizing them to a valid datetime.
 *
 * One use-case is a consistent, sortable string. Another is to work with older invalid createdAt datetimes.
 *
 * Successful output will be a valid atproto datetime with millisecond precision (3 sub-second digits) and UTC timezone with trailing 'Z' syntax. Throws `InvalidDatetimeError` if the input string could not be parsed as a datetime, even with permissive parsing.
 *
 * Expected output format: YYYY-MM-DDTHH:mm:ss.sssZ
 */ const $ad46a50b184c9dea$var$normalizeDatetime = (dtStr)=>{
    if ((0, module.exports.isValidDatetime)(dtStr)) {
        const outStr = new Date(dtStr).toISOString();
        if ((0, module.exports.isValidDatetime)(outStr)) return outStr;
    }
    // check if this permissive datetime is missing a timezone
    if (!/.*(([+-]\d\d:?\d\d)|[a-zA-Z])$/.test(dtStr)) {
        const date = new Date(dtStr + 'Z');
        if (!isNaN(date.getTime())) {
            const tzStr = date.toISOString();
            if ((0, module.exports.isValidDatetime)(tzStr)) return tzStr;
        }
    }
    // finally try parsing as simple datetime
    const date = new Date(dtStr);
    if (isNaN(date.getTime())) throw new $ad46a50b184c9dea$var$InvalidDatetimeError('datetime did not parse as any timestamp format');
    const isoStr = date.toISOString();
    if ((0, module.exports.isValidDatetime)(isoStr)) return isoStr;
    else throw new $ad46a50b184c9dea$var$InvalidDatetimeError('datetime normalized to invalid timestamp string');
};
module.exports.normalizeDatetime = $ad46a50b184c9dea$var$normalizeDatetime;
/* Variant of normalizeDatetime() which always returns a valid datetime strings.
 *
 * If a InvalidDatetimeError is encountered, returns the UNIX epoch time as a UTC datetime (1970-01-01T00:00:00.000Z).
 */ const $ad46a50b184c9dea$var$normalizeDatetimeAlways = (dtStr)=>{
    try {
        return (0, module.exports.normalizeDatetime)(dtStr);
    } catch (err) {
        if (err instanceof $ad46a50b184c9dea$var$InvalidDatetimeError) return new Date(0).toISOString();
        throw err;
    }
};
module.exports.normalizeDatetimeAlways = $ad46a50b184c9dea$var$normalizeDatetimeAlways;
/* Indicates a datetime string did not pass full atproto Lexicon datetime string format checks.
 */ class $ad46a50b184c9dea$var$InvalidDatetimeError extends Error {
}
module.exports.InvalidDatetimeError = $ad46a50b184c9dea$var$InvalidDatetimeError;

});




parcelRegister("59fWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FALLBACK_ALG = void 0;
/**
 * Per ATProto spec (OpenID uses RS256)
 */ module.exports.FALLBACK_ALG = 'ES256';

});

parcelRegister("5QfU8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenRevokedError = void 0;
class $440e25566cb2860b$var$TokenRevokedError extends Error {
    constructor(sub, message = `The session for "${sub}" was successfully revoked`, options){
        super(message, options);
        Object.defineProperty(this, "sub", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sub
        });
    }
}
module.exports.TokenRevokedError = $440e25566cb2860b$var$TokenRevokedError;

});

parcelRegister("fFwT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthProtectedResourceMetadataResolver = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $559MJ = parcelRequire("559MJ");

var $auA9I = parcelRequire("auA9I");

var $96UnS = parcelRequire("96UnS");
/**
 * @see {@link https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05}
 */ class $b6843221b3288950$var$OAuthProtectedResourceMetadataResolver extends $559MJ.CachedGetter {
    constructor(cache, fetch = globalThis.fetch){
        super(async (origin, options)=>this.fetchMetadata(origin, options), cache);
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fetch = (0, $8oTqd.bindFetch)(fetch);
    }
    async get(resource, options) {
        const { protocol: protocol, origin: origin } = new URL(resource);
        if (protocol === 'https:' || protocol === 'http:' && $auA9I.ALLOW_UNSECURE_ORIGINS) return super.get(origin, options);
        throw new TypeError(`Forbidden resource sercure protocol "${protocol}"`);
    }
    async fetchMetadata(origin, options) {
        const headers = new Headers([
            [
                'accept',
                'application/json'
            ]
        ]);
        if (options?.noCache) headers.set('cache-control', 'no-cache');
        const url = new URL(`/.well-known/oauth-protected-resource`, origin);
        const request = new Request(url, {
            signal: options?.signal,
            headers: headers,
            redirect: 'manual'
        });
        const response = await this.fetch(request);
        // https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05#section-3.2
        if (response.status !== 200) {
            await (0, $8oTqd.cancelBody)(response, 'log');
            throw await $8oTqd.FetchResponseError.from(response, `Unexpected status code ${response.status} for "${url}"`, undefined, {
                cause: request
            });
        }
        if ((0, $96UnS.contentMime)(response.headers) !== 'application/json') {
            await (0, $8oTqd.cancelBody)(response, 'log');
            throw await $8oTqd.FetchResponseError.from(response, `Unexpected content type for "${url}"`, undefined, {
                cause: request
            });
        }
        const metadata = $auA9I.oauthProtectedResourceMetadataSchema.parse(await response.json());
        // https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05#section-3.3
        if (metadata.resource !== origin) throw new TypeError(`Invalid issuer ${metadata.resource}`);
        return metadata;
    }
}
module.exports.OAuthProtectedResourceMetadataResolver = $b6843221b3288950$var$OAuthProtectedResourceMetadataResolver;

});

parcelRegister("b1J1b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthResolver = void 0;

var $auA9I = parcelRequire("auA9I");

var $90baw = parcelRequire("90baw");
class $8072b561bd459c16$var$OAuthResolver {
    constructor(identityResolver, protectedResourceMetadataResolver, authorizationServerMetadataResolver){
        Object.defineProperty(this, "identityResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: identityResolver
        });
        Object.defineProperty(this, "protectedResourceMetadataResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: protectedResourceMetadataResolver
        });
        Object.defineProperty(this, "authorizationServerMetadataResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: authorizationServerMetadataResolver
        });
    }
    /**
     * @param input - A handle, DID, PDS URL or Entryway URL
     */ async resolve(input, options) {
        // Allow using an entryway, or PDS url, directly as login input (e.g.
        // when the user forgot their handle, or when the handle does not
        // resolve to a DID)
        return /^https?:\/\//.test(input) ? this.resolveFromService(input, options) : this.resolveFromIdentity(input, options);
    }
    /**
     * @note this method can be used to verify if a particular uri supports OAuth
     * based sign-in (for compatibility with legacy implementation).
     */ async resolveFromService(input, options) {
        try {
            // Assume first that input is a PDS URL (as required by ATPROTO)
            const metadata = await this.getResourceServerMetadata(input, options);
            return {
                metadata: metadata
            };
        } catch (err) {
            if (!options?.signal?.aborted && err instanceof $90baw.OAuthResolverError) try {
                // Fallback to trying to fetch as an issuer (Entryway)
                const result = $auA9I.oauthIssuerIdentifierSchema.safeParse(input);
                if (result.success) {
                    const metadata = await this.getAuthorizationServerMetadata(result.data, options);
                    return {
                        metadata: metadata
                    };
                }
            } catch  {
            // Fallback failed, throw original error
            }
            throw err;
        }
    }
    async resolveFromIdentity(input, options) {
        const identity = await this.resolveIdentity(input, options);
        options?.signal?.throwIfAborted();
        const metadata = await this.getResourceServerMetadata(identity.pds, options);
        return {
            identity: identity,
            metadata: metadata
        };
    }
    async resolveIdentity(input, options) {
        try {
            return await this.identityResolver.resolve(input, options);
        } catch (cause) {
            throw $90baw.OAuthResolverError.from(cause, `Failed to resolve identity: ${input}`);
        }
    }
    async getAuthorizationServerMetadata(issuer, options) {
        try {
            return await this.authorizationServerMetadataResolver.get(issuer, options);
        } catch (cause) {
            throw $90baw.OAuthResolverError.from(cause, `Failed to resolve OAuth server metadata for issuer: ${issuer}`);
        }
    }
    async getResourceServerMetadata(pdsUrl, options) {
        try {
            const rsMetadata = await this.protectedResourceMetadataResolver.get(pdsUrl, options);
            // ATPROTO requires one, and only one, authorization server entry
            if (rsMetadata.authorization_servers?.length !== 1) throw new $90baw.OAuthResolverError(rsMetadata.authorization_servers?.length ? `Unable to determine authorization server for PDS: ${pdsUrl}` : `No authorization servers found for PDS: ${pdsUrl}`);
            const issuer = rsMetadata.authorization_servers[0];
            options?.signal?.throwIfAborted();
            const asMetadata = await this.getAuthorizationServerMetadata(issuer, options);
            // https://datatracker.ietf.org/doc/html/draft-ietf-oauth-resource-metadata-05#section-4
            if (asMetadata.protected_resources) {
                if (!asMetadata.protected_resources.includes(rsMetadata.resource)) throw new $90baw.OAuthResolverError(`PDS "${pdsUrl}" not protected by issuer "${issuer}"`);
            }
            return asMetadata;
        } catch (cause) {
            throw $90baw.OAuthResolverError.from(cause, `Failed to resolve OAuth server metadata for resource: ${pdsUrl}`);
        }
    }
}
module.exports.OAuthResolver = $8072b561bd459c16$var$OAuthResolver;

});
parcelRegister("90baw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthResolverError = void 0;
class $68dcc705cf1f2548$var$OAuthResolverError extends Error {
    constructor(message, options){
        super(message, options);
    }
    static from(cause, message) {
        if (cause instanceof $68dcc705cf1f2548$var$OAuthResolverError) return cause;
        return new $68dcc705cf1f2548$var$OAuthResolverError(message ?? `Unable to resolve identity`, {
            cause: cause
        });
    }
}
module.exports.OAuthResolverError = $68dcc705cf1f2548$var$OAuthResolverError;

});


parcelRegister("4H3QM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthServerFactory = void 0;

var $eXxXt = parcelRequire("eXxXt");
class $36ae2a2fbefa4567$var$OAuthServerFactory {
    constructor(clientMetadata, runtime, resolver, fetch, keyset, dpopNonceCache){
        Object.defineProperty(this, "clientMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: clientMetadata
        });
        Object.defineProperty(this, "runtime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: runtime
        });
        Object.defineProperty(this, "resolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: resolver
        });
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: fetch
        });
        Object.defineProperty(this, "keyset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: keyset
        });
        Object.defineProperty(this, "dpopNonceCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: dpopNonceCache
        });
    }
    async fromIssuer(issuer, dpopKey, options) {
        const serverMetadata = await this.resolver.getAuthorizationServerMetadata(issuer, options);
        return this.fromMetadata(serverMetadata, dpopKey);
    }
    async fromMetadata(serverMetadata, dpopKey) {
        return new $eXxXt.OAuthServerAgent(dpopKey, serverMetadata, this.clientMetadata, this.dpopNonceCache, this.resolver, this.runtime, this.keyset, this.fetch);
    }
}
module.exports.OAuthServerFactory = $36ae2a2fbefa4567$var$OAuthServerFactory;

});
parcelRegister("eXxXt", function(module, exports) {
"use strict";
var $ae40eacc1aa528fc$var$__addDisposableResource = module.exports && module.exports.__addDisposableResource || function(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
};
var $ae40eacc1aa528fc$var$__disposeResources = module.exports && module.exports.__disposeResources || function(SuppressedError1) {
    return function(env) {
        function fail(e) {
            env.error = env.hasError ? new SuppressedError1(e, env.error, "An error was suppressed during disposal.") : e;
            env.hasError = true;
        }
        function next() {
            while(env.stack.length){
                var rec = env.stack.pop();
                try {
                    var result = rec.dispose && rec.dispose.call(rec.value);
                    if (rec.async) return Promise.resolve(result).then(next, function(e) {
                        fail(e);
                        return next();
                    });
                } catch (e) {
                    fail(e);
                }
            }
            if (env.hasError) throw env.error;
        }
        return next();
    };
}(typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
});
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthServerAgent = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $auA9I = parcelRequire("auA9I");

var $59fWx = parcelRequire("59fWx");

var $gbHhk = parcelRequire("gbHhk");

var $9oKOU = parcelRequire("9oKOU");

var $3e91q = parcelRequire("3e91q");

var $96UnS = parcelRequire("96UnS");
class $ae40eacc1aa528fc$var$OAuthServerAgent {
    constructor(dpopKey, serverMetadata, clientMetadata, dpopNonces, oauthResolver, runtime, keyset, fetch){
        Object.defineProperty(this, "dpopKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: dpopKey
        });
        Object.defineProperty(this, "serverMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: serverMetadata
        });
        Object.defineProperty(this, "clientMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: clientMetadata
        });
        Object.defineProperty(this, "dpopNonces", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: dpopNonces
        });
        Object.defineProperty(this, "oauthResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: oauthResolver
        });
        Object.defineProperty(this, "runtime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: runtime
        });
        Object.defineProperty(this, "keyset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: keyset
        });
        Object.defineProperty(this, "dpopFetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.dpopFetch = (0, $9oKOU.dpopFetchWrapper)({
            fetch: (0, $8oTqd.bindFetch)(fetch),
            iss: clientMetadata.client_id,
            key: dpopKey,
            supportedAlgs: serverMetadata.dpop_signing_alg_values_supported,
            sha256: async (v)=>runtime.sha256(v),
            nonces: dpopNonces,
            isAuthServer: true
        });
    }
    async revoke(token) {
        try {
            await this.request('revocation', {
                token: token
            });
        } catch  {
        // Don't care
        }
    }
    async exchangeCode(code, verifier) {
        const tokenResponse = await this.request('token', {
            grant_type: 'authorization_code',
            redirect_uri: this.clientMetadata.redirect_uris[0],
            code: code,
            code_verifier: verifier
        });
        try {
            return this.processTokenResponse(tokenResponse);
        } catch (err) {
            await this.revoke(tokenResponse.access_token);
            throw err;
        }
    }
    async refresh(tokenSet) {
        if (!tokenSet.refresh_token) throw new $gbHhk.TokenRefreshError(tokenSet.sub, 'No refresh token available');
        const tokenResponse = await this.request('token', {
            grant_type: 'refresh_token',
            refresh_token: tokenSet.refresh_token
        });
        try {
            if (tokenSet.sub !== tokenResponse.sub) throw new $gbHhk.TokenRefreshError(tokenSet.sub, `Unexpected "sub" in token response (${tokenResponse.sub})`);
            if (tokenSet.iss !== this.serverMetadata.issuer) throw new $gbHhk.TokenRefreshError(tokenSet.sub, 'Issuer mismatch');
            return this.processTokenResponse(tokenResponse);
        } catch (err) {
            await this.revoke(tokenResponse.access_token);
            throw err;
        }
    }
    /**
     * VERY IMPORTANT ! Always call this to process token responses.
     *
     * Whenever an OAuth token response is received, we **MUST** verify that the
     * "sub" is a DID, whose issuer authority is indeed the server we just
     * obtained credentials from. This check is a critical step to actually be
     * able to use the "sub" (DID) as being the actual user's identifier.
     */ async processTokenResponse(tokenResponse) {
        const env_1 = {
            stack: [],
            error: void 0,
            hasError: false
        };
        try {
            const { sub: sub } = tokenResponse;
            if (!sub || typeof sub !== 'string') throw new TypeError(`Unexpected ${typeof sub} "sub" in token response`);
            // Using an array to check for the presence of the "atproto" scope (we don't
            // want atproto to be a substring of another scope)
            const scopes = tokenResponse.scope?.split(' ');
            if (!scopes?.includes('atproto')) throw new TypeError('Missing "atproto" scope in token response');
            // @TODO (?) make timeout configurable
            const signal = $ae40eacc1aa528fc$var$__addDisposableResource(env_1, (0, $96UnS.timeoutSignal)(10e3), false);
            const resolved = await this.oauthResolver.resolveFromIdentity(sub, {
                signal: signal
            });
            if (this.serverMetadata.issuer !== resolved.metadata.issuer) // Best case scenario; the user switched PDS. Worst case scenario; a bad
            // actor is trying to impersonate a user. In any case, we must not allow
            // this token to be used.
            throw new TypeError('Issuer mismatch');
            return {
                aud: resolved.identity.pds.href,
                iss: resolved.metadata.issuer,
                sub: sub,
                scope: tokenResponse.scope,
                refresh_token: tokenResponse.refresh_token,
                access_token: tokenResponse.access_token,
                token_type: tokenResponse.token_type ?? 'Bearer',
                expires_at: typeof tokenResponse.expires_in === 'number' ? new Date(Date.now() + tokenResponse.expires_in * 1000).toISOString() : undefined
            };
        } catch (e_1) {
            env_1.error = e_1;
            env_1.hasError = true;
        } finally{
            $ae40eacc1aa528fc$var$__disposeResources(env_1);
        }
    }
    async request(endpoint, payload) {
        const url = this.serverMetadata[`${endpoint}_endpoint`];
        if (!url) throw new Error(`No ${endpoint} endpoint available`);
        const auth = await this.buildClientAuth(endpoint);
        const { response: response, json: json } = await this.dpopFetch(url, {
            method: 'POST',
            headers: {
                ...auth.headers,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...payload,
                ...auth.payload
            })
        }).then((0, $8oTqd.fetchJsonProcessor)());
        if (response.ok) switch(endpoint){
            case 'token':
                return $auA9I.oauthTokenResponseSchema.parse(json);
            case 'pushed_authorization_request':
                return $auA9I.oauthParResponseSchema.parse(json);
            default:
                return json;
        }
        else throw new $3e91q.OAuthResponseError(response, json);
    }
    async buildClientAuth(endpoint) {
        const methodSupported = this.serverMetadata[`token_endpoint_auth_methods_supported`];
        const method = this.clientMetadata[`token_endpoint_auth_method`];
        if (method === 'private_key_jwt' || this.keyset && !method && (methodSupported?.includes('private_key_jwt') ?? false)) {
            if (!this.keyset) throw new Error('No keyset available');
            try {
                const alg = this.serverMetadata[`token_endpoint_auth_signing_alg_values_supported`] ?? $59fWx.FALLBACK_ALG;
                // If jwks is defined, make sure to only sign using a key that exists in
                // the jwks. If jwks_uri is defined, we can't be sure that the key we're
                // looking for is in there so we will just assume it is.
                const kid = this.clientMetadata.jwks?.keys.map(({ kid: kid })=>kid).filter((v)=>typeof v === 'string');
                return {
                    payload: {
                        client_id: this.clientMetadata.client_id,
                        client_assertion_type: $auA9I.CLIENT_ASSERTION_TYPE_JWT_BEARER,
                        client_assertion: await this.keyset.createJwt({
                            alg: alg,
                            kid: kid
                        }, {
                            iss: this.clientMetadata.client_id,
                            sub: this.clientMetadata.client_id,
                            aud: this.serverMetadata.issuer,
                            jti: await this.runtime.generateNonce(),
                            iat: Math.floor(Date.now() / 1000)
                        })
                    }
                };
            } catch (err) {
                if (method === 'private_key_jwt') throw err;
            // Else try next method
            }
        }
        if (method === 'none' || !method && (methodSupported?.includes('none') ?? true)) return {
            payload: {
                client_id: this.clientMetadata.client_id
            }
        };
        throw new Error(`Unsupported ${endpoint} authentication method`);
    }
}
module.exports.OAuthServerAgent = $ae40eacc1aa528fc$var$OAuthServerAgent;

});
parcelRegister("gbHhk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenRefreshError = void 0;
class $bc8f3e9c231b56c2$var$TokenRefreshError extends Error {
    constructor(sub, message, options){
        super(message, options);
        Object.defineProperty(this, "sub", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sub
        });
    }
}
module.exports.TokenRefreshError = $bc8f3e9c231b56c2$var$TokenRefreshError;

});

parcelRegister("9oKOU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dpopFetchWrapper = void 0;

var $8oTqd = parcelRequire("8oTqd");

var $j3YM6 = parcelRequire("j3YM6");
// "undefined" in non https environments or environments without crypto
const $6d7aac6c3c01655b$var$subtle = globalThis.crypto?.subtle;
const $6d7aac6c3c01655b$var$ReadableStream = globalThis.ReadableStream;
function $6d7aac6c3c01655b$var$dpopFetchWrapper({ key: key, iss: iss, supportedAlgs: supportedAlgs, nonces: nonces, sha256: sha256 = typeof $6d7aac6c3c01655b$var$subtle !== 'undefined' ? $6d7aac6c3c01655b$var$subtleSha256 : undefined, isAuthServer: isAuthServer, fetch: fetch = globalThis.fetch }) {
    if (!sha256) throw new TypeError(`crypto.subtle is not available in this environment. Please provide a sha256 function.`);
    const alg = $6d7aac6c3c01655b$var$negotiateAlg(key, supportedAlgs);
    return async function(input, init) {
        if (!key.algorithms.includes(alg)) throw new TypeError(`Key does not support the algorithm ${alg}`);
        const request = init == null && input instanceof Request ? input : new Request(input, init);
        const authorizationHeader = request.headers.get('Authorization');
        const ath = authorizationHeader?.startsWith('DPoP ') ? await sha256(authorizationHeader.slice(5)) : undefined;
        const { method: method, url: url } = request;
        const { origin: origin } = new URL(url);
        let initNonce;
        try {
            initNonce = await nonces.get(origin);
        } catch  {
        // Ignore get errors, we will just not send a nonce
        }
        const initProof = await $6d7aac6c3c01655b$var$buildProof(key, alg, iss, method, url, initNonce, ath);
        request.headers.set('DPoP', initProof);
        const initResponse = await fetch.call(this, request);
        // Make sure the response body is consumed. Either by the caller (when the
        // response is returned), of if an error is thrown (catch block).
        const nextNonce = initResponse.headers.get('DPoP-Nonce');
        if (!nextNonce || nextNonce === initNonce) // No nonce was returned or it is the same as the one we sent. No need to
        // update the nonce store, or retry the request.
        return initResponse;
        // Store the fresh nonce for future requests
        try {
            await nonces.set(origin, nextNonce);
        } catch  {
        // Ignore set errors
        }
        const shouldRetry = await $6d7aac6c3c01655b$var$isUseDpopNonceError(initResponse, isAuthServer);
        if (!shouldRetry) // Not a "use_dpop_nonce" error, so there is no need to retry
        return initResponse;
        // If the input stream was already consumed, we cannot retry the request. A
        // solution would be to clone() the request but that would bufferize the
        // entire stream in memory which can lead to memory starvation. Instead, we
        // will return the original response and let the calling code handle retries.
        if (input === request) // The input request body was consumed. We cannot retry the request.
        return initResponse;
        if ($6d7aac6c3c01655b$var$ReadableStream && init?.body instanceof $6d7aac6c3c01655b$var$ReadableStream) // The init body was consumed. We cannot retry the request.
        return initResponse;
        // We will now retry the request with the fresh nonce.
        // The initial response body must be consumed (see cancelBody's doc).
        await (0, $8oTqd.cancelBody)(initResponse, 'log');
        const nextProof = await $6d7aac6c3c01655b$var$buildProof(key, alg, iss, method, url, nextNonce, ath);
        const nextRequest = new Request(input, init);
        nextRequest.headers.set('DPoP', nextProof);
        return fetch.call(this, nextRequest);
    };
}
module.exports.dpopFetchWrapper = $6d7aac6c3c01655b$var$dpopFetchWrapper;
async function $6d7aac6c3c01655b$var$buildProof(key, alg, iss, htm, htu, nonce, ath) {
    if (!key.bareJwk) throw new Error('Only asymmetric keys can be used as DPoP proofs');
    const now = Math.floor(Date.now() / 1e3);
    return key.createJwt(// https://datatracker.ietf.org/doc/html/rfc9449#section-4.2
    {
        alg: alg,
        typ: 'dpop+jwt',
        jwk: key.bareJwk
    }, {
        iss: iss,
        iat: now,
        // Any collision will cause the request to be rejected by the server. no biggie.
        jti: Math.random().toString(36).slice(2),
        htm: htm,
        htu: htu,
        nonce: nonce,
        ath: ath
    });
}
async function $6d7aac6c3c01655b$var$isUseDpopNonceError(response, isAuthServer) {
    // https://datatracker.ietf.org/doc/html/rfc6750#section-3
    // https://datatracker.ietf.org/doc/html/rfc9449#name-resource-server-provided-no
    if (isAuthServer === undefined || isAuthServer === false) {
        if (response.status === 401) {
            const wwwAuth = response.headers.get('WWW-Authenticate');
            if (wwwAuth?.startsWith('DPoP')) return wwwAuth.includes('error="use_dpop_nonce"');
        }
    }
    // https://datatracker.ietf.org/doc/html/rfc9449#name-authorization-server-provid
    if (isAuthServer === undefined || isAuthServer === true) {
        if (response.status === 400) try {
            const json = await (0, $8oTqd.peekJson)(response, 10240);
            return typeof json === 'object' && json?.['error'] === 'use_dpop_nonce';
        } catch  {
            // Response too big (to be "use_dpop_nonce" error) or invalid JSON
            return false;
        }
    }
    return false;
}
function $6d7aac6c3c01655b$var$negotiateAlg(key, supportedAlgs) {
    if (supportedAlgs) {
        // Use order of supportedAlgs as preference
        const alg = supportedAlgs.find((a)=>key.algorithms.includes(a));
        if (alg) return alg;
    } else {
        const [alg] = key.algorithms;
        if (alg) return alg;
    }
    throw new Error('Key does not match any alg supported by the server');
}
async function $6d7aac6c3c01655b$var$subtleSha256(input) {
    if ($6d7aac6c3c01655b$var$subtle == null) throw new Error(`crypto.subtle is not available in this environment. Please provide a sha256 function.`);
    const bytes = new TextEncoder().encode(input);
    const digest = await $6d7aac6c3c01655b$var$subtle.digest('SHA-256', bytes);
    const digestBytes = new Uint8Array(digest);
    return $j3YM6.base64url.baseEncode(digestBytes);
}

});

parcelRegister("3e91q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthResponseError = void 0;

var $8oTqd = parcelRequire("8oTqd");
class $2599ad8042ef1054$var$OAuthResponseError extends Error {
    constructor(response, payload){
        const error = (0, $8oTqd.ifString)((0, $8oTqd.ifObject)(payload)?.['error']);
        const errorDescription = (0, $8oTqd.ifString)((0, $8oTqd.ifObject)(payload)?.['error_description']);
        const messageError = error ? `"${error}"` : 'unknown';
        const messageDesc = errorDescription ? `: ${errorDescription}` : '';
        const message = `OAuth ${messageError} error${messageDesc}`;
        super(message);
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: response
        });
        Object.defineProperty(this, "payload", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: payload
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorDescription", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.error = error;
        this.errorDescription = errorDescription;
    }
    get status() {
        return this.response.status;
    }
    get headers() {
        return this.response.headers;
    }
}
module.exports.OAuthResponseError = $2599ad8042ef1054$var$OAuthResponseError;

});



parcelRegister("6aqH9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OAuthSession = void 0;

var $hoXKl = parcelRequire("hoXKl");

var $8oTqd = parcelRequire("8oTqd");

var $5F6X2 = parcelRequire("5F6X2");

var $5QfU8 = parcelRequire("5QfU8");

var $9oKOU = parcelRequire("9oKOU");
const $47d8624fc3b88b76$var$ReadableStream = globalThis.ReadableStream;
class $47d8624fc3b88b76$var$OAuthSession {
    constructor(server, sub, sessionGetter, fetch = globalThis.fetch){
        Object.defineProperty(this, "server", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: server
        });
        Object.defineProperty(this, "sub", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sub
        });
        Object.defineProperty(this, "sessionGetter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sessionGetter
        });
        Object.defineProperty(this, "dpopFetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.dpopFetch = (0, $9oKOU.dpopFetchWrapper)({
            fetch: (0, $8oTqd.bindFetch)(fetch),
            iss: server.clientMetadata.client_id,
            key: server.dpopKey,
            supportedAlgs: server.serverMetadata.dpop_signing_alg_values_supported,
            sha256: async (v)=>server.runtime.sha256(v),
            nonces: server.dpopNonces,
            isAuthServer: false
        });
    }
    get did() {
        return (0, $hoXKl.asDid)(this.sub);
    }
    get serverMetadata() {
        return this.server.serverMetadata;
    }
    /**
     * @param refresh See {@link SessionGetter.getSession}
     */ async getTokenSet(refresh) {
        const { tokenSet: tokenSet } = await this.sessionGetter.getSession(this.sub, refresh);
        return tokenSet;
    }
    async getTokenInfo(refresh) {
        const tokenSet = await this.getTokenSet(refresh);
        const expiresAt = tokenSet.expires_at == null ? undefined : new Date(tokenSet.expires_at);
        return {
            expiresAt: expiresAt,
            get expired () {
                return expiresAt == null ? undefined : expiresAt.getTime() < Date.now() - 5e3;
            },
            scope: tokenSet.scope,
            iss: tokenSet.iss,
            aud: tokenSet.aud,
            sub: tokenSet.sub
        };
    }
    async signOut() {
        try {
            const { tokenSet: tokenSet } = await this.sessionGetter.getSession(this.sub, false);
            await this.server.revoke(tokenSet.access_token);
        } finally{
            await this.sessionGetter.delStored(this.sub, new $5QfU8.TokenRevokedError(this.sub));
        }
    }
    async fetchHandler(pathname, init) {
        // This will try and refresh the token if it is known to be expired
        const tokenSet = await this.getTokenSet(undefined);
        const initialUrl = new URL(pathname, tokenSet.aud);
        const initialAuth = `${tokenSet.token_type} ${tokenSet.access_token}`;
        const headers = new Headers(init?.headers);
        headers.set('Authorization', initialAuth);
        const initialResponse = await this.dpopFetch(initialUrl, {
            ...init,
            headers: headers
        });
        // If the token is not expired, we don't need to refresh it
        if (!$47d8624fc3b88b76$var$isInvalidTokenResponse(initialResponse)) return initialResponse;
        let tokenSetFresh;
        try {
            // Force a refresh
            tokenSetFresh = await this.getTokenSet(true);
        } catch (err) {
            return initialResponse;
        }
        // The stream was already consumed. We cannot retry the request. A solution
        // would be to tee() the input stream but that would bufferize the entire
        // stream in memory which can lead to memory starvation. Instead, we will
        // return the original response and let the calling code handle retries.
        if ($47d8624fc3b88b76$var$ReadableStream && init?.body instanceof $47d8624fc3b88b76$var$ReadableStream) return initialResponse;
        const finalAuth = `${tokenSetFresh.token_type} ${tokenSetFresh.access_token}`;
        const finalUrl = new URL(pathname, tokenSetFresh.aud);
        headers.set('Authorization', finalAuth);
        const finalResponse = await this.dpopFetch(finalUrl, {
            ...init,
            headers: headers
        });
        // The token was successfully refreshed, but is still not accepted by the
        // resource server. This might be due to the resource server not accepting
        // credentials from the authorization server (e.g. because some migration
        // occurred). Any ways, there is no point in keeping the session.
        if ($47d8624fc3b88b76$var$isInvalidTokenResponse(finalResponse)) // TODO: Is there a "softer" way to handle this, e.g. by marking the
        // session as "expired" in the session store, allowing the user to trigger
        // a new login (using login_hint)?
        await this.sessionGetter.delStored(this.sub, new $5F6X2.TokenInvalidError(this.sub));
        return finalResponse;
    }
}
module.exports.OAuthSession = $47d8624fc3b88b76$var$OAuthSession;
/**
 * @see {@link https://datatracker.ietf.org/doc/html/rfc6750#section-3}
 * @see {@link https://datatracker.ietf.org/doc/html/rfc9449#name-resource-server-provided-no}
 */ function $47d8624fc3b88b76$var$isInvalidTokenResponse(response) {
    if (response.status !== 401) return false;
    const wwwAuth = response.headers.get('WWW-Authenticate');
    return wwwAuth != null && (wwwAuth.startsWith('Bearer ') || wwwAuth.startsWith('DPoP ')) && wwwAuth.includes('error="invalid_token"');
}

});
parcelRegister("5F6X2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenInvalidError = void 0;
class $41f62c72fd3526dc$var$TokenInvalidError extends Error {
    constructor(sub, message = `The session for "${sub}" is invalid`, options){
        super(message, options);
        Object.defineProperty(this, "sub", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sub
        });
    }
}
module.exports.TokenInvalidError = $41f62c72fd3526dc$var$TokenInvalidError;

});


parcelRegister("f60TT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Runtime = void 0;

var $j3YM6 = parcelRequire("j3YM6");

var $lvqTT = parcelRequire("lvqTT");
class $afd81d65222e188e$var$Runtime {
    constructor(implementation){
        Object.defineProperty(this, "implementation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: implementation
        });
        Object.defineProperty(this, "hasImplementationLock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "usingLock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const { requestLock: requestLock } = implementation;
        this.hasImplementationLock = requestLock != null;
        this.usingLock = requestLock?.bind(implementation) || // Falling back to a local lock
        $lvqTT.requestLocalLock;
    }
    async generateKey(algs) {
        const algsSorted = Array.from(algs).sort($afd81d65222e188e$var$compareAlgos);
        return this.implementation.createKey(algsSorted);
    }
    async sha256(text) {
        const bytes = new TextEncoder().encode(text);
        const digest = await this.implementation.digest(bytes, {
            name: 'sha256'
        });
        return $j3YM6.base64url.baseEncode(digest);
    }
    async generateNonce(length = 16) {
        const bytes = await this.implementation.getRandomValues(length);
        return $j3YM6.base64url.baseEncode(bytes);
    }
    async generatePKCE(byteLength) {
        const verifier = await this.generateVerifier(byteLength);
        return {
            verifier: verifier,
            challenge: await this.sha256(verifier),
            method: 'S256'
        };
    }
    async calculateJwkThumbprint(jwk) {
        const components = $afd81d65222e188e$var$extractJktComponents(jwk);
        const data = JSON.stringify(components);
        return this.sha256(data);
    }
    /**
     * @see {@link https://datatracker.ietf.org/doc/html/rfc7636#section-4.1}
     * @note It is RECOMMENDED that the output of a suitable random number generator
     * be used to create a 32-octet sequence. The octet sequence is then
     * base64url-encoded to produce a 43-octet URL safe string to use as the code
     * verifier.
     */ async generateVerifier(byteLength = 32) {
        if (byteLength < 32 || byteLength > 96) throw new TypeError('Invalid code_verifier length');
        const bytes = await this.implementation.getRandomValues(byteLength);
        return $j3YM6.base64url.baseEncode(bytes);
    }
}
module.exports.Runtime = $afd81d65222e188e$var$Runtime;
function $afd81d65222e188e$var$extractJktComponents(jwk) {
    const get = (field)=>{
        const value = jwk[field];
        if (typeof value !== 'string' || !value) throw new TypeError(`"${field}" Parameter missing or invalid`);
        return value;
    };
    switch(jwk.kty){
        case 'EC':
            return {
                crv: get('crv'),
                kty: get('kty'),
                x: get('x'),
                y: get('y')
            };
        case 'OKP':
            return {
                crv: get('crv'),
                kty: get('kty'),
                x: get('x')
            };
        case 'RSA':
            return {
                e: get('e'),
                kty: get('kty'),
                n: get('n')
            };
        case 'oct':
            return {
                k: get('k'),
                kty: get('kty')
            };
        default:
            throw new TypeError('"kty" (Key Type) Parameter missing or unsupported');
    }
}
/**
 * 256K > ES (256 > 384 > 512) > PS (256 > 384 > 512) > RS (256 > 384 > 512) > other (in original order)
 */ function $afd81d65222e188e$var$compareAlgos(a, b) {
    if (a === 'ES256K') return -1;
    if (b === 'ES256K') return 1;
    for (const prefix of [
        'ES',
        'PS',
        'RS'
    ]){
        if (a.startsWith(prefix)) {
            if (b.startsWith(prefix)) {
                const aLen = parseInt(a.slice(2, 5));
                const bLen = parseInt(b.slice(2, 5));
                // Prefer shorter key lengths
                return aLen - bLen;
            }
            return -1;
        } else if (b.startsWith(prefix)) return 1;
    }
    // Don't know how to compare, keep original order
    return 0;
}

});
parcelRegister("lvqTT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.requestLocalLock = void 0;
const $fa815c16c44025ef$var$locks = new Map();
function $fa815c16c44025ef$var$acquireLocalLock(name) {
    return new Promise((resolveAcquire)=>{
        const prev = $fa815c16c44025ef$var$locks.get(name) ?? Promise.resolve();
        const next = prev.then(()=>{
            return new Promise((resolveRelease)=>{
                const release = ()=>{
                    // Only delete the lock if it is still the current one
                    if ($fa815c16c44025ef$var$locks.get(name) === next) $fa815c16c44025ef$var$locks.delete(name);
                    resolveRelease();
                };
                resolveAcquire(release);
            });
        });
        $fa815c16c44025ef$var$locks.set(name, next);
    });
}
const $fa815c16c44025ef$var$requestLocalLock = (name, fn)=>{
    return $fa815c16c44025ef$var$acquireLocalLock(name).then(async (release)=>{
        try {
            return await fn();
        } finally{
            release();
        }
    });
};
module.exports.requestLocalLock = $fa815c16c44025ef$var$requestLocalLock;

});


parcelRegister("5u6ZB", function(module, exports) {
"use strict";
var $3fe52db2d4c599e9$var$__addDisposableResource = module.exports && module.exports.__addDisposableResource || function(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
};
var $3fe52db2d4c599e9$var$__disposeResources = module.exports && module.exports.__disposeResources || function(SuppressedError1) {
    return function(env) {
        function fail(e) {
            env.error = env.hasError ? new SuppressedError1(e, env.error, "An error was suppressed during disposal.") : e;
            env.hasError = true;
        }
        function next() {
            while(env.stack.length){
                var rec = env.stack.pop();
                try {
                    var result = rec.dispose && rec.dispose.call(rec.value);
                    if (rec.async) return Promise.resolve(result).then(next, function(e) {
                        fail(e);
                        return next();
                    });
                } catch (e) {
                    fail(e);
                }
            }
            if (env.hasError) throw env.error;
        }
        return next();
    };
}(typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
});
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SessionGetter = void 0;

var $559MJ = parcelRequire("559MJ");

var $5F6X2 = parcelRequire("5F6X2");

var $gbHhk = parcelRequire("gbHhk");

var $5QfU8 = parcelRequire("5QfU8");

var $3e91q = parcelRequire("3e91q");

var $96UnS = parcelRequire("96UnS");
/**
 * There are several advantages to wrapping the sessionStore in a (single)
 * CachedGetter, the main of which is that the cached getter will ensure that at
 * most one fresh call is ever being made. Another advantage, is that it
 * contains the logic for reading from the cache which, if the cache is based on
 * localStorage/indexedDB, will sync across multiple tabs (for a given sub).
 */ class $3fe52db2d4c599e9$var$SessionGetter extends $559MJ.CachedGetter {
    constructor(sessionStore, serverFactory, runtime){
        super(async (sub, options, storedSession)=>{
            // There needs to be a previous session to be able to refresh. If
            // storedSession is undefined, it means that the store does not contain
            // a session for the given sub.
            if (storedSession === undefined) {
                // Because the session is not in the store, this.delStored() method
                // will not be called by the CachedGetter class (because there is
                // nothing to delete). This would typically happen if there is no
                // synchronization mechanism between instances of this class. Let's
                // make sure an event is dispatched here if this occurs.
                const msg = 'The session was deleted by another process';
                const cause = new $gbHhk.TokenRefreshError(sub, msg);
                this.dispatchEvent('deleted', {
                    sub: sub,
                    cause: cause
                });
                throw cause;
            }
            // From this point forward, throwing a TokenRefreshError will result in
            // this.delStored() being called, resulting in an event being
            // dispatched, even if the session was removed from the store through a
            // concurrent access (which, normally, should not happen if a proper
            // runtime lock was provided).
            if (sub !== storedSession.tokenSet.sub) // Fool-proofing (e.g. against invalid session storage)
            throw new $gbHhk.TokenRefreshError(sub, 'Stored session sub mismatch');
            // Since refresh tokens can only be used once, we might run into
            // concurrency issues if multiple tabs/instances are trying to refresh
            // the same token. The chances of this happening when multiple instances
            // are started simultaneously is reduced by randomizing the expiry time
            // (see isStale() below). Even so, There still exist chances that
            // multiple tabs will try to refresh the token at the same time. The
            // best solution would be to use a mutex/lock to ensure that only one
            // instance is refreshing the token at a time. A simpler workaround is
            // to check if the value stored in the session store is the same as the
            // one in memory. If it isn't, then another instance has already
            // refreshed the token.
            const { tokenSet: tokenSet, dpopKey: dpopKey } = storedSession;
            const server = await serverFactory.fromIssuer(tokenSet.iss, dpopKey);
            // Because refresh tokens can only be used once, we must not use the
            // "signal" to abort the refresh, or throw any abort error beyond this
            // point. Any thrown error beyond this point will prevent the
            // SessionGetter from obtaining, and storing, the new token set,
            // effectively rendering the currently saved session unusable.
            options?.signal?.throwIfAborted();
            try {
                const newTokenSet = await server.refresh(tokenSet);
                if (sub !== newTokenSet.sub) // The server returned another sub. Was the tokenSet manipulated?
                throw new $gbHhk.TokenRefreshError(sub, 'Token set sub mismatch');
                return {
                    dpopKey: dpopKey,
                    tokenSet: newTokenSet
                };
            } catch (cause) {
                // If the refresh token is invalid, let's try to recover from
                // concurrency issues, or make sure the session is deleted by throwing
                // a TokenRefreshError.
                if (cause instanceof $3e91q.OAuthResponseError && cause.status === 400 && cause.error === 'invalid_grant') {
                    // In case there is no lock implementation in the runtime, we will
                    // wait for a short time to give the other concurrent instances a
                    // chance to finish their refreshing of the token. If a concurrent
                    // refresh did occur, we will pretend that this one succeeded.
                    if (!runtime.hasImplementationLock) {
                        await new Promise((r)=>setTimeout(r, 1000));
                        const stored = await this.getStored(sub);
                        if (stored === undefined) {
                            // A concurrent refresh occurred and caused the session to be
                            // deleted (for a reason we can't know at this point).
                            // Using a distinct error message mainly for debugging
                            // purposes. Also, throwing a TokenRefreshError to trigger
                            // deletion through the deleteOnError callback.
                            const msg = 'The session was deleted by another process';
                            throw new $gbHhk.TokenRefreshError(sub, msg, {
                                cause: cause
                            });
                        } else if (stored.tokenSet.access_token !== tokenSet.access_token || stored.tokenSet.refresh_token !== tokenSet.refresh_token) // A concurrent refresh occurred. Pretend this one succeeded.
                        return {
                            dpopKey: dpopKey,
                            tokenSet: stored.tokenSet
                        };
                    }
                    // Make sure the session gets deleted from the store
                    const msg = cause.errorDescription ?? 'The session was revoked';
                    throw new $gbHhk.TokenRefreshError(sub, msg, {
                        cause: cause
                    });
                }
                throw cause;
            }
        }, sessionStore, {
            isStale: (sub, { tokenSet: tokenSet })=>{
                return tokenSet.expires_at != null && new Date(tokenSet.expires_at).getTime() < // Add some lee way to ensure the token is not expired when it
                // reaches the server.
                Date.now() + 60e3;
            },
            onStoreError: async (err, sub, { tokenSet: tokenSet, dpopKey: dpopKey })=>{
                // If the token data cannot be stored, let's revoke it
                const server = await serverFactory.fromIssuer(tokenSet.iss, dpopKey);
                await server.revoke(tokenSet.refresh_token ?? tokenSet.access_token);
                throw err;
            },
            deleteOnError: async (err)=>// Optimization: More likely to happen first
                err instanceof $gbHhk.TokenRefreshError || err instanceof $5QfU8.TokenRevokedError || err instanceof $5F6X2.TokenInvalidError
        });
        Object.defineProperty(this, "runtime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: runtime
        });
        Object.defineProperty(this, "eventTarget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new $96UnS.CustomEventTarget()
        });
    }
    addEventListener(type, callback, options) {
        this.eventTarget.addEventListener(type, callback, options);
    }
    removeEventListener(type, callback, options) {
        this.eventTarget.removeEventListener(type, callback, options);
    }
    dispatchEvent(type, detail) {
        return this.eventTarget.dispatchCustomEvent(type, detail);
    }
    async setStored(sub, session) {
        await super.setStored(sub, session);
        this.dispatchEvent('updated', {
            sub: sub,
            ...session
        });
    }
    async delStored(sub, cause) {
        await super.delStored(sub, cause);
        this.dispatchEvent('deleted', {
            sub: sub,
            cause: cause
        });
    }
    /**
     * @param refresh When `true`, the credentials will be refreshed even if they
     * are not expired. When `false`, the credentials will not be refreshed even
     * if they are expired. When `undefined`, the credentials will be refreshed
     * if, and only if, they are (about to be) expired. Defaults to `undefined`.
     */ async getSession(sub, refresh) {
        const session = await this.get(sub, {
            noCache: refresh === true,
            allowStale: refresh === false
        });
        if (sub !== session.tokenSet.sub) // Fool-proofing (e.g. against invalid session storage)
        throw new Error('Token set does not match the expected sub');
        return session;
    }
    async get(sub, options) {
        return this.runtime.usingLock(`@atproto-oauth-client-${sub}`, async ()=>{
            const env_1 = {
                stack: [],
                error: void 0,
                hasError: false
            };
            try {
                // Make sure, even if there is no signal in the options, that the request
                // will be cancelled after at most 30 seconds.
                const signal = $3fe52db2d4c599e9$var$__addDisposableResource(env_1, (0, $96UnS.timeoutSignal)(30e3, options), false);
                return await super.get(sub, {
                    ...options,
                    signal: signal
                });
            } catch (e_1) {
                env_1.error = e_1;
                env_1.hasError = true;
            } finally{
                $3fe52db2d4c599e9$var$__disposeResources(env_1);
            }
        });
    }
}
module.exports.SessionGetter = $3fe52db2d4c599e9$var$SessionGetter;

});

parcelRegister("5cQ7D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateClientMetadata = void 0;

var $auA9I = parcelRequire("auA9I");

var $fr8VS = parcelRequire("fr8VS");
const $3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD = `token_endpoint_auth_method`;
const $3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_SIGNING_ALG = `token_endpoint_auth_signing_alg`;
function $3ca6811f8b134d00$var$validateClientMetadata(input, keyset) {
    if (input.jwks) {
        if (!keyset) throw new TypeError(`Keyset must not be provided when jwks is provided`);
        for (const key of input.jwks.keys){
            if (!key.kid) throw new TypeError(`Key must have a "kid" property`);
            else if (!keyset.has(key.kid)) throw new TypeError(`Key with kid "${key.kid}" not found in keyset`);
        }
    }
    // Allow to pass a keyset and omit the jwks/jwks_uri properties
    if (!input.jwks && !input.jwks_uri && keyset?.size) input = {
        ...input,
        jwks: keyset.toJSON()
    };
    const metadata = $fr8VS.clientMetadataSchema.parse(input);
    // Validate client ID
    if (metadata.client_id.startsWith('http:')) (0, $auA9I.assertOAuthLoopbackClientId)(metadata.client_id);
    else (0, $auA9I.assertOAuthDiscoverableClientId)(metadata.client_id);
    const scopes = metadata.scope?.split(' ');
    if (!scopes?.includes('atproto')) throw new TypeError(`Client metadata must include the "atproto" scope`);
    if (!metadata.response_types.includes('code')) throw new TypeError(`"response_types" must include "code"`);
    if (!metadata.grant_types.includes('authorization_code')) throw new TypeError(`"grant_types" must include "authorization_code"`);
    const method = metadata[$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD];
    switch(method){
        case undefined:
            throw new TypeError(`${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD} must be provided`);
        case 'none':
            if (metadata[$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_SIGNING_ALG]) throw new TypeError(`${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_SIGNING_ALG} must not be provided when ${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD} is "${method}"`);
            break;
        case 'private_key_jwt':
            if (!keyset?.size) throw new TypeError(`A non-empty keyset must be provided when ${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD} is "${method}"`);
            if (!metadata[$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_SIGNING_ALG]) throw new TypeError(`${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_SIGNING_ALG} must be provided when ${$3ca6811f8b134d00$var$TOKEN_ENDPOINT_AUTH_METHOD} is "${method}"`);
            break;
        default:
            throw new TypeError(`Invalid "token_endpoint_auth_method" value: ${method}`);
    }
    return metadata;
}
module.exports.validateClientMetadata = $3ca6811f8b134d00$var$validateClientMetadata;

});
parcelRegister("fr8VS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clientMetadataSchema = void 0;

var $auA9I = parcelRequire("auA9I");
module.exports.clientMetadataSchema = $auA9I.oauthClientMetadataSchema.extend({
    client_id: $auA9I.oauthClientIdSchema.url()
});

});



parcelRegister("8vaR3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lfiD0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("7JhZC", function(module, exports) {
"use strict";
var $5a0ab15eeffedffa$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserOAuthClient = void 0;

var $cNZAj = parcelRequire("cNZAj");

var $auA9I = parcelRequire("auA9I");

var $l4NzH = parcelRequire("l4NzH");

var $20NiT = parcelRequire("20NiT");

var $51ST3 = parcelRequire("51ST3");

var $4B1hY = parcelRequire("4B1hY");
const $5a0ab15eeffedffa$var$NAMESPACE = `@@atproto/oauth-client-browser`;
//- Popup channel
const $5a0ab15eeffedffa$var$POPUP_CHANNEL_NAME = `${$5a0ab15eeffedffa$var$NAMESPACE}(popup-channel)`;
const $5a0ab15eeffedffa$var$POPUP_STATE_PREFIX = `${$5a0ab15eeffedffa$var$NAMESPACE}(popup-state):`;
const $5a0ab15eeffedffa$var$syncChannel = new BroadcastChannel(`${$5a0ab15eeffedffa$var$NAMESPACE}(synchronization-channel)`);
class $5a0ab15eeffedffa$var$BrowserOAuthClient extends $cNZAj.OAuthClient {
    static async load({ clientId: clientId, ...options }) {
        if (clientId.startsWith('http:')) {
            const clientMetadata = (0, $auA9I.atprotoLoopbackClientMetadata)(clientId);
            return new $5a0ab15eeffedffa$var$BrowserOAuthClient({
                clientMetadata: clientMetadata,
                ...options
            });
        } else if (clientId.startsWith('https:')) {
            (0, $auA9I.assertOAuthDiscoverableClientId)(clientId);
            const clientMetadata = await $cNZAj.OAuthClient.fetchMetadata({
                clientId: clientId,
                ...options
            });
            return new $5a0ab15eeffedffa$var$BrowserOAuthClient({
                clientMetadata: clientMetadata,
                ...options
            });
        } else throw new TypeError(`Invalid client id: ${clientId}`);
    }
    constructor({ handleResolver: handleResolver, clientMetadata: clientMetadata = (0, $auA9I.atprotoLoopbackClientMetadata)((0, $4B1hY.buildLoopbackClientId)(window.location)), responseMode: // "fragment" is a safer default as the query params will not be sent to the server
    responseMode = 'fragment', plcDirectoryUrl: plcDirectoryUrl, fetch: fetch }){
        if (!globalThis.crypto?.subtle) throw new Error('WebCrypto API is required');
        if (![
            'query',
            'fragment'
        ].includes(responseMode)) // Make sure "form_post" is not used as it is not supported in the browser
        throw new TypeError(`Invalid response mode: ${responseMode}`);
        const database = new $l4NzH.BrowserOAuthDatabase();
        super({
            clientMetadata: clientMetadata,
            responseMode: responseMode,
            fetch: fetch,
            plcDirectoryUrl: plcDirectoryUrl,
            handleResolver: handleResolver,
            runtimeImplementation: new $20NiT.BrowserRuntimeImplementation(),
            sessionStore: database.getSessionStore(),
            stateStore: database.getStateStore(),
            didCache: database.getDidCache(),
            handleCache: database.getHandleCache(),
            dpopNonceCache: database.getDpopNonceCache(),
            authorizationServerMetadataCache: database.getAuthorizationServerMetadataCache(),
            protectedResourceMetadataCache: database.getProtectedResourceMetadataCache()
        });
        Object.defineProperty(this, $5a0ab15eeffedffa$var$_a, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // TODO: replace with AsyncDisposableStack once they are standardized
        const ac = new AbortController();
        const { signal: signal } = ac;
        this[Symbol.dispose] = ()=>ac.abort();
        signal.addEventListener('abort', ()=>database[Symbol.asyncDispose](), {
            once: true
        });
        // Keep track of the current session
        this.addEventListener('deleted', ({ detail: { sub: sub } })=>{
            if (localStorage.getItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`) === sub) localStorage.removeItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`);
        });
        // Session synchronization across tabs
        for (const type of [
            'deleted',
            'updated'
        ])this.sessionGetter.addEventListener(type, ({ detail: detail })=>{
            // Notify other tabs when a session is deleted or updated
            $5a0ab15eeffedffa$var$syncChannel.postMessage([
                type,
                detail
            ]);
        });
        $5a0ab15eeffedffa$var$syncChannel.addEventListener('message', (event)=>{
            if (event.source !== window) {
                // Trigger listeners when an event is received from another tab
                const [type, detail] = event.data;
                this.dispatchCustomEvent(type, detail);
            }
        }, // Remove the listener when the client is disposed
        {
            signal: signal
        });
    }
    async init(refresh) {
        await $5a0ab15eeffedffa$var$fixLocation(this.clientMetadata);
        const signInResult = await this.signInCallback();
        if (signInResult) {
            localStorage.setItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`, signInResult.session.sub);
            return signInResult;
        }
        const sub = localStorage.getItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`);
        if (sub) try {
            const session = await this.restore(sub, refresh);
            return {
                session: session
            };
        } catch (err) {
            localStorage.removeItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`);
            throw err;
        }
    }
    async restore(sub, refresh) {
        const session = await super.restore(sub, refresh);
        localStorage.setItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`, session.sub);
        return session;
    }
    async revoke(sub) {
        localStorage.removeItem(`${$5a0ab15eeffedffa$var$NAMESPACE}(sub)`);
        return super.revoke(sub);
    }
    async signIn(input, options) {
        if (options?.display === 'popup') return this.signInPopup(input, options);
        else return this.signInRedirect(input, options);
    }
    async signInRedirect(input, options) {
        const url = await this.authorize(input, options);
        window.location.href = url.href;
        // back-forward cache
        return new Promise((resolve, reject)=>{
            setTimeout((err)=>{
                // Take the opportunity to proactively cancel the pending request
                this.abortRequest(url).then(()=>reject(err), (reason)=>reject(new AggregateError([
                        err,
                        reason
                    ])));
            }, 5e3, new Error('User navigated back'));
        });
    }
    async signInPopup(input, options) {
        // Open new window asap to prevent popup busting by browsers
        const popupFeatures = 'width=600,height=600,menubar=no,toolbar=no';
        let popup = window.open('about:blank', '_blank', popupFeatures);
        const stateKey = `${Math.random().toString(36).slice(2)}`;
        const url = await this.authorize(input, {
            ...options,
            state: `${$5a0ab15eeffedffa$var$POPUP_STATE_PREFIX}${stateKey}`,
            display: options?.display ?? 'popup'
        });
        options?.signal?.throwIfAborted();
        if (popup) popup.window.location.href = url.href;
        else popup = window.open(url.href, '_blank', popupFeatures);
        popup?.focus();
        return new Promise((resolve, reject)=>{
            const popupChannel = new BroadcastChannel($5a0ab15eeffedffa$var$POPUP_CHANNEL_NAME);
            const cleanup = ()=>{
                clearTimeout(timeout);
                popupChannel.removeEventListener('message', onMessage);
                popupChannel.close();
                options?.signal?.removeEventListener('abort', cancel);
                popup?.close();
            };
            const cancel = ()=>{
                // @TODO: Store fact that the request was cancelled, allowing any
                // callback (e.g. in the popup) to revoke the session or credentials.
                reject(new Error(options?.signal?.aborted ? 'Aborted' : 'Timeout'));
                cleanup();
            };
            options?.signal?.addEventListener('abort', cancel);
            const timeout = setTimeout(cancel, 300000);
            const onMessage = async ({ data: data })=>{
                if (data.key !== stateKey) return;
                if (!('result' in data)) return;
                // Send acknowledgment to popup window
                popupChannel.postMessage({
                    key: stateKey,
                    ack: true
                });
                cleanup();
                const { result: result } = data;
                if (result.status === 'fulfilled') {
                    const sub = result.value;
                    try {
                        options?.signal?.throwIfAborted();
                        resolve(await this.restore(sub, false));
                    } catch (err) {
                        reject(err);
                        this.revoke(sub);
                    }
                } else {
                    const { message: message, params: params } = result.reason;
                    reject(new $cNZAj.OAuthCallbackError(new URLSearchParams(params), message));
                }
            };
            popupChannel.addEventListener('message', onMessage);
        });
    }
    readCallbackParams() {
        const params = this.responseMode === 'fragment' ? new URLSearchParams(location.hash.slice(1)) : new URLSearchParams(location.search);
        // Only if the current URL contains a valid oauth response params
        if (!params.has('state') || !(params.has('code') || params.has('error'))) return null;
        const matchesLocation = (url)=>location.origin === url.origin && location.pathname === url.pathname;
        const redirectUrls = this.clientMetadata.redirect_uris.map((uri)=>new URL(uri));
        // Only if the current URL is one of the redirect_uris
        if (!redirectUrls.some(matchesLocation)) return null;
        return params;
    }
    async signInCallback() {
        const params = this.readCallbackParams();
        // Not a (valid) OAuth redirect
        if (!params) return null;
        // Replace the current history entry without the params (this will prevent
        // the following code to run again if the user refreshes the page)
        if (this.responseMode === 'fragment') history.replaceState(null, '', location.pathname + location.search);
        else if (this.responseMode === 'query') history.replaceState(null, '', location.pathname);
        // Utility function to send the result of the popup to the parent window
        const sendPopupResult = (message)=>{
            const popupChannel = new BroadcastChannel($5a0ab15eeffedffa$var$POPUP_CHANNEL_NAME);
            return new Promise((resolve)=>{
                const cleanup = (result)=>{
                    clearTimeout(timer);
                    popupChannel.removeEventListener('message', onMessage);
                    popupChannel.close();
                    resolve(result);
                };
                const onMessage = ({ data: data })=>{
                    if ('ack' in data && message.key === data.key) cleanup(true);
                };
                popupChannel.addEventListener('message', onMessage);
                popupChannel.postMessage(message);
                // Receiving of "ack" should be very fast, giving it 500 ms anyway
                const timer = setTimeout(cleanup, 500, false);
            });
        };
        return this.callback(params).then(async (result)=>{
            if (result.state?.startsWith($5a0ab15eeffedffa$var$POPUP_STATE_PREFIX)) {
                const receivedByParent = await sendPopupResult({
                    key: result.state.slice($5a0ab15eeffedffa$var$POPUP_STATE_PREFIX.length),
                    result: {
                        status: 'fulfilled',
                        value: result.session.sub
                    }
                });
                // Revoke the credentials if the parent window was closed
                if (!receivedByParent) await result.session.signOut();
                throw new $51ST3.LoginContinuedInParentWindowError(); // signInPopup
            }
            return result;
        }).catch(async (err)=>{
            if (err instanceof $cNZAj.OAuthCallbackError && err.state?.startsWith($5a0ab15eeffedffa$var$POPUP_STATE_PREFIX)) {
                await sendPopupResult({
                    key: err.state.slice($5a0ab15eeffedffa$var$POPUP_STATE_PREFIX.length),
                    result: {
                        status: 'rejected',
                        reason: {
                            message: err.message,
                            params: Array.from(err.params.entries())
                        }
                    }
                });
                throw new $51ST3.LoginContinuedInParentWindowError(); // signInPopup
            }
            // Most probable cause at this point is that the "state" parameter is
            // invalid.
            throw err;
        }).catch((err)=>{
            if (err instanceof $51ST3.LoginContinuedInParentWindowError) // parent will also try to close the popup
            window.close();
            throw err;
        });
    }
    dispose() {
        this[Symbol.dispose]();
    }
}
module.exports.BrowserOAuthClient = $5a0ab15eeffedffa$var$BrowserOAuthClient;
$5a0ab15eeffedffa$var$_a = Symbol.dispose;
/**
 * Since "localhost" is often used either in IP mode or in hostname mode,
 * and because the redirect uris must use the IP mode, we need to make sure
 * that the current location url is not using "localhost".
 *
 * This is required for the IndexedDB to work properly. Indeed, the IndexedDB
 * is shared by origin, so we must ensure to be on the same origin as the
 * redirect uris.
 */ function $5a0ab15eeffedffa$var$fixLocation(clientMetadata) {
    if (!(0, $auA9I.isOAuthClientIdLoopback)(clientMetadata.client_id)) return;
    if (window.location.hostname !== 'localhost') return;
    const locationUrl = new URL(window.location.href);
    for (const uri of clientMetadata.redirect_uris){
        const url = new URL(uri);
        if ((url.hostname === '127.0.0.1' || url.hostname === '[::1]') && (!url.port || url.port === locationUrl.port) && url.protocol === locationUrl.protocol && url.pathname === locationUrl.pathname) {
            url.port = locationUrl.port;
            window.location.href = url.href;
            // Prevent init() on the wrong origin
            throw new Error('Redirecting to loopback IP...');
        }
    }
    throw new Error(`Please use the loopback IP address instead of ${locationUrl}`);
}

});
parcelRegister("l4NzH", function(module, exports) {
"use strict";
var $f5806d3d78b686b9$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $f5806d3d78b686b9$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserOAuthDatabase = void 0;

var $h3MMF = parcelRequire("h3MMF");

var $kZIXW = parcelRequire("kZIXW");
function $f5806d3d78b686b9$var$encodeKey(key) {
    if (!(key instanceof $h3MMF.WebcryptoKey) || !key.kid) throw new Error('Invalid key object');
    return {
        keyId: key.kid,
        keyPair: key.cryptoKeyPair
    };
}
async function $f5806d3d78b686b9$var$decodeKey(encoded) {
    return $h3MMF.WebcryptoKey.fromKeypair(encoded.keyPair, encoded.keyId);
}
const $f5806d3d78b686b9$var$STORES = [
    'state',
    'session',
    'didCache',
    'dpopNonceCache',
    'handleCache',
    'authorizationServerMetadataCache',
    'protectedResourceMetadataCache'
];
class $f5806d3d78b686b9$var$BrowserOAuthDatabase {
    constructor(options){
        $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise.set(this, void 0);
        $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval.set(this, void 0);
        $f5806d3d78b686b9$var$__classPrivateFieldSet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, $kZIXW.DB.open(options?.name ?? '@atproto-oauth-client', [
            (db)=>{
                for (const name of $f5806d3d78b686b9$var$STORES){
                    const store = db.createObjectStore(name, {
                        autoIncrement: true
                    });
                    store.createIndex('expiresAt', 'expiresAt', {
                        unique: false
                    });
                }
            }
        ], {
            durability: options?.durability ?? 'strict'
        }), "f");
        $f5806d3d78b686b9$var$__classPrivateFieldSet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval, setInterval(()=>{
            this.cleanup();
        }, options?.cleanupInterval ?? 30e3), "f");
    }
    async run(storeName, mode, fn) {
        const db = await $f5806d3d78b686b9$var$__classPrivateFieldGet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, "f");
        return await db.transaction([
            storeName
        ], mode, (tx)=>fn(tx.objectStore(storeName)));
    }
    createStore(name, { encode: encode, decode: decode, expiresAt: expiresAt }) {
        return {
            get: async (key)=>{
                // Find item in store
                const item = await this.run(name, 'readonly', (store)=>store.get(key));
                // Not found
                if (item === undefined) return undefined;
                // Too old (delete)
                if (item.expiresAt != null && new Date(item.expiresAt) < new Date()) {
                    await this.run(name, 'readwrite', (store)=>store.delete(key));
                    return undefined;
                }
                // Item found and valid. Decode
                return decode(item.value);
            },
            set: async (key, value)=>{
                // Create encoded item record
                const item = {
                    value: await encode(value),
                    expiresAt: expiresAt(value)?.toISOString()
                };
                // Store item record
                await this.run(name, 'readwrite', (store)=>store.put(item, key));
            },
            del: async (key)=>{
                // Delete
                await this.run(name, 'readwrite', (store)=>store.delete(key));
            }
        };
    }
    getSessionStore() {
        return this.createStore('session', {
            expiresAt: ({ tokenSet: tokenSet })=>tokenSet.refresh_token || tokenSet.expires_at == null ? null : new Date(tokenSet.expires_at),
            encode: ({ dpopKey: dpopKey, ...session })=>({
                    ...session,
                    dpopKey: $f5806d3d78b686b9$var$encodeKey(dpopKey)
                }),
            decode: async ({ dpopKey: dpopKey, ...encoded })=>({
                    ...encoded,
                    dpopKey: await $f5806d3d78b686b9$var$decodeKey(dpopKey)
                })
        });
    }
    getStateStore() {
        return this.createStore('state', {
            expiresAt: (_value)=>new Date(Date.now() + 600000),
            encode: ({ dpopKey: dpopKey, ...session })=>({
                    ...session,
                    dpopKey: $f5806d3d78b686b9$var$encodeKey(dpopKey)
                }),
            decode: async ({ dpopKey: dpopKey, ...encoded })=>({
                    ...encoded,
                    dpopKey: await $f5806d3d78b686b9$var$decodeKey(dpopKey)
                })
        });
    }
    getDpopNonceCache() {
        return this.createStore('dpopNonceCache', {
            expiresAt: (_value)=>new Date(Date.now() + 600e3),
            encode: (value)=>value,
            decode: (encoded)=>encoded
        });
    }
    getDidCache() {
        return this.createStore('didCache', {
            expiresAt: (_value)=>new Date(Date.now() + 60e3),
            encode: (value)=>value,
            decode: (encoded)=>encoded
        });
    }
    getHandleCache() {
        return this.createStore('handleCache', {
            expiresAt: (_value)=>new Date(Date.now() + 60e3),
            encode: (value)=>value,
            decode: (encoded)=>encoded
        });
    }
    getAuthorizationServerMetadataCache() {
        return this.createStore('authorizationServerMetadataCache', {
            expiresAt: (_value)=>new Date(Date.now() + 60e3),
            encode: (value)=>value,
            decode: (encoded)=>encoded
        });
    }
    getProtectedResourceMetadataCache() {
        return this.createStore('protectedResourceMetadataCache', {
            expiresAt: (_value)=>new Date(Date.now() + 60e3),
            encode: (value)=>value,
            decode: (encoded)=>encoded
        });
    }
    async cleanup() {
        const db = await $f5806d3d78b686b9$var$__classPrivateFieldGet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, "f");
        for (const name of $f5806d3d78b686b9$var$STORES)await db.transaction([
            name
        ], 'readwrite', (tx)=>tx.objectStore(name).index('expiresAt').deleteAll(IDBKeyRange.upperBound(Date.now())));
    }
    async [($f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise = new WeakMap(), $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval = new WeakMap(), Symbol.asyncDispose)]() {
        clearInterval($f5806d3d78b686b9$var$__classPrivateFieldGet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval, "f"));
        $f5806d3d78b686b9$var$__classPrivateFieldSet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_cleanupInterval, undefined, "f");
        const dbPromise = $f5806d3d78b686b9$var$__classPrivateFieldGet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, "f");
        $f5806d3d78b686b9$var$__classPrivateFieldSet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, Promise.reject(new Error('Database has been disposed')), "f");
        // Avoid "unhandled promise rejection"
        $f5806d3d78b686b9$var$__classPrivateFieldGet(this, $f5806d3d78b686b9$var$_BrowserOAuthDatabase_dbPromise, "f").catch(()=>null);
        // Spec recommends not to throw errors in dispose
        const db = await dbPromise.catch(()=>null);
        if (db) await (db[Symbol.asyncDispose] || db[Symbol.dispose]).call(db);
    }
}
module.exports.BrowserOAuthDatabase = $f5806d3d78b686b9$var$BrowserOAuthDatabase;

});
parcelRegister("kZIXW", function(module, exports) {
"use strict";
var $f48c62705f0c0a58$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f48c62705f0c0a58$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f48c62705f0c0a58$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
parcelRequire("6AwK3");

$f48c62705f0c0a58$var$__exportStar((parcelRequire("bnJpA")), module.exports);

$f48c62705f0c0a58$var$__exportStar((parcelRequire("bLaWA")), module.exports);

$f48c62705f0c0a58$var$__exportStar((parcelRequire("6u4mF")), module.exports);

$f48c62705f0c0a58$var$__exportStar((parcelRequire("95IS0")), module.exports);

});
parcelRegister("6AwK3", function(module, exports) {
"use strict";
// Code compiled with tsc supports "using" and "await using" syntax. This
// features is supported by downleveling the code to ES2017. The downleveling
// relies on `Symbol.dispose` and `Symbol.asyncDispose` symbols. These symbols
// might not be available in all environments. This package provides a polyfill
// for these symbols.
// @ts-expect-error
Symbol.dispose ?? (Symbol.dispose = Symbol('@@dispose'));
// @ts-expect-error
Symbol.asyncDispose ?? (Symbol.asyncDispose = Symbol('@@asyncDispose'));

});

parcelRegister("bnJpA", function(module, exports) {
"use strict";
var $849511834b38a66e$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $849511834b38a66e$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $849511834b38a66e$var$_DB_db;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DB = void 0;

var $95IS0 = parcelRequire("95IS0");
class $849511834b38a66e$var$DB {
    static async open(dbName, migrations, txOptions) {
        const db = await new Promise((resolve, reject)=>{
            const request = indexedDB.open(dbName, migrations.length);
            request.onerror = ()=>reject(request.error);
            request.onsuccess = ()=>resolve(request.result);
            request.onupgradeneeded = ({ oldVersion: oldVersion, newVersion: newVersion })=>{
                const db = request.result;
                try {
                    for(let version = oldVersion; version < (newVersion ?? migrations.length); ++version){
                        const migration = migrations[version];
                        if (migration) migration(db);
                        else throw new Error(`Missing migration for version ${version}`);
                    }
                } catch (err) {
                    db.close();
                    reject(err);
                }
            };
        });
        return new $849511834b38a66e$var$DB(db, txOptions);
    }
    constructor(db, txOptions){
        Object.defineProperty(this, "txOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: txOptions
        });
        $849511834b38a66e$var$_DB_db.set(this, void 0);
        $849511834b38a66e$var$__classPrivateFieldSet(this, $849511834b38a66e$var$_DB_db, db, "f");
        const cleanup = ()=>{
            $849511834b38a66e$var$__classPrivateFieldSet(this, $849511834b38a66e$var$_DB_db, null, "f");
            db.removeEventListener('versionchange', cleanup);
            db.removeEventListener('close', cleanup);
            db.close(); // Can we call close on a "closed" database?
        };
        db.addEventListener('versionchange', cleanup);
        db.addEventListener('close', cleanup);
    }
    get db() {
        if (!$849511834b38a66e$var$__classPrivateFieldGet(this, $849511834b38a66e$var$_DB_db, "f")) throw new Error('Database closed');
        return $849511834b38a66e$var$__classPrivateFieldGet(this, $849511834b38a66e$var$_DB_db, "f");
    }
    get name() {
        return this.db.name;
    }
    get objectStoreNames() {
        return this.db.objectStoreNames;
    }
    get version() {
        return this.db.version;
    }
    async transaction(storeNames, mode, run) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject)=>{
            try {
                const tx = this.db.transaction(storeNames, mode, this.txOptions);
                let result = {
                    done: false
                };
                tx.oncomplete = ()=>{
                    if (result.done) resolve(result.value);
                    else reject(new Error('Transaction completed without result'));
                };
                tx.onerror = ()=>reject(tx.error);
                tx.onabort = ()=>reject(tx.error || new Error('Transaction aborted'));
                try {
                    const value = await run(new $95IS0.DBTransaction(tx));
                    result = {
                        done: true,
                        value: value
                    };
                    tx.commit();
                } catch (err) {
                    tx.abort();
                    throw err;
                }
            } catch (err) {
                reject(err);
            }
        });
    }
    close() {
        const { db: db } = this;
        $849511834b38a66e$var$__classPrivateFieldSet(this, $849511834b38a66e$var$_DB_db, null, "f");
        db.close();
    }
    [($849511834b38a66e$var$_DB_db = new WeakMap(), Symbol.dispose)]() {
        if ($849511834b38a66e$var$__classPrivateFieldGet(this, $849511834b38a66e$var$_DB_db, "f")) return this.close();
    }
}
module.exports.DB = $849511834b38a66e$var$DB;

});
parcelRegister("95IS0", function(module, exports) {
"use strict";
var $69e762f62ba077bf$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $69e762f62ba077bf$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $69e762f62ba077bf$var$_DBTransaction_tx;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DBTransaction = void 0;

var $6u4mF = parcelRequire("6u4mF");
class $69e762f62ba077bf$var$DBTransaction {
    constructor(tx){
        $69e762f62ba077bf$var$_DBTransaction_tx.set(this, void 0);
        $69e762f62ba077bf$var$__classPrivateFieldSet(this, $69e762f62ba077bf$var$_DBTransaction_tx, tx, "f");
        const onAbort = ()=>{
            cleanup();
        };
        const onComplete = ()=>{
            cleanup();
        };
        const cleanup = ()=>{
            $69e762f62ba077bf$var$__classPrivateFieldSet(this, $69e762f62ba077bf$var$_DBTransaction_tx, null, "f");
            tx.removeEventListener('abort', onAbort);
            tx.removeEventListener('complete', onComplete);
        };
        tx.addEventListener('abort', onAbort);
        tx.addEventListener('complete', onComplete);
    }
    get tx() {
        if (!$69e762f62ba077bf$var$__classPrivateFieldGet(this, $69e762f62ba077bf$var$_DBTransaction_tx, "f")) throw new Error('Transaction already ended');
        return $69e762f62ba077bf$var$__classPrivateFieldGet(this, $69e762f62ba077bf$var$_DBTransaction_tx, "f");
    }
    async abort() {
        const { tx: tx } = this;
        $69e762f62ba077bf$var$__classPrivateFieldSet(this, $69e762f62ba077bf$var$_DBTransaction_tx, null, "f");
        tx.abort();
    }
    async commit() {
        const { tx: tx } = this;
        $69e762f62ba077bf$var$__classPrivateFieldSet(this, $69e762f62ba077bf$var$_DBTransaction_tx, null, "f");
        tx.commit?.();
    }
    objectStore(name) {
        const store = this.tx.objectStore(name);
        return new $6u4mF.DBObjectStore(store);
    }
    [($69e762f62ba077bf$var$_DBTransaction_tx = new WeakMap(), Symbol.dispose)]() {
        if ($69e762f62ba077bf$var$__classPrivateFieldGet(this, $69e762f62ba077bf$var$_DBTransaction_tx, "f")) this.commit();
    }
}
module.exports.DBTransaction = $69e762f62ba077bf$var$DBTransaction;

});
parcelRegister("6u4mF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DBObjectStore = void 0;

var $bLaWA = parcelRequire("bLaWA");

var $3yVAC = parcelRequire("3yVAC");
class $4b88ee2538b66a6f$var$DBObjectStore {
    constructor(idbObjStore){
        Object.defineProperty(this, "idbObjStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: idbObjStore
        });
    }
    get name() {
        return this.idbObjStore.name;
    }
    index(name) {
        return new $bLaWA.DBIndex(this.idbObjStore.index(name));
    }
    get(key) {
        return (0, $3yVAC.promisify)(this.idbObjStore.get(key));
    }
    getKey(query) {
        return (0, $3yVAC.promisify)(this.idbObjStore.getKey(query));
    }
    getAll(query, count) {
        return (0, $3yVAC.promisify)(this.idbObjStore.getAll(query, count));
    }
    getAllKeys(query, count) {
        return (0, $3yVAC.promisify)(this.idbObjStore.getAllKeys(query, count));
    }
    add(value, key) {
        return (0, $3yVAC.promisify)(this.idbObjStore.add(value, key));
    }
    put(value, key) {
        return (0, $3yVAC.promisify)(this.idbObjStore.put(value, key));
    }
    delete(key) {
        return (0, $3yVAC.promisify)(this.idbObjStore.delete(key));
    }
    clear() {
        return (0, $3yVAC.promisify)(this.idbObjStore.clear());
    }
}
module.exports.DBObjectStore = $4b88ee2538b66a6f$var$DBObjectStore;

});
parcelRegister("bLaWA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DBIndex = void 0;

var $3yVAC = parcelRequire("3yVAC");
class $88fc92c22f0674d7$var$DBIndex {
    constructor(idbIndex){
        Object.defineProperty(this, "idbIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: idbIndex
        });
    }
    count(query) {
        return (0, $3yVAC.promisify)(this.idbIndex.count(query));
    }
    get(query) {
        return (0, $3yVAC.promisify)(this.idbIndex.get(query));
    }
    getKey(query) {
        return (0, $3yVAC.promisify)(this.idbIndex.getKey(query));
    }
    getAll(query, count) {
        return (0, $3yVAC.promisify)(this.idbIndex.getAll(query, count));
    }
    getAllKeys(query, count) {
        return (0, $3yVAC.promisify)(this.idbIndex.getAllKeys(query, count));
    }
    deleteAll(query) {
        return new Promise((resolve, reject)=>{
            const result = this.idbIndex.openCursor(query);
            result.onsuccess = function(event) {
                const cursor = event.target.result;
                if (cursor) {
                    cursor.delete();
                    cursor.continue();
                } else resolve();
            };
            result.onerror = function(event) {
                reject(event.target?.error || new Error('Unexpected error'));
            };
        });
    }
}
module.exports.DBIndex = $88fc92c22f0674d7$var$DBIndex;

});
parcelRegister("3yVAC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.promisify = module.exports.handleRequest = void 0;
function $2981382c10919bdc$var$handleRequest(request, onSuccess, onError) {
    const cleanup = ()=>{
        request.removeEventListener('success', success);
        request.removeEventListener('error', error);
    };
    const success = ()=>{
        onSuccess(request.result);
        cleanup();
    };
    const error = ()=>{
        onError(request.error || new Error('Unknown error'));
        cleanup();
    };
    request.addEventListener('success', success);
    request.addEventListener('error', error);
}
module.exports.handleRequest = $2981382c10919bdc$var$handleRequest;
function $2981382c10919bdc$var$promisify(request) {
    return new Promise((resolve, reject)=>{
        $2981382c10919bdc$var$handleRequest(request, resolve, reject);
    });
}
module.exports.promisify = $2981382c10919bdc$var$promisify;

});







parcelRegister("20NiT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserRuntimeImplementation = void 0;

var $h3MMF = parcelRequire("h3MMF");
/**
 * @see {@link // https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request}
 */ const $1771d387fe46e6bc$var$nativeRequestLock = navigator.locks?.request ? (name, fn)=>navigator.locks.request(name, {
        mode: 'exclusive'
    }, async ()=>fn()) : undefined;
class $1771d387fe46e6bc$var$BrowserRuntimeImplementation {
    constructor(){
        Object.defineProperty(this, "requestLock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $1771d387fe46e6bc$var$nativeRequestLock
        });
        if (typeof crypto !== 'object' || !crypto?.subtle) throw new Error('Crypto with CryptoSubtle is required. If running in a browser, make sure the current page is loaded over HTTPS.');
        if (!this.requestLock) // There is no real need to polyfill this on older browsers. Indeed, the
        // oauth-client library will try and recover from concurrency issues when
        // refreshing tokens.
        console.warn('Locks API not available. You should consider using a more recent browser.');
    }
    async createKey(algs) {
        return $h3MMF.WebcryptoKey.generate(algs);
    }
    getRandomValues(byteLength) {
        return crypto.getRandomValues(new Uint8Array(byteLength));
    }
    async digest(data, { name: name }) {
        switch(name){
            case 'sha256':
            case 'sha384':
            case 'sha512':
                {
                    const buf = await crypto.subtle.digest(`SHA-${name.slice(3)}`, data);
                    return new Uint8Array(buf);
                }
            default:
                throw new Error(`Unsupported digest algorithm: ${name}`);
        }
    }
}
module.exports.BrowserRuntimeImplementation = $1771d387fe46e6bc$var$BrowserRuntimeImplementation;

});

parcelRegister("51ST3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoginContinuedInParentWindowError = void 0;
/**
 * Special error class destined to be thrown when the login process was
 * performed in a popup and should be continued in the parent/initiating window.
 */ class $3a979f2a0e419d70$var$LoginContinuedInParentWindowError extends Error {
    constructor(){
        super('Login complete, please close the popup window.');
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'LOGIN_CONTINUED_IN_PARENT_WINDOW'
        });
    }
}
module.exports.LoginContinuedInParentWindowError = $3a979f2a0e419d70$var$LoginContinuedInParentWindowError;

});

parcelRegister("4B1hY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildLoopbackClientId = void 0;

var $auA9I = parcelRequire("auA9I");
/**
 * @example
 * ```ts
 * const clientId = buildLoopbackClientId(window.location)
 * ```
 */ function $358b9e0f3e39cebe$var$buildLoopbackClientId(location, localhost = '127.0.0.1') {
    if (!(0, $auA9I.isLoopbackHost)(location.hostname)) throw new TypeError(`Expected a loopback host, got ${location.hostname}`);
    const redirectUri = `http://${location.hostname === 'localhost' ? localhost : location.hostname}${location.port && !location.port.startsWith(':') ? `:${location.port}` : location.port}${location.pathname}`;
    return `http://localhost${location.pathname === '/' ? '' : location.pathname}?redirect_uri=${encodeURIComponent(redirectUri)}`;
}
module.exports.buildLoopbackClientId = $358b9e0f3e39cebe$var$buildLoopbackClientId;

});


class $0c49926af059baba$export$2e2bcd8739ae039 {
    static YEARS_IN_SECONDS = 31536000;
    static DAYS_IN_SECONDS = 86400;
    static HOURS_IN_SECONDS = 3600;
    static MINUTES_IN_SECONDS = 60;
    static ageFormatter = (origin)=>{
        const difference = this.distanceFromCurrentInSeconds(Date.parse(origin));
        if (difference > this.YEARS_IN_SECONDS) {
            const newCalc = Math.floor(difference / this.YEARS_IN_SECONDS);
            return this.isMultipleOf(newCalc) ? newCalc + " years" : newCalc + " year";
        } else if (difference >= this.DAYS_IN_SECONDS) {
            const newCalc = Math.floor(difference / this.DAYS_IN_SECONDS);
            return this.isMultipleOf(newCalc) ? newCalc + " days" : newCalc + " day";
        } else if (difference >= this.HOURS_IN_SECONDS) {
            const newCalc = Math.floor(difference / this.HOURS_IN_SECONDS);
            return this.isMultipleOf(newCalc) ? newCalc + " hours" : newCalc + " hour";
        } else if (difference >= this.MINUTES_IN_SECONDS) {
            const newCalc = Math.floor(difference / this.MINUTES_IN_SECONDS);
            return this.isMultipleOf(newCalc) ? newCalc + " minutes" : newCalc + " minute";
        } else return this.isMultipleOf(difference) ? difference + " seconds" : difference + " second";
    };
    static isMultipleOf = (recurrence)=>{
        if (recurrence >= 2) return true;
    };
    static distanceFromCurrentInSeconds = (origin)=>{
        return Math.floor((Date.now() - origin) / 1000);
    };
}


const $d8c9604b13bbb64c$var$Post = (record, isSnippet)=>{
    if (!record.post) return "";
    const postDate = isSnippet ? (0, $0c49926af059baba$export$2e2bcd8739ae039).ageFormatter(record.post.record.createdAt) : "";
    return `
        <div style="display: flex; flex-direction: column;">
            <p>${record.post.uri}</p>
            <div>
                <div style="display: flex; gap: 1rem; justify-content: space-between;">
                    <div style="display: flex; gap: 1rem; align-items: center;">
                        ${record.post.author.avatar != undefined ? '<img src="' + record.post.author.avatar + '" width="40" height="40">' : ""}
                        <div style="display: flex; flex-direction: column;">
                            ${record.post.author.displayName != undefined ? '<strong>' + record.post.author.displayName + '</strong>' : ""}
                            <div>@${record.post.author.handle}</div>
                        </div>
                    </div>
                    <div>
                        ${isSnippet ? '<p title="' + new Date(record.post.record.createdAt) + '">' + postDate + ' ago</p>' : ""}
                    </div>
                </div>
            </div>
            ${record.post.record.text != undefined ? '<p>' + record.post.record.text + '</p>' : ""}
            ${record.post.embed != undefined ? `<strong>Embed in post.</strong>` : ""}
            <div style="display: flex; gap: 1rem">
                <p>Comments: <strong>${record.post.replyCount}</strong></p>
                <p>Reposts: <strong>${record.post.repostCount}</strong></p>
                <p>Quotes: <strong>${record.post.quoteCount}</strong></p>
                <p>Likes: <strong>${record.post.likeCount}</strong></p>
            </div>
        </div>
    `;
};
var $d8c9604b13bbb64c$export$2e2bcd8739ae039 = $d8c9604b13bbb64c$var$Post;


var $d349326c2b62c55f$exports = {};
/*! @license DOMPurify 3.2.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.5/LICENSE */ (function(global, factory) {
    $d349326c2b62c55f$exports = factory();
})($d349326c2b62c55f$exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.2.5';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === 'value' ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


class $9809423ed41a5bb9$export$2e2bcd8739ae039 {
    static noAgent = `
        <p>You are not logged in!</p>
    `;
    static title = "lightweight";
    static titleDelimiter = " - ";
    static authedPages = [
        "/",
        "/rooms",
        "/notifications",
        "/callback"
    ];
    static main = async (agent)=>{
        const content = document.getElementById("content");
        const pageTitle = document.getElementsByTagName("title")[0];
        const route = document.location.pathname;
        const param = document.location.search;
        const hash = document.location.hash;
        var authedPage = false;
        for (const page of this.authedPages)if (page == route) authedPage = true;
        if (authedPage == true && agent == null) {
            content.innerHTML = this.noAgent;
            return;
        }
        if (route == "/") content.innerHTML = await agent.getTimeline().then((r)=>JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize(JSON.stringify(r))).data.feed.map((item)=>(0, $d8c9604b13bbb64c$export$2e2bcd8739ae039)(item, true)).join("<hr>"));
        else if (route == "/rooms" || route == "/notifications") {
            pageTitle.innerHTML = this.title + this.titleDelimiter + "Construction Zone";
            content.innerHTML = "This feature is not yet implemented.";
        } else if (route == "/about") {
            pageTitle.innerHTML = this.title + this.titleDelimiter + "About";
            content.innerHTML = `
                <h3>About</h3>
                <p>lightweight is a minimalistic AT Proto wrapper.</p>
                <p>Its objective is to use as little code as possible to wrap the lexicon.</p>
                <br>
                <h3>Maintainers</h3>
                <a href="https://amazingca.dev" target="_blank">@autumn.bsky.gay</a>
            `;
        } else if (route == "/acknowledgments") {
            pageTitle.innerHTML = this.title + this.titleDelimiter + "Acknowledgments";
            content.innerHTML = `
                <h3>Acknowledgments</h3>
                <p>lightweight is in a local-intended beta that uses these libraries:</p>
                <br>
                <h4>JetBrains</h4>
                <a href="https://github.com/JetBrains/JetBrainsMono" target="_blank" class="link">JetBrains Mono</a>
                <br>
                <br>
                <h4>Parcel Bundler</h4>
                <a href="https://github.com/parcel-bundler/parcel" target="_blank" class="link">Parcel</a>
                <br>
                <br>
                <h4>Bluesky Social</h4>
                <a href="https://github.com/bluesky-social/atproto" target="_blank" class="link">AT Protocol</a>
                <br>
                <br>
                <h3>Honorable Mentions</h3>
                <a href="https://atproto.com/community/projects" target="_blank" class="link">ATP Dev Community</a>
            `;
        } else if (route == "/callback") content.innerHTML = `
                <p>Successfully logged in as @${await agent.getProfile({
            actor: agent.did
        }).then((r)=>(0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize(r.data.handle))}</p>
            `;
        else {
            pageTitle.textContent = this.title + this.titleDelimiter + "404";
            content.innerHTML = "<strong>404</strong> Not found";
        }
    };
}


var $b7ba13108be67195$exports = {};
"use strict";
var $b7ba13108be67195$var$__createBinding = $b7ba13108be67195$exports && $b7ba13108be67195$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b7ba13108be67195$var$__exportStar = $b7ba13108be67195$exports && $b7ba13108be67195$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b7ba13108be67195$var$__createBinding(exports1, m, p);
};
Object.defineProperty($b7ba13108be67195$exports, "__esModule", {
    value: true
});
$b7ba13108be67195$exports.lexicons = $b7ba13108be67195$exports.default = $b7ba13108be67195$exports.BskyAgent = $b7ba13108be67195$exports.CredentialSession = $b7ba13108be67195$exports.AtpAgent = $b7ba13108be67195$exports.Agent = $b7ba13108be67195$exports.LABELS = $b7ba13108be67195$exports.DEFAULT_LABEL_SETTINGS = $b7ba13108be67195$exports.schemas = $b7ba13108be67195$exports.parseLanguage = $b7ba13108be67195$exports.stringifyLex = $b7ba13108be67195$exports.lexToJson = $b7ba13108be67195$exports.jsonToLex = $b7ba13108be67195$exports.jsonStringToLex = $b7ba13108be67195$exports.BlobRef = $b7ba13108be67195$exports.AtUri = void 0;

var $3dCVT = parcelRequire("3dCVT");

var $8DB7o = parcelRequire("8DB7o");

var $UiDXP = parcelRequire("UiDXP");
Object.defineProperty($b7ba13108be67195$exports, "AtUri", {
    enumerable: true,
    get: function() {
        return $UiDXP.AtUri;
    }
});

var $3dCVT = parcelRequire("3dCVT");
Object.defineProperty($b7ba13108be67195$exports, "BlobRef", {
    enumerable: true,
    get: function() {
        return $3dCVT.BlobRef;
    }
});
Object.defineProperty($b7ba13108be67195$exports, "jsonStringToLex", {
    enumerable: true,
    get: function() {
        return $3dCVT.jsonStringToLex;
    }
});
Object.defineProperty($b7ba13108be67195$exports, "jsonToLex", {
    enumerable: true,
    get: function() {
        return $3dCVT.jsonToLex;
    }
});
Object.defineProperty($b7ba13108be67195$exports, "lexToJson", {
    enumerable: true,
    get: function() {
        return $3dCVT.lexToJson;
    }
});
Object.defineProperty($b7ba13108be67195$exports, "stringifyLex", {
    enumerable: true,
    get: function() {
        return $3dCVT.stringifyLex;
    }
});

var $bc6Ix = parcelRequire("bc6Ix");
Object.defineProperty($b7ba13108be67195$exports, "parseLanguage", {
    enumerable: true,
    get: function() {
        return $bc6Ix.parseLanguage;
    }
});

$b7ba13108be67195$var$__exportStar((parcelRequire("gAO5y")), $b7ba13108be67195$exports);

$b7ba13108be67195$var$__exportStar((parcelRequire("hPpei")), $b7ba13108be67195$exports);

$b7ba13108be67195$var$__exportStar((parcelRequire("bjLh7")), $b7ba13108be67195$exports);

$b7ba13108be67195$var$__exportStar((parcelRequire("2wqOO")), $b7ba13108be67195$exports);

var $8DB7o = parcelRequire("8DB7o");
Object.defineProperty($b7ba13108be67195$exports, "schemas", {
    enumerable: true,
    get: function() {
        return $8DB7o.schemas;
    }
});

$b7ba13108be67195$var$__exportStar((parcelRequire("hPzsQ")), $b7ba13108be67195$exports);

$b7ba13108be67195$var$__exportStar((parcelRequire("gRg7n")), $b7ba13108be67195$exports);

$b7ba13108be67195$var$__exportStar((parcelRequire("f8MrZ")), $b7ba13108be67195$exports);

$b7ba13108be67195$var$__exportStar((parcelRequire("lbDJ5")), $b7ba13108be67195$exports);

$b7ba13108be67195$var$__exportStar((parcelRequire("3Dbjc")), $b7ba13108be67195$exports);

$b7ba13108be67195$var$__exportStar((parcelRequire("6pyjK")), $b7ba13108be67195$exports);

$b7ba13108be67195$var$__exportStar((parcelRequire("lV5Zn")), $b7ba13108be67195$exports);

var $fAi2h = parcelRequire("fAi2h");
Object.defineProperty($b7ba13108be67195$exports, "DEFAULT_LABEL_SETTINGS", {
    enumerable: true,
    get: function() {
        return $fAi2h.DEFAULT_LABEL_SETTINGS;
    }
});
Object.defineProperty($b7ba13108be67195$exports, "LABELS", {
    enumerable: true,
    get: function() {
        return $fAi2h.LABELS;
    }
});
var $bf8bc4cd44d3126a$exports = {};
"use strict";
var $bf8bc4cd44d3126a$var$__classPrivateFieldGet = $bf8bc4cd44d3126a$exports && $bf8bc4cd44d3126a$exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $bf8bc4cd44d3126a$var$__importDefault = $bf8bc4cd44d3126a$exports && $bf8bc4cd44d3126a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $bf8bc4cd44d3126a$var$_Agent_prefsLock;
Object.defineProperty($bf8bc4cd44d3126a$exports, "__esModule", {
    value: true
});
$bf8bc4cd44d3126a$exports.Agent = void 0;

const $bf8bc4cd44d3126a$var$await_lock_1 = $bf8bc4cd44d3126a$var$__importDefault((parcelRequire("8rHSu")));

var $bc6Ix = parcelRequire("bc6Ix");

var $UiDXP = parcelRequire("UiDXP");

var $al5Ta = parcelRequire("al5Ta");

var $2wqOO = parcelRequire("2wqOO");

var $8DB7o = parcelRequire("8DB7o");

var $hPpei = parcelRequire("hPpei");

var $3Dbjc = parcelRequire("3Dbjc");

var $fAi2h = parcelRequire("fAi2h");

var $bjLh7 = parcelRequire("bjLh7");
const $bf8bc4cd44d3126a$var$FEED_VIEW_PREF_DEFAULTS = {
    hideReplies: false,
    hideRepliesByUnfollowed: true,
    hideRepliesByLikeCount: 0,
    hideReposts: false,
    hideQuotePosts: false
};
const $bf8bc4cd44d3126a$var$THREAD_VIEW_PREF_DEFAULTS = {
    sort: 'hotness',
    prioritizeFollowedUsers: true
};
/**
 * An {@link Agent} is an {@link AtpBaseClient} with the following
 * additional features:
 * - AT Protocol labelers configuration utilities
 * - AT Protocol proxy configuration utilities
 * - Cloning utilities
 * - `app.bsky` syntactic sugar
 * - `com.atproto` syntactic sugar
 */ class $bf8bc4cd44d3126a$var$Agent extends $al5Ta.XrpcClient {
    /**
     * Configures the Agent (or its sub classes) globally.
     */ static configure(opts) {
        if (opts.appLabelers) this.appLabelers = opts.appLabelers.map($bjLh7.asDid); // Validate & copy
    }
    /** @deprecated use `this` instead */ get xrpc() {
        return this;
    }
    constructor(options){
        const sessionManager = typeof options === 'string' || options instanceof URL ? {
            did: undefined,
            fetchHandler: (0, $al5Ta.buildFetchHandler)(options)
        } : options;
        super((url, init)=>{
            const headers = new Headers(init?.headers);
            if (this.proxy && !headers.has('atproto-proxy')) headers.set('atproto-proxy', this.proxy);
            // Merge the labelers header of this particular request with the app &
            // instance labelers.
            headers.set('atproto-accept-labelers', [
                ...this.appLabelers.map((l)=>`${l};redact`),
                ...this.labelers,
                headers.get('atproto-accept-labelers')?.trim()
            ].filter(Boolean).join(', '));
            return this.sessionManager.fetchHandler(url, {
                ...init,
                headers: headers
            });
        }, $8DB7o.schemas);
        //#endregion
        Object.defineProperty(this, "com", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new $2wqOO.ComNS(this)
        });
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new $2wqOO.AppNS(this)
        });
        Object.defineProperty(this, "chat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new $2wqOO.ChatNS(this)
        });
        Object.defineProperty(this, "tools", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new $2wqOO.ToolsNS(this)
        });
        Object.defineProperty(this, "sessionManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "labelers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        //#endregion
        //#region ATPROTO proxy configuration utilities
        Object.defineProperty(this, "proxy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        //#region "com.atproto" lexicon short hand methods
        /**
         * Upload a binary blob to the server
         */ Object.defineProperty(this, "uploadBlob", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data, opts)=>this.com.atproto.repo.uploadBlob(data, opts)
        });
        /**
         * Resolve a handle to a DID
         */ Object.defineProperty(this, "resolveHandle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.com.atproto.identity.resolveHandle(params, opts)
        });
        /**
         * Change the user's handle
         */ Object.defineProperty(this, "updateHandle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data, opts)=>this.com.atproto.identity.updateHandle(data, opts)
        });
        /**
         * Create a moderation report
         */ Object.defineProperty(this, "createModerationReport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data, opts)=>this.com.atproto.moderation.createReport(data, opts)
        });
        //#endregion
        //#region "app.bsky" lexicon short hand methods
        Object.defineProperty(this, "getTimeline", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getTimeline(params, opts)
        });
        Object.defineProperty(this, "getAuthorFeed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getAuthorFeed(params, opts)
        });
        Object.defineProperty(this, "getActorLikes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getActorLikes(params, opts)
        });
        Object.defineProperty(this, "getPostThread", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getPostThread(params, opts)
        });
        Object.defineProperty(this, "getPost", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params)=>this.app.bsky.feed.post.get(params)
        });
        Object.defineProperty(this, "getPosts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getPosts(params, opts)
        });
        Object.defineProperty(this, "getLikes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getLikes(params, opts)
        });
        Object.defineProperty(this, "getRepostedBy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getRepostedBy(params, opts)
        });
        Object.defineProperty(this, "getFollows", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.graph.getFollows(params, opts)
        });
        Object.defineProperty(this, "getFollowers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.graph.getFollowers(params, opts)
        });
        Object.defineProperty(this, "getProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.actor.getProfile(params, opts)
        });
        Object.defineProperty(this, "getProfiles", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.actor.getProfiles(params, opts)
        });
        Object.defineProperty(this, "getSuggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.actor.getSuggestions(params, opts)
        });
        Object.defineProperty(this, "searchActors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.actor.searchActors(params, opts)
        });
        Object.defineProperty(this, "searchActorsTypeahead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.actor.searchActorsTypeahead(params, opts)
        });
        Object.defineProperty(this, "listNotifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.notification.listNotifications(params, opts)
        });
        Object.defineProperty(this, "countUnreadNotifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.notification.getUnreadCount(params, opts)
        });
        Object.defineProperty(this, "getLabelers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.labeler.getServices(params, opts)
        });
        //- Private methods
        $bf8bc4cd44d3126a$var$_Agent_prefsLock.set(this, new $bf8bc4cd44d3126a$var$await_lock_1.default());
        this.sessionManager = sessionManager;
    }
    //#region Cloning utilities
    clone() {
        return this.copyInto(new $bf8bc4cd44d3126a$var$Agent(this.sessionManager));
    }
    copyInto(inst) {
        inst.configureLabelers(this.labelers);
        inst.configureProxy(this.proxy ?? null);
        inst.clearHeaders();
        for (const [key, value] of this.headers)inst.setHeader(key, value);
        return inst;
    }
    withProxy(serviceType, did) {
        const inst = this.clone();
        inst.configureProxy(`${(0, $bjLh7.asDid)(did)}#${serviceType}`);
        return inst;
    }
    //#endregion
    //#region ATPROTO labelers configuration utilities
    /**
     * The labelers statically configured on the class of the current instance.
     */ get appLabelers() {
        return this.constructor.appLabelers;
    }
    configureLabelers(labelerDids) {
        this.labelers = labelerDids.map($bjLh7.asDid); // Validate & copy
    }
    /** @deprecated use {@link configureLabelers} instead */ configureLabelersHeader(labelerDids) {
        // Filtering non-did values for backwards compatibility
        this.configureLabelers(labelerDids.filter($bjLh7.isDid));
    }
    configureProxy(value) {
        if (value === null) this.proxy = undefined;
        else if ((0, $bjLh7.isDid)(value)) this.proxy = value;
        else throw new TypeError('Invalid proxy DID');
    }
    /** @deprecated use {@link configureProxy} instead */ configureProxyHeader(serviceType, did) {
        // Ignoring non-did values for backwards compatibility
        if ((0, $bjLh7.isDid)(did)) this.configureProxy(`${did}#${serviceType}`);
    }
    //#endregion
    //#region Session management
    /**
     * Get the authenticated user's DID, if any.
     */ get did() {
        return this.sessionManager.did;
    }
    /** @deprecated Use {@link Agent.assertDid} instead */ get accountDid() {
        return this.assertDid;
    }
    /**
     * Get the authenticated user's DID, or throw an error if not authenticated.
     */ get assertDid() {
        this.assertAuthenticated();
        return this.did;
    }
    /**
     * Assert that the user is authenticated.
     */ assertAuthenticated() {
        if (!this.did) throw new Error('Not logged in');
    }
    //#endregion
    /** @deprecated use "this" instead */ get api() {
        return this;
    }
    async getLabelDefinitions(prefs) {
        // collect the labeler dids
        const dids = [
            ...this.appLabelers
        ];
        if ($bf8bc4cd44d3126a$var$isBskyPrefs(prefs)) dids.push(...prefs.moderationPrefs.labelers.map((l)=>l.did));
        else if ($bf8bc4cd44d3126a$var$isModPrefs(prefs)) dids.push(...prefs.labelers.map((l)=>l.did));
        else dids.push(...prefs);
        // fetch their definitions
        const labelers = await this.getLabelers({
            dids: dids,
            detailed: true
        });
        // assemble a map of labeler dids to the interpreted label value definitions
        const labelDefs = {};
        if (labelers.data) for (const labeler of labelers.data.views)labelDefs[labeler.creator.did] = (0, $3Dbjc.interpretLabelValueDefinitions)(labeler);
        return labelDefs;
    }
    async post(record) {
        record.createdAt || (record.createdAt = new Date().toISOString());
        return this.app.bsky.feed.post.create({
            repo: this.accountDid
        }, record);
    }
    async deletePost(postUri) {
        this.assertAuthenticated();
        const postUrip = new $UiDXP.AtUri(postUri);
        return this.app.bsky.feed.post.delete({
            repo: postUrip.hostname,
            rkey: postUrip.rkey
        });
    }
    async like(uri, cid) {
        return this.app.bsky.feed.like.create({
            repo: this.accountDid
        }, {
            subject: {
                uri: uri,
                cid: cid
            },
            createdAt: new Date().toISOString()
        });
    }
    async deleteLike(likeUri) {
        this.assertAuthenticated();
        const likeUrip = new $UiDXP.AtUri(likeUri);
        return this.app.bsky.feed.like.delete({
            repo: likeUrip.hostname,
            rkey: likeUrip.rkey
        });
    }
    async repost(uri, cid) {
        return this.app.bsky.feed.repost.create({
            repo: this.accountDid
        }, {
            subject: {
                uri: uri,
                cid: cid
            },
            createdAt: new Date().toISOString()
        });
    }
    async deleteRepost(repostUri) {
        this.assertAuthenticated();
        const repostUrip = new $UiDXP.AtUri(repostUri);
        return this.app.bsky.feed.repost.delete({
            repo: repostUrip.hostname,
            rkey: repostUrip.rkey
        });
    }
    async follow(subjectDid) {
        return this.app.bsky.graph.follow.create({
            repo: this.accountDid
        }, {
            subject: subjectDid,
            createdAt: new Date().toISOString()
        });
    }
    async deleteFollow(followUri) {
        this.assertAuthenticated();
        const followUrip = new $UiDXP.AtUri(followUri);
        return this.app.bsky.graph.follow.delete({
            repo: followUrip.hostname,
            rkey: followUrip.rkey
        });
    }
    async upsertProfile(updateFn) {
        const repo = this.accountDid;
        let retriesRemaining = 5;
        while(retriesRemaining >= 0){
            // fetch existing
            const existing = await this.com.atproto.repo.getRecord({
                repo: repo,
                collection: 'app.bsky.actor.profile',
                rkey: 'self'
            }).catch((_)=>undefined);
            // run the update
            const updated = await updateFn(existing?.data.value);
            if (updated) updated.$type = 'app.bsky.actor.profile';
            // validate the record
            const validation = $2wqOO.AppBskyActorProfile.validateRecord(updated);
            if (!validation.success) throw validation.error;
            try {
                // attempt the put
                await this.com.atproto.repo.putRecord({
                    repo: repo,
                    collection: 'app.bsky.actor.profile',
                    rkey: 'self',
                    record: updated,
                    swapRecord: existing?.data.cid || null
                });
            } catch (e) {
                if (retriesRemaining > 0 && e instanceof $2wqOO.ComAtprotoRepoPutRecord.InvalidSwapError) {
                    // try again
                    retriesRemaining--;
                    continue;
                } else throw e;
            }
            break;
        }
    }
    async mute(actor) {
        return this.app.bsky.graph.muteActor({
            actor: actor
        });
    }
    async unmute(actor) {
        return this.app.bsky.graph.unmuteActor({
            actor: actor
        });
    }
    async muteModList(uri) {
        return this.app.bsky.graph.muteActorList({
            list: uri
        });
    }
    async unmuteModList(uri) {
        return this.app.bsky.graph.unmuteActorList({
            list: uri
        });
    }
    async blockModList(uri) {
        return this.app.bsky.graph.listblock.create({
            repo: this.accountDid
        }, {
            subject: uri,
            createdAt: new Date().toISOString()
        });
    }
    async unblockModList(uri) {
        const repo = this.accountDid;
        const listInfo = await this.app.bsky.graph.getList({
            list: uri,
            limit: 1
        });
        const blocked = listInfo.data.list.viewer?.blocked;
        if (blocked) {
            const { rkey: rkey } = new $UiDXP.AtUri(blocked);
            return this.app.bsky.graph.listblock.delete({
                repo: repo,
                rkey: rkey
            });
        }
    }
    async updateSeenNotifications(seenAt = new Date().toISOString()) {
        return this.app.bsky.notification.updateSeen({
            seenAt: seenAt
        });
    }
    async getPreferences() {
        const prefs = {
            feeds: {
                saved: undefined,
                pinned: undefined
            },
            // @ts-ignore populating below
            savedFeeds: undefined,
            feedViewPrefs: {
                home: {
                    ...$bf8bc4cd44d3126a$var$FEED_VIEW_PREF_DEFAULTS
                }
            },
            threadViewPrefs: {
                ...$bf8bc4cd44d3126a$var$THREAD_VIEW_PREF_DEFAULTS
            },
            moderationPrefs: {
                adultContentEnabled: false,
                labels: {
                    ...$fAi2h.DEFAULT_LABEL_SETTINGS
                },
                labelers: this.appLabelers.map((did)=>({
                        did: did,
                        labels: {}
                    })),
                mutedWords: [],
                hiddenPosts: []
            },
            birthDate: undefined,
            interests: {
                tags: []
            },
            bskyAppState: {
                queuedNudges: [],
                activeProgressGuide: undefined,
                nuxs: []
            },
            postInteractionSettings: {
                threadgateAllowRules: undefined,
                postgateEmbeddingRules: undefined
            }
        };
        const res = await this.app.bsky.actor.getPreferences({});
        const labelPrefs = [];
        for (const pref of res.data.preferences){
            if ($2wqOO.AppBskyActorDefs.isAdultContentPref(pref) && $2wqOO.AppBskyActorDefs.validateAdultContentPref(pref).success) // adult content preferences
            prefs.moderationPrefs.adultContentEnabled = pref.enabled;
            else if ($2wqOO.AppBskyActorDefs.isContentLabelPref(pref) && $2wqOO.AppBskyActorDefs.validateContentLabelPref(pref).success) {
                // content label preference
                const adjustedPref = $bf8bc4cd44d3126a$var$adjustLegacyContentLabelPref(pref);
                labelPrefs.push(adjustedPref);
            } else if ($2wqOO.AppBskyActorDefs.isLabelersPref(pref) && $2wqOO.AppBskyActorDefs.validateLabelersPref(pref).success) // labelers preferences
            prefs.moderationPrefs.labelers = this.appLabelers.map((did)=>({
                    did: did,
                    labels: {}
                })).concat(pref.labelers.map((labeler)=>({
                    ...labeler,
                    labels: {}
                })));
            else if ($2wqOO.AppBskyActorDefs.isSavedFeedsPrefV2(pref) && $2wqOO.AppBskyActorDefs.validateSavedFeedsPrefV2(pref).success) prefs.savedFeeds = pref.items;
            else if ($2wqOO.AppBskyActorDefs.isSavedFeedsPref(pref) && $2wqOO.AppBskyActorDefs.validateSavedFeedsPref(pref).success) {
                // saved and pinned feeds
                prefs.feeds.saved = pref.saved;
                prefs.feeds.pinned = pref.pinned;
            } else if ($2wqOO.AppBskyActorDefs.isPersonalDetailsPref(pref) && $2wqOO.AppBskyActorDefs.validatePersonalDetailsPref(pref).success) // birth date (irl)
            {
                if (pref.birthDate) prefs.birthDate = new Date(pref.birthDate);
            } else if ($2wqOO.AppBskyActorDefs.isFeedViewPref(pref) && $2wqOO.AppBskyActorDefs.validateFeedViewPref(pref).success) {
                // feed view preferences
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { $type: $type, feed: feed, ...v } = pref;
                prefs.feedViewPrefs[pref.feed] = {
                    ...$bf8bc4cd44d3126a$var$FEED_VIEW_PREF_DEFAULTS,
                    ...v
                };
            } else if ($2wqOO.AppBskyActorDefs.isThreadViewPref(pref) && $2wqOO.AppBskyActorDefs.validateThreadViewPref(pref).success) {
                // thread view preferences
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { $type: $type, ...v } = pref;
                prefs.threadViewPrefs = {
                    ...prefs.threadViewPrefs,
                    ...v
                };
            } else if ($2wqOO.AppBskyActorDefs.isInterestsPref(pref) && $2wqOO.AppBskyActorDefs.validateInterestsPref(pref).success) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { $type: $type, ...v } = pref;
                prefs.interests = {
                    ...prefs.interests,
                    ...v
                };
            } else if ($2wqOO.AppBskyActorDefs.isMutedWordsPref(pref) && $2wqOO.AppBskyActorDefs.validateMutedWordsPref(pref).success) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { $type: $type, ...v } = pref;
                prefs.moderationPrefs.mutedWords = v.items;
                if (prefs.moderationPrefs.mutedWords.length) prefs.moderationPrefs.mutedWords = prefs.moderationPrefs.mutedWords.map((word)=>{
                    word.actorTarget = word.actorTarget || 'all';
                    return word;
                });
            } else if ($2wqOO.AppBskyActorDefs.isHiddenPostsPref(pref) && $2wqOO.AppBskyActorDefs.validateHiddenPostsPref(pref).success) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { $type: $type, ...v } = pref;
                prefs.moderationPrefs.hiddenPosts = v.items;
            } else if ($2wqOO.AppBskyActorDefs.isBskyAppStatePref(pref) && $2wqOO.AppBskyActorDefs.validateBskyAppStatePref(pref).success) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { $type: $type, ...v } = pref;
                prefs.bskyAppState.queuedNudges = v.queuedNudges || [];
                prefs.bskyAppState.activeProgressGuide = v.activeProgressGuide;
                prefs.bskyAppState.nuxs = v.nuxs || [];
            } else if ($2wqOO.AppBskyActorDefs.isPostInteractionSettingsPref(pref) && $2wqOO.AppBskyActorDefs.validatePostInteractionSettingsPref(pref).success) {
                prefs.postInteractionSettings.threadgateAllowRules = pref.threadgateAllowRules;
                prefs.postInteractionSettings.postgateEmbeddingRules = pref.postgateEmbeddingRules;
            }
        }
        /*
         * If `prefs.savedFeeds` is undefined, no `savedFeedsPrefV2` exists, which
         * means we want to try to migrate if needed.
         *
         * If v1 prefs exist, they will be migrated to v2.
         *
         * If no v1 prefs exist, the user is either new, or could be old and has
         * never edited their feeds.
         */ if (prefs.savedFeeds == null) {
            const { saved: saved, pinned: pinned } = prefs.feeds;
            if (saved && pinned) {
                const uniqueMigratedSavedFeeds = new Map();
                // insert Following feed first
                uniqueMigratedSavedFeeds.set('timeline', {
                    id: $bc6Ix.TID.nextStr(),
                    type: 'timeline',
                    value: 'following',
                    pinned: true
                });
                // use pinned as source of truth for feed order
                for (const uri of pinned){
                    const type = (0, $bjLh7.getSavedFeedType)(uri);
                    // only want supported types
                    if (type === 'unknown') continue;
                    uniqueMigratedSavedFeeds.set(uri, {
                        id: $bc6Ix.TID.nextStr(),
                        type: type,
                        value: uri,
                        pinned: true
                    });
                }
                for (const uri of saved)if (!uniqueMigratedSavedFeeds.has(uri)) {
                    const type = (0, $bjLh7.getSavedFeedType)(uri);
                    // only want supported types
                    if (type === 'unknown') continue;
                    uniqueMigratedSavedFeeds.set(uri, {
                        id: $bc6Ix.TID.nextStr(),
                        type: type,
                        value: uri,
                        pinned: false
                    });
                }
                prefs.savedFeeds = Array.from(uniqueMigratedSavedFeeds.values());
            } else prefs.savedFeeds = [
                {
                    id: $bc6Ix.TID.nextStr(),
                    type: 'timeline',
                    value: 'following',
                    pinned: true
                }
            ];
            // save to user preferences so this migration doesn't re-occur
            await this.overwriteSavedFeeds(prefs.savedFeeds);
        }
        // apply the label prefs
        for (const pref of labelPrefs)if (pref.labelerDid) {
            const labeler = prefs.moderationPrefs.labelers.find((labeler)=>labeler.did === pref.labelerDid);
            if (!labeler) continue;
            labeler.labels[pref.label] = pref.visibility;
        } else prefs.moderationPrefs.labels[pref.label] = pref.visibility;
        prefs.moderationPrefs.labels = $bf8bc4cd44d3126a$var$remapLegacyLabels(prefs.moderationPrefs.labels);
        // automatically configure the client
        this.configureLabelers($bf8bc4cd44d3126a$var$prefsArrayToLabelerDids(res.data.preferences));
        return prefs;
    }
    async overwriteSavedFeeds(savedFeeds) {
        savedFeeds.forEach($bjLh7.validateSavedFeed);
        const uniqueSavedFeeds = new Map();
        savedFeeds.forEach((feed)=>{
            // remove and re-insert to preserve order
            if (uniqueSavedFeeds.has(feed.id)) uniqueSavedFeeds.delete(feed.id);
            uniqueSavedFeeds.set(feed.id, feed);
        });
        return this.updateSavedFeedsV2Preferences(()=>Array.from(uniqueSavedFeeds.values()));
    }
    async updateSavedFeeds(savedFeedsToUpdate) {
        savedFeedsToUpdate.map($bjLh7.validateSavedFeed);
        return this.updateSavedFeedsV2Preferences((savedFeeds)=>{
            return savedFeeds.map((savedFeed)=>{
                const updatedVersion = savedFeedsToUpdate.find((updated)=>savedFeed.id === updated.id);
                if (updatedVersion) return {
                    ...savedFeed,
                    // only update pinned
                    pinned: updatedVersion.pinned
                };
                return savedFeed;
            });
        });
    }
    async addSavedFeeds(savedFeeds) {
        const toSave = savedFeeds.map((f)=>({
                ...f,
                id: $bc6Ix.TID.nextStr()
            }));
        toSave.forEach($bjLh7.validateSavedFeed);
        return this.updateSavedFeedsV2Preferences((savedFeeds)=>[
                ...savedFeeds,
                ...toSave
            ]);
    }
    async removeSavedFeeds(ids) {
        return this.updateSavedFeedsV2Preferences((savedFeeds)=>[
                ...savedFeeds.filter((feed)=>!ids.find((id)=>feed.id === id))
            ]);
    }
    /**
     * @deprecated use `overwriteSavedFeeds`
     */ async setSavedFeeds(saved, pinned) {
        return this.updateFeedPreferences(()=>({
                saved: saved,
                pinned: pinned
            }));
    }
    /**
     * @deprecated use `addSavedFeeds`
     */ async addSavedFeed(v) {
        return this.updateFeedPreferences((saved, pinned)=>({
                saved: [
                    ...saved.filter((uri)=>uri !== v),
                    v
                ],
                pinned: pinned
            }));
    }
    /**
     * @deprecated use `removeSavedFeeds`
     */ async removeSavedFeed(v) {
        return this.updateFeedPreferences((saved, pinned)=>({
                saved: saved.filter((uri)=>uri !== v),
                pinned: pinned.filter((uri)=>uri !== v)
            }));
    }
    /**
     * @deprecated use `addSavedFeeds` or `updateSavedFeeds`
     */ async addPinnedFeed(v) {
        return this.updateFeedPreferences((saved, pinned)=>({
                saved: [
                    ...saved.filter((uri)=>uri !== v),
                    v
                ],
                pinned: [
                    ...pinned.filter((uri)=>uri !== v),
                    v
                ]
            }));
    }
    /**
     * @deprecated use `updateSavedFeeds` or `removeSavedFeeds`
     */ async removePinnedFeed(v) {
        return this.updateFeedPreferences((saved, pinned)=>({
                saved: saved,
                pinned: pinned.filter((uri)=>uri !== v)
            }));
    }
    async setAdultContentEnabled(v) {
        await this.updatePreferences((prefs)=>{
            let adultContentPref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isAdultContentPref(pref) && $2wqOO.AppBskyActorDefs.validateAdultContentPref(pref).success);
            if (adultContentPref) adultContentPref.enabled = v;
            else adultContentPref = {
                $type: 'app.bsky.actor.defs#adultContentPref',
                enabled: v
            };
            return prefs.filter((pref)=>!$2wqOO.AppBskyActorDefs.isAdultContentPref(pref)).concat([
                adultContentPref
            ]);
        });
    }
    async setContentLabelPref(key, value, labelerDid) {
        if (labelerDid) (0, $UiDXP.ensureValidDid)(labelerDid);
        await this.updatePreferences((prefs)=>{
            let labelPref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isContentLabelPref(pref) && $2wqOO.AppBskyActorDefs.validateContentLabelPref(pref).success && pref.label === key && pref.labelerDid === labelerDid);
            let legacyLabelPref;
            if (labelPref) labelPref.visibility = value;
            else labelPref = {
                $type: 'app.bsky.actor.defs#contentLabelPref',
                label: key,
                labelerDid: labelerDid,
                visibility: value
            };
            if ($2wqOO.AppBskyActorDefs.isContentLabelPref(labelPref)) // is global
            {
                if (!labelPref.labelerDid) {
                    const legacyLabelValue = {
                        'graphic-media': 'gore',
                        porn: 'nsfw',
                        sexual: 'suggestive'
                    }[labelPref.label];
                    // if it's a legacy label, double-write the legacy label
                    if (legacyLabelValue) {
                        legacyLabelPref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isContentLabelPref(pref) && $2wqOO.AppBskyActorDefs.validateContentLabelPref(pref).success && pref.label === legacyLabelValue && pref.labelerDid === undefined);
                        if (legacyLabelPref) legacyLabelPref.visibility = value;
                        else legacyLabelPref = {
                            $type: 'app.bsky.actor.defs#contentLabelPref',
                            label: legacyLabelValue,
                            labelerDid: undefined,
                            visibility: value
                        };
                    }
                }
            }
            return prefs.filter((pref)=>!$2wqOO.AppBskyActorDefs.isContentLabelPref(pref) || !(pref.label === key && pref.labelerDid === labelerDid)).concat([
                labelPref
            ]).filter((pref)=>{
                if (!legacyLabelPref) return true;
                return !$2wqOO.AppBskyActorDefs.isContentLabelPref(pref) || !(pref.label === legacyLabelPref.label && pref.labelerDid === undefined);
            }).concat(legacyLabelPref ? [
                legacyLabelPref
            ] : []);
        });
    }
    async addLabeler(did) {
        const prefs = await this.updatePreferences((prefs)=>{
            let labelersPref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isLabelersPref(pref) && $2wqOO.AppBskyActorDefs.validateLabelersPref(pref).success);
            if (!labelersPref) labelersPref = {
                $type: 'app.bsky.actor.defs#labelersPref',
                labelers: []
            };
            if ($2wqOO.AppBskyActorDefs.isLabelersPref(labelersPref)) {
                let labelerPrefItem = labelersPref.labelers.find((labeler)=>labeler.did === did);
                if (!labelerPrefItem) {
                    labelerPrefItem = {
                        did: did
                    };
                    labelersPref.labelers.push(labelerPrefItem);
                }
            }
            return prefs.filter((pref)=>!$2wqOO.AppBskyActorDefs.isLabelersPref(pref)).concat([
                labelersPref
            ]);
        });
        // automatically configure the client
        this.configureLabelers($bf8bc4cd44d3126a$var$prefsArrayToLabelerDids(prefs));
    }
    async removeLabeler(did) {
        const prefs = await this.updatePreferences((prefs)=>{
            let labelersPref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isLabelersPref(pref) && $2wqOO.AppBskyActorDefs.validateLabelersPref(pref).success);
            if (!labelersPref) labelersPref = {
                $type: 'app.bsky.actor.defs#labelersPref',
                labelers: []
            };
            if ($2wqOO.AppBskyActorDefs.isLabelersPref(labelersPref)) labelersPref.labelers = labelersPref.labelers.filter((labeler)=>labeler.did !== did);
            return prefs.filter((pref)=>!$2wqOO.AppBskyActorDefs.isLabelersPref(pref)).concat([
                labelersPref
            ]);
        });
        // automatically configure the client
        this.configureLabelers($bf8bc4cd44d3126a$var$prefsArrayToLabelerDids(prefs));
    }
    async setPersonalDetails({ birthDate: birthDate }) {
        birthDate = birthDate instanceof Date ? birthDate.toISOString() : birthDate;
        await this.updatePreferences((prefs)=>{
            let personalDetailsPref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isPersonalDetailsPref(pref) && $2wqOO.AppBskyActorDefs.validatePersonalDetailsPref(pref).success);
            if (personalDetailsPref) personalDetailsPref.birthDate = birthDate;
            else personalDetailsPref = {
                $type: 'app.bsky.actor.defs#personalDetailsPref',
                birthDate: birthDate
            };
            return prefs.filter((pref)=>!$2wqOO.AppBskyActorDefs.isPersonalDetailsPref(pref)).concat([
                personalDetailsPref
            ]);
        });
    }
    async setFeedViewPrefs(feed, pref) {
        await this.updatePreferences((prefs)=>{
            const existing = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isFeedViewPref(pref) && $2wqOO.AppBskyActorDefs.validateFeedViewPref(pref).success && pref.feed === feed);
            if (existing) pref = {
                ...existing,
                ...pref
            };
            return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isFeedViewPref(pref) || p.feed !== feed).concat([
                {
                    ...pref,
                    $type: 'app.bsky.actor.defs#feedViewPref',
                    feed: feed
                }
            ]);
        });
    }
    async setThreadViewPrefs(pref) {
        await this.updatePreferences((prefs)=>{
            const existing = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isThreadViewPref(pref) && $2wqOO.AppBskyActorDefs.validateThreadViewPref(pref).success);
            if (existing) pref = {
                ...existing,
                ...pref
            };
            return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isThreadViewPref(p)).concat([
                {
                    ...pref,
                    $type: 'app.bsky.actor.defs#threadViewPref'
                }
            ]);
        });
    }
    async setInterestsPref(pref) {
        await this.updatePreferences((prefs)=>{
            const existing = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isInterestsPref(pref) && $2wqOO.AppBskyActorDefs.validateInterestsPref(pref).success);
            if (existing) pref = {
                ...existing,
                ...pref
            };
            return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isInterestsPref(p)).concat([
                {
                    ...pref,
                    $type: 'app.bsky.actor.defs#interestsPref'
                }
            ]);
        });
    }
    /**
     * Add a muted word to user preferences.
     */ async addMutedWord(mutedWord) {
        const sanitizedValue = (0, $bjLh7.sanitizeMutedWordValue)(mutedWord.value);
        if (!sanitizedValue) return;
        await this.updatePreferences((prefs)=>{
            let mutedWordsPref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isMutedWordsPref(pref) && $2wqOO.AppBskyActorDefs.validateMutedWordsPref(pref).success);
            const newMutedWord = {
                id: $bc6Ix.TID.nextStr(),
                value: sanitizedValue,
                targets: mutedWord.targets || [],
                actorTarget: mutedWord.actorTarget || 'all',
                expiresAt: mutedWord.expiresAt || undefined
            };
            if (mutedWordsPref && $2wqOO.AppBskyActorDefs.isMutedWordsPref(mutedWordsPref)) {
                mutedWordsPref.items.push(newMutedWord);
                /**
                 * Migrate any old muted words that don't have an id
                 */ mutedWordsPref.items = $bf8bc4cd44d3126a$var$migrateLegacyMutedWordsItems(mutedWordsPref.items);
            } else // if the pref doesn't exist, create it
            mutedWordsPref = {
                items: [
                    newMutedWord
                ]
            };
            return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isMutedWordsPref(p)).concat([
                {
                    ...mutedWordsPref,
                    $type: 'app.bsky.actor.defs#mutedWordsPref'
                }
            ]);
        });
    }
    /**
     * Convenience method to add muted words to user preferences
     */ async addMutedWords(newMutedWords) {
        await Promise.all(newMutedWords.map((word)=>this.addMutedWord(word)));
    }
    /**
     * @deprecated use `addMutedWords` or `addMutedWord` instead
     */ async upsertMutedWords(mutedWords) {
        await this.addMutedWords(mutedWords);
    }
    /**
     * Update a muted word in user preferences.
     */ async updateMutedWord(mutedWord) {
        await this.updatePreferences((prefs)=>{
            const mutedWordsPref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isMutedWordsPref(pref) && $2wqOO.AppBskyActorDefs.validateMutedWordsPref(pref).success);
            if (mutedWordsPref && $2wqOO.AppBskyActorDefs.isMutedWordsPref(mutedWordsPref)) {
                mutedWordsPref.items = mutedWordsPref.items.map((existingItem)=>{
                    const match = $bf8bc4cd44d3126a$var$matchMutedWord(existingItem, mutedWord);
                    if (match) {
                        const updated = {
                            ...existingItem,
                            ...mutedWord
                        };
                        return {
                            id: existingItem.id || $bc6Ix.TID.nextStr(),
                            value: (0, $bjLh7.sanitizeMutedWordValue)(updated.value) || existingItem.value,
                            targets: updated.targets || [],
                            actorTarget: updated.actorTarget || 'all',
                            expiresAt: updated.expiresAt || undefined
                        };
                    } else return existingItem;
                });
                /**
                 * Migrate any old muted words that don't have an id
                 */ mutedWordsPref.items = $bf8bc4cd44d3126a$var$migrateLegacyMutedWordsItems(mutedWordsPref.items);
                return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isMutedWordsPref(p)).concat([
                    {
                        ...mutedWordsPref,
                        $type: 'app.bsky.actor.defs#mutedWordsPref'
                    }
                ]);
            }
            return prefs;
        });
    }
    /**
     * Remove a muted word from user preferences.
     */ async removeMutedWord(mutedWord) {
        await this.updatePreferences((prefs)=>{
            const mutedWordsPref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isMutedWordsPref(pref) && $2wqOO.AppBskyActorDefs.validateMutedWordsPref(pref).success);
            if (mutedWordsPref && $2wqOO.AppBskyActorDefs.isMutedWordsPref(mutedWordsPref)) {
                for(let i = 0; i < mutedWordsPref.items.length; i++){
                    const match = $bf8bc4cd44d3126a$var$matchMutedWord(mutedWordsPref.items[i], mutedWord);
                    if (match) {
                        mutedWordsPref.items.splice(i, 1);
                        break;
                    }
                }
                /**
                 * Migrate any old muted words that don't have an id
                 */ mutedWordsPref.items = $bf8bc4cd44d3126a$var$migrateLegacyMutedWordsItems(mutedWordsPref.items);
                return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isMutedWordsPref(p)).concat([
                    {
                        ...mutedWordsPref,
                        $type: 'app.bsky.actor.defs#mutedWordsPref'
                    }
                ]);
            }
            return prefs;
        });
    }
    /**
     * Convenience method to remove muted words from user preferences
     */ async removeMutedWords(mutedWords) {
        await Promise.all(mutedWords.map((word)=>this.removeMutedWord(word)));
    }
    async hidePost(postUri) {
        await this.updateHiddenPost(postUri, 'hide');
    }
    async unhidePost(postUri) {
        await this.updateHiddenPost(postUri, 'unhide');
    }
    async bskyAppQueueNudges(nudges) {
        await this.updatePreferences((prefs)=>{
            let bskyAppStatePref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isBskyAppStatePref(pref) && $2wqOO.AppBskyActorDefs.validateBskyAppStatePref(pref).success);
            bskyAppStatePref = bskyAppStatePref || {};
            nudges = Array.isArray(nudges) ? nudges : [
                nudges
            ];
            bskyAppStatePref.queuedNudges = (bskyAppStatePref.queuedNudges || []).concat(nudges);
            return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isBskyAppStatePref(p)).concat([
                {
                    ...bskyAppStatePref,
                    $type: 'app.bsky.actor.defs#bskyAppStatePref'
                }
            ]);
        });
    }
    async bskyAppDismissNudges(nudges) {
        await this.updatePreferences((prefs)=>{
            let bskyAppStatePref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isBskyAppStatePref(pref) && $2wqOO.AppBskyActorDefs.validateBskyAppStatePref(pref).success);
            bskyAppStatePref = bskyAppStatePref || {};
            nudges = Array.isArray(nudges) ? nudges : [
                nudges
            ];
            bskyAppStatePref.queuedNudges = (bskyAppStatePref.queuedNudges || []).filter((nudge)=>!nudges.includes(nudge));
            return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isBskyAppStatePref(p)).concat([
                {
                    ...bskyAppStatePref,
                    $type: 'app.bsky.actor.defs#bskyAppStatePref'
                }
            ]);
        });
    }
    async bskyAppSetActiveProgressGuide(guide) {
        if (guide && !$2wqOO.AppBskyActorDefs.validateBskyAppProgressGuide(guide).success) throw new Error('Invalid progress guide');
        await this.updatePreferences((prefs)=>{
            let bskyAppStatePref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isBskyAppStatePref(pref) && $2wqOO.AppBskyActorDefs.validateBskyAppStatePref(pref).success);
            bskyAppStatePref = bskyAppStatePref || {};
            bskyAppStatePref.activeProgressGuide = guide;
            return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isBskyAppStatePref(p)).concat([
                {
                    ...bskyAppStatePref,
                    $type: 'app.bsky.actor.defs#bskyAppStatePref'
                }
            ]);
        });
    }
    /**
     * Insert or update a NUX in user prefs
     */ async bskyAppUpsertNux(nux) {
        (0, $bjLh7.validateNux)(nux);
        await this.updatePreferences((prefs)=>{
            let bskyAppStatePref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isBskyAppStatePref(pref) && $2wqOO.AppBskyActorDefs.validateBskyAppStatePref(pref).success);
            bskyAppStatePref = bskyAppStatePref || {};
            bskyAppStatePref.nuxs = bskyAppStatePref.nuxs || [];
            const existing = bskyAppStatePref.nuxs?.find((n)=>{
                return n.id === nux.id;
            });
            let next;
            if (existing) next = {
                id: existing.id,
                completed: nux.completed,
                data: nux.data,
                expiresAt: nux.expiresAt
            };
            else next = nux;
            // remove duplicates and append
            bskyAppStatePref.nuxs = bskyAppStatePref.nuxs.filter((n)=>n.id !== nux.id).concat(next);
            return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isBskyAppStatePref(p)).concat([
                {
                    ...bskyAppStatePref,
                    $type: 'app.bsky.actor.defs#bskyAppStatePref'
                }
            ]);
        });
    }
    /**
     * Removes NUXs from user preferences.
     */ async bskyAppRemoveNuxs(ids) {
        await this.updatePreferences((prefs)=>{
            let bskyAppStatePref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isBskyAppStatePref(pref) && $2wqOO.AppBskyActorDefs.validateBskyAppStatePref(pref).success);
            bskyAppStatePref = bskyAppStatePref || {};
            bskyAppStatePref.nuxs = (bskyAppStatePref.nuxs || []).filter((nux)=>{
                return !ids.includes(nux.id);
            });
            return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isBskyAppStatePref(p)).concat([
                {
                    ...bskyAppStatePref,
                    $type: 'app.bsky.actor.defs#bskyAppStatePref'
                }
            ]);
        });
    }
    async setPostInteractionSettings(settings) {
        if (!$2wqOO.AppBskyActorDefs.validatePostInteractionSettingsPref(settings).success) throw new Error('Invalid post interaction settings');
        await this.updatePreferences((prefs)=>{
            let prev = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isPostInteractionSettingsPref(pref) && $2wqOO.AppBskyActorDefs.validatePostInteractionSettingsPref(pref).success);
            if (!prev) prev = {
                /**
                     * Matches handling of `threadgate.allow` where `undefined` means "everyone"
                     */ threadgateAllowRules: undefined,
                postgateEmbeddingRules: undefined
            };
            /**
             * Matches handling of `threadgate.allow` where `undefined` means "everyone"
             */ prev.threadgateAllowRules = settings.threadgateAllowRules;
            prev.postgateEmbeddingRules = settings.postgateEmbeddingRules;
            return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isPostInteractionSettingsPref(p)).concat([
                {
                    ...prev,
                    $type: 'app.bsky.actor.defs#postInteractionSettingsPref'
                }
            ]);
        });
    }
    /**
     * This function updates the preferences of a user and allows for a callback function to be executed
     * before the update.
     * @param cb - cb is a callback function that takes in a single parameter of type
     * AppBskyActorDefs.Preferences and returns either a boolean or void. This callback function is used to
     * update the preferences of the user. The function is called with the current preferences as an
     * argument and if the callback returns false, the preferences are not updated.
     */ async updatePreferences(cb) {
        try {
            await $bf8bc4cd44d3126a$var$__classPrivateFieldGet(this, $bf8bc4cd44d3126a$var$_Agent_prefsLock, "f").acquireAsync();
            const res = await this.app.bsky.actor.getPreferences({});
            const newPrefs = cb(res.data.preferences);
            if (newPrefs === false) return res.data.preferences;
            await this.app.bsky.actor.putPreferences({
                preferences: newPrefs
            });
            return newPrefs;
        } finally{
            $bf8bc4cd44d3126a$var$__classPrivateFieldGet(this, $bf8bc4cd44d3126a$var$_Agent_prefsLock, "f").release();
        }
    }
    async updateHiddenPost(postUri, action) {
        await this.updatePreferences((prefs)=>{
            let pref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isHiddenPostsPref(pref) && $2wqOO.AppBskyActorDefs.validateHiddenPostsPref(pref).success);
            if (pref && $2wqOO.AppBskyActorDefs.isHiddenPostsPref(pref)) pref.items = action === 'hide' ? Array.from(new Set([
                ...pref.items,
                postUri
            ])) : pref.items.filter((uri)=>uri !== postUri);
            else if (action === 'hide') pref = {
                $type: 'app.bsky.actor.defs#hiddenPostsPref',
                items: [
                    postUri
                ]
            };
            return prefs.filter((p)=>!$2wqOO.AppBskyActorDefs.isInterestsPref(p)).concat([
                {
                    ...pref,
                    $type: 'app.bsky.actor.defs#hiddenPostsPref'
                }
            ]);
        });
    }
    /**
     * A helper specifically for updating feed preferences
     */ async updateFeedPreferences(cb) {
        let res;
        await this.updatePreferences((prefs)=>{
            let feedsPref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isSavedFeedsPref(pref) && $2wqOO.AppBskyActorDefs.validateSavedFeedsPref(pref).success);
            if (feedsPref) {
                res = cb(feedsPref.saved, feedsPref.pinned);
                feedsPref.saved = res.saved;
                feedsPref.pinned = res.pinned;
            } else {
                res = cb([], []);
                feedsPref = {
                    $type: 'app.bsky.actor.defs#savedFeedsPref',
                    saved: res.saved,
                    pinned: res.pinned
                };
            }
            return prefs.filter((pref)=>!$2wqOO.AppBskyActorDefs.isSavedFeedsPref(pref)).concat([
                feedsPref
            ]);
        });
        return res;
    }
    async updateSavedFeedsV2Preferences(cb) {
        let maybeMutatedSavedFeeds = [];
        await this.updatePreferences((prefs)=>{
            let existingV2Pref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isSavedFeedsPrefV2(pref) && $2wqOO.AppBskyActorDefs.validateSavedFeedsPrefV2(pref).success);
            let existingV1Pref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isSavedFeedsPref(pref) && $2wqOO.AppBskyActorDefs.validateSavedFeedsPref(pref).success);
            if (existingV2Pref) {
                maybeMutatedSavedFeeds = cb(existingV2Pref.items);
                existingV2Pref = {
                    ...existingV2Pref,
                    items: maybeMutatedSavedFeeds
                };
            } else {
                maybeMutatedSavedFeeds = cb([]);
                existingV2Pref = {
                    $type: 'app.bsky.actor.defs#savedFeedsPrefV2',
                    items: maybeMutatedSavedFeeds
                };
            }
            // enforce ordering, pinned then saved
            const pinned = existingV2Pref.items.filter((i)=>i.pinned);
            const saved = existingV2Pref.items.filter((i)=>!i.pinned);
            existingV2Pref.items = pinned.concat(saved);
            let updatedPrefs = prefs.filter((pref)=>!$2wqOO.AppBskyActorDefs.isSavedFeedsPrefV2(pref)).concat(existingV2Pref);
            /*
             * If there's a v2 pref present, it means this account was migrated from v1
             * to v2. During the transition period, we double write v2 prefs back to
             * v1, but NOT the other way around.
             */ if (existingV1Pref) {
                const { saved: saved, pinned: pinned } = existingV1Pref;
                const v2Compat = (0, $bjLh7.savedFeedsToUriArrays)(// v1 only supports feeds and lists
                existingV2Pref.items.filter((i)=>[
                        'feed',
                        'list'
                    ].includes(i.type)));
                existingV1Pref = {
                    ...existingV1Pref,
                    saved: Array.from(new Set([
                        ...saved,
                        ...v2Compat.saved
                    ])),
                    pinned: Array.from(new Set([
                        ...pinned,
                        ...v2Compat.pinned
                    ]))
                };
                updatedPrefs = updatedPrefs.filter((pref)=>!$2wqOO.AppBskyActorDefs.isSavedFeedsPref(pref)).concat(existingV1Pref);
            }
            return updatedPrefs;
        });
        return maybeMutatedSavedFeeds;
    }
}
$bf8bc4cd44d3126a$exports.Agent = $bf8bc4cd44d3126a$var$Agent;
$bf8bc4cd44d3126a$var$_Agent_prefsLock = new WeakMap();
//#region Static configuration
/**
 * The labelers to be used across all requests with the takedown capability
 */ Object.defineProperty($bf8bc4cd44d3126a$var$Agent, "appLabelers", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [
        $hPpei.BSKY_LABELER_DID
    ]
});
/**
 * Helper to transform the legacy content preferences.
 */ function $bf8bc4cd44d3126a$var$adjustLegacyContentLabelPref(pref) {
    let visibility = pref.visibility;
    // adjust legacy values
    if (visibility === 'show') visibility = 'ignore';
    return {
        ...pref,
        visibility: visibility
    };
}
/**
 * Re-maps legacy labels to new labels on READ. Does not save these changes to
 * the user's preferences.
 */ function $bf8bc4cd44d3126a$var$remapLegacyLabels(labels) {
    const _labels = {
        ...labels
    };
    const legacyToNewMap = {
        gore: 'graphic-media',
        nsfw: 'porn',
        suggestive: 'sexual'
    };
    for(const labelName in _labels){
        const newLabelName = legacyToNewMap[labelName];
        if (newLabelName) _labels[newLabelName] = _labels[labelName];
    }
    return _labels;
}
/**
 * A helper to get the currently enabled labelers from the full preferences array
 */ function $bf8bc4cd44d3126a$var$prefsArrayToLabelerDids(prefs) {
    const labelersPref = prefs.findLast((pref)=>$2wqOO.AppBskyActorDefs.isLabelersPref(pref) && $2wqOO.AppBskyActorDefs.validateLabelersPref(pref).success);
    let dids = [];
    if (labelersPref) dids = labelersPref.labelers.map((labeler)=>labeler.did);
    return dids;
}
function $bf8bc4cd44d3126a$var$isBskyPrefs(v) {
    return v && typeof v === 'object' && 'moderationPrefs' in v && $bf8bc4cd44d3126a$var$isModPrefs(v.moderationPrefs);
}
function $bf8bc4cd44d3126a$var$isModPrefs(v) {
    return v && typeof v === 'object' && 'labelers' in v;
}
function $bf8bc4cd44d3126a$var$migrateLegacyMutedWordsItems(items) {
    return items.map((item)=>({
            ...item,
            id: item.id || $bc6Ix.TID.nextStr()
        }));
}
function $bf8bc4cd44d3126a$var$matchMutedWord(existingWord, newWord) {
    // id is undefined in legacy implementation
    const existingId = existingWord.id;
    // prefer matching based on id
    const matchById = existingId && existingId === newWord.id;
    // handle legacy case where id is not set
    const legacyMatchByValue = !existingId && existingWord.value === newWord.value;
    return matchById || legacyMatchByValue;
}


Object.defineProperty($b7ba13108be67195$exports, "Agent", {
    enumerable: true,
    get: function() {
        return $bf8bc4cd44d3126a$exports.Agent;
    }
});
var $781613b48fa7e9ff$exports = {};
"use strict";
Object.defineProperty($781613b48fa7e9ff$exports, "__esModule", {
    value: true
});
$781613b48fa7e9ff$exports.CredentialSession = $781613b48fa7e9ff$exports.AtpAgent = void 0;

var $bc6Ix = parcelRequire("bc6Ix");

var $al5Ta = parcelRequire("al5Ta");


var $2wqOO = parcelRequire("2wqOO");

var $8DB7o = parcelRequire("8DB7o");
const $781613b48fa7e9ff$var$ReadableStream = globalThis.ReadableStream;
/**
 * A wrapper around the {@link Agent} class that uses credential based session
 * management. This class also exposes most of the session management methods
 * directly.
 *
 * This class will be deprecated in the near future. Use {@link Agent} directly
 * with a {@link CredentialSession} instead:
 *
 *  ```ts
 *  const session = new CredentialSession({
 *    service: new URL('https://example.com'),
 *  })
 *
 *  const agent = new Agent(session)
 *  ```
 */ class $781613b48fa7e9ff$var$AtpAgent extends $bf8bc4cd44d3126a$exports.Agent {
    constructor(options){
        const sessionManager = options instanceof $781613b48fa7e9ff$var$CredentialSession ? options : new $781613b48fa7e9ff$var$CredentialSession(new URL(options.service), options.fetch, options.persistSession);
        super(sessionManager);
        Object.defineProperty(this, "sessionManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // This assignment is already being done in the super constructor, but we
        // need to do it here to make TypeScript happy.
        this.sessionManager = sessionManager;
        if (!(options instanceof $781613b48fa7e9ff$var$CredentialSession) && options.headers) for (const [key, value] of options.headers)this.setHeader(key, value);
    }
    clone() {
        return this.copyInto(new $781613b48fa7e9ff$var$AtpAgent(this.sessionManager));
    }
    get session() {
        return this.sessionManager.session;
    }
    get hasSession() {
        return this.sessionManager.hasSession;
    }
    get did() {
        return this.sessionManager.did;
    }
    get serviceUrl() {
        return this.sessionManager.serviceUrl;
    }
    get pdsUrl() {
        return this.sessionManager.pdsUrl;
    }
    get dispatchUrl() {
        return this.sessionManager.dispatchUrl;
    }
    /** @deprecated use {@link serviceUrl} instead */ get service() {
        return this.serviceUrl;
    }
    get persistSession() {
        throw new Error('Cannot set persistSession directly. "persistSession" is defined through the constructor and will be invoked automatically when session data changes.');
    }
    set persistSession(v) {
        throw new Error('Cannot set persistSession directly. "persistSession" must be defined in the constructor and can no longer be changed.');
    }
    /** @deprecated use {@link AtpAgent.serviceUrl} instead */ getServiceUrl() {
        return this.serviceUrl;
    }
    async resumeSession(session) {
        return this.sessionManager.resumeSession(session);
    }
    async createAccount(data, opts) {
        return this.sessionManager.createAccount(data, opts);
    }
    async login(opts) {
        return this.sessionManager.login(opts);
    }
    async logout() {
        return this.sessionManager.logout();
    }
}
$781613b48fa7e9ff$exports.AtpAgent = $781613b48fa7e9ff$var$AtpAgent;
/**
 * Credentials (username / password) based session manager. Instances of this
 * class will typically be used as the session manager for an {@link AtpAgent}.
 * They can also be used with an {@link XrpcClient}, if you want to use you
 * own Lexicons.
 */ class $781613b48fa7e9ff$var$CredentialSession {
    constructor(serviceUrl, fetch = globalThis.fetch, persistSession){
        Object.defineProperty(this, "serviceUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: serviceUrl
        });
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: fetch
        });
        Object.defineProperty(this, "persistSession", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: persistSession
        });
        Object.defineProperty(this, "pdsUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // The PDS URL, driven by the did doc
        Object.defineProperty(this, "session", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "refreshSessionPromise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Private {@link ComAtprotoServerNS} used to perform session management API
         * calls on the service endpoint. Calls performed by this agent will not be
         * authenticated using the user's session to allow proper manual configuration
         * of the headers when performing session management operations.
         */ Object.defineProperty(this, "server", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new $2wqOO.ComAtprotoServerNS(// Note that the use of the codegen "schemas" (to instantiate `this.api`),
            // as well as the use of `ComAtprotoServerNS` will cause this class to
            // reference (way) more code than it actually needs. It is not possible,
            // with the current state of the codegen, to generate a client that only
            // includes the methods that are actually used by this class. This is a
            // known limitation that should be addressed in a future version of the
            // codegen.
            new $al5Ta.XrpcClient((url, init)=>{
                return (0, this.fetch)(new URL(url, this.serviceUrl), init);
            }, $8DB7o.schemas))
        });
    }
    get did() {
        return this.session?.did;
    }
    get dispatchUrl() {
        return this.pdsUrl || this.serviceUrl;
    }
    get hasSession() {
        return !!this.session;
    }
    /**
     * Sets a WhatWG "fetch()" function to be used for making HTTP requests.
     */ setFetch(fetch = globalThis.fetch) {
        this.fetch = fetch;
    }
    async fetchHandler(url, init) {
        // wait for any active session-refreshes to finish
        await this.refreshSessionPromise;
        const initialUri = new URL(url, this.dispatchUrl);
        const initialReq = new Request(initialUri, init);
        const initialToken = this.session?.accessJwt;
        if (!initialToken || initialReq.headers.has('authorization')) return (0, this.fetch)(initialReq);
        initialReq.headers.set('authorization', `Bearer ${initialToken}`);
        const initialRes = await (0, this.fetch)(initialReq);
        if (!this.session?.refreshJwt) return initialRes;
        const isExpiredToken = await $781613b48fa7e9ff$var$isErrorResponse(initialRes, [
            400
        ], [
            'ExpiredToken'
        ]);
        if (!isExpiredToken) return initialRes;
        try {
            await this.refreshSession();
        } catch  {
            return initialRes;
        }
        if (init?.signal?.aborted) return initialRes;
        // The stream was already consumed. We cannot retry the request. A solution
        // would be to tee() the input stream but that would bufferize the entire
        // stream in memory which can lead to memory starvation. Instead, we will
        // return the original response and let the calling code handle retries.
        if ($781613b48fa7e9ff$var$ReadableStream && init?.body instanceof $781613b48fa7e9ff$var$ReadableStream) return initialRes;
        // Return initial "ExpiredToken" response if the session was not refreshed.
        const updatedToken = this.session?.accessJwt;
        if (!updatedToken || updatedToken === initialToken) return initialRes;
        // Make sure the initial request is cancelled to avoid leaking resources
        // (NodeJS 👀): https://undici.nodejs.org/#/?id=garbage-collection
        await initialRes.body?.cancel();
        // We need to re-compute the URI in case the PDS endpoint has changed
        const updatedUri = new URL(url, this.dispatchUrl);
        const updatedReq = new Request(updatedUri, init);
        updatedReq.headers.set('authorization', `Bearer ${updatedToken}`);
        return await (0, this.fetch)(updatedReq);
    }
    /**
     * Create a new account and hydrate its session in this agent.
     */ async createAccount(data, opts) {
        try {
            const res = await this.server.createAccount(data, opts);
            this.session = {
                accessJwt: res.data.accessJwt,
                refreshJwt: res.data.refreshJwt,
                handle: res.data.handle,
                did: res.data.did,
                email: data.email,
                emailConfirmed: false,
                emailAuthFactor: false,
                active: true
            };
            this.persistSession?.('create', this.session);
            this._updateApiEndpoint(res.data.didDoc);
            return res;
        } catch (e) {
            this.session = undefined;
            this.persistSession?.('create-failed', undefined);
            throw e;
        }
    }
    /**
     * Start a new session with this agent.
     */ async login(opts) {
        try {
            const res = await this.server.createSession({
                identifier: opts.identifier,
                password: opts.password,
                authFactorToken: opts.authFactorToken,
                allowTakendown: opts.allowTakendown
            });
            this.session = {
                accessJwt: res.data.accessJwt,
                refreshJwt: res.data.refreshJwt,
                handle: res.data.handle,
                did: res.data.did,
                email: res.data.email,
                emailConfirmed: res.data.emailConfirmed,
                emailAuthFactor: res.data.emailAuthFactor,
                active: res.data.active ?? true,
                status: res.data.status
            };
            this._updateApiEndpoint(res.data.didDoc);
            this.persistSession?.('create', this.session);
            return res;
        } catch (e) {
            this.session = undefined;
            this.persistSession?.('create-failed', undefined);
            throw e;
        }
    }
    async logout() {
        if (this.session) try {
            await this.server.deleteSession(undefined, {
                headers: {
                    authorization: `Bearer ${this.session.accessJwt}`
                }
            });
        } catch  {
        // Ignore errors
        } finally{
            this.session = undefined;
            this.persistSession?.('expired', undefined);
        }
    }
    /**
     * Resume a pre-existing session with this agent.
     */ async resumeSession(session) {
        this.session = session;
        try {
            const res = await this.server.getSession(undefined, {
                headers: {
                    authorization: `Bearer ${session.accessJwt}`
                }
            }).catch(async (err)=>{
                if (err instanceof $al5Ta.XRPCError && [
                    'ExpiredToken',
                    'InvalidToken'
                ].includes(err.error) && session.refreshJwt) try {
                    const res = await this.server.refreshSession(undefined, {
                        headers: {
                            authorization: `Bearer ${session.refreshJwt}`
                        }
                    });
                    session.accessJwt = res.data.accessJwt;
                    session.refreshJwt = res.data.refreshJwt;
                    return this.server.getSession(undefined, {
                        headers: {
                            authorization: `Bearer ${session.accessJwt}`
                        }
                    });
                } catch  {
                // Noop, we'll throw the original error
                }
                throw err;
            });
            if (res.data.did !== session.did) throw new $al5Ta.XRPCError($al5Ta.ResponseType.InvalidRequest, 'Invalid session', 'InvalidDID');
            session.email = res.data.email;
            session.handle = res.data.handle;
            session.emailConfirmed = res.data.emailConfirmed;
            session.emailAuthFactor = res.data.emailAuthFactor;
            session.active = res.data.active ?? true;
            session.status = res.data.status;
            // protect against concurrent session updates
            if (this.session === session) {
                this._updateApiEndpoint(res.data.didDoc);
                this.persistSession?.('update', session);
            }
            return res;
        } catch (err) {
            // protect against concurrent session updates
            if (this.session === session) {
                this.session = undefined;
                this.persistSession?.(err instanceof $al5Ta.XRPCError && [
                    'ExpiredToken',
                    'InvalidToken'
                ].includes(err.error) ? 'expired' : 'network-error', undefined);
            }
            throw err;
        }
    }
    /**
     * Internal helper to refresh sessions
     * - Wraps the actual implementation in a promise-guard to ensure only
     *   one refresh is attempted at a time.
     */ async refreshSession() {
        return this.refreshSessionPromise || (this.refreshSessionPromise = this._refreshSessionInner().finally(()=>{
            this.refreshSessionPromise = undefined;
        }));
    }
    /**
     * Internal helper to refresh sessions (actual behavior)
     */ async _refreshSessionInner() {
        if (!this.session?.refreshJwt) return;
        try {
            const res = await this.server.refreshSession(undefined, {
                headers: {
                    authorization: `Bearer ${this.session.refreshJwt}`
                }
            });
            // succeeded, update the session
            this.session = {
                ...this.session,
                accessJwt: res.data.accessJwt,
                refreshJwt: res.data.refreshJwt,
                handle: res.data.handle,
                did: res.data.did
            };
            this._updateApiEndpoint(res.data.didDoc);
            this.persistSession?.('update', this.session);
        } catch (err) {
            if (err instanceof $al5Ta.XRPCError && err.error && [
                'ExpiredToken',
                'InvalidToken'
            ].includes(err.error)) {
                // failed due to a bad refresh token
                this.session = undefined;
                this.persistSession?.('expired', undefined);
            }
        // else: other failures should be ignored - the issue will
        // propagate in the _dispatch() second attempt to run
        // the request
        }
    }
    /**
     * Helper to update the pds endpoint dynamically.
     *
     * The session methods (create, resume, refresh) may respond with the user's
     * did document which contains the user's canonical PDS endpoint. That endpoint
     * may differ from the endpoint used to contact the server. We capture that
     * PDS endpoint and update the client to use that given endpoint for future
     * requests. (This helps ensure smooth migrations between PDSes, especially
     * when the PDSes are operated by a single org.)
     */ _updateApiEndpoint(didDoc) {
        if ((0, $bc6Ix.isValidDidDoc)(didDoc)) {
            const endpoint = (0, $bc6Ix.getPdsEndpoint)(didDoc);
            this.pdsUrl = endpoint ? new URL(endpoint) : undefined;
        } else // If the did doc is invalid, we clear the pdsUrl (should never happen)
        this.pdsUrl = undefined;
    }
}
$781613b48fa7e9ff$exports.CredentialSession = $781613b48fa7e9ff$var$CredentialSession;
function $781613b48fa7e9ff$var$isErrorObject(v) {
    return $al5Ta.errorResponseBody.safeParse(v).success;
}
async function $781613b48fa7e9ff$var$isErrorResponse(response, status, errorNames) {
    if (!status.includes(response.status)) return false;
    // Some engines (react-native 👀) don't expose a response.body property...
    // if (!response.body) return false
    try {
        const json = await $781613b48fa7e9ff$var$peekJson(response, 10240);
        return $781613b48fa7e9ff$var$isErrorObject(json) && errorNames.includes(json.error);
    } catch (err) {
        return false;
    }
}
async function $781613b48fa7e9ff$var$peekJson(response, maxSize = Infinity) {
    if ($781613b48fa7e9ff$var$extractType(response) !== 'application/json') throw new Error('Not JSON');
    if ($781613b48fa7e9ff$var$extractLength(response) > maxSize) throw new Error('Response too large');
    return response.clone().json();
}
function $781613b48fa7e9ff$var$extractLength({ headers: headers }) {
    return headers.get('Content-Length') ? Number(headers.get('Content-Length')) : NaN;
}
function $781613b48fa7e9ff$var$extractType({ headers: headers }) {
    return headers.get('Content-Type')?.split(';')[0]?.trim();
}


Object.defineProperty($b7ba13108be67195$exports, "AtpAgent", {
    enumerable: true,
    get: function() {
        return $781613b48fa7e9ff$exports.AtpAgent;
    }
});

Object.defineProperty($b7ba13108be67195$exports, "CredentialSession", {
    enumerable: true,
    get: function() {
        return $781613b48fa7e9ff$exports.CredentialSession;
    }
});
var $504fae94a14f3d19$exports = {};
"use strict";
Object.defineProperty($504fae94a14f3d19$exports, "__esModule", {
    value: true
});
$504fae94a14f3d19$exports.BskyAgent = void 0;

/** @deprecated use {@link AtpAgent} instead */ class $504fae94a14f3d19$var$BskyAgent extends $781613b48fa7e9ff$exports.AtpAgent {
    clone() {
        if (this.constructor === $504fae94a14f3d19$var$BskyAgent) {
            const agent = new $504fae94a14f3d19$var$BskyAgent(this.sessionManager);
            return this.copyInto(agent);
        }
        // sub-classes should override this method
        throw new TypeError('Cannot clone a subclass of BskyAgent');
    }
}
$504fae94a14f3d19$exports.BskyAgent = $504fae94a14f3d19$var$BskyAgent;


Object.defineProperty($b7ba13108be67195$exports, "BskyAgent", {
    enumerable: true,
    get: function() {
        return $504fae94a14f3d19$exports.BskyAgent;
    }
});

/** @deprecated */ Object.defineProperty($b7ba13108be67195$exports, "default", {
    enumerable: true,
    get: function() {
        return $781613b48fa7e9ff$exports.AtpAgent;
    }
});
// Expose a copy to prevent alteration of the internal Lexicon instance used by
// the AtpBaseClient class.
$b7ba13108be67195$exports.lexicons = new $3dCVT.Lexicons($8DB7o.lexicons);


var $a0b2960f62553c3e$exports = {};
"use strict";
var $a0b2960f62553c3e$var$__createBinding = $a0b2960f62553c3e$exports && $a0b2960f62553c3e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a0b2960f62553c3e$var$__exportStar = $a0b2960f62553c3e$exports && $a0b2960f62553c3e$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a0b2960f62553c3e$var$__createBinding(exports1, m, p);
};
Object.defineProperty($a0b2960f62553c3e$exports, "__esModule", {
    value: true
});
$a0b2960f62553c3e$exports.buildLoopbackClientId = void 0;
parcelRequire("6AwK3");

$a0b2960f62553c3e$var$__exportStar((parcelRequire("h3MMF")), $a0b2960f62553c3e$exports);

$a0b2960f62553c3e$var$__exportStar((parcelRequire("cNZAj")), $a0b2960f62553c3e$exports);

$a0b2960f62553c3e$var$__exportStar((parcelRequire("7JhZC")), $a0b2960f62553c3e$exports);

$a0b2960f62553c3e$var$__exportStar((parcelRequire("51ST3")), $a0b2960f62553c3e$exports);

var $4B1hY = parcelRequire("4B1hY");
Object.defineProperty($a0b2960f62553c3e$exports, "buildLoopbackClientId", {
    enumerable: true,
    get: function() {
        return $4B1hY.buildLoopbackClientId;
    }
});


async function $e73bf42412feb220$var$main() {
    const oauthClient = await (0, $a0b2960f62553c3e$exports.BrowserOAuthClient).load({
        clientId: "https://lw.amazingca.dev/client-metadata.json",
        handleResolver: "https://bsky.social/"
    });
    const result = await oauthClient.init();
    if (result) {
        if ('state' in result) console.log("The user was just redirected back from the authorization page");
        console.log(`The user is currently signed in as`, result);
    }
    const login = document.getElementById("login");
    login.addEventListener("click", async ()=>{
        const handle = prompt('Enter your atproto handle to authenticate');
        if (!handle) throw new Error('Authentication process canceled by the user');
        const url = await oauthClient.authorize(handle);
        // Redirect the user to the authorization page
        window.open(url, '_self', 'noopener');
        // Protect against browser's back-forward cache
        await new Promise, never;
    });
    var agent = null;
    if (result) {
        agent = new (0, $b7ba13108be67195$exports.Agent)(result.session);
        const fetchProfile = async ()=>{
            const profile = await agent.getProfile({
                actor: agent.did
            });
            return profile.data;
        };
        // Update the user interface
        while(document.getElementsByClassName("hidden").length > 0)for (const element of document.getElementsByClassName("hidden"))element.classList.remove("hidden");
        login.classList.add("hidden");
        const logout = document.getElementById("logout");
        logout.addEventListener("click", async ()=>{
            await result.session.signOut();
            window.location.reload();
        });
        document.getElementById("handle").innerHTML = await fetchProfile().then((r)=>"@" + r.handle);
        document.getElementById("notifications").innerHTML += await agent.countUnreadNotifications().then((r)=>" [" + r.data.count + "]");
    }
    (0, $9809423ed41a5bb9$export$2e2bcd8739ae039).main(agent);
    document.getElementById("sidebar-padding").style.width = document.getElementById("sidebar").offsetWidth + "px";
}
document.addEventListener('DOMContentLoaded', $e73bf42412feb220$var$main);


//# sourceMappingURL=repo.d7099f14.js.map
